var Kk = Object.defineProperty;
var Xk = (e, t, n) => t in e ? Kk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var z = (e, t, n) => Xk(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as _, jsxs as Z, Fragment as Ke } from "react/jsx-runtime";
import * as b from "react";
import G, { useRef as Ye, useState as He, useEffect as ye, forwardRef as _e, createElement as V, createContext as Ct, useContext as tn, useLayoutEffect as Rr, useCallback as Fn, useMemo as yn, Children as at, isValidElement as Nt, cloneElement as Ar, Fragment as Hg, useReducer as Zk } from "react";
import * as sa from "react-dom";
import zg, { flushSync as jT } from "react-dom";
const Qk = (e) => /* @__PURE__ */ b.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "12px", height: "12px", fill: "currentColor", strokeWidth: 1, viewBox: "0 0 467.871 467.871", xmlSpace: "preserve", "data-test-id": "ReloadIcon", ...e }, /* @__PURE__ */ b.createElement("g", null, /* @__PURE__ */ b.createElement("path", { d: "M392.098,344.131c-6.597-5.014-16.007-3.729-21.019,2.868c-0.962,1.266-1.948,2.516-2.957,3.751       c-15.046,18.411-35.315,33.36-60.321,44.474c-0.124,0.055-0.247,0.111-0.369,0.17c-39.456,18.831-85.618,21.405-129.896,7.274       c-38.875-12.657-70.505-37.162-94.017-72.837c-17.462-27.997-26.613-58.428-27.264-90.524c-0.016-0.781-0.015-1.564-0.021-2.346       h18.402c6.919,0,10.384-8.365,5.491-13.257L46.7,190.277c-3.033-3.033-7.95-3.033-10.983,0L2.29,223.704       c-4.892,4.892-1.427,13.257,5.491,13.257H26.21c0.24,38.722,10.983,75.351,31.963,108.92c0.062,0.099,0.125,0.196,0.188,0.294       c27.356,41.581,64.327,70.186,109.971,85.046c21.87,6.979,44.152,10.447,66.102,10.447c29.833-0.001,59.045-6.407,85.737-19.113       c31.267-13.929,56.432-33.243,74.793-57.405C399.977,358.554,398.693,349.144,392.098,344.131z" }), /* @__PURE__ */ b.createElement("path", { d: "M460.09,233.876h-18.428c-0.001-4.112-0.123-8.271-0.364-12.362c-1.913-32.411-11.568-64.326-27.921-92.295       c-15.945-27.271-38.292-50.932-64.626-68.426c-26.774-17.787-57.774-29.226-89.649-33.079       c-35.426-4.283-71.452,0.578-104.185,14.052c-32.1,13.213-60.653,34.522-82.572,61.623c-5.21,6.44-4.211,15.886,2.229,21.096       c6.442,5.209,15.886,4.211,21.096-2.23c1.12-1.385,2.264-2.75,3.424-4.1c18.274-21.253,41.418-38.016,67.242-48.646       c27.995-11.523,58.83-15.678,89.166-12.011c27.25,3.294,53.754,13.074,76.648,28.284c22.546,14.979,41.679,35.234,55.329,58.58       c13.98,23.91,22.235,51.2,23.871,78.92c0.104,1.763,0.182,3.54,0.235,5.32c0.052,1.76,0.077,3.522,0.078,5.275h-18.426       c-6.919,0-10.384,8.365-5.491,13.257l33.427,33.427c3.033,3.033,7.95,3.033,10.983,0l33.427-33.427       C470.473,242.241,467.008,233.876,460.09,233.876z" }))), Jk = (e) => /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
  Qk,
  {
    className: `${{
      large: "h-8 w-8",
      normal: "h-4 w-4",
      small: "h-3 w-3"
    }[e.size || "normal"]} fill-foreground ${e.loading ? "animate-spin" : "animate-none"}`
  }
) }), e0 = (e) => /* @__PURE__ */ Z("div", { className: "flex flex-col justify-start h-[100%] rounded-lg shadow-lg bg-white", children: [
  /* @__PURE__ */ Z("div", { className: "flex p-4 items-center justify-between", children: [
    /* @__PURE__ */ _("h3", { className: "font-semibold", children: e.title }),
    e.isRefreshing && /* @__PURE__ */ _(Jk, { loading: e.isRefreshing })
  ] }),
  /* @__PURE__ */ _("div", { className: "p-4 pt-0 grow", children: e.content }),
  /* @__PURE__ */ _("div", { className: "p-4 pt-0", children: e.footer })
] });
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function bi(e) {
  return e + 0.5 | 0;
}
const On = (e, t, n) => Math.max(Math.min(e, n), t);
function Pa(e) {
  return On(bi(e * 2.55), 0, 255);
}
function $n(e) {
  return On(bi(e * 255), 0, 255);
}
function dn(e) {
  return On(bi(e / 2.55) / 100, 0, 1);
}
function km(e) {
  return On(bi(e * 100), 0, 100);
}
const Rt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Up = [..."0123456789ABCDEF"], t0 = (e) => Up[e & 15], n0 = (e) => Up[(e & 240) >> 4] + Up[e & 15], Ui = (e) => (e & 240) >> 4 === (e & 15), r0 = (e) => Ui(e.r) && Ui(e.g) && Ui(e.b) && Ui(e.a);
function a0(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & Rt[e[1]] * 17,
    g: 255 & Rt[e[2]] * 17,
    b: 255 & Rt[e[3]] * 17,
    a: t === 5 ? Rt[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: Rt[e[1]] << 4 | Rt[e[2]],
    g: Rt[e[3]] << 4 | Rt[e[4]],
    b: Rt[e[5]] << 4 | Rt[e[6]],
    a: t === 9 ? Rt[e[7]] << 4 | Rt[e[8]] : 255
  })), n;
}
const i0 = (e, t) => e < 255 ? t(e) : "";
function o0(e) {
  var t = r0(e) ? t0 : n0;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + i0(e.a, t) : void 0;
}
const s0 = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function YT(e, t, n) {
  const r = t * Math.min(n, 1 - n), a = (i, o = (i + e / 30) % 12) => n - r * Math.max(Math.min(o - 3, 9 - o, 1), -1);
  return [a(0), a(8), a(4)];
}
function l0(e, t, n) {
  const r = (a, i = (a + e / 60) % 6) => n - n * t * Math.max(Math.min(i, 4 - i, 1), 0);
  return [r(5), r(3), r(1)];
}
function c0(e, t, n) {
  const r = YT(e, 1, 0.5);
  let a;
  for (t + n > 1 && (a = 1 / (t + n), t *= a, n *= a), a = 0; a < 3; a++)
    r[a] *= 1 - t - n, r[a] += t;
  return r;
}
function u0(e, t, n, r, a) {
  return e === a ? (t - n) / r + (t < n ? 6 : 0) : t === a ? (n - e) / r + 2 : (e - t) / r + 4;
}
function Wg(e) {
  const n = e.r / 255, r = e.g / 255, a = e.b / 255, i = Math.max(n, r, a), o = Math.min(n, r, a), s = (i + o) / 2;
  let l, c, u;
  return i !== o && (u = i - o, c = s > 0.5 ? u / (2 - i - o) : u / (i + o), l = u0(n, r, a, u, i), l = l * 60 + 0.5), [l | 0, c || 0, s];
}
function qg(e, t, n, r) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map($n);
}
function Vg(e, t, n) {
  return qg(YT, e, t, n);
}
function d0(e, t, n) {
  return qg(c0, e, t, n);
}
function f0(e, t, n) {
  return qg(l0, e, t, n);
}
function KT(e) {
  return (e % 360 + 360) % 360;
}
function p0(e) {
  const t = s0.exec(e);
  let n = 255, r;
  if (!t)
    return;
  t[5] !== r && (n = t[6] ? Pa(+t[5]) : $n(+t[5]));
  const a = KT(+t[2]), i = +t[3] / 100, o = +t[4] / 100;
  return t[1] === "hwb" ? r = d0(a, i, o) : t[1] === "hsv" ? r = f0(a, i, o) : r = Vg(a, i, o), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function g0(e, t) {
  var n = Wg(e);
  n[0] = KT(n[0] + t), n = Vg(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function h0(e) {
  if (!e)
    return;
  const t = Wg(e), n = t[0], r = km(t[1]), a = km(t[2]);
  return e.a < 255 ? `hsla(${n}, ${r}%, ${a}%, ${dn(e.a)})` : `hsl(${n}, ${r}%, ${a}%)`;
}
const Om = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Dm = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function m0() {
  const e = {}, t = Object.keys(Dm), n = Object.keys(Om);
  let r, a, i, o, s;
  for (r = 0; r < t.length; r++) {
    for (o = s = t[r], a = 0; a < n.length; a++)
      i = n[a], s = s.replace(i, Om[i]);
    i = parseInt(Dm[o], 16), e[s] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return e;
}
let Gi;
function b0(e) {
  Gi || (Gi = m0(), Gi.transparent = [0, 0, 0, 0]);
  const t = Gi[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const v0 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function y0(e) {
  const t = v0.exec(e);
  let n = 255, r, a, i;
  if (t) {
    if (t[7] !== r) {
      const o = +t[7];
      n = t[8] ? Pa(o) : On(o * 255, 0, 255);
    }
    return r = +t[1], a = +t[3], i = +t[5], r = 255 & (t[2] ? Pa(r) : On(r, 0, 255)), a = 255 & (t[4] ? Pa(a) : On(a, 0, 255)), i = 255 & (t[6] ? Pa(i) : On(i, 0, 255)), {
      r,
      g: a,
      b: i,
      a: n
    };
  }
}
function E0(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${dn(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const zs = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Dr = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function S0(e, t, n) {
  const r = Dr(dn(e.r)), a = Dr(dn(e.g)), i = Dr(dn(e.b));
  return {
    r: $n(zs(r + n * (Dr(dn(t.r)) - r))),
    g: $n(zs(a + n * (Dr(dn(t.g)) - a))),
    b: $n(zs(i + n * (Dr(dn(t.b)) - i))),
    a: e.a + n * (t.a - e.a)
  };
}
function Hi(e, t, n) {
  if (e) {
    let r = Wg(e);
    r[t] = Math.max(0, Math.min(r[t] + r[t] * n, t === 0 ? 360 : 1)), r = Vg(r), e.r = r[0], e.g = r[1], e.b = r[2];
  }
}
function XT(e, t) {
  return e && Object.assign(t || {}, e);
}
function Lm(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = $n(e[3]))) : (t = XT(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = $n(t.a)), t;
}
function w0(e) {
  return e.charAt(0) === "r" ? y0(e) : p0(e);
}
class ei {
  constructor(t) {
    if (t instanceof ei)
      return t;
    const n = typeof t;
    let r;
    n === "object" ? r = Lm(t) : n === "string" && (r = a0(t) || b0(t) || w0(t)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = XT(this._rgb);
    return t && (t.a = dn(t.a)), t;
  }
  set rgb(t) {
    this._rgb = Lm(t);
  }
  rgbString() {
    return this._valid ? E0(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? o0(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? h0(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const r = this.rgb, a = t.rgb;
      let i;
      const o = n === i ? 0.5 : n, s = 2 * o - 1, l = r.a - a.a, c = ((s * l === -1 ? s : (s + l) / (1 + s * l)) + 1) / 2;
      i = 1 - c, r.r = 255 & c * r.r + i * a.r + 0.5, r.g = 255 & c * r.g + i * a.g + 0.5, r.b = 255 & c * r.b + i * a.b + 0.5, r.a = o * r.a + (1 - o) * a.a, this.rgb = r;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = S0(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new ei(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = $n(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = bi(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Hi(this._rgb, 2, t), this;
  }
  darken(t) {
    return Hi(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Hi(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Hi(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return g0(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.6
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
function on() {
}
const _0 = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function fe(e) {
  return e === null || typeof e > "u";
}
function De(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function ue(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function Fe(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function St(e, t) {
  return Fe(e) ? e : t;
}
function se(e, t) {
  return typeof e > "u" ? t : e;
}
const T0 = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, ZT = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function Ae(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function ve(e, t, n, r) {
  let a, i, o;
  if (De(e))
    for (i = e.length, a = 0; a < i; a++)
      t.call(n, e[a], a);
  else if (ue(e))
    for (o = Object.keys(e), i = o.length, a = 0; a < i; a++)
      t.call(n, e[o[a]], o[a]);
}
function Po(e, t) {
  let n, r, a, i;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, r = e.length; n < r; ++n)
    if (a = e[n], i = t[n], a.datasetIndex !== i.datasetIndex || a.index !== i.index)
      return !1;
  return !0;
}
function Fo(e) {
  if (De(e))
    return e.map(Fo);
  if (ue(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), r = n.length;
    let a = 0;
    for (; a < r; ++a)
      t[n[a]] = Fo(e[n[a]]);
    return t;
  }
  return e;
}
function QT(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function R0(e, t, n, r) {
  if (!QT(e))
    return;
  const a = t[e], i = n[e];
  ue(a) && ue(i) ? ti(a, i, r) : t[e] = Fo(i);
}
function ti(e, t, n) {
  const r = De(t) ? t : [
    t
  ], a = r.length;
  if (!ue(e))
    return e;
  n = n || {};
  const i = n.merger || R0;
  let o;
  for (let s = 0; s < a; ++s) {
    if (o = r[s], !ue(o))
      continue;
    const l = Object.keys(o);
    for (let c = 0, u = l.length; c < u; ++c)
      i(l[c], e, o, n);
  }
  return e;
}
function ja(e, t) {
  return ti(e, t, {
    merger: A0
  });
}
function A0(e, t, n) {
  if (!QT(e))
    return;
  const r = t[e], a = n[e];
  ue(r) && ue(a) ? ja(r, a) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Fo(a));
}
const Mm = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function x0(e) {
  const t = e.split("."), n = [];
  let r = "";
  for (const a of t)
    r += a, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function C0(e) {
  const t = x0(e);
  return (n) => {
    for (const r of t) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function Un(e, t) {
  return (Mm[t] || (Mm[t] = C0(t)))(e);
}
function jg(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const ni = (e) => typeof e < "u", Gn = (e) => typeof e == "function", Pm = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function N0(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Oe = Math.PI, ke = 2 * Oe, I0 = ke + Oe, $o = Number.POSITIVE_INFINITY, k0 = Oe / 180, Be = Oe / 2, er = Oe / 4, Fm = Oe * 2 / 3, Dn = Math.log10, Xt = Math.sign;
function Ya(e, t, n) {
  return Math.abs(e - t) < n;
}
function $m(e) {
  const t = Math.round(e);
  e = Ya(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(Dn(e))), r = e / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function O0(e) {
  const t = [], n = Math.sqrt(e);
  let r;
  for (r = 1; r < n; r++)
    e % r === 0 && (t.push(r), t.push(e / r));
  return n === (n | 0) && t.push(n), t.sort((a, i) => a - i).pop(), t;
}
function na(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function D0(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function JT(e, t, n) {
  let r, a, i;
  for (r = 0, a = e.length; r < a; r++)
    i = e[r][n], isNaN(i) || (t.min = Math.min(t.min, i), t.max = Math.max(t.max, i));
}
function Pt(e) {
  return e * (Oe / 180);
}
function Yg(e) {
  return e * (180 / Oe);
}
function Bm(e) {
  if (!Fe(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function eR(e, t) {
  const n = t.x - e.x, r = t.y - e.y, a = Math.sqrt(n * n + r * r);
  let i = Math.atan2(r, n);
  return i < -0.5 * Oe && (i += ke), {
    angle: i,
    distance: a
  };
}
function Gp(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function L0(e, t) {
  return (e - t + I0) % ke - Oe;
}
function wt(e) {
  return (e % ke + ke) % ke;
}
function ri(e, t, n, r) {
  const a = wt(e), i = wt(t), o = wt(n), s = wt(i - a), l = wt(o - a), c = wt(a - i), u = wt(a - o);
  return a === i || a === o || r && i === o || s > l && c < u;
}
function Ze(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function M0(e) {
  return Ze(e, -32768, 32767);
}
function pn(e, t, n, r = 1e-6) {
  return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
}
function Kg(e, t, n) {
  n = n || ((o) => e[o] < t);
  let r = e.length - 1, a = 0, i;
  for (; r - a > 1; )
    i = a + r >> 1, n(i) ? a = i : r = i;
  return {
    lo: a,
    hi: r
  };
}
const gn = (e, t, n, r) => Kg(e, n, r ? (a) => {
  const i = e[a][t];
  return i < n || i === n && e[a + 1][t] === n;
} : (a) => e[a][t] < n), P0 = (e, t, n) => Kg(e, n, (r) => e[r][t] >= n);
function F0(e, t, n) {
  let r = 0, a = e.length;
  for (; r < a && e[r] < t; )
    r++;
  for (; a > r && e[a - 1] > n; )
    a--;
  return r > 0 || a < e.length ? e.slice(r, a) : e;
}
const tR = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function $0(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), tR.forEach((n) => {
    const r = "_onData" + jg(n), a = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const o = a.apply(this, i);
        return e._chartjs.listeners.forEach((s) => {
          typeof s[r] == "function" && s[r](...i);
        }), o;
      }
    });
  });
}
function Um(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const r = n.listeners, a = r.indexOf(t);
  a !== -1 && r.splice(a, 1), !(r.length > 0) && (tR.forEach((i) => {
    delete e[i];
  }), delete e._chartjs);
}
function nR(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const rR = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function aR(e, t) {
  let n = [], r = !1;
  return function(...a) {
    n = a, r || (r = !0, rR.call(window, () => {
      r = !1, e.apply(t, n);
    }));
  };
}
function B0(e, t) {
  let n;
  return function(...r) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, r)) : e.apply(this, r), t;
  };
}
const Xg = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", nt = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, U0 = (e, t, n, r) => e === (r ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function iR(e, t, n) {
  const r = t.length;
  let a = 0, i = r;
  if (e._sorted) {
    const { iScale: o, _parsed: s } = e, l = o.axis, { min: c, max: u, minDefined: d, maxDefined: f } = o.getUserBounds();
    d && (a = Ze(Math.min(
      // @ts-expect-error Need to type _parsed
      gn(s, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? r : gn(t, l, o.getPixelForValue(c)).lo
    ), 0, r - 1)), f ? i = Ze(Math.max(
      // @ts-expect-error Need to type _parsed
      gn(s, o.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : gn(t, l, o.getPixelForValue(u), !0).hi + 1
    ), a, r) - a : i = r - a;
  }
  return {
    start: a,
    count: i
  };
}
function oR(e) {
  const { xScale: t, yScale: n, _scaleRanges: r } = e, a = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return e._scaleRanges = a, !0;
  const i = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, a), i;
}
const zi = (e) => e === 0 || e === 1, Gm = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * ke / n)), Hm = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * ke / n) + 1, Ka = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * Be) + 1,
  easeOutSine: (e) => Math.sin(e * Be),
  easeInOutSine: (e) => -0.5 * (Math.cos(Oe * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => zi(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => zi(e) ? e : Gm(e, 0.075, 0.3),
  easeOutElastic: (e) => zi(e) ? e : Hm(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return zi(e) ? e : e < 0.5 ? 0.5 * Gm(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * Hm(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - Ka.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? Ka.easeInBounce(e * 2) * 0.5 : Ka.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Zg(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function zm(e) {
  return Zg(e) ? e : new ei(e);
}
function Ws(e) {
  return Zg(e) ? e : new ei(e).saturate(0.5).darken(0.1).hexString();
}
const G0 = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], H0 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function z0(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: H0
    },
    numbers: {
      type: "number",
      properties: G0
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function W0(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Wm = /* @__PURE__ */ new Map();
function q0(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let r = Wm.get(n);
  return r || (r = new Intl.NumberFormat(e, t), Wm.set(n, r)), r;
}
function vi(e, t, n) {
  return q0(t, n).format(e);
}
const sR = {
  values(e) {
    return De(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const r = this.chart.options.locale;
    let a, i = e;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (a = "scientific"), i = V0(e, n);
    }
    const o = Dn(Math.abs(i)), s = isNaN(o) ? 1 : Math.max(Math.min(-1 * Math.floor(o), 20), 0), l = {
      notation: a,
      minimumFractionDigits: s,
      maximumFractionDigits: s
    };
    return Object.assign(l, this.options.ticks.format), vi(e, r, l);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const r = n[t].significand || e / Math.pow(10, Math.floor(Dn(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || t > 0.8 * n.length ? sR.numeric.call(this, e, t, n) : "";
  }
};
function V0(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var cs = {
  formatters: sR
};
function j0(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: cs.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const br = /* @__PURE__ */ Object.create(null), Hp = /* @__PURE__ */ Object.create(null);
function Xa(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let r = 0, a = n.length; r < a; ++r) {
    const i = n[r];
    e = e[i] || (e[i] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function qs(e, t, n) {
  return typeof t == "string" ? ti(Xa(e, t), n) : ti(Xa(e, ""), t);
}
class Y0 {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, a) => Ws(a.backgroundColor), this.hoverBorderColor = (r, a) => Ws(a.borderColor), this.hoverColor = (r, a) => Ws(a.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return qs(this, t, n);
  }
  get(t) {
    return Xa(this, t);
  }
  describe(t, n) {
    return qs(Hp, t, n);
  }
  override(t, n) {
    return qs(br, t, n);
  }
  route(t, n, r, a) {
    const i = Xa(this, t), o = Xa(this, r), s = "_" + n;
    Object.defineProperties(i, {
      [s]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[s], c = o[a];
          return ue(l) ? Object.assign({}, c, l) : se(l, c);
        },
        set(l) {
          this[s] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var Le = /* @__PURE__ */ new Y0({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  z0,
  W0,
  j0
]);
function K0(e) {
  return !e || fe(e.size) || fe(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function Bo(e, t, n, r, a) {
  let i = t[a];
  return i || (i = t[a] = e.measureText(a).width, n.push(a)), i > r && (r = i), r;
}
function X0(e, t, n, r) {
  r = r || {};
  let a = r.data = r.data || {}, i = r.garbageCollect = r.garbageCollect || [];
  r.font !== t && (a = r.data = {}, i = r.garbageCollect = [], r.font = t), e.save(), e.font = t;
  let o = 0;
  const s = n.length;
  let l, c, u, d, f;
  for (l = 0; l < s; l++)
    if (d = n[l], d != null && !De(d))
      o = Bo(e, a, i, o, d);
    else if (De(d))
      for (c = 0, u = d.length; c < u; c++)
        f = d[c], f != null && !De(f) && (o = Bo(e, a, i, o, f));
  e.restore();
  const g = i.length / 2;
  if (g > n.length) {
    for (l = 0; l < g; l++)
      delete a[i[l]];
    i.splice(0, g);
  }
  return o;
}
function tr(e, t, n) {
  const r = e.currentDevicePixelRatio, a = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - a) * r) / r + a;
}
function qm(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function zp(e, t, n, r) {
  lR(e, t, n, r, null);
}
function lR(e, t, n, r, a) {
  let i, o, s, l, c, u, d, f;
  const g = t.pointStyle, h = t.rotation, p = t.radius;
  let m = (h || 0) * k0;
  if (g && typeof g == "object" && (i = g.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, r), e.rotate(m), e.drawImage(g, -g.width / 2, -g.height / 2, g.width, g.height), e.restore();
    return;
  }
  if (!(isNaN(p) || p <= 0)) {
    switch (e.beginPath(), g) {
      default:
        a ? e.ellipse(n, r, a / 2, p, 0, 0, ke) : e.arc(n, r, p, 0, ke), e.closePath();
        break;
      case "triangle":
        u = a ? a / 2 : p, e.moveTo(n + Math.sin(m) * u, r - Math.cos(m) * p), m += Fm, e.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * p), m += Fm, e.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * p), e.closePath();
        break;
      case "rectRounded":
        c = p * 0.516, l = p - c, o = Math.cos(m + er) * l, d = Math.cos(m + er) * (a ? a / 2 - c : l), s = Math.sin(m + er) * l, f = Math.sin(m + er) * (a ? a / 2 - c : l), e.arc(n - d, r - s, c, m - Oe, m - Be), e.arc(n + f, r - o, c, m - Be, m), e.arc(n + d, r + s, c, m, m + Be), e.arc(n - f, r + o, c, m + Be, m + Oe), e.closePath();
        break;
      case "rect":
        if (!h) {
          l = Math.SQRT1_2 * p, u = a ? a / 2 : l, e.rect(n - u, r - l, 2 * u, 2 * l);
          break;
        }
        m += er;
      case "rectRot":
        d = Math.cos(m) * (a ? a / 2 : p), o = Math.cos(m) * p, s = Math.sin(m) * p, f = Math.sin(m) * (a ? a / 2 : p), e.moveTo(n - d, r - s), e.lineTo(n + f, r - o), e.lineTo(n + d, r + s), e.lineTo(n - f, r + o), e.closePath();
        break;
      case "crossRot":
        m += er;
      case "cross":
        d = Math.cos(m) * (a ? a / 2 : p), o = Math.cos(m) * p, s = Math.sin(m) * p, f = Math.sin(m) * (a ? a / 2 : p), e.moveTo(n - d, r - s), e.lineTo(n + d, r + s), e.moveTo(n + f, r - o), e.lineTo(n - f, r + o);
        break;
      case "star":
        d = Math.cos(m) * (a ? a / 2 : p), o = Math.cos(m) * p, s = Math.sin(m) * p, f = Math.sin(m) * (a ? a / 2 : p), e.moveTo(n - d, r - s), e.lineTo(n + d, r + s), e.moveTo(n + f, r - o), e.lineTo(n - f, r + o), m += er, d = Math.cos(m) * (a ? a / 2 : p), o = Math.cos(m) * p, s = Math.sin(m) * p, f = Math.sin(m) * (a ? a / 2 : p), e.moveTo(n - d, r - s), e.lineTo(n + d, r + s), e.moveTo(n + f, r - o), e.lineTo(n - f, r + o);
        break;
      case "line":
        o = a ? a / 2 : Math.cos(m) * p, s = Math.sin(m) * p, e.moveTo(n - o, r - s), e.lineTo(n + o, r + s);
        break;
      case "dash":
        e.moveTo(n, r), e.lineTo(n + Math.cos(m) * (a ? a / 2 : p), r + Math.sin(m) * p);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function hn(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function us(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function ds(e) {
  e.restore();
}
function Z0(e, t, n, r, a) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (a === "middle") {
    const i = (t.x + n.x) / 2;
    e.lineTo(i, t.y), e.lineTo(i, n.y);
  } else a === "after" != !!r ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function Q0(e, t, n, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(r ? t.cp1x : t.cp2x, r ? t.cp1y : t.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function J0(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), fe(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function eO(e, t, n, r, a) {
  if (a.strikethrough || a.underline) {
    const i = e.measureText(r), o = t - i.actualBoundingBoxLeft, s = t + i.actualBoundingBoxRight, l = n - i.actualBoundingBoxAscent, c = n + i.actualBoundingBoxDescent, u = a.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = a.decorationWidth || 2, e.moveTo(o, u), e.lineTo(s, u), e.stroke();
  }
}
function tO(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function vr(e, t, n, r, a, i = {}) {
  const o = De(t) ? t : [
    t
  ], s = i.strokeWidth > 0 && i.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = a.string, J0(e, i), l = 0; l < o.length; ++l)
    c = o[l], i.backdrop && tO(e, i.backdrop), s && (i.strokeColor && (e.strokeStyle = i.strokeColor), fe(i.strokeWidth) || (e.lineWidth = i.strokeWidth), e.strokeText(c, n, r, i.maxWidth)), e.fillText(c, n, r, i.maxWidth), eO(e, n, r, c, i), r += Number(a.lineHeight);
  e.restore();
}
function ai(e, t) {
  const { x: n, y: r, w: a, h: i, radius: o } = t;
  e.arc(n + o.topLeft, r + o.topLeft, o.topLeft, 1.5 * Oe, Oe, !0), e.lineTo(n, r + i - o.bottomLeft), e.arc(n + o.bottomLeft, r + i - o.bottomLeft, o.bottomLeft, Oe, Be, !0), e.lineTo(n + a - o.bottomRight, r + i), e.arc(n + a - o.bottomRight, r + i - o.bottomRight, o.bottomRight, Be, 0, !0), e.lineTo(n + a, r + o.topRight), e.arc(n + a - o.topRight, r + o.topRight, o.topRight, 0, -Be, !0), e.lineTo(n + o.topLeft, r);
}
const nO = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, rO = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function aO(e, t) {
  const n = ("" + e).match(nO);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const iO = (e) => +e || 0;
function Qg(e, t) {
  const n = {}, r = ue(t), a = r ? Object.keys(t) : t, i = ue(e) ? r ? (o) => se(e[o], e[t[o]]) : (o) => e[o] : () => e;
  for (const o of a)
    n[o] = iO(i(o));
  return n;
}
function cR(e) {
  return Qg(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function gr(e) {
  return Qg(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function it(e) {
  const t = cR(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function je(e, t) {
  e = e || {}, t = t || Le.font;
  let n = se(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = se(e.style, t.style);
  r && !("" + r).match(rO) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const a = {
    family: se(e.family, t.family),
    lineHeight: aO(se(e.lineHeight, t.lineHeight), n),
    size: n,
    style: r,
    weight: se(e.weight, t.weight),
    string: ""
  };
  return a.string = K0(a), a;
}
function Fa(e, t, n, r) {
  let a, i, o;
  for (a = 0, i = e.length; a < i; ++a)
    if (o = e[a], o !== void 0 && o !== void 0)
      return o;
}
function oO(e, t, n) {
  const { min: r, max: a } = e, i = ZT(t, (a - r) / 2), o = (s, l) => n && s === 0 ? 0 : s + l;
  return {
    min: o(r, -Math.abs(i)),
    max: o(a, i)
  };
}
function Vn(e, t) {
  return Object.assign(Object.create(e), t);
}
function Jg(e, t = [
  ""
], n, r, a = () => e[0]) {
  const i = n || e;
  typeof r > "u" && (r = pR("_fallback", e));
  const o = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: i,
    _fallback: r,
    _getTarget: a,
    override: (s) => Jg([
      s,
      ...e
    ], t, i, r)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, l) {
      return delete s[l], delete s._keys, delete e[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, l) {
      return dR(s, l, () => gO(l, t, e, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, l) {
      return Reflect.getOwnPropertyDescriptor(s._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(s, l) {
      return jm(s).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(s) {
      return jm(s);
    },
    /**
    * A trap for setting property values.
    */
    set(s, l, c) {
      const u = s._storage || (s._storage = a());
      return s[l] = u[l] = c, delete s._keys, !0;
    }
  });
}
function ra(e, t, n, r) {
  const a = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: uR(e, r),
    setContext: (i) => ra(e, i, n, r),
    override: (i) => ra(e.override(i), t, n, r)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, o) {
      return delete i[o], delete e[o], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, o, s) {
      return dR(i, o, () => lO(i, o, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, o) {
      return i._descriptors.allKeys ? Reflect.has(e, o) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, o);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(i, o) {
      return Reflect.has(e, o);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(i, o, s) {
      return e[o] = s, delete i[o], !0;
    }
  });
}
function uR(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: r = t.indexable, _allKeys: a = t.allKeys } = e;
  return {
    allKeys: a,
    scriptable: n,
    indexable: r,
    isScriptable: Gn(n) ? n : () => n,
    isIndexable: Gn(r) ? r : () => r
  };
}
const sO = (e, t) => e ? e + jg(t) : t, eh = (e, t) => ue(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function dR(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const r = n();
  return e[t] = r, r;
}
function lO(e, t, n) {
  const { _proxy: r, _context: a, _subProxy: i, _descriptors: o } = e;
  let s = r[t];
  return Gn(s) && o.isScriptable(t) && (s = cO(t, s, e, n)), De(s) && s.length && (s = uO(t, s, e, o.isIndexable)), eh(t, s) && (s = ra(s, a, i && i[t], o)), s;
}
function cO(e, t, n, r) {
  const { _proxy: a, _context: i, _subProxy: o, _stack: s } = n;
  if (s.has(e))
    throw new Error("Recursion detected: " + Array.from(s).join("->") + "->" + e);
  s.add(e);
  let l = t(i, o || r);
  return s.delete(e), eh(e, l) && (l = th(a._scopes, a, e, l)), l;
}
function uO(e, t, n, r) {
  const { _proxy: a, _context: i, _subProxy: o, _descriptors: s } = n;
  if (typeof i.index < "u" && r(e))
    return t[i.index % t.length];
  if (ue(t[0])) {
    const l = t, c = a._scopes.filter((u) => u !== l);
    t = [];
    for (const u of l) {
      const d = th(c, a, e, u);
      t.push(ra(d, i, o && o[e], s));
    }
  }
  return t;
}
function fR(e, t, n) {
  return Gn(e) ? e(t, n) : e;
}
const dO = (e, t) => e === !0 ? t : typeof e == "string" ? Un(t, e) : void 0;
function fO(e, t, n, r, a) {
  for (const i of t) {
    const o = dO(n, i);
    if (o) {
      e.add(o);
      const s = fR(o._fallback, n, a);
      if (typeof s < "u" && s !== n && s !== r)
        return s;
    } else if (o === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function th(e, t, n, r) {
  const a = t._rootScopes, i = fR(t._fallback, n, r), o = [
    ...e,
    ...a
  ], s = /* @__PURE__ */ new Set();
  s.add(r);
  let l = Vm(s, o, n, i || n, r);
  return l === null || typeof i < "u" && i !== n && (l = Vm(s, o, i, l, r), l === null) ? !1 : Jg(Array.from(s), [
    ""
  ], a, i, () => pO(t, n, r));
}
function Vm(e, t, n, r, a) {
  for (; n; )
    n = fO(e, t, n, r, a);
  return n;
}
function pO(e, t, n) {
  const r = e._getTarget();
  t in r || (r[t] = {});
  const a = r[t];
  return De(a) && ue(n) ? n : a || {};
}
function gO(e, t, n, r) {
  let a;
  for (const i of t)
    if (a = pR(sO(i, e), n), typeof a < "u")
      return eh(e, a) ? th(n, r, e, a) : a;
}
function pR(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const r = n[e];
    if (typeof r < "u")
      return r;
  }
}
function jm(e) {
  let t = e._keys;
  return t || (t = e._keys = hO(e._scopes)), t;
}
function hO(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of Object.keys(n).filter((a) => !a.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
function gR(e, t, n, r) {
  const { iScale: a } = e, { key: i = "r" } = this._parsing, o = new Array(r);
  let s, l, c, u;
  for (s = 0, l = r; s < l; ++s)
    c = s + n, u = t[c], o[s] = {
      r: a.parse(Un(u, i), c)
    };
  return o;
}
const mO = Number.EPSILON || 1e-14, aa = (e, t) => t < e.length && !e[t].skip && e[t], hR = (e) => e === "x" ? "y" : "x";
function bO(e, t, n, r) {
  const a = e.skip ? t : e, i = t, o = n.skip ? t : n, s = Gp(i, a), l = Gp(o, i);
  let c = s / (s + l), u = l / (s + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = r * c, f = r * u;
  return {
    previous: {
      x: i.x - d * (o.x - a.x),
      y: i.y - d * (o.y - a.y)
    },
    next: {
      x: i.x + f * (o.x - a.x),
      y: i.y + f * (o.y - a.y)
    }
  };
}
function vO(e, t, n) {
  const r = e.length;
  let a, i, o, s, l, c = aa(e, 0);
  for (let u = 0; u < r - 1; ++u)
    if (l = c, c = aa(e, u + 1), !(!l || !c)) {
      if (Ya(t[u], 0, mO)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      a = n[u] / t[u], i = n[u + 1] / t[u], s = Math.pow(a, 2) + Math.pow(i, 2), !(s <= 9) && (o = 3 / Math.sqrt(s), n[u] = a * o * t[u], n[u + 1] = i * o * t[u]);
    }
}
function yO(e, t, n = "x") {
  const r = hR(n), a = e.length;
  let i, o, s, l = aa(e, 0);
  for (let c = 0; c < a; ++c) {
    if (o = s, s = l, l = aa(e, c + 1), !s)
      continue;
    const u = s[n], d = s[r];
    o && (i = (u - o[n]) / 3, s[`cp1${n}`] = u - i, s[`cp1${r}`] = d - i * t[c]), l && (i = (l[n] - u) / 3, s[`cp2${n}`] = u + i, s[`cp2${r}`] = d + i * t[c]);
  }
}
function EO(e, t = "x") {
  const n = hR(t), r = e.length, a = Array(r).fill(0), i = Array(r);
  let o, s, l, c = aa(e, 0);
  for (o = 0; o < r; ++o)
    if (s = l, l = c, c = aa(e, o + 1), !!l) {
      if (c) {
        const u = c[t] - l[t];
        a[o] = u !== 0 ? (c[n] - l[n]) / u : 0;
      }
      i[o] = s ? c ? Xt(a[o - 1]) !== Xt(a[o]) ? 0 : (a[o - 1] + a[o]) / 2 : a[o - 1] : a[o];
    }
  vO(e, a, i), yO(e, i, t);
}
function Wi(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function SO(e, t) {
  let n, r, a, i, o, s = hn(e[0], t);
  for (n = 0, r = e.length; n < r; ++n)
    o = i, i = s, s = n < r - 1 && hn(e[n + 1], t), i && (a = e[n], o && (a.cp1x = Wi(a.cp1x, t.left, t.right), a.cp1y = Wi(a.cp1y, t.top, t.bottom)), s && (a.cp2x = Wi(a.cp2x, t.left, t.right), a.cp2y = Wi(a.cp2y, t.top, t.bottom)));
}
function wO(e, t, n, r, a) {
  let i, o, s, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    EO(e, a);
  else {
    let c = r ? e[e.length - 1] : e[0];
    for (i = 0, o = e.length; i < o; ++i)
      s = e[i], l = bO(c, s, e[Math.min(i + 1, o - (r ? 0 : 1)) % o], t.tension), s.cp1x = l.previous.x, s.cp1y = l.previous.y, s.cp2x = l.next.x, s.cp2y = l.next.y, c = s;
  }
  t.capBezierPoints && SO(e, n);
}
function nh() {
  return typeof window < "u" && typeof document < "u";
}
function rh(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function Uo(e, t, n) {
  let r;
  return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[n])) : r = e, r;
}
const fs = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function _O(e, t) {
  return fs(e).getPropertyValue(t);
}
const TO = [
  "top",
  "right",
  "bottom",
  "left"
];
function hr(e, t, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let a = 0; a < 4; a++) {
    const i = TO[a];
    r[i] = parseFloat(e[t + "-" + i + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const RO = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function AO(e, t) {
  const n = e.touches, r = n && n.length ? n[0] : e, { offsetX: a, offsetY: i } = r;
  let o = !1, s, l;
  if (RO(a, i, e.target))
    s = a, l = i;
  else {
    const c = t.getBoundingClientRect();
    s = r.clientX - c.left, l = r.clientY - c.top, o = !0;
  }
  return {
    x: s,
    y: l,
    box: o
  };
}
function lr(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: r } = t, a = fs(n), i = a.boxSizing === "border-box", o = hr(a, "padding"), s = hr(a, "border", "width"), { x: l, y: c, box: u } = AO(e, n), d = o.left + (u && s.left), f = o.top + (u && s.top);
  let { width: g, height: h } = t;
  return i && (g -= o.width + s.width, h -= o.height + s.height), {
    x: Math.round((l - d) / g * n.width / r),
    y: Math.round((c - f) / h * n.height / r)
  };
}
function xO(e, t, n) {
  let r, a;
  if (t === void 0 || n === void 0) {
    const i = e && rh(e);
    if (!i)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const o = i.getBoundingClientRect(), s = fs(i), l = hr(s, "border", "width"), c = hr(s, "padding");
      t = o.width - c.width - l.width, n = o.height - c.height - l.height, r = Uo(s.maxWidth, i, "clientWidth"), a = Uo(s.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: r || $o,
    maxHeight: a || $o
  };
}
const qi = (e) => Math.round(e * 10) / 10;
function CO(e, t, n, r) {
  const a = fs(e), i = hr(a, "margin"), o = Uo(a.maxWidth, e, "clientWidth") || $o, s = Uo(a.maxHeight, e, "clientHeight") || $o, l = xO(e, t, n);
  let { width: c, height: u } = l;
  if (a.boxSizing === "content-box") {
    const f = hr(a, "border", "width"), g = hr(a, "padding");
    c -= g.width + f.width, u -= g.height + f.height;
  }
  return c = Math.max(0, c - i.width), u = Math.max(0, r ? c / r : u - i.height), c = qi(Math.min(c, o, l.maxWidth)), u = qi(Math.min(u, s, l.maxHeight)), c && !u && (u = qi(c / 2)), (t !== void 0 || n !== void 0) && r && l.height && u > l.height && (u = l.height, c = qi(Math.floor(u * r))), {
    width: c,
    height: u
  };
}
function Ym(e, t, n) {
  const r = t || 1, a = Math.floor(e.height * r), i = Math.floor(e.width * r);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const o = e.canvas;
  return o.style && (n || !o.style.height && !o.style.width) && (o.style.height = `${e.height}px`, o.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || o.height !== a || o.width !== i ? (e.currentDevicePixelRatio = r, o.height = a, o.width = i, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const NO = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    nh() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function Km(e, t) {
  const n = _O(e, t), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function cr(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function IO(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: r === "middle" ? n < 0.5 ? e.y : t.y : r === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function kO(e, t, n, r) {
  const a = {
    x: e.cp2x,
    y: e.cp2y
  }, i = {
    x: t.cp1x,
    y: t.cp1y
  }, o = cr(e, a, n), s = cr(a, i, n), l = cr(i, t, n), c = cr(o, s, n), u = cr(s, l, n);
  return cr(c, u, n);
}
const OO = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, DO = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function Yr(e, t, n) {
  return e ? OO(t, n) : DO();
}
function mR(e, t) {
  let n, r;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = r);
}
function bR(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function vR(e) {
  return e === "angle" ? {
    between: ri,
    compare: L0,
    normalize: wt
  } : {
    between: pn,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function Xm({ start: e, end: t, count: n, loop: r, style: a }) {
  return {
    start: e % n,
    end: t % n,
    loop: r && (t - e + 1) % n === 0,
    style: a
  };
}
function LO(e, t, n) {
  const { property: r, start: a, end: i } = n, { between: o, normalize: s } = vR(r), l = t.length;
  let { start: c, end: u, loop: d } = e, f, g;
  if (d) {
    for (c += l, u += l, f = 0, g = l; f < g && o(s(t[c % l][r]), a, i); ++f)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: e.style
  };
}
function yR(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: r, start: a, end: i } = n, o = t.length, { compare: s, between: l, normalize: c } = vR(r), { start: u, end: d, loop: f, style: g } = LO(e, t, n), h = [];
  let p = !1, m = null, v, y, E;
  const S = () => l(a, E, v) && s(a, E) !== 0, w = () => s(i, v) === 0 || l(i, E, v), R = () => p || S(), T = () => !p || w();
  for (let A = u, C = u; A <= d; ++A)
    y = t[A % o], !y.skip && (v = c(y[r]), v !== E && (p = l(v, a, i), m === null && R() && (m = s(v, a) === 0 ? A : C), m !== null && T() && (h.push(Xm({
      start: m,
      end: A,
      loop: f,
      count: o,
      style: g
    })), m = null), C = A, E = v));
  return m !== null && h.push(Xm({
    start: m,
    end: d,
    loop: f,
    count: o,
    style: g
  })), h;
}
function ER(e, t) {
  const n = [], r = e.segments;
  for (let a = 0; a < r.length; a++) {
    const i = yR(r[a], e.points, t);
    i.length && n.push(...i);
  }
  return n;
}
function MO(e, t, n, r) {
  let a = 0, i = t - 1;
  if (n && !r)
    for (; a < t && !e[a].skip; )
      a++;
  for (; a < t && e[a].skip; )
    a++;
  for (a %= t, n && (i += a); i > a && e[i % t].skip; )
    i--;
  return i %= t, {
    start: a,
    end: i
  };
}
function PO(e, t, n, r) {
  const a = e.length, i = [];
  let o = t, s = e[t], l;
  for (l = t + 1; l <= n; ++l) {
    const c = e[l % a];
    c.skip || c.stop ? s.skip || (r = !1, i.push({
      start: t % a,
      end: (l - 1) % a,
      loop: r
    }), t = o = c.stop ? l : null) : (o = l, s.skip && (t = l)), s = c;
  }
  return o !== null && i.push({
    start: t % a,
    end: o % a,
    loop: r
  }), i;
}
function FO(e, t) {
  const n = e.points, r = e.options.spanGaps, a = n.length;
  if (!a)
    return [];
  const i = !!e._loop, { start: o, end: s } = MO(n, a, i, r);
  if (r === !0)
    return Zm(e, [
      {
        start: o,
        end: s,
        loop: i
      }
    ], n, t);
  const l = s < o ? s + a : s, c = !!e._fullLoop && o === 0 && s === a - 1;
  return Zm(e, PO(n, o, l, c), n, t);
}
function Zm(e, t, n, r) {
  return !r || !r.setContext || !n ? t : $O(e, t, n, r);
}
function $O(e, t, n, r) {
  const a = e._chart.getContext(), i = Qm(e.options), { _datasetIndex: o, options: { spanGaps: s } } = e, l = n.length, c = [];
  let u = i, d = t[0].start, f = d;
  function g(h, p, m, v) {
    const y = s ? -1 : 1;
    if (h !== p) {
      for (h += l; n[h % l].skip; )
        h -= y;
      for (; n[p % l].skip; )
        p += y;
      h % l !== p % l && (c.push({
        start: h % l,
        end: p % l,
        loop: m,
        style: v
      }), u = v, d = p % l);
    }
  }
  for (const h of t) {
    d = s ? d : h.start;
    let p = n[d % l], m;
    for (f = d + 1; f <= h.end; f++) {
      const v = n[f % l];
      m = Qm(r.setContext(Vn(a, {
        type: "segment",
        p0: p,
        p1: v,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: o
      }))), BO(m, u) && g(d, f - 1, h.loop, u), p = v, u = m;
    }
    d < f - 1 && g(d, f - 1, h.loop, u);
  }
  return c;
}
function Qm(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function BO(e, t) {
  if (!t)
    return !1;
  const n = [], r = function(a, i) {
    return Zg(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  };
  return JSON.stringify(e, r) !== JSON.stringify(t, r);
}
/*!
 * Chart.js v4.4.6
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
class UO {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, r, a) {
    const i = n.listeners[a], o = n.duration;
    i.forEach((s) => s({
      chart: t,
      initial: n.initial,
      numSteps: o,
      currentStep: Math.min(r - n.start, o)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = rR.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((r, a) => {
      if (!r.running || !r.items.length)
        return;
      const i = r.items;
      let o = i.length - 1, s = !1, l;
      for (; o >= 0; --o)
        l = i[o], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(t), s = !0) : (i[o] = i[i.length - 1], i.pop());
      s && (a.draw(), this._notify(a, r, t, "progress")), i.length || (r.running = !1, this._notify(a, r, t, "complete"), r.initial = !1), n += i.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let r = n.get(t);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, r)), r;
  }
  listen(t, n, r) {
    this._getAnims(t).listeners[n].push(r);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, a) => Math.max(r, a._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let a = r.length - 1;
    for (; a >= 0; --a)
      r[a].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var cn = /* @__PURE__ */ new UO();
const Jm = "transparent", GO = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const r = zm(e || Jm), a = r.valid && zm(t || Jm);
    return a && a.valid ? a.mix(r, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class HO {
  constructor(t, n, r, a) {
    const i = n[r];
    a = Fa([
      t.to,
      a,
      i,
      t.from
    ]);
    const o = Fa([
      t.from,
      i,
      a
    ]);
    this._active = !0, this._fn = t.fn || GO[t.type || typeof o], this._easing = Ka[t.easing] || Ka.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = r, this._from = o, this._to = a, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, r) {
    if (this._active) {
      this._notify(!1);
      const a = this._target[this._prop], i = r - this._start, o = this._duration - i;
      this._start = r, this._duration = Math.floor(Math.max(o, t.duration)), this._total += i, this._loop = !!t.loop, this._to = Fa([
        t.to,
        n,
        a,
        t.from
      ]), this._from = Fa([
        t.from,
        a,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, r = this._duration, a = this._prop, i = this._from, o = this._loop, s = this._to;
    let l;
    if (this._active = i !== s && (o || n < r), !this._active) {
      this._target[a] = s, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[a] = i;
      return;
    }
    l = n / r % 2, l = o && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[a] = this._fn(i, s, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      t.push({
        res: n,
        rej: r
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", r = this._promises || [];
    for (let a = 0; a < r.length; a++)
      r[a][n]();
  }
}
class SR {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!ue(t))
      return;
    const n = Object.keys(Le.animation), r = this._properties;
    Object.getOwnPropertyNames(t).forEach((a) => {
      const i = t[a];
      if (!ue(i))
        return;
      const o = {};
      for (const s of n)
        o[s] = i[s];
      (De(i.properties) && i.properties || [
        a
      ]).forEach((s) => {
        (s === a || !r.has(s)) && r.set(s, o);
      });
    });
  }
  _animateOptions(t, n) {
    const r = n.options, a = WO(t, r);
    if (!a)
      return [];
    const i = this._createAnimations(a, r);
    return r.$shared && zO(t.options.$animations, r).then(() => {
      t.options = r;
    }, () => {
    }), i;
  }
  _createAnimations(t, n) {
    const r = this._properties, a = [], i = t.$animations || (t.$animations = {}), o = Object.keys(n), s = Date.now();
    let l;
    for (l = o.length - 1; l >= 0; --l) {
      const c = o[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        a.push(...this._animateOptions(t, n));
        continue;
      }
      const u = n[c];
      let d = i[c];
      const f = r.get(c);
      if (d)
        if (f && d.active()) {
          d.update(f, u, s);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        t[c] = u;
        continue;
      }
      i[c] = d = new HO(f, t, c, u), a.push(d);
    }
    return a;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const r = this._createAnimations(t, n);
    if (r.length)
      return cn.add(this._chart, r), !0;
  }
}
function zO(e, t) {
  const n = [], r = Object.keys(t);
  for (let a = 0; a < r.length; a++) {
    const i = e[r[a]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
function WO(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function eb(e, t) {
  const n = e && e.options || {}, r = n.reverse, a = n.min === void 0 ? t : 0, i = n.max === void 0 ? t : 0;
  return {
    start: r ? i : a,
    end: r ? a : i
  };
}
function qO(e, t, n) {
  if (n === !1)
    return !1;
  const r = eb(e, n), a = eb(t, n);
  return {
    top: a.end,
    right: r.end,
    bottom: a.start,
    left: r.start
  };
}
function VO(e) {
  let t, n, r, a;
  return ue(e) ? (t = e.top, n = e.right, r = e.bottom, a = e.left) : t = n = r = a = e, {
    top: t,
    right: n,
    bottom: r,
    left: a,
    disabled: e === !1
  };
}
function wR(e, t) {
  const n = [], r = e._getSortedDatasetMetas(t);
  let a, i;
  for (a = 0, i = r.length; a < i; ++a)
    n.push(r[a].index);
  return n;
}
function tb(e, t, n, r = {}) {
  const a = e.keys, i = r.mode === "single";
  let o, s, l, c;
  if (t === null)
    return;
  let u = !1;
  for (o = 0, s = a.length; o < s; ++o) {
    if (l = +a[o], l === n) {
      if (u = !0, r.all)
        continue;
      break;
    }
    c = e.values[l], Fe(c) && (i || t === 0 || Xt(t) === Xt(c)) && (t += c);
  }
  return !u && !r.all ? 0 : t;
}
function jO(e, t) {
  const { iScale: n, vScale: r } = t, a = n.axis === "x" ? "x" : "y", i = r.axis === "x" ? "x" : "y", o = Object.keys(e), s = new Array(o.length);
  let l, c, u;
  for (l = 0, c = o.length; l < c; ++l)
    u = o[l], s[l] = {
      [a]: u,
      [i]: e[u]
    };
  return s;
}
function Vs(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function YO(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function KO(e) {
  const { min: t, max: n, minDefined: r, maxDefined: a } = e.getUserBounds();
  return {
    min: r ? t : Number.NEGATIVE_INFINITY,
    max: a ? n : Number.POSITIVE_INFINITY
  };
}
function XO(e, t, n) {
  const r = e[t] || (e[t] = {});
  return r[n] || (r[n] = {});
}
function nb(e, t, n, r) {
  for (const a of t.getMatchingVisibleMetas(r).reverse()) {
    const i = e[a.index];
    if (n && i > 0 || !n && i < 0)
      return a.index;
  }
  return null;
}
function rb(e, t) {
  const { chart: n, _cachedMeta: r } = e, a = n._stacks || (n._stacks = {}), { iScale: i, vScale: o, index: s } = r, l = i.axis, c = o.axis, u = YO(i, o, r), d = t.length;
  let f;
  for (let g = 0; g < d; ++g) {
    const h = t[g], { [l]: p, [c]: m } = h, v = h._stacks || (h._stacks = {});
    f = v[c] = XO(a, u, p), f[s] = m, f._top = nb(f, o, !0, r.type), f._bottom = nb(f, o, !1, r.type);
    const y = f._visualValues || (f._visualValues = {});
    y[s] = m;
  }
}
function js(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((r) => n[r].axis === t).shift();
}
function ZO(e, t) {
  return Vn(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function QO(e, t, n) {
  return Vn(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function _a(e, t) {
  const n = e.controller.index, r = e.vScale && e.vScale.axis;
  if (r) {
    t = t || e._parsed;
    for (const a of t) {
      const i = a._stacks;
      if (!i || i[r] === void 0 || i[r][n] === void 0)
        return;
      delete i[r][n], i[r]._visualValues !== void 0 && i[r]._visualValues[n] !== void 0 && delete i[r]._visualValues[n];
    }
  }
}
const Ys = (e) => e === "reset" || e === "none", ab = (e, t) => t ? e : Object.assign({}, e), JO = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: wR(n, !0),
  values: null
};
class $t {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = Vs(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && _a(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, r = this.getDataset(), a = (d, f, g, h) => d === "x" ? f : d === "r" ? h : g, i = n.xAxisID = se(r.xAxisID, js(t, "x")), o = n.yAxisID = se(r.yAxisID, js(t, "y")), s = n.rAxisID = se(r.rAxisID, js(t, "r")), l = n.indexAxis, c = n.iAxisID = a(l, i, o, s), u = n.vAxisID = a(l, o, i, s);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(o), n.rScale = this.getScaleForId(s), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Um(this._data, this), t._stacked && _a(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), r = this._data;
    if (ue(n)) {
      const a = this._cachedMeta;
      this._data = jO(n, a);
    } else if (r !== n) {
      if (r) {
        Um(r, this);
        const a = this._cachedMeta;
        _a(a), a._parsed = [];
      }
      n && Object.isExtensible(n) && $0(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, r = this.getDataset();
    let a = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = Vs(n.vScale, n), n.stack !== r.stack && (a = !0, _a(n), n.stack = r.stack), this._resyncElements(t), (a || i !== n._stacked) && (rb(this, n._parsed), n._stacked = Vs(n.vScale, n));
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), r = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: r, _data: a } = this, { iScale: i, _stacked: o } = r, s = i.axis;
    let l = t === 0 && n === a.length ? !0 : r._sorted, c = t > 0 && r._parsed[t - 1], u, d, f;
    if (this._parsing === !1)
      r._parsed = a, r._sorted = !0, f = a;
    else {
      De(a[t]) ? f = this.parseArrayData(r, a, t, n) : ue(a[t]) ? f = this.parseObjectData(r, a, t, n) : f = this.parsePrimitiveData(r, a, t, n);
      const g = () => d[s] === null || c && d[s] < c[s];
      for (u = 0; u < n; ++u)
        r._parsed[u + t] = d = f[u], l && (g() && (l = !1), c = d);
      r._sorted = l;
    }
    o && rb(this, f);
  }
  parsePrimitiveData(t, n, r, a) {
    const { iScale: i, vScale: o } = t, s = i.axis, l = o.axis, c = i.getLabels(), u = i === o, d = new Array(a);
    let f, g, h;
    for (f = 0, g = a; f < g; ++f)
      h = f + r, d[f] = {
        [s]: u || i.parse(c[h], h),
        [l]: o.parse(n[h], h)
      };
    return d;
  }
  parseArrayData(t, n, r, a) {
    const { xScale: i, yScale: o } = t, s = new Array(a);
    let l, c, u, d;
    for (l = 0, c = a; l < c; ++l)
      u = l + r, d = n[u], s[l] = {
        x: i.parse(d[0], u),
        y: o.parse(d[1], u)
      };
    return s;
  }
  parseObjectData(t, n, r, a) {
    const { xScale: i, yScale: o } = t, { xAxisKey: s = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(a);
    let u, d, f, g;
    for (u = 0, d = a; u < d; ++u)
      f = u + r, g = n[f], c[u] = {
        x: i.parse(Un(g, s), f),
        y: o.parse(Un(g, l), f)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, r) {
    const a = this.chart, i = this._cachedMeta, o = n[t.axis], s = {
      keys: wR(a, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return tb(s, o, i.index, {
      mode: r
    });
  }
  updateRangeFromParsed(t, n, r, a) {
    const i = r[n.axis];
    let o = i === null ? NaN : i;
    const s = a && r._stacks[n.axis];
    a && s && (a.values = s, o = tb(a, i, this._cachedMeta.index)), t.min = Math.min(t.min, o), t.max = Math.max(t.max, o);
  }
  getMinMax(t, n) {
    const r = this._cachedMeta, a = r._parsed, i = r._sorted && t === r.iScale, o = a.length, s = this._getOtherScale(t), l = JO(n, r, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = KO(s);
    let f, g;
    function h() {
      g = a[f];
      const p = g[s.axis];
      return !Fe(g[t.axis]) || u > p || d < p;
    }
    for (f = 0; f < o && !(!h() && (this.updateRangeFromParsed(c, t, g, l), i)); ++f)
      ;
    if (i) {
      for (f = o - 1; f >= 0; --f)
        if (!h()) {
          this.updateRangeFromParsed(c, t, g, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, r = [];
    let a, i, o;
    for (a = 0, i = n.length; a < i; ++a)
      o = n[a][t.axis], Fe(o) && r.push(o);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = n.iScale, a = n.vScale, i = this.getParsed(t);
    return {
      label: r ? "" + r.getLabelForValue(i[r.axis]) : "",
      value: a ? "" + a.getLabelForValue(i[a.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = VO(se(this.options.clip, qO(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, r = this._cachedMeta, a = r.data || [], i = n.chartArea, o = [], s = this._drawStart || 0, l = this._drawCount || a.length - s, c = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(t, i, s, l), u = s; u < s + l; ++u) {
      const d = a[u];
      d.hidden || (d.active && c ? o.push(d) : d.draw(t, i));
    }
    for (u = 0; u < o.length; ++u)
      o[u].draw(t, i);
  }
  getStyle(t, n) {
    const r = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(t || 0, r);
  }
  getContext(t, n, r) {
    const a = this.getDataset();
    let i;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const o = this._cachedMeta.data[t];
      i = o.$context || (o.$context = QO(this.getContext(), t, o)), i.parsed = this.getParsed(t), i.raw = a.data[t], i.index = i.dataIndex = t;
    } else
      i = this.$context || (this.$context = ZO(this.chart.getContext(), this.index)), i.dataset = a, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = r, i;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", r) {
    const a = n === "active", i = this._cachedDataOpts, o = t + "-" + n, s = i[o], l = this.enableOptionSharing && ni(r);
    if (s)
      return ab(s, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, t), d = a ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], f = c.getOptionScopes(this.getDataset(), u), g = Object.keys(Le.elements[t]), h = () => this.getContext(r, a, n), p = c.resolveNamedOptions(f, g, h, d);
    return p.$shared && (p.$shared = l, i[o] = Object.freeze(ab(p, l))), p;
  }
  _resolveAnimations(t, n, r) {
    const a = this.chart, i = this._cachedDataOpts, o = `animation-${n}`, s = i[o];
    if (s)
      return s;
    let l;
    if (a.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, n), f = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(f, this.getContext(t, r, n));
    }
    const c = new SR(a, l && l.animations);
    return l && l._cacheable && (i[o] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || Ys(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const r = this.resolveDataElementOptions(t, n), a = this._sharedOptions, i = this.getSharedOptions(r), o = this.includeOptions(n, i) || i !== a;
    return this.updateSharedOptions(i, n, r), {
      sharedOptions: i,
      includeOptions: o
    };
  }
  updateElement(t, n, r, a) {
    Ys(a) ? Object.assign(t, r) : this._resolveAnimations(n, a).update(t, r);
  }
  updateSharedOptions(t, n, r) {
    t && !Ys(n) && this._resolveAnimations(void 0, n).update(t, r);
  }
  _setStyle(t, n, r, a) {
    t.active = a;
    const i = this.getStyle(n, a);
    this._resolveAnimations(n, r, a).update(t, {
      options: !a && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !1);
  }
  setHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [s, l, c] of this._syncList)
      this[s](l, c);
    this._syncList = [];
    const a = r.length, i = n.length, o = Math.min(i, a);
    o && this.parse(0, o), i > a ? this._insertElements(a, i - a, t) : i < a && this._removeElements(i, a - i);
  }
  _insertElements(t, n, r = !0) {
    const a = this._cachedMeta, i = a.data, o = t + n;
    let s;
    const l = (c) => {
      for (c.length += n, s = c.length - 1; s >= o; s--)
        c[s] = c[s - n];
    };
    for (l(i), s = t; s < o; ++s)
      i[s] = new this.dataElementType();
    this._parsing && l(a._parsed), this.parse(t, n), r && this.updateElements(i, t, n, "reset");
  }
  updateElements(t, n, r, a) {
  }
  _removeElements(t, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const a = r._parsed.splice(t, n);
      r._stacked && _a(r, a);
    }
    r.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, r, a] = t;
      this[n](r, a);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      t,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
z($t, "defaults", {}), z($t, "datasetElementType", null), z($t, "dataElementType", null);
function eD(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let r = [];
    for (let a = 0, i = n.length; a < i; a++)
      r = r.concat(n[a].controller.getAllParsedValues(e));
    e._cache.$bar = nR(r.sort((a, i) => a - i));
  }
  return e._cache.$bar;
}
function tD(e) {
  const t = e.iScale, n = eD(t, e.type);
  let r = t._length, a, i, o, s;
  const l = () => {
    o === 32767 || o === -32768 || (ni(s) && (r = Math.min(r, Math.abs(o - s) || r)), s = o);
  };
  for (a = 0, i = n.length; a < i; ++a)
    o = t.getPixelForValue(n[a]), l();
  for (s = void 0, a = 0, i = t.ticks.length; a < i; ++a)
    o = t.getPixelForTick(a), l();
  return r;
}
function nD(e, t, n, r) {
  const a = n.barThickness;
  let i, o;
  return fe(a) ? (i = t.min * n.categoryPercentage, o = n.barPercentage) : (i = a * r, o = 1), {
    chunk: i / r,
    ratio: o,
    start: t.pixels[e] - i / 2
  };
}
function rD(e, t, n, r) {
  const a = t.pixels, i = a[e];
  let o = e > 0 ? a[e - 1] : null, s = e < a.length - 1 ? a[e + 1] : null;
  const l = n.categoryPercentage;
  o === null && (o = i - (s === null ? t.end - t.start : s - i)), s === null && (s = i + i - o);
  const c = i - (i - Math.min(o, s)) / 2 * l;
  return {
    chunk: Math.abs(s - o) / 2 * l / r,
    ratio: n.barPercentage,
    start: c
  };
}
function aD(e, t, n, r) {
  const a = n.parse(e[0], r), i = n.parse(e[1], r), o = Math.min(a, i), s = Math.max(a, i);
  let l = o, c = s;
  Math.abs(o) > Math.abs(s) && (l = s, c = o), t[n.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: a,
    end: i,
    min: o,
    max: s
  };
}
function _R(e, t, n, r) {
  return De(e) ? aD(e, t, n, r) : t[n.axis] = n.parse(e, r), t;
}
function ib(e, t, n, r) {
  const a = e.iScale, i = e.vScale, o = a.getLabels(), s = a === i, l = [];
  let c, u, d, f;
  for (c = n, u = n + r; c < u; ++c)
    f = t[c], d = {}, d[a.axis] = s || a.parse(o[c], c), l.push(_R(f, d, i, c));
  return l;
}
function Ks(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function iD(e, t, n) {
  return e !== 0 ? Xt(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function oD(e) {
  let t, n, r, a, i;
  return e.horizontal ? (t = e.base > e.x, n = "left", r = "right") : (t = e.base < e.y, n = "bottom", r = "top"), t ? (a = "end", i = "start") : (a = "start", i = "end"), {
    start: n,
    end: r,
    reverse: t,
    top: a,
    bottom: i
  };
}
function sD(e, t, n, r) {
  let a = t.borderSkipped;
  const i = {};
  if (!a) {
    e.borderSkipped = i;
    return;
  }
  if (a === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: o, end: s, reverse: l, top: c, bottom: u } = oD(e);
  a === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === r ? a = c : (n._bottom || 0) === r ? a = u : (i[ob(u, o, s, l)] = !0, a = c)), i[ob(a, o, s, l)] = !0, e.borderSkipped = i;
}
function ob(e, t, n, r) {
  return r ? (e = lD(e, t, n), e = sb(e, n, t)) : e = sb(e, t, n), e;
}
function lD(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function sb(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function cD(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class wo extends $t {
  parsePrimitiveData(t, n, r, a) {
    return ib(t, n, r, a);
  }
  parseArrayData(t, n, r, a) {
    return ib(t, n, r, a);
  }
  parseObjectData(t, n, r, a) {
    const { iScale: i, vScale: o } = t, { xAxisKey: s = "x", yAxisKey: l = "y" } = this._parsing, c = i.axis === "x" ? s : l, u = o.axis === "x" ? s : l, d = [];
    let f, g, h, p;
    for (f = r, g = r + a; f < g; ++f)
      p = n[f], h = {}, h[i.axis] = i.parse(Un(p, c), f), d.push(_R(Un(p, u), h, o, f));
    return d;
  }
  updateRangeFromParsed(t, n, r, a) {
    super.updateRangeFromParsed(t, n, r, a);
    const i = r._custom;
    i && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, i.min), t.max = Math.max(t.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: r, vScale: a } = n, i = this.getParsed(t), o = i._custom, s = Ks(o) ? "[" + o.start + ", " + o.end + "]" : "" + a.getLabelForValue(i[a.axis]);
    return {
      label: "" + r.getLabelForValue(i[r.axis]),
      value: s
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, r, a) {
    const i = a === "reset", { index: o, _cachedMeta: { vScale: s } } = this, l = s.getBasePixel(), c = s.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(n, a);
    for (let g = n; g < n + r; g++) {
      const h = this.getParsed(g), p = i || fe(h[s.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(g), m = this._calculateBarIndexPixels(g, u), v = (h._stacks || {})[s.axis], y = {
        horizontal: c,
        base: p.base,
        enableBorderRadius: !v || Ks(h._custom) || o === v._top || o === v._bottom,
        x: c ? p.head : m.center,
        y: c ? m.center : p.head,
        height: c ? m.size : Math.abs(p.size),
        width: c ? Math.abs(p.size) : m.size
      };
      f && (y.options = d || this.resolveDataElementOptions(g, t[g].active ? "active" : a));
      const E = y.options || t[g].options;
      sD(y, E, v, o), cD(y, E, u.ratio), this.updateElement(t[g], g, y, a);
    }
  }
  _getStacks(t, n) {
    const { iScale: r } = this._cachedMeta, a = r.getMatchingVisibleMetas(this._type).filter((u) => u.controller.options.grouped), i = r.options.stacked, o = [], s = this._cachedMeta.controller.getParsed(n), l = s && s[r.axis], c = (u) => {
      const d = u._parsed.find((g) => g[r.axis] === l), f = d && d[u.vScale.axis];
      if (fe(f) || isNaN(f))
        return !0;
    };
    for (const u of a)
      if (!(n !== void 0 && c(u)) && ((i === !1 || o.indexOf(u.stack) === -1 || i === void 0 && u.stack === void 0) && o.push(u.stack), u.index === t))
        break;
    return o.length || o.push(void 0), o;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, n, r) {
    const a = this._getStacks(t, r), i = n !== void 0 ? a.indexOf(n) : -1;
    return i === -1 ? a.length - 1 : i;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, r = n.iScale, a = [];
    let i, o;
    for (i = 0, o = n.data.length; i < o; ++i)
      a.push(r.getPixelForValue(this.getParsed(i)[r.axis], i));
    const s = t.barThickness;
    return {
      min: s || tD(n),
      pixels: a,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: t.grouped,
      ratio: s ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: r, index: a }, options: { base: i, minBarLength: o } } = this, s = i || 0, l = this.getParsed(t), c = l._custom, u = Ks(c);
    let d = l[n.axis], f = 0, g = r ? this.applyStack(n, l, r) : d, h, p;
    g !== d && (f = g - d, g = d), u && (d = c.barStart, g = c.barEnd - c.barStart, d !== 0 && Xt(d) !== Xt(c.barEnd) && (f = 0), f += d);
    const m = !fe(i) && !u ? i : f;
    let v = n.getPixelForValue(m);
    if (this.chart.getDataVisibility(t) ? h = n.getPixelForValue(f + g) : h = v, p = h - v, Math.abs(p) < o) {
      p = iD(p, n, s) * o, d === s && (v -= p / 2);
      const y = n.getPixelForDecimal(0), E = n.getPixelForDecimal(1), S = Math.min(y, E), w = Math.max(y, E);
      v = Math.max(Math.min(v, w), S), h = v + p, r && !u && (l._stacks[n.axis]._visualValues[a] = n.getValueForPixel(h) - n.getValueForPixel(v));
    }
    if (v === n.getPixelForValue(s)) {
      const y = Xt(p) * n.getLineWidthForValue(s) / 2;
      v += y, p -= y;
    }
    return {
      size: p,
      base: v,
      head: h,
      center: h + p / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const r = n.scale, a = this.options, i = a.skipNull, o = se(a.maxBarThickness, 1 / 0);
    let s, l;
    if (n.grouped) {
      const c = i ? this._getStackCount(t) : n.stackCount, u = a.barThickness === "flex" ? rD(t, n, a, c) : nD(t, n, a, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, i ? t : void 0);
      s = u.start + u.chunk * d + u.chunk / 2, l = Math.min(o, u.chunk * u.ratio);
    } else
      s = r.getPixelForValue(this.getParsed(t)[r.axis], t), l = Math.min(o, n.min * n.ratio);
    return {
      base: s - l / 2,
      head: s + l / 2,
      center: s,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, r = t.data, a = r.length;
    let i = 0;
    for (; i < a; ++i)
      this.getParsed(i)[n.axis] !== null && !r[i].hidden && r[i].draw(this._ctx);
  }
}
z(wo, "id", "bar"), z(wo, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), z(wo, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class _o extends $t {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, n, r, a) {
    const i = super.parsePrimitiveData(t, n, r, a);
    for (let o = 0; o < i.length; o++)
      i[o]._custom = this.resolveDataElementOptions(o + r).radius;
    return i;
  }
  parseArrayData(t, n, r, a) {
    const i = super.parseArrayData(t, n, r, a);
    for (let o = 0; o < i.length; o++) {
      const s = n[r + o];
      i[o]._custom = se(s[2], this.resolveDataElementOptions(o + r).radius);
    }
    return i;
  }
  parseObjectData(t, n, r, a) {
    const i = super.parseObjectData(t, n, r, a);
    for (let o = 0; o < i.length; o++) {
      const s = n[r + o];
      i[o]._custom = se(s && s.r && +s.r, this.resolveDataElementOptions(o + r).radius);
    }
    return i;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let n = 0;
    for (let r = t.length - 1; r >= 0; --r)
      n = Math.max(n, t[r].size(this.resolveDataElementOptions(r)) / 2);
    return n > 0 && n;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart.data.labels || [], { xScale: a, yScale: i } = n, o = this.getParsed(t), s = a.getLabelForValue(o.x), l = i.getLabelForValue(o.y), c = o._custom;
    return {
      label: r[t] || "",
      value: "(" + s + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta.data;
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, n, r, a) {
    const i = a === "reset", { iScale: o, vScale: s } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(n, a), u = o.axis, d = s.axis;
    for (let f = n; f < n + r; f++) {
      const g = t[f], h = !i && this.getParsed(f), p = {}, m = p[u] = i ? o.getPixelForDecimal(0.5) : o.getPixelForValue(h[u]), v = p[d] = i ? s.getBasePixel() : s.getPixelForValue(h[d]);
      p.skip = isNaN(m) || isNaN(v), c && (p.options = l || this.resolveDataElementOptions(f, g.active ? "active" : a), i && (p.options.radius = 0)), this.updateElement(g, f, p, a);
    }
  }
  resolveDataElementOptions(t, n) {
    const r = this.getParsed(t);
    let a = super.resolveDataElementOptions(t, n);
    a.$shared && (a = Object.assign({}, a, {
      $shared: !1
    }));
    const i = a.radius;
    return n !== "active" && (a.radius = 0), a.radius += se(r && r._custom, i), a;
  }
}
z(_o, "id", "bubble"), z(_o, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), z(_o, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function uD(e, t, n) {
  let r = 1, a = 1, i = 0, o = 0;
  if (t < ke) {
    const s = e, l = s + t, c = Math.cos(s), u = Math.sin(s), d = Math.cos(l), f = Math.sin(l), g = (E, S, w) => ri(E, s, l, !0) ? 1 : Math.max(S, S * n, w, w * n), h = (E, S, w) => ri(E, s, l, !0) ? -1 : Math.min(S, S * n, w, w * n), p = g(0, c, d), m = g(Be, u, f), v = h(Oe, c, d), y = h(Oe + Be, u, f);
    r = (p - v) / 2, a = (m - y) / 2, i = -(p + v) / 2, o = -(m + y) / 2;
  }
  return {
    ratioX: r,
    ratioY: a,
    offsetX: i,
    offsetY: o
  };
}
class pr extends $t {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const r = this.getDataset().data, a = this._cachedMeta;
    if (this._parsing === !1)
      a._parsed = r;
    else {
      let i = (l) => +r[l];
      if (ue(r[t])) {
        const { key: l = "value" } = this._parsing;
        i = (c) => +Un(r[c], l);
      }
      let o, s;
      for (o = t, s = t + n; o < s; ++o)
        a._parsed[o] = i(o);
    }
  }
  _getRotation() {
    return Pt(this.options.rotation - 90);
  }
  _getCircumference() {
    return Pt(this.options.circumference);
  }
  _getRotationExtents() {
    let t = ke, n = -ke;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r) && this.chart.getDatasetMeta(r).type === this._type) {
        const a = this.chart.getDatasetMeta(r).controller, i = a._getRotation(), o = a._getCircumference();
        t = Math.min(t, i), n = Math.max(n, i + o);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: r } = n, a = this._cachedMeta, i = a.data, o = this.getMaxBorderWidth() + this.getMaxOffset(i) + this.options.spacing, s = Math.max((Math.min(r.width, r.height) - o) / 2, 0), l = Math.min(T0(this.options.cutout, s), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: f, ratioY: g, offsetX: h, offsetY: p } = uD(d, u, l), m = (r.width - o) / f, v = (r.height - o) / g, y = Math.max(Math.min(m, v) / 2, 0), E = ZT(this.options.radius, y), S = Math.max(E * l, 0), w = (E - S) / this._getVisibleDatasetWeightTotal();
    this.offsetX = h * E, this.offsetY = p * E, a.total = this.calculateTotal(), this.outerRadius = E - w * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - w * c, 0), this.updateElements(i, 0, i.length, t);
  }
  _circumference(t, n) {
    const r = this.options, a = this._cachedMeta, i = this._getCircumference();
    return n && r.animation.animateRotate || !this.chart.getDataVisibility(t) || a._parsed[t] === null || a.data[t].hidden ? 0 : this.calculateCircumference(a._parsed[t] * i / ke);
  }
  updateElements(t, n, r, a) {
    const i = a === "reset", o = this.chart, s = o.chartArea, c = o.options.animation, u = (s.left + s.right) / 2, d = (s.top + s.bottom) / 2, f = i && c.animateScale, g = f ? 0 : this.innerRadius, h = f ? 0 : this.outerRadius, { sharedOptions: p, includeOptions: m } = this._getSharedOptions(n, a);
    let v = this._getRotation(), y;
    for (y = 0; y < n; ++y)
      v += this._circumference(y, i);
    for (y = n; y < n + r; ++y) {
      const E = this._circumference(y, i), S = t[y], w = {
        x: u + this.offsetX,
        y: d + this.offsetY,
        startAngle: v,
        endAngle: v + E,
        circumference: E,
        outerRadius: h,
        innerRadius: g
      };
      m && (w.options = p || this.resolveDataElementOptions(y, S.active ? "active" : a)), v += E, this.updateElement(S, y, w, a);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let r = 0, a;
    for (a = 0; a < n.length; a++) {
      const i = t._parsed[a];
      i !== null && !isNaN(i) && this.chart.getDataVisibility(a) && !n[a].hidden && (r += Math.abs(i));
    }
    return r;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? ke * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, a = r.data.labels || [], i = vi(n._parsed[t], r.options.locale);
    return {
      label: a[t] || "",
      value: i
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const r = this.chart;
    let a, i, o, s, l;
    if (!t) {
      for (a = 0, i = r.data.datasets.length; a < i; ++a)
        if (r.isDatasetVisible(a)) {
          o = r.getDatasetMeta(a), t = o.data, s = o.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (a = 0, i = t.length; a < i; ++a)
      l = s.resolveDataElementOptions(a), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let r = 0, a = t.length; r < a; ++r) {
      const i = this.resolveDataElementOptions(r);
      n = Math.max(n, i.offset || 0, i.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let r = 0; r < t; ++r)
      this.chart.isDatasetVisible(r) && (n += this._getRingWeight(r));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(se(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
z(pr, "id", "doughnut"), z(pr, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), z(pr, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), z(pr, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: r, color: a } } = t.legend.options;
            return n.labels.map((i, o) => {
              const l = t.getDatasetMeta(0).controller.getStyle(o);
              return {
                text: i,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: a,
                lineWidth: l.borderWidth,
                pointStyle: r,
                hidden: !t.getDataVisibility(o),
                index: o
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, r) {
        r.chart.toggleDataVisibility(n.index), r.chart.update();
      }
    }
  }
});
class To extends $t {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: r, data: a = [], _dataset: i } = n, o = this.chart._animationsDisabled;
    let { start: s, count: l } = iR(n, a, o);
    this._drawStart = s, this._drawCount = l, oR(n) && (s = 0, l = a.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!i._decimated, r.points = a;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !o,
      options: c
    }, t), this.updateElements(a, s, l, t);
  }
  updateElements(t, n, r, a) {
    const i = a === "reset", { iScale: o, vScale: s, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(n, a), f = o.axis, g = s.axis, { spanGaps: h, segment: p } = this.options, m = na(h) ? h : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || i || a === "none", y = n + r, E = t.length;
    let S = n > 0 && this.getParsed(n - 1);
    for (let w = 0; w < E; ++w) {
      const R = t[w], T = v ? R : {};
      if (w < n || w >= y) {
        T.skip = !0;
        continue;
      }
      const A = this.getParsed(w), C = fe(A[g]), N = T[f] = o.getPixelForValue(A[f], w), L = T[g] = i || C ? s.getBasePixel() : s.getPixelForValue(l ? this.applyStack(s, A, l) : A[g], w);
      T.skip = isNaN(N) || isNaN(L) || C, T.stop = w > 0 && Math.abs(A[f] - S[f]) > m, p && (T.parsed = A, T.raw = c.data[w]), d && (T.options = u || this.resolveDataElementOptions(w, R.active ? "active" : a)), v || this.updateElement(R, w, T, a), S = A;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, r = n.options && n.options.borderWidth || 0, a = t.data || [];
    if (!a.length)
      return r;
    const i = a[0].size(this.resolveDataElementOptions(0)), o = a[a.length - 1].size(this.resolveDataElementOptions(a.length - 1));
    return Math.max(r, i, o) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
z(To, "id", "line"), z(To, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), z(To, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class Za extends $t {
  constructor(t, n) {
    super(t, n), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, a = r.data.labels || [], i = vi(n._parsed[t].r, r.options.locale);
    return {
      label: a[t] || "",
      value: i
    };
  }
  parseObjectData(t, n, r, a) {
    return gR.bind(this)(t, n, r, a);
  }
  update(t) {
    const n = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(n, 0, n.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, n = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((r, a) => {
      const i = this.getParsed(a).r;
      !isNaN(i) && this.chart.getDataVisibility(a) && (i < n.min && (n.min = i), i > n.max && (n.max = i));
    }), n;
  }
  _updateRadius() {
    const t = this.chart, n = t.chartArea, r = t.options, a = Math.min(n.right - n.left, n.bottom - n.top), i = Math.max(a / 2, 0), o = Math.max(r.cutoutPercentage ? i / 100 * r.cutoutPercentage : 1, 0), s = (i - o) / t.getVisibleDatasetCount();
    this.outerRadius = i - s * this.index, this.innerRadius = this.outerRadius - s;
  }
  updateElements(t, n, r, a) {
    const i = a === "reset", o = this.chart, l = o.options.animation, c = this._cachedMeta.rScale, u = c.xCenter, d = c.yCenter, f = c.getIndexAngle(0) - 0.5 * Oe;
    let g = f, h;
    const p = 360 / this.countVisibleElements();
    for (h = 0; h < n; ++h)
      g += this._computeAngle(h, a, p);
    for (h = n; h < n + r; h++) {
      const m = t[h];
      let v = g, y = g + this._computeAngle(h, a, p), E = o.getDataVisibility(h) ? c.getDistanceFromCenterForValue(this.getParsed(h).r) : 0;
      g = y, i && (l.animateScale && (E = 0), l.animateRotate && (v = y = f));
      const S = {
        x: u,
        y: d,
        innerRadius: 0,
        outerRadius: E,
        startAngle: v,
        endAngle: y,
        options: this.resolveDataElementOptions(h, m.active ? "active" : a)
      };
      this.updateElement(m, h, S, a);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let n = 0;
    return t.data.forEach((r, a) => {
      !isNaN(this.getParsed(a).r) && this.chart.getDataVisibility(a) && n++;
    }), n;
  }
  _computeAngle(t, n, r) {
    return this.chart.getDataVisibility(t) ? Pt(this.resolveDataElementOptions(t, n).angle || r) : 0;
  }
}
z(Za, "id", "polarArea"), z(Za, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), z(Za, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: r, color: a } } = t.legend.options;
            return n.labels.map((i, o) => {
              const l = t.getDatasetMeta(0).controller.getStyle(o);
              return {
                text: i,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: a,
                lineWidth: l.borderWidth,
                pointStyle: r,
                hidden: !t.getDataVisibility(o),
                index: o
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, r) {
        r.chart.toggleDataVisibility(n.index), r.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class Wp extends pr {
}
z(Wp, "id", "pie"), z(Wp, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class Ro extends $t {
  getLabelAndValue(t) {
    const n = this._cachedMeta.vScale, r = this.getParsed(t);
    return {
      label: n.getLabels()[t],
      value: "" + n.getLabelForValue(r[n.axis])
    };
  }
  parseObjectData(t, n, r, a) {
    return gR.bind(this)(t, n, r, a);
  }
  update(t) {
    const n = this._cachedMeta, r = n.dataset, a = n.data || [], i = n.iScale.getLabels();
    if (r.points = a, t !== "resize") {
      const o = this.resolveDatasetElementOptions(t);
      this.options.showLine || (o.borderWidth = 0);
      const s = {
        _loop: !0,
        _fullLoop: i.length === a.length,
        options: o
      };
      this.updateElement(r, void 0, s, t);
    }
    this.updateElements(a, 0, a.length, t);
  }
  updateElements(t, n, r, a) {
    const i = this._cachedMeta.rScale, o = a === "reset";
    for (let s = n; s < n + r; s++) {
      const l = t[s], c = this.resolveDataElementOptions(s, l.active ? "active" : a), u = i.getPointPositionForValue(s, this.getParsed(s).r), d = o ? i.xCenter : u.x, f = o ? i.yCenter : u.y, g = {
        x: d,
        y: f,
        angle: u.angle,
        skip: isNaN(d) || isNaN(f),
        options: c
      };
      this.updateElement(l, s, g, a);
    }
  }
}
z(Ro, "id", "radar"), z(Ro, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), z(Ro, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class Ao extends $t {
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart.data.labels || [], { xScale: a, yScale: i } = n, o = this.getParsed(t), s = a.getLabelForValue(o.x), l = i.getLabelForValue(o.y);
    return {
      label: r[t] || "",
      value: "(" + s + ", " + l + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta, { data: r = [] } = n, a = this.chart._animationsDisabled;
    let { start: i, count: o } = iR(n, r, a);
    if (this._drawStart = i, this._drawCount = o, oR(n) && (i = 0, o = r.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: s, _dataset: l } = n;
      s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!l._decimated, s.points = r;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(s, void 0, {
        animated: !a,
        options: c
      }, t);
    } else this.datasetElementType && (delete n.dataset, this.datasetElementType = !1);
    this.updateElements(r, i, o, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, n, r, a) {
    const i = a === "reset", { iScale: o, vScale: s, _stacked: l, _dataset: c } = this._cachedMeta, u = this.resolveDataElementOptions(n, a), d = this.getSharedOptions(u), f = this.includeOptions(a, d), g = o.axis, h = s.axis, { spanGaps: p, segment: m } = this.options, v = na(p) ? p : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || i || a === "none";
    let E = n > 0 && this.getParsed(n - 1);
    for (let S = n; S < n + r; ++S) {
      const w = t[S], R = this.getParsed(S), T = y ? w : {}, A = fe(R[h]), C = T[g] = o.getPixelForValue(R[g], S), N = T[h] = i || A ? s.getBasePixel() : s.getPixelForValue(l ? this.applyStack(s, R, l) : R[h], S);
      T.skip = isNaN(C) || isNaN(N) || A, T.stop = S > 0 && Math.abs(R[g] - E[g]) > v, m && (T.parsed = R, T.raw = c.data[S]), f && (T.options = d || this.resolveDataElementOptions(S, w.active ? "active" : a)), y || this.updateElement(w, S, T, a), E = R;
    }
    this.updateSharedOptions(d, a, u);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.data || [];
    if (!this.options.showLine) {
      let s = 0;
      for (let l = n.length - 1; l >= 0; --l)
        s = Math.max(s, n[l].size(this.resolveDataElementOptions(l)) / 2);
      return s > 0 && s;
    }
    const r = t.dataset, a = r.options && r.options.borderWidth || 0;
    if (!n.length)
      return a;
    const i = n[0].size(this.resolveDataElementOptions(0)), o = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(a, i, o) / 2;
  }
}
z(Ao, "id", "scatter"), z(Ao, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), z(Ao, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var dD = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: wo,
  BubbleController: _o,
  DoughnutController: pr,
  LineController: To,
  PieController: Wp,
  PolarAreaController: Za,
  RadarController: Ro,
  ScatterController: Ao
});
function nr() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class ah {
  constructor(t) {
    z(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(ah.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return nr();
  }
  parse() {
    return nr();
  }
  format() {
    return nr();
  }
  add() {
    return nr();
  }
  diff() {
    return nr();
  }
  startOf() {
    return nr();
  }
  endOf() {
    return nr();
  }
}
var fD = {
  _date: ah
};
function pD(e, t, n, r) {
  const { controller: a, data: i, _sorted: o } = e, s = a._cachedMeta.iScale;
  if (s && t === s.axis && t !== "r" && o && i.length) {
    const l = s._reversePixels ? P0 : gn;
    if (r) {
      if (a._sharedOptions) {
        const c = i[0], u = typeof c.getRange == "function" && c.getRange(t);
        if (u) {
          const d = l(i, t, n - u), f = l(i, t, n + u);
          return {
            lo: d.lo,
            hi: f.hi
          };
        }
      }
    } else return l(i, t, n);
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function yi(e, t, n, r, a) {
  const i = e.getSortedVisibleDatasetMetas(), o = n[t];
  for (let s = 0, l = i.length; s < l; ++s) {
    const { index: c, data: u } = i[s], { lo: d, hi: f } = pD(i[s], t, o, a);
    for (let g = d; g <= f; ++g) {
      const h = u[g];
      h.skip || r(h, c, g);
    }
  }
}
function gD(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(r, a) {
    const i = t ? Math.abs(r.x - a.x) : 0, o = n ? Math.abs(r.y - a.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(o, 2));
  };
}
function Xs(e, t, n, r, a) {
  const i = [];
  return !a && !e.isPointInArea(t) || yi(e, n, t, function(s, l, c) {
    !a && !hn(s, e.chartArea, 0) || s.inRange(t.x, t.y, r) && i.push({
      element: s,
      datasetIndex: l,
      index: c
    });
  }, !0), i;
}
function hD(e, t, n, r) {
  let a = [];
  function i(o, s, l) {
    const { startAngle: c, endAngle: u } = o.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = eR(o, {
      x: t.x,
      y: t.y
    });
    ri(d, c, u) && a.push({
      element: o,
      datasetIndex: s,
      index: l
    });
  }
  return yi(e, n, t, i), a;
}
function mD(e, t, n, r, a, i) {
  let o = [];
  const s = gD(n);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, f) {
    const g = u.inRange(t.x, t.y, a);
    if (r && !g)
      return;
    const h = u.getCenterPoint(a);
    if (!(!!i || e.isPointInArea(h)) && !g)
      return;
    const m = s(t, h);
    m < l ? (o = [
      {
        element: u,
        datasetIndex: d,
        index: f
      }
    ], l = m) : m === l && o.push({
      element: u,
      datasetIndex: d,
      index: f
    });
  }
  return yi(e, n, t, c), o;
}
function Zs(e, t, n, r, a, i) {
  return !i && !e.isPointInArea(t) ? [] : n === "r" && !r ? hD(e, t, n, a) : mD(e, t, n, r, a, i);
}
function lb(e, t, n, r, a) {
  const i = [], o = n === "x" ? "inXRange" : "inYRange";
  let s = !1;
  return yi(e, n, t, (l, c, u) => {
    l[o] && l[o](t[n], a) && (i.push({
      element: l,
      datasetIndex: c,
      index: u
    }), s = s || l.inRange(t.x, t.y, a));
  }), r && !s ? [] : i;
}
var bD = {
  evaluateInteractionItems: yi,
  modes: {
    index(e, t, n, r) {
      const a = lr(t, e), i = n.axis || "x", o = n.includeInvisible || !1, s = n.intersect ? Xs(e, a, i, r, o) : Zs(e, a, i, !1, r, o), l = [];
      return s.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = s[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(e, t, n, r) {
      const a = lr(t, e), i = n.axis || "xy", o = n.includeInvisible || !1;
      let s = n.intersect ? Xs(e, a, i, r, o) : Zs(e, a, i, !1, r, o);
      if (s.length > 0) {
        const l = s[0].datasetIndex, c = e.getDatasetMeta(l).data;
        s = [];
        for (let u = 0; u < c.length; ++u)
          s.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return s;
    },
    point(e, t, n, r) {
      const a = lr(t, e), i = n.axis || "xy", o = n.includeInvisible || !1;
      return Xs(e, a, i, r, o);
    },
    nearest(e, t, n, r) {
      const a = lr(t, e), i = n.axis || "xy", o = n.includeInvisible || !1;
      return Zs(e, a, i, n.intersect, r, o);
    },
    x(e, t, n, r) {
      const a = lr(t, e);
      return lb(e, a, "x", n.intersect, r);
    },
    y(e, t, n, r) {
      const a = lr(t, e);
      return lb(e, a, "y", n.intersect, r);
    }
  }
};
const TR = [
  "left",
  "top",
  "right",
  "bottom"
];
function Ta(e, t) {
  return e.filter((n) => n.pos === t);
}
function cb(e, t) {
  return e.filter((n) => TR.indexOf(n.pos) === -1 && n.box.axis === t);
}
function Ra(e, t) {
  return e.sort((n, r) => {
    const a = t ? r : n, i = t ? n : r;
    return a.weight === i.weight ? a.index - i.index : a.weight - i.weight;
  });
}
function vD(e) {
  const t = [];
  let n, r, a, i, o, s;
  for (n = 0, r = (e || []).length; n < r; ++n)
    a = e[n], { position: i, options: { stack: o, stackWeight: s = 1 } } = a, t.push({
      index: n,
      box: a,
      pos: i,
      horizontal: a.isHorizontal(),
      weight: a.weight,
      stack: o && i + o,
      stackWeight: s
    });
  return t;
}
function yD(e) {
  const t = {};
  for (const n of e) {
    const { stack: r, pos: a, stackWeight: i } = n;
    if (!r || !TR.includes(a))
      continue;
    const o = t[r] || (t[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    o.count++, o.weight += i;
  }
  return t;
}
function ED(e, t) {
  const n = yD(e), { vBoxMaxWidth: r, hBoxMaxHeight: a } = t;
  let i, o, s;
  for (i = 0, o = e.length; i < o; ++i) {
    s = e[i];
    const { fullSize: l } = s.box, c = n[s.stack], u = c && s.stackWeight / c.weight;
    s.horizontal ? (s.width = u ? u * r : l && t.availableWidth, s.height = a) : (s.width = r, s.height = u ? u * a : l && t.availableHeight);
  }
  return n;
}
function SD(e) {
  const t = vD(e), n = Ra(t.filter((c) => c.box.fullSize), !0), r = Ra(Ta(t, "left"), !0), a = Ra(Ta(t, "right")), i = Ra(Ta(t, "top"), !0), o = Ra(Ta(t, "bottom")), s = cb(t, "x"), l = cb(t, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(i),
    rightAndBottom: a.concat(l).concat(o).concat(s),
    chartArea: Ta(t, "chartArea"),
    vertical: r.concat(a).concat(l),
    horizontal: i.concat(o).concat(s)
  };
}
function ub(e, t, n, r) {
  return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
}
function RR(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function wD(e, t, n, r) {
  const { pos: a, box: i } = n, o = e.maxPadding;
  if (!ue(a)) {
    n.size && (e[a] -= n.size);
    const d = r[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? i.height : i.width), n.size = d.size / d.count, e[a] += n.size;
  }
  i.getPadding && RR(o, i.getPadding());
  const s = Math.max(0, t.outerWidth - ub(o, e, "left", "right")), l = Math.max(0, t.outerHeight - ub(o, e, "top", "bottom")), c = s !== e.w, u = l !== e.h;
  return e.w = s, e.h = l, n.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function _D(e) {
  const t = e.maxPadding;
  function n(r) {
    const a = Math.max(t[r] - e[r], 0);
    return e[r] += a, a;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function TD(e, t) {
  const n = t.maxPadding;
  function r(a) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return a.forEach((o) => {
      i[o] = Math.max(t[o], n[o]);
    }), i;
  }
  return r(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function $a(e, t, n, r) {
  const a = [];
  let i, o, s, l, c, u;
  for (i = 0, o = e.length, c = 0; i < o; ++i) {
    s = e[i], l = s.box, l.update(s.width || t.w, s.height || t.h, TD(s.horizontal, t));
    const { same: d, other: f } = wD(t, n, s, r);
    c |= d && a.length, u = u || f, l.fullSize || a.push(s);
  }
  return c && $a(a, t, n, r) || u;
}
function Vi(e, t, n, r, a) {
  e.top = n, e.left = t, e.right = t + r, e.bottom = n + a, e.width = r, e.height = a;
}
function db(e, t, n, r) {
  const a = n.padding;
  let { x: i, y: o } = t;
  for (const s of e) {
    const l = s.box, c = r[s.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = s.stackWeight / c.weight || 1;
    if (s.horizontal) {
      const d = t.w * u, f = c.size || l.height;
      ni(c.start) && (o = c.start), l.fullSize ? Vi(l, a.left, o, n.outerWidth - a.right - a.left, f) : Vi(l, t.left + c.placed, o, d, f), c.start = o, c.placed += d, o = l.bottom;
    } else {
      const d = t.h * u, f = c.size || l.width;
      ni(c.start) && (i = c.start), l.fullSize ? Vi(l, i, a.top, f, n.outerHeight - a.bottom - a.top) : Vi(l, i, t.top + c.placed, f, d), c.start = i, c.placed += d, i = l.right;
    }
  }
  t.x = i, t.y = o;
}
var rt = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, r) {
    if (!e)
      return;
    const a = it(e.options.layout.padding), i = Math.max(t - a.width, 0), o = Math.max(n - a.height, 0), s = SD(e.boxes), l = s.vertical, c = s.horizontal;
    ve(e.boxes, (p) => {
      typeof p.beforeLayout == "function" && p.beforeLayout();
    });
    const u = l.reduce((p, m) => m.box.options && m.box.options.display === !1 ? p : p + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: a,
      availableWidth: i,
      availableHeight: o,
      vBoxMaxWidth: i / 2 / u,
      hBoxMaxHeight: o / 2
    }), f = Object.assign({}, a);
    RR(f, it(r));
    const g = Object.assign({
      maxPadding: f,
      w: i,
      h: o,
      x: a.left,
      y: a.top
    }, a), h = ED(l.concat(c), d);
    $a(s.fullSize, g, d, h), $a(l, g, d, h), $a(c, g, d, h) && $a(l, g, d, h), _D(g), db(s.leftAndTop, g, d, h), g.x += g.w, g.y += g.h, db(s.rightAndBottom, g, d, h), e.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, ve(s.chartArea, (p) => {
      const m = p.box;
      Object.assign(m, e.chartArea), m.update(g.w, g.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class AR {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, r) {
  }
  removeEventListener(t, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, r, a) {
    return n = Math.max(0, n || t.width), r = r || t.height, {
      width: n,
      height: Math.max(0, a ? Math.floor(n / a) : r)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class RD extends AR {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const xo = "$chartjs", AD = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, fb = (e) => e === null || e === "";
function xD(e, t) {
  const n = e.style, r = e.getAttribute("height"), a = e.getAttribute("width");
  if (e[xo] = {
    initial: {
      height: r,
      width: a,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", fb(a)) {
    const i = Km(e, "width");
    i !== void 0 && (e.width = i);
  }
  if (fb(r))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const i = Km(e, "height");
      i !== void 0 && (e.height = i);
    }
  return e;
}
const xR = NO ? {
  passive: !0
} : !1;
function CD(e, t, n) {
  e && e.addEventListener(t, n, xR);
}
function ND(e, t, n) {
  e && e.canvas && e.canvas.removeEventListener(t, n, xR);
}
function ID(e, t) {
  const n = AD[e.type] || e.type, { x: r, y: a } = lr(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: r !== void 0 ? r : null,
    y: a !== void 0 ? a : null
  };
}
function Go(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function kD(e, t, n) {
  const r = e.canvas, a = new MutationObserver((i) => {
    let o = !1;
    for (const s of i)
      o = o || Go(s.addedNodes, r), o = o && !Go(s.removedNodes, r);
    o && n();
  });
  return a.observe(document, {
    childList: !0,
    subtree: !0
  }), a;
}
function OD(e, t, n) {
  const r = e.canvas, a = new MutationObserver((i) => {
    let o = !1;
    for (const s of i)
      o = o || Go(s.removedNodes, r), o = o && !Go(s.addedNodes, r);
    o && n();
  });
  return a.observe(document, {
    childList: !0,
    subtree: !0
  }), a;
}
const ii = /* @__PURE__ */ new Map();
let pb = 0;
function CR() {
  const e = window.devicePixelRatio;
  e !== pb && (pb = e, ii.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function DD(e, t) {
  ii.size || window.addEventListener("resize", CR), ii.set(e, t);
}
function LD(e) {
  ii.delete(e), ii.size || window.removeEventListener("resize", CR);
}
function MD(e, t, n) {
  const r = e.canvas, a = r && rh(r);
  if (!a)
    return;
  const i = aR((s, l) => {
    const c = a.clientWidth;
    n(s, l), c < a.clientWidth && n();
  }, window), o = new ResizeObserver((s) => {
    const l = s[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || i(c, u);
  });
  return o.observe(a), DD(e, i), o;
}
function Qs(e, t, n) {
  n && n.disconnect(), t === "resize" && LD(e);
}
function PD(e, t, n) {
  const r = e.canvas, a = aR((i) => {
    e.ctx !== null && n(ID(i, e));
  }, e);
  return CD(r, t, a), a;
}
class FD extends AR {
  acquireContext(t, n) {
    const r = t && t.getContext && t.getContext("2d");
    return r && r.canvas === t ? (xD(t, n), r) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[xo])
      return !1;
    const r = n[xo].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const o = r[i];
      fe(o) ? n.removeAttribute(i) : n.setAttribute(i, o);
    });
    const a = r.style || {};
    return Object.keys(a).forEach((i) => {
      n.style[i] = a[i];
    }), n.width = n.width, delete n[xo], !0;
  }
  addEventListener(t, n, r) {
    this.removeEventListener(t, n);
    const a = t.$proxies || (t.$proxies = {}), o = {
      attach: kD,
      detach: OD,
      resize: MD
    }[n] || PD;
    a[n] = o(t, n, r);
  }
  removeEventListener(t, n) {
    const r = t.$proxies || (t.$proxies = {}), a = r[n];
    if (!a)
      return;
    ({
      attach: Qs,
      detach: Qs,
      resize: Qs
    }[n] || ND)(t, n, a), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, r, a) {
    return CO(t, n, r, a);
  }
  isAttached(t) {
    const n = t && rh(t);
    return !!(n && n.isConnected);
  }
}
function $D(e) {
  return !nh() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? RD : FD;
}
var So;
let wn = (So = class {
  constructor() {
    z(this, "x");
    z(this, "y");
    z(this, "active", !1);
    z(this, "options");
    z(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: r } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: r
    };
  }
  hasValue() {
    return na(this.x) && na(this.y);
  }
  getProps(t, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const a = {};
    return t.forEach((i) => {
      a[i] = r[i] && r[i].active() ? r[i]._to : this[i];
    }), a;
  }
}, z(So, "defaults", {}), z(So, "defaultRoutes"), So);
function BD(e, t) {
  const n = e.options.ticks, r = UD(e), a = Math.min(n.maxTicksLimit || r, r), i = n.major.enabled ? HD(t) : [], o = i.length, s = i[0], l = i[o - 1], c = [];
  if (o > a)
    return zD(t, c, i, o / a), c;
  const u = GD(i, t, a);
  if (o > 0) {
    let d, f;
    const g = o > 1 ? Math.round((l - s) / (o - 1)) : null;
    for (ji(t, c, u, fe(g) ? 0 : s - g, s), d = 0, f = o - 1; d < f; d++)
      ji(t, c, u, i[d], i[d + 1]);
    return ji(t, c, u, l, fe(g) ? t.length : l + g), c;
  }
  return ji(t, c, u), c;
}
function UD(e) {
  const t = e.options.offset, n = e._tickSize(), r = e._length / n + (t ? 0 : 1), a = e._maxLength / n;
  return Math.floor(Math.min(r, a));
}
function GD(e, t, n) {
  const r = WD(e), a = t.length / n;
  if (!r)
    return Math.max(a, 1);
  const i = O0(r);
  for (let o = 0, s = i.length - 1; o < s; o++) {
    const l = i[o];
    if (l > a)
      return l;
  }
  return Math.max(a, 1);
}
function HD(e) {
  const t = [];
  let n, r;
  for (n = 0, r = e.length; n < r; n++)
    e[n].major && t.push(n);
  return t;
}
function zD(e, t, n, r) {
  let a = 0, i = n[0], o;
  for (r = Math.ceil(r), o = 0; o < e.length; o++)
    o === i && (t.push(e[o]), a++, i = n[a * r]);
}
function ji(e, t, n, r, a) {
  const i = se(r, 0), o = Math.min(se(a, e.length), e.length);
  let s = 0, l, c, u;
  for (n = Math.ceil(n), a && (l = a - r, n = l / Math.floor(l / n)), u = i; u < 0; )
    s++, u = Math.round(i + s * n);
  for (c = Math.max(i, 0); c < o; c++)
    c === u && (t.push(e[c]), s++, u = Math.round(i + s * n));
}
function WD(e) {
  const t = e.length;
  let n, r;
  if (t < 2)
    return !1;
  for (r = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== r)
      return !1;
  return r;
}
const qD = (e) => e === "left" ? "right" : e === "right" ? "left" : e, gb = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, hb = (e, t) => Math.min(t || e, e);
function mb(e, t) {
  const n = [], r = e.length / t, a = e.length;
  let i = 0;
  for (; i < a; i += r)
    n.push(e[Math.floor(i)]);
  return n;
}
function VD(e, t, n) {
  const r = e.ticks.length, a = Math.min(t, r - 1), i = e._startPixel, o = e._endPixel, s = 1e-6;
  let l = e.getPixelForTick(a), c;
  if (!(n && (r === 1 ? c = Math.max(l - i, o - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(a - 1)) / 2, l += a < t ? c : -c, l < i - s || l > o + s)))
    return l;
}
function jD(e, t) {
  ve(e, (n) => {
    const r = n.gc, a = r.length / 2;
    let i;
    if (a > t) {
      for (i = 0; i < a; ++i)
        delete n.data[r[i]];
      r.splice(0, a);
    }
  });
}
function Aa(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function bb(e, t) {
  if (!e.display)
    return 0;
  const n = je(e.font, t), r = it(e.padding);
  return (De(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
}
function YD(e, t) {
  return Vn(e, {
    scale: t,
    type: "scale"
  });
}
function KD(e, t, n) {
  return Vn(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function XD(e, t, n) {
  let r = Xg(e);
  return (n && t !== "right" || !n && t === "right") && (r = qD(r)), r;
}
function ZD(e, t, n, r) {
  const { top: a, left: i, bottom: o, right: s, chart: l } = e, { chartArea: c, scales: u } = l;
  let d = 0, f, g, h;
  const p = o - a, m = s - i;
  if (e.isHorizontal()) {
    if (g = nt(r, i, s), ue(n)) {
      const v = Object.keys(n)[0], y = n[v];
      h = u[v].getPixelForValue(y) + p - t;
    } else n === "center" ? h = (c.bottom + c.top) / 2 + p - t : h = gb(e, n, t);
    f = s - i;
  } else {
    if (ue(n)) {
      const v = Object.keys(n)[0], y = n[v];
      g = u[v].getPixelForValue(y) - m + t;
    } else n === "center" ? g = (c.left + c.right) / 2 - m + t : g = gb(e, n, t);
    h = nt(r, o, a), d = n === "left" ? -Be : Be;
  }
  return {
    titleX: g,
    titleY: h,
    maxWidth: f,
    rotation: d
  };
}
class xr extends wn {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: r, _suggestedMax: a } = this;
    return t = St(t, Number.POSITIVE_INFINITY), n = St(n, Number.NEGATIVE_INFINITY), r = St(r, Number.POSITIVE_INFINITY), a = St(a, Number.NEGATIVE_INFINITY), {
      min: St(t, r),
      max: St(n, a),
      minDefined: Fe(t),
      maxDefined: Fe(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: r, minDefined: a, maxDefined: i } = this.getUserBounds(), o;
    if (a && i)
      return {
        min: n,
        max: r
      };
    const s = this.getMatchingVisibleMetas();
    for (let l = 0, c = s.length; l < c; ++l)
      o = s[l].controller.getMinMax(this, t), a || (n = Math.min(n, o.min)), i || (r = Math.max(r, o.max));
    return n = i && n > r ? r : n, r = a && n > r ? n : r, {
      min: St(n, St(r, n)),
      max: St(r, St(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Ae(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, r) {
    const { beginAtZero: a, grace: i, ticks: o } = this.options, s = o.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = oO(this, i, a), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = s < this.ticks.length;
    this._convertTicksToLabels(l ? mb(this.ticks, s) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), o.display && (o.autoSkip || o.source === "auto") && (this.ticks = BD(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, t = !t), this._startPixel = n, this._endPixel = r, this._reversePixels = t, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Ae(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Ae(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Ae(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Ae(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Ae(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let r, a, i;
    for (r = 0, a = t.length; r < a; r++)
      i = t[r], i.label = Ae(n.callback, [
        i.value,
        r,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    Ae(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Ae(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, r = hb(this.ticks.length, t.ticks.maxTicksLimit), a = n.minRotation || 0, i = n.maxRotation;
    let o = a, s, l, c;
    if (!this._isVisible() || !n.display || a >= i || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = a;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, f = u.highest.height, g = Ze(this.chart.width - d, 0, this.maxWidth);
    s = t.offset ? this.maxWidth / r : g / (r - 1), d + 6 > s && (s = g / (r - (t.offset ? 0.5 : 1)), l = this.maxHeight - Aa(t.grid) - n.padding - bb(t.title, this.chart.options.font), c = Math.sqrt(d * d + f * f), o = Yg(Math.min(Math.asin(Ze((u.highest.height + 6) / s, -1, 1)), Math.asin(Ze(l / c, -1, 1)) - Math.asin(Ze(f / c, -1, 1)))), o = Math.max(a, Math.min(i, o))), this.labelRotation = o;
  }
  afterCalculateLabelRotation() {
    Ae(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Ae(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: a, grid: i } } = this, o = this._isVisible(), s = this.isHorizontal();
    if (o) {
      const l = bb(a, n.options.font);
      if (s ? (t.width = this.maxWidth, t.height = Aa(i) + l) : (t.height = this.maxHeight, t.width = Aa(i) + l), r.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: f } = this._getLabelSizes(), g = r.padding * 2, h = Pt(this.labelRotation), p = Math.cos(h), m = Math.sin(h);
        if (s) {
          const v = r.mirror ? 0 : m * d.width + p * f.height;
          t.height = Math.min(this.maxHeight, t.height + v + g);
        } else {
          const v = r.mirror ? 0 : p * d.width + m * f.height;
          t.width = Math.min(this.maxWidth, t.width + v + g);
        }
        this._calculatePadding(c, u, m, p);
      }
    }
    this._handleMargins(), s ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, r, a) {
    const { ticks: { align: i, padding: o }, position: s } = this.options, l = this.labelRotation !== 0, c = s !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, g = 0;
      l ? c ? (f = a * t.width, g = r * n.height) : (f = r * t.height, g = a * n.width) : i === "start" ? g = n.width : i === "end" ? f = t.width : i !== "inner" && (f = t.width / 2, g = n.width / 2), this.paddingLeft = Math.max((f - u + o) * this.width / (this.width - u), 0), this.paddingRight = Math.max((g - d + o) * this.width / (this.width - d), 0);
    } else {
      let u = n.height / 2, d = t.height / 2;
      i === "start" ? (u = 0, d = t.height) : i === "end" && (u = n.height, d = 0), this.paddingTop = u + o, this.paddingBottom = d + o;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Ae(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, r;
    for (n = 0, r = t.length; n < r; n++)
      fe(t[n].label) && (t.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = mb(r, n)), this._labelSizes = t = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, r) {
    const { ctx: a, _longestTextCache: i } = this, o = [], s = [], l = Math.floor(n / hb(n, r));
    let c = 0, u = 0, d, f, g, h, p, m, v, y, E, S, w;
    for (d = 0; d < n; d += l) {
      if (h = t[d].label, p = this._resolveTickFontOptions(d), a.font = m = p.string, v = i[m] = i[m] || {
        data: {},
        gc: []
      }, y = p.lineHeight, E = S = 0, !fe(h) && !De(h))
        E = Bo(a, v.data, v.gc, E, h), S = y;
      else if (De(h))
        for (f = 0, g = h.length; f < g; ++f)
          w = h[f], !fe(w) && !De(w) && (E = Bo(a, v.data, v.gc, E, w), S += y);
      o.push(E), s.push(S), c = Math.max(E, c), u = Math.max(S, u);
    }
    jD(i, n);
    const R = o.indexOf(c), T = s.indexOf(u), A = (C) => ({
      width: o[C] || 0,
      height: s[C] || 0
    });
    return {
      first: A(0),
      last: A(n - 1),
      widest: A(R),
      highest: A(T),
      widths: o,
      heights: s
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return M0(this._alignToPixels ? tr(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return r.$context || (r.$context = KD(this.getContext(), t, r));
    }
    return this.$context || (this.$context = YD(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = Pt(this.labelRotation), r = Math.abs(Math.cos(n)), a = Math.abs(Math.sin(n)), i = this._getLabelSizes(), o = t.autoSkipPadding || 0, s = i ? i.widest.width + o : 0, l = i ? i.highest.height + o : 0;
    return this.isHorizontal() ? l * r > s * a ? s / r : l / a : l * a < s * r ? l / r : s / a;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, r = this.chart, a = this.options, { grid: i, position: o, border: s } = a, l = i.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), f = Aa(i), g = [], h = s.setContext(this.getContext()), p = h.display ? h.width : 0, m = p / 2, v = function(P) {
      return tr(r, P, p);
    };
    let y, E, S, w, R, T, A, C, N, L, I, k;
    if (o === "top")
      y = v(this.bottom), T = this.bottom - f, C = y - m, L = v(t.top) + m, k = t.bottom;
    else if (o === "bottom")
      y = v(this.top), L = t.top, k = v(t.bottom) - m, T = y + m, C = this.top + f;
    else if (o === "left")
      y = v(this.right), R = this.right - f, A = y - m, N = v(t.left) + m, I = t.right;
    else if (o === "right")
      y = v(this.left), N = t.left, I = v(t.right) - m, R = y + m, A = this.left + f;
    else if (n === "x") {
      if (o === "center")
        y = v((t.top + t.bottom) / 2 + 0.5);
      else if (ue(o)) {
        const P = Object.keys(o)[0], D = o[P];
        y = v(this.chart.scales[P].getPixelForValue(D));
      }
      L = t.top, k = t.bottom, T = y + m, C = T + f;
    } else if (n === "y") {
      if (o === "center")
        y = v((t.left + t.right) / 2);
      else if (ue(o)) {
        const P = Object.keys(o)[0], D = o[P];
        y = v(this.chart.scales[P].getPixelForValue(D));
      }
      R = y - m, A = R - f, N = t.left, I = t.right;
    }
    const B = se(a.ticks.maxTicksLimit, d), F = Math.max(1, Math.ceil(d / B));
    for (E = 0; E < d; E += F) {
      const P = this.getContext(E), D = i.setContext(P), O = s.setContext(P), M = D.lineWidth, W = D.color, U = O.dash || [], q = O.dashOffset, re = D.tickWidth, j = D.tickColor, ie = D.tickBorderDash || [], Q = D.tickBorderDashOffset;
      S = VD(this, E, l), S !== void 0 && (w = tr(r, S, M), c ? R = A = N = I = w : T = C = L = k = w, g.push({
        tx1: R,
        ty1: T,
        tx2: A,
        ty2: C,
        x1: N,
        y1: L,
        x2: I,
        y2: k,
        width: M,
        color: W,
        borderDash: U,
        borderDashOffset: q,
        tickWidth: re,
        tickColor: j,
        tickBorderDash: ie,
        tickBorderDashOffset: Q
      }));
    }
    return this._ticksLength = d, this._borderValue = y, g;
  }
  _computeLabelItems(t) {
    const n = this.axis, r = this.options, { position: a, ticks: i } = r, o = this.isHorizontal(), s = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = i, f = Aa(r.grid), g = f + u, h = d ? -u : g, p = -Pt(this.labelRotation), m = [];
    let v, y, E, S, w, R, T, A, C, N, L, I, k = "middle";
    if (a === "top")
      R = this.bottom - h, T = this._getXAxisLabelAlignment();
    else if (a === "bottom")
      R = this.top + h, T = this._getXAxisLabelAlignment();
    else if (a === "left") {
      const F = this._getYAxisLabelAlignment(f);
      T = F.textAlign, w = F.x;
    } else if (a === "right") {
      const F = this._getYAxisLabelAlignment(f);
      T = F.textAlign, w = F.x;
    } else if (n === "x") {
      if (a === "center")
        R = (t.top + t.bottom) / 2 + g;
      else if (ue(a)) {
        const F = Object.keys(a)[0], P = a[F];
        R = this.chart.scales[F].getPixelForValue(P) + g;
      }
      T = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (a === "center")
        w = (t.left + t.right) / 2 - g;
      else if (ue(a)) {
        const F = Object.keys(a)[0], P = a[F];
        w = this.chart.scales[F].getPixelForValue(P);
      }
      T = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (l === "start" ? k = "top" : l === "end" && (k = "bottom"));
    const B = this._getLabelSizes();
    for (v = 0, y = s.length; v < y; ++v) {
      E = s[v], S = E.label;
      const F = i.setContext(this.getContext(v));
      A = this.getPixelForTick(v) + i.labelOffset, C = this._resolveTickFontOptions(v), N = C.lineHeight, L = De(S) ? S.length : 1;
      const P = L / 2, D = F.color, O = F.textStrokeColor, M = F.textStrokeWidth;
      let W = T;
      o ? (w = A, T === "inner" && (v === y - 1 ? W = this.options.reverse ? "left" : "right" : v === 0 ? W = this.options.reverse ? "right" : "left" : W = "center"), a === "top" ? c === "near" || p !== 0 ? I = -L * N + N / 2 : c === "center" ? I = -B.highest.height / 2 - P * N + N : I = -B.highest.height + N / 2 : c === "near" || p !== 0 ? I = N / 2 : c === "center" ? I = B.highest.height / 2 - P * N : I = B.highest.height - L * N, d && (I *= -1), p !== 0 && !F.showLabelBackdrop && (w += N / 2 * Math.sin(p))) : (R = A, I = (1 - L) * N / 2);
      let U;
      if (F.showLabelBackdrop) {
        const q = it(F.backdropPadding), re = B.heights[v], j = B.widths[v];
        let ie = I - q.top, Q = 0 - q.left;
        switch (k) {
          case "middle":
            ie -= re / 2;
            break;
          case "bottom":
            ie -= re;
            break;
        }
        switch (T) {
          case "center":
            Q -= j / 2;
            break;
          case "right":
            Q -= j;
            break;
          case "inner":
            v === y - 1 ? Q -= j : v > 0 && (Q -= j / 2);
            break;
        }
        U = {
          left: Q,
          top: ie,
          width: j + q.width,
          height: re + q.height,
          color: F.backdropColor
        };
      }
      m.push({
        label: S,
        font: C,
        textOffset: I,
        options: {
          rotation: p,
          color: D,
          strokeColor: O,
          strokeWidth: M,
          textAlign: W,
          textBaseline: k,
          translation: [
            w,
            R
          ],
          backdrop: U
        }
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-Pt(this.labelRotation))
      return t === "top" ? "left" : "right";
    let a = "center";
    return n.align === "start" ? a = "left" : n.align === "end" ? a = "right" : n.align === "inner" && (a = "inner"), a;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: r, mirror: a, padding: i } } = this.options, o = this._getLabelSizes(), s = t + i, l = o.widest.width;
    let c, u;
    return n === "left" ? a ? (u = this.right + i, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - s, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : n === "right" ? a ? (u = this.left + i, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + s, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: r, top: a, width: i, height: o } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(r, a, i, o), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const a = this.ticks.findIndex((i) => i.value === t);
    return a >= 0 ? n.setContext(this.getContext(a)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, r = this.ctx, a = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let i, o;
    const s = (l, c, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (i = 0, o = a.length; i < o; ++i) {
        const l = a[i];
        n.drawOnChartArea && s({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && s({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: r, grid: a } } = this, i = r.setContext(this.getContext()), o = r.display ? i.width : 0;
    if (!o)
      return;
    const s = a.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, f;
    this.isHorizontal() ? (c = tr(t, this.left, o) - o / 2, u = tr(t, this.right, s) + s / 2, d = f = l) : (d = tr(t, this.top, o) - o / 2, f = tr(t, this.bottom, s) + s / 2, c = u = l), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(c, d), n.lineTo(u, f), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, a = this._computeLabelArea();
    a && us(r, a);
    const i = this.getLabelItems(t);
    for (const o of i) {
      const s = o.options, l = o.font, c = o.label, u = o.textOffset;
      vr(r, c, 0, u, l, s);
    }
    a && ds(r);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: r, reverse: a } } = this;
    if (!r.display)
      return;
    const i = je(r.font), o = it(r.padding), s = r.align;
    let l = i.lineHeight / 2;
    n === "bottom" || n === "center" || ue(n) ? (l += o.bottom, De(r.text) && (l += i.lineHeight * (r.text.length - 1))) : l += o.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: f } = ZD(this, l, n, s);
    vr(t, r.text, 0, 0, i, {
      color: r.color,
      maxWidth: d,
      rotation: f,
      textAlign: XD(s, n, a),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, r = se(t.grid && t.grid.z, -1), a = se(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== xr.prototype.draw ? [
      {
        z: n,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: r,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: a,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", a = [];
    let i, o;
    for (i = 0, o = n.length; i < o; ++i) {
      const s = n[i];
      s[r] === this.id && (!t || s.type === t) && a.push(s);
    }
    return a;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return je(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Yi {
  constructor(t, n, r) {
    this.type = t, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let r;
    eL(n) && (r = this.register(n));
    const a = this.items, i = t.id, o = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + t);
    return i in a || (a[i] = t, QD(t, o, r), this.override && Le.override(t.id, t.overrides)), o;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, r = t.id, a = this.scope;
    r in n && delete n[r], a && r in Le[a] && (delete Le[a][r], this.override && delete br[r]);
  }
}
function QD(e, t, n) {
  const r = ti(/* @__PURE__ */ Object.create(null), [
    n ? Le.get(n) : {},
    Le.get(t),
    e.defaults
  ]);
  Le.set(t, r), e.defaultRoutes && JD(t, e.defaultRoutes), e.descriptors && Le.describe(t, e.descriptors);
}
function JD(e, t) {
  Object.keys(t).forEach((n) => {
    const r = n.split("."), a = r.pop(), i = [
      e
    ].concat(r).join("."), o = t[n].split("."), s = o.pop(), l = o.join(".");
    Le.route(i, a, l, s);
  });
}
function eL(e) {
  return "id" in e && "defaults" in e;
}
class tL {
  constructor() {
    this.controllers = new Yi($t, "datasets", !0), this.elements = new Yi(wn, "elements"), this.plugins = new Yi(Object, "plugins"), this.scales = new Yi(xr, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, r) {
    [
      ...n
    ].forEach((a) => {
      const i = r || this._getRegistryForType(a);
      r || i.isForType(a) || i === this.plugins && a.id ? this._exec(t, i, a) : ve(a, (o) => {
        const s = r || this._getRegistryForType(o);
        this._exec(t, s, o);
      });
    });
  }
  _exec(t, n, r) {
    const a = jg(t);
    Ae(r["before" + a], [], r), n[t](r), Ae(r["after" + a], [], r);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(t))
        return r;
    }
    return this.plugins;
  }
  _get(t, n, r) {
    const a = n.get(t);
    if (a === void 0)
      throw new Error('"' + t + '" is not a registered ' + r + ".");
    return a;
  }
}
var Yt = /* @__PURE__ */ new tL();
class nL {
  constructor() {
    this._init = [];
  }
  notify(t, n, r, a) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const i = a ? this._descriptors(t).filter(a) : this._descriptors(t), o = this._notify(i, t, n, r);
    return n === "afterDestroy" && (this._notify(i, t, "stop"), this._notify(this._init, t, "uninstall")), o;
  }
  _notify(t, n, r, a) {
    a = a || {};
    for (const i of t) {
      const o = i.plugin, s = o[r], l = [
        n,
        a,
        i.options
      ];
      if (Ae(s, l, o) === !1 && a.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    fe(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const r = t && t.config, a = se(r.options && r.options.plugins, {}), i = rL(r);
    return a === !1 && !n ? [] : iL(t, i, a, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], r = this._cache, a = (i, o) => i.filter((s) => !o.some((l) => s.plugin.id === l.plugin.id));
    this._notify(a(n, r), t, "stop"), this._notify(a(r, n), t, "start");
  }
}
function rL(e) {
  const t = {}, n = [], r = Object.keys(Yt.plugins.items);
  for (let i = 0; i < r.length; i++)
    n.push(Yt.getPlugin(r[i]));
  const a = e.plugins || [];
  for (let i = 0; i < a.length; i++) {
    const o = a[i];
    n.indexOf(o) === -1 && (n.push(o), t[o.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function aL(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function iL(e, { plugins: t, localIds: n }, r, a) {
  const i = [], o = e.getContext();
  for (const s of t) {
    const l = s.id, c = aL(r[l], a);
    c !== null && i.push({
      plugin: s,
      options: oL(e.config, {
        plugin: s,
        local: n[l]
      }, c, o)
    });
  }
  return i;
}
function oL(e, { plugin: t, local: n }, r, a) {
  const i = e.pluginScopeKeys(t), o = e.getOptionScopes(r, i);
  return n && t.defaults && o.push(t.defaults), e.createResolver(o, a, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function qp(e, t) {
  const n = Le.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function sL(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function lL(e, t) {
  return e === t ? "_index_" : "_value_";
}
function vb(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function cL(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Vp(e, ...t) {
  if (vb(e))
    return e;
  for (const n of t) {
    const r = n.axis || cL(n.position) || e.length > 1 && vb(e[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function yb(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function uL(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((r) => r.xAxisID === e || r.yAxisID === e);
    if (n.length)
      return yb(e, "x", n[0]) || yb(e, "y", n[0]);
  }
  return {};
}
function dL(e, t) {
  const n = br[e.type] || {
    scales: {}
  }, r = t.scales || {}, a = qp(e.type, t), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((o) => {
    const s = r[o];
    if (!ue(s))
      return console.error(`Invalid scale configuration for scale: ${o}`);
    if (s._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${o}`);
    const l = Vp(o, s, uL(o, e), Le.scales[s.type]), c = lL(l, a), u = n.scales || {};
    i[o] = ja(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      s,
      u[l],
      u[c]
    ]);
  }), e.data.datasets.forEach((o) => {
    const s = o.type || e.type, l = o.indexAxis || qp(s, t), u = (br[s] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const f = sL(d, l), g = o[f + "AxisID"] || f;
      i[g] = i[g] || /* @__PURE__ */ Object.create(null), ja(i[g], [
        {
          axis: f
        },
        r[g],
        u[d]
      ]);
    });
  }), Object.keys(i).forEach((o) => {
    const s = i[o];
    ja(s, [
      Le.scales[s.type],
      Le.scale
    ]);
  }), i;
}
function NR(e) {
  const t = e.options || (e.options = {});
  t.plugins = se(t.plugins, {}), t.scales = dL(e, t);
}
function IR(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function fL(e) {
  return e = e || {}, e.data = IR(e.data), NR(e), e;
}
const Eb = /* @__PURE__ */ new Map(), kR = /* @__PURE__ */ new Set();
function Ki(e, t) {
  let n = Eb.get(e);
  return n || (n = t(), Eb.set(e, n), kR.add(n)), n;
}
const xa = (e, t, n) => {
  const r = Un(t, n);
  r !== void 0 && e.add(r);
};
class pL {
  constructor(t) {
    this._config = fL(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = IR(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), NR(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Ki(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return Ki(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return Ki(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, r = this.type;
    return Ki(`${r}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const r = this._scopeCache;
    let a = r.get(t);
    return (!a || n) && (a = /* @__PURE__ */ new Map(), r.set(t, a)), a;
  }
  getOptionScopes(t, n, r) {
    const { options: a, type: i } = this, o = this._cachedScopes(t, r), s = o.get(n);
    if (s)
      return s;
    const l = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      t && (l.add(t), u.forEach((d) => xa(l, t, d))), u.forEach((d) => xa(l, a, d)), u.forEach((d) => xa(l, br[i] || {}, d)), u.forEach((d) => xa(l, Le, d)), u.forEach((d) => xa(l, Hp, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), kR.has(n) && o.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      br[n] || {},
      Le.datasets[n] || {},
      {
        type: n
      },
      Le,
      Hp
    ];
  }
  resolveNamedOptions(t, n, r, a = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: o, subPrefixes: s } = Sb(this._resolverCache, t, a);
    let l = o;
    if (hL(o, n)) {
      i.$shared = !1, r = Gn(r) ? r() : r;
      const c = this.createResolver(t, r, s);
      l = ra(o, r, c);
    }
    for (const c of n)
      i[c] = l[c];
    return i;
  }
  createResolver(t, n, r = [
    ""
  ], a) {
    const { resolver: i } = Sb(this._resolverCache, t, r);
    return ue(n) ? ra(i, n, void 0, a) : i;
  }
}
function Sb(e, t, n) {
  let r = e.get(t);
  r || (r = /* @__PURE__ */ new Map(), e.set(t, r));
  const a = n.join();
  let i = r.get(a);
  return i || (i = {
    resolver: Jg(t, n),
    subPrefixes: n.filter((s) => !s.toLowerCase().includes("hover"))
  }, r.set(a, i)), i;
}
const gL = (e) => ue(e) && Object.getOwnPropertyNames(e).some((t) => Gn(e[t]));
function hL(e, t) {
  const { isScriptable: n, isIndexable: r } = uR(e);
  for (const a of t) {
    const i = n(a), o = r(a), s = (o || i) && e[a];
    if (i && (Gn(s) || gL(s)) || o && De(s))
      return !0;
  }
  return !1;
}
var mL = "4.4.6";
const bL = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function wb(e, t) {
  return e === "top" || e === "bottom" || bL.indexOf(e) === -1 && t === "x";
}
function _b(e, t) {
  return function(n, r) {
    return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
  };
}
function Tb(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), Ae(n && n.onComplete, [
    e
  ], t);
}
function vL(e) {
  const t = e.chart, n = t.options.animation;
  Ae(n && n.onProgress, [
    e
  ], t);
}
function OR(e) {
  return nh() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Co = {}, Rb = (e) => {
  const t = OR(e);
  return Object.values(Co).filter((n) => n.canvas === t).pop();
};
function yL(e, t, n) {
  const r = Object.keys(e);
  for (const a of r) {
    const i = +a;
    if (i >= t) {
      const o = e[a];
      delete e[a], (n > 0 || i > t) && (e[i + n] = o);
    }
  }
}
function EL(e, t, n, r) {
  return !n || e.type === "mouseout" ? null : r ? t : e;
}
function Xi(e, t, n) {
  return e.options.clip ? e[n] : t[n];
}
function SL(e, t) {
  const { xScale: n, yScale: r } = e;
  return n && r ? {
    left: Xi(n, t, "left"),
    right: Xi(n, t, "right"),
    top: Xi(r, t, "top"),
    bottom: Xi(r, t, "bottom")
  } : t;
}
class fn {
  static register(...t) {
    Yt.add(...t), Ab();
  }
  static unregister(...t) {
    Yt.remove(...t), Ab();
  }
  constructor(t, n) {
    const r = this.config = new pL(n), a = OR(t), i = Rb(a);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const o = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || $D(a))(), this.platform.updateConfig(r);
    const s = this.platform.acquireContext(a, o.aspectRatio), l = s && s.canvas, c = l && l.height, u = l && l.width;
    if (this.id = _0(), this.ctx = s, this.canvas = l, this.width = u, this.height = c, this._options = o, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new nL(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = B0((d) => this.update(d), o.resizeDelay || 0), this._dataChanges = [], Co[this.id] = this, !s || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    cn.listen(this, "complete", Tb), cn.listen(this, "progress", vL), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: r, height: a, _aspectRatio: i } = this;
    return fe(t) ? n && i ? i : a ? r / a : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Yt;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Ym(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return qm(this.canvas, this.ctx), this;
  }
  stop() {
    return cn.stop(this), this;
  }
  resize(t, n) {
    cn.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const r = this.options, a = this.canvas, i = r.maintainAspectRatio && this.aspectRatio, o = this.platform.getMaximumSize(a, t, n, i), s = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = o.width, this.height = o.height, this._aspectRatio = this.aspectRatio, Ym(this, s, !0) && (this.notifyPlugins("resize", {
      size: o
    }), Ae(r.onResize, [
      this,
      o
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    ve(n, (r, a) => {
      r.id = a;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, r = this.scales, a = Object.keys(r).reduce((o, s) => (o[s] = !1, o), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((o) => {
      const s = n[o], l = Vp(o, s), c = l === "r", u = l === "x";
      return {
        options: s,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), ve(i, (o) => {
      const s = o.options, l = s.id, c = Vp(l, s), u = se(s.type, o.dtype);
      (s.position === void 0 || wb(s.position, c) !== wb(o.dposition)) && (s.position = o.dposition), a[l] = !0;
      let d = null;
      if (l in r && r[l].type === u)
        d = r[l];
      else {
        const f = Yt.getScale(u);
        d = new f({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(s, t);
    }), ve(a, (o, s) => {
      o || delete r[s];
    }), ve(r, (o) => {
      rt.configure(this, o, o.options), rt.addBox(this, o);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, r = t.length;
    if (t.sort((a, i) => a.index - i.index), r > n) {
      for (let a = n; a < r; ++a)
        this._destroyDatasetMeta(a);
      t.splice(n, r - n);
    }
    this._sortedMetasets = t.slice(0).sort(_b("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((r, a) => {
      n.filter((i) => i === r._dataset).length === 0 && this._destroyDatasetMeta(a);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let r, a;
    for (this._removeUnreferencedMetasets(), r = 0, a = n.length; r < a; r++) {
      const i = n[r];
      let o = this.getDatasetMeta(r);
      const s = i.type || this.config.type;
      if (o.type && o.type !== s && (this._destroyDatasetMeta(r), o = this.getDatasetMeta(r)), o.type = s, o.indexAxis = i.indexAxis || qp(s, this.options), o.order = i.order || 0, o.index = r, o.label = "" + i.label, o.visible = this.isDatasetVisible(r), o.controller)
        o.controller.updateIndex(r), o.controller.linkScales();
      else {
        const l = Yt.getController(s), { datasetElementType: c, dataElementType: u } = Le.datasets[s];
        Object.assign(l, {
          dataElementType: Yt.getElement(u),
          datasetElementType: c && Yt.getElement(c)
        }), o.controller = new l(this, r), t.push(o.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    ve(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), a = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let o = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), f = !a && i.indexOf(d) === -1;
      d.buildOrUpdateElements(f), o = Math.max(+d.getMaxOverflow(), o);
    }
    o = this._minPadding = r.layout.autoPadding ? o : 0, this._updateLayout(o), a || ve(i, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(_b("z", "_idx"));
    const { _active: s, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : s.length && this._updateHoverStyles(s, s, !0), this.render();
  }
  _updateScales() {
    ve(this.scales, (t) => {
      rt.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(t.events);
    (!Pm(n, r) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: a, count: i } of n) {
      const o = r === "_removeElements" ? -i : i;
      yL(t, a, o);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (i) => new Set(t.filter((o) => o[0] === i).map((o, s) => s + "," + o.splice(1).join(","))), a = r(0);
    for (let i = 1; i < n; i++)
      if (!Pm(a, r(i)))
        return;
    return Array.from(a).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    rt.update(this, this.width, this.height, t);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], ve(this.boxes, (a) => {
      r && a.position === "chartArea" || (a.configure && a.configure(), this._layers.push(...a._layers()));
    }, this), this._layers.forEach((a, i) => {
      a._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, Gn(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const r = this.getDatasetMeta(t), a = {
      meta: r,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", a) !== !1 && (r.controller._update(n), a.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", a));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (cn.has(this) ? this.attached && !cn.running(this) && cn.start(this) : (this.draw(), Tb({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: r, height: a } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(r, a);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, r = [];
    let a, i;
    for (a = 0, i = n.length; a < i; ++a) {
      const o = n[a];
      (!t || o.visible) && r.push(o);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, r = t._clip, a = !r.disabled, i = SL(t, this.chartArea), o = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", o) !== !1 && (a && us(n, {
      left: r.left === !1 ? 0 : i.left - r.left,
      right: r.right === !1 ? this.width : i.right + r.right,
      top: r.top === !1 ? 0 : i.top - r.top,
      bottom: r.bottom === !1 ? this.height : i.bottom + r.bottom
    }), t.controller.draw(), a && ds(n), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
  }
  isPointInArea(t) {
    return hn(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, r, a) {
    const i = bD.modes[n];
    return typeof i == "function" ? i(this, t, r, a) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], r = this._metasets;
    let a = r.filter((i) => i && i._dataset === n).pop();
    return a || (a = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = Vn(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(t);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const r = this.getDatasetMeta(t);
    r.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, r) {
    const a = r ? "show" : "hide", i = this.getDatasetMeta(t), o = i.controller._resolveAnimations(void 0, a);
    ni(n) ? (i.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(t, r), o.update(i, {
      visible: r
    }), this.update((s) => s.datasetIndex === t ? a : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), cn.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), qm(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Co[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, r = (i, o) => {
      n.addEventListener(this, i, o), t[i] = o;
    }, a = (i, o, s) => {
      i.offsetX = o, i.offsetY = s, this._eventHandler(i);
    };
    ve(this.options.events, (i) => r(i, a));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, r = (l, c) => {
      n.addEventListener(this, l, c), t[l] = c;
    }, a = (l, c) => {
      t[l] && (n.removeEventListener(this, l, c), delete t[l]);
    }, i = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let o;
    const s = () => {
      a("attach", s), this.attached = !0, this.resize(), r("resize", i), r("detach", o);
    };
    o = () => {
      this.attached = !1, a("resize", i), this._stop(), this._resize(0, 0), r("attach", s);
    }, n.isAttached(this.canvas) ? s() : o();
  }
  unbindEvents() {
    ve(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, ve(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, r) {
    const a = r ? "set" : "remove";
    let i, o, s, l;
    for (n === "dataset" && (i = this.getDatasetMeta(t[0].datasetIndex), i.controller["_" + a + "DatasetHoverStyle"]()), s = 0, l = t.length; s < l; ++s) {
      o = t[s];
      const c = o && this.getDatasetMeta(o.datasetIndex).controller;
      c && c[a + "HoverStyle"](o.element, o.datasetIndex, o.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], r = t.map(({ datasetIndex: i, index: o }) => {
      const s = this.getDatasetMeta(i);
      if (!s)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: s.data[o],
        index: o
      };
    });
    !Po(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(t, n, r) {
    return this._plugins.notify(this, t, n, r);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, r) {
    const a = this.options.hover, i = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), o = i(n, t), s = r ? t : i(t, n);
    o.length && this.updateHoverStyle(o, a.mode, !1), s.length && a.mode && this.updateHoverStyle(s, a.mode, !0);
  }
  _eventHandler(t, n) {
    const r = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, a = (o) => (o.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", r, a) === !1)
      return;
    const i = this._handleEvent(t, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, a), (i || r.changed) && this.render(), this;
  }
  _handleEvent(t, n, r) {
    const { _active: a = [], options: i } = this, o = n, s = this._getActiveElements(t, a, r, o), l = N0(t), c = EL(t, this._lastEvent, r, l);
    r && (this._lastEvent = null, Ae(i.onHover, [
      t,
      s,
      this
    ], this), l && Ae(i.onClick, [
      t,
      s,
      this
    ], this));
    const u = !Po(s, a);
    return (u || n) && (this._active = s, this._updateHoverStyles(s, a, n)), this._lastEvent = c, u;
  }
  _getActiveElements(t, n, r, a) {
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(t, i.mode, i, a);
  }
}
z(fn, "defaults", Le), z(fn, "instances", Co), z(fn, "overrides", br), z(fn, "registry", Yt), z(fn, "version", mL), z(fn, "getChart", Rb);
function Ab() {
  return ve(fn.instances, (e) => e._plugins.invalidate());
}
function wL(e, t, n) {
  const { startAngle: r, pixelMargin: a, x: i, y: o, outerRadius: s, innerRadius: l } = t;
  let c = a / s;
  e.beginPath(), e.arc(i, o, s, r - c, n + c), l > a ? (c = a / l, e.arc(i, o, l, n + c, r - c, !0)) : e.arc(i, o, a, n + Be, r - Be), e.closePath(), e.clip();
}
function _L(e) {
  return Qg(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function TL(e, t, n, r) {
  const a = _L(e.options.borderRadius), i = (n - t) / 2, o = Math.min(i, r * t / 2), s = (l) => {
    const c = (n - Math.min(i, l)) * r / 2;
    return Ze(l, 0, Math.min(i, c));
  };
  return {
    outerStart: s(a.outerStart),
    outerEnd: s(a.outerEnd),
    innerStart: Ze(a.innerStart, 0, o),
    innerEnd: Ze(a.innerEnd, 0, o)
  };
}
function Lr(e, t, n, r) {
  return {
    x: n + e * Math.cos(t),
    y: r + e * Math.sin(t)
  };
}
function Ho(e, t, n, r, a, i) {
  const { x: o, y: s, startAngle: l, pixelMargin: c, innerRadius: u } = t, d = Math.max(t.outerRadius + r + n - c, 0), f = u > 0 ? u + r + n + c : 0;
  let g = 0;
  const h = a - l;
  if (r) {
    const F = u > 0 ? u - r : 0, P = d > 0 ? d - r : 0, D = (F + P) / 2, O = D !== 0 ? h * D / (D + r) : h;
    g = (h - O) / 2;
  }
  const p = Math.max(1e-3, h * d - n / Oe) / d, m = (h - p) / 2, v = l + m + g, y = a - m - g, { outerStart: E, outerEnd: S, innerStart: w, innerEnd: R } = TL(t, f, d, y - v), T = d - E, A = d - S, C = v + E / T, N = y - S / A, L = f + w, I = f + R, k = v + w / L, B = y - R / I;
  if (e.beginPath(), i) {
    const F = (C + N) / 2;
    if (e.arc(o, s, d, C, F), e.arc(o, s, d, F, N), S > 0) {
      const M = Lr(A, N, o, s);
      e.arc(M.x, M.y, S, N, y + Be);
    }
    const P = Lr(I, y, o, s);
    if (e.lineTo(P.x, P.y), R > 0) {
      const M = Lr(I, B, o, s);
      e.arc(M.x, M.y, R, y + Be, B + Math.PI);
    }
    const D = (y - R / f + (v + w / f)) / 2;
    if (e.arc(o, s, f, y - R / f, D, !0), e.arc(o, s, f, D, v + w / f, !0), w > 0) {
      const M = Lr(L, k, o, s);
      e.arc(M.x, M.y, w, k + Math.PI, v - Be);
    }
    const O = Lr(T, v, o, s);
    if (e.lineTo(O.x, O.y), E > 0) {
      const M = Lr(T, C, o, s);
      e.arc(M.x, M.y, E, v - Be, C);
    }
  } else {
    e.moveTo(o, s);
    const F = Math.cos(C) * d + o, P = Math.sin(C) * d + s;
    e.lineTo(F, P);
    const D = Math.cos(N) * d + o, O = Math.sin(N) * d + s;
    e.lineTo(D, O);
  }
  e.closePath();
}
function RL(e, t, n, r, a) {
  const { fullCircles: i, startAngle: o, circumference: s } = t;
  let l = t.endAngle;
  if (i) {
    Ho(e, t, n, r, l, a);
    for (let c = 0; c < i; ++c)
      e.fill();
    isNaN(s) || (l = o + (s % ke || ke));
  }
  return Ho(e, t, n, r, l, a), e.fill(), l;
}
function AL(e, t, n, r, a) {
  const { fullCircles: i, startAngle: o, circumference: s, options: l } = t, { borderWidth: c, borderJoinStyle: u, borderDash: d, borderDashOffset: f } = l, g = l.borderAlign === "inner";
  if (!c)
    return;
  e.setLineDash(d || []), e.lineDashOffset = f, g ? (e.lineWidth = c * 2, e.lineJoin = u || "round") : (e.lineWidth = c, e.lineJoin = u || "bevel");
  let h = t.endAngle;
  if (i) {
    Ho(e, t, n, r, h, a);
    for (let p = 0; p < i; ++p)
      e.stroke();
    isNaN(s) || (h = o + (s % ke || ke));
  }
  g && wL(e, t, h), i || (Ho(e, t, n, r, h, a), e.stroke());
}
class Ba extends wn {
  constructor(n) {
    super();
    z(this, "circumference");
    z(this, "endAngle");
    z(this, "fullCircles");
    z(this, "innerRadius");
    z(this, "outerRadius");
    z(this, "pixelMargin");
    z(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, r, a) {
    const i = this.getProps([
      "x",
      "y"
    ], a), { angle: o, distance: s } = eR(i, {
      x: n,
      y: r
    }), { startAngle: l, endAngle: c, innerRadius: u, outerRadius: d, circumference: f } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], a), g = (this.options.spacing + this.options.borderWidth) / 2, h = se(f, c - l), p = ri(o, l, c) && l !== c, m = h >= ke || p, v = pn(s, u + g, d + g);
    return m && v;
  }
  getCenterPoint(n) {
    const { x: r, y: a, startAngle: i, endAngle: o, innerRadius: s, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: c, spacing: u } = this.options, d = (i + o) / 2, f = (s + l + u + c) / 2;
    return {
      x: r + Math.cos(d) * f,
      y: a + Math.sin(d) * f
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: r, circumference: a } = this, i = (r.offset || 0) / 4, o = (r.spacing || 0) / 2, s = r.circular;
    if (this.pixelMargin = r.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = a > ke ? Math.floor(a / ke) : 0, a === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const l = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(l) * i, Math.sin(l) * i);
    const c = 1 - Math.sin(Math.min(Oe, a || 0)), u = i * c;
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, RL(n, this, u, o, s), AL(n, this, u, o, s), n.restore();
  }
}
z(Ba, "id", "arc"), z(Ba, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), z(Ba, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), z(Ba, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function DR(e, t, n = t) {
  e.lineCap = se(n.borderCapStyle, t.borderCapStyle), e.setLineDash(se(n.borderDash, t.borderDash)), e.lineDashOffset = se(n.borderDashOffset, t.borderDashOffset), e.lineJoin = se(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = se(n.borderWidth, t.borderWidth), e.strokeStyle = se(n.borderColor, t.borderColor);
}
function xL(e, t, n) {
  e.lineTo(n.x, n.y);
}
function CL(e) {
  return e.stepped ? Z0 : e.tension || e.cubicInterpolationMode === "monotone" ? Q0 : xL;
}
function LR(e, t, n = {}) {
  const r = e.length, { start: a = 0, end: i = r - 1 } = n, { start: o, end: s } = t, l = Math.max(a, o), c = Math.min(i, s), u = a < o && i < o || a > s && i > s;
  return {
    count: r,
    start: l,
    loop: t.loop,
    ilen: c < l && !u ? r + c - l : c - l
  };
}
function NL(e, t, n, r) {
  const { points: a, options: i } = t, { count: o, start: s, loop: l, ilen: c } = LR(a, n, r), u = CL(i);
  let { move: d = !0, reverse: f } = r || {}, g, h, p;
  for (g = 0; g <= c; ++g)
    h = a[(s + (f ? c - g : g)) % o], !h.skip && (d ? (e.moveTo(h.x, h.y), d = !1) : u(e, p, h, f, i.stepped), p = h);
  return l && (h = a[(s + (f ? c : 0)) % o], u(e, p, h, f, i.stepped)), !!l;
}
function IL(e, t, n, r) {
  const a = t.points, { count: i, start: o, ilen: s } = LR(a, n, r), { move: l = !0, reverse: c } = r || {};
  let u = 0, d = 0, f, g, h, p, m, v;
  const y = (S) => (o + (c ? s - S : S)) % i, E = () => {
    p !== m && (e.lineTo(u, m), e.lineTo(u, p), e.lineTo(u, v));
  };
  for (l && (g = a[y(0)], e.moveTo(g.x, g.y)), f = 0; f <= s; ++f) {
    if (g = a[y(f)], g.skip)
      continue;
    const S = g.x, w = g.y, R = S | 0;
    R === h ? (w < p ? p = w : w > m && (m = w), u = (d * u + S) / ++d) : (E(), e.lineTo(S, w), h = R, d = 0, p = m = w), v = w;
  }
  E();
}
function jp(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? IL : NL;
}
function kL(e) {
  return e.stepped ? IO : e.tension || e.cubicInterpolationMode === "monotone" ? kO : cr;
}
function OL(e, t, n, r) {
  let a = t._path;
  a || (a = t._path = new Path2D(), t.path(a, n, r) && a.closePath()), DR(e, t.options), e.stroke(a);
}
function DL(e, t, n, r) {
  const { segments: a, options: i } = t, o = jp(t);
  for (const s of a)
    DR(e, i, s.style), e.beginPath(), o(e, t, s, {
      start: n,
      end: n + r - 1
    }) && e.closePath(), e.stroke();
}
const LL = typeof Path2D == "function";
function ML(e, t, n, r) {
  LL && !t.options.segment ? OL(e, t, n, r) : DL(e, t, n, r);
}
class Ln extends wn {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const a = r.spanGaps ? this._loop : this._fullLoop;
      wO(this._points, r, t, a, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = FO(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, r = t.length;
    return r && n[t[r - 1].end];
  }
  interpolate(t, n) {
    const r = this.options, a = t[n], i = this.points, o = ER(this, {
      property: n,
      start: a,
      end: a
    });
    if (!o.length)
      return;
    const s = [], l = kL(r);
    let c, u;
    for (c = 0, u = o.length; c < u; ++c) {
      const { start: d, end: f } = o[c], g = i[d], h = i[f];
      if (g === h) {
        s.push(g);
        continue;
      }
      const p = Math.abs((a - g[n]) / (h[n] - g[n])), m = l(g, h, p, r.stepped);
      m[n] = t[n], s.push(m);
    }
    return s.length === 1 ? s[0] : s;
  }
  pathSegment(t, n, r) {
    return jp(this)(t, this, n, r);
  }
  path(t, n, r) {
    const a = this.segments, i = jp(this);
    let o = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const s of a)
      o &= i(t, this, s, {
        start: n,
        end: n + r - 1
      });
    return !!o;
  }
  draw(t, n, r, a) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (t.save(), ML(t, this, r, a), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
z(Ln, "id", "line"), z(Ln, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), z(Ln, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), z(Ln, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function xb(e, t, n, r) {
  const a = e.options, { [n]: i } = e.getProps([
    n
  ], r);
  return Math.abs(t - i) < a.radius + a.hitRadius;
}
class No extends wn {
  constructor(n) {
    super();
    z(this, "parsed");
    z(this, "skip");
    z(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, r, a) {
    const i = this.options, { x: o, y: s } = this.getProps([
      "x",
      "y"
    ], a);
    return Math.pow(n - o, 2) + Math.pow(r - s, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(n, r) {
    return xb(this, n, "x", r);
  }
  inYRange(n, r) {
    return xb(this, n, "y", r);
  }
  getCenterPoint(n) {
    const { x: r, y: a } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: r,
      y: a
    };
  }
  size(n) {
    n = n || this.options || {};
    let r = n.radius || 0;
    r = Math.max(r, r && n.hoverRadius || 0);
    const a = r && n.borderWidth || 0;
    return (r + a) * 2;
  }
  draw(n, r) {
    const a = this.options;
    this.skip || a.radius < 0.1 || !hn(this, r, this.size(a) / 2) || (n.strokeStyle = a.borderColor, n.lineWidth = a.borderWidth, n.fillStyle = a.backgroundColor, zp(n, a, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
z(No, "id", "point"), /**
* @type {any}
*/
z(No, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
z(No, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function MR(e, t) {
  const { x: n, y: r, base: a, width: i, height: o } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let s, l, c, u, d;
  return e.horizontal ? (d = o / 2, s = Math.min(n, a), l = Math.max(n, a), c = r - d, u = r + d) : (d = i / 2, s = n - d, l = n + d, c = Math.min(r, a), u = Math.max(r, a)), {
    left: s,
    top: c,
    right: l,
    bottom: u
  };
}
function Mn(e, t, n, r) {
  return e ? 0 : Ze(t, n, r);
}
function PL(e, t, n) {
  const r = e.options.borderWidth, a = e.borderSkipped, i = cR(r);
  return {
    t: Mn(a.top, i.top, 0, n),
    r: Mn(a.right, i.right, 0, t),
    b: Mn(a.bottom, i.bottom, 0, n),
    l: Mn(a.left, i.left, 0, t)
  };
}
function FL(e, t, n) {
  const { enableBorderRadius: r } = e.getProps([
    "enableBorderRadius"
  ]), a = e.options.borderRadius, i = gr(a), o = Math.min(t, n), s = e.borderSkipped, l = r || ue(a);
  return {
    topLeft: Mn(!l || s.top || s.left, i.topLeft, 0, o),
    topRight: Mn(!l || s.top || s.right, i.topRight, 0, o),
    bottomLeft: Mn(!l || s.bottom || s.left, i.bottomLeft, 0, o),
    bottomRight: Mn(!l || s.bottom || s.right, i.bottomRight, 0, o)
  };
}
function $L(e) {
  const t = MR(e), n = t.right - t.left, r = t.bottom - t.top, a = PL(e, n / 2, r / 2), i = FL(e, n / 2, r / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: r,
      radius: i
    },
    inner: {
      x: t.left + a.l,
      y: t.top + a.t,
      w: n - a.l - a.r,
      h: r - a.t - a.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(a.t, a.l)),
        topRight: Math.max(0, i.topRight - Math.max(a.t, a.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(a.b, a.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(a.b, a.r))
      }
    }
  };
}
function Js(e, t, n, r) {
  const a = t === null, i = n === null, s = e && !(a && i) && MR(e, r);
  return s && (a || pn(t, s.left, s.right)) && (i || pn(n, s.top, s.bottom));
}
function BL(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function UL(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function el(e, t, n = {}) {
  const r = e.x !== n.x ? -t : 0, a = e.y !== n.y ? -t : 0, i = (e.x + e.w !== n.x + n.w ? t : 0) - r, o = (e.y + e.h !== n.y + n.h ? t : 0) - a;
  return {
    x: e.x + r,
    y: e.y + a,
    w: e.w + i,
    h: e.h + o,
    radius: e.radius
  };
}
class Io extends wn {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: a } } = this, { inner: i, outer: o } = $L(this), s = BL(o.radius) ? ai : UL;
    t.save(), (o.w !== i.w || o.h !== i.h) && (t.beginPath(), s(t, el(o, n, i)), t.clip(), s(t, el(i, -n, o)), t.fillStyle = r, t.fill("evenodd")), t.beginPath(), s(t, el(i, n)), t.fillStyle = a, t.fill(), t.restore();
  }
  inRange(t, n, r) {
    return Js(this, t, n, r);
  }
  inXRange(t, n) {
    return Js(this, t, null, n);
  }
  inYRange(t, n) {
    return Js(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: r, base: a, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: i ? (n + a) / 2 : n,
      y: i ? r : (r + a) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
z(Io, "id", "bar"), z(Io, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), z(Io, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var GL = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: Ba,
  BarElement: Io,
  LineElement: Ln,
  PointElement: No
});
const Yp = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], Cb = /* @__PURE__ */ Yp.map((e) => e.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function PR(e) {
  return Yp[e % Yp.length];
}
function FR(e) {
  return Cb[e % Cb.length];
}
function HL(e, t) {
  return e.borderColor = PR(t), e.backgroundColor = FR(t), ++t;
}
function zL(e, t) {
  return e.backgroundColor = e.data.map(() => PR(t++)), t;
}
function WL(e, t) {
  return e.backgroundColor = e.data.map(() => FR(t++)), t;
}
function qL(e) {
  let t = 0;
  return (n, r) => {
    const a = e.getDatasetMeta(r).controller;
    a instanceof pr ? t = zL(n, t) : a instanceof Za ? t = WL(n, t) : a && (t = HL(n, t));
  };
}
function Nb(e) {
  let t;
  for (t in e)
    if (e[t].borderColor || e[t].backgroundColor)
      return !0;
  return !1;
}
function VL(e) {
  return e && (e.borderColor || e.backgroundColor);
}
function jL() {
  return Le.borderColor !== "rgba(0,0,0,0.1)" || Le.backgroundColor !== "rgba(0,0,0,0.1)";
}
var YL = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(e, t, n) {
    if (!n.enabled)
      return;
    const { data: { datasets: r }, options: a } = e.config, { elements: i } = a, o = Nb(r) || VL(a) || i && Nb(i) || jL();
    if (!n.forceOverride && o)
      return;
    const s = qL(e);
    r.forEach(s);
  }
};
function KL(e, t, n, r, a) {
  const i = a.samples || r;
  if (i >= n)
    return e.slice(t, t + n);
  const o = [], s = (n - 2) / (i - 2);
  let l = 0;
  const c = t + n - 1;
  let u = t, d, f, g, h, p;
  for (o[l++] = e[u], d = 0; d < i - 2; d++) {
    let m = 0, v = 0, y;
    const E = Math.floor((d + 1) * s) + 1 + t, S = Math.min(Math.floor((d + 2) * s) + 1, n) + t, w = S - E;
    for (y = E; y < S; y++)
      m += e[y].x, v += e[y].y;
    m /= w, v /= w;
    const R = Math.floor(d * s) + 1 + t, T = Math.min(Math.floor((d + 1) * s) + 1, n) + t, { x: A, y: C } = e[u];
    for (g = h = -1, y = R; y < T; y++)
      h = 0.5 * Math.abs((A - m) * (e[y].y - C) - (A - e[y].x) * (v - C)), h > g && (g = h, f = e[y], p = y);
    o[l++] = f, u = p;
  }
  return o[l++] = e[c], o;
}
function XL(e, t, n, r) {
  let a = 0, i = 0, o, s, l, c, u, d, f, g, h, p;
  const m = [], v = t + n - 1, y = e[t].x, S = e[v].x - y;
  for (o = t; o < t + n; ++o) {
    s = e[o], l = (s.x - y) / S * r, c = s.y;
    const w = l | 0;
    if (w === u)
      c < h ? (h = c, d = o) : c > p && (p = c, f = o), a = (i * a + s.x) / ++i;
    else {
      const R = o - 1;
      if (!fe(d) && !fe(f)) {
        const T = Math.min(d, f), A = Math.max(d, f);
        T !== g && T !== R && m.push({
          ...e[T],
          x: a
        }), A !== g && A !== R && m.push({
          ...e[A],
          x: a
        });
      }
      o > 0 && R !== g && m.push(e[R]), m.push(s), u = w, i = 0, h = p = c, d = f = g = o;
    }
  }
  return m;
}
function $R(e) {
  if (e._decimated) {
    const t = e._data;
    delete e._decimated, delete e._data, Object.defineProperty(e, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function Ib(e) {
  e.data.datasets.forEach((t) => {
    $R(t);
  });
}
function ZL(e, t) {
  const n = t.length;
  let r = 0, a;
  const { iScale: i } = e, { min: o, max: s, minDefined: l, maxDefined: c } = i.getUserBounds();
  return l && (r = Ze(gn(t, i.axis, o).lo, 0, n - 1)), c ? a = Ze(gn(t, i.axis, s).hi + 1, r, n) - r : a = n - r, {
    start: r,
    count: a
  };
}
var QL = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (e, t, n) => {
    if (!n.enabled) {
      Ib(e);
      return;
    }
    const r = e.width;
    e.data.datasets.forEach((a, i) => {
      const { _data: o, indexAxis: s } = a, l = e.getDatasetMeta(i), c = o || a.data;
      if (Fa([
        s,
        e.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const u = e.scales[l.xAxisID];
      if (u.type !== "linear" && u.type !== "time" || e.options.parsing)
        return;
      let { start: d, count: f } = ZL(l, c);
      const g = n.threshold || 4 * r;
      if (f <= g) {
        $R(a);
        return;
      }
      fe(o) && (a._data = c, delete a.data, Object.defineProperty(a, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(p) {
          this._data = p;
        }
      }));
      let h;
      switch (n.algorithm) {
        case "lttb":
          h = KL(c, d, f, r, n);
          break;
        case "min-max":
          h = XL(c, d, f, r);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`);
      }
      a._decimated = h;
    });
  },
  destroy(e) {
    Ib(e);
  }
};
function JL(e, t, n) {
  const r = e.segments, a = e.points, i = t.points, o = [];
  for (const s of r) {
    let { start: l, end: c } = s;
    c = ih(l, c, a);
    const u = Kp(n, a[l], a[c], s.loop);
    if (!t.segments) {
      o.push({
        source: s,
        target: u,
        start: a[l],
        end: a[c]
      });
      continue;
    }
    const d = ER(t, u);
    for (const f of d) {
      const g = Kp(n, i[f.start], i[f.end], f.loop), h = yR(s, a, g);
      for (const p of h)
        o.push({
          source: p,
          target: f,
          start: {
            [n]: kb(u, g, "start", Math.max)
          },
          end: {
            [n]: kb(u, g, "end", Math.min)
          }
        });
    }
  }
  return o;
}
function Kp(e, t, n, r) {
  if (r)
    return;
  let a = t[e], i = n[e];
  return e === "angle" && (a = wt(a), i = wt(i)), {
    property: e,
    start: a,
    end: i
  };
}
function e1(e, t) {
  const { x: n = null, y: r = null } = e || {}, a = t.points, i = [];
  return t.segments.forEach(({ start: o, end: s }) => {
    s = ih(o, s, a);
    const l = a[o], c = a[s];
    r !== null ? (i.push({
      x: l.x,
      y: r
    }), i.push({
      x: c.x,
      y: r
    })) : n !== null && (i.push({
      x: n,
      y: l.y
    }), i.push({
      x: n,
      y: c.y
    }));
  }), i;
}
function ih(e, t, n) {
  for (; t > e; t--) {
    const r = n[t];
    if (!isNaN(r.x) && !isNaN(r.y))
      break;
  }
  return t;
}
function kb(e, t, n, r) {
  return e && t ? r(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function BR(e, t) {
  let n = [], r = !1;
  return De(e) ? (r = !0, n = e) : n = e1(e, t), n.length ? new Ln({
    points: n,
    options: {
      tension: 0
    },
    _loop: r,
    _fullLoop: r
  }) : null;
}
function Ob(e) {
  return e && e.fill !== !1;
}
function t1(e, t, n) {
  let a = e[t].fill;
  const i = [
    t
  ];
  let o;
  if (!n)
    return a;
  for (; a !== !1 && i.indexOf(a) === -1; ) {
    if (!Fe(a))
      return a;
    if (o = e[a], !o)
      return !1;
    if (o.visible)
      return a;
    i.push(a), a = o.fill;
  }
  return !1;
}
function n1(e, t, n) {
  const r = o1(e);
  if (ue(r))
    return isNaN(r.value) ? !1 : r;
  let a = parseFloat(r);
  return Fe(a) && Math.floor(a) === a ? r1(r[0], t, a, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(r) >= 0 && r;
}
function r1(e, t, n, r) {
  return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= r ? !1 : n;
}
function a1(e, t) {
  let n = null;
  return e === "start" ? n = t.bottom : e === "end" ? n = t.top : ue(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function i1(e, t, n) {
  let r;
  return e === "start" ? r = n : e === "end" ? r = t.options.reverse ? t.min : t.max : ue(e) ? r = e.value : r = t.getBaseValue(), r;
}
function o1(e) {
  const t = e.options, n = t.fill;
  let r = se(n && n.target, n);
  return r === void 0 && (r = !!t.backgroundColor), r === !1 || r === null ? !1 : r === !0 ? "origin" : r;
}
function s1(e) {
  const { scale: t, index: n, line: r } = e, a = [], i = r.segments, o = r.points, s = l1(t, n);
  s.push(BR({
    x: null,
    y: t.bottom
  }, r));
  for (let l = 0; l < i.length; l++) {
    const c = i[l];
    for (let u = c.start; u <= c.end; u++)
      c1(a, o[u], s);
  }
  return new Ln({
    points: a,
    options: {}
  });
}
function l1(e, t) {
  const n = [], r = e.getMatchingVisibleMetas("line");
  for (let a = 0; a < r.length; a++) {
    const i = r[a];
    if (i.index === t)
      break;
    i.hidden || n.unshift(i.dataset);
  }
  return n;
}
function c1(e, t, n) {
  const r = [];
  for (let a = 0; a < n.length; a++) {
    const i = n[a], { first: o, last: s, point: l } = u1(i, t, "x");
    if (!(!l || o && s)) {
      if (o)
        r.unshift(l);
      else if (e.push(l), !s)
        break;
    }
  }
  e.push(...r);
}
function u1(e, t, n) {
  const r = e.interpolate(t, n);
  if (!r)
    return {};
  const a = r[n], i = e.segments, o = e.points;
  let s = !1, l = !1;
  for (let c = 0; c < i.length; c++) {
    const u = i[c], d = o[u.start][n], f = o[u.end][n];
    if (pn(a, d, f)) {
      s = a === d, l = a === f;
      break;
    }
  }
  return {
    first: s,
    last: l,
    point: r
  };
}
class UR {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, n, r) {
    const { x: a, y: i, radius: o } = this;
    return n = n || {
      start: 0,
      end: ke
    }, t.arc(a, i, o, n.end, n.start, !0), !r.bounds;
  }
  interpolate(t) {
    const { x: n, y: r, radius: a } = this, i = t.angle;
    return {
      x: n + Math.cos(i) * a,
      y: r + Math.sin(i) * a,
      angle: i
    };
  }
}
function d1(e) {
  const { chart: t, fill: n, line: r } = e;
  if (Fe(n))
    return f1(t, n);
  if (n === "stack")
    return s1(e);
  if (n === "shape")
    return !0;
  const a = p1(e);
  return a instanceof UR ? a : BR(a, r);
}
function f1(e, t) {
  const n = e.getDatasetMeta(t);
  return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function p1(e) {
  return (e.scale || {}).getPointPositionForValue ? h1(e) : g1(e);
}
function g1(e) {
  const { scale: t = {}, fill: n } = e, r = a1(n, t);
  if (Fe(r)) {
    const a = t.isHorizontal();
    return {
      x: a ? r : null,
      y: a ? null : r
    };
  }
  return null;
}
function h1(e) {
  const { scale: t, fill: n } = e, r = t.options, a = t.getLabels().length, i = r.reverse ? t.max : t.min, o = i1(n, t, i), s = [];
  if (r.grid.circular) {
    const l = t.getPointPositionForValue(0, i);
    return new UR({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(o)
    });
  }
  for (let l = 0; l < a; ++l)
    s.push(t.getPointPositionForValue(l, o));
  return s;
}
function tl(e, t, n) {
  const r = d1(t), { line: a, scale: i, axis: o } = t, s = a.options, l = s.fill, c = s.backgroundColor, { above: u = c, below: d = c } = l || {};
  r && a.points.length && (us(e, n), m1(e, {
    line: a,
    target: r,
    above: u,
    below: d,
    area: n,
    scale: i,
    axis: o
  }), ds(e));
}
function m1(e, t) {
  const { line: n, target: r, above: a, below: i, area: o, scale: s } = t, l = n._loop ? "angle" : t.axis;
  e.save(), l === "x" && i !== a && (Db(e, r, o.top), Lb(e, {
    line: n,
    target: r,
    color: a,
    scale: s,
    property: l
  }), e.restore(), e.save(), Db(e, r, o.bottom)), Lb(e, {
    line: n,
    target: r,
    color: i,
    scale: s,
    property: l
  }), e.restore();
}
function Db(e, t, n) {
  const { segments: r, points: a } = t;
  let i = !0, o = !1;
  e.beginPath();
  for (const s of r) {
    const { start: l, end: c } = s, u = a[l], d = a[ih(l, c, a)];
    i ? (e.moveTo(u.x, u.y), i = !1) : (e.lineTo(u.x, n), e.lineTo(u.x, u.y)), o = !!t.pathSegment(e, s, {
      move: o
    }), o ? e.closePath() : e.lineTo(d.x, n);
  }
  e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function Lb(e, t) {
  const { line: n, target: r, property: a, color: i, scale: o } = t, s = JL(n, r, a);
  for (const { source: l, target: c, start: u, end: d } of s) {
    const { style: { backgroundColor: f = i } = {} } = l, g = r !== !0;
    e.save(), e.fillStyle = f, b1(e, o, g && Kp(a, u, d)), e.beginPath();
    const h = !!n.pathSegment(e, l);
    let p;
    if (g) {
      h ? e.closePath() : Mb(e, r, d, a);
      const m = !!r.pathSegment(e, c, {
        move: h,
        reverse: !0
      });
      p = h && m, p || Mb(e, r, u, a);
    }
    e.closePath(), e.fill(p ? "evenodd" : "nonzero"), e.restore();
  }
}
function b1(e, t, n) {
  const { top: r, bottom: a } = t.chart.chartArea, { property: i, start: o, end: s } = n || {};
  i === "x" && (e.beginPath(), e.rect(o, r, s - o, a - r), e.clip());
}
function Mb(e, t, n, r) {
  const a = t.interpolate(n, r);
  a && e.lineTo(a.x, a.y);
}
var v1 = {
  id: "filler",
  afterDatasetsUpdate(e, t, n) {
    const r = (e.data.datasets || []).length, a = [];
    let i, o, s, l;
    for (o = 0; o < r; ++o)
      i = e.getDatasetMeta(o), s = i.dataset, l = null, s && s.options && s instanceof Ln && (l = {
        visible: e.isDatasetVisible(o),
        index: o,
        fill: n1(s, o, r),
        chart: e,
        axis: i.controller.options.indexAxis,
        scale: i.vScale,
        line: s
      }), i.$filler = l, a.push(l);
    for (o = 0; o < r; ++o)
      l = a[o], !(!l || l.fill === !1) && (l.fill = t1(a, o, n.propagate));
  },
  beforeDraw(e, t, n) {
    const r = n.drawTime === "beforeDraw", a = e.getSortedVisibleDatasetMetas(), i = e.chartArea;
    for (let o = a.length - 1; o >= 0; --o) {
      const s = a[o].$filler;
      s && (s.line.updateControlPoints(i, s.axis), r && s.fill && tl(e.ctx, s, i));
    }
  },
  beforeDatasetsDraw(e, t, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const r = e.getSortedVisibleDatasetMetas();
    for (let a = r.length - 1; a >= 0; --a) {
      const i = r[a].$filler;
      Ob(i) && tl(e.ctx, i, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, n) {
    const r = t.meta.$filler;
    !Ob(r) || n.drawTime !== "beforeDatasetDraw" || tl(e.ctx, r, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const Pb = (e, t) => {
  let { boxHeight: n = t, boxWidth: r = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), r = e.pointStyleWidth || Math.min(r, t)), {
    boxWidth: r,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, y1 = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
let Fb = class extends wn {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, r) {
    this.maxWidth = t, this.maxHeight = n, this._margins = r, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = Ae(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (n = n.filter((r) => t.filter(r, this.chart.data))), t.sort && (n = n.sort((r, a) => t.sort(r, a, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const r = t.labels, a = je(r.font), i = a.size, o = this._computeTitleHeight(), { boxWidth: s, itemHeight: l } = Pb(r, i);
    let c, u;
    n.font = a.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(o, i, s, l) + 10) : (u = this.maxHeight, c = this._fitCols(o, a, s, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(u, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, r, a) {
    const { ctx: i, maxWidth: o, options: { labels: { padding: s } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = a + s;
    let d = t;
    i.textAlign = "left", i.textBaseline = "middle";
    let f = -1, g = -u;
    return this.legendItems.forEach((h, p) => {
      const m = r + n / 2 + i.measureText(h.text).width;
      (p === 0 || c[c.length - 1] + m + 2 * s > o) && (d += u, c[c.length - (p > 0 ? 0 : 1)] = 0, g += u, f++), l[p] = {
        left: 0,
        top: g,
        row: f,
        width: m,
        height: a
      }, c[c.length - 1] += m + s;
    }), d;
  }
  _fitCols(t, n, r, a) {
    const { ctx: i, maxHeight: o, options: { labels: { padding: s } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = o - t;
    let d = s, f = 0, g = 0, h = 0, p = 0;
    return this.legendItems.forEach((m, v) => {
      const { itemWidth: y, itemHeight: E } = E1(r, n, i, m, a);
      v > 0 && g + E + 2 * s > u && (d += f + s, c.push({
        width: f,
        height: g
      }), h += f + s, p++, f = g = 0), l[v] = {
        left: h,
        top: g,
        col: p,
        width: y,
        height: E
      }, f = Math.max(f, y), g += E + s;
    }), d += f, c.push({
      width: f,
      height: g
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: r, labels: { padding: a }, rtl: i } } = this, o = Yr(i, this.left, this.width);
    if (this.isHorizontal()) {
      let s = 0, l = nt(r, this.left + a, this.right - this.lineWidths[s]);
      for (const c of n)
        s !== c.row && (s = c.row, l = nt(r, this.left + a, this.right - this.lineWidths[s])), c.top += this.top + t + a, c.left = o.leftForLtr(o.x(l), c.width), l += c.width + a;
    } else {
      let s = 0, l = nt(r, this.top + t + a, this.bottom - this.columnSizes[s].height);
      for (const c of n)
        c.col !== s && (s = c.col, l = nt(r, this.top + t + a, this.bottom - this.columnSizes[s].height)), c.top = l, c.left += this.left + a, c.left = o.leftForLtr(o.x(c.left), c.width), l += c.height + a;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      us(t, this), this._draw(), ds(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: r, ctx: a } = this, { align: i, labels: o } = t, s = Le.color, l = Yr(t.rtl, this.left, this.width), c = je(o.font), { padding: u } = o, d = c.size, f = d / 2;
    let g;
    this.drawTitle(), a.textAlign = l.textAlign("left"), a.textBaseline = "middle", a.lineWidth = 0.5, a.font = c.string;
    const { boxWidth: h, boxHeight: p, itemHeight: m } = Pb(o, d), v = function(R, T, A) {
      if (isNaN(h) || h <= 0 || isNaN(p) || p < 0)
        return;
      a.save();
      const C = se(A.lineWidth, 1);
      if (a.fillStyle = se(A.fillStyle, s), a.lineCap = se(A.lineCap, "butt"), a.lineDashOffset = se(A.lineDashOffset, 0), a.lineJoin = se(A.lineJoin, "miter"), a.lineWidth = C, a.strokeStyle = se(A.strokeStyle, s), a.setLineDash(se(A.lineDash, [])), o.usePointStyle) {
        const N = {
          radius: p * Math.SQRT2 / 2,
          pointStyle: A.pointStyle,
          rotation: A.rotation,
          borderWidth: C
        }, L = l.xPlus(R, h / 2), I = T + f;
        lR(a, N, L, I, o.pointStyleWidth && h);
      } else {
        const N = T + Math.max((d - p) / 2, 0), L = l.leftForLtr(R, h), I = gr(A.borderRadius);
        a.beginPath(), Object.values(I).some((k) => k !== 0) ? ai(a, {
          x: L,
          y: N,
          w: h,
          h: p,
          radius: I
        }) : a.rect(L, N, h, p), a.fill(), C !== 0 && a.stroke();
      }
      a.restore();
    }, y = function(R, T, A) {
      vr(a, A.text, R, T + m / 2, c, {
        strikethrough: A.hidden,
        textAlign: l.textAlign(A.textAlign)
      });
    }, E = this.isHorizontal(), S = this._computeTitleHeight();
    E ? g = {
      x: nt(i, this.left + u, this.right - r[0]),
      y: this.top + u + S,
      line: 0
    } : g = {
      x: this.left + u,
      y: nt(i, this.top + S + u, this.bottom - n[0].height),
      line: 0
    }, mR(this.ctx, t.textDirection);
    const w = m + u;
    this.legendItems.forEach((R, T) => {
      a.strokeStyle = R.fontColor, a.fillStyle = R.fontColor;
      const A = a.measureText(R.text).width, C = l.textAlign(R.textAlign || (R.textAlign = o.textAlign)), N = h + f + A;
      let L = g.x, I = g.y;
      l.setWidth(this.width), E ? T > 0 && L + N + u > this.right && (I = g.y += w, g.line++, L = g.x = nt(i, this.left + u, this.right - r[g.line])) : T > 0 && I + w > this.bottom && (L = g.x = L + n[g.line].width + u, g.line++, I = g.y = nt(i, this.top + S + u, this.bottom - n[g.line].height));
      const k = l.x(L);
      if (v(k, I, R), L = U0(C, L + h + f, E ? L + N : this.right, t.rtl), y(l.x(L), I, R), E)
        g.x += N + u;
      else if (typeof R.text != "string") {
        const B = c.lineHeight;
        g.y += GR(R, B) + u;
      } else
        g.y += w;
    }), bR(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, r = je(n.font), a = it(n.padding);
    if (!n.display)
      return;
    const i = Yr(t.rtl, this.left, this.width), o = this.ctx, s = n.position, l = r.size / 2, c = a.top + l;
    let u, d = this.left, f = this.width;
    if (this.isHorizontal())
      f = Math.max(...this.lineWidths), u = this.top + c, d = nt(t.align, d, this.right - f);
    else {
      const h = this.columnSizes.reduce((p, m) => Math.max(p, m.height), 0);
      u = c + nt(t.align, this.top, this.bottom - h - t.labels.padding - this._computeTitleHeight());
    }
    const g = nt(s, d, d + f);
    o.textAlign = i.textAlign(Xg(s)), o.textBaseline = "middle", o.strokeStyle = n.color, o.fillStyle = n.color, o.font = r.string, vr(o, n.text, g, u, r);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = je(t.font), r = it(t.padding);
    return t.display ? n.lineHeight + r.height : 0;
  }
  _getLegendItemAt(t, n) {
    let r, a, i;
    if (pn(t, this.left, this.right) && pn(n, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, r = 0; r < i.length; ++r)
        if (a = i[r], pn(t, a.left, a.left + a.width) && pn(n, a.top, a.top + a.height))
          return this.legendItems[r];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!_1(t.type, n))
      return;
    const r = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const a = this._hoveredItem, i = y1(a, r);
      a && !i && Ae(n.onLeave, [
        t,
        a,
        this
      ], this), this._hoveredItem = r, r && !i && Ae(n.onHover, [
        t,
        r,
        this
      ], this);
    } else r && Ae(n.onClick, [
      t,
      r,
      this
    ], this);
  }
};
function E1(e, t, n, r, a) {
  const i = S1(r, e, t, n), o = w1(a, r, t.lineHeight);
  return {
    itemWidth: i,
    itemHeight: o
  };
}
function S1(e, t, n, r) {
  let a = e.text;
  return a && typeof a != "string" && (a = a.reduce((i, o) => i.length > o.length ? i : o)), t + n.size / 2 + r.measureText(a).width;
}
function w1(e, t, n) {
  let r = e;
  return typeof t.text != "string" && (r = GR(t, n)), r;
}
function GR(e, t) {
  const n = e.text ? e.text.length : 0;
  return t * n;
}
function _1(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var T1 = {
  id: "legend",
  _element: Fb,
  start(e, t, n) {
    const r = e.legend = new Fb({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    rt.configure(e, r, n), rt.addBox(e, r);
  },
  stop(e) {
    rt.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const r = e.legend;
    rt.configure(e, r, n), r.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const r = t.datasetIndex, a = n.chart;
      a.isDatasetVisible(r) ? (a.hide(r), t.hidden = !0) : (a.show(r), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: r, textAlign: a, color: i, useBorderRadius: o, borderRadius: s } } = e.legend.options;
        return e._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(n ? 0 : void 0), u = it(c.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: i,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: r || c.pointStyle,
            rotation: c.rotation,
            textAlign: a || c.textAlign,
            borderRadius: o && (s || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
let oh = class extends wn {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n) {
    const r = this.options;
    if (this.left = 0, this.top = 0, !r.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = n;
    const a = De(r.text) ? r.text.length : 1;
    this._padding = it(r.padding);
    const i = a * je(r.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = i : this.width = i;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: n, left: r, bottom: a, right: i, options: o } = this, s = o.align;
    let l = 0, c, u, d;
    return this.isHorizontal() ? (u = nt(s, r, i), d = n + t, c = i - r) : (o.position === "left" ? (u = r + t, d = nt(s, a, n), l = Oe * -0.5) : (u = i - t, d = nt(s, n, a), l = Oe * 0.5), c = a - n), {
      titleX: u,
      titleY: d,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, n = this.options;
    if (!n.display)
      return;
    const r = je(n.font), i = r.lineHeight / 2 + this._padding.top, { titleX: o, titleY: s, maxWidth: l, rotation: c } = this._drawArgs(i);
    vr(t, n.text, 0, 0, r, {
      color: n.color,
      maxWidth: l,
      rotation: c,
      textAlign: Xg(n.align),
      textBaseline: "middle",
      translation: [
        o,
        s
      ]
    });
  }
};
function R1(e, t) {
  const n = new oh({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  rt.configure(e, n, t), rt.addBox(e, n), e.titleBlock = n;
}
var A1 = {
  id: "title",
  _element: oh,
  start(e, t, n) {
    R1(e, n);
  },
  stop(e) {
    const t = e.titleBlock;
    rt.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, n) {
    const r = e.titleBlock;
    rt.configure(e, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Zi = /* @__PURE__ */ new WeakMap();
var x1 = {
  id: "subtitle",
  start(e, t, n) {
    const r = new oh({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    rt.configure(e, r, n), rt.addBox(e, r), Zi.set(e, r);
  },
  stop(e) {
    rt.removeBox(e, Zi.get(e)), Zi.delete(e);
  },
  beforeUpdate(e, t, n) {
    const r = Zi.get(e);
    rt.configure(e, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Ua = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, r = /* @__PURE__ */ new Set(), a = 0, i = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const s = e[t].element;
      if (s && s.hasValue()) {
        const l = s.tooltipPosition();
        r.add(l.x), a += l.y, ++i;
      }
    }
    return i === 0 || r.size === 0 ? !1 : {
      x: [
        ...r
      ].reduce((s, l) => s + l) / r.size,
      y: a / i
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, r = t.y, a = Number.POSITIVE_INFINITY, i, o, s;
    for (i = 0, o = e.length; i < o; ++i) {
      const l = e[i].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = Gp(t, c);
        u < a && (a = u, s = l);
      }
    }
    if (s) {
      const l = s.tooltipPosition();
      n = l.x, r = l.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function jt(e, t) {
  return t && (De(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function un(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function C1(e, t) {
  const { element: n, datasetIndex: r, index: a } = t, i = e.getDatasetMeta(r).controller, { label: o, value: s } = i.getLabelAndValue(a);
  return {
    chart: e,
    label: o,
    parsed: i.getParsed(a),
    raw: e.data.datasets[r].data[a],
    formattedValue: s,
    dataset: i.getDataset(),
    dataIndex: a,
    datasetIndex: r,
    element: n
  };
}
function $b(e, t) {
  const n = e.chart.ctx, { body: r, footer: a, title: i } = e, { boxWidth: o, boxHeight: s } = t, l = je(t.bodyFont), c = je(t.titleFont), u = je(t.footerFont), d = i.length, f = a.length, g = r.length, h = it(t.padding);
  let p = h.height, m = 0, v = r.reduce((S, w) => S + w.before.length + w.lines.length + w.after.length, 0);
  if (v += e.beforeBody.length + e.afterBody.length, d && (p += d * c.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), v) {
    const S = t.displayColors ? Math.max(s, l.lineHeight) : l.lineHeight;
    p += g * S + (v - g) * l.lineHeight + (v - 1) * t.bodySpacing;
  }
  f && (p += t.footerMarginTop + f * u.lineHeight + (f - 1) * t.footerSpacing);
  let y = 0;
  const E = function(S) {
    m = Math.max(m, n.measureText(S).width + y);
  };
  return n.save(), n.font = c.string, ve(e.title, E), n.font = l.string, ve(e.beforeBody.concat(e.afterBody), E), y = t.displayColors ? o + 2 + t.boxPadding : 0, ve(r, (S) => {
    ve(S.before, E), ve(S.lines, E), ve(S.after, E);
  }), y = 0, n.font = u.string, ve(e.footer, E), n.restore(), m += h.width, {
    width: m,
    height: p
  };
}
function N1(e, t) {
  const { y: n, height: r } = t;
  return n < r / 2 ? "top" : n > e.height - r / 2 ? "bottom" : "center";
}
function I1(e, t, n, r) {
  const { x: a, width: i } = r, o = n.caretSize + n.caretPadding;
  if (e === "left" && a + i + o > t.width || e === "right" && a - i - o < 0)
    return !0;
}
function k1(e, t, n, r) {
  const { x: a, width: i } = n, { width: o, chartArea: { left: s, right: l } } = e;
  let c = "center";
  return r === "center" ? c = a <= (s + l) / 2 ? "left" : "right" : a <= i / 2 ? c = "left" : a >= o - i / 2 && (c = "right"), I1(c, e, t, n) && (c = "center"), c;
}
function Bb(e, t, n) {
  const r = n.yAlign || t.yAlign || N1(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || k1(e, t, n, r),
    yAlign: r
  };
}
function O1(e, t) {
  let { x: n, width: r } = e;
  return t === "right" ? n -= r : t === "center" && (n -= r / 2), n;
}
function D1(e, t, n) {
  let { y: r, height: a } = e;
  return t === "top" ? r += n : t === "bottom" ? r -= a + n : r -= a / 2, r;
}
function Ub(e, t, n, r) {
  const { caretSize: a, caretPadding: i, cornerRadius: o } = e, { xAlign: s, yAlign: l } = n, c = a + i, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: g } = gr(o);
  let h = O1(t, s);
  const p = D1(t, l, c);
  return l === "center" ? s === "left" ? h += c : s === "right" && (h -= c) : s === "left" ? h -= Math.max(u, f) + a : s === "right" && (h += Math.max(d, g) + a), {
    x: Ze(h, 0, r.width - t.width),
    y: Ze(p, 0, r.height - t.height)
  };
}
function Qi(e, t, n) {
  const r = it(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - r.right : e.x + r.left;
}
function Gb(e) {
  return jt([], un(e));
}
function L1(e, t, n) {
  return Vn(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function Hb(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const HR = {
  beforeTitle: on,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, r = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (r > 0 && t.dataIndex < r)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: on,
  beforeBody: on,
  beforeLabel: on,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return fe(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: on,
  afterBody: on,
  beforeFooter: on,
  footer: on,
  afterFooter: on
};
function ft(e, t, n, r) {
  const a = e[t].call(n, r);
  return typeof a > "u" ? HR[t].call(n, r) : a;
}
class Xp extends wn {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, r = this.options.setContext(this.getContext()), a = r.enabled && n.options.animation && r.animations, i = new SR(this.chart, a);
    return a._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = L1(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: r } = n, a = ft(r, "beforeTitle", this, t), i = ft(r, "title", this, t), o = ft(r, "afterTitle", this, t);
    let s = [];
    return s = jt(s, un(a)), s = jt(s, un(i)), s = jt(s, un(o)), s;
  }
  getBeforeBody(t, n) {
    return Gb(ft(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: r } = n, a = [];
    return ve(t, (i) => {
      const o = {
        before: [],
        lines: [],
        after: []
      }, s = Hb(r, i);
      jt(o.before, un(ft(s, "beforeLabel", this, i))), jt(o.lines, ft(s, "label", this, i)), jt(o.after, un(ft(s, "afterLabel", this, i))), a.push(o);
    }), a;
  }
  getAfterBody(t, n) {
    return Gb(ft(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: r } = n, a = ft(r, "beforeFooter", this, t), i = ft(r, "footer", this, t), o = ft(r, "afterFooter", this, t);
    let s = [];
    return s = jt(s, un(a)), s = jt(s, un(i)), s = jt(s, un(o)), s;
  }
  _createItems(t) {
    const n = this._active, r = this.chart.data, a = [], i = [], o = [];
    let s = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      s.push(C1(this.chart, n[l]));
    return t.filter && (s = s.filter((u, d, f) => t.filter(u, d, f, r))), t.itemSort && (s = s.sort((u, d) => t.itemSort(u, d, r))), ve(s, (u) => {
      const d = Hb(t.callbacks, u);
      a.push(ft(d, "labelColor", this, u)), i.push(ft(d, "labelPointStyle", this, u)), o.push(ft(d, "labelTextColor", this, u));
    }), this.labelColors = a, this.labelPointStyles = i, this.labelTextColors = o, this.dataPoints = s, s;
  }
  update(t, n) {
    const r = this.options.setContext(this.getContext()), a = this._active;
    let i, o = [];
    if (!a.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const s = Ua[r.position].call(this, a, this._eventPosition);
      o = this._createItems(r), this.title = this.getTitle(o, r), this.beforeBody = this.getBeforeBody(o, r), this.body = this.getBody(o, r), this.afterBody = this.getAfterBody(o, r), this.footer = this.getFooter(o, r);
      const l = this._size = $b(this, r), c = Object.assign({}, s, l), u = Bb(this.chart, r, c), d = Ub(r, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, i = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: s.x,
        caretY: s.y
      };
    }
    this._tooltipItems = o, this.$context = void 0, i && this._resolveAnimations().update(this, i), t && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, r, a) {
    const i = this.getCaretPosition(t, r, a);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(t, n, r) {
    const { xAlign: a, yAlign: i } = this, { caretSize: o, cornerRadius: s } = r, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = gr(s), { x: f, y: g } = t, { width: h, height: p } = n;
    let m, v, y, E, S, w;
    return i === "center" ? (S = g + p / 2, a === "left" ? (m = f, v = m - o, E = S + o, w = S - o) : (m = f + h, v = m + o, E = S - o, w = S + o), y = m) : (a === "left" ? v = f + Math.max(l, u) + o : a === "right" ? v = f + h - Math.max(c, d) - o : v = this.caretX, i === "top" ? (E = g, S = E - o, m = v - o, y = v + o) : (E = g + p, S = E + o, m = v + o, y = v - o), w = E), {
      x1: m,
      x2: v,
      x3: y,
      y1: E,
      y2: S,
      y3: w
    };
  }
  drawTitle(t, n, r) {
    const a = this.title, i = a.length;
    let o, s, l;
    if (i) {
      const c = Yr(r.rtl, this.x, this.width);
      for (t.x = Qi(this, r.titleAlign, r), n.textAlign = c.textAlign(r.titleAlign), n.textBaseline = "middle", o = je(r.titleFont), s = r.titleSpacing, n.fillStyle = r.titleColor, n.font = o.string, l = 0; l < i; ++l)
        n.fillText(a[l], c.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + s, l + 1 === i && (t.y += r.titleMarginBottom - s);
    }
  }
  _drawColorBox(t, n, r, a, i) {
    const o = this.labelColors[r], s = this.labelPointStyles[r], { boxHeight: l, boxWidth: c } = i, u = je(i.bodyFont), d = Qi(this, "left", i), f = a.x(d), g = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, h = n.y + g;
    if (i.usePointStyle) {
      const p = {
        radius: Math.min(c, l) / 2,
        pointStyle: s.pointStyle,
        rotation: s.rotation,
        borderWidth: 1
      }, m = a.leftForLtr(f, c) + c / 2, v = h + l / 2;
      t.strokeStyle = i.multiKeyBackground, t.fillStyle = i.multiKeyBackground, zp(t, p, m, v), t.strokeStyle = o.borderColor, t.fillStyle = o.backgroundColor, zp(t, p, m, v);
    } else {
      t.lineWidth = ue(o.borderWidth) ? Math.max(...Object.values(o.borderWidth)) : o.borderWidth || 1, t.strokeStyle = o.borderColor, t.setLineDash(o.borderDash || []), t.lineDashOffset = o.borderDashOffset || 0;
      const p = a.leftForLtr(f, c), m = a.leftForLtr(a.xPlus(f, 1), c - 2), v = gr(o.borderRadius);
      Object.values(v).some((y) => y !== 0) ? (t.beginPath(), t.fillStyle = i.multiKeyBackground, ai(t, {
        x: p,
        y: h,
        w: c,
        h: l,
        radius: v
      }), t.fill(), t.stroke(), t.fillStyle = o.backgroundColor, t.beginPath(), ai(t, {
        x: m,
        y: h + 1,
        w: c - 2,
        h: l - 2,
        radius: v
      }), t.fill()) : (t.fillStyle = i.multiKeyBackground, t.fillRect(p, h, c, l), t.strokeRect(p, h, c, l), t.fillStyle = o.backgroundColor, t.fillRect(m, h + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[r];
  }
  drawBody(t, n, r) {
    const { body: a } = this, { bodySpacing: i, bodyAlign: o, displayColors: s, boxHeight: l, boxWidth: c, boxPadding: u } = r, d = je(r.bodyFont);
    let f = d.lineHeight, g = 0;
    const h = Yr(r.rtl, this.x, this.width), p = function(A) {
      n.fillText(A, h.x(t.x + g), t.y + f / 2), t.y += f + i;
    }, m = h.textAlign(o);
    let v, y, E, S, w, R, T;
    for (n.textAlign = o, n.textBaseline = "middle", n.font = d.string, t.x = Qi(this, m, r), n.fillStyle = r.bodyColor, ve(this.beforeBody, p), g = s && m !== "right" ? o === "center" ? c / 2 + u : c + 2 + u : 0, S = 0, R = a.length; S < R; ++S) {
      for (v = a[S], y = this.labelTextColors[S], n.fillStyle = y, ve(v.before, p), E = v.lines, s && E.length && (this._drawColorBox(n, t, S, h, r), f = Math.max(d.lineHeight, l)), w = 0, T = E.length; w < T; ++w)
        p(E[w]), f = d.lineHeight;
      ve(v.after, p);
    }
    g = 0, f = d.lineHeight, ve(this.afterBody, p), t.y -= i;
  }
  drawFooter(t, n, r) {
    const a = this.footer, i = a.length;
    let o, s;
    if (i) {
      const l = Yr(r.rtl, this.x, this.width);
      for (t.x = Qi(this, r.footerAlign, r), t.y += r.footerMarginTop, n.textAlign = l.textAlign(r.footerAlign), n.textBaseline = "middle", o = je(r.footerFont), n.fillStyle = r.footerColor, n.font = o.string, s = 0; s < i; ++s)
        n.fillText(a[s], l.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(t, n, r, a) {
    const { xAlign: i, yAlign: o } = this, { x: s, y: l } = t, { width: c, height: u } = r, { topLeft: d, topRight: f, bottomLeft: g, bottomRight: h } = gr(a.cornerRadius);
    n.fillStyle = a.backgroundColor, n.strokeStyle = a.borderColor, n.lineWidth = a.borderWidth, n.beginPath(), n.moveTo(s + d, l), o === "top" && this.drawCaret(t, n, r, a), n.lineTo(s + c - f, l), n.quadraticCurveTo(s + c, l, s + c, l + f), o === "center" && i === "right" && this.drawCaret(t, n, r, a), n.lineTo(s + c, l + u - h), n.quadraticCurveTo(s + c, l + u, s + c - h, l + u), o === "bottom" && this.drawCaret(t, n, r, a), n.lineTo(s + g, l + u), n.quadraticCurveTo(s, l + u, s, l + u - g), o === "center" && i === "left" && this.drawCaret(t, n, r, a), n.lineTo(s, l + d), n.quadraticCurveTo(s, l, s + d, l), n.closePath(), n.fill(), a.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, r = this.$animations, a = r && r.x, i = r && r.y;
    if (a || i) {
      const o = Ua[t.position].call(this, this._active, this._eventPosition);
      if (!o)
        return;
      const s = this._size = $b(this, t), l = Object.assign({}, o, this._size), c = Bb(n, t, l), u = Ub(t, l, c, n);
      (a._to !== u.x || i._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = s.width, this.height = s.height, this.caretX = o.x, this.caretY = o.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const a = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const o = it(n.padding), s = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && s && (t.save(), t.globalAlpha = r, this.drawBackground(i, t, a, n), mR(t, n.textDirection), i.y += o.top, this.drawTitle(i, t, n), this.drawBody(i, t, n), this.drawFooter(i, t, n), bR(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const r = this._active, a = t.map(({ datasetIndex: s, index: l }) => {
      const c = this.chart.getDatasetMeta(s);
      if (!c)
        throw new Error("Cannot find a dataset at index " + s);
      return {
        datasetIndex: s,
        element: c.data[l],
        index: l
      };
    }), i = !Po(r, a), o = this._positionChanged(a, n);
    (i || o) && (this._active = a, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const a = this.options, i = this._active || [], o = this._getActiveElements(t, i, n, r), s = this._positionChanged(o, t), l = n || !Po(o, i) || s;
    return l && (this._active = o, (a.enabled || a.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(t, n, r, a) {
    const i = this.options;
    if (t.type === "mouseout")
      return [];
    if (!a)
      return n.filter((s) => this.chart.data.datasets[s.datasetIndex] && this.chart.getDatasetMeta(s.datasetIndex).controller.getParsed(s.index) !== void 0);
    const o = this.chart.getElementsAtEventForMode(t, i.mode, i, r);
    return i.reverse && o.reverse(), o;
  }
  _positionChanged(t, n) {
    const { caretX: r, caretY: a, options: i } = this, o = Ua[i.position].call(this, t, n);
    return o !== !1 && (r !== o.x || a !== o.y);
  }
}
z(Xp, "positioners", Ua);
var M1 = {
  id: "tooltip",
  _element: Xp,
  positioners: Ua,
  afterInit(e, t, n) {
    n && (e.tooltip = new Xp({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: HR
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, P1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: YL,
  Decimation: QL,
  Filler: v1,
  Legend: T1,
  SubTitle: x1,
  Title: A1,
  Tooltip: M1
});
const F1 = (e, t, n, r) => (typeof t == "string" ? (n = e.push(t) - 1, r.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function $1(e, t, n, r) {
  const a = e.indexOf(t);
  if (a === -1)
    return F1(e, t, n, r);
  const i = e.lastIndexOf(t);
  return a !== i ? n : a;
}
const B1 = (e, t) => e === null ? null : Ze(Math.round(e), 0, t);
function zb(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class Zp extends xr {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: a, label: i } of n)
        r[a] === i && r.splice(a, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (fe(t))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === t ? n : $1(r, t, se(n, t), this._addedLabels), B1(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: r, max: a } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (r = 0), n || (a = this.getLabels().length - 1)), this.min = r, this.max = a;
  }
  buildTicks() {
    const t = this.min, n = this.max, r = this.options.offset, a = [];
    let i = this.getLabels();
    i = t === 0 && n === i.length - 1 ? i : i.slice(t, n + 1), this._valueRange = Math.max(i.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let o = t; o <= n; o++)
      a.push({
        value: o
      });
    return a;
  }
  getLabelForValue(t) {
    return zb.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
z(Zp, "id", "category"), z(Zp, "defaults", {
  ticks: {
    callback: zb
  }
});
function U1(e, t) {
  const n = [], { bounds: a, step: i, min: o, max: s, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: f } = e, g = i || 1, h = u - 1, { min: p, max: m } = t, v = !fe(o), y = !fe(s), E = !fe(c), S = (m - p) / (d + 1);
  let w = $m((m - p) / h / g) * g, R, T, A, C;
  if (w < 1e-14 && !v && !y)
    return [
      {
        value: p
      },
      {
        value: m
      }
    ];
  C = Math.ceil(m / w) - Math.floor(p / w), C > h && (w = $m(C * w / h / g) * g), fe(l) || (R = Math.pow(10, l), w = Math.ceil(w * R) / R), a === "ticks" ? (T = Math.floor(p / w) * w, A = Math.ceil(m / w) * w) : (T = p, A = m), v && y && i && D0((s - o) / i, w / 1e3) ? (C = Math.round(Math.min((s - o) / w, u)), w = (s - o) / C, T = o, A = s) : E ? (T = v ? o : T, A = y ? s : A, C = c - 1, w = (A - T) / C) : (C = (A - T) / w, Ya(C, Math.round(C), w / 1e3) ? C = Math.round(C) : C = Math.ceil(C));
  const N = Math.max(Bm(w), Bm(T));
  R = Math.pow(10, fe(l) ? N : l), T = Math.round(T * R) / R, A = Math.round(A * R) / R;
  let L = 0;
  for (v && (f && T !== o ? (n.push({
    value: o
  }), T < o && L++, Ya(Math.round((T + L * w) * R) / R, o, Wb(o, S, e)) && L++) : T < o && L++); L < C; ++L) {
    const I = Math.round((T + L * w) * R) / R;
    if (y && I > s)
      break;
    n.push({
      value: I
    });
  }
  return y && f && A !== s ? n.length && Ya(n[n.length - 1].value, s, Wb(s, S, e)) ? n[n.length - 1].value = s : n.push({
    value: s
  }) : (!y || A === s) && n.push({
    value: A
  }), n;
}
function Wb(e, t, { horizontal: n, minRotation: r }) {
  const a = Pt(r), i = (n ? Math.sin(a) : Math.cos(a)) || 1e-3, o = 0.75 * t * ("" + e).length;
  return Math.min(t / i, o);
}
class zo extends xr {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return fe(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: a, max: i } = this;
    const o = (l) => a = n ? a : l, s = (l) => i = r ? i : l;
    if (t) {
      const l = Xt(a), c = Xt(i);
      l < 0 && c < 0 ? s(0) : l > 0 && c > 0 && o(0);
    }
    if (a === i) {
      let l = i === 0 ? 1 : Math.abs(i * 0.05);
      s(i + l), t || o(a - l);
    }
    this.min = a, this.max = i;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = t, a;
    return r ? (a = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, a > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${a} ticks. Limiting to 1000.`), a = 1e3)) : (a = this.computeTickLimit(), n = n || 11), n && (a = Math.min(n, a)), a;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const a = {
      maxTicks: r,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, o = U1(a, i);
    return t.bounds === "ticks" && JT(o, this, "value"), t.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const a = (r - n) / Math.max(t.length - 1, 1) / 2;
      n -= a, r += a;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(t) {
    return vi(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Qp extends zo {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Fe(t) ? t : 0, this.max = Fe(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, r = Pt(this.options.ticks.minRotation), a = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / a));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
z(Qp, "id", "linear"), z(Qp, "defaults", {
  ticks: {
    callback: cs.formatters.numeric
  }
});
const oi = (e) => Math.floor(Dn(e)), rr = (e, t) => Math.pow(10, oi(e) + t);
function qb(e) {
  return e / Math.pow(10, oi(e)) === 1;
}
function Vb(e, t, n) {
  const r = Math.pow(10, n), a = Math.floor(e / r);
  return Math.ceil(t / r) - a;
}
function G1(e, t) {
  const n = t - e;
  let r = oi(n);
  for (; Vb(e, t, r) > 10; )
    r++;
  for (; Vb(e, t, r) < 10; )
    r--;
  return Math.min(r, oi(e));
}
function H1(e, { min: t, max: n }) {
  t = St(e.min, t);
  const r = [], a = oi(t);
  let i = G1(t, n), o = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
  const s = Math.pow(10, i), l = a > i ? Math.pow(10, a) : 0, c = Math.round((t - l) * o) / o, u = Math.floor((t - l) / s / 10) * s * 10;
  let d = Math.floor((c - u) / Math.pow(10, i)), f = St(e.min, Math.round((l + u + d * Math.pow(10, i)) * o) / o);
  for (; f < n; )
    r.push({
      value: f,
      major: qb(f),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (i++, d = 2, o = i >= 0 ? 1 : o), f = Math.round((l + u + d * Math.pow(10, i)) * o) / o;
  const g = St(e.max, f);
  return r.push({
    value: g,
    major: qb(g),
    significand: d
  }), r;
}
class Jp extends xr {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const r = zo.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return Fe(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Fe(t) ? Math.max(0, t) : null, this.max = Fe(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !Fe(this._userMin) && (this.min = t === rr(this.min, 0) ? rr(this.min, -1) : rr(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let r = this.min, a = this.max;
    const i = (s) => r = t ? r : s, o = (s) => a = n ? a : s;
    r === a && (r <= 0 ? (i(1), o(10)) : (i(rr(r, -1)), o(rr(a, 1)))), r <= 0 && i(rr(a, -1)), a <= 0 && o(rr(r, 1)), this.min = r, this.max = a;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = H1(n, this);
    return t.bounds === "ticks" && JT(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : vi(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = Dn(t), this._valueRange = Dn(this.max) - Dn(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (Dn(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
z(Jp, "id", "logarithmic"), z(Jp, "defaults", {
  ticks: {
    callback: cs.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function eg(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = it(t.backdropPadding);
    return se(t.font && t.font.size, Le.font.size) + n.height;
  }
  return 0;
}
function z1(e, t, n) {
  return n = De(n) ? n : [
    n
  ], {
    w: X0(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function jb(e, t, n, r, a) {
  return e === r || e === a ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < r || e > a ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function W1(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), r = [], a = [], i = e._pointLabels.length, o = e.options.pointLabels, s = o.centerPointLabels ? Oe / i : 0;
  for (let l = 0; l < i; l++) {
    const c = o.setContext(e.getPointLabelContext(l));
    a[l] = c.padding;
    const u = e.getPointPosition(l, e.drawingArea + a[l], s), d = je(c.font), f = z1(e.ctx, d, e._pointLabels[l]);
    r[l] = f;
    const g = wt(e.getIndexAngle(l) + s), h = Math.round(Yg(g)), p = jb(h, u.x, f.w, 0, 180), m = jb(h, u.y, f.h, 90, 270);
    q1(n, t, g, p, m);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = Y1(e, r, a);
}
function q1(e, t, n, r, a) {
  const i = Math.abs(Math.sin(n)), o = Math.abs(Math.cos(n));
  let s = 0, l = 0;
  r.start < t.l ? (s = (t.l - r.start) / i, e.l = Math.min(e.l, t.l - s)) : r.end > t.r && (s = (r.end - t.r) / i, e.r = Math.max(e.r, t.r + s)), a.start < t.t ? (l = (t.t - a.start) / o, e.t = Math.min(e.t, t.t - l)) : a.end > t.b && (l = (a.end - t.b) / o, e.b = Math.max(e.b, t.b + l));
}
function V1(e, t, n) {
  const r = e.drawingArea, { extra: a, additionalAngle: i, padding: o, size: s } = n, l = e.getPointPosition(t, r + a + o, i), c = Math.round(Yg(wt(l.angle + Be))), u = Z1(l.y, s.h, c), d = K1(c), f = X1(l.x, s.w, d);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: d,
    left: f,
    top: u,
    right: f + s.w,
    bottom: u + s.h
  };
}
function j1(e, t) {
  if (!t)
    return !0;
  const { left: n, top: r, right: a, bottom: i } = e;
  return !(hn({
    x: n,
    y: r
  }, t) || hn({
    x: n,
    y: i
  }, t) || hn({
    x: a,
    y: r
  }, t) || hn({
    x: a,
    y: i
  }, t));
}
function Y1(e, t, n) {
  const r = [], a = e._pointLabels.length, i = e.options, { centerPointLabels: o, display: s } = i.pointLabels, l = {
    extra: eg(i) / 2,
    additionalAngle: o ? Oe / a : 0
  };
  let c;
  for (let u = 0; u < a; u++) {
    l.padding = n[u], l.size = t[u];
    const d = V1(e, u, l);
    r.push(d), s === "auto" && (d.visible = j1(d, c), d.visible && (c = d));
  }
  return r;
}
function K1(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function X1(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function Z1(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function Q1(e, t, n) {
  const { left: r, top: a, right: i, bottom: o } = n, { backdropColor: s } = t;
  if (!fe(s)) {
    const l = gr(t.borderRadius), c = it(t.backdropPadding);
    e.fillStyle = s;
    const u = r - c.left, d = a - c.top, f = i - r + c.width, g = o - a + c.height;
    Object.values(l).some((h) => h !== 0) ? (e.beginPath(), ai(e, {
      x: u,
      y: d,
      w: f,
      h: g,
      radius: l
    }), e.fill()) : e.fillRect(u, d, f, g);
  }
}
function J1(e, t) {
  const { ctx: n, options: { pointLabels: r } } = e;
  for (let a = t - 1; a >= 0; a--) {
    const i = e._pointLabelItems[a];
    if (!i.visible)
      continue;
    const o = r.setContext(e.getPointLabelContext(a));
    Q1(n, o, i);
    const s = je(o.font), { x: l, y: c, textAlign: u } = i;
    vr(n, e._pointLabels[a], l, c + s.lineHeight / 2, s, {
      color: o.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function zR(e, t, n, r) {
  const { ctx: a } = e;
  if (n)
    a.arc(e.xCenter, e.yCenter, t, 0, ke);
  else {
    let i = e.getPointPosition(0, t);
    a.moveTo(i.x, i.y);
    for (let o = 1; o < r; o++)
      i = e.getPointPosition(o, t), a.lineTo(i.x, i.y);
  }
}
function eM(e, t, n, r, a) {
  const i = e.ctx, o = t.circular, { color: s, lineWidth: l } = t;
  !o && !r || !s || !l || n < 0 || (i.save(), i.strokeStyle = s, i.lineWidth = l, i.setLineDash(a.dash || []), i.lineDashOffset = a.dashOffset, i.beginPath(), zR(e, n, o, r), i.closePath(), i.stroke(), i.restore());
}
function tM(e, t, n) {
  return Vn(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class Ga extends zo {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = it(eg(this.options) / 2), n = this.width = this.maxWidth - t.width, r = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + r / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = Fe(t) && !isNaN(t) ? t : 0, this.max = Fe(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / eg(this.options));
  }
  generateTickLabels(t) {
    zo.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, r) => {
      const a = Ae(this.options.pointLabels.callback, [
        n,
        r
      ], this);
      return a || a === 0 ? a : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? W1(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, r, a) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((r - a) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, r, a));
  }
  getIndexAngle(t) {
    const n = ke / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return wt(t * n + Pt(r));
  }
  getDistanceFromCenterForValue(t) {
    if (fe(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (fe(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return tM(this.getContext(), t, r);
    }
  }
  getPointPosition(t, n, r = 0) {
    const a = this.getIndexAngle(t) - Be + r;
    return {
      x: Math.cos(a) * n + this.xCenter,
      y: Math.sin(a) * n + this.yCenter,
      angle: a
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: r, right: a, bottom: i } = this._pointLabelItems[t];
    return {
      left: n,
      top: r,
      right: a,
      bottom: i
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const r = this.ctx;
      r.save(), r.beginPath(), zR(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = t, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: r, grid: a, border: i } = n, o = this._pointLabels.length;
    let s, l, c;
    if (n.pointLabels.display && J1(this, o), a.display && this.ticks.forEach((u, d) => {
      if (d !== 0 || d === 0 && this.min < 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const f = this.getContext(d), g = a.setContext(f), h = i.setContext(f);
        eM(this, g, l, o, h);
      }
    }), r.display) {
      for (t.save(), s = o - 1; s >= 0; s--) {
        const u = r.setContext(this.getPointLabelContext(s)), { color: d, lineWidth: f } = u;
        !f || !d || (t.lineWidth = f, t.strokeStyle = d, t.setLineDash(u.borderDash), t.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(n.reverse ? this.min : this.max), c = this.getPointPosition(s, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const a = this.getIndexAngle(0);
    let i, o;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(a), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((s, l) => {
      if (l === 0 && this.min >= 0 && !n.reverse)
        return;
      const c = r.setContext(this.getContext(l)), u = je(c.font);
      if (i = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = u.string, o = t.measureText(s.label).width, t.fillStyle = c.backdropColor;
        const d = it(c.backdropPadding);
        t.fillRect(-o / 2 - d.left, -i - u.size / 2 - d.top, o + d.width, u.size + d.height);
      }
      vr(t, s.label, 0, -i, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
z(Ga, "id", "radialLinear"), z(Ga, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: cs.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), z(Ga, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), z(Ga, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const ps = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, gt = /* @__PURE__ */ Object.keys(ps);
function Yb(e, t) {
  return e - t;
}
function Kb(e, t) {
  if (fe(t))
    return null;
  const n = e._adapter, { parser: r, round: a, isoWeekday: i } = e._parseOpts;
  let o = t;
  return typeof r == "function" && (o = r(o)), Fe(o) || (o = typeof r == "string" ? n.parse(o, r) : n.parse(o)), o === null ? null : (a && (o = a === "week" && (na(i) || i === !0) ? n.startOf(o, "isoWeek", i) : n.startOf(o, a)), +o);
}
function Xb(e, t, n, r) {
  const a = gt.length;
  for (let i = gt.indexOf(e); i < a - 1; ++i) {
    const o = ps[gt[i]], s = o.steps ? o.steps : Number.MAX_SAFE_INTEGER;
    if (o.common && Math.ceil((n - t) / (s * o.size)) <= r)
      return gt[i];
  }
  return gt[a - 1];
}
function nM(e, t, n, r, a) {
  for (let i = gt.length - 1; i >= gt.indexOf(n); i--) {
    const o = gt[i];
    if (ps[o].common && e._adapter.diff(a, r, o) >= t - 1)
      return o;
  }
  return gt[n ? gt.indexOf(n) : 0];
}
function rM(e) {
  for (let t = gt.indexOf(e) + 1, n = gt.length; t < n; ++t)
    if (ps[gt[t]].common)
      return gt[t];
}
function Zb(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: r, hi: a } = Kg(n, t), i = n[r] >= t ? n[r] : n[a];
    e[i] = !0;
  }
}
function aM(e, t, n, r) {
  const a = e._adapter, i = +a.startOf(t[0].value, r), o = t[t.length - 1].value;
  let s, l;
  for (s = i; s <= o; s = +a.add(s, 1, r))
    l = n[s], l >= 0 && (t[l].major = !0);
  return t;
}
function Qb(e, t, n) {
  const r = [], a = {}, i = t.length;
  let o, s;
  for (o = 0; o < i; ++o)
    s = t[o], a[s] = o, r.push({
      value: s,
      major: !1
    });
  return i === 0 || !n ? r : aM(e, r, a, n);
}
class si extends xr {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const r = t.time || (t.time = {}), a = this._adapter = new fD._date(t.adapters.date);
    a.init(n), ja(r.displayFormats, a.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : Kb(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, r = t.time.unit || "day";
    let { min: a, max: i, minDefined: o, maxDefined: s } = this.getUserBounds();
    function l(c) {
      !o && !isNaN(c.min) && (a = Math.min(a, c.min)), !s && !isNaN(c.max) && (i = Math.max(i, c.max));
    }
    (!o || !s) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), a = Fe(a) && !isNaN(a) ? a : +n.startOf(Date.now(), r), i = Fe(i) && !isNaN(i) ? i : +n.endOf(Date.now(), r) + 1, this.min = Math.min(a, i - 1), this.max = Math.max(a + 1, i);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], r = t[t.length - 1]), {
      min: n,
      max: r
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, r = t.ticks, a = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && a.length && (this.min = this._userMin || a[0], this.max = this._userMax || a[a.length - 1]);
    const i = this.min, o = this.max, s = F0(a, i, o);
    return this._unit = n.unit || (r.autoSkip ? Xb(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : nM(this, s.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : rM(this._unit), this.initOffsets(a), t.reverse && s.reverse(), Qb(this, s, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, r = 0, a, i;
    this.options.offset && t.length && (a = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - a : n = (this.getDecimalForValue(t[1]) - a) / 2, i = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? r = i : r = (i - this.getDecimalForValue(t[t.length - 2])) / 2);
    const o = t.length < 3 ? 0.5 : 0.25;
    n = Ze(n, 0, o), r = Ze(r, 0, o), this._offsets = {
      start: n,
      end: r,
      factor: 1 / (n + 1 + r)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, r = this.max, a = this.options, i = a.time, o = i.unit || Xb(i.minUnit, n, r, this._getLabelCapacity(n)), s = se(a.ticks.stepSize, 1), l = o === "week" ? i.isoWeekday : !1, c = na(l) || l === !0, u = {};
    let d = n, f, g;
    if (c && (d = +t.startOf(d, "isoWeek", l)), d = +t.startOf(d, c ? "day" : o), t.diff(r, n, o) > 1e5 * s)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + s + " " + o);
    const h = a.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, g = 0; f < r; f = +t.add(f, s, o), g++)
      Zb(u, f, h);
    return (f === r || a.bounds === "ticks" || g === 1) && Zb(u, f, h), Object.keys(u).sort(Yb).map((p) => +p);
  }
  getLabelForValue(t) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(t, r.tooltipFormat) : n.format(t, r.displayFormats.datetime);
  }
  format(t, n) {
    const a = this.options.time.displayFormats, i = this._unit, o = n || a[i];
    return this._adapter.format(t, o);
  }
  _tickFormatFunction(t, n, r, a) {
    const i = this.options, o = i.ticks.callback;
    if (o)
      return Ae(o, [
        t,
        n,
        r
      ], this);
    const s = i.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && s[l], d = c && s[c], f = r[n], g = c && d && f && f.major;
    return this._adapter.format(t, a || (g ? d : u));
  }
  generateTickLabels(t) {
    let n, r, a;
    for (n = 0, r = t.length; n < r; ++n)
      a = t[n], a.label = this._tickFormatFunction(a.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, r = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, r = this.ctx.measureText(t).width, a = Pt(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(a), o = Math.sin(a), s = this._resolveTickFontOptions(0).size;
    return {
      w: r * i + s * o,
      h: r * o + s * i
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, r = n.displayFormats, a = r[n.unit] || r.millisecond, i = this._tickFormatFunction(t, 0, Qb(this, [
      t
    ], this._majorUnit), a), o = this._getLabelSize(i), s = Math.floor(this.isHorizontal() ? this.width / o.w : this.height / o.h) - 1;
    return s > 0 ? s : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, r;
    if (t.length)
      return t;
    const a = this.getMatchingVisibleMetas();
    if (this._normalized && a.length)
      return this._cache.data = a[0].controller.getAllParsedValues(this);
    for (n = 0, r = a.length; n < r; ++n)
      t = t.concat(a[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, r;
    if (t.length)
      return t;
    const a = this.getLabels();
    for (n = 0, r = a.length; n < r; ++n)
      t.push(Kb(this, a[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return nR(t.sort(Yb));
  }
}
z(si, "id", "time"), z(si, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Ji(e, t, n) {
  let r = 0, a = e.length - 1, i, o, s, l;
  n ? (t >= e[r].pos && t <= e[a].pos && ({ lo: r, hi: a } = gn(e, "pos", t)), { pos: i, time: s } = e[r], { pos: o, time: l } = e[a]) : (t >= e[r].time && t <= e[a].time && ({ lo: r, hi: a } = gn(e, "time", t)), { time: i, pos: s } = e[r], { time: o, pos: l } = e[a]);
  const c = o - i;
  return c ? s + (l - s) * (t - i) / c : s;
}
class tg extends si {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = Ji(n, this.min), this._tableRange = Ji(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: r } = this, a = [], i = [];
    let o, s, l, c, u;
    for (o = 0, s = t.length; o < s; ++o)
      c = t[o], c >= n && c <= r && a.push(c);
    if (a.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (o = 0, s = a.length; o < s; ++o)
      u = a[o + 1], l = a[o - 1], c = a[o], Math.round((u + l) / 2) !== c && i.push({
        time: c,
        pos: o / (s - 1)
      });
    return i;
  }
  _generate() {
    const t = this.min, n = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(t) || !r.length) && r.splice(0, 0, t), (!r.includes(n) || r.length === 1) && r.push(n), r.sort((a, i) => a - i);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? t = this.normalize(n.concat(r)) : t = n.length ? n : r, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Ji(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return Ji(this._table, r * this._tableRange + this._minPos, !0);
  }
}
z(tg, "id", "timeseries"), z(tg, "defaults", si.defaults);
var iM = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: Zp,
  LinearScale: Qp,
  LogarithmicScale: Jp,
  RadialLinearScale: Ga,
  TimeScale: si,
  TimeSeriesScale: tg
});
const oM = [
  dD,
  GL,
  P1,
  iM
], sM = (e) => {
  const t = [
    "bg-chart-1/60",
    "bg-chart-2/60",
    "bg-chart-3/60",
    "bg-chart-4/60",
    "bg-chart-5/60",
    "bg-chart-6/60",
    "bg-chart-7/60",
    "bg-chart-8/60",
    "bg-chart-9/60",
    "bg-chart-10/60"
  ], n = [
    "border-chart-1",
    "border-chart-2",
    "border-chart-3",
    "border-chart-4",
    "border-chart-5",
    "border-chart-6",
    "border-chart-7",
    "border-chart-8",
    "border-chart-9",
    "border-chart-10"
  ], r = (a) => /* @__PURE__ */ Z(
    "button",
    {
      onClick: () => e.onSelect(a),
      className: "flex items-center focus-visible:outline-none",
      children: [
        /* @__PURE__ */ _(
          "span",
          {
            className: `${t[a]} h-3 w-3 mr-2 border border-solid ${n[a % 10]}`
          }
        ),
        e.datasets[a].label
      ]
    }
  );
  return e.displayStats ? /* @__PURE__ */ Z("table", { className: "text-sm w-[100%]", children: [
    /* @__PURE__ */ _("thead", { children: /* @__PURE__ */ Z("tr", { children: [
      /* @__PURE__ */ _("td", {}),
      /* @__PURE__ */ _("td", { children: "Max" }),
      /* @__PURE__ */ _("td", { children: "Last" })
    ] }) }),
    /* @__PURE__ */ _("tbody", { className: "h-10 overflow-hidden", children: e.datasets.map((a, i) => /* @__PURE__ */ Z(
      "tr",
      {
        className: `mx-8 ${Object.keys(e.visibleSet).length === 0 || e.visibleSet[i] ? "opacity-100" : "opacity-40"}`,
        children: [
          /* @__PURE__ */ _("td", { children: r(i) }),
          /* @__PURE__ */ _("td", { children: Math.max(...a.data) }),
          /* @__PURE__ */ _("td", { children: a.data[a.data.length - 1] })
        ]
      }
    )) })
  ] }) : /* @__PURE__ */ _("div", { className: "grid grid-cols-[1fr_1fr_1fr] place-content-center text-xs place-items-start font-normal", children: e.datasets.map((a, i) => /* @__PURE__ */ _(
    "div",
    {
      className: `mx-8 ${Object.keys(e.visibleSet).length === 0 || e.visibleSet[i] ? "opacity-100" : "opacity-40"}`,
      children: r(i)
    }
  )) });
}, eo = (e) => `${e >= 10 ? e : "0" + e}`, Jb = (e) => {
  const t = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ], n = e.map((r) => new Date(parseInt(r) * 1e3));
  return n[0].getDay() != (/* @__PURE__ */ new Date()).getDay() ? n.map((r) => `${t[r.getMonth()]} ${r.getDate()} ${eo(
    r.getHours()
  )}:${eo(r.getMinutes())}`) : n.map(
    (r) => `${eo(r.getHours())}:${eo(r.getMinutes())}`
  );
}, wX = (e) => {
  const t = Ye(null), n = Ye(null), [r, a] = He({});
  fn.register(...oM);
  const i = (u) => u.map((f, g) => ({
    ...f,
    backgroundColor: `hsla(${getComputedStyle(document.documentElement).getPropertyValue(`--chart-${g + 1}`).split(" ").join(",")}, 1)`,
    borderColor: `hsla(${getComputedStyle(document.documentElement).getPropertyValue(`--chart-${g + 1}`).split(" ").join(",")}, 0.6)`,
    borderWidth: 2
  })), o = () => {
    var u, d, f, g, h;
    return new fn(
      (u = n.current) == null ? void 0 : u.getContext("2d"),
      {
        type: "line",
        data: {
          datasets: i(e.datasets),
          labels: Jb(e.labels)
        },
        options: {
          maintainAspectRatio: !1,
          responsive: !0,
          plugins: {
            legend: { display: !1 }
          },
          elements: {
            point: {
              pointStyle: e.showPoints ? "circle" : !1
            }
          },
          scales: {
            y: {
              type: "linear",
              title: {
                text: (d = e.axisLabel) != null && d.y ? e.axisLabel.y : "",
                align: "center",
                display: ((f = e.axisLabel) == null ? void 0 : f.y) !== void 0
              },
              ticks: {
                precision: 3
              }
            },
            x: {
              title: {
                text: (g = e.axisLabel) != null && g.x ? e.axisLabel.x : "",
                align: "center",
                display: ((h = e.axisLabel) == null ? void 0 : h.x) !== void 0
              },
              ticks: {
                maxTicksLimit: 7
              }
            }
          }
        }
      }
    );
  };
  ye(() => {
    n && (t.current && t.current.destroy(), t.current = o());
  }, []), ye(() => {
    if (e.datasets && t.current) {
      const u = i(e.datasets);
      t.current.data.datasets = u, t.current.data.labels = Jb(e.labels), t.current.options.animation = !1, l(), t.current.update();
    }
  }, [e.datasets, e.labels]), ye(() => {
    var u, d;
    t.current && ((u = t.current.options.elements) != null && u.point) && (t.current.options.elements.point.pointStyle = e.showPoints ? "circle" : !1, (d = t.current) == null || d.update());
  }, [e.showPoints]);
  const s = () => {
    var u;
    a({});
    for (let d = 0; d < e.datasets.length; d++)
      (u = t.current) == null || u.setDatasetVisibility(d, !0);
  }, l = () => {
    if (t.current) {
      if (Object.keys(r).length === 0) {
        s();
        return;
      }
      for (let u = 0; u < e.datasets.length; u++)
        r[u] ? t.current.setDatasetVisibility(u, !0) : t.current.setDatasetVisibility(u, !1);
    }
  }, c = (u) => {
    var f, g, h;
    const d = {
      ...r
    };
    if (d[u] ? delete d[u] : d[u] = !0, Object.keys(d).length === 0 || Object.keys(d).length === e.datasets.length)
      s();
    else {
      for (let p = 0; p < e.datasets.length; p++)
        d[p] ? (f = t.current) == null || f.setDatasetVisibility(p, !0) : (delete d[p], (g = t.current) == null || g.setDatasetVisibility(p, !1));
      a({
        ...d
      });
    }
    (h = t.current) == null || h.update("resize");
  };
  return /* @__PURE__ */ Z("div", { className: "grid grid-rows-[1fr_4rem]", children: [
    /* @__PURE__ */ _(
      "div",
      {
        style: {
          height: e.chartHeight,
          width: "100%"
        },
        children: /* @__PURE__ */ _("canvas", { role: "img", ref: n })
      }
    ),
    /* @__PURE__ */ _("div", { className: "my-2 overflow-y-auto scrollbar", children: /* @__PURE__ */ _(
      sM,
      {
        datasets: e.datasets,
        onSelect: c,
        visibleSet: r,
        displayStats: e.statsInLegend || !1
      }
    ) })
  ] });
};
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lM = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), WR = (...e) => e.filter((t, n, r) => !!t && r.indexOf(t) === n).join(" ");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var cM = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uM = _e(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: a = "",
    children: i,
    iconNode: o,
    ...s
  }, l) => V(
    "svg",
    {
      ref: l,
      ...cM,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: WR("lucide", a),
      ...s
    },
    [
      ...o.map(([c, u]) => V(c, u)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jn = (e, t) => {
  const n = _e(
    ({ className: r, ...a }, i) => V(uM, {
      ref: i,
      iconNode: t,
      className: WR(`lucide-${lM(e)}`, r),
      ...a
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dM = jn("Calendar", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fM = jn("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pM = jn("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gM = jn("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hM = jn("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mM = jn("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bM = jn("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vM = jn("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
function yM(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function EM(...e) {
  return (t) => e.forEach((n) => yM(n, t));
}
var It = b.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = b.Children.toArray(n), i = a.find(wM);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? b.Children.count(o) > 1 ? b.Children.only(null) : b.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ _(ng, { ...r, ref: t, children: b.isValidElement(o) ? b.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ _(ng, { ...r, ref: t, children: n });
});
It.displayName = "Slot";
var ng = b.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (b.isValidElement(n)) {
    const a = TM(n);
    return b.cloneElement(n, {
      ..._M(r, n.props),
      // @ts-ignore
      ref: t ? EM(t, a) : a
    });
  }
  return b.Children.count(n) > 1 ? b.Children.only(null) : null;
});
ng.displayName = "SlotClone";
var SM = ({ children: e }) => /* @__PURE__ */ _(Ke, { children: e });
function wM(e) {
  return b.isValidElement(e) && e.type === SM;
}
function _M(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function TM(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function qR(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = qR(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function RM() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = qR(e)) && (r && (r += " "), r += t);
  return r;
}
const ev = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, tv = RM, sh = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return tv(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: a, defaultVariants: i } = t, o = Object.keys(a).map((c) => {
    const u = n == null ? void 0 : n[c], d = i == null ? void 0 : i[c];
    if (u === null) return null;
    const f = ev(u) || ev(d);
    return a[c][f];
  }), s = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...g } = u;
    return Object.entries(g).every((h) => {
      let [p, m] = h;
      return Array.isArray(m) ? m.includes({
        ...i,
        ...s
      }[p]) : {
        ...i,
        ...s
      }[p] === m;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return tv(e, o, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function VR(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = VR(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function AM() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = VR(e)) && (r && (r += " "), r += t);
  return r;
}
const lh = "-", xM = (e) => {
  const t = NM(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (o) => {
      const s = o.split(lh);
      return s[0] === "" && s.length !== 1 && s.shift(), jR(s, t) || CM(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const l = n[o] || [];
      return s && r[o] ? [...l, ...r[o]] : l;
    }
  };
}, jR = (e, t) => {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), a = r ? jR(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const i = e.join(lh);
  return (o = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : o.classGroupId;
}, nv = /^\[(.+)\]$/, CM = (e) => {
  if (nv.test(e)) {
    const t = nv.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, NM = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return kM(Object.entries(e.classGroups), n).forEach(([i, o]) => {
    rg(o, r, i, t);
  }), r;
}, rg = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? t : rv(t, a);
      i.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (IM(a)) {
        rg(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      rg(o, rv(t, i), n, r);
    });
  });
}, rv = (e, t) => {
  let n = e;
  return t.split(lh).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, IM = (e) => e.isThemeGetter, kM = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, s]) => [t + o, s])) : i);
  return [n, a];
}) : e, OM = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (i, o) => {
    n.set(i, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = n.get(i);
      if (o !== void 0)
        return o;
      if ((o = r.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      n.has(i) ? n.set(i, o) : a(i, o);
    }
  };
}, YR = "!", DM = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], i = t.length, o = (s) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let m = 0; m < s.length; m++) {
      let v = s[m];
      if (c === 0) {
        if (v === a && (r || s.slice(m, m + i) === t)) {
          l.push(s.slice(u, m)), u = m + i;
          continue;
        }
        if (v === "/") {
          d = m;
          continue;
        }
      }
      v === "[" ? c++ : v === "]" && c--;
    }
    const f = l.length === 0 ? s : s.substring(u), g = f.startsWith(YR), h = g ? f.substring(1) : f, p = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: g,
      baseClassName: h,
      maybePostfixModifierPosition: p
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: o
  }) : o;
}, LM = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, MM = (e) => ({
  cache: OM(e.cacheSize),
  parseClassName: DM(e),
  ...xM(e)
}), PM = /\s+/, FM = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, i = [], o = e.trim().split(PM);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const c = o[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: g
    } = n(c);
    let h = !!g, p = r(h ? f.substring(0, g) : f);
    if (!p) {
      if (!h) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (p = r(f), !p) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      h = !1;
    }
    const m = LM(u).join(":"), v = d ? m + YR : m, y = v + p;
    if (i.includes(y))
      continue;
    i.push(y);
    const E = a(p, h);
    for (let S = 0; S < E.length; ++S) {
      const w = E[S];
      i.push(v + w);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function $M() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = KR(t)) && (r && (r += " "), r += n);
  return r;
}
const KR = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = KR(e[r])) && (n && (n += " "), n += t);
  return n;
};
function BM(e, ...t) {
  let n, r, a, i = o;
  function o(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = MM(c), r = n.cache.get, a = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = FM(l, n);
    return a(l, u), u;
  }
  return function() {
    return i($M.apply(null, arguments));
  };
}
const Ne = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, XR = /^\[(?:([a-z-]+):)?(.+)\]$/i, UM = /^\d+\/\d+$/, GM = /* @__PURE__ */ new Set(["px", "full", "screen"]), HM = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, zM = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, WM = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, qM = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, VM = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, sn = (e) => Kr(e) || GM.has(e) || UM.test(e), xn = (e) => la(e, "length", eP), Kr = (e) => !!e && !Number.isNaN(Number(e)), nl = (e) => la(e, "number", Kr), Ca = (e) => !!e && Number.isInteger(Number(e)), jM = (e) => e.endsWith("%") && Kr(e.slice(0, -1)), le = (e) => XR.test(e), Cn = (e) => HM.test(e), YM = /* @__PURE__ */ new Set(["length", "size", "percentage"]), KM = (e) => la(e, YM, ZR), XM = (e) => la(e, "position", ZR), ZM = /* @__PURE__ */ new Set(["image", "url"]), QM = (e) => la(e, ZM, nP), JM = (e) => la(e, "", tP), Na = () => !0, la = (e, t, n) => {
  const r = XR.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, eP = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  zM.test(e) && !WM.test(e)
), ZR = () => !1, tP = (e) => qM.test(e), nP = (e) => VM.test(e), rP = () => {
  const e = Ne("colors"), t = Ne("spacing"), n = Ne("blur"), r = Ne("brightness"), a = Ne("borderColor"), i = Ne("borderRadius"), o = Ne("borderSpacing"), s = Ne("borderWidth"), l = Ne("contrast"), c = Ne("grayscale"), u = Ne("hueRotate"), d = Ne("invert"), f = Ne("gap"), g = Ne("gradientColorStops"), h = Ne("gradientColorStopPositions"), p = Ne("inset"), m = Ne("margin"), v = Ne("opacity"), y = Ne("padding"), E = Ne("saturate"), S = Ne("scale"), w = Ne("sepia"), R = Ne("skew"), T = Ne("space"), A = Ne("translate"), C = () => ["auto", "contain", "none"], N = () => ["auto", "hidden", "clip", "visible", "scroll"], L = () => ["auto", le, t], I = () => [le, t], k = () => ["", sn, xn], B = () => ["auto", Kr, le], F = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], P = () => ["solid", "dashed", "dotted", "double", "none"], D = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], O = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], M = () => ["", "0", le], W = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], U = () => [Kr, le];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Na],
      spacing: [sn, xn],
      blur: ["none", "", Cn, le],
      brightness: U(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Cn, le],
      borderSpacing: I(),
      borderWidth: k(),
      contrast: U(),
      grayscale: M(),
      hueRotate: U(),
      invert: M(),
      gap: I(),
      gradientColorStops: [e],
      gradientColorStopPositions: [jM, xn],
      inset: L(),
      margin: L(),
      opacity: U(),
      padding: I(),
      saturate: U(),
      scale: U(),
      sepia: M(),
      skew: U(),
      space: I(),
      translate: I()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", le]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Cn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": W()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": W()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...F(), le]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: N()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": N()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": N()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: C()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": C()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": C()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [p]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [p]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [p]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [p]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [p]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [p]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [p]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [p]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [p]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ca, le]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: L()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", le]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: M()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: M()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ca, le]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Na]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ca, le]
        }, le]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": B()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": B()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Na]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ca, le]
        }, le]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": B()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": B()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", le]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", le]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...O()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...O(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...O(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [T]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [T]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", le, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [le, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [le, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Cn]
        }, Cn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [le, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [le, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [le, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [le, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Cn, xn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", nl]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Na]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", le]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Kr, nl]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", sn, le]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", le]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", le]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...P(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", sn, xn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", sn, le]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: I()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", le]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", le]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...F(), XM]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", KM]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, QM]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [g]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...P(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: P()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...P()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [sn, le]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [sn, xn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: k()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [sn, xn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Cn, JM]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Na]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...D(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": D()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Cn, le]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [E]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [w]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [E]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [w]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", le]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: U()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", le]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: U()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", le]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ca, le]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [A]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [A]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [R]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [R]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", le]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", le]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": I()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": I()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": I()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": I()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": I()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": I()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": I()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": I()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": I()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": I()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": I()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": I()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": I()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": I()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": I()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": I()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": I()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": I()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", le]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [sn, xn, nl]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, aP = /* @__PURE__ */ BM(rP);
function de(...e) {
  return aP(AM(e));
}
const ag = sh(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 text-md",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-primary hover:border-primary",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Xr = b.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...a }, i) => /* @__PURE__ */ _(
    r ? It : "button",
    {
      className: de(ag({ variant: t, size: n, className: e })),
      ref: i,
      ...a
    }
  )
);
Xr.displayName = "Button";
const iP = (e) => /* @__PURE__ */ Z(Xr, { ...e, disabled: e.disabled || e.loading, children: [
  e.loading && /* @__PURE__ */ _(bM, { className: "animate-spin mr-1" }),
  e.children
] }), _X = (e) => {
  const t = /* @__PURE__ */ _("div", { className: "flex flex-col justify-center h-[100%]", children: /* @__PURE__ */ _("h1", { className: "text-gray-300 font-semibold text-center", children: "NO DATA" }) });
  return /* @__PURE__ */ _(
    e0,
    {
      title: e.title,
      isRefreshing: e.isRefreshing,
      content: t
    }
  );
}, ch = 6048e5, oP = 864e5, sP = 6e4, lP = 36e5, av = Symbol.for("constructDateFrom");
function Xe(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && av in e ? e[av](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ge(e, t) {
  return Xe(t || e, e);
}
function Je(e, t, n) {
  const r = ge(e, n == null ? void 0 : n.in);
  return isNaN(t) ? Xe((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function kt(e, t, n) {
  const r = ge(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return Xe((n == null ? void 0 : n.in) || e, NaN);
  if (!t)
    return r;
  const a = r.getDate(), i = Xe((n == null ? void 0 : n.in) || e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const o = i.getDate();
  return a >= o ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    a
  ), r);
}
function cP(e, t, n) {
  return Xe(e, +ge(e) + t);
}
function to(e, t, n) {
  return cP(e, t * lP);
}
let uP = {};
function Ei() {
  return uP;
}
function Zt(e, t) {
  var s, l, c, u;
  const n = Ei(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = ge(e, t == null ? void 0 : t.in), i = a.getDay(), o = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function yr(e, t) {
  return Zt(e, { ...t, weekStartsOn: 1 });
}
function QR(e, t) {
  const n = ge(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = Xe(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = yr(a), o = Xe(n, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const s = yr(o);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function Wo(e) {
  const t = ge(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function ca(e, ...t) {
  const n = Xe.bind(
    null,
    e || t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function ia(e, t) {
  const n = ge(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Kt(e, t, n) {
  const [r, a] = ca(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = ia(r), o = ia(a), s = +i - Wo(i), l = +o - Wo(o);
  return Math.round((s - l) / oP);
}
function dP(e, t) {
  const n = QR(e, t), r = Xe(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), yr(r);
}
function ar(e, t, n) {
  const r = ge(e, n == null ? void 0 : n.in);
  return r.setTime(r.getTime() + t * sP), r;
}
function ig(e, t, n) {
  return Je(e, t * 7, n);
}
function fP(e, t, n) {
  return kt(e, t * 12, n);
}
function pP(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((a) => {
    !r && typeof a == "object" && (r = Xe.bind(null, a));
    const i = ge(a, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), Xe(r, n || NaN);
}
function gP(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((a) => {
    !r && typeof a == "object" && (r = Xe.bind(null, a));
    const i = ge(a, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), Xe(r, n || NaN);
}
function ht(e, t, n) {
  const [r, a] = ca(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +ia(r) == +ia(a);
}
function uh(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function hP(e) {
  return !(!uh(e) && typeof e != "number" || isNaN(+ge(e)));
}
function li(e, t, n) {
  const [r, a] = ca(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = r.getFullYear() - a.getFullYear(), o = r.getMonth() - a.getMonth();
  return i * 12 + o;
}
function mP(e, t, n) {
  const [r, a] = ca(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = Zt(r, n), o = Zt(a, n), s = +i - Wo(i), l = +o - Wo(o);
  return Math.round((s - l) / ch);
}
function dh(e, t) {
  const n = ge(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function mt(e, t) {
  const n = ge(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function JR(e, t) {
  const n = ge(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function fh(e, t) {
  var s, l, c, u;
  const n = Ei(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = ge(e, t == null ? void 0 : t.in), i = a.getDay(), o = (i < r ? -7 : 0) + 6 - (i - r);
  return a.setDate(a.getDate() + o), a.setHours(23, 59, 59, 999), a;
}
function eA(e, t) {
  return fh(e, { ...t, weekStartsOn: 1 });
}
const bP = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, vP = (e, t, n) => {
  let r;
  const a = bP[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function rl(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const yP = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, EP = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, SP = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wP = {
  date: rl({
    formats: yP,
    defaultWidth: "full"
  }),
  time: rl({
    formats: EP,
    defaultWidth: "full"
  }),
  dateTime: rl({
    formats: SP,
    defaultWidth: "full"
  })
}, _P = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, TP = (e, t, n, r) => _P[e];
function Ia(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const RP = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, AP = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, xP = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, CP = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, NP = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, IP = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, kP = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, OP = {
  ordinalNumber: kP,
  era: Ia({
    values: RP,
    defaultWidth: "wide"
  }),
  quarter: Ia({
    values: AP,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ia({
    values: xP,
    defaultWidth: "wide"
  }),
  day: Ia({
    values: CP,
    defaultWidth: "wide"
  }),
  dayPeriod: Ia({
    values: NP,
    defaultWidth: "wide",
    formattingValues: IP,
    defaultFormattingWidth: "wide"
  })
};
function ka(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? LP(s, (d) => d.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      DP(s, (d) => d.test(o))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(o.length);
    return { value: c, rest: u };
  };
}
function DP(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function LP(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function MP(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
const PP = /^(\d+)(th|st|nd|rd)?/i, FP = /\d+/i, $P = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, BP = {
  any: [/^b/i, /^(a|c)/i]
}, UP = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, GP = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, HP = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, zP = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, WP = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, qP = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, VP = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, jP = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, YP = {
  ordinalNumber: MP({
    matchPattern: PP,
    parsePattern: FP,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ka({
    matchPatterns: $P,
    defaultMatchWidth: "wide",
    parsePatterns: BP,
    defaultParseWidth: "any"
  }),
  quarter: ka({
    matchPatterns: UP,
    defaultMatchWidth: "wide",
    parsePatterns: GP,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ka({
    matchPatterns: HP,
    defaultMatchWidth: "wide",
    parsePatterns: zP,
    defaultParseWidth: "any"
  }),
  day: ka({
    matchPatterns: WP,
    defaultMatchWidth: "wide",
    parsePatterns: qP,
    defaultParseWidth: "any"
  }),
  dayPeriod: ka({
    matchPatterns: VP,
    defaultMatchWidth: "any",
    parsePatterns: jP,
    defaultParseWidth: "any"
  })
}, tA = {
  code: "en-US",
  formatDistance: vP,
  formatLong: wP,
  formatRelative: TP,
  localize: OP,
  match: YP,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function KP(e, t) {
  const n = ge(e, t == null ? void 0 : t.in);
  return Kt(n, JR(n)) + 1;
}
function nA(e, t) {
  const n = ge(e, t == null ? void 0 : t.in), r = +yr(n) - +dP(n);
  return Math.round(r / ch) + 1;
}
function rA(e, t) {
  var u, d, f, g;
  const n = ge(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = Ei(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((g = (f = a.locale) == null ? void 0 : f.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, o = Xe((t == null ? void 0 : t.in) || e, 0);
  o.setFullYear(r + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = Zt(o, t), l = Xe((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = Zt(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function XP(e, t) {
  var s, l, c, u;
  const n = Ei(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = rA(e, t), i = Xe((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), Zt(i, t);
}
function aA(e, t) {
  const n = ge(e, t == null ? void 0 : t.in), r = +Zt(n, t) - +XP(n, t);
  return Math.round(r / ch) + 1;
}
function be(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Nn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return be(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : be(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return be(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return be(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return be(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return be(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return be(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return be(a, t.length);
  }
}, Mr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, iv = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return Nn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = rA(e, r), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return be(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : be(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = QR(e);
    return be(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return be(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return be(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return be(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Nn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return be(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = aA(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : be(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = nA(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : be(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Nn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = KP(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : be(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return be(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return be(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return be(a, t.length);
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = Mr.noon : r === 0 ? a = Mr.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = Mr.evening : r >= 12 ? a = Mr.afternoon : r >= 4 ? a = Mr.morning : a = Mr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Nn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Nn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : be(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : be(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Nn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Nn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Nn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return sv(r);
      case "XXXX":
      case "XX":
        return ur(r);
      case "XXXXX":
      case "XXX":
      default:
        return ur(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return sv(r);
      case "xxxx":
      case "xx":
        return ur(r);
      case "xxxxx":
      case "xxx":
      default:
        return ur(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ov(r, ":");
      case "OOOO":
      default:
        return "GMT" + ur(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ov(r, ":");
      case "zzzz":
      default:
        return "GMT" + ur(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return be(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return be(+e, t.length);
  }
};
function ov(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(a) : n + String(a) + t + be(i, 2);
}
function sv(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + be(Math.abs(e) / 60, 2) : ur(e, t);
}
function ur(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = be(Math.trunc(r / 60), 2), i = be(r % 60, 2);
  return n + a + t + i;
}
const lv = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, iA = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, ZP = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return lv(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", lv(r, t)).replace("{{time}}", iA(a, t));
}, QP = {
  p: iA,
  P: ZP
}, JP = /^D+$/, eF = /^Y+$/, tF = ["D", "DD", "YY", "YYYY"];
function nF(e) {
  return JP.test(e);
}
function rF(e) {
  return eF.test(e);
}
function aF(e, t, n) {
  const r = iF(e, t, n);
  if (console.warn(r), tF.includes(e)) throw new RangeError(r);
}
function iF(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const oF = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, sF = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, lF = /^'([^]*?)'?$/, cF = /''/g, uF = /[a-zA-Z]/;
function Ft(e, t, n) {
  var u, d, f, g, h, p, m, v;
  const r = Ei(), a = (n == null ? void 0 : n.locale) ?? r.locale ?? tA, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((g = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, o = (n == null ? void 0 : n.weekStartsOn) ?? ((p = (h = n == null ? void 0 : n.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? r.weekStartsOn ?? ((v = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : v.weekStartsOn) ?? 0, s = ge(e, n == null ? void 0 : n.in);
  if (!hP(s))
    throw new RangeError("Invalid time value");
  let l = t.match(sF).map((y) => {
    const E = y[0];
    if (E === "p" || E === "P") {
      const S = QP[E];
      return S(y, a.formatLong);
    }
    return y;
  }).join("").match(oF).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const E = y[0];
    if (E === "'")
      return { isToken: !1, value: dF(y) };
    if (iv[E])
      return { isToken: !0, value: y };
    if (E.match(uF))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + E + "`"
      );
    return { isToken: !1, value: y };
  });
  a.localize.preprocessor && (l = a.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return l.map((y) => {
    if (!y.isToken) return y.value;
    const E = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && rF(E) || !(n != null && n.useAdditionalDayOfYearTokens) && nF(E)) && aF(E, t, String(e));
    const S = iv[E[0]];
    return S(s, E, a.localize, c);
  }).join("");
}
function dF(e) {
  const t = e.match(lF);
  return t ? t[1].replace(cF, "'") : e;
}
function fF(e, t) {
  const n = ge(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = n.getMonth(), i = Xe(n, 0);
  return i.setFullYear(r, a + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function pF(e) {
  return Math.trunc(+ge(e) / 1e3);
}
function gF(e, t) {
  const n = ge(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(0, 0, 0, 0), ge(n, t == null ? void 0 : t.in);
}
function hF(e, t) {
  const n = ge(e, t == null ? void 0 : t.in);
  return mP(
    gF(n, t),
    mt(n, t),
    t
  ) + 1;
}
function og(e, t) {
  return +ge(e) > +ge(t);
}
function oA(e, t) {
  return +ge(e) < +ge(t);
}
function ph(e, t, n) {
  const [r, a] = ca(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === a.getFullYear() && r.getMonth() === a.getMonth();
}
function mF(e, t, n) {
  const [r, a] = ca(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === a.getFullYear();
}
function al(e, t, n) {
  return Je(e, -t, n);
}
function il(e, t, n) {
  const r = ge(e, n == null ? void 0 : n.in), a = r.getFullYear(), i = r.getDate(), o = Xe(e, 0);
  o.setFullYear(a, t, 15), o.setHours(0, 0, 0, 0);
  const s = fF(o);
  return r.setMonth(t, Math.min(i, s)), r;
}
function cv(e, t, n) {
  const r = ge(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? Xe(e, NaN) : (r.setFullYear(t), r);
}
function ua(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var bF = ["color"], vF = /* @__PURE__ */ _e(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, a = ua(e, bF);
  return V("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, a, {
    ref: t
  }), V("path", {
    d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), yF = ["color"], EF = /* @__PURE__ */ _e(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, a = ua(e, yF);
  return V("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, a, {
    ref: t
  }), V("path", {
    d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), SF = ["color"], wF = /* @__PURE__ */ _e(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, a = ua(e, SF);
  return V("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, a, {
    ref: t
  }), V("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), _F = ["color"], TF = /* @__PURE__ */ _e(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, a = ua(e, _F);
  return V("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, a, {
    ref: t
  }), V("path", {
    d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), RF = ["color"], AF = /* @__PURE__ */ _e(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, a = ua(e, RF);
  return V("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, a, {
    ref: t
  }), V("path", {
    d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), xF = ["color"], CF = /* @__PURE__ */ _e(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, a = ua(e, xF);
  return V("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, a, {
    ref: t
  }), V("path", {
    d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), X = function() {
  return X = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, X.apply(this, arguments);
};
function NF(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function sA(e, t, n) {
  for (var r = 0, a = t.length, i; r < a; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Si(e) {
  return e.mode === "multiple";
}
function wi(e) {
  return e.mode === "range";
}
function gs(e) {
  return e.mode === "single";
}
var IF = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function kF(e, t) {
  return Ft(e, "LLLL y", t);
}
function OF(e, t) {
  return Ft(e, "d", t);
}
function DF(e, t) {
  return Ft(e, "LLLL", t);
}
function LF(e) {
  return "".concat(e);
}
function MF(e, t) {
  return Ft(e, "cccccc", t);
}
function PF(e, t) {
  return Ft(e, "yyyy", t);
}
var FF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: kF,
  formatDay: OF,
  formatMonthCaption: DF,
  formatWeekNumber: LF,
  formatWeekdayName: MF,
  formatYearCaption: PF
}), $F = function(e, t, n) {
  return Ft(e, "do MMMM (EEEE)", n);
}, BF = function() {
  return "Month: ";
}, UF = function() {
  return "Go to next month";
}, GF = function() {
  return "Go to previous month";
}, HF = function(e, t) {
  return Ft(e, "cccc", t);
}, zF = function(e) {
  return "Week n. ".concat(e);
}, WF = function() {
  return "Year: ";
}, qF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: $F,
  labelMonthDropdown: BF,
  labelNext: UF,
  labelPrevious: GF,
  labelWeekNumber: zF,
  labelWeekday: HF,
  labelYearDropdown: WF
});
function VF() {
  var e = "buttons", t = IF, n = tA, r = {}, a = {}, i = 1, o = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: FF,
    labels: qF,
    locale: n,
    modifiersClassNames: r,
    modifiers: a,
    numberOfMonths: i,
    styles: o,
    today: s,
    mode: "default"
  };
}
function jF(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, a = e.toMonth, i = e.fromDate, o = e.toDate;
  return r ? i = mt(r) : t && (i = new Date(t, 0, 1)), a ? o = dh(a) : n && (o = new Date(n, 11, 31)), {
    fromDate: i ? ia(i) : void 0,
    toDate: o ? ia(o) : void 0
  };
}
var lA = Ct(void 0);
function YF(e) {
  var t, n = e.initialProps, r = VF(), a = jF(n), i = a.fromDate, o = a.toDate, s = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  s !== "buttons" && (!i || !o) && (s = "buttons");
  var l;
  (gs(n) || Si(n) || wi(n)) && (l = n.onSelect);
  var c = X(X(X({}, r), n), { captionLayout: s, classNames: X(X({}, r.classNames), n.classNames), components: X({}, n.components), formatters: X(X({}, r.formatters), n.formatters), fromDate: i, labels: X(X({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: X(X({}, r.modifiers), n.modifiers), modifiersClassNames: X(X({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: X(X({}, r.styles), n.styles), toDate: o });
  return _(lA.Provider, { value: c, children: e.children });
}
function xe() {
  var e = tn(lA);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function cA(e) {
  var t = xe(), n = t.locale, r = t.classNames, a = t.styles, i = t.formatters.formatCaption;
  return _("div", { className: r.caption_label, style: a.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: i(e.displayMonth, { locale: n }) });
}
function KF(e) {
  return _("svg", X({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: _("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function uA(e) {
  var t, n, r = e.onChange, a = e.value, i = e.children, o = e.caption, s = e.className, l = e.style, c = xe(), u = (n = (t = c.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : KF;
  return Z("div", { className: s, style: l, children: [_("span", { className: c.classNames.vhidden, children: e["aria-label"] }), _("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: a, onChange: r, children: i }), Z("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [o, _(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function XF(e) {
  var t, n = xe(), r = n.fromDate, a = n.toDate, i = n.styles, o = n.locale, s = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return _(Ke, {});
  if (!a)
    return _(Ke, {});
  var d = [];
  if (mF(r, a))
    for (var f = mt(r), g = r.getMonth(); g <= a.getMonth(); g++)
      d.push(il(f, g));
  else
    for (var f = mt(/* @__PURE__ */ new Date()), g = 0; g <= 11; g++)
      d.push(il(f, g));
  var h = function(m) {
    var v = Number(m.target.value), y = il(mt(e.displayMonth), v);
    e.onChange(y);
  }, p = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : uA;
  return _(p, { name: "months", "aria-label": u(), className: l.dropdown_month, style: i.dropdown_month, onChange: h, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: o }), children: d.map(function(m) {
    return _("option", { value: m.getMonth(), children: s(m, { locale: o }) }, m.getMonth());
  }) });
}
function ZF(e) {
  var t, n = e.displayMonth, r = xe(), a = r.fromDate, i = r.toDate, o = r.locale, s = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!a)
    return _(Ke, {});
  if (!i)
    return _(Ke, {});
  for (var g = a.getFullYear(), h = i.getFullYear(), p = g; p <= h; p++)
    f.push(cv(JR(/* @__PURE__ */ new Date()), p));
  var m = function(y) {
    var E = cv(mt(n), Number(y.target.value));
    e.onChange(E);
  }, v = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : uA;
  return _(v, { name: "years", "aria-label": d(), className: l.dropdown_year, style: s.dropdown_year, onChange: m, value: n.getFullYear(), caption: u(n, { locale: o }), children: f.map(function(y) {
    return _("option", { value: y.getFullYear(), children: u(y, { locale: o }) }, y.getFullYear());
  }) });
}
function QF(e, t) {
  var n = He(e), r = n[0], a = n[1], i = t === void 0 ? r : t;
  return [i, a];
}
function JF(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, a = t || n || r || /* @__PURE__ */ new Date(), i = e.toDate, o = e.fromDate, s = e.numberOfMonths, l = s === void 0 ? 1 : s;
  if (i && li(i, a) < 0) {
    var c = -1 * (l - 1);
    a = kt(i, c);
  }
  return o && li(a, o) < 0 && (a = o), mt(a);
}
function e$() {
  var e = xe(), t = JF(e), n = QF(t, e.month), r = n[0], a = n[1], i = function(o) {
    var s;
    if (!e.disableNavigation) {
      var l = mt(o);
      a(l), (s = e.onMonthChange) === null || s === void 0 || s.call(e, l);
    }
  };
  return [r, i];
}
function t$(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, a = mt(e), i = mt(kt(a, r)), o = li(i, a), s = [], l = 0; l < o; l++) {
    var c = kt(a, l);
    s.push(c);
  }
  return n && (s = s.reverse()), s;
}
function n$(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, a = t.numberOfMonths, i = a === void 0 ? 1 : a, o = r ? i : 1, s = mt(e);
    if (!n)
      return kt(s, o);
    var l = li(n, e);
    if (!(l < i))
      return kt(s, o);
  }
}
function r$(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, a = t.numberOfMonths, i = a === void 0 ? 1 : a, o = r ? i : 1, s = mt(e);
    if (!n)
      return kt(s, -o);
    var l = li(s, n);
    if (!(l <= 0))
      return kt(s, -o);
  }
}
var dA = Ct(void 0);
function a$(e) {
  var t = xe(), n = e$(), r = n[0], a = n[1], i = t$(r, t), o = n$(r, t), s = r$(r, t), l = function(d) {
    return i.some(function(f) {
      return ph(d, f);
    });
  }, c = function(d, f) {
    l(d) || (f && oA(d, f) ? a(kt(d, 1 + t.numberOfMonths * -1)) : a(d));
  }, u = {
    currentMonth: r,
    displayMonths: i,
    goToMonth: a,
    goToDate: c,
    previousMonth: s,
    nextMonth: o,
    isDateDisplayed: l
  };
  return _(dA.Provider, { value: u, children: e.children });
}
function _i() {
  var e = tn(dA);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function uv(e) {
  var t, n = xe(), r = n.classNames, a = n.styles, i = n.components, o = _i().goToMonth, s = function(u) {
    o(kt(u, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = i == null ? void 0 : i.CaptionLabel) !== null && t !== void 0 ? t : cA, c = _(l, { id: e.id, displayMonth: e.displayMonth });
  return Z("div", { className: r.caption_dropdowns, style: a.caption_dropdowns, children: [_("div", { className: r.vhidden, children: c }), _(XF, { onChange: s, displayMonth: e.displayMonth }), _(ZF, { onChange: s, displayMonth: e.displayMonth })] });
}
function i$(e) {
  return _("svg", X({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: _("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function o$(e) {
  return _("svg", X({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: _("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var qo = _e(function(e, t) {
  var n = xe(), r = n.classNames, a = n.styles, i = [r.button_reset, r.button];
  e.className && i.push(e.className);
  var o = i.join(" "), s = X(X({}, a.button_reset), a.button);
  return e.style && Object.assign(s, e.style), _("button", X({}, e, { ref: t, type: "button", className: o, style: s }));
});
function s$(e) {
  var t, n, r = xe(), a = r.dir, i = r.locale, o = r.classNames, s = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, d = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return _(Ke, {});
  var f = c(e.previousMonth, { locale: i }), g = [
    o.nav_button,
    o.nav_button_previous
  ].join(" "), h = u(e.nextMonth, { locale: i }), p = [
    o.nav_button,
    o.nav_button_next
  ].join(" "), m = (t = d == null ? void 0 : d.IconRight) !== null && t !== void 0 ? t : o$, v = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : i$;
  return Z("div", { className: o.nav, style: s.nav, children: [!e.hidePrevious && _(qo, { name: "previous-month", "aria-label": f, className: g, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: a === "rtl" ? _(m, { className: o.nav_icon, style: s.nav_icon }) : _(v, { className: o.nav_icon, style: s.nav_icon }) }), !e.hideNext && _(qo, { name: "next-month", "aria-label": h, className: p, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: a === "rtl" ? _(v, { className: o.nav_icon, style: s.nav_icon }) : _(m, { className: o.nav_icon, style: s.nav_icon }) })] });
}
function dv(e) {
  var t = xe().numberOfMonths, n = _i(), r = n.previousMonth, a = n.nextMonth, i = n.goToMonth, o = n.displayMonths, s = o.findIndex(function(h) {
    return ph(e.displayMonth, h);
  }), l = s === 0, c = s === o.length - 1, u = t > 1 && (l || !c), d = t > 1 && (c || !l), f = function() {
    r && i(r);
  }, g = function() {
    a && i(a);
  };
  return _(s$, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: d, nextMonth: a, previousMonth: r, onPreviousClick: f, onNextClick: g });
}
function l$(e) {
  var t, n = xe(), r = n.classNames, a = n.disableNavigation, i = n.styles, o = n.captionLayout, s = n.components, l = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : cA, c;
  return a ? c = _(l, { id: e.id, displayMonth: e.displayMonth }) : o === "dropdown" ? c = _(uv, { displayMonth: e.displayMonth, id: e.id }) : o === "dropdown-buttons" ? c = Z(Ke, { children: [_(uv, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), _(dv, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = Z(Ke, { children: [_(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), _(dv, { displayMonth: e.displayMonth, id: e.id })] }), _("div", { className: r.caption, style: i.caption, children: c });
}
function c$(e) {
  var t = xe(), n = t.footer, r = t.styles, a = t.classNames.tfoot;
  return n ? _("tfoot", { className: a, style: r.tfoot, children: _("tr", { children: _("td", { colSpan: 8, children: n }) }) }) : _(Ke, {});
}
function u$(e, t, n) {
  for (var r = n ? yr(/* @__PURE__ */ new Date()) : Zt(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), a = [], i = 0; i < 7; i++) {
    var o = Je(r, i);
    a.push(o);
  }
  return a;
}
function d$() {
  var e = xe(), t = e.classNames, n = e.styles, r = e.showWeekNumber, a = e.locale, i = e.weekStartsOn, o = e.ISOWeek, s = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, c = u$(a, i, o);
  return Z("tr", { style: n.head_row, className: t.head_row, children: [r && _("td", { style: n.head_cell, className: t.head_cell }), c.map(function(u, d) {
    return _("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(u, { locale: a }), children: s(u, { locale: a }) }, d);
  })] });
}
function f$() {
  var e, t = xe(), n = t.classNames, r = t.styles, a = t.components, i = (e = a == null ? void 0 : a.HeadRow) !== null && e !== void 0 ? e : d$;
  return _("thead", { style: r.head, className: n.head, children: _(i, {}) });
}
function p$(e) {
  var t = xe(), n = t.locale, r = t.formatters.formatDay;
  return _(Ke, { children: r(e.date, { locale: n }) });
}
var gh = Ct(void 0);
function g$(e) {
  if (!Si(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return _(gh.Provider, { value: t, children: e.children });
  }
  return _(h$, { initialProps: e.initialProps, children: e.children });
}
function h$(e) {
  var t = e.initialProps, n = e.children, r = t.selected, a = t.min, i = t.max, o = function(c, u, d) {
    var f, g;
    (f = t.onDayClick) === null || f === void 0 || f.call(t, c, u, d);
    var h = !!(u.selected && a && (r == null ? void 0 : r.length) === a);
    if (!h) {
      var p = !!(!u.selected && i && (r == null ? void 0 : r.length) === i);
      if (!p) {
        var m = r ? sA([], r) : [];
        if (u.selected) {
          var v = m.findIndex(function(y) {
            return ht(c, y);
          });
          m.splice(v, 1);
        } else
          m.push(c);
        (g = t.onSelect) === null || g === void 0 || g.call(t, m, c, u, d);
      }
    }
  }, s = {
    disabled: []
  };
  r && s.disabled.push(function(c) {
    var u = i && r.length > i - 1, d = r.some(function(f) {
      return ht(f, c);
    });
    return !!(u && !d);
  });
  var l = {
    selected: r,
    onDayClick: o,
    modifiers: s
  };
  return _(gh.Provider, { value: l, children: n });
}
function hh() {
  var e = tn(gh);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function m$(e, t) {
  var n = t || {}, r = n.from, a = n.to;
  return r && a ? ht(a, e) && ht(r, e) ? void 0 : ht(a, e) ? { from: a, to: void 0 } : ht(r, e) ? void 0 : og(r, e) ? { from: e, to: a } : { from: r, to: e } : a ? og(e, a) ? { from: a, to: e } : { from: e, to: a } : r ? oA(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var mh = Ct(void 0);
function b$(e) {
  if (!wi(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return _(mh.Provider, { value: t, children: e.children });
  }
  return _(v$, { initialProps: e.initialProps, children: e.children });
}
function v$(e) {
  var t = e.initialProps, n = e.children, r = t.selected, a = r || {}, i = a.from, o = a.to, s = t.min, l = t.max, c = function(g, h, p) {
    var m, v;
    (m = t.onDayClick) === null || m === void 0 || m.call(t, g, h, p);
    var y = m$(g, r);
    (v = t.onSelect) === null || v === void 0 || v.call(t, y, g, h, p);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i ? (u.range_start = [i], o ? (u.range_end = [o], ht(i, o) || (u.range_middle = [
    {
      after: i,
      before: o
    }
  ])) : u.range_end = [i]) : o && (u.range_start = [o], u.range_end = [o]), s && (i && !o && u.disabled.push({
    after: al(i, s - 1),
    before: Je(i, s - 1)
  }), i && o && u.disabled.push({
    after: i,
    before: Je(i, s - 1)
  }), !i && o && u.disabled.push({
    after: al(o, s - 1),
    before: Je(o, s - 1)
  })), l) {
    if (i && !o && (u.disabled.push({
      before: Je(i, -l + 1)
    }), u.disabled.push({
      after: Je(i, l - 1)
    })), i && o) {
      var d = Kt(o, i) + 1, f = l - d;
      u.disabled.push({
        before: al(i, f)
      }), u.disabled.push({
        after: Je(o, f)
      });
    }
    !i && o && (u.disabled.push({
      before: Je(o, -l + 1)
    }), u.disabled.push({
      after: Je(o, l - 1)
    }));
  }
  return _(mh.Provider, { value: { selected: r, onDayClick: c, modifiers: u }, children: n });
}
function bh() {
  var e = tn(mh);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function ko(e) {
  return Array.isArray(e) ? sA([], e) : e !== void 0 ? [e] : [];
}
function y$(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], a = n[1];
    t[r] = ko(a);
  }), t;
}
var Ut;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(Ut || (Ut = {}));
var E$ = Ut.Selected, ln = Ut.Disabled, S$ = Ut.Hidden, w$ = Ut.Today, ol = Ut.RangeEnd, sl = Ut.RangeMiddle, ll = Ut.RangeStart, _$ = Ut.Outside;
function T$(e, t, n) {
  var r, a = (r = {}, r[E$] = ko(e.selected), r[ln] = ko(e.disabled), r[S$] = ko(e.hidden), r[w$] = [e.today], r[ol] = [], r[sl] = [], r[ll] = [], r[_$] = [], r);
  return e.fromDate && a[ln].push({ before: e.fromDate }), e.toDate && a[ln].push({ after: e.toDate }), Si(e) ? a[ln] = a[ln].concat(t.modifiers[ln]) : wi(e) && (a[ln] = a[ln].concat(n.modifiers[ln]), a[ll] = n.modifiers[ll], a[sl] = n.modifiers[sl], a[ol] = n.modifiers[ol]), a;
}
var fA = Ct(void 0);
function R$(e) {
  var t = xe(), n = hh(), r = bh(), a = T$(t, n, r), i = y$(t.modifiers), o = X(X({}, a), i);
  return _(fA.Provider, { value: o, children: e.children });
}
function pA() {
  var e = tn(fA);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function A$(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function x$(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function C$(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function N$(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function I$(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function k$(e, t) {
  var n, r = t.from, a = t.to;
  if (r && a) {
    var i = Kt(a, r) < 0;
    i && (n = [a, r], r = n[0], a = n[1]);
    var o = Kt(e, r) >= 0 && Kt(a, e) >= 0;
    return o;
  }
  return a ? ht(a, e) : r ? ht(r, e) : !1;
}
function O$(e) {
  return uh(e);
}
function D$(e) {
  return Array.isArray(e) && e.every(uh);
}
function L$(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (O$(n))
      return ht(e, n);
    if (D$(n))
      return n.includes(e);
    if (x$(n))
      return k$(e, n);
    if (I$(n))
      return n.dayOfWeek.includes(e.getDay());
    if (A$(n)) {
      var r = Kt(n.before, e), a = Kt(n.after, e), i = r > 0, o = a < 0, s = og(n.before, n.after);
      return s ? o && i : i || o;
    }
    return C$(n) ? Kt(e, n.after) > 0 : N$(n) ? Kt(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function vh(e, t, n) {
  var r = Object.keys(t).reduce(function(i, o) {
    var s = t[o];
    return L$(e, s) && i.push(o), i;
  }, []), a = {};
  return r.forEach(function(i) {
    return a[i] = !0;
  }), n && !ph(e, n) && (a.outside = !0), a;
}
function M$(e, t) {
  for (var n = mt(e[0]), r = dh(e[e.length - 1]), a, i, o = n; o <= r; ) {
    var s = vh(o, t), l = !s.disabled && !s.hidden;
    if (!l) {
      o = Je(o, 1);
      continue;
    }
    if (s.selected)
      return o;
    s.today && !i && (i = o), a || (a = o), o = Je(o, 1);
  }
  return i || a;
}
var P$ = 365;
function gA(e, t) {
  var n = t.moveBy, r = t.direction, a = t.context, i = t.modifiers, o = t.retry, s = o === void 0 ? { count: 0, lastFocused: e } : o, l = a.weekStartsOn, c = a.fromDate, u = a.toDate, d = a.locale, f = {
    day: Je,
    week: ig,
    month: kt,
    year: fP,
    startOfWeek: function(m) {
      return a.ISOWeek ? yr(m) : Zt(m, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(m) {
      return a.ISOWeek ? eA(m) : fh(m, { locale: d, weekStartsOn: l });
    }
  }, g = f[n](e, r === "after" ? 1 : -1);
  r === "before" && c ? g = pP([c, g]) : r === "after" && u && (g = gP([u, g]));
  var h = !0;
  if (i) {
    var p = vh(g, i);
    h = !p.disabled && !p.hidden;
  }
  return h ? g : s.count > P$ ? s.lastFocused : gA(g, {
    moveBy: n,
    direction: r,
    context: a,
    modifiers: i,
    retry: X(X({}, s), { count: s.count + 1 })
  });
}
var hA = Ct(void 0);
function F$(e) {
  var t = _i(), n = pA(), r = He(), a = r[0], i = r[1], o = He(), s = o[0], l = o[1], c = M$(t.displayMonths, n), u = a ?? (s && t.isDateDisplayed(s)) ? s : c, d = function() {
    l(a), i(void 0);
  }, f = function(m) {
    i(m);
  }, g = xe(), h = function(m, v) {
    if (a) {
      var y = gA(a, {
        moveBy: m,
        direction: v,
        context: g,
        modifiers: n
      });
      ht(a, y) || (t.goToDate(y, a), f(y));
    }
  }, p = {
    focusedDay: a,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return h("day", "after");
    },
    focusDayBefore: function() {
      return h("day", "before");
    },
    focusWeekAfter: function() {
      return h("week", "after");
    },
    focusWeekBefore: function() {
      return h("week", "before");
    },
    focusMonthBefore: function() {
      return h("month", "before");
    },
    focusMonthAfter: function() {
      return h("month", "after");
    },
    focusYearBefore: function() {
      return h("year", "before");
    },
    focusYearAfter: function() {
      return h("year", "after");
    },
    focusStartOfWeek: function() {
      return h("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return h("endOfWeek", "after");
    }
  };
  return _(hA.Provider, { value: p, children: e.children });
}
function yh() {
  var e = tn(hA);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function $$(e, t) {
  var n = pA(), r = vh(e, n, t);
  return r;
}
var Eh = Ct(void 0);
function B$(e) {
  if (!gs(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return _(Eh.Provider, { value: t, children: e.children });
  }
  return _(U$, { initialProps: e.initialProps, children: e.children });
}
function U$(e) {
  var t = e.initialProps, n = e.children, r = function(i, o, s) {
    var l, c, u;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, i, o, s), o.selected && !t.required) {
      (c = t.onSelect) === null || c === void 0 || c.call(t, void 0, i, o, s);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, i, i, o, s);
  }, a = {
    selected: t.selected,
    onDayClick: r
  };
  return _(Eh.Provider, { value: a, children: n });
}
function mA() {
  var e = tn(Eh);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function G$(e, t) {
  var n = xe(), r = mA(), a = hh(), i = bh(), o = yh(), s = o.focusDayAfter, l = o.focusDayBefore, c = o.focusWeekAfter, u = o.focusWeekBefore, d = o.blur, f = o.focus, g = o.focusMonthBefore, h = o.focusMonthAfter, p = o.focusYearBefore, m = o.focusYearAfter, v = o.focusStartOfWeek, y = o.focusEndOfWeek, E = function(D) {
    var O, M, W, U;
    gs(n) ? (O = r.onDayClick) === null || O === void 0 || O.call(r, e, t, D) : Si(n) ? (M = a.onDayClick) === null || M === void 0 || M.call(a, e, t, D) : wi(n) ? (W = i.onDayClick) === null || W === void 0 || W.call(i, e, t, D) : (U = n.onDayClick) === null || U === void 0 || U.call(n, e, t, D);
  }, S = function(D) {
    var O;
    f(e), (O = n.onDayFocus) === null || O === void 0 || O.call(n, e, t, D);
  }, w = function(D) {
    var O;
    d(), (O = n.onDayBlur) === null || O === void 0 || O.call(n, e, t, D);
  }, R = function(D) {
    var O;
    (O = n.onDayMouseEnter) === null || O === void 0 || O.call(n, e, t, D);
  }, T = function(D) {
    var O;
    (O = n.onDayMouseLeave) === null || O === void 0 || O.call(n, e, t, D);
  }, A = function(D) {
    var O;
    (O = n.onDayPointerEnter) === null || O === void 0 || O.call(n, e, t, D);
  }, C = function(D) {
    var O;
    (O = n.onDayPointerLeave) === null || O === void 0 || O.call(n, e, t, D);
  }, N = function(D) {
    var O;
    (O = n.onDayTouchCancel) === null || O === void 0 || O.call(n, e, t, D);
  }, L = function(D) {
    var O;
    (O = n.onDayTouchEnd) === null || O === void 0 || O.call(n, e, t, D);
  }, I = function(D) {
    var O;
    (O = n.onDayTouchMove) === null || O === void 0 || O.call(n, e, t, D);
  }, k = function(D) {
    var O;
    (O = n.onDayTouchStart) === null || O === void 0 || O.call(n, e, t, D);
  }, B = function(D) {
    var O;
    (O = n.onDayKeyUp) === null || O === void 0 || O.call(n, e, t, D);
  }, F = function(D) {
    var O;
    switch (D.key) {
      case "ArrowLeft":
        D.preventDefault(), D.stopPropagation(), n.dir === "rtl" ? s() : l();
        break;
      case "ArrowRight":
        D.preventDefault(), D.stopPropagation(), n.dir === "rtl" ? l() : s();
        break;
      case "ArrowDown":
        D.preventDefault(), D.stopPropagation(), c();
        break;
      case "ArrowUp":
        D.preventDefault(), D.stopPropagation(), u();
        break;
      case "PageUp":
        D.preventDefault(), D.stopPropagation(), D.shiftKey ? p() : g();
        break;
      case "PageDown":
        D.preventDefault(), D.stopPropagation(), D.shiftKey ? m() : h();
        break;
      case "Home":
        D.preventDefault(), D.stopPropagation(), v();
        break;
      case "End":
        D.preventDefault(), D.stopPropagation(), y();
        break;
    }
    (O = n.onDayKeyDown) === null || O === void 0 || O.call(n, e, t, D);
  }, P = {
    onClick: E,
    onFocus: S,
    onBlur: w,
    onKeyDown: F,
    onKeyUp: B,
    onMouseEnter: R,
    onMouseLeave: T,
    onPointerEnter: A,
    onPointerLeave: C,
    onTouchCancel: N,
    onTouchEnd: L,
    onTouchMove: I,
    onTouchStart: k
  };
  return P;
}
function H$() {
  var e = xe(), t = mA(), n = hh(), r = bh(), a = gs(e) ? t.selected : Si(e) ? n.selected : wi(e) ? r.selected : void 0;
  return a;
}
function z$(e) {
  return Object.values(Ut).includes(e);
}
function W$(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var a = e.modifiersClassNames[r];
    if (a)
      n.push(a);
    else if (z$(r)) {
      var i = e.classNames["day_".concat(r)];
      i && n.push(i);
    }
  }), n;
}
function q$(e, t) {
  var n = X({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var a;
    n = X(X({}, n), (a = e.modifiersStyles) === null || a === void 0 ? void 0 : a[r]);
  }), n;
}
function V$(e, t, n) {
  var r, a, i, o = xe(), s = yh(), l = $$(e, t), c = G$(e, l), u = H$(), d = !!(o.onDayClick || o.mode !== "default");
  ye(function() {
    var R;
    l.outside || s.focusedDay && d && ht(s.focusedDay, e) && ((R = n.current) === null || R === void 0 || R.focus());
  }, [
    s.focusedDay,
    e,
    n,
    d,
    l.outside
  ]);
  var f = W$(o, l).join(" "), g = q$(o, l), h = !!(l.outside && !o.showOutsideDays || l.hidden), p = (i = (a = o.components) === null || a === void 0 ? void 0 : a.DayContent) !== null && i !== void 0 ? i : p$, m = _(p, { date: e, displayMonth: t, activeModifiers: l }), v = {
    style: g,
    className: f,
    children: m,
    role: "gridcell"
  }, y = s.focusTarget && ht(s.focusTarget, e) && !l.outside, E = s.focusedDay && ht(s.focusedDay, e), S = X(X(X({}, v), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = E || y ? 0 : -1, r)), c), w = {
    isButton: d,
    isHidden: h,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: S,
    divProps: v
  };
  return w;
}
function j$(e) {
  var t = Ye(null), n = V$(e.date, e.displayMonth, t);
  return n.isHidden ? _("div", { role: "gridcell" }) : n.isButton ? _(qo, X({ name: "day", ref: t }, n.buttonProps)) : _("div", X({}, n.divProps));
}
function Y$(e) {
  var t = e.number, n = e.dates, r = xe(), a = r.onWeekNumberClick, i = r.styles, o = r.classNames, s = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(t), { locale: s });
  if (!a)
    return _("span", { className: o.weeknumber, style: i.weeknumber, children: u });
  var d = l(Number(t), { locale: s }), f = function(g) {
    a(t, n, g);
  };
  return _(qo, { name: "week-number", "aria-label": d, className: o.weeknumber, style: i.weeknumber, onClick: f, children: u });
}
function K$(e) {
  var t, n, r = xe(), a = r.styles, i = r.classNames, o = r.showWeekNumber, s = r.components, l = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : j$, c = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : Y$, u;
  return o && (u = _("td", { className: i.cell, style: a.cell, children: _(c, { number: e.weekNumber, dates: e.dates }) })), Z("tr", { className: i.row, style: a.row, children: [u, e.dates.map(function(d) {
    return _("td", { className: i.cell, style: a.cell, role: "presentation", children: _(l, { displayMonth: e.displayMonth, date: d }) }, pF(d));
  })] });
}
function fv(e, t, n) {
  for (var r = n != null && n.ISOWeek ? eA(t) : fh(t, n), a = n != null && n.ISOWeek ? yr(e) : Zt(e, n), i = Kt(r, a), o = [], s = 0; s <= i; s++)
    o.push(Je(a, s));
  var l = o.reduce(function(c, u) {
    var d = n != null && n.ISOWeek ? nA(u) : aA(u, n), f = c.find(function(g) {
      return g.weekNumber === d;
    });
    return f ? (f.dates.push(u), c) : (c.push({
      weekNumber: d,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function X$(e, t) {
  var n = fv(mt(e), dh(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = hF(e, t);
    if (r < 6) {
      var a = n[n.length - 1], i = a.dates[a.dates.length - 1], o = ig(i, 6 - r), s = fv(ig(i, 1), o, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function Z$(e) {
  var t, n, r, a = xe(), i = a.locale, o = a.classNames, s = a.styles, l = a.hideHead, c = a.fixedWeeks, u = a.components, d = a.weekStartsOn, f = a.firstWeekContainsDate, g = a.ISOWeek, h = X$(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: g,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), p = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : f$, m = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : K$, v = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : c$;
  return Z("table", { id: e.id, className: o.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && _(p, {}), _("tbody", { className: o.tbody, style: s.tbody, children: h.map(function(y) {
    return _(m, { displayMonth: e.displayMonth, dates: y.dates, weekNumber: y.weekNumber }, y.weekNumber);
  }) }), _(v, { displayMonth: e.displayMonth })] });
}
function Q$() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var J$ = Q$() ? Rr : ye, cl = !1, e2 = 0;
function pv() {
  return "react-day-picker-".concat(++e2);
}
function t2(e) {
  var t, n = e ?? (cl ? pv() : null), r = He(n), a = r[0], i = r[1];
  return J$(function() {
    a === null && i(pv());
  }, []), ye(function() {
    cl === !1 && (cl = !0);
  }, []), (t = e ?? a) !== null && t !== void 0 ? t : void 0;
}
function n2(e) {
  var t, n, r = xe(), a = r.dir, i = r.classNames, o = r.styles, s = r.components, l = _i().displayMonths, c = t2(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, d = [i.month], f = o.month, g = e.displayIndex === 0, h = e.displayIndex === l.length - 1, p = !g && !h;
  a === "rtl" && (t = [g, h], h = t[0], g = t[1]), g && (d.push(i.caption_start), f = X(X({}, f), o.caption_start)), h && (d.push(i.caption_end), f = X(X({}, f), o.caption_end)), p && (d.push(i.caption_between), f = X(X({}, f), o.caption_between));
  var m = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : l$;
  return Z("div", { className: d.join(" "), style: f, children: [_(m, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), _(Z$, { id: u, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function r2(e) {
  var t = xe(), n = t.classNames, r = t.styles;
  return _("div", { className: n.months, style: r.months, children: e.children });
}
function a2(e) {
  var t, n, r = e.initialProps, a = xe(), i = yh(), o = _i(), s = He(!1), l = s[0], c = s[1];
  ye(function() {
    a.initialFocus && i.focusTarget && (l || (i.focus(i.focusTarget), c(!0)));
  }, [
    a.initialFocus,
    l,
    i.focus,
    i.focusTarget,
    i
  ]);
  var u = [a.classNames.root, a.className];
  a.numberOfMonths > 1 && u.push(a.classNames.multiple_months), a.showWeekNumber && u.push(a.classNames.with_weeknumber);
  var d = X(X({}, a.styles.root), a.style), f = Object.keys(r).filter(function(h) {
    return h.startsWith("data-");
  }).reduce(function(h, p) {
    var m;
    return X(X({}, h), (m = {}, m[p] = r[p], m));
  }, {}), g = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : r2;
  return _("div", X({ className: u.join(" "), style: d, dir: a.dir, id: a.id, nonce: r.nonce, title: r.title, lang: r.lang }, f, { children: _(g, { children: o.displayMonths.map(function(h, p) {
    return _(n2, { displayIndex: p, displayMonth: h }, p);
  }) }) }));
}
function i2(e) {
  var t = e.children, n = NF(e, ["children"]);
  return _(YF, { initialProps: n, children: _(a$, { children: _(B$, { initialProps: n, children: _(g$, { initialProps: n, children: _(b$, { initialProps: n, children: _(R$, { children: _(F$, { children: t }) }) }) }) }) }) });
}
function o2(e) {
  return _(i2, X({}, e, { children: _(a2, { initialProps: e }) }));
}
function bA({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  ...r
}) {
  return /* @__PURE__ */ _(
    o2,
    {
      showOutsideDays: n,
      className: de("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: de(
          ag({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: de(
          "relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected].day-range-end)]:rounded-r-md",
          r.mode === "range" ? "[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md" : "[&:has([aria-selected])]:rounded-md"
        ),
        day: de(
          ag({ variant: "ghost" }),
          "h-8 w-8 p-0 font-normal aria-selected:opacity-100"
        ),
        day_range_start: "day-range-start",
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground opacity-50  aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...t
      },
      components: {
        IconLeft: () => /* @__PURE__ */ _(TF, { className: "h-4 w-4" }),
        IconRight: () => /* @__PURE__ */ _(AF, { className: "h-4 w-4" })
      },
      ...r
    }
  );
}
bA.displayName = "Calendar";
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pe.apply(this, arguments);
}
function mr(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented) return t == null ? void 0 : t(a);
  };
}
function s2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function vA(...e) {
  return (t) => e.forEach(
    (n) => s2(n, t)
  );
}
function Ti(...e) {
  return Fn(vA(...e), e);
}
function l2(e, t = []) {
  let n = [];
  function r(i, o) {
    const s = /* @__PURE__ */ Ct(o), l = n.length;
    n = [
      ...n,
      o
    ];
    function c(d) {
      const { scope: f, children: g, ...h } = d, p = (f == null ? void 0 : f[e][l]) || s, m = yn(
        () => h,
        Object.values(h)
      );
      return /* @__PURE__ */ V(p.Provider, {
        value: m
      }, g);
    }
    function u(d, f) {
      const g = (f == null ? void 0 : f[e][l]) || s, h = tn(g);
      if (h) return h;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      u
    ];
  }
  const a = () => {
    const i = n.map((o) => /* @__PURE__ */ Ct(o));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return yn(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return a.scopeName = e, [
    r,
    c2(a, ...t)
  ];
}
function c2(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return yn(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const Sh = /* @__PURE__ */ _e((e, t) => {
  const { children: n, ...r } = e, a = at.toArray(n), i = a.find(d2);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? at.count(o) > 1 ? at.only(null) : /* @__PURE__ */ Nt(o) ? o.props.children : null : l);
    return /* @__PURE__ */ V(sg, Pe({}, r, {
      ref: t
    }), /* @__PURE__ */ Nt(o) ? /* @__PURE__ */ Ar(o, void 0, s) : null);
  }
  return /* @__PURE__ */ V(sg, Pe({}, r, {
    ref: t
  }), n);
});
Sh.displayName = "Slot";
const sg = /* @__PURE__ */ _e((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Nt(n) ? /* @__PURE__ */ Ar(n, {
    ...f2(r, n.props),
    ref: vA(t, n.ref)
  }) : at.count(n) > 1 ? at.only(null) : null;
});
sg.displayName = "SlotClone";
const u2 = ({ children: e }) => /* @__PURE__ */ V(Hg, null, e);
function d2(e) {
  return /* @__PURE__ */ Nt(e) && e.type === u2;
}
function f2(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...i
    } : r === "className" && (n[r] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const p2 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], hs = p2.reduce((e, t) => {
  const n = /* @__PURE__ */ _e((r, a) => {
    const { asChild: i, ...o } = r, s = i ? Sh : t;
    return ye(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Pe({}, o, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function g2(e, t) {
  e && jT(
    () => e.dispatchEvent(t)
  );
}
function Er(e) {
  const t = Ye(e);
  return ye(() => {
    t.current = e;
  }), yn(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function h2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Er(e);
  ye(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const lg = "dismissableLayer.update", m2 = "dismissableLayer.pointerDownOutside", b2 = "dismissableLayer.focusOutside";
let gv;
const v2 = /* @__PURE__ */ Ct({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), y2 = /* @__PURE__ */ _e((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: o, onInteractOutside: s, onDismiss: l, ...c } = e, u = tn(v2), [d, f] = He(null), g = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, h] = He({}), p = Ti(
    t,
    (A) => f(A)
  ), m = Array.from(u.layers), [v] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), y = m.indexOf(v), E = d ? m.indexOf(d) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, w = E >= y, R = E2((A) => {
    const C = A.target, N = [
      ...u.branches
    ].some(
      (L) => L.contains(C)
    );
    !w || N || (i == null || i(A), s == null || s(A), A.defaultPrevented || l == null || l());
  }, g), T = S2((A) => {
    const C = A.target;
    [
      ...u.branches
    ].some(
      (L) => L.contains(C)
    ) || (o == null || o(A), s == null || s(A), A.defaultPrevented || l == null || l());
  }, g);
  return h2((A) => {
    E === u.layers.size - 1 && (a == null || a(A), !A.defaultPrevented && l && (A.preventDefault(), l()));
  }, g), ye(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (gv = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), hv(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = gv);
      };
  }, [
    d,
    g,
    r,
    u
  ]), ye(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), hv());
  }, [
    d,
    u
  ]), ye(() => {
    const A = () => h({});
    return document.addEventListener(lg, A), () => document.removeEventListener(lg, A);
  }, []), /* @__PURE__ */ V(hs.div, Pe({}, c, {
    ref: p,
    style: {
      pointerEvents: S ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: mr(e.onFocusCapture, T.onFocusCapture),
    onBlurCapture: mr(e.onBlurCapture, T.onBlurCapture),
    onPointerDownCapture: mr(e.onPointerDownCapture, R.onPointerDownCapture)
  }));
});
function E2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Er(e), r = Ye(!1), a = Ye(() => {
  });
  return ye(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          yA(m2, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = c, t.addEventListener("click", a.current, {
          once: !0
        })) : c();
      }
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function S2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Er(e), r = Ye(!1);
  return ye(() => {
    const a = (i) => {
      i.target && !r.current && yA(b2, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function hv() {
  const e = new CustomEvent(lg);
  document.dispatchEvent(e);
}
function yA(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), r ? g2(a, i) : a.dispatchEvent(i);
}
let ul = 0;
function w2() {
  ye(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : mv()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : mv()), ul++, () => {
      ul === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), ul--;
    };
  }, []);
}
function mv() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const dl = "focusScope.autoFocusOnMount", fl = "focusScope.autoFocusOnUnmount", bv = {
  bubbles: !1,
  cancelable: !0
}, _2 = /* @__PURE__ */ _e((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...o } = e, [s, l] = He(null), c = Er(a), u = Er(i), d = Ye(null), f = Ti(
    t,
    (p) => l(p)
  ), g = Ye({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ye(() => {
    if (r) {
      let p = function(v) {
        if (g.paused || !s) return;
        const y = v.target;
        s.contains(y) ? d.current = y : dr(d.current, {
          select: !0
        });
      }, m = function(v) {
        g.paused || !s || s.contains(v.relatedTarget) || dr(d.current, {
          select: !0
        });
      };
      return document.addEventListener("focusin", p), document.addEventListener("focusout", m), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m);
      };
    }
  }, [
    r,
    s,
    g.paused
  ]), ye(() => {
    if (s) {
      yv.add(g);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const v = new CustomEvent(dl, bv);
        s.addEventListener(dl, c), s.dispatchEvent(v), v.defaultPrevented || (T2(N2(EA(s)), {
          select: !0
        }), document.activeElement === p && dr(s));
      }
      return () => {
        s.removeEventListener(dl, c), setTimeout(() => {
          const v = new CustomEvent(fl, bv);
          s.addEventListener(fl, u), s.dispatchEvent(v), v.defaultPrevented || dr(p ?? document.body, {
            select: !0
          }), s.removeEventListener(fl, u), yv.remove(g);
        }, 0);
      };
    }
  }, [
    s,
    c,
    u,
    g
  ]);
  const h = Fn((p) => {
    if (!n && !r || g.paused) return;
    const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, v = document.activeElement;
    if (m && v) {
      const y = p.currentTarget, [E, S] = R2(y);
      E && S ? !p.shiftKey && v === S ? (p.preventDefault(), n && dr(E, {
        select: !0
      })) : p.shiftKey && v === E && (p.preventDefault(), n && dr(S, {
        select: !0
      })) : v === y && p.preventDefault();
    }
  }, [
    n,
    r,
    g.paused
  ]);
  return /* @__PURE__ */ V(hs.div, Pe({
    tabIndex: -1
  }, o, {
    ref: f,
    onKeyDown: h
  }));
});
function T2(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (dr(r, {
      select: t
    }), document.activeElement !== n) return;
}
function R2(e) {
  const t = EA(e), n = vv(t, e), r = vv(t.reverse(), e);
  return [
    n,
    r
  ];
}
function EA(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function vv(e, t) {
  for (const n of e)
    if (!A2(n, {
      upTo: t
    })) return n;
}
function A2(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function x2(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function dr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && x2(e) && t && e.select();
  }
}
const yv = C2();
function C2() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Ev(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Ev(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Ev(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function N2(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const cg = globalThis != null && globalThis.document ? Rr : () => {
}, I2 = b.useId || (() => {
});
let k2 = 0;
function O2(e) {
  const [t, n] = b.useState(I2());
  return cg(() => {
    e || n(
      (r) => r ?? String(k2++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Cr(e) {
  return e.split("-")[0];
}
function Ri(e) {
  return e.split("-")[1];
}
function da(e) {
  return ["top", "bottom"].includes(Cr(e)) ? "x" : "y";
}
function wh(e) {
  return e === "y" ? "height" : "width";
}
function Sv(e, t, n) {
  let { reference: r, floating: a } = e;
  const i = r.x + r.width / 2 - a.width / 2, o = r.y + r.height / 2 - a.height / 2, s = da(t), l = wh(s), c = r[l] / 2 - a[l] / 2, u = s === "x";
  let d;
  switch (Cr(t)) {
    case "top":
      d = { x: i, y: r.y - a.height };
      break;
    case "bottom":
      d = { x: i, y: r.y + r.height };
      break;
    case "right":
      d = { x: r.x + r.width, y: o };
      break;
    case "left":
      d = { x: r.x - a.width, y: o };
      break;
    default:
      d = { x: r.x, y: r.y };
  }
  switch (Ri(t)) {
    case "start":
      d[s] -= c * (n && u ? -1 : 1);
      break;
    case "end":
      d[s] += c * (n && u ? -1 : 1);
  }
  return d;
}
const D2 = async (e, t, n) => {
  const { placement: r = "bottom", strategy: a = "absolute", middleware: i = [], platform: o } = n, s = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let l = await o.getElementRects({ reference: e, floating: t, strategy: a }), { x: c, y: u } = Sv(l, r, s), d = r, f = {}, g = 0;
  for (let h = 0; h < i.length; h++) {
    const { name: p, fn: m } = i[h], { x: v, y, data: E, reset: S } = await m({ x: c, y: u, initialPlacement: r, placement: d, strategy: a, middlewareData: f, rects: l, platform: o, elements: { reference: e, floating: t } });
    c = v ?? c, u = y ?? u, f = { ...f, [p]: { ...f[p], ...E } }, S && g <= 50 && (g++, typeof S == "object" && (S.placement && (d = S.placement), S.rects && (l = S.rects === !0 ? await o.getElementRects({ reference: e, floating: t, strategy: a }) : S.rects), { x: c, y: u } = Sv(l, d, s)), h = -1);
  }
  return { x: c, y: u, placement: d, strategy: a, middlewareData: f };
};
function SA(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function Vo(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
async function ci(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: r, y: a, platform: i, rects: o, elements: s, strategy: l } = e, { boundary: c = "clippingAncestors", rootBoundary: u = "viewport", elementContext: d = "floating", altBoundary: f = !1, padding: g = 0 } = t, h = SA(g), p = s[f ? d === "floating" ? "reference" : "floating" : d], m = Vo(await i.getClippingRect({ element: (n = await (i.isElement == null ? void 0 : i.isElement(p))) == null || n ? p : p.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)), boundary: c, rootBoundary: u, strategy: l })), v = Vo(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: d === "floating" ? { ...o.floating, x: r, y: a } : o.reference, offsetParent: await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), strategy: l }) : o[d]);
  return { top: m.top - v.top + h.top, bottom: v.bottom - m.bottom + h.bottom, left: m.left - v.left + h.left, right: v.right - m.right + h.right };
}
const L2 = Math.min, fr = Math.max;
function ug(e, t, n) {
  return fr(e, L2(t, n));
}
const wv = (e) => ({ name: "arrow", options: e, async fn(t) {
  const { element: n, padding: r = 0 } = e ?? {}, { x: a, y: i, placement: o, rects: s, platform: l } = t;
  if (n == null) return {};
  const c = SA(r), u = { x: a, y: i }, d = da(o), f = Ri(o), g = wh(d), h = await l.getDimensions(n), p = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", v = s.reference[g] + s.reference[d] - u[d] - s.floating[g], y = u[d] - s.reference[d], E = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(n));
  let S = E ? d === "y" ? E.clientHeight || 0 : E.clientWidth || 0 : 0;
  S === 0 && (S = s.floating[g]);
  const w = v / 2 - y / 2, R = c[p], T = S - h[g] - c[m], A = S / 2 - h[g] / 2 + w, C = ug(R, A, T), N = (f === "start" ? c[p] : c[m]) > 0 && A !== C && s.reference[g] <= s.floating[g];
  return { [d]: u[d] - (N ? A < R ? R - A : T - A : 0), data: { [d]: C, centerOffset: A - C } };
} }), M2 = { left: "right", right: "left", bottom: "top", top: "bottom" };
function jo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => M2[t]);
}
function P2(e, t, n) {
  n === void 0 && (n = !1);
  const r = Ri(e), a = da(e), i = wh(a);
  let o = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = jo(o)), { main: o, cross: jo(o) };
}
const F2 = { start: "end", end: "start" };
function _v(e) {
  return e.replace(/start|end/g, (t) => F2[t]);
}
const wA = ["top", "right", "bottom", "left"];
wA.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
const $2 = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n;
    const { placement: r, middlewareData: a, rects: i, initialPlacement: o, platform: s, elements: l } = t, { mainAxis: c = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", flipAlignment: g = !0, ...h } = e, p = Cr(r), m = d || (p === o || !g ? [jo(o)] : function(A) {
      const C = jo(A);
      return [_v(A), C, _v(C)];
    }(o)), v = [o, ...m], y = await ci(t, h), E = [];
    let S = ((n = a.flip) == null ? void 0 : n.overflows) || [];
    if (c && E.push(y[p]), u) {
      const { main: A, cross: C } = P2(r, i, await (s.isRTL == null ? void 0 : s.isRTL(l.floating)));
      E.push(y[A], y[C]);
    }
    if (S = [...S, { placement: r, overflows: E }], !E.every((A) => A <= 0)) {
      var w, R;
      const A = ((w = (R = a.flip) == null ? void 0 : R.index) != null ? w : 0) + 1, C = v[A];
      if (C) return { data: { index: A, overflows: S }, reset: { placement: C } };
      let N = "bottom";
      switch (f) {
        case "bestFit": {
          var T;
          const L = (T = S.map((I) => [I, I.overflows.filter((k) => k > 0).reduce((k, B) => k + B, 0)]).sort((I, k) => I[1] - k[1])[0]) == null ? void 0 : T[0].placement;
          L && (N = L);
          break;
        }
        case "initialPlacement":
          N = o;
      }
      if (r !== N) return { reset: { placement: N } };
    }
    return {};
  } };
};
function Tv(e, t) {
  return { top: e.top - t.height, right: e.right - t.width, bottom: e.bottom - t.height, left: e.left - t.width };
}
function Rv(e) {
  return wA.some((t) => e[t] >= 0);
}
const B2 = function(e) {
  let { strategy: t = "referenceHidden", ...n } = e === void 0 ? {} : e;
  return { name: "hide", async fn(r) {
    const { rects: a } = r;
    switch (t) {
      case "referenceHidden": {
        const i = Tv(await ci(r, { ...n, elementContext: "reference" }), a.reference);
        return { data: { referenceHiddenOffsets: i, referenceHidden: Rv(i) } };
      }
      case "escaped": {
        const i = Tv(await ci(r, { ...n, altBoundary: !0 }), a.floating);
        return { data: { escapedOffsets: i, escaped: Rv(i) } };
      }
      default:
        return {};
    }
  } };
}, U2 = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    const { x: n, y: r } = t, a = await async function(i, o) {
      const { placement: s, platform: l, elements: c } = i, u = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), d = Cr(s), f = Ri(s), g = da(s) === "x", h = ["left", "top"].includes(d) ? -1 : 1, p = u && g ? -1 : 1, m = typeof o == "function" ? o(i) : o;
      let { mainAxis: v, crossAxis: y, alignmentAxis: E } = typeof m == "number" ? { mainAxis: m, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...m };
      return f && typeof E == "number" && (y = f === "end" ? -1 * E : E), g ? { x: y * p, y: v * h } : { x: v * h, y: y * p };
    }(t, e);
    return { x: n + a.x, y: r + a.y, data: a };
  } };
};
function _A(e) {
  return e === "x" ? "y" : "x";
}
const G2 = function(e) {
  return e === void 0 && (e = {}), { name: "shift", options: e, async fn(t) {
    const { x: n, y: r, placement: a } = t, { mainAxis: i = !0, crossAxis: o = !1, limiter: s = { fn: (m) => {
      let { x: v, y } = m;
      return { x: v, y };
    } }, ...l } = e, c = { x: n, y: r }, u = await ci(t, l), d = da(Cr(a)), f = _A(d);
    let g = c[d], h = c[f];
    if (i) {
      const m = d === "y" ? "bottom" : "right";
      g = ug(g + u[d === "y" ? "top" : "left"], g, g - u[m]);
    }
    if (o) {
      const m = f === "y" ? "bottom" : "right";
      h = ug(h + u[f === "y" ? "top" : "left"], h, h - u[m]);
    }
    const p = s.fn({ ...t, [d]: g, [f]: h });
    return { ...p, data: { x: p.x - n, y: p.y - r } };
  } };
}, H2 = function(e) {
  return e === void 0 && (e = {}), { options: e, fn(t) {
    const { x: n, y: r, placement: a, rects: i, middlewareData: o } = t, { offset: s = 0, mainAxis: l = !0, crossAxis: c = !0 } = e, u = { x: n, y: r }, d = da(a), f = _A(d);
    let g = u[d], h = u[f];
    const p = typeof s == "function" ? s({ ...i, placement: a }) : s, m = typeof p == "number" ? { mainAxis: p, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...p };
    if (l) {
      const w = d === "y" ? "height" : "width", R = i.reference[d] - i.floating[w] + m.mainAxis, T = i.reference[d] + i.reference[w] - m.mainAxis;
      g < R ? g = R : g > T && (g = T);
    }
    if (c) {
      var v, y, E, S;
      const w = d === "y" ? "width" : "height", R = ["top", "left"].includes(Cr(a)), T = i.reference[f] - i.floating[w] + (R && (v = (y = o.offset) == null ? void 0 : y[f]) != null ? v : 0) + (R ? 0 : m.crossAxis), A = i.reference[f] + i.reference[w] + (R ? 0 : (E = (S = o.offset) == null ? void 0 : S[f]) != null ? E : 0) - (R ? m.crossAxis : 0);
      h < T ? h = T : h > A && (h = A);
    }
    return { [d]: g, [f]: h };
  } };
}, z2 = function(e) {
  return e === void 0 && (e = {}), { name: "size", options: e, async fn(t) {
    const { placement: n, rects: r, platform: a, elements: i } = t, { apply: o, ...s } = e, l = await ci(t, s), c = Cr(n), u = Ri(n);
    let d, f;
    c === "top" || c === "bottom" ? (d = c, f = u === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (f = c, d = u === "end" ? "top" : "bottom");
    const g = fr(l.left, 0), h = fr(l.right, 0), p = fr(l.top, 0), m = fr(l.bottom, 0), v = { availableHeight: r.floating.height - (["left", "right"].includes(n) ? 2 * (p !== 0 || m !== 0 ? p + m : fr(l.top, l.bottom)) : l[d]), availableWidth: r.floating.width - (["top", "bottom"].includes(n) ? 2 * (g !== 0 || h !== 0 ? g + h : fr(l.left, l.right)) : l[f]) }, y = await a.getDimensions(i.floating);
    o == null || o({ ...t, ...v });
    const E = await a.getDimensions(i.floating);
    return y.width !== E.width || y.height !== E.height ? { reset: { rects: !0 } } : {};
  } };
};
function TA(e) {
  return e && e.document && e.location && e.alert && e.setInterval;
}
function _n(e) {
  if (e == null) return window;
  if (!TA(e)) {
    const t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Ai(e) {
  return _n(e).getComputedStyle(e);
}
function mn(e) {
  return TA(e) ? "" : e ? (e.nodeName || "").toLowerCase() : "";
}
function RA() {
  const e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map((t) => t.brand + "/" + t.version).join(" ") : navigator.userAgent;
}
function Qt(e) {
  return e instanceof _n(e).HTMLElement;
}
function Hn(e) {
  return e instanceof _n(e).Element;
}
function _h(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof _n(e).ShadowRoot || e instanceof ShadowRoot;
}
function ms(e) {
  const { overflow: t, overflowX: n, overflowY: r } = Ai(e);
  return /auto|scroll|overlay|hidden/.test(t + r + n);
}
function W2(e) {
  return ["table", "td", "th"].includes(mn(e));
}
function Av(e) {
  const t = /firefox/i.test(RA()), n = Ai(e);
  return n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].includes(n.willChange) || t && n.willChange === "filter" || t && !!n.filter && n.filter !== "none";
}
function AA() {
  return !/^((?!chrome|android).)*safari/i.test(RA());
}
const xv = Math.min, Qa = Math.max, Yo = Math.round;
function bn(e, t, n) {
  var r, a, i, o;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect();
  let l = 1, c = 1;
  t && Qt(e) && (l = e.offsetWidth > 0 && Yo(s.width) / e.offsetWidth || 1, c = e.offsetHeight > 0 && Yo(s.height) / e.offsetHeight || 1);
  const u = Hn(e) ? _n(e) : window, d = !AA() && n, f = (s.left + (d && (r = (a = u.visualViewport) == null ? void 0 : a.offsetLeft) != null ? r : 0)) / l, g = (s.top + (d && (i = (o = u.visualViewport) == null ? void 0 : o.offsetTop) != null ? i : 0)) / c, h = s.width / l, p = s.height / c;
  return { width: h, height: p, top: g, right: f + h, bottom: g + p, left: f, x: f, y: g };
}
function Bn(e) {
  return (t = e, (t instanceof _n(t).Node ? e.ownerDocument : e.document) || window.document).documentElement;
  var t;
}
function bs(e) {
  return Hn(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function xA(e) {
  return bn(Bn(e)).left + bs(e).scrollLeft;
}
function q2(e, t, n) {
  const r = Qt(t), a = Bn(t), i = bn(e, r && function(l) {
    const c = bn(l);
    return Yo(c.width) !== l.offsetWidth || Yo(c.height) !== l.offsetHeight;
  }(t), n === "fixed");
  let o = { scrollLeft: 0, scrollTop: 0 };
  const s = { x: 0, y: 0 };
  if (r || !r && n !== "fixed") if ((mn(t) !== "body" || ms(a)) && (o = bs(t)), Qt(t)) {
    const l = bn(t, !0);
    s.x = l.x + t.clientLeft, s.y = l.y + t.clientTop;
  } else a && (s.x = xA(a));
  return { x: i.left + o.scrollLeft - s.x, y: i.top + o.scrollTop - s.y, width: i.width, height: i.height };
}
function CA(e) {
  return mn(e) === "html" ? e : e.assignedSlot || e.parentNode || (_h(e) ? e.host : null) || Bn(e);
}
function Cv(e) {
  return Qt(e) && getComputedStyle(e).position !== "fixed" ? e.offsetParent : null;
}
function dg(e) {
  const t = _n(e);
  let n = Cv(e);
  for (; n && W2(n) && getComputedStyle(n).position === "static"; ) n = Cv(n);
  return n && (mn(n) === "html" || mn(n) === "body" && getComputedStyle(n).position === "static" && !Av(n)) ? t : n || function(r) {
    let a = CA(r);
    for (_h(a) && (a = a.host); Qt(a) && !["html", "body"].includes(mn(a)); ) {
      if (Av(a)) return a;
      a = a.parentNode;
    }
    return null;
  }(e) || t;
}
function Nv(e) {
  if (Qt(e)) return { width: e.offsetWidth, height: e.offsetHeight };
  const t = bn(e);
  return { width: t.width, height: t.height };
}
function NA(e) {
  const t = CA(e);
  return ["html", "body", "#document"].includes(mn(t)) ? e.ownerDocument.body : Qt(t) && ms(t) ? t : NA(t);
}
function Ko(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = NA(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = _n(r), o = a ? [i].concat(i.visualViewport || [], ms(r) ? r : []) : r, s = t.concat(o);
  return a ? s : s.concat(Ko(o));
}
function Iv(e, t, n) {
  return t === "viewport" ? Vo(function(r, a) {
    const i = _n(r), o = Bn(r), s = i.visualViewport;
    let l = o.clientWidth, c = o.clientHeight, u = 0, d = 0;
    if (s) {
      l = s.width, c = s.height;
      const f = AA();
      (f || !f && a === "fixed") && (u = s.offsetLeft, d = s.offsetTop);
    }
    return { width: l, height: c, x: u, y: d };
  }(e, n)) : Hn(t) ? function(r, a) {
    const i = bn(r, !1, a === "fixed"), o = i.top + r.clientTop, s = i.left + r.clientLeft;
    return { top: o, left: s, x: s, y: o, right: s + r.clientWidth, bottom: o + r.clientHeight, width: r.clientWidth, height: r.clientHeight };
  }(t, n) : Vo(function(r) {
    var a;
    const i = Bn(r), o = bs(r), s = (a = r.ownerDocument) == null ? void 0 : a.body, l = Qa(i.scrollWidth, i.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), c = Qa(i.scrollHeight, i.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0);
    let u = -o.scrollLeft + xA(r);
    const d = -o.scrollTop;
    return Ai(s || i).direction === "rtl" && (u += Qa(i.clientWidth, s ? s.clientWidth : 0) - l), { width: l, height: c, x: u, y: d };
  }(Bn(e)));
}
function V2(e) {
  const t = Ko(e), n = ["absolute", "fixed"].includes(Ai(e).position) && Qt(e) ? dg(e) : e;
  return Hn(n) ? t.filter((r) => Hn(r) && function(a, i) {
    const o = i.getRootNode == null ? void 0 : i.getRootNode();
    if (a.contains(i)) return !0;
    if (o && _h(o)) {
      let s = i;
      do {
        if (s && a === s) return !0;
        s = s.parentNode || s.host;
      } while (s);
    }
    return !1;
  }(r, n) && mn(r) !== "body") : [];
}
const j2 = { getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: r, strategy: a } = e;
  const i = [...n === "clippingAncestors" ? V2(t) : [].concat(n), r], o = i[0], s = i.reduce((l, c) => {
    const u = Iv(t, c, a);
    return l.top = Qa(u.top, l.top), l.right = xv(u.right, l.right), l.bottom = xv(u.bottom, l.bottom), l.left = Qa(u.left, l.left), l;
  }, Iv(t, o, a));
  return { width: s.right - s.left, height: s.bottom - s.top, x: s.left, y: s.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: n, strategy: r } = e;
  const a = Qt(n), i = Bn(n);
  if (n === i) return t;
  let o = { scrollLeft: 0, scrollTop: 0 };
  const s = { x: 0, y: 0 };
  if ((a || !a && r !== "fixed") && ((mn(n) !== "body" || ms(i)) && (o = bs(n)), Qt(n))) {
    const l = bn(n, !0);
    s.x = l.x + n.clientLeft, s.y = l.y + n.clientTop;
  }
  return { ...t, x: t.x - o.scrollLeft + s.x, y: t.y - o.scrollTop + s.y };
}, isElement: Hn, getDimensions: Nv, getOffsetParent: dg, getDocumentElement: Bn, getElementRects: (e) => {
  let { reference: t, floating: n, strategy: r } = e;
  return { reference: q2(t, dg(n), r), floating: { ...Nv(n), x: 0, y: 0 } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => Ai(e).direction === "rtl" };
function Y2(e, t, n, r) {
  r === void 0 && (r = {});
  const { ancestorScroll: a = !0, ancestorResize: i = !0, elementResize: o = !0, animationFrame: s = !1 } = r, l = a && !s, c = i && !s, u = l || c ? [...Hn(e) ? Ko(e) : [], ...Ko(t)] : [];
  u.forEach((h) => {
    l && h.addEventListener("scroll", n, { passive: !0 }), c && h.addEventListener("resize", n);
  });
  let d, f = null;
  if (o) {
    let h = !0;
    f = new ResizeObserver(() => {
      h || n(), h = !1;
    }), Hn(e) && !s && f.observe(e), f.observe(t);
  }
  let g = s ? bn(e) : null;
  return s && function h() {
    const p = bn(e);
    !g || p.x === g.x && p.y === g.y && p.width === g.width && p.height === g.height || n(), g = p, d = requestAnimationFrame(h);
  }(), n(), () => {
    var h;
    u.forEach((p) => {
      l && p.removeEventListener("scroll", n), c && p.removeEventListener("resize", n);
    }), (h = f) == null || h.disconnect(), f = null, s && cancelAnimationFrame(d);
  };
}
const K2 = (e, t, n) => D2(e, t, { platform: j2, ...n });
var fg = typeof document < "u" ? Rr : ye;
function pg(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!pg(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = a[r];
      if (!(i === "_owner" && e.$$typeof) && !pg(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function X2(e) {
  const t = b.useRef(e);
  return fg(() => {
    t.current = e;
  }), t;
}
function Z2(e) {
  let {
    middleware: t,
    placement: n = "bottom",
    strategy: r = "absolute",
    whileElementsMounted: a
  } = e === void 0 ? {} : e;
  const i = b.useRef(null), o = b.useRef(null), s = X2(a), l = b.useRef(null), [c, u] = b.useState({
    // Setting these to `null` will allow the consumer to determine if
    // `computePosition()` has run yet
    x: null,
    y: null,
    strategy: r,
    placement: n,
    middlewareData: {}
  }), [d, f] = b.useState(t);
  pg(d == null ? void 0 : d.map((E) => {
    let {
      options: S
    } = E;
    return S;
  }), t == null ? void 0 : t.map((E) => {
    let {
      options: S
    } = E;
    return S;
  })) || f(t);
  const g = b.useCallback(() => {
    !i.current || !o.current || K2(i.current, o.current, {
      middleware: d,
      placement: n,
      strategy: r
    }).then((E) => {
      h.current && sa.flushSync(() => {
        u(E);
      });
    });
  }, [d, n, r]);
  fg(() => {
    h.current && g();
  }, [g]);
  const h = b.useRef(!1);
  fg(() => (h.current = !0, () => {
    h.current = !1;
  }), []);
  const p = b.useCallback(() => {
    if (typeof l.current == "function" && (l.current(), l.current = null), i.current && o.current)
      if (s.current) {
        const E = s.current(i.current, o.current, g);
        l.current = E;
      } else
        g();
  }, [g, s]), m = b.useCallback((E) => {
    i.current = E, p();
  }, [p]), v = b.useCallback((E) => {
    o.current = E, p();
  }, [p]), y = b.useMemo(() => ({
    reference: i,
    floating: o
  }), []);
  return b.useMemo(() => ({
    ...c,
    update: g,
    refs: y,
    reference: m,
    floating: v
  }), [c, g, y, m, v]);
}
const Q2 = (e) => {
  const {
    element: t,
    padding: n
  } = e;
  function r(a) {
    return Object.prototype.hasOwnProperty.call(a, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(a) {
      return r(t) ? t.current != null ? wv({
        element: t.current,
        padding: n
      }).fn(a) : {} : t ? wv({
        element: t,
        padding: n
      }).fn(a) : {};
    }
  };
};
function J2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function eB(...e) {
  return (t) => e.forEach(
    (n) => J2(n, t)
  );
}
const IA = /* @__PURE__ */ _e((e, t) => {
  const { children: n, ...r } = e, a = at.toArray(n), i = a.find(nB);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? at.count(o) > 1 ? at.only(null) : /* @__PURE__ */ Nt(o) ? o.props.children : null : l);
    return /* @__PURE__ */ V(gg, Pe({}, r, {
      ref: t
    }), /* @__PURE__ */ Nt(o) ? /* @__PURE__ */ Ar(o, void 0, s) : null);
  }
  return /* @__PURE__ */ V(gg, Pe({}, r, {
    ref: t
  }), n);
});
IA.displayName = "Slot";
const gg = /* @__PURE__ */ _e((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Nt(n) ? /* @__PURE__ */ Ar(n, {
    ...rB(r, n.props),
    ref: eB(t, n.ref)
  }) : at.count(n) > 1 ? at.only(null) : null;
});
gg.displayName = "SlotClone";
const tB = ({ children: e }) => /* @__PURE__ */ V(Hg, null, e);
function nB(e) {
  return /* @__PURE__ */ Nt(e) && e.type === tB;
}
function rB(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...i
    } : r === "className" && (n[r] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const aB = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], TX = aB.reduce((e, t) => {
  const n = /* @__PURE__ */ _e((r, a) => {
    const { asChild: i, ...o } = r, s = i ? IA : t;
    return ye(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Pe({}, o, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function iB(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function kA(...e) {
  return (t) => e.forEach(
    (n) => iB(n, t)
  );
}
function OA(...e) {
  return Fn(kA(...e), e);
}
function oB(e, t = []) {
  let n = [];
  function r(i, o) {
    const s = /* @__PURE__ */ Ct(o), l = n.length;
    n = [
      ...n,
      o
    ];
    function c(d) {
      const { scope: f, children: g, ...h } = d, p = (f == null ? void 0 : f[e][l]) || s, m = yn(
        () => h,
        Object.values(h)
      );
      return /* @__PURE__ */ V(p.Provider, {
        value: m
      }, g);
    }
    function u(d, f) {
      const g = (f == null ? void 0 : f[e][l]) || s, h = tn(g);
      if (h) return h;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      u
    ];
  }
  const a = () => {
    const i = n.map((o) => /* @__PURE__ */ Ct(o));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return yn(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return a.scopeName = e, [
    r,
    sB(a, ...t)
  ];
}
function sB(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return yn(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const DA = /* @__PURE__ */ _e((e, t) => {
  const { children: n, ...r } = e, a = at.toArray(n), i = a.find(cB);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? at.count(o) > 1 ? at.only(null) : /* @__PURE__ */ Nt(o) ? o.props.children : null : l);
    return /* @__PURE__ */ V(hg, Pe({}, r, {
      ref: t
    }), /* @__PURE__ */ Nt(o) ? /* @__PURE__ */ Ar(o, void 0, s) : null);
  }
  return /* @__PURE__ */ V(hg, Pe({}, r, {
    ref: t
  }), n);
});
DA.displayName = "Slot";
const hg = /* @__PURE__ */ _e((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Nt(n) ? /* @__PURE__ */ Ar(n, {
    ...uB(r, n.props),
    ref: kA(t, n.ref)
  }) : at.count(n) > 1 ? at.only(null) : null;
});
hg.displayName = "SlotClone";
const lB = ({ children: e }) => /* @__PURE__ */ V(Hg, null, e);
function cB(e) {
  return /* @__PURE__ */ Nt(e) && e.type === lB;
}
function uB(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...i
    } : r === "className" && (n[r] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const dB = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], mg = dB.reduce((e, t) => {
  const n = /* @__PURE__ */ _e((r, a) => {
    const { asChild: i, ...o } = r, s = i ? DA : t;
    return ye(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ V(s, Pe({}, o, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function fB(e) {
  const t = Ye(e);
  return ye(() => {
    t.current = e;
  }), yn(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
const Ha = globalThis != null && globalThis.document ? Rr : () => {
};
function pB(e) {
  const [t, n] = He(void 0);
  return Ha(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          o = c.inlineSize, s = c.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        n({
          width: o,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const LA = "Popper", [Th, MA] = oB(LA), [gB, PA] = Th(LA), hB = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = He(null);
  return /* @__PURE__ */ V(gB, {
    scope: t,
    anchor: r,
    onAnchorChange: a
  }, n);
}, mB = "PopperAnchor", bB = /* @__PURE__ */ _e((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...a } = e, i = PA(mB, n), o = Ye(null), s = OA(t, o);
  return ye(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || o.current);
  }), r ? null : /* @__PURE__ */ V(mg.div, Pe({}, a, {
    ref: s
  }));
}), Xo = "PopperContent", [vB, RX] = Th(Xo), [yB, EB] = Th(Xo, {
  hasParent: !1,
  positionUpdateFns: /* @__PURE__ */ new Set()
}), SB = /* @__PURE__ */ _e((e, t) => {
  var n, r, a, i, o, s, l, c;
  const { __scopePopper: u, side: d = "bottom", sideOffset: f = 0, align: g = "center", alignOffset: h = 0, arrowPadding: p = 0, collisionBoundary: m = [], collisionPadding: v = 0, sticky: y = "partial", hideWhenDetached: E = !1, avoidCollisions: S = !0, onPlaced: w, ...R } = e, T = PA(Xo, u), [A, C] = He(null), N = OA(
    t,
    (Ge) => C(Ge)
  ), [L, I] = He(null), k = pB(L), B = (n = k == null ? void 0 : k.width) !== null && n !== void 0 ? n : 0, F = (r = k == null ? void 0 : k.height) !== null && r !== void 0 ? r : 0, P = d + (g !== "center" ? "-" + g : ""), D = typeof v == "number" ? v : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  }, O = Array.isArray(m) ? m : [
    m
  ], M = O.length > 0, W = {
    padding: D,
    boundary: O.filter(_B),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: M
  }, { reference: U, floating: q, strategy: re, x: j, y: ie, placement: Q, middlewareData: H, update: K } = Z2({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: P,
    whileElementsMounted: Y2,
    middleware: [
      TB(),
      U2({
        mainAxis: f + F,
        alignmentAxis: h
      }),
      S ? G2({
        mainAxis: !0,
        crossAxis: !1,
        limiter: y === "partial" ? H2() : void 0,
        ...W
      }) : void 0,
      L ? Q2({
        element: L,
        padding: p
      }) : void 0,
      S ? $2({
        ...W
      }) : void 0,
      z2({
        ...W,
        apply: ({ elements: Ge, availableWidth: ot, availableHeight: Et }) => {
          Ge.floating.style.setProperty("--radix-popper-available-width", `${ot}px`), Ge.floating.style.setProperty("--radix-popper-available-height", `${Et}px`);
        }
      }),
      RB({
        arrowWidth: B,
        arrowHeight: F
      }),
      E ? B2({
        strategy: "referenceHidden"
      }) : void 0
    ].filter(wB)
  });
  Ha(() => {
    U(T.anchor);
  }, [
    U,
    T.anchor
  ]);
  const J = j !== null && ie !== null, [ne, ee] = FA(Q), ae = fB(w);
  Ha(() => {
    J && (ae == null || ae());
  }, [
    J,
    ae
  ]);
  const he = (a = H.arrow) === null || a === void 0 ? void 0 : a.x, $ = (i = H.arrow) === null || i === void 0 ? void 0 : i.y, Y = ((o = H.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [Ee, Te] = He();
  Ha(() => {
    A && Te(window.getComputedStyle(A).zIndex);
  }, [
    A
  ]);
  const { hasParent: Ue, positionUpdateFns: oe } = EB(Xo, u), Re = !Ue;
  Rr(() => {
    if (!Re)
      return oe.add(K), () => {
        oe.delete(K);
      };
  }, [
    Re,
    oe,
    K
  ]), Ha(() => {
    Re && J && Array.from(oe).reverse().forEach(
      (Ge) => requestAnimationFrame(Ge)
    );
  }, [
    Re,
    J,
    oe
  ]);
  const zt = {
    "data-side": ne,
    "data-align": ee,
    ...R,
    ref: N,
    style: {
      ...R.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: J ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (s = H.hide) !== null && s !== void 0 && s.referenceHidden ? 0 : void 0
    }
  };
  return /* @__PURE__ */ V("div", {
    ref: q,
    "data-radix-popper-content-wrapper": "",
    style: {
      position: re,
      left: 0,
      top: 0,
      transform: J ? `translate3d(${Math.round(j)}px, ${Math.round(ie)}px, 0)` : "translate3d(0, -200%, 0)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Ee,
      "--radix-popper-transform-origin": [
        (l = H.transformOrigin) === null || l === void 0 ? void 0 : l.x,
        (c = H.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ V(vB, {
    scope: u,
    placedSide: ne,
    onArrowChange: I,
    arrowX: he,
    arrowY: $,
    shouldHideArrow: Y
  }, Re ? /* @__PURE__ */ V(yB, {
    scope: u,
    hasParent: !0,
    positionUpdateFns: oe
  }, /* @__PURE__ */ V(mg.div, zt)) : /* @__PURE__ */ V(mg.div, zt)));
});
function wB(e) {
  return e !== void 0;
}
function _B(e) {
  return e !== null;
}
const TB = () => ({
  name: "anchorCssProperties",
  fn(e) {
    const { rects: t, elements: n } = e, { width: r, height: a } = t.reference;
    return n.floating.style.setProperty("--radix-popper-anchor-width", `${r}px`), n.floating.style.setProperty("--radix-popper-anchor-height", `${a}px`), {};
  }
}), RB = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, a, i, o;
    const { placement: s, rects: l, middlewareData: c } = t, d = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : e.arrowWidth, g = d ? 0 : e.arrowHeight, [h, p] = FA(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[p], v = ((r = (a = c.arrow) === null || a === void 0 ? void 0 : a.x) !== null && r !== void 0 ? r : 0) + f / 2, y = ((i = (o = c.arrow) === null || o === void 0 ? void 0 : o.y) !== null && i !== void 0 ? i : 0) + g / 2;
    let E = "", S = "";
    return h === "bottom" ? (E = d ? m : `${v}px`, S = `${-g}px`) : h === "top" ? (E = d ? m : `${v}px`, S = `${l.floating.height + g}px`) : h === "right" ? (E = `${-g}px`, S = d ? m : `${y}px`) : h === "left" && (E = `${l.floating.width + g}px`, S = d ? m : `${y}px`), {
      data: {
        x: E,
        y: S
      }
    };
  }
});
function FA(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const AB = hB, xB = bB, CB = SB, NB = /* @__PURE__ */ _e((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...a } = e;
  return r ? /* @__PURE__ */ zg.createPortal(/* @__PURE__ */ V(hs.div, Pe({}, a, {
    ref: t
  })), r) : null;
});
function IB(e, t) {
  return Zk((n, r) => {
    const a = t[n][r];
    return a ?? n;
  }, e);
}
const Rh = (e) => {
  const { present: t, children: n } = e, r = kB(t), a = typeof n == "function" ? n({
    present: r.isPresent
  }) : at.only(n), i = Ti(r.ref, a.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Ar(a, {
    ref: i
  }) : null;
};
Rh.displayName = "Presence";
function kB(e) {
  const [t, n] = He(), r = Ye({}), a = Ye(e), i = Ye("none"), o = e ? "mounted" : "unmounted", [s, l] = IB(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ye(() => {
    const c = no(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [
    s
  ]), cg(() => {
    const c = r.current, u = a.current;
    if (u !== e) {
      const f = i.current, g = no(c);
      e ? l("MOUNT") : g === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== g ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    l
  ]), cg(() => {
    if (t) {
      const c = (d) => {
        const g = no(r.current).includes(d.animationName);
        d.target === t && g && jT(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = no(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Fn((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function no(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function OB({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = DB({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, o = i ? e : r, s = Er(n), l = Fn((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && s(d);
    } else a(c);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    o,
    l
  ];
}
function DB({ defaultProp: e, onChange: t }) {
  const n = He(e), [r] = n, a = Ye(r), i = Er(t);
  return ye(() => {
    a.current !== r && (i(r), a.current = r);
  }, [
    r,
    a,
    i
  ]), n;
}
var LB = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Pr = /* @__PURE__ */ new WeakMap(), ro = /* @__PURE__ */ new WeakMap(), ao = {}, pl = 0, $A = function(e) {
  return e && (e.host || $A(e.parentNode));
}, MB = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = $A(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, PB = function(e, t, n, r) {
  var a = MB(t, Array.isArray(e) ? e : [e]);
  ao[n] || (ao[n] = /* @__PURE__ */ new WeakMap());
  var i = ao[n], o = [], s = /* @__PURE__ */ new Set(), l = new Set(a), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  a.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (s.has(f))
        u(f);
      else
        try {
          var g = f.getAttribute(r), h = g !== null && g !== "false", p = (Pr.get(f) || 0) + 1, m = (i.get(f) || 0) + 1;
          Pr.set(f, p), i.set(f, m), o.push(f), p === 1 && h && ro.set(f, !0), m === 1 && f.setAttribute(n, "true"), h || f.setAttribute(r, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", f, v);
        }
    });
  };
  return u(t), s.clear(), pl++, function() {
    o.forEach(function(d) {
      var f = Pr.get(d) - 1, g = i.get(d) - 1;
      Pr.set(d, f), i.set(d, g), f || (ro.has(d) || d.removeAttribute(r), ro.delete(d)), g || d.removeAttribute(n);
    }), pl--, pl || (Pr = /* @__PURE__ */ new WeakMap(), Pr = /* @__PURE__ */ new WeakMap(), ro = /* @__PURE__ */ new WeakMap(), ao = {});
  };
}, vs = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), a = LB(e);
  return a ? (r.push.apply(r, Array.from(a.querySelectorAll("[aria-live]"))), PB(r, a, n, "aria-hidden")) : function() {
    return null;
  };
}, we = function() {
  return we = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, we.apply(this, arguments);
};
function xi(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function ys(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, i; r < a; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Zr = "right-scroll-bar-position", Qr = "width-before-scroll-bar", FB = "with-scroll-bars-hidden", $B = "--removed-body-scroll-bar-size";
function gl(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function BB(e, t) {
  var n = He(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var UB = typeof window < "u" ? b.useLayoutEffect : b.useEffect, kv = /* @__PURE__ */ new WeakMap();
function Ah(e, t) {
  var n = BB(null, function(r) {
    return e.forEach(function(a) {
      return gl(a, r);
    });
  });
  return UB(function() {
    var r = kv.get(n);
    if (r) {
      var a = new Set(r), i = new Set(e), o = n.current;
      a.forEach(function(s) {
        i.has(s) || gl(s, null);
      }), i.forEach(function(s) {
        a.has(s) || gl(s, o);
      });
    }
    kv.set(n, e);
  }, [e]), n;
}
function GB(e) {
  return e;
}
function HB(e, t) {
  t === void 0 && (t = GB);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, r);
      return n.push(o), function() {
        n = n.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var o = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), o = n;
      }
      var l = function() {
        var u = o;
        o = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          o.push(u), c();
        },
        filter: function(u) {
          return o = o.filter(u), n;
        }
      };
    }
  };
  return a;
}
function Es(e) {
  e === void 0 && (e = {});
  var t = HB(null);
  return t.options = we({ async: !0, ssr: !1 }, e), t;
}
var BA = function(e) {
  var t = e.sideCar, n = xi(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return b.createElement(r, we({}, n));
};
BA.isSideCarExport = !0;
function Ss(e, t) {
  return e.useMedium(t), BA;
}
var UA = Es(), hl = function() {
}, ws = b.forwardRef(function(e, t) {
  var n = b.useRef(null), r = b.useState({
    onScrollCapture: hl,
    onWheelCapture: hl,
    onTouchMoveCapture: hl
  }), a = r[0], i = r[1], o = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, g = e.noIsolation, h = e.inert, p = e.allowPinchZoom, m = e.as, v = m === void 0 ? "div" : m, y = xi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), E = f, S = Ah([n, t]), w = we(we({}, y), a);
  return b.createElement(
    b.Fragment,
    null,
    u && b.createElement(E, { sideCar: UA, removeScrollBar: c, shards: d, noIsolation: g, inert: h, setCallbacks: i, allowPinchZoom: !!p, lockRef: n }),
    o ? b.cloneElement(b.Children.only(s), we(we({}, w), { ref: S })) : b.createElement(v, we({}, w, { className: l, ref: S }), s)
  );
});
ws.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ws.classNames = {
  fullWidth: Qr,
  zeroRight: Zr
};
var GA = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function zB() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = GA();
  return t && e.setAttribute("nonce", t), e;
}
function WB(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function qB(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var VB = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = zB()) && (WB(t, n), qB(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, jB = function() {
  var e = VB();
  return function(t, n) {
    b.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Ci = function() {
  var e = jB(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, YB = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ml = function(e) {
  return parseInt(e || "", 10) || 0;
}, KB = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ml(n), ml(r), ml(a)];
}, XB = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return YB;
  var t = KB(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, ZB = Ci(), Jr = "data-scroll-locked", QB = function(e, t, n, r) {
  var a = e.left, i = e.top, o = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(FB, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Jr, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Zr, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Qr, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Zr, " .").concat(Zr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Qr, " .").concat(Qr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Jr, `] {
    `).concat($B, ": ").concat(s, `px;
  }
`);
}, Ov = function() {
  var e = parseInt(document.body.getAttribute(Jr) || "0", 10);
  return isFinite(e) ? e : 0;
}, JB = function() {
  b.useEffect(function() {
    return document.body.setAttribute(Jr, (Ov() + 1).toString()), function() {
      var e = Ov() - 1;
      e <= 0 ? document.body.removeAttribute(Jr) : document.body.setAttribute(Jr, e.toString());
    };
  }, []);
}, xh = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r;
  JB();
  var i = b.useMemo(function() {
    return XB(a);
  }, [a]);
  return b.createElement(ZB, { styles: QB(i, !t, a, n ? "" : "!important") });
}, bg = !1;
if (typeof window < "u")
  try {
    var io = Object.defineProperty({}, "passive", {
      get: function() {
        return bg = !0, !0;
      }
    });
    window.addEventListener("test", io, io), window.removeEventListener("test", io, io);
  } catch {
    bg = !1;
  }
var Fr = bg ? { passive: !1 } : !1, eU = function(e) {
  return e.tagName === "TEXTAREA";
}, HA = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !eU(e) && n[t] === "visible")
  );
}, tU = function(e) {
  return HA(e, "overflowY");
}, nU = function(e) {
  return HA(e, "overflowX");
}, Dv = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = zA(e, n);
    if (r) {
      var a = WA(e, n), i = a[1], o = a[2];
      if (i > o)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, rU = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, aU = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, zA = function(e, t) {
  return e === "v" ? tU(t) : nU(t);
}, WA = function(e, t) {
  return e === "v" ? rU(t) : aU(t);
}, iU = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, oU = function(e, t, n, r, a) {
  var i = iU(e, window.getComputedStyle(t).direction), o = i * r, s = n.target, l = t.contains(s), c = !1, u = o > 0, d = 0, f = 0;
  do {
    var g = WA(e, s), h = g[0], p = g[1], m = g[2], v = p - m - i * h;
    (h || v) && zA(e, s) && (d += v, f += h), s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && (d === 0 || !a) || !u && (f === 0 || !a)) && (c = !0), c;
}, oo = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Lv = function(e) {
  return [e.deltaX, e.deltaY];
}, Mv = function(e) {
  return e && "current" in e ? e.current : e;
}, sU = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, lU = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, cU = 0, $r = [];
function uU(e) {
  var t = b.useRef([]), n = b.useRef([0, 0]), r = b.useRef(), a = b.useState(cU++)[0], i = b.useState(function() {
    return Ci();
  })[0], o = b.useRef(e);
  b.useEffect(function() {
    o.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = ys([e.lockRef.current], (e.shards || []).map(Mv), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = b.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var v = oo(p), y = n.current, E = "deltaX" in p ? p.deltaX : y[0] - v[0], S = "deltaY" in p ? p.deltaY : y[1] - v[1], w, R = p.target, T = Math.abs(E) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && T === "h" && R.type === "range")
      return !1;
    var A = Dv(T, R);
    if (!A)
      return !0;
    if (A ? w = T : (w = T === "v" ? "h" : "v", A = Dv(T, R)), !A)
      return !1;
    if (!r.current && "changedTouches" in p && (E || S) && (r.current = w), !w)
      return !0;
    var C = r.current || w;
    return oU(C, m, p, C === "h" ? E : S, !0);
  }, []), l = b.useCallback(function(p) {
    var m = p;
    if (!(!$r.length || $r[$r.length - 1] !== i)) {
      var v = "deltaY" in m ? Lv(m) : oo(m), y = t.current.filter(function(w) {
        return w.name === m.type && w.target === m.target && sU(w.delta, v);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var E = (o.current.shards || []).map(Mv).filter(Boolean).filter(function(w) {
          return w.contains(m.target);
        }), S = E.length > 0 ? s(m, E[0]) : !o.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = b.useCallback(function(p, m, v, y) {
    var E = { name: p, delta: m, target: v, should: y };
    t.current.push(E), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== E;
      });
    }, 1);
  }, []), u = b.useCallback(function(p) {
    n.current = oo(p), r.current = void 0;
  }, []), d = b.useCallback(function(p) {
    c(p.type, Lv(p), p.target, s(p, e.lockRef.current));
  }, []), f = b.useCallback(function(p) {
    c(p.type, oo(p), p.target, s(p, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return $r.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Fr), document.addEventListener("touchmove", l, Fr), document.addEventListener("touchstart", u, Fr), function() {
      $r = $r.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", l, Fr), document.removeEventListener("touchmove", l, Fr), document.removeEventListener("touchstart", u, Fr);
    };
  }, []);
  var g = e.removeScrollBar, h = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    h ? b.createElement(i, { styles: lU(a) }) : null,
    g ? b.createElement(xh, { gapMode: "margin" }) : null
  );
}
const dU = Ss(UA, uU);
var qA = b.forwardRef(function(e, t) {
  return b.createElement(ws, we({}, e, { ref: t, sideCar: dU }));
});
qA.classNames = ws.classNames;
const VA = "Popover", [jA, AX] = l2(VA, [
  MA
]), Ch = MA(), [fU, fa] = jA(VA), pU = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: a, onOpenChange: i, modal: o = !1 } = e, s = Ch(t), l = Ye(null), [c, u] = He(!1), [d = !1, f] = OB({
    prop: r,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ V(AB, s, /* @__PURE__ */ V(fU, {
    scope: t,
    contentId: O2(),
    triggerRef: l,
    open: d,
    onOpenChange: f,
    onOpenToggle: Fn(
      () => f(
        (g) => !g
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: c,
    onCustomAnchorAdd: Fn(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: Fn(
      () => u(!1),
      []
    ),
    modal: o
  }, n));
}, gU = "PopoverTrigger", hU = /* @__PURE__ */ _e((e, t) => {
  const { __scopePopover: n, ...r } = e, a = fa(gU, n), i = Ch(n), o = Ti(t, a.triggerRef), s = /* @__PURE__ */ V(hs.button, Pe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": a.open,
    "aria-controls": a.contentId,
    "data-state": XA(a.open)
  }, r, {
    ref: o,
    onClick: mr(e.onClick, a.onOpenToggle)
  }));
  return a.hasCustomAnchor ? s : /* @__PURE__ */ V(xB, Pe({
    asChild: !0
  }, i), s);
}), YA = "PopoverPortal", [mU, bU] = jA(YA, {
  forceMount: void 0
}), vU = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: a } = e, i = fa(YA, t);
  return /* @__PURE__ */ V(mU, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ V(Rh, {
    present: n || i.open
  }, /* @__PURE__ */ V(NB, {
    asChild: !0,
    container: a
  }, r)));
}, ui = "PopoverContent", yU = /* @__PURE__ */ _e((e, t) => {
  const n = bU(ui, e.__scopePopover), { forceMount: r = n.forceMount, ...a } = e, i = fa(ui, e.__scopePopover);
  return /* @__PURE__ */ V(Rh, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ V(EU, Pe({}, a, {
    ref: t
  })) : /* @__PURE__ */ V(SU, Pe({}, a, {
    ref: t
  })));
}), EU = /* @__PURE__ */ _e((e, t) => {
  const n = fa(ui, e.__scopePopover), r = Ye(null), a = Ti(t, r), i = Ye(!1);
  return ye(() => {
    const o = r.current;
    if (o) return vs(o);
  }, []), /* @__PURE__ */ V(qA, {
    as: Sh,
    allowPinchZoom: !0
  }, /* @__PURE__ */ V(KA, Pe({}, e, {
    ref: a,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: mr(e.onCloseAutoFocus, (o) => {
      var s;
      o.preventDefault(), i.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: mr(e.onPointerDownOutside, (o) => {
      const s = o.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
      i.current = c;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: mr(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), SU = /* @__PURE__ */ _e((e, t) => {
  const n = fa(ui, e.__scopePopover), r = Ye(!1);
  return /* @__PURE__ */ V(KA, Pe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
        var o;
        r.current || (o = n.triggerRef.current) === null || o === void 0 || o.focus(), a.preventDefault();
      }
      r.current = !1;
    },
    onInteractOutside: (a) => {
      var i, o;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0);
      const s = a.target;
      ((o = n.triggerRef.current) === null || o === void 0 ? void 0 : o.contains(s)) && a.preventDefault();
    }
  }));
}), KA = /* @__PURE__ */ _e((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: l, onFocusOutside: c, onInteractOutside: u, ...d } = e, f = fa(ui, n), g = Ch(n);
  return w2(), /* @__PURE__ */ V(_2, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ V(y2, {
    asChild: !0,
    disableOutsidePointerEvents: o,
    onInteractOutside: u,
    onEscapeKeyDown: s,
    onPointerDownOutside: l,
    onFocusOutside: c,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ V(CB, Pe({
    "data-state": XA(f.open),
    role: "dialog",
    id: f.contentId
  }, g, d, {
    ref: t,
    style: {
      ...d.style,
      // re-namespace exposed content custom property
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)"
    }
  }))));
});
function XA(e) {
  return e ? "open" : "closed";
}
const wU = pU, _U = hU, TU = vU, ZA = yU, RU = wU, AU = _U, QA = b.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, a) => /* @__PURE__ */ _(TU, { children: /* @__PURE__ */ _(
  ZA,
  {
    ref: a,
    align: t,
    sideOffset: n,
    className: de(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
QA.displayName = ZA.displayName;
function Pv(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function et(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function xU(e, t = []) {
  let n = [];
  function r(i, o) {
    const s = b.createContext(o), l = n.length;
    n = [...n, o];
    function c(d) {
      const { scope: f, children: g, ...h } = d, p = (f == null ? void 0 : f[e][l]) || s, m = b.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ _(p.Provider, { value: m, children: g });
    }
    function u(d, f) {
      const g = (f == null ? void 0 : f[e][l]) || s, h = b.useContext(g);
      if (h) return h;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [c, u];
  }
  const a = () => {
    const i = n.map((o) => b.createContext(o));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return a.scopeName = e, [r, CU(a, ...t)];
}
function CU(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const o = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function NU(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function IU(...e) {
  return (t) => e.forEach((n) => NU(n, t));
}
function bt(...e) {
  return b.useCallback(IU(...e), e);
}
function kU(e) {
  const t = e + "CollectionProvider", [n, r] = xU(t), [a, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (g) => {
    const { scope: h, children: p } = g, m = G.useRef(null), v = G.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ _(a, { scope: h, itemMap: v, collectionRef: m, children: p });
  };
  o.displayName = t;
  const s = e + "CollectionSlot", l = G.forwardRef(
    (g, h) => {
      const { scope: p, children: m } = g, v = i(s, p), y = bt(h, v.collectionRef);
      return /* @__PURE__ */ _(It, { ref: y, children: m });
    }
  );
  l.displayName = s;
  const c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = G.forwardRef(
    (g, h) => {
      const { scope: p, children: m, ...v } = g, y = G.useRef(null), E = bt(h, y), S = i(c, p);
      return G.useEffect(() => (S.itemMap.set(y, { ref: y, ...v }), () => void S.itemMap.delete(y))), /* @__PURE__ */ _(It, { [u]: "", ref: E, children: m });
    }
  );
  d.displayName = c;
  function f(g) {
    const h = i(e + "CollectionConsumer", g);
    return G.useCallback(() => {
      const m = h.collectionRef.current;
      if (!m) return [];
      const v = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(h.itemMap.values()).sort(
        (S, w) => v.indexOf(S.ref.current) - v.indexOf(w.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: o, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
function OU(e, t) {
  const n = b.createContext(t), r = (i) => {
    const { children: o, ...s } = i, l = b.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ _(n.Provider, { value: l, children: o });
  };
  r.displayName = e + "Provider";
  function a(i) {
    const o = b.useContext(n);
    if (o) return o;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, a];
}
function nn(e, t = []) {
  let n = [];
  function r(i, o) {
    const s = b.createContext(o), l = n.length;
    n = [...n, o];
    const c = (d) => {
      var v;
      const { scope: f, children: g, ...h } = d, p = ((v = f == null ? void 0 : f[e]) == null ? void 0 : v[l]) || s, m = b.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ _(p.Provider, { value: m, children: g });
    };
    c.displayName = i + "Provider";
    function u(d, f) {
      var p;
      const g = ((p = f == null ? void 0 : f[e]) == null ? void 0 : p[l]) || s, h = b.useContext(g);
      if (h) return h;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const a = () => {
    const i = n.map((o) => b.createContext(o));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return a.scopeName = e, [r, DU(a, ...t)];
}
function DU(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const o = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var LU = b.createContext(void 0);
function Ni(e) {
  const t = b.useContext(LU);
  return e || t || "ltr";
}
function bl(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
var MU = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], JA = MU.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? It : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function PU(e, t) {
  e && sa.flushSync(() => e.dispatchEvent(t));
}
function FU(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function $U(...e) {
  return (t) => e.forEach((n) => FU(n, t));
}
function ex(...e) {
  return b.useCallback($U(...e), e);
}
function Qe(e) {
  const t = b.useRef(e);
  return b.useEffect(() => {
    t.current = e;
  }), b.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function tx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qe(e);
  b.useEffect(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var BU = "DismissableLayer", vg = "dismissableLayer.update", UU = "dismissableLayer.pointerDownOutside", GU = "dismissableLayer.focusOutside", Fv, nx = b.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Nh = b.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: o,
      onDismiss: s,
      ...l
    } = e, c = b.useContext(nx), [u, d] = b.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, g] = b.useState({}), h = ex(t, (T) => d(T)), p = Array.from(c.layers), [m] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), v = p.indexOf(m), y = u ? p.indexOf(u) : -1, E = c.layersWithOutsidePointerEventsDisabled.size > 0, S = y >= v, w = WU((T) => {
      const A = T.target, C = [...c.branches].some((N) => N.contains(A));
      !S || C || (a == null || a(T), o == null || o(T), T.defaultPrevented || s == null || s());
    }, f), R = qU((T) => {
      const A = T.target;
      [...c.branches].some((N) => N.contains(A)) || (i == null || i(T), o == null || o(T), T.defaultPrevented || s == null || s());
    }, f);
    return tx((T) => {
      y === c.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && s && (T.preventDefault(), s()));
    }, f), b.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Fv = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), $v(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Fv);
        };
    }, [u, f, n, c]), b.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), $v());
    }, [u, c]), b.useEffect(() => {
      const T = () => g({});
      return document.addEventListener(vg, T), () => document.removeEventListener(vg, T);
    }, []), /* @__PURE__ */ _(
      JA.div,
      {
        ...l,
        ref: h,
        style: {
          pointerEvents: E ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: bl(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: bl(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: bl(
          e.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
Nh.displayName = BU;
var HU = "DismissableLayerBranch", zU = b.forwardRef((e, t) => {
  const n = b.useContext(nx), r = b.useRef(null), a = ex(t, r);
  return b.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ _(JA.div, { ...e, ref: a });
});
zU.displayName = HU;
function WU(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qe(e), r = b.useRef(!1), a = b.useRef(() => {
  });
  return b.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          rx(
            UU,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = l, t.addEventListener("click", a.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function qU(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qe(e), r = b.useRef(!1);
  return b.useEffect(() => {
    const a = (i) => {
      i.target && !r.current && rx(GU, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function $v() {
  const e = new CustomEvent(vg);
  document.dispatchEvent(e);
}
function rx(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), r ? PU(a, i) : a.dispatchEvent(i);
}
var vl = 0;
function Ih() {
  b.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Bv()), document.body.insertAdjacentElement("beforeend", e[1] ?? Bv()), vl++, () => {
      vl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), vl--;
    };
  }, []);
}
function Bv() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
function VU(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function jU(...e) {
  return (t) => e.forEach((n) => VU(n, t));
}
function YU(...e) {
  return b.useCallback(jU(...e), e);
}
var KU = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], XU = KU.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? It : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), yl = "focusScope.autoFocusOnMount", El = "focusScope.autoFocusOnUnmount", Uv = { bubbles: !1, cancelable: !0 }, ZU = "FocusScope", kh = b.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i,
    ...o
  } = e, [s, l] = b.useState(null), c = Qe(a), u = Qe(i), d = b.useRef(null), f = YU(t, (p) => l(p)), g = b.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  b.useEffect(() => {
    if (r) {
      let p = function(E) {
        if (g.paused || !s) return;
        const S = E.target;
        s.contains(S) ? d.current = S : In(d.current, { select: !0 });
      }, m = function(E) {
        if (g.paused || !s) return;
        const S = E.relatedTarget;
        S !== null && (s.contains(S) || In(d.current, { select: !0 }));
      }, v = function(E) {
        if (document.activeElement === document.body)
          for (const w of E)
            w.removedNodes.length > 0 && In(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const y = new MutationObserver(v);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [r, s, g.paused]), b.useEffect(() => {
    if (s) {
      Hv.add(g);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const v = new CustomEvent(yl, Uv);
        s.addEventListener(yl, c), s.dispatchEvent(v), v.defaultPrevented || (QU(rG(ax(s)), { select: !0 }), document.activeElement === p && In(s));
      }
      return () => {
        s.removeEventListener(yl, c), setTimeout(() => {
          const v = new CustomEvent(El, Uv);
          s.addEventListener(El, u), s.dispatchEvent(v), v.defaultPrevented || In(p ?? document.body, { select: !0 }), s.removeEventListener(El, u), Hv.remove(g);
        }, 0);
      };
    }
  }, [s, c, u, g]);
  const h = b.useCallback(
    (p) => {
      if (!n && !r || g.paused) return;
      const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, v = document.activeElement;
      if (m && v) {
        const y = p.currentTarget, [E, S] = JU(y);
        E && S ? !p.shiftKey && v === S ? (p.preventDefault(), n && In(E, { select: !0 })) : p.shiftKey && v === E && (p.preventDefault(), n && In(S, { select: !0 })) : v === y && p.preventDefault();
      }
    },
    [n, r, g.paused]
  );
  return /* @__PURE__ */ _(XU.div, { tabIndex: -1, ...o, ref: f, onKeyDown: h });
});
kh.displayName = ZU;
function QU(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (In(r, { select: t }), document.activeElement !== n) return;
}
function JU(e) {
  const t = ax(e), n = Gv(t, e), r = Gv(t.reverse(), e);
  return [n, r];
}
function ax(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Gv(e, t) {
  for (const n of e)
    if (!eG(n, { upTo: t })) return n;
}
function eG(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function tG(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function In(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && tG(e) && t && e.select();
  }
}
var Hv = nG();
function nG() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = zv(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = zv(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function zv(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function rG(e) {
  return e.filter((t) => t.tagName !== "A");
}
var We = globalThis != null && globalThis.document ? b.useLayoutEffect : () => {
}, aG = b.useId || (() => {
}), iG = 0;
function Bt(e) {
  const [t, n] = b.useState(aG());
  return We(() => {
    n((r) => r ?? String(iG++));
  }, [e]), t ? `radix-${t}` : "";
}
const oG = ["top", "right", "bottom", "left"], zn = Math.min, _t = Math.max, Zo = Math.round, so = Math.floor, Wn = (e) => ({
  x: e,
  y: e
}), sG = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, lG = {
  start: "end",
  end: "start"
};
function yg(e, t, n) {
  return _t(e, zn(t, n));
}
function En(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Sn(e) {
  return e.split("-")[0];
}
function pa(e) {
  return e.split("-")[1];
}
function Oh(e) {
  return e === "x" ? "y" : "x";
}
function Dh(e) {
  return e === "y" ? "height" : "width";
}
function ga(e) {
  return ["top", "bottom"].includes(Sn(e)) ? "y" : "x";
}
function Lh(e) {
  return Oh(ga(e));
}
function cG(e, t, n) {
  n === void 0 && (n = !1);
  const r = pa(e), a = Lh(e), i = Dh(a);
  let o = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = Qo(o)), [o, Qo(o)];
}
function uG(e) {
  const t = Qo(e);
  return [Eg(e), t, Eg(t)];
}
function Eg(e) {
  return e.replace(/start|end/g, (t) => lG[t]);
}
function dG(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function fG(e, t, n, r) {
  const a = pa(e);
  let i = dG(Sn(e), n === "start", r);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(Eg)))), i;
}
function Qo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => sG[t]);
}
function pG(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ix(e) {
  return typeof e != "number" ? pG(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Jo(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function Wv(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = ga(t), o = Lh(t), s = Dh(o), l = Sn(t), c = i === "y", u = r.x + r.width / 2 - a.width / 2, d = r.y + r.height / 2 - a.height / 2, f = r[s] / 2 - a[s] / 2;
  let g;
  switch (l) {
    case "top":
      g = {
        x: u,
        y: r.y - a.height
      };
      break;
    case "bottom":
      g = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      g = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      g = {
        x: r.x - a.width,
        y: d
      };
      break;
    default:
      g = {
        x: r.x,
        y: r.y
      };
  }
  switch (pa(t)) {
    case "start":
      g[o] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      g[o] += f * (n && c ? -1 : 1);
      break;
  }
  return g;
}
const gG = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = n, s = i.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let c = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: d
  } = Wv(c, r, l), f = r, g = {}, h = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: m,
      fn: v
    } = s[p], {
      x: y,
      y: E,
      data: S,
      reset: w
    } = await v({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: a,
      middlewareData: g,
      rects: c,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = y ?? u, d = E ?? d, g = {
      ...g,
      [m]: {
        ...g[m],
        ...S
      }
    }, w && h <= 50 && (h++, typeof w == "object" && (w.placement && (f = w.placement), w.rects && (c = w.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : w.rects), {
      x: u,
      y: d
    } = Wv(c, f, l)), p = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: a,
    middlewareData: g
  };
};
async function di(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: g = 0
  } = En(t, e), h = ix(g), m = s[f ? d === "floating" ? "reference" : "floating" : d], v = Jo(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(m))) == null || n ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), y = d === "floating" ? {
    x: r,
    y: a,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, E = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), S = await (i.isElement == null ? void 0 : i.isElement(E)) ? await (i.getScale == null ? void 0 : i.getScale(E)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = Jo(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: E,
    strategy: l
  }) : y);
  return {
    top: (v.top - w.top + h.top) / S.y,
    bottom: (w.bottom - v.bottom + h.bottom) / S.y,
    left: (v.left - w.left + h.left) / S.x,
    right: (w.right - v.right + h.right) / S.x
  };
}
const hG = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: o,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = En(e, t) || {};
    if (c == null)
      return {};
    const d = ix(u), f = {
      x: n,
      y: r
    }, g = Lh(a), h = Dh(g), p = await o.getDimensions(c), m = g === "y", v = m ? "top" : "left", y = m ? "bottom" : "right", E = m ? "clientHeight" : "clientWidth", S = i.reference[h] + i.reference[g] - f[g] - i.floating[h], w = f[g] - i.reference[g], R = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let T = R ? R[E] : 0;
    (!T || !await (o.isElement == null ? void 0 : o.isElement(R))) && (T = s.floating[E] || i.floating[h]);
    const A = S / 2 - w / 2, C = T / 2 - p[h] / 2 - 1, N = zn(d[v], C), L = zn(d[y], C), I = N, k = T - p[h] - L, B = T / 2 - p[h] / 2 + A, F = yg(I, B, k), P = !l.arrow && pa(a) != null && B !== F && i.reference[h] / 2 - (B < I ? N : L) - p[h] / 2 < 0, D = P ? B < I ? B - I : B - k : 0;
    return {
      [g]: f[g] + D,
      data: {
        [g]: F,
        centerOffset: B - F - D,
        ...P && {
          alignmentOffset: D
        }
      },
      reset: P
    };
  }
}), mG = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: g = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: p = !0,
        ...m
      } = En(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const v = Sn(a), y = Sn(s) === s, E = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = f || (y || !p ? [Qo(s)] : uG(s));
      !f && h !== "none" && S.push(...fG(s, p, h, E));
      const w = [s, ...S], R = await di(t, m), T = [];
      let A = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && T.push(R[v]), d) {
        const I = cG(a, o, E);
        T.push(R[I[0]], R[I[1]]);
      }
      if (A = [...A, {
        placement: a,
        overflows: T
      }], !T.every((I) => I <= 0)) {
        var C, N;
        const I = (((C = i.flip) == null ? void 0 : C.index) || 0) + 1, k = w[I];
        if (k)
          return {
            data: {
              index: I,
              overflows: A
            },
            reset: {
              placement: k
            }
          };
        let B = (N = A.filter((F) => F.overflows[0] <= 0).sort((F, P) => F.overflows[1] - P.overflows[1])[0]) == null ? void 0 : N.placement;
        if (!B)
          switch (g) {
            case "bestFit": {
              var L;
              const F = (L = A.map((P) => [P.placement, P.overflows.filter((D) => D > 0).reduce((D, O) => D + O, 0)]).sort((P, D) => P[1] - D[1])[0]) == null ? void 0 : L[0];
              F && (B = F);
              break;
            }
            case "initialPlacement":
              B = s;
              break;
          }
        if (a !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
};
function qv(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Vv(e) {
  return oG.some((t) => e[t] >= 0);
}
const bG = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = En(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await di(t, {
            ...a,
            elementContext: "reference"
          }), o = qv(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: Vv(o)
            }
          };
        }
        case "escaped": {
          const i = await di(t, {
            ...a,
            altBoundary: !0
          }), o = qv(i, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: Vv(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function vG(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), o = Sn(n), s = pa(n), l = ga(n) === "y", c = ["left", "top"].includes(o) ? -1 : 1, u = i && l ? -1 : 1, d = En(t, e);
  let {
    mainAxis: f,
    crossAxis: g,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof h == "number" && (g = s === "end" ? h * -1 : h), l ? {
    x: g * u,
    y: f * c
  } : {
    x: f * c,
    y: g * u
  };
}
const yG = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: i,
        placement: o,
        middlewareData: s
      } = t, l = await vG(t, e);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: a + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, EG = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: v,
              y
            } = m;
            return {
              x: v,
              y
            };
          }
        },
        ...l
      } = En(e, t), c = {
        x: n,
        y: r
      }, u = await di(t, l), d = ga(Sn(a)), f = Oh(d);
      let g = c[f], h = c[d];
      if (i) {
        const m = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", y = g + u[m], E = g - u[v];
        g = yg(y, g, E);
      }
      if (o) {
        const m = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", y = h + u[m], E = h - u[v];
        h = yg(y, h, E);
      }
      const p = s.fn({
        ...t,
        [f]: g,
        [d]: h
      });
      return {
        ...p,
        data: {
          x: p.x - n,
          y: p.y - r
        }
      };
    }
  };
}, SG = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = En(e, t), u = {
        x: n,
        y: r
      }, d = ga(a), f = Oh(d);
      let g = u[f], h = u[d];
      const p = En(s, t), m = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (l) {
        const E = f === "y" ? "height" : "width", S = i.reference[f] - i.floating[E] + m.mainAxis, w = i.reference[f] + i.reference[E] - m.mainAxis;
        g < S ? g = S : g > w && (g = w);
      }
      if (c) {
        var v, y;
        const E = f === "y" ? "width" : "height", S = ["top", "left"].includes(Sn(a)), w = i.reference[d] - i.floating[E] + (S && ((v = o.offset) == null ? void 0 : v[d]) || 0) + (S ? 0 : m.crossAxis), R = i.reference[d] + i.reference[E] + (S ? 0 : ((y = o.offset) == null ? void 0 : y[d]) || 0) - (S ? m.crossAxis : 0);
        h < w ? h = w : h > R && (h = R);
      }
      return {
        [f]: g,
        [d]: h
      };
    }
  };
}, wG = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: a,
        elements: i
      } = t, {
        apply: o = () => {
        },
        ...s
      } = En(e, t), l = await di(t, s), c = Sn(n), u = pa(n), d = ga(n) === "y", {
        width: f,
        height: g
      } = r.floating;
      let h, p;
      c === "top" || c === "bottom" ? (h = c, p = u === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (p = c, h = u === "end" ? "top" : "bottom");
      const m = g - l[h], v = f - l[p], y = !t.middlewareData.shift;
      let E = m, S = v;
      if (d) {
        const R = f - l.left - l.right;
        S = u || y ? zn(v, R) : R;
      } else {
        const R = g - l.top - l.bottom;
        E = u || y ? zn(m, R) : R;
      }
      if (y && !u) {
        const R = _t(l.left, 0), T = _t(l.right, 0), A = _t(l.top, 0), C = _t(l.bottom, 0);
        d ? S = f - 2 * (R !== 0 || T !== 0 ? R + T : _t(l.left, l.right)) : E = g - 2 * (A !== 0 || C !== 0 ? A + C : _t(l.top, l.bottom));
      }
      await o({
        ...t,
        availableWidth: S,
        availableHeight: E
      });
      const w = await a.getDimensions(i.floating);
      return f !== w.width || g !== w.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ha(e) {
  return ox(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Tt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Tn(e) {
  var t;
  return (t = (ox(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ox(e) {
  return e instanceof Node || e instanceof Tt(e).Node;
}
function Jt(e) {
  return e instanceof Element || e instanceof Tt(e).Element;
}
function en(e) {
  return e instanceof HTMLElement || e instanceof Tt(e).HTMLElement;
}
function jv(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Tt(e).ShadowRoot;
}
function Ii(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = Gt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function _G(e) {
  return ["table", "td", "th"].includes(ha(e));
}
function Mh(e) {
  const t = Ph(), n = Gt(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function TG(e) {
  let t = qn(e);
  for (; en(t) && !oa(t); ) {
    if (Mh(t))
      return t;
    t = qn(t);
  }
  return null;
}
function Ph() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function oa(e) {
  return ["html", "body", "#document"].includes(ha(e));
}
function Gt(e) {
  return Tt(e).getComputedStyle(e);
}
function _s(e) {
  return Jt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function qn(e) {
  if (ha(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    jv(e) && e.host || // Fallback.
    Tn(e)
  );
  return jv(t) ? t.host : t;
}
function sx(e) {
  const t = qn(e);
  return oa(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : en(t) && Ii(t) ? t : sx(t);
}
function fi(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = sx(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), o = Tt(a);
  return i ? t.concat(o, o.visualViewport || [], Ii(a) ? a : [], o.frameElement && n ? fi(o.frameElement) : []) : t.concat(a, fi(a, [], n));
}
function lx(e) {
  const t = Gt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = en(e), i = a ? e.offsetWidth : n, o = a ? e.offsetHeight : r, s = Zo(n) !== i || Zo(r) !== o;
  return s && (n = i, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function Fh(e) {
  return Jt(e) ? e : e.contextElement;
}
function ea(e) {
  const t = Fh(e);
  if (!en(t))
    return Wn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = lx(t);
  let o = (i ? Zo(n.width) : n.width) / r, s = (i ? Zo(n.height) : n.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const RG = /* @__PURE__ */ Wn(0);
function cx(e) {
  const t = Tt(e);
  return !Ph() || !t.visualViewport ? RG : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function AG(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Tt(e) ? !1 : t;
}
function Sr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = Fh(e);
  let o = Wn(1);
  t && (r ? Jt(r) && (o = ea(r)) : o = ea(e));
  const s = AG(i, n, r) ? cx(i) : Wn(0);
  let l = (a.left + s.x) / o.x, c = (a.top + s.y) / o.y, u = a.width / o.x, d = a.height / o.y;
  if (i) {
    const f = Tt(i), g = r && Jt(r) ? Tt(r) : r;
    let h = f, p = h.frameElement;
    for (; p && r && g !== h; ) {
      const m = ea(p), v = p.getBoundingClientRect(), y = Gt(p), E = v.left + (p.clientLeft + parseFloat(y.paddingLeft)) * m.x, S = v.top + (p.clientTop + parseFloat(y.paddingTop)) * m.y;
      l *= m.x, c *= m.y, u *= m.x, d *= m.y, l += E, c += S, h = Tt(p), p = h.frameElement;
    }
  }
  return Jo({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
const xG = [":popover-open", ":modal"];
function $h(e) {
  return xG.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function CG(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const i = a === "fixed", o = Tn(r), s = t ? $h(t.floating) : !1;
  if (r === o || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Wn(1);
  const u = Wn(0), d = en(r);
  if ((d || !d && !i) && ((ha(r) !== "body" || Ii(o)) && (l = _s(r)), en(r))) {
    const f = Sr(r);
    c = ea(r), u.x = f.x + r.clientLeft, u.y = f.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y
  };
}
function NG(e) {
  return Array.from(e.getClientRects());
}
function ux(e) {
  return Sr(Tn(e)).left + _s(e).scrollLeft;
}
function IG(e) {
  const t = Tn(e), n = _s(e), r = e.ownerDocument.body, a = _t(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = _t(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + ux(e);
  const s = -n.scrollTop;
  return Gt(r).direction === "rtl" && (o += _t(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function kG(e, t) {
  const n = Tt(e), r = Tn(e), a = n.visualViewport;
  let i = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    const c = Ph();
    (!c || c && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function OG(e, t) {
  const n = Sr(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = en(e) ? ea(e) : Wn(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, l = a * i.x, c = r * i.y;
  return {
    width: o,
    height: s,
    x: l,
    y: c
  };
}
function Yv(e, t, n) {
  let r;
  if (t === "viewport")
    r = kG(e, n);
  else if (t === "document")
    r = IG(Tn(e));
  else if (Jt(t))
    r = OG(t, n);
  else {
    const a = cx(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return Jo(r);
}
function dx(e, t) {
  const n = qn(e);
  return n === t || !Jt(n) || oa(n) ? !1 : Gt(n).position === "fixed" || dx(n, t);
}
function DG(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = fi(e, [], !1).filter((s) => Jt(s) && ha(s) !== "body"), a = null;
  const i = Gt(e).position === "fixed";
  let o = i ? qn(e) : e;
  for (; Jt(o) && !oa(o); ) {
    const s = Gt(o), l = Mh(o);
    !l && s.position === "fixed" && (a = null), (i ? !l && !a : !l && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Ii(o) && !l && dx(e, o)) ? r = r.filter((u) => u !== o) : a = s, o = qn(o);
  }
  return t.set(e, r), r;
}
function LG(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const o = [...n === "clippingAncestors" ? $h(t) ? [] : DG(t, this._c) : [].concat(n), r], s = o[0], l = o.reduce((c, u) => {
    const d = Yv(t, u, a);
    return c.top = _t(d.top, c.top), c.right = zn(d.right, c.right), c.bottom = zn(d.bottom, c.bottom), c.left = _t(d.left, c.left), c;
  }, Yv(t, s, a));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function MG(e) {
  const {
    width: t,
    height: n
  } = lx(e);
  return {
    width: t,
    height: n
  };
}
function PG(e, t, n) {
  const r = en(t), a = Tn(t), i = n === "fixed", o = Sr(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Wn(0);
  if (r || !r && !i)
    if ((ha(t) !== "body" || Ii(a)) && (s = _s(t)), r) {
      const d = Sr(t, !0, i, t);
      l.x = d.x + t.clientLeft, l.y = d.y + t.clientTop;
    } else a && (l.x = ux(a));
  const c = o.left + s.scrollLeft - l.x, u = o.top + s.scrollTop - l.y;
  return {
    x: c,
    y: u,
    width: o.width,
    height: o.height
  };
}
function Sl(e) {
  return Gt(e).position === "static";
}
function Kv(e, t) {
  return !en(e) || Gt(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function fx(e, t) {
  const n = Tt(e);
  if ($h(e))
    return n;
  if (!en(e)) {
    let a = qn(e);
    for (; a && !oa(a); ) {
      if (Jt(a) && !Sl(a))
        return a;
      a = qn(a);
    }
    return n;
  }
  let r = Kv(e, t);
  for (; r && _G(r) && Sl(r); )
    r = Kv(r, t);
  return r && oa(r) && Sl(r) && !Mh(r) ? n : r || TG(e) || n;
}
const FG = async function(e) {
  const t = this.getOffsetParent || fx, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: PG(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function $G(e) {
  return Gt(e).direction === "rtl";
}
const BG = {
  convertOffsetParentRelativeRectToViewportRelativeRect: CG,
  getDocumentElement: Tn,
  getClippingRect: LG,
  getOffsetParent: fx,
  getElementRects: FG,
  getClientRects: NG,
  getDimensions: MG,
  getScale: ea,
  isElement: Jt,
  isRTL: $G
};
function UG(e, t) {
  let n = null, r;
  const a = Tn(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !d || !f)
      return;
    const g = so(u), h = so(a.clientWidth - (c + d)), p = so(a.clientHeight - (u + f)), m = so(c), y = {
      rootMargin: -g + "px " + -h + "px " + -p + "px " + -m + "px",
      threshold: _t(0, zn(1, l)) || 1
    };
    let E = !0;
    function S(w) {
      const R = w[0].intersectionRatio;
      if (R !== l) {
        if (!E)
          return o();
        R ? o(!1, R) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      E = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...y,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, y);
    }
    n.observe(e);
  }
  return o(!0), i;
}
function px(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Fh(e), u = a || i ? [...c ? fi(c) : [], ...fi(t)] : [];
  u.forEach((v) => {
    a && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const d = c && s ? UG(c, n) : null;
  let f = -1, g = null;
  o && (g = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === c && g && (g.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var E;
      (E = g) == null || E.observe(t);
    })), n();
  }), c && !l && g.observe(c), g.observe(t));
  let h, p = l ? Sr(e) : null;
  l && m();
  function m() {
    const v = Sr(e);
    p && (v.x !== p.x || v.y !== p.y || v.width !== p.width || v.height !== p.height) && n(), p = v, h = requestAnimationFrame(m);
  }
  return n(), () => {
    var v;
    u.forEach((y) => {
      a && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), d == null || d(), (v = g) == null || v.disconnect(), g = null, l && cancelAnimationFrame(h);
  };
}
const gx = yG, hx = EG, mx = mG, bx = wG, vx = bG, Xv = hG, yx = SG, GG = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: BG,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return gG(e, t, {
    ...a,
    platform: i
  });
}, Ex = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Xv({
        element: r.current,
        padding: a
      }).fn(n) : {} : r ? Xv({
        element: r,
        padding: a
      }).fn(n) : {};
    }
  };
};
var Oo = typeof document < "u" ? Rr : ye;
function es(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!es(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = a[r];
      if (!(i === "_owner" && e.$$typeof) && !es(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Sx(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Zv(e, t) {
  const n = Sx(e);
  return Math.round(t * n) / n;
}
function Qv(e) {
  const t = b.useRef(e);
  return Oo(() => {
    t.current = e;
  }), t;
}
function wx(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = b.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, g] = b.useState(r);
  es(f, r) || g(r);
  const [h, p] = b.useState(null), [m, v] = b.useState(null), y = b.useCallback((D) => {
    D !== R.current && (R.current = D, p(D));
  }, []), E = b.useCallback((D) => {
    D !== T.current && (T.current = D, v(D));
  }, []), S = i || h, w = o || m, R = b.useRef(null), T = b.useRef(null), A = b.useRef(u), C = l != null, N = Qv(l), L = Qv(a), I = b.useCallback(() => {
    if (!R.current || !T.current)
      return;
    const D = {
      placement: t,
      strategy: n,
      middleware: f
    };
    L.current && (D.platform = L.current), GG(R.current, T.current, D).then((O) => {
      const M = {
        ...O,
        isPositioned: !0
      };
      k.current && !es(A.current, M) && (A.current = M, sa.flushSync(() => {
        d(M);
      }));
    });
  }, [f, t, n, L]);
  Oo(() => {
    c === !1 && A.current.isPositioned && (A.current.isPositioned = !1, d((D) => ({
      ...D,
      isPositioned: !1
    })));
  }, [c]);
  const k = b.useRef(!1);
  Oo(() => (k.current = !0, () => {
    k.current = !1;
  }), []), Oo(() => {
    if (S && (R.current = S), w && (T.current = w), S && w) {
      if (N.current)
        return N.current(S, w, I);
      I();
    }
  }, [S, w, I, N, C]);
  const B = b.useMemo(() => ({
    reference: R,
    floating: T,
    setReference: y,
    setFloating: E
  }), [y, E]), F = b.useMemo(() => ({
    reference: S,
    floating: w
  }), [S, w]), P = b.useMemo(() => {
    const D = {
      position: n,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return D;
    const O = Zv(F.floating, u.x), M = Zv(F.floating, u.y);
    return s ? {
      ...D,
      transform: "translate(" + O + "px, " + M + "px)",
      ...Sx(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: O,
      top: M
    };
  }, [n, s, F.floating, u.x, u.y]);
  return b.useMemo(() => ({
    ...u,
    update: I,
    refs: B,
    elements: F,
    floatingStyles: P
  }), [u, I, B, F, P]);
}
var HG = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ct = HG.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? It : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), zG = "Arrow", _x = b.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: a = 5, ...i } = e;
  return /* @__PURE__ */ _(
    ct.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ _("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
_x.displayName = zG;
var WG = _x;
function qG(e, t = []) {
  let n = [];
  function r(i, o) {
    const s = b.createContext(o), l = n.length;
    n = [...n, o];
    function c(d) {
      const { scope: f, children: g, ...h } = d, p = (f == null ? void 0 : f[e][l]) || s, m = b.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ _(p.Provider, { value: m, children: g });
    }
    function u(d, f) {
      const g = (f == null ? void 0 : f[e][l]) || s, h = b.useContext(g);
      if (h) return h;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [c, u];
  }
  const a = () => {
    const i = n.map((o) => b.createContext(o));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return a.scopeName = e, [r, VG(a, ...t)];
}
function VG(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const o = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Tx(e) {
  const [t, n] = b.useState(void 0);
  return We(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          o = c.inlineSize, s = c.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        n({ width: o, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Bh = "Popper", [Rx, Ax] = qG(Bh), [jG, xx] = Rx(Bh), Cx = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = b.useState(null);
  return /* @__PURE__ */ _(jG, { scope: t, anchor: r, onAnchorChange: a, children: n });
};
Cx.displayName = Bh;
var Nx = "PopperAnchor", Ix = b.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...a } = e, i = xx(Nx, n), o = b.useRef(null), s = bt(t, o);
    return b.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || o.current);
    }), r ? null : /* @__PURE__ */ _(ct.div, { ...a, ref: s });
  }
);
Ix.displayName = Nx;
var Uh = "PopperContent", [YG, KG] = Rx(Uh), kx = b.forwardRef(
  (e, t) => {
    var H, K, J, ne, ee, ae;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: a = 0,
      align: i = "center",
      alignOffset: o = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: g = "optimized",
      onPlaced: h,
      ...p
    } = e, m = xx(Uh, n), [v, y] = b.useState(null), E = bt(t, (he) => y(he)), [S, w] = b.useState(null), R = Tx(S), T = (R == null ? void 0 : R.width) ?? 0, A = (R == null ? void 0 : R.height) ?? 0, C = r + (i !== "center" ? "-" + i : ""), N = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, L = Array.isArray(c) ? c : [c], I = L.length > 0, k = {
      padding: N,
      boundary: L.filter(ZG),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: B, floatingStyles: F, placement: P, isPositioned: D, middlewareData: O } = wx({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: C,
      whileElementsMounted: (...he) => px(...he, {
        animationFrame: g === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        gx({ mainAxis: a + A, alignmentAxis: o }),
        l && hx({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? yx() : void 0,
          ...k
        }),
        l && mx({ ...k }),
        bx({
          ...k,
          apply: ({ elements: he, rects: $, availableWidth: Y, availableHeight: Ee }) => {
            const { width: Te, height: Ue } = $.reference, oe = he.floating.style;
            oe.setProperty("--radix-popper-available-width", `${Y}px`), oe.setProperty("--radix-popper-available-height", `${Ee}px`), oe.setProperty("--radix-popper-anchor-width", `${Te}px`), oe.setProperty("--radix-popper-anchor-height", `${Ue}px`);
          }
        }),
        S && Ex({ element: S, padding: s }),
        QG({ arrowWidth: T, arrowHeight: A }),
        f && vx({ strategy: "referenceHidden", ...k })
      ]
    }), [M, W] = Lx(P), U = Qe(h);
    We(() => {
      D && (U == null || U());
    }, [D, U]);
    const q = (H = O.arrow) == null ? void 0 : H.x, re = (K = O.arrow) == null ? void 0 : K.y, j = ((J = O.arrow) == null ? void 0 : J.centerOffset) !== 0, [ie, Q] = b.useState();
    return We(() => {
      v && Q(window.getComputedStyle(v).zIndex);
    }, [v]), /* @__PURE__ */ _(
      "div",
      {
        ref: B.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...F,
          transform: D ? F.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ie,
          "--radix-popper-transform-origin": [
            (ne = O.transformOrigin) == null ? void 0 : ne.x,
            (ee = O.transformOrigin) == null ? void 0 : ee.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ae = O.hide) == null ? void 0 : ae.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ _(
          YG,
          {
            scope: n,
            placedSide: M,
            onArrowChange: w,
            arrowX: q,
            arrowY: re,
            shouldHideArrow: j,
            children: /* @__PURE__ */ _(
              ct.div,
              {
                "data-side": M,
                "data-align": W,
                ...p,
                ref: E,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: D ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
kx.displayName = Uh;
var Ox = "PopperArrow", XG = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Dx = b.forwardRef(function(t, n) {
  const { __scopePopper: r, ...a } = t, i = KG(Ox, r), o = XG[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ _(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ _(
          WG,
          {
            ...a,
            ref: n,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Dx.displayName = Ox;
function ZG(e) {
  return e !== null;
}
var QG = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var m, v, y;
    const { placement: n, rects: r, middlewareData: a } = t, o = ((m = a.arrow) == null ? void 0 : m.centerOffset) !== 0, s = o ? 0 : e.arrowWidth, l = o ? 0 : e.arrowHeight, [c, u] = Lx(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((v = a.arrow) == null ? void 0 : v.x) ?? 0) + s / 2, g = (((y = a.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let h = "", p = "";
    return c === "bottom" ? (h = o ? d : `${f}px`, p = `${-l}px`) : c === "top" ? (h = o ? d : `${f}px`, p = `${r.floating.height + l}px`) : c === "right" ? (h = `${-l}px`, p = o ? d : `${g}px`) : c === "left" && (h = `${r.floating.width + l}px`, p = o ? d : `${g}px`), { data: { x: h, y: p } };
  }
});
function Lx(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var JG = Cx, eH = Ix, tH = kx, nH = Dx, rH = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], aH = rH.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? It : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), iH = "Portal", Gh = b.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [a, i] = b.useState(!1);
  We(() => i(!0), []);
  const o = n || a && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return o ? zg.createPortal(/* @__PURE__ */ _(aH.div, { ...r, ref: t }), o) : null;
});
Gh.displayName = iH;
function wr({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = oH({ defaultProp: t, onChange: n }), i = e !== void 0, o = i ? e : r, s = Qe(n), l = b.useCallback(
    (c) => {
      if (i) {
        const d = typeof c == "function" ? c(e) : c;
        d !== e && s(d);
      } else
        a(c);
    },
    [i, e, a, s]
  );
  return [o, l];
}
function oH({
  defaultProp: e,
  onChange: t
}) {
  const n = b.useState(e), [r] = n, a = b.useRef(r), i = Qe(t);
  return b.useEffect(() => {
    a.current !== r && (i(r), a.current = r);
  }, [r, a, i]), n;
}
function sH(e) {
  const t = b.useRef({ value: e, previous: e });
  return b.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var lH = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], cH = lH.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? It : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), uH = "VisuallyHidden", Mx = b.forwardRef(
  (e, t) => /* @__PURE__ */ _(
    cH.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Mx.displayName = uH;
var Px = Es(), wl = function() {
}, Ts = b.forwardRef(function(e, t) {
  var n = b.useRef(null), r = b.useState({
    onScrollCapture: wl,
    onWheelCapture: wl,
    onTouchMoveCapture: wl
  }), a = r[0], i = r[1], o = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, g = e.noIsolation, h = e.inert, p = e.allowPinchZoom, m = e.as, v = m === void 0 ? "div" : m, y = e.gapMode, E = xi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = f, w = Ah([n, t]), R = we(we({}, E), a);
  return b.createElement(
    b.Fragment,
    null,
    u && b.createElement(S, { sideCar: Px, removeScrollBar: c, shards: d, noIsolation: g, inert: h, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    o ? b.cloneElement(b.Children.only(s), we(we({}, R), { ref: w })) : b.createElement(v, we({}, R, { className: l, ref: w }), s)
  );
});
Ts.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ts.classNames = {
  fullWidth: Qr,
  zeroRight: Zr
};
var Sg = !1;
if (typeof window < "u")
  try {
    var lo = Object.defineProperty({}, "passive", {
      get: function() {
        return Sg = !0, !0;
      }
    });
    window.addEventListener("test", lo, lo), window.removeEventListener("test", lo, lo);
  } catch {
    Sg = !1;
  }
var Br = Sg ? { passive: !1 } : !1, dH = function(e) {
  return e.tagName === "TEXTAREA";
}, Fx = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !dH(e) && n[t] === "visible")
  );
}, fH = function(e) {
  return Fx(e, "overflowY");
}, pH = function(e) {
  return Fx(e, "overflowX");
}, Jv = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = $x(e, r);
    if (a) {
      var i = Bx(e, r), o = i[1], s = i[2];
      if (o > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, gH = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, hH = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, $x = function(e, t) {
  return e === "v" ? fH(t) : pH(t);
}, Bx = function(e, t) {
  return e === "v" ? gH(t) : hH(t);
}, mH = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, bH = function(e, t, n, r, a) {
  var i = mH(e, window.getComputedStyle(t).direction), o = i * r, s = n.target, l = t.contains(s), c = !1, u = o > 0, d = 0, f = 0;
  do {
    var g = Bx(e, s), h = g[0], p = g[1], m = g[2], v = p - m - i * h;
    (h || v) && $x(e, s) && (d += v, f += h), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && (Math.abs(d) < 1 || !a) || !u && (Math.abs(f) < 1 || !a)) && (c = !0), c;
}, co = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ey = function(e) {
  return [e.deltaX, e.deltaY];
}, ty = function(e) {
  return e && "current" in e ? e.current : e;
}, vH = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, yH = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, EH = 0, Ur = [];
function SH(e) {
  var t = b.useRef([]), n = b.useRef([0, 0]), r = b.useRef(), a = b.useState(EH++)[0], i = b.useState(Ci)[0], o = b.useRef(e);
  b.useEffect(function() {
    o.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = ys([e.lockRef.current], (e.shards || []).map(ty), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = b.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !o.current.allowPinchZoom;
    var v = co(p), y = n.current, E = "deltaX" in p ? p.deltaX : y[0] - v[0], S = "deltaY" in p ? p.deltaY : y[1] - v[1], w, R = p.target, T = Math.abs(E) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && T === "h" && R.type === "range")
      return !1;
    var A = Jv(T, R);
    if (!A)
      return !0;
    if (A ? w = T : (w = T === "v" ? "h" : "v", A = Jv(T, R)), !A)
      return !1;
    if (!r.current && "changedTouches" in p && (E || S) && (r.current = w), !w)
      return !0;
    var C = r.current || w;
    return bH(C, m, p, C === "h" ? E : S, !0);
  }, []), l = b.useCallback(function(p) {
    var m = p;
    if (!(!Ur.length || Ur[Ur.length - 1] !== i)) {
      var v = "deltaY" in m ? ey(m) : co(m), y = t.current.filter(function(w) {
        return w.name === m.type && (w.target === m.target || m.target === w.shadowParent) && vH(w.delta, v);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var E = (o.current.shards || []).map(ty).filter(Boolean).filter(function(w) {
          return w.contains(m.target);
        }), S = E.length > 0 ? s(m, E[0]) : !o.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = b.useCallback(function(p, m, v, y) {
    var E = { name: p, delta: m, target: v, should: y, shadowParent: wH(v) };
    t.current.push(E), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== E;
      });
    }, 1);
  }, []), u = b.useCallback(function(p) {
    n.current = co(p), r.current = void 0;
  }, []), d = b.useCallback(function(p) {
    c(p.type, ey(p), p.target, s(p, e.lockRef.current));
  }, []), f = b.useCallback(function(p) {
    c(p.type, co(p), p.target, s(p, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return Ur.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Br), document.addEventListener("touchmove", l, Br), document.addEventListener("touchstart", u, Br), function() {
      Ur = Ur.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", l, Br), document.removeEventListener("touchmove", l, Br), document.removeEventListener("touchstart", u, Br);
    };
  }, []);
  var g = e.removeScrollBar, h = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    h ? b.createElement(i, { styles: yH(a) }) : null,
    g ? b.createElement(xh, { gapMode: e.gapMode }) : null
  );
}
function wH(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const _H = Ss(Px, SH);
var Ux = b.forwardRef(function(e, t) {
  return b.createElement(Ts, we({}, e, { ref: t, sideCar: _H }));
});
Ux.classNames = Ts.classNames;
var TH = [" ", "Enter", "ArrowUp", "ArrowDown"], RH = [" ", "Enter"], ki = "Select", [Rs, As, AH] = kU(ki), [ma, xX] = nn(ki, [
  AH,
  Ax
]), xs = Ax(), [xH, Yn] = ma(ki), [CH, NH] = ma(ki), Gx = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    value: o,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: f,
    required: g,
    form: h
  } = e, p = xs(t), [m, v] = b.useState(null), [y, E] = b.useState(null), [S, w] = b.useState(!1), R = Ni(c), [T = !1, A] = wr({
    prop: r,
    defaultProp: a,
    onChange: i
  }), [C, N] = wr({
    prop: o,
    defaultProp: s,
    onChange: l
  }), L = b.useRef(null), I = m ? h || !!m.closest("form") : !0, [k, B] = b.useState(/* @__PURE__ */ new Set()), F = Array.from(k).map((P) => P.props.value).join(";");
  return /* @__PURE__ */ _(JG, { ...p, children: /* @__PURE__ */ Z(
    xH,
    {
      required: g,
      scope: t,
      trigger: m,
      onTriggerChange: v,
      valueNode: y,
      onValueNodeChange: E,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: w,
      contentId: Bt(),
      value: C,
      onValueChange: N,
      open: T,
      onOpenChange: A,
      dir: R,
      triggerPointerDownPosRef: L,
      disabled: f,
      children: [
        /* @__PURE__ */ _(Rs.Provider, { scope: t, children: /* @__PURE__ */ _(
          CH,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: b.useCallback((P) => {
              B((D) => new Set(D).add(P));
            }, []),
            onNativeOptionRemove: b.useCallback((P) => {
              B((D) => {
                const O = new Set(D);
                return O.delete(P), O;
              });
            }, []),
            children: n
          }
        ) }),
        I ? /* @__PURE__ */ Z(
          fC,
          {
            "aria-hidden": !0,
            required: g,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: C,
            onChange: (P) => N(P.target.value),
            disabled: f,
            form: h,
            children: [
              C === void 0 ? /* @__PURE__ */ _("option", { value: "" }) : null,
              Array.from(k)
            ]
          },
          F
        ) : null
      ]
    }
  ) });
};
Gx.displayName = ki;
var Hx = "SelectTrigger", zx = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...a } = e, i = xs(n), o = Yn(Hx, n), s = o.disabled || r, l = bt(t, o.onTriggerChange), c = As(n), u = b.useRef("touch"), [d, f, g] = pC((p) => {
      const m = c().filter((E) => !E.disabled), v = m.find((E) => E.value === o.value), y = gC(m, p, v);
      y !== void 0 && o.onValueChange(y.value);
    }), h = (p) => {
      s || (o.onOpenChange(!0), g()), p && (o.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      });
    };
    return /* @__PURE__ */ _(eH, { asChild: !0, ...i, children: /* @__PURE__ */ _(
      ct.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": o.contentId,
        "aria-expanded": o.open,
        "aria-required": o.required,
        "aria-autocomplete": "none",
        dir: o.dir,
        "data-state": o.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": dC(o.value) ? "" : void 0,
        ...a,
        ref: l,
        onClick: et(a.onClick, (p) => {
          p.currentTarget.focus(), u.current !== "mouse" && h(p);
        }),
        onPointerDown: et(a.onPointerDown, (p) => {
          u.current = p.pointerType;
          const m = p.target;
          m.hasPointerCapture(p.pointerId) && m.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && p.pointerType === "mouse" && (h(p), p.preventDefault());
        }),
        onKeyDown: et(a.onKeyDown, (p) => {
          const m = d.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && f(p.key), !(m && p.key === " ") && TH.includes(p.key) && (h(), p.preventDefault());
        })
      }
    ) });
  }
);
zx.displayName = Hx;
var Wx = "SelectValue", qx = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: a, children: i, placeholder: o = "", ...s } = e, l = Yn(Wx, n), { onValueNodeHasChildrenChange: c } = l, u = i !== void 0, d = bt(t, l.onValueNodeChange);
    return We(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ _(
      ct.span,
      {
        ...s,
        ref: d,
        style: { pointerEvents: "none" },
        children: dC(l.value) ? /* @__PURE__ */ _(Ke, { children: o }) : i
      }
    );
  }
);
qx.displayName = Wx;
var IH = "SelectIcon", Vx = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...a } = e;
    return /* @__PURE__ */ _(ct.span, { "aria-hidden": !0, ...a, ref: t, children: r || "▼" });
  }
);
Vx.displayName = IH;
var kH = "SelectPortal", jx = (e) => /* @__PURE__ */ _(Gh, { asChild: !0, ...e });
jx.displayName = kH;
var _r = "SelectContent", Yx = b.forwardRef(
  (e, t) => {
    const n = Yn(_r, e.__scopeSelect), [r, a] = b.useState();
    if (We(() => {
      a(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? sa.createPortal(
        /* @__PURE__ */ _(Kx, { scope: e.__scopeSelect, children: /* @__PURE__ */ _(Rs.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ _("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ _(Xx, { ...e, ref: t });
  }
);
Yx.displayName = _r;
var Mt = 10, [Kx, Kn] = ma(_r), OH = "SelectContentImpl", Xx = b.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: a,
      onEscapeKeyDown: i,
      onPointerDownOutside: o,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: g,
      sticky: h,
      hideWhenDetached: p,
      avoidCollisions: m,
      //
      ...v
    } = e, y = Yn(_r, n), [E, S] = b.useState(null), [w, R] = b.useState(null), T = bt(t, (H) => S(H)), [A, C] = b.useState(null), [N, L] = b.useState(
      null
    ), I = As(n), [k, B] = b.useState(!1), F = b.useRef(!1);
    b.useEffect(() => {
      if (E) return vs(E);
    }, [E]), Ih();
    const P = b.useCallback(
      (H) => {
        const [K, ...J] = I().map((ae) => ae.ref.current), [ne] = J.slice(-1), ee = document.activeElement;
        for (const ae of H)
          if (ae === ee || (ae == null || ae.scrollIntoView({ block: "nearest" }), ae === K && w && (w.scrollTop = 0), ae === ne && w && (w.scrollTop = w.scrollHeight), ae == null || ae.focus(), document.activeElement !== ee)) return;
      },
      [I, w]
    ), D = b.useCallback(
      () => P([A, E]),
      [P, A, E]
    );
    b.useEffect(() => {
      k && D();
    }, [k, D]);
    const { onOpenChange: O, triggerPointerDownPosRef: M } = y;
    b.useEffect(() => {
      if (E) {
        let H = { x: 0, y: 0 };
        const K = (ne) => {
          var ee, ae;
          H = {
            x: Math.abs(Math.round(ne.pageX) - (((ee = M.current) == null ? void 0 : ee.x) ?? 0)),
            y: Math.abs(Math.round(ne.pageY) - (((ae = M.current) == null ? void 0 : ae.y) ?? 0))
          };
        }, J = (ne) => {
          H.x <= 10 && H.y <= 10 ? ne.preventDefault() : E.contains(ne.target) || O(!1), document.removeEventListener("pointermove", K), M.current = null;
        };
        return M.current !== null && (document.addEventListener("pointermove", K), document.addEventListener("pointerup", J, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", K), document.removeEventListener("pointerup", J, { capture: !0 });
        };
      }
    }, [E, O, M]), b.useEffect(() => {
      const H = () => O(!1);
      return window.addEventListener("blur", H), window.addEventListener("resize", H), () => {
        window.removeEventListener("blur", H), window.removeEventListener("resize", H);
      };
    }, [O]);
    const [W, U] = pC((H) => {
      const K = I().filter((ee) => !ee.disabled), J = K.find((ee) => ee.ref.current === document.activeElement), ne = gC(K, H, J);
      ne && setTimeout(() => ne.ref.current.focus());
    }), q = b.useCallback(
      (H, K, J) => {
        const ne = !F.current && !J;
        (y.value !== void 0 && y.value === K || ne) && (C(H), ne && (F.current = !0));
      },
      [y.value]
    ), re = b.useCallback(() => E == null ? void 0 : E.focus(), [E]), j = b.useCallback(
      (H, K, J) => {
        const ne = !F.current && !J;
        (y.value !== void 0 && y.value === K || ne) && L(H);
      },
      [y.value]
    ), ie = r === "popper" ? wg : Zx, Q = ie === wg ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: g,
      sticky: h,
      hideWhenDetached: p,
      avoidCollisions: m
    } : {};
    return /* @__PURE__ */ _(
      Kx,
      {
        scope: n,
        content: E,
        viewport: w,
        onViewportChange: R,
        itemRefCallback: q,
        selectedItem: A,
        onItemLeave: re,
        itemTextRefCallback: j,
        focusSelectedItem: D,
        selectedItemText: N,
        position: r,
        isPositioned: k,
        searchRef: W,
        children: /* @__PURE__ */ _(Ux, { as: It, allowPinchZoom: !0, children: /* @__PURE__ */ _(
          kh,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (H) => {
              H.preventDefault();
            },
            onUnmountAutoFocus: et(a, (H) => {
              var K;
              (K = y.trigger) == null || K.focus({ preventScroll: !0 }), H.preventDefault();
            }),
            children: /* @__PURE__ */ _(
              Nh,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: o,
                onFocusOutside: (H) => H.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ _(
                  ie,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (H) => H.preventDefault(),
                    ...v,
                    ...Q,
                    onPlaced: () => B(!0),
                    ref: T,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...v.style
                    },
                    onKeyDown: et(v.onKeyDown, (H) => {
                      const K = H.ctrlKey || H.altKey || H.metaKey;
                      if (H.key === "Tab" && H.preventDefault(), !K && H.key.length === 1 && U(H.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(H.key)) {
                        let ne = I().filter((ee) => !ee.disabled).map((ee) => ee.ref.current);
                        if (["ArrowUp", "End"].includes(H.key) && (ne = ne.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(H.key)) {
                          const ee = H.target, ae = ne.indexOf(ee);
                          ne = ne.slice(ae + 1);
                        }
                        setTimeout(() => P(ne)), H.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Xx.displayName = OH;
var DH = "SelectItemAlignedPosition", Zx = b.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...a } = e, i = Yn(_r, n), o = Kn(_r, n), [s, l] = b.useState(null), [c, u] = b.useState(null), d = bt(t, (T) => u(T)), f = As(n), g = b.useRef(!1), h = b.useRef(!0), { viewport: p, selectedItem: m, selectedItemText: v, focusSelectedItem: y } = o, E = b.useCallback(() => {
    if (i.trigger && i.valueNode && s && c && p && m && v) {
      const T = i.trigger.getBoundingClientRect(), A = c.getBoundingClientRect(), C = i.valueNode.getBoundingClientRect(), N = v.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const ee = N.left - A.left, ae = C.left - ee, he = T.left - ae, $ = T.width + he, Y = Math.max($, A.width), Ee = window.innerWidth - Mt, Te = Pv(ae, [
          Mt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Mt, Ee - Y)
        ]);
        s.style.minWidth = $ + "px", s.style.left = Te + "px";
      } else {
        const ee = A.right - N.right, ae = window.innerWidth - C.right - ee, he = window.innerWidth - T.right - ae, $ = T.width + he, Y = Math.max($, A.width), Ee = window.innerWidth - Mt, Te = Pv(ae, [
          Mt,
          Math.max(Mt, Ee - Y)
        ]);
        s.style.minWidth = $ + "px", s.style.right = Te + "px";
      }
      const L = f(), I = window.innerHeight - Mt * 2, k = p.scrollHeight, B = window.getComputedStyle(c), F = parseInt(B.borderTopWidth, 10), P = parseInt(B.paddingTop, 10), D = parseInt(B.borderBottomWidth, 10), O = parseInt(B.paddingBottom, 10), M = F + P + k + O + D, W = Math.min(m.offsetHeight * 5, M), U = window.getComputedStyle(p), q = parseInt(U.paddingTop, 10), re = parseInt(U.paddingBottom, 10), j = T.top + T.height / 2 - Mt, ie = I - j, Q = m.offsetHeight / 2, H = m.offsetTop + Q, K = F + P + H, J = M - K;
      if (K <= j) {
        const ee = L.length > 0 && m === L[L.length - 1].ref.current;
        s.style.bottom = "0px";
        const ae = c.clientHeight - p.offsetTop - p.offsetHeight, he = Math.max(
          ie,
          Q + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ee ? re : 0) + ae + D
        ), $ = K + he;
        s.style.height = $ + "px";
      } else {
        const ee = L.length > 0 && m === L[0].ref.current;
        s.style.top = "0px";
        const he = Math.max(
          j,
          F + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ee ? q : 0) + Q
        ) + J;
        s.style.height = he + "px", p.scrollTop = K - j + p.offsetTop;
      }
      s.style.margin = `${Mt}px 0`, s.style.minHeight = W + "px", s.style.maxHeight = I + "px", r == null || r(), requestAnimationFrame(() => g.current = !0);
    }
  }, [
    f,
    i.trigger,
    i.valueNode,
    s,
    c,
    p,
    m,
    v,
    i.dir,
    r
  ]);
  We(() => E(), [E]);
  const [S, w] = b.useState();
  We(() => {
    c && w(window.getComputedStyle(c).zIndex);
  }, [c]);
  const R = b.useCallback(
    (T) => {
      T && h.current === !0 && (E(), y == null || y(), h.current = !1);
    },
    [E, y]
  );
  return /* @__PURE__ */ _(
    MH,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: g,
      onScrollButtonChange: R,
      children: /* @__PURE__ */ _(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ _(
            ct.div,
            {
              ...a,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...a.style
              }
            }
          )
        }
      )
    }
  );
});
Zx.displayName = DH;
var LH = "SelectPopperPosition", wg = b.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: a = Mt,
    ...i
  } = e, o = xs(n);
  return /* @__PURE__ */ _(
    tH,
    {
      ...o,
      ...i,
      ref: t,
      align: r,
      collisionPadding: a,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
wg.displayName = LH;
var [MH, Hh] = ma(_r, {}), _g = "SelectViewport", Qx = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...a } = e, i = Kn(_g, n), o = Hh(_g, n), s = bt(t, i.onViewportChange), l = b.useRef(0);
    return /* @__PURE__ */ Z(Ke, { children: [
      /* @__PURE__ */ _(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ _(Rs.Slot, { scope: n, children: /* @__PURE__ */ _(
        ct.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...a,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...a.style
          },
          onScroll: et(a.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = o;
            if (f != null && f.current && d) {
              const g = Math.abs(l.current - u.scrollTop);
              if (g > 0) {
                const h = window.innerHeight - Mt * 2, p = parseFloat(d.style.minHeight), m = parseFloat(d.style.height), v = Math.max(p, m);
                if (v < h) {
                  const y = v + g, E = Math.min(h, y), S = y - E;
                  d.style.height = E + "px", d.style.bottom === "0px" && (u.scrollTop = S > 0 ? S : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Qx.displayName = _g;
var Jx = "SelectGroup", [PH, FH] = ma(Jx), $H = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = Bt();
    return /* @__PURE__ */ _(PH, { scope: n, id: a, children: /* @__PURE__ */ _(ct.div, { role: "group", "aria-labelledby": a, ...r, ref: t }) });
  }
);
$H.displayName = Jx;
var eC = "SelectLabel", tC = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = FH(eC, n);
    return /* @__PURE__ */ _(ct.div, { id: a.id, ...r, ref: t });
  }
);
tC.displayName = eC;
var ts = "SelectItem", [BH, nC] = ma(ts), rC = b.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: a = !1,
      textValue: i,
      ...o
    } = e, s = Yn(ts, n), l = Kn(ts, n), c = s.value === r, [u, d] = b.useState(i ?? ""), [f, g] = b.useState(!1), h = bt(
      t,
      (y) => {
        var E;
        return (E = l.itemRefCallback) == null ? void 0 : E.call(l, y, r, a);
      }
    ), p = Bt(), m = b.useRef("touch"), v = () => {
      a || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ _(
      BH,
      {
        scope: n,
        value: r,
        disabled: a,
        textId: p,
        isSelected: c,
        onItemTextChange: b.useCallback((y) => {
          d((E) => E || ((y == null ? void 0 : y.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ _(
          Rs.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: a,
            textValue: u,
            children: /* @__PURE__ */ _(
              ct.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": c && f,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": a || void 0,
                "data-disabled": a ? "" : void 0,
                tabIndex: a ? void 0 : -1,
                ...o,
                ref: h,
                onFocus: et(o.onFocus, () => g(!0)),
                onBlur: et(o.onBlur, () => g(!1)),
                onClick: et(o.onClick, () => {
                  m.current !== "mouse" && v();
                }),
                onPointerUp: et(o.onPointerUp, () => {
                  m.current === "mouse" && v();
                }),
                onPointerDown: et(o.onPointerDown, (y) => {
                  m.current = y.pointerType;
                }),
                onPointerMove: et(o.onPointerMove, (y) => {
                  var E;
                  m.current = y.pointerType, a ? (E = l.onItemLeave) == null || E.call(l) : m.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: et(o.onPointerLeave, (y) => {
                  var E;
                  y.currentTarget === document.activeElement && ((E = l.onItemLeave) == null || E.call(l));
                }),
                onKeyDown: et(o.onKeyDown, (y) => {
                  var S;
                  ((S = l.searchRef) == null ? void 0 : S.current) !== "" && y.key === " " || (RH.includes(y.key) && v(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
rC.displayName = ts;
var za = "SelectItemText", aC = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: a, ...i } = e, o = Yn(za, n), s = Kn(za, n), l = nC(za, n), c = NH(za, n), [u, d] = b.useState(null), f = bt(
      t,
      (v) => d(v),
      l.onItemTextChange,
      (v) => {
        var y;
        return (y = s.itemTextRefCallback) == null ? void 0 : y.call(s, v, l.value, l.disabled);
      }
    ), g = u == null ? void 0 : u.textContent, h = b.useMemo(
      () => /* @__PURE__ */ _("option", { value: l.value, disabled: l.disabled, children: g }, l.value),
      [l.disabled, l.value, g]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: m } = c;
    return We(() => (p(h), () => m(h)), [p, m, h]), /* @__PURE__ */ Z(Ke, { children: [
      /* @__PURE__ */ _(ct.span, { id: l.textId, ...i, ref: f }),
      l.isSelected && o.valueNode && !o.valueNodeHasChildren ? sa.createPortal(i.children, o.valueNode) : null
    ] });
  }
);
aC.displayName = za;
var iC = "SelectItemIndicator", oC = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return nC(iC, n).isSelected ? /* @__PURE__ */ _(ct.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
oC.displayName = iC;
var Tg = "SelectScrollUpButton", sC = b.forwardRef((e, t) => {
  const n = Kn(Tg, e.__scopeSelect), r = Hh(Tg, e.__scopeSelect), [a, i] = b.useState(!1), o = bt(t, r.onScrollButtonChange);
  return We(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), a ? /* @__PURE__ */ _(
    cC,
    {
      ...e,
      ref: o,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
sC.displayName = Tg;
var Rg = "SelectScrollDownButton", lC = b.forwardRef((e, t) => {
  const n = Kn(Rg, e.__scopeSelect), r = Hh(Rg, e.__scopeSelect), [a, i] = b.useState(!1), o = bt(t, r.onScrollButtonChange);
  return We(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        i(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), a ? /* @__PURE__ */ _(
    cC,
    {
      ...e,
      ref: o,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
lC.displayName = Rg;
var cC = b.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...a } = e, i = Kn("SelectScrollButton", n), o = b.useRef(null), s = As(n), l = b.useCallback(() => {
    o.current !== null && (window.clearInterval(o.current), o.current = null);
  }, []);
  return b.useEffect(() => () => l(), [l]), We(() => {
    var u;
    const c = s().find((d) => d.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ _(
    ct.div,
    {
      "aria-hidden": !0,
      ...a,
      ref: t,
      style: { flexShrink: 0, ...a.style },
      onPointerDown: et(a.onPointerDown, () => {
        o.current === null && (o.current = window.setInterval(r, 50));
      }),
      onPointerMove: et(a.onPointerMove, () => {
        var c;
        (c = i.onItemLeave) == null || c.call(i), o.current === null && (o.current = window.setInterval(r, 50));
      }),
      onPointerLeave: et(a.onPointerLeave, () => {
        l();
      })
    }
  );
}), UH = "SelectSeparator", uC = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ _(ct.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
uC.displayName = UH;
var Ag = "SelectArrow", GH = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, a = xs(n), i = Yn(Ag, n), o = Kn(Ag, n);
    return i.open && o.position === "popper" ? /* @__PURE__ */ _(nH, { ...a, ...r, ref: t }) : null;
  }
);
GH.displayName = Ag;
function dC(e) {
  return e === "" || e === void 0;
}
var fC = b.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, a = b.useRef(null), i = bt(t, a), o = sH(n);
    return b.useEffect(() => {
      const s = a.current, l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (o !== n && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(s, n), s.dispatchEvent(d);
      }
    }, [o, n]), /* @__PURE__ */ _(Mx, { asChild: !0, children: /* @__PURE__ */ _("select", { ...r, ref: i, defaultValue: n }) });
  }
);
fC.displayName = "BubbleSelect";
function pC(e) {
  const t = Qe(e), n = b.useRef(""), r = b.useRef(0), a = b.useCallback(
    (o) => {
      const s = n.current + o;
      t(s), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), i = b.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return b.useEffect(() => () => window.clearTimeout(r.current), []), [n, a, i];
}
function gC(e, t, n) {
  const a = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let o = HH(e, Math.max(i, 0));
  a.length === 1 && (o = o.filter((c) => c !== n));
  const l = o.find(
    (c) => c.textValue.toLowerCase().startsWith(a.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function HH(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var zH = Gx, hC = zx, WH = qx, qH = Vx, VH = jx, mC = Yx, jH = Qx, bC = tC, vC = rC, YH = aC, KH = oC, yC = sC, EC = lC, SC = uC;
const XH = zH, ZH = WH, wC = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  hC,
  {
    ref: r,
    className: de(
      "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ _(qH, { asChild: !0, children: /* @__PURE__ */ _(vF, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
wC.displayName = hC.displayName;
const _C = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  yC,
  {
    ref: n,
    className: de(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ _(CF, {})
  }
));
_C.displayName = yC.displayName;
const TC = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  EC,
  {
    ref: n,
    className: de(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ _(wF, {})
  }
));
TC.displayName = EC.displayName;
const RC = b.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, a) => /* @__PURE__ */ _(VH, { children: /* @__PURE__ */ Z(
  mC,
  {
    ref: a,
    className: de(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ _(_C, {}),
      /* @__PURE__ */ _(
        jH,
        {
          className: de(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ _(TC, {})
    ]
  }
) }));
RC.displayName = mC.displayName;
const QH = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  bC,
  {
    ref: n,
    className: de("px-2 py-1.5 text-sm font-semibold", e),
    ...t
  }
));
QH.displayName = bC.displayName;
const AC = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  vC,
  {
    ref: r,
    className: de(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ _("span", { className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ _(KH, { children: /* @__PURE__ */ _(EF, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ _(YH, { children: t })
    ]
  }
));
AC.displayName = vC.displayName;
const JH = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  SC,
  {
    ref: n,
    className: de("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
JH.displayName = SC.displayName;
const ny = (e) => /* @__PURE__ */ Z(
  XH,
  {
    onValueChange: e.onChange,
    defaultValue: e.defaultValue || e.options[0].value,
    value: e.value,
    children: [
      /* @__PURE__ */ _(wC, { className: "bg-white", children: /* @__PURE__ */ _(ZH, { placeholder: e.placeholder || "Select" }) }),
      /* @__PURE__ */ _(RC, { children: e.options.map((t) => /* @__PURE__ */ _(AC, { value: t.value, disabled: t.disabled, children: t.label }, t.value)) })
    ]
  }
), ry = (e) => {
  var o, s;
  const t = new Array(24).fill(0).map((l, c) => ({
    label: `${c < 10 ? "0" + c : c}`,
    value: `${c}`,
    disabled: e.isToday && (/* @__PURE__ */ new Date()).getHours() < c
  })), n = new Array(60).fill(0).map((l, c) => ({
    label: `${c < 10 ? "0" + c : c}`,
    value: `${c}`,
    disabled: e.isToday && (/* @__PURE__ */ new Date()).getMinutes() < c
  })), [r, a] = He({
    hour: (/* @__PURE__ */ new Date()).getHours(),
    minute: (/* @__PURE__ */ new Date()).getMinutes()
  });
  ye(() => {
    e.value && a(e.value);
  }, [e.value]);
  const i = (l) => (c) => {
    a({
      ...r,
      [l]: parseInt(c)
    }), e.onChange({
      ...r,
      [l]: parseInt(c)
    });
  };
  return /* @__PURE__ */ Z("div", { className: "flex items-center", children: [
    /* @__PURE__ */ _("span", { className: "text-sm mr-4", children: e.label }),
    /* @__PURE__ */ _(
      ny,
      {
        value: `${r.hour}`,
        defaultValue: `${((o = e.defaultTime) == null ? void 0 : o.hour) || (/* @__PURE__ */ new Date()).getHours()}`,
        onChange: i("hour"),
        options: t
      }
    ),
    /* @__PURE__ */ _("span", { className: "mx-2", children: ":" }),
    /* @__PURE__ */ _(
      ny,
      {
        value: `${r.minute}`,
        defaultValue: `${((s = e.defaultTime) == null ? void 0 : s.minute) || (/* @__PURE__ */ new Date()).getMinutes()}`,
        onChange: i("minute"),
        options: n
      }
    )
  ] });
};
function CX(e) {
  var v, y;
  const t = {
    from: ar(/* @__PURE__ */ new Date(), -5),
    to: /* @__PURE__ */ new Date()
  }, [n, r] = b.useState(!1), [
    a,
    i
  ] = b.useState({
    ...t,
    preset: 0
  }), [o, s] = b.useState(t), [l, c] = b.useState(0), u = [
    {
      label: "Last 5 Minutes",
      date: () => ar(/* @__PURE__ */ new Date(), -5)
    },
    {
      label: "Last 15 Minutes",
      date: () => ar(/* @__PURE__ */ new Date(), -15)
    },
    {
      label: "Last 30 Minutes",
      date: () => ar(/* @__PURE__ */ new Date(), -30)
    },
    {
      label: "Last 1 Hour",
      date: () => to(/* @__PURE__ */ new Date(), -1)
    },
    {
      label: "Last 3 Hours",
      date: () => to(/* @__PURE__ */ new Date(), -3)
    },
    {
      label: "Last 6 Hours",
      date: () => to(/* @__PURE__ */ new Date(), -6)
    },
    {
      label: "Last 12 Hours",
      date: () => to(/* @__PURE__ */ new Date(), -12)
    },
    {
      label: "Last 1 Day",
      date: () => Je(/* @__PURE__ */ new Date(), -1)
    },
    {
      label: "Custom",
      date: () => null
    }
  ];
  b.useEffect(() => {
    u[l].date() && s({
      from: u[l].date() || ar(/* @__PURE__ */ new Date(), -5),
      to: /* @__PURE__ */ new Date()
    });
  }, [l]), b.useEffect(() => {
    c(0), i({
      ...o,
      preset: 0
    });
  }, []), b.useEffect(() => {
    e.refreshTime && u[l].date() && s({
      from: u[l].date(),
      to: /* @__PURE__ */ new Date()
    }), e.onChange(o);
  }, [e.refreshTime]);
  const d = (E) => {
    c(E);
  }, f = (E) => {
    const S = {
      from: E != null && E.from ? E.from : o.from,
      to: E != null && E.to ? E.to : E != null && E.from ? E.from : o.from
    };
    S.from = new Date(S.from.getTime()), S.from.setHours(o.from.getHours()), S.from.setMinutes(o.from.getMinutes()), S.to = new Date(S.to.getTime()), S.to.setHours(o.to.getHours()), S.to.setMinutes(o.to.getMinutes()), s({
      ...S
    }), c(u.length - 1);
  }, g = (E, S) => {
    const w = o[S];
    w == null || w.setMinutes(E.minute), w == null || w.setHours(E.hour), c(u.length - 1), s({
      ...o,
      [S]: w
    });
  }, h = () => {
    r(!1), i({
      ...o,
      preset: l
    }), e.onChange(o);
  }, p = () => {
    s({
      from: a.from,
      to: a.to
    }), c(a.preset), r(!1);
  }, m = (E) => `${Ft(E, "MMM")} ${Ft(E, "dd")}, ${Ft(
    E,
    "H"
  )}:${Ft(E, "mm")}`;
  return /* @__PURE__ */ Z(RU, { open: n, defaultOpen: !0, children: [
    /* @__PURE__ */ _(AU, { asChild: !0, children: /* @__PURE__ */ Z(
      Xr,
      {
        variant: "outline",
        className: de(
          "justify-start text-left font-normal w-[100%]",
          !o && "text-muted-foreground"
        ),
        onClick: () => r(!0),
        children: [
          /* @__PURE__ */ _(dM, { className: "mr-2" }),
          u[l].date() ? u[l].label : o.from && o.to ? `${m(o.from)} - ${m(o.to)}` : "Select Time Range"
        ]
      }
    ) }),
    /* @__PURE__ */ Z(QA, { className: "w-auto space-y-2 p-2", children: [
      /* @__PURE__ */ Z("div", { className: "flex", children: [
        /* @__PURE__ */ _("div", { className: "mr-4 my-4 h-[100%]", children: u.map((E, S) => /* @__PURE__ */ _(
          "div",
          {
            className: `py-2 text-sm cursor-pointer hover:bg-primary hover:text-white rounded px-2 ${S === l ? "bg-primary text-white" : ""}`,
            onClick: () => d(S),
            children: E.label
          }
        )) }),
        /* @__PURE__ */ Z("div", { className: "rounded-md border", children: [
          /* @__PURE__ */ _(
            bA,
            {
              mode: "range",
              selected: o,
              onSelect: f,
              numberOfMonths: 2,
              defaultMonth: kt(/* @__PURE__ */ new Date(), -1),
              disabled: { before: Je(/* @__PURE__ */ new Date(), -15), after: /* @__PURE__ */ new Date() }
            }
          ),
          /* @__PURE__ */ Z("div", { className: "flex justify-between p-4", children: [
            /* @__PURE__ */ _(
              ry,
              {
                value: {
                  hour: o.from.getHours(),
                  minute: o.from.getMinutes()
                },
                defaultTime: {
                  hour: ar(/* @__PURE__ */ new Date(), -5).getHours(),
                  minute: ar(/* @__PURE__ */ new Date(), -5).getMinutes()
                },
                isToday: (Date.now() - o.from.getTime()) / 1e3 < 24 * 60 * 60,
                label: "From",
                onChange: (E) => g(E, "from")
              }
            ),
            /* @__PURE__ */ _(
              ry,
              {
                value: {
                  hour: (v = o.to) == null ? void 0 : v.getHours(),
                  minute: (y = o == null ? void 0 : o.to) == null ? void 0 : y.getMinutes()
                },
                isToday: (Date.now() - o.to.getTime()) / 1e3 < 24 * 60 * 60,
                label: "To",
                onChange: (E) => g(E, "to")
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ Z("div", { className: "flex justify-end", children: [
        /* @__PURE__ */ _("div", { className: "mr-2", children: /* @__PURE__ */ _(Xr, { variant: "outline", onClick: p, children: "Cancel" }) }),
        /* @__PURE__ */ _(Xr, { variant: "default", onClick: h, children: "Apply" })
      ] })
    ] })
  ] });
}
const ez = sh(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        info: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "info"
    }
  }
), xC = b.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ _(
  "div",
  {
    ref: r,
    role: "alert",
    className: de(ez({ variant: t }), e),
    ...n
  }
));
xC.displayName = "Alert";
const CC = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "h5",
  {
    ref: n,
    className: de("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
CC.displayName = "AlertTitle";
const NC = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    ref: n,
    className: de("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
NC.displayName = "AlertDescription";
const NX = (e) => {
  const t = {
    info: /* @__PURE__ */ _(mM, { className: "h-4 w-4" }),
    destructive: /* @__PURE__ */ _(gM, { className: "h-4 w-4" })
  };
  return /* @__PURE__ */ Z(xC, { variant: e.variant || "info", className: "", children: [
    t[e.variant || "info"],
    /* @__PURE__ */ _(CC, { children: e.title }),
    /* @__PURE__ */ _(NC, { children: e.message })
  ] });
}, tz = (e) => /* @__PURE__ */ b.createElement("svg", { width: 10, height: 10, viewBox: "0 0 15 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ b.createElement("path", { d: "M7.50052 9.16562C6.86976 9.16562 6.26733 8.89649 5.84654 8.42738L0.487984 2.98883C-0.0136259 2.44139 -0.134445 1.70981 0.153022 1.05821C0.440489 0.405788 1.06125 0 1.77367 0H13.2265C13.9381 0 14.5597 0.404954 14.8464 1.05738C15.133 1.70981 15.013 2.44056 14.5331 2.96633L9.12783 8.45654C8.73288 8.89649 8.13045 9.16562 7.50052 9.16562Z", fill: "currentColor" }));
function ns(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function ay(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ba(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((a) => {
      const i = ay(a, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let a = 0; a < r.length; a++) {
          const i = r[a];
          typeof i == "function" ? i() : ay(e[a], null);
        }
      };
  };
}
function tt(...e) {
  return b.useCallback(ba(...e), e);
}
var IC = b.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = b.Children.toArray(n), i = a.find(rz);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? b.Children.count(o) > 1 ? b.Children.only(null) : b.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ _(xg, { ...r, ref: t, children: b.isValidElement(o) ? b.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ _(xg, { ...r, ref: t, children: n });
});
IC.displayName = "Slot";
var xg = b.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (b.isValidElement(n)) {
    const a = iz(n);
    return b.cloneElement(n, {
      ...az(r, n.props),
      // @ts-ignore
      ref: t ? ba(t, a) : a
    });
  }
  return b.Children.count(n) > 1 ? b.Children.only(null) : null;
});
xg.displayName = "SlotClone";
var nz = ({ children: e }) => /* @__PURE__ */ _(Ke, { children: e });
function rz(e) {
  return b.isValidElement(e) && e.type === nz;
}
function az(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function iz(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var oz = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], sz = oz.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? IC : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function me(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
var pi = b.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = b.Children.toArray(n), i = a.find(cz);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? b.Children.count(o) > 1 ? b.Children.only(null) : b.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ _(Cg, { ...r, ref: t, children: b.isValidElement(o) ? b.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ _(Cg, { ...r, ref: t, children: n });
});
pi.displayName = "Slot";
var Cg = b.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (b.isValidElement(n)) {
    const a = dz(n);
    return b.cloneElement(n, {
      ...uz(r, n.props),
      // @ts-ignore
      ref: t ? ba(t, a) : a
    });
  }
  return b.Children.count(n) > 1 ? b.Children.only(null) : null;
});
Cg.displayName = "SlotClone";
var lz = ({ children: e }) => /* @__PURE__ */ _(Ke, { children: e });
function cz(e) {
  return b.isValidElement(e) && e.type === lz;
}
function uz(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function dz(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function kC(e) {
  const t = e + "CollectionProvider", [n, r] = nn(t), [a, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (g) => {
    const { scope: h, children: p } = g, m = G.useRef(null), v = G.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ _(a, { scope: h, itemMap: v, collectionRef: m, children: p });
  };
  o.displayName = t;
  const s = e + "CollectionSlot", l = G.forwardRef(
    (g, h) => {
      const { scope: p, children: m } = g, v = i(s, p), y = tt(h, v.collectionRef);
      return /* @__PURE__ */ _(pi, { ref: y, children: m });
    }
  );
  l.displayName = s;
  const c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = G.forwardRef(
    (g, h) => {
      const { scope: p, children: m, ...v } = g, y = G.useRef(null), E = tt(h, y), S = i(c, p);
      return G.useEffect(() => (S.itemMap.set(y, { ref: y, ...v }), () => void S.itemMap.delete(y))), /* @__PURE__ */ _(pi, { [u]: "", ref: E, children: m });
    }
  );
  d.displayName = c;
  function f(g) {
    const h = i(e + "CollectionConsumer", g);
    return G.useCallback(() => {
      const m = h.collectionRef.current;
      if (!m) return [];
      const v = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(h.itemMap.values()).sort(
        (S, w) => v.indexOf(S.ref.current) - v.indexOf(w.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: o, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
var fz = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], vt = fz.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? pi : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function OC(e, t) {
  e && sa.flushSync(() => e.dispatchEvent(t));
}
var pz = "DismissableLayer", Ng = "dismissableLayer.update", gz = "dismissableLayer.pointerDownOutside", hz = "dismissableLayer.focusOutside", iy, DC = b.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), LC = b.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: o,
      onDismiss: s,
      ...l
    } = e, c = b.useContext(DC), [u, d] = b.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, g] = b.useState({}), h = tt(t, (T) => d(T)), p = Array.from(c.layers), [m] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), v = p.indexOf(m), y = u ? p.indexOf(u) : -1, E = c.layersWithOutsidePointerEventsDisabled.size > 0, S = y >= v, w = vz((T) => {
      const A = T.target, C = [...c.branches].some((N) => N.contains(A));
      !S || C || (a == null || a(T), o == null || o(T), T.defaultPrevented || s == null || s());
    }, f), R = yz((T) => {
      const A = T.target;
      [...c.branches].some((N) => N.contains(A)) || (i == null || i(T), o == null || o(T), T.defaultPrevented || s == null || s());
    }, f);
    return tx((T) => {
      y === c.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && s && (T.preventDefault(), s()));
    }, f), b.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (iy = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), oy(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = iy);
        };
    }, [u, f, n, c]), b.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), oy());
    }, [u, c]), b.useEffect(() => {
      const T = () => g({});
      return document.addEventListener(Ng, T), () => document.removeEventListener(Ng, T);
    }, []), /* @__PURE__ */ _(
      vt.div,
      {
        ...l,
        ref: h,
        style: {
          pointerEvents: E ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: me(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: me(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: me(
          e.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
LC.displayName = pz;
var mz = "DismissableLayerBranch", bz = b.forwardRef((e, t) => {
  const n = b.useContext(DC), r = b.useRef(null), a = tt(t, r);
  return b.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ _(vt.div, { ...e, ref: a });
});
bz.displayName = mz;
function vz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qe(e), r = b.useRef(!1), a = b.useRef(() => {
  });
  return b.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          MC(
            gz,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = l, t.addEventListener("click", a.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function yz(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qe(e), r = b.useRef(!1);
  return b.useEffect(() => {
    const a = (i) => {
      i.target && !r.current && MC(hz, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function oy() {
  const e = new CustomEvent(Ng);
  document.dispatchEvent(e);
}
function MC(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), r ? OC(a, i) : a.dispatchEvent(i);
}
var _l = "focusScope.autoFocusOnMount", Tl = "focusScope.autoFocusOnUnmount", sy = { bubbles: !1, cancelable: !0 }, Ez = "FocusScope", PC = b.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i,
    ...o
  } = e, [s, l] = b.useState(null), c = Qe(a), u = Qe(i), d = b.useRef(null), f = tt(t, (p) => l(p)), g = b.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  b.useEffect(() => {
    if (r) {
      let p = function(E) {
        if (g.paused || !s) return;
        const S = E.target;
        s.contains(S) ? d.current = S : kn(d.current, { select: !0 });
      }, m = function(E) {
        if (g.paused || !s) return;
        const S = E.relatedTarget;
        S !== null && (s.contains(S) || kn(d.current, { select: !0 }));
      }, v = function(E) {
        if (document.activeElement === document.body)
          for (const w of E)
            w.removedNodes.length > 0 && kn(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const y = new MutationObserver(v);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [r, s, g.paused]), b.useEffect(() => {
    if (s) {
      cy.add(g);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const v = new CustomEvent(_l, sy);
        s.addEventListener(_l, c), s.dispatchEvent(v), v.defaultPrevented || (Sz(Az(FC(s)), { select: !0 }), document.activeElement === p && kn(s));
      }
      return () => {
        s.removeEventListener(_l, c), setTimeout(() => {
          const v = new CustomEvent(Tl, sy);
          s.addEventListener(Tl, u), s.dispatchEvent(v), v.defaultPrevented || kn(p ?? document.body, { select: !0 }), s.removeEventListener(Tl, u), cy.remove(g);
        }, 0);
      };
    }
  }, [s, c, u, g]);
  const h = b.useCallback(
    (p) => {
      if (!n && !r || g.paused) return;
      const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, v = document.activeElement;
      if (m && v) {
        const y = p.currentTarget, [E, S] = wz(y);
        E && S ? !p.shiftKey && v === S ? (p.preventDefault(), n && kn(E, { select: !0 })) : p.shiftKey && v === E && (p.preventDefault(), n && kn(S, { select: !0 })) : v === y && p.preventDefault();
      }
    },
    [n, r, g.paused]
  );
  return /* @__PURE__ */ _(vt.div, { tabIndex: -1, ...o, ref: f, onKeyDown: h });
});
PC.displayName = Ez;
function Sz(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (kn(r, { select: t }), document.activeElement !== n) return;
}
function wz(e) {
  const t = FC(e), n = ly(t, e), r = ly(t.reverse(), e);
  return [n, r];
}
function FC(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ly(e, t) {
  for (const n of e)
    if (!_z(n, { upTo: t })) return n;
}
function _z(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Tz(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function kn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Tz(e) && t && e.select();
  }
}
var cy = Rz();
function Rz() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = uy(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = uy(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function uy(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Az(e) {
  return e.filter((t) => t.tagName !== "A");
}
var xz = "Arrow", $C = b.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: a = 5, ...i } = e;
  return /* @__PURE__ */ _(
    vt.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ _("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
$C.displayName = xz;
var Cz = $C, zh = "Popper", [BC, UC] = nn(zh), [Nz, GC] = BC(zh), HC = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = b.useState(null);
  return /* @__PURE__ */ _(Nz, { scope: t, anchor: r, onAnchorChange: a, children: n });
};
HC.displayName = zh;
var zC = "PopperAnchor", WC = b.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...a } = e, i = GC(zC, n), o = b.useRef(null), s = tt(t, o);
    return b.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || o.current);
    }), r ? null : /* @__PURE__ */ _(vt.div, { ...a, ref: s });
  }
);
WC.displayName = zC;
var Wh = "PopperContent", [Iz, kz] = BC(Wh), qC = b.forwardRef(
  (e, t) => {
    var H, K, J, ne, ee, ae;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: a = 0,
      align: i = "center",
      alignOffset: o = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: g = "optimized",
      onPlaced: h,
      ...p
    } = e, m = GC(Wh, n), [v, y] = b.useState(null), E = tt(t, (he) => y(he)), [S, w] = b.useState(null), R = Tx(S), T = (R == null ? void 0 : R.width) ?? 0, A = (R == null ? void 0 : R.height) ?? 0, C = r + (i !== "center" ? "-" + i : ""), N = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, L = Array.isArray(c) ? c : [c], I = L.length > 0, k = {
      padding: N,
      boundary: L.filter(Dz),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: B, floatingStyles: F, placement: P, isPositioned: D, middlewareData: O } = wx({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: C,
      whileElementsMounted: (...he) => px(...he, {
        animationFrame: g === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        gx({ mainAxis: a + A, alignmentAxis: o }),
        l && hx({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? yx() : void 0,
          ...k
        }),
        l && mx({ ...k }),
        bx({
          ...k,
          apply: ({ elements: he, rects: $, availableWidth: Y, availableHeight: Ee }) => {
            const { width: Te, height: Ue } = $.reference, oe = he.floating.style;
            oe.setProperty("--radix-popper-available-width", `${Y}px`), oe.setProperty("--radix-popper-available-height", `${Ee}px`), oe.setProperty("--radix-popper-anchor-width", `${Te}px`), oe.setProperty("--radix-popper-anchor-height", `${Ue}px`);
          }
        }),
        S && Ex({ element: S, padding: s }),
        Lz({ arrowWidth: T, arrowHeight: A }),
        f && vx({ strategy: "referenceHidden", ...k })
      ]
    }), [M, W] = YC(P), U = Qe(h);
    We(() => {
      D && (U == null || U());
    }, [D, U]);
    const q = (H = O.arrow) == null ? void 0 : H.x, re = (K = O.arrow) == null ? void 0 : K.y, j = ((J = O.arrow) == null ? void 0 : J.centerOffset) !== 0, [ie, Q] = b.useState();
    return We(() => {
      v && Q(window.getComputedStyle(v).zIndex);
    }, [v]), /* @__PURE__ */ _(
      "div",
      {
        ref: B.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...F,
          transform: D ? F.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ie,
          "--radix-popper-transform-origin": [
            (ne = O.transformOrigin) == null ? void 0 : ne.x,
            (ee = O.transformOrigin) == null ? void 0 : ee.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ae = O.hide) == null ? void 0 : ae.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ _(
          Iz,
          {
            scope: n,
            placedSide: M,
            onArrowChange: w,
            arrowX: q,
            arrowY: re,
            shouldHideArrow: j,
            children: /* @__PURE__ */ _(
              vt.div,
              {
                "data-side": M,
                "data-align": W,
                ...p,
                ref: E,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: D ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
qC.displayName = Wh;
var VC = "PopperArrow", Oz = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, jC = b.forwardRef(function(t, n) {
  const { __scopePopper: r, ...a } = t, i = kz(VC, r), o = Oz[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ _(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ _(
          Cz,
          {
            ...a,
            ref: n,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
jC.displayName = VC;
function Dz(e) {
  return e !== null;
}
var Lz = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var m, v, y;
    const { placement: n, rects: r, middlewareData: a } = t, o = ((m = a.arrow) == null ? void 0 : m.centerOffset) !== 0, s = o ? 0 : e.arrowWidth, l = o ? 0 : e.arrowHeight, [c, u] = YC(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((v = a.arrow) == null ? void 0 : v.x) ?? 0) + s / 2, g = (((y = a.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let h = "", p = "";
    return c === "bottom" ? (h = o ? d : `${f}px`, p = `${-l}px`) : c === "top" ? (h = o ? d : `${f}px`, p = `${r.floating.height + l}px`) : c === "right" ? (h = `${-l}px`, p = o ? d : `${g}px`) : c === "left" && (h = `${r.floating.width + l}px`, p = o ? d : `${g}px`), { data: { x: h, y: p } };
  }
});
function YC(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Mz = HC, Pz = WC, Fz = qC, $z = jC, Bz = "Portal", KC = b.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [a, i] = b.useState(!1);
  We(() => i(!0), []);
  const o = n || a && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return o ? zg.createPortal(/* @__PURE__ */ _(vt.div, { ...r, ref: t }), o) : null;
});
KC.displayName = Bz;
function Uz(e, t) {
  return b.useReducer((n, r) => t[n][r] ?? n, e);
}
var va = (e) => {
  const { present: t, children: n } = e, r = Gz(t), a = typeof n == "function" ? n({ present: r.isPresent }) : b.Children.only(n), i = tt(r.ref, Hz(a));
  return typeof n == "function" || r.isPresent ? b.cloneElement(a, { ref: i }) : null;
};
va.displayName = "Presence";
function Gz(e) {
  const [t, n] = b.useState(), r = b.useRef({}), a = b.useRef(e), i = b.useRef("none"), o = e ? "mounted" : "unmounted", [s, l] = Uz(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return b.useEffect(() => {
    const c = uo(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), We(() => {
    const c = r.current, u = a.current;
    if (u !== e) {
      const f = i.current, g = uo(c);
      e ? l("MOUNT") : g === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== g ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, l]), We(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (g) => {
        const p = uo(r.current).includes(g.animationName);
        if (g.target === t && p && (l("ANIMATION_END"), !a.current)) {
          const m = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = m);
          });
        }
      }, f = (g) => {
        g.target === t && (i.current = uo(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: b.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function uo(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Hz(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Rl = "rovingFocusGroup.onEntryFocus", zz = { bubbles: !1, cancelable: !0 }, Cs = "RovingFocusGroup", [Ig, XC, Wz] = kC(Cs), [qz, ZC] = nn(
  Cs,
  [Wz]
), [Vz, jz] = qz(Cs), QC = b.forwardRef(
  (e, t) => /* @__PURE__ */ _(Ig.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ _(Ig.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ _(Yz, { ...e, ref: t }) }) })
);
QC.displayName = Cs;
var Yz = b.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: a = !1,
    dir: i,
    currentTabStopId: o,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, f = b.useRef(null), g = tt(t, f), h = Ni(i), [p = null, m] = wr({
    prop: o,
    defaultProp: s,
    onChange: l
  }), [v, y] = b.useState(!1), E = Qe(c), S = XC(n), w = b.useRef(!1), [R, T] = b.useState(0);
  return b.useEffect(() => {
    const A = f.current;
    if (A)
      return A.addEventListener(Rl, E), () => A.removeEventListener(Rl, E);
  }, [E]), /* @__PURE__ */ _(
    Vz,
    {
      scope: n,
      orientation: r,
      dir: h,
      loop: a,
      currentTabStopId: p,
      onItemFocus: b.useCallback(
        (A) => m(A),
        [m]
      ),
      onItemShiftTab: b.useCallback(() => y(!0), []),
      onFocusableItemAdd: b.useCallback(
        () => T((A) => A + 1),
        []
      ),
      onFocusableItemRemove: b.useCallback(
        () => T((A) => A - 1),
        []
      ),
      children: /* @__PURE__ */ _(
        vt.div,
        {
          tabIndex: v || R === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: g,
          style: { outline: "none", ...e.style },
          onMouseDown: me(e.onMouseDown, () => {
            w.current = !0;
          }),
          onFocus: me(e.onFocus, (A) => {
            const C = !w.current;
            if (A.target === A.currentTarget && C && !v) {
              const N = new CustomEvent(Rl, zz);
              if (A.currentTarget.dispatchEvent(N), !N.defaultPrevented) {
                const L = S().filter((P) => P.focusable), I = L.find((P) => P.active), k = L.find((P) => P.id === p), F = [I, k, ...L].filter(
                  Boolean
                ).map((P) => P.ref.current);
                tN(F, u);
              }
            }
            w.current = !1;
          }),
          onBlur: me(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), JC = "RovingFocusGroupItem", eN = b.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: a = !1,
      tabStopId: i,
      ...o
    } = e, s = Bt(), l = i || s, c = jz(JC, n), u = c.currentTabStopId === l, d = XC(n), { onFocusableItemAdd: f, onFocusableItemRemove: g } = c;
    return b.useEffect(() => {
      if (r)
        return f(), () => g();
    }, [r, f, g]), /* @__PURE__ */ _(
      Ig.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: a,
        children: /* @__PURE__ */ _(
          vt.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...o,
            ref: t,
            onMouseDown: me(e.onMouseDown, (h) => {
              r ? c.onItemFocus(l) : h.preventDefault();
            }),
            onFocus: me(e.onFocus, () => c.onItemFocus(l)),
            onKeyDown: me(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget) return;
              const p = Zz(h, c.orientation, c.dir);
              if (p !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey) return;
                h.preventDefault();
                let v = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (p === "last") v.reverse();
                else if (p === "prev" || p === "next") {
                  p === "prev" && v.reverse();
                  const y = v.indexOf(h.currentTarget);
                  v = c.loop ? Qz(v, y + 1) : v.slice(y + 1);
                }
                setTimeout(() => tN(v));
              }
            })
          }
        )
      }
    );
  }
);
eN.displayName = JC;
var Kz = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Xz(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Zz(e, t, n) {
  const r = Xz(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Kz[r];
}
function tN(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Qz(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Jz = QC, e3 = eN, Do = "right-scroll-bar-position", Lo = "width-before-scroll-bar", t3 = "with-scroll-bars-hidden", n3 = "--removed-body-scroll-bar-size";
function Al(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function r3(e, t) {
  var n = He(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var a3 = typeof window < "u" ? b.useLayoutEffect : b.useEffect, dy = /* @__PURE__ */ new WeakMap();
function i3(e, t) {
  var n = r3(null, function(r) {
    return e.forEach(function(a) {
      return Al(a, r);
    });
  });
  return a3(function() {
    var r = dy.get(n);
    if (r) {
      var a = new Set(r), i = new Set(e), o = n.current;
      a.forEach(function(s) {
        i.has(s) || Al(s, null);
      }), i.forEach(function(s) {
        a.has(s) || Al(s, o);
      });
    }
    dy.set(n, e);
  }, [e]), n;
}
var nN = Es(), xl = function() {
}, Ns = b.forwardRef(function(e, t) {
  var n = b.useRef(null), r = b.useState({
    onScrollCapture: xl,
    onWheelCapture: xl,
    onTouchMoveCapture: xl
  }), a = r[0], i = r[1], o = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, g = e.noIsolation, h = e.inert, p = e.allowPinchZoom, m = e.as, v = m === void 0 ? "div" : m, y = e.gapMode, E = xi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = f, w = i3([n, t]), R = we(we({}, E), a);
  return b.createElement(
    b.Fragment,
    null,
    u && b.createElement(S, { sideCar: nN, removeScrollBar: c, shards: d, noIsolation: g, inert: h, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    o ? b.cloneElement(b.Children.only(s), we(we({}, R), { ref: w })) : b.createElement(v, we({}, R, { className: l, ref: w }), s)
  );
});
Ns.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ns.classNames = {
  fullWidth: Lo,
  zeroRight: Do
};
function o3() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = GA();
  return t && e.setAttribute("nonce", t), e;
}
function s3(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function l3(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var c3 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = o3()) && (s3(t, n), l3(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, u3 = function() {
  var e = c3();
  return function(t, n) {
    b.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, d3 = function() {
  var e = u3(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, f3 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Cl = function(e) {
  return parseInt(e || "", 10) || 0;
}, p3 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Cl(n), Cl(r), Cl(a)];
}, g3 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return f3;
  var t = p3(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, h3 = d3(), ta = "data-scroll-locked", m3 = function(e, t, n, r) {
  var a = e.left, i = e.top, o = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(t3, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(ta, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Do, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Lo, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Do, " .").concat(Do, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Lo, " .").concat(Lo, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(ta, `] {
    `).concat(n3, ": ").concat(s, `px;
  }
`);
}, fy = function() {
  var e = parseInt(document.body.getAttribute(ta) || "0", 10);
  return isFinite(e) ? e : 0;
}, b3 = function() {
  b.useEffect(function() {
    return document.body.setAttribute(ta, (fy() + 1).toString()), function() {
      var e = fy() - 1;
      e <= 0 ? document.body.removeAttribute(ta) : document.body.setAttribute(ta, e.toString());
    };
  }, []);
}, v3 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r;
  b3();
  var i = b.useMemo(function() {
    return g3(a);
  }, [a]);
  return b.createElement(h3, { styles: m3(i, !t, a, n ? "" : "!important") });
}, kg = !1;
if (typeof window < "u")
  try {
    var fo = Object.defineProperty({}, "passive", {
      get: function() {
        return kg = !0, !0;
      }
    });
    window.addEventListener("test", fo, fo), window.removeEventListener("test", fo, fo);
  } catch {
    kg = !1;
  }
var Gr = kg ? { passive: !1 } : !1, y3 = function(e) {
  return e.tagName === "TEXTAREA";
}, rN = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !y3(e) && n[t] === "visible")
  );
}, E3 = function(e) {
  return rN(e, "overflowY");
}, S3 = function(e) {
  return rN(e, "overflowX");
}, py = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = aN(e, r);
    if (a) {
      var i = iN(e, r), o = i[1], s = i[2];
      if (o > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, w3 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, _3 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, aN = function(e, t) {
  return e === "v" ? E3(t) : S3(t);
}, iN = function(e, t) {
  return e === "v" ? w3(t) : _3(t);
}, T3 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, R3 = function(e, t, n, r, a) {
  var i = T3(e, window.getComputedStyle(t).direction), o = i * r, s = n.target, l = t.contains(s), c = !1, u = o > 0, d = 0, f = 0;
  do {
    var g = iN(e, s), h = g[0], p = g[1], m = g[2], v = p - m - i * h;
    (h || v) && aN(e, s) && (d += v, f += h), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && (Math.abs(d) < 1 || !a) || !u && (Math.abs(f) < 1 || !a)) && (c = !0), c;
}, po = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, gy = function(e) {
  return [e.deltaX, e.deltaY];
}, hy = function(e) {
  return e && "current" in e ? e.current : e;
}, A3 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, x3 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, C3 = 0, Hr = [];
function N3(e) {
  var t = b.useRef([]), n = b.useRef([0, 0]), r = b.useRef(), a = b.useState(C3++)[0], i = b.useState(Ci)[0], o = b.useRef(e);
  b.useEffect(function() {
    o.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = ys([e.lockRef.current], (e.shards || []).map(hy), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = b.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !o.current.allowPinchZoom;
    var v = po(p), y = n.current, E = "deltaX" in p ? p.deltaX : y[0] - v[0], S = "deltaY" in p ? p.deltaY : y[1] - v[1], w, R = p.target, T = Math.abs(E) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && T === "h" && R.type === "range")
      return !1;
    var A = py(T, R);
    if (!A)
      return !0;
    if (A ? w = T : (w = T === "v" ? "h" : "v", A = py(T, R)), !A)
      return !1;
    if (!r.current && "changedTouches" in p && (E || S) && (r.current = w), !w)
      return !0;
    var C = r.current || w;
    return R3(C, m, p, C === "h" ? E : S, !0);
  }, []), l = b.useCallback(function(p) {
    var m = p;
    if (!(!Hr.length || Hr[Hr.length - 1] !== i)) {
      var v = "deltaY" in m ? gy(m) : po(m), y = t.current.filter(function(w) {
        return w.name === m.type && (w.target === m.target || m.target === w.shadowParent) && A3(w.delta, v);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var E = (o.current.shards || []).map(hy).filter(Boolean).filter(function(w) {
          return w.contains(m.target);
        }), S = E.length > 0 ? s(m, E[0]) : !o.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = b.useCallback(function(p, m, v, y) {
    var E = { name: p, delta: m, target: v, should: y, shadowParent: I3(v) };
    t.current.push(E), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== E;
      });
    }, 1);
  }, []), u = b.useCallback(function(p) {
    n.current = po(p), r.current = void 0;
  }, []), d = b.useCallback(function(p) {
    c(p.type, gy(p), p.target, s(p, e.lockRef.current));
  }, []), f = b.useCallback(function(p) {
    c(p.type, po(p), p.target, s(p, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return Hr.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Gr), document.addEventListener("touchmove", l, Gr), document.addEventListener("touchstart", u, Gr), function() {
      Hr = Hr.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", l, Gr), document.removeEventListener("touchmove", l, Gr), document.removeEventListener("touchstart", u, Gr);
    };
  }, []);
  var g = e.removeScrollBar, h = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    h ? b.createElement(i, { styles: x3(a) }) : null,
    g ? b.createElement(v3, { gapMode: e.gapMode }) : null
  );
}
function I3(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const k3 = Ss(nN, N3);
var oN = b.forwardRef(function(e, t) {
  return b.createElement(Ns, we({}, e, { ref: t, sideCar: k3 }));
});
oN.classNames = Ns.classNames;
var Og = ["Enter", " "], O3 = ["ArrowDown", "PageUp", "Home"], sN = ["ArrowUp", "PageDown", "End"], D3 = [...O3, ...sN], L3 = {
  ltr: [...Og, "ArrowRight"],
  rtl: [...Og, "ArrowLeft"]
}, M3 = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Oi = "Menu", [gi, P3, F3] = kC(Oi), [Nr, lN] = nn(Oi, [
  F3,
  UC,
  ZC
]), Is = UC(), cN = ZC(), [$3, Ir] = Nr(Oi), [B3, Di] = Nr(Oi), uN = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: a, onOpenChange: i, modal: o = !0 } = e, s = Is(t), [l, c] = b.useState(null), u = b.useRef(!1), d = Qe(i), f = Ni(a);
  return b.useEffect(() => {
    const g = () => {
      u.current = !0, document.addEventListener("pointerdown", h, { capture: !0, once: !0 }), document.addEventListener("pointermove", h, { capture: !0, once: !0 });
    }, h = () => u.current = !1;
    return document.addEventListener("keydown", g, { capture: !0 }), () => {
      document.removeEventListener("keydown", g, { capture: !0 }), document.removeEventListener("pointerdown", h, { capture: !0 }), document.removeEventListener("pointermove", h, { capture: !0 });
    };
  }, []), /* @__PURE__ */ _(Mz, { ...s, children: /* @__PURE__ */ _(
    $3,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ _(
        B3,
        {
          scope: t,
          onClose: b.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: u,
          dir: f,
          modal: o,
          children: r
        }
      )
    }
  ) });
};
uN.displayName = Oi;
var U3 = "MenuAnchor", qh = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, a = Is(n);
    return /* @__PURE__ */ _(Pz, { ...a, ...r, ref: t });
  }
);
qh.displayName = U3;
var Vh = "MenuPortal", [G3, dN] = Nr(Vh, {
  forceMount: void 0
}), fN = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: a } = e, i = Ir(Vh, t);
  return /* @__PURE__ */ _(G3, { scope: t, forceMount: n, children: /* @__PURE__ */ _(va, { present: n || i.open, children: /* @__PURE__ */ _(KC, { asChild: !0, container: a, children: r }) }) });
};
fN.displayName = Vh;
var xt = "MenuContent", [H3, jh] = Nr(xt), pN = b.forwardRef(
  (e, t) => {
    const n = dN(xt, e.__scopeMenu), { forceMount: r = n.forceMount, ...a } = e, i = Ir(xt, e.__scopeMenu), o = Di(xt, e.__scopeMenu);
    return /* @__PURE__ */ _(gi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ _(va, { present: r || i.open, children: /* @__PURE__ */ _(gi.Slot, { scope: e.__scopeMenu, children: o.modal ? /* @__PURE__ */ _(z3, { ...a, ref: t }) : /* @__PURE__ */ _(W3, { ...a, ref: t }) }) }) });
  }
), z3 = b.forwardRef(
  (e, t) => {
    const n = Ir(xt, e.__scopeMenu), r = b.useRef(null), a = tt(t, r);
    return b.useEffect(() => {
      const i = r.current;
      if (i) return vs(i);
    }, []), /* @__PURE__ */ _(
      Yh,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: me(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), W3 = b.forwardRef((e, t) => {
  const n = Ir(xt, e.__scopeMenu);
  return /* @__PURE__ */ _(
    Yh,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Yh = b.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: a,
      onOpenAutoFocus: i,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: g,
      disableOutsideScroll: h,
      ...p
    } = e, m = Ir(xt, n), v = Di(xt, n), y = Is(n), E = cN(n), S = P3(n), [w, R] = b.useState(null), T = b.useRef(null), A = tt(t, T, m.onContentChange), C = b.useRef(0), N = b.useRef(""), L = b.useRef(0), I = b.useRef(null), k = b.useRef("right"), B = b.useRef(0), F = h ? oN : b.Fragment, P = h ? { as: pi, allowPinchZoom: !0 } : void 0, D = (M) => {
      var H, K;
      const W = N.current + M, U = S().filter((J) => !J.disabled), q = document.activeElement, re = (H = U.find((J) => J.ref.current === q)) == null ? void 0 : H.textValue, j = U.map((J) => J.textValue), ie = nW(j, W, re), Q = (K = U.find((J) => J.textValue === ie)) == null ? void 0 : K.ref.current;
      (function J(ne) {
        N.current = ne, window.clearTimeout(C.current), ne !== "" && (C.current = window.setTimeout(() => J(""), 1e3));
      })(W), Q && setTimeout(() => Q.focus());
    };
    b.useEffect(() => () => window.clearTimeout(C.current), []), Ih();
    const O = b.useCallback((M) => {
      var U, q;
      return k.current === ((U = I.current) == null ? void 0 : U.side) && aW(M, (q = I.current) == null ? void 0 : q.area);
    }, []);
    return /* @__PURE__ */ _(
      H3,
      {
        scope: n,
        searchRef: N,
        onItemEnter: b.useCallback(
          (M) => {
            O(M) && M.preventDefault();
          },
          [O]
        ),
        onItemLeave: b.useCallback(
          (M) => {
            var W;
            O(M) || ((W = T.current) == null || W.focus(), R(null));
          },
          [O]
        ),
        onTriggerLeave: b.useCallback(
          (M) => {
            O(M) && M.preventDefault();
          },
          [O]
        ),
        pointerGraceTimerRef: L,
        onPointerGraceIntentChange: b.useCallback((M) => {
          I.current = M;
        }, []),
        children: /* @__PURE__ */ _(F, { ...P, children: /* @__PURE__ */ _(
          PC,
          {
            asChild: !0,
            trapped: a,
            onMountAutoFocus: me(i, (M) => {
              var W;
              M.preventDefault(), (W = T.current) == null || W.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: o,
            children: /* @__PURE__ */ _(
              LC,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: g,
                children: /* @__PURE__ */ _(
                  Jz,
                  {
                    asChild: !0,
                    ...E,
                    dir: v.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: w,
                    onCurrentTabStopIdChange: R,
                    onEntryFocus: me(l, (M) => {
                      v.isUsingKeyboardRef.current || M.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ _(
                      Fz,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": NN(m.open),
                        "data-radix-menu-content": "",
                        dir: v.dir,
                        ...y,
                        ...p,
                        ref: A,
                        style: { outline: "none", ...p.style },
                        onKeyDown: me(p.onKeyDown, (M) => {
                          const U = M.target.closest("[data-radix-menu-content]") === M.currentTarget, q = M.ctrlKey || M.altKey || M.metaKey, re = M.key.length === 1;
                          U && (M.key === "Tab" && M.preventDefault(), !q && re && D(M.key));
                          const j = T.current;
                          if (M.target !== j || !D3.includes(M.key)) return;
                          M.preventDefault();
                          const Q = S().filter((H) => !H.disabled).map((H) => H.ref.current);
                          sN.includes(M.key) && Q.reverse(), eW(Q);
                        }),
                        onBlur: me(e.onBlur, (M) => {
                          M.currentTarget.contains(M.target) || (window.clearTimeout(C.current), N.current = "");
                        }),
                        onPointerMove: me(
                          e.onPointerMove,
                          hi((M) => {
                            const W = M.target, U = B.current !== M.clientX;
                            if (M.currentTarget.contains(W) && U) {
                              const q = M.clientX > B.current ? "right" : "left";
                              k.current = q, B.current = M.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
pN.displayName = xt;
var q3 = "MenuGroup", Kh = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ _(vt.div, { role: "group", ...r, ref: t });
  }
);
Kh.displayName = q3;
var V3 = "MenuLabel", gN = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ _(vt.div, { ...r, ref: t });
  }
);
gN.displayName = V3;
var rs = "MenuItem", my = "menu.itemSelect", ks = b.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...a } = e, i = b.useRef(null), o = Di(rs, e.__scopeMenu), s = jh(rs, e.__scopeMenu), l = tt(t, i), c = b.useRef(!1), u = () => {
      const d = i.current;
      if (!n && d) {
        const f = new CustomEvent(my, { bubbles: !0, cancelable: !0 });
        d.addEventListener(my, (g) => r == null ? void 0 : r(g), { once: !0 }), OC(d, f), f.defaultPrevented ? c.current = !1 : o.onClose();
      }
    };
    return /* @__PURE__ */ _(
      hN,
      {
        ...a,
        ref: l,
        disabled: n,
        onClick: me(e.onClick, u),
        onPointerDown: (d) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, d), c.current = !0;
        },
        onPointerUp: me(e.onPointerUp, (d) => {
          var f;
          c.current || (f = d.currentTarget) == null || f.click();
        }),
        onKeyDown: me(e.onKeyDown, (d) => {
          const f = s.searchRef.current !== "";
          n || f && d.key === " " || Og.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
ks.displayName = rs;
var hN = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: a, ...i } = e, o = jh(rs, n), s = cN(n), l = b.useRef(null), c = tt(t, l), [u, d] = b.useState(!1), [f, g] = b.useState("");
    return b.useEffect(() => {
      const h = l.current;
      h && g((h.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ _(
      gi.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: a ?? f,
        children: /* @__PURE__ */ _(e3, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ _(
          vt.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: c,
            onPointerMove: me(
              e.onPointerMove,
              hi((h) => {
                r ? o.onItemLeave(h) : (o.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: me(
              e.onPointerLeave,
              hi((h) => o.onItemLeave(h))
            ),
            onFocus: me(e.onFocus, () => d(!0)),
            onBlur: me(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), j3 = "MenuCheckboxItem", mN = b.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...a } = e;
    return /* @__PURE__ */ _(SN, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ _(
      ks,
      {
        role: "menuitemcheckbox",
        "aria-checked": as(n) ? "mixed" : n,
        ...a,
        ref: t,
        "data-state": Zh(n),
        onSelect: me(
          a.onSelect,
          () => r == null ? void 0 : r(as(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
mN.displayName = j3;
var bN = "MenuRadioGroup", [Y3, K3] = Nr(
  bN,
  { value: void 0, onValueChange: () => {
  } }
), vN = b.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...a } = e, i = Qe(r);
    return /* @__PURE__ */ _(Y3, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ _(Kh, { ...a, ref: t }) });
  }
);
vN.displayName = bN;
var yN = "MenuRadioItem", EN = b.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, a = K3(yN, e.__scopeMenu), i = n === a.value;
    return /* @__PURE__ */ _(SN, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ _(
      ks,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": Zh(i),
        onSelect: me(
          r.onSelect,
          () => {
            var o;
            return (o = a.onValueChange) == null ? void 0 : o.call(a, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
EN.displayName = yN;
var Xh = "MenuItemIndicator", [SN, X3] = Nr(
  Xh,
  { checked: !1 }
), wN = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...a } = e, i = X3(Xh, n);
    return /* @__PURE__ */ _(
      va,
      {
        present: r || as(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ _(
          vt.span,
          {
            ...a,
            ref: t,
            "data-state": Zh(i.checked)
          }
        )
      }
    );
  }
);
wN.displayName = Xh;
var Z3 = "MenuSeparator", _N = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ _(
      vt.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
_N.displayName = Z3;
var Q3 = "MenuArrow", TN = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, a = Is(n);
    return /* @__PURE__ */ _($z, { ...a, ...r, ref: t });
  }
);
TN.displayName = Q3;
var J3 = "MenuSub", [IX, RN] = Nr(J3), Wa = "MenuSubTrigger", AN = b.forwardRef(
  (e, t) => {
    const n = Ir(Wa, e.__scopeMenu), r = Di(Wa, e.__scopeMenu), a = RN(Wa, e.__scopeMenu), i = jh(Wa, e.__scopeMenu), o = b.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = i, c = { __scopeMenu: e.__scopeMenu }, u = b.useCallback(() => {
      o.current && window.clearTimeout(o.current), o.current = null;
    }, []);
    return b.useEffect(() => u, [u]), b.useEffect(() => {
      const d = s.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [s, l]), /* @__PURE__ */ _(qh, { asChild: !0, ...c, children: /* @__PURE__ */ _(
      hN,
      {
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": a.contentId,
        "data-state": NN(n.open),
        ...e,
        ref: ba(t, a.onTriggerChange),
        onClick: (d) => {
          var f;
          (f = e.onClick) == null || f.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: me(
          e.onPointerMove,
          hi((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !o.current && (i.onPointerGraceIntentChange(null), o.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: me(
          e.onPointerLeave,
          hi((d) => {
            var g, h;
            u();
            const f = (g = n.content) == null ? void 0 : g.getBoundingClientRect();
            if (f) {
              const p = (h = n.content) == null ? void 0 : h.dataset.side, m = p === "right", v = m ? -5 : 5, y = f[m ? "left" : "right"], E = f[m ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + v, y: d.clientY },
                  { x: y, y: f.top },
                  { x: E, y: f.top },
                  { x: E, y: f.bottom },
                  { x: y, y: f.bottom }
                ],
                side: p
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: me(e.onKeyDown, (d) => {
          var g;
          const f = i.searchRef.current !== "";
          e.disabled || f && d.key === " " || L3[r.dir].includes(d.key) && (n.onOpenChange(!0), (g = n.content) == null || g.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
AN.displayName = Wa;
var xN = "MenuSubContent", CN = b.forwardRef(
  (e, t) => {
    const n = dN(xt, e.__scopeMenu), { forceMount: r = n.forceMount, ...a } = e, i = Ir(xt, e.__scopeMenu), o = Di(xt, e.__scopeMenu), s = RN(xN, e.__scopeMenu), l = b.useRef(null), c = tt(t, l);
    return /* @__PURE__ */ _(gi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ _(va, { present: r || i.open, children: /* @__PURE__ */ _(gi.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ _(
      Yh,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...a,
        ref: c,
        align: "start",
        side: o.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var d;
          o.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: me(e.onFocusOutside, (u) => {
          u.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: me(e.onEscapeKeyDown, (u) => {
          o.onClose(), u.preventDefault();
        }),
        onKeyDown: me(e.onKeyDown, (u) => {
          var g;
          const d = u.currentTarget.contains(u.target), f = M3[o.dir].includes(u.key);
          d && f && (i.onOpenChange(!1), (g = s.trigger) == null || g.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
CN.displayName = xN;
function NN(e) {
  return e ? "open" : "closed";
}
function as(e) {
  return e === "indeterminate";
}
function Zh(e) {
  return as(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function eW(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function tW(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function nW(e, t, n) {
  const a = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let o = tW(e, Math.max(i, 0));
  a.length === 1 && (o = o.filter((c) => c !== n));
  const l = o.find(
    (c) => c.toLowerCase().startsWith(a.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function rW(e, t) {
  const { x: n, y: r } = e;
  let a = !1;
  for (let i = 0, o = t.length - 1; i < t.length; o = i++) {
    const s = t[i].x, l = t[i].y, c = t[o].x, u = t[o].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (a = !a);
  }
  return a;
}
function aW(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return rW(n, t);
}
function hi(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var iW = uN, oW = qh, sW = fN, lW = pN, cW = Kh, uW = gN, dW = ks, fW = mN, pW = vN, gW = EN, hW = wN, mW = _N, bW = TN, vW = AN, yW = CN, Qh = "DropdownMenu", [EW, kX] = nn(
  Qh,
  [lN]
), ut = lN(), [SW, IN] = EW(Qh), kN = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: a,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !0
  } = e, l = ut(t), c = b.useRef(null), [u = !1, d] = wr({
    prop: a,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ _(
    SW,
    {
      scope: t,
      triggerId: Bt(),
      triggerRef: c,
      contentId: Bt(),
      open: u,
      onOpenChange: d,
      onOpenToggle: b.useCallback(() => d((f) => !f), [d]),
      modal: s,
      children: /* @__PURE__ */ _(iW, { ...l, open: u, onOpenChange: d, dir: r, modal: s, children: n })
    }
  );
};
kN.displayName = Qh;
var ON = "DropdownMenuTrigger", DN = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...a } = e, i = IN(ON, n), o = ut(n);
    return /* @__PURE__ */ _(oW, { asChild: !0, ...o, children: /* @__PURE__ */ _(
      sz.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...a,
        ref: ba(t, i.triggerRef),
        onPointerDown: ns(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: ns(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
DN.displayName = ON;
var wW = "DropdownMenuPortal", LN = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = ut(t);
  return /* @__PURE__ */ _(sW, { ...r, ...n });
};
LN.displayName = wW;
var MN = "DropdownMenuContent", PN = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = IN(MN, n), i = ut(n), o = b.useRef(!1);
    return /* @__PURE__ */ _(
      lW,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: ns(e.onCloseAutoFocus, (s) => {
          var l;
          o.current || (l = a.triggerRef.current) == null || l.focus(), o.current = !1, s.preventDefault();
        }),
        onInteractOutside: ns(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!a.modal || u) && (o.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
PN.displayName = MN;
var _W = "DropdownMenuGroup", TW = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
    return /* @__PURE__ */ _(cW, { ...a, ...r, ref: t });
  }
);
TW.displayName = _W;
var RW = "DropdownMenuLabel", FN = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
    return /* @__PURE__ */ _(uW, { ...a, ...r, ref: t });
  }
);
FN.displayName = RW;
var AW = "DropdownMenuItem", $N = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
    return /* @__PURE__ */ _(dW, { ...a, ...r, ref: t });
  }
);
$N.displayName = AW;
var xW = "DropdownMenuCheckboxItem", BN = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
  return /* @__PURE__ */ _(fW, { ...a, ...r, ref: t });
});
BN.displayName = xW;
var CW = "DropdownMenuRadioGroup", NW = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
  return /* @__PURE__ */ _(pW, { ...a, ...r, ref: t });
});
NW.displayName = CW;
var IW = "DropdownMenuRadioItem", UN = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
  return /* @__PURE__ */ _(gW, { ...a, ...r, ref: t });
});
UN.displayName = IW;
var kW = "DropdownMenuItemIndicator", GN = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
  return /* @__PURE__ */ _(hW, { ...a, ...r, ref: t });
});
GN.displayName = kW;
var OW = "DropdownMenuSeparator", HN = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
  return /* @__PURE__ */ _(mW, { ...a, ...r, ref: t });
});
HN.displayName = OW;
var DW = "DropdownMenuArrow", LW = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
    return /* @__PURE__ */ _(bW, { ...a, ...r, ref: t });
  }
);
LW.displayName = DW;
var MW = "DropdownMenuSubTrigger", zN = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
  return /* @__PURE__ */ _(vW, { ...a, ...r, ref: t });
});
zN.displayName = MW;
var PW = "DropdownMenuSubContent", WN = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = ut(n);
  return /* @__PURE__ */ _(
    yW,
    {
      ...a,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
WN.displayName = PW;
var FW = kN, $W = DN, BW = LN, qN = PN, VN = FN, jN = $N, YN = BN, KN = UN, XN = GN, ZN = HN, QN = zN, JN = WN;
const UW = FW, GW = $W, HW = b.forwardRef(({ className: e, inset: t, children: n, ...r }, a) => /* @__PURE__ */ Z(
  QN,
  {
    ref: a,
    className: de(
      "flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ _(pM, { className: "ml-auto" })
    ]
  }
));
HW.displayName = QN.displayName;
const zW = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  JN,
  {
    ref: n,
    className: de(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
zW.displayName = JN.displayName;
const eI = b.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ _(BW, { children: /* @__PURE__ */ _(
  qN,
  {
    ref: r,
    sideOffset: t,
    className: de(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
eI.displayName = qN.displayName;
const tI = b.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ _(
  jN,
  {
    ref: r,
    className: de(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...n
  }
));
tI.displayName = jN.displayName;
const WW = b.forwardRef(({ className: e, children: t, checked: n, ...r }, a) => /* @__PURE__ */ Z(
  YN,
  {
    ref: a,
    className: de(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ _("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ _(XN, { children: /* @__PURE__ */ _(fM, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
WW.displayName = YN.displayName;
const qW = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  KN,
  {
    ref: r,
    className: de(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ _("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ _(XN, { children: /* @__PURE__ */ _(hM, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
qW.displayName = KN.displayName;
const VW = b.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ _(
  VN,
  {
    ref: r,
    className: de(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
VW.displayName = VN.displayName;
const jW = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  ZN,
  {
    ref: n,
    className: de("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
jW.displayName = ZN.displayName;
const OX = (e) => /* @__PURE__ */ Z(UW, { children: [
  /* @__PURE__ */ _(GW, { asChild: !0, children: /* @__PURE__ */ _(Xr, { ...e.buttonProps, children: /* @__PURE__ */ Z("span", { className: "flex items-center", children: [
    e.label,
    " ",
    /* @__PURE__ */ _("span", { className: "ml-4", children: /* @__PURE__ */ _(tz, {}) })
  ] }) }) }),
  /* @__PURE__ */ _(eI, { children: e.items.map((t) => /* @__PURE__ */ _(tI, { onClick: t.onClick, children: t.label })) })
] });
function Ja(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function YW(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function KW(...e) {
  return (t) => e.forEach((n) => YW(n, t));
}
function Os(...e) {
  return b.useCallback(KW(...e), e);
}
function XW(e, t) {
  return b.useReducer((n, r) => t[n][r] ?? n, e);
}
var Ds = (e) => {
  const { present: t, children: n } = e, r = ZW(t), a = typeof n == "function" ? n({ present: r.isPresent }) : b.Children.only(n), i = Os(r.ref, QW(a));
  return typeof n == "function" || r.isPresent ? b.cloneElement(a, { ref: i }) : null;
};
Ds.displayName = "Presence";
function ZW(e) {
  const [t, n] = b.useState(), r = b.useRef({}), a = b.useRef(e), i = b.useRef("none"), o = e ? "mounted" : "unmounted", [s, l] = XW(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return b.useEffect(() => {
    const c = go(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), We(() => {
    const c = r.current, u = a.current;
    if (u !== e) {
      const f = i.current, g = go(c);
      e ? l("MOUNT") : g === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== g ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, l]), We(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (g) => {
        const p = go(r.current).includes(g.animationName);
        if (g.target === t && p && (l("ANIMATION_END"), !a.current)) {
          const m = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = m);
          });
        }
      }, f = (g) => {
        g.target === t && (i.current = go(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: b.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function go(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function QW(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var JW = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Li = JW.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? It : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), nI = Es(), Nl = function() {
}, Ls = b.forwardRef(function(e, t) {
  var n = b.useRef(null), r = b.useState({
    onScrollCapture: Nl,
    onWheelCapture: Nl,
    onTouchMoveCapture: Nl
  }), a = r[0], i = r[1], o = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, g = e.noIsolation, h = e.inert, p = e.allowPinchZoom, m = e.as, v = m === void 0 ? "div" : m, y = e.gapMode, E = xi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = f, w = Ah([n, t]), R = we(we({}, E), a);
  return b.createElement(
    b.Fragment,
    null,
    u && b.createElement(S, { sideCar: nI, removeScrollBar: c, shards: d, noIsolation: g, inert: h, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: y }),
    o ? b.cloneElement(b.Children.only(s), we(we({}, R), { ref: w })) : b.createElement(v, we({}, R, { className: l, ref: w }), s)
  );
});
Ls.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ls.classNames = {
  fullWidth: Qr,
  zeroRight: Zr
};
var Dg = !1;
if (typeof window < "u")
  try {
    var ho = Object.defineProperty({}, "passive", {
      get: function() {
        return Dg = !0, !0;
      }
    });
    window.addEventListener("test", ho, ho), window.removeEventListener("test", ho, ho);
  } catch {
    Dg = !1;
  }
var zr = Dg ? { passive: !1 } : !1, eq = function(e) {
  return e.tagName === "TEXTAREA";
}, rI = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !eq(e) && n[t] === "visible")
  );
}, tq = function(e) {
  return rI(e, "overflowY");
}, nq = function(e) {
  return rI(e, "overflowX");
}, by = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = aI(e, r);
    if (a) {
      var i = iI(e, r), o = i[1], s = i[2];
      if (o > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, rq = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, aq = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, aI = function(e, t) {
  return e === "v" ? tq(t) : nq(t);
}, iI = function(e, t) {
  return e === "v" ? rq(t) : aq(t);
}, iq = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, oq = function(e, t, n, r, a) {
  var i = iq(e, window.getComputedStyle(t).direction), o = i * r, s = n.target, l = t.contains(s), c = !1, u = o > 0, d = 0, f = 0;
  do {
    var g = iI(e, s), h = g[0], p = g[1], m = g[2], v = p - m - i * h;
    (h || v) && aI(e, s) && (d += v, f += h), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && (Math.abs(d) < 1 || !a) || !u && (Math.abs(f) < 1 || !a)) && (c = !0), c;
}, mo = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, vy = function(e) {
  return [e.deltaX, e.deltaY];
}, yy = function(e) {
  return e && "current" in e ? e.current : e;
}, sq = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, lq = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, cq = 0, Wr = [];
function uq(e) {
  var t = b.useRef([]), n = b.useRef([0, 0]), r = b.useRef(), a = b.useState(cq++)[0], i = b.useState(Ci)[0], o = b.useRef(e);
  b.useEffect(function() {
    o.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = ys([e.lockRef.current], (e.shards || []).map(yy), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = b.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !o.current.allowPinchZoom;
    var v = mo(p), y = n.current, E = "deltaX" in p ? p.deltaX : y[0] - v[0], S = "deltaY" in p ? p.deltaY : y[1] - v[1], w, R = p.target, T = Math.abs(E) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && T === "h" && R.type === "range")
      return !1;
    var A = by(T, R);
    if (!A)
      return !0;
    if (A ? w = T : (w = T === "v" ? "h" : "v", A = by(T, R)), !A)
      return !1;
    if (!r.current && "changedTouches" in p && (E || S) && (r.current = w), !w)
      return !0;
    var C = r.current || w;
    return oq(C, m, p, C === "h" ? E : S, !0);
  }, []), l = b.useCallback(function(p) {
    var m = p;
    if (!(!Wr.length || Wr[Wr.length - 1] !== i)) {
      var v = "deltaY" in m ? vy(m) : mo(m), y = t.current.filter(function(w) {
        return w.name === m.type && (w.target === m.target || m.target === w.shadowParent) && sq(w.delta, v);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var E = (o.current.shards || []).map(yy).filter(Boolean).filter(function(w) {
          return w.contains(m.target);
        }), S = E.length > 0 ? s(m, E[0]) : !o.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = b.useCallback(function(p, m, v, y) {
    var E = { name: p, delta: m, target: v, should: y, shadowParent: dq(v) };
    t.current.push(E), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== E;
      });
    }, 1);
  }, []), u = b.useCallback(function(p) {
    n.current = mo(p), r.current = void 0;
  }, []), d = b.useCallback(function(p) {
    c(p.type, vy(p), p.target, s(p, e.lockRef.current));
  }, []), f = b.useCallback(function(p) {
    c(p.type, mo(p), p.target, s(p, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return Wr.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, zr), document.addEventListener("touchmove", l, zr), document.addEventListener("touchstart", u, zr), function() {
      Wr = Wr.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", l, zr), document.removeEventListener("touchmove", l, zr), document.removeEventListener("touchstart", u, zr);
    };
  }, []);
  var g = e.removeScrollBar, h = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    h ? b.createElement(i, { styles: lq(a) }) : null,
    g ? b.createElement(xh, { gapMode: e.gapMode }) : null
  );
}
function dq(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const fq = Ss(nI, uq);
var oI = b.forwardRef(function(e, t) {
  return b.createElement(Ls, we({}, e, { ref: t, sideCar: fq }));
});
oI.classNames = Ls.classNames;
var Jh = "Dialog", [sI, DX] = nn(Jh), [pq, Ht] = sI(Jh), lI = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    modal: o = !0
  } = e, s = b.useRef(null), l = b.useRef(null), [c = !1, u] = wr({
    prop: r,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ _(
    pq,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: Bt(),
      titleId: Bt(),
      descriptionId: Bt(),
      open: c,
      onOpenChange: u,
      onOpenToggle: b.useCallback(() => u((d) => !d), [u]),
      modal: o,
      children: n
    }
  );
};
lI.displayName = Jh;
var cI = "DialogTrigger", uI = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Ht(cI, n), i = Os(t, a.triggerRef);
    return /* @__PURE__ */ _(
      Li.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": nm(a.open),
        ...r,
        ref: i,
        onClick: Ja(e.onClick, a.onOpenToggle)
      }
    );
  }
);
uI.displayName = cI;
var em = "DialogPortal", [gq, dI] = sI(em, {
  forceMount: void 0
}), fI = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: a } = e, i = Ht(em, t);
  return /* @__PURE__ */ _(gq, { scope: t, forceMount: n, children: b.Children.map(r, (o) => /* @__PURE__ */ _(Ds, { present: n || i.open, children: /* @__PURE__ */ _(Gh, { asChild: !0, container: a, children: o }) })) });
};
fI.displayName = em;
var is = "DialogOverlay", pI = b.forwardRef(
  (e, t) => {
    const n = dI(is, e.__scopeDialog), { forceMount: r = n.forceMount, ...a } = e, i = Ht(is, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ _(Ds, { present: r || i.open, children: /* @__PURE__ */ _(hq, { ...a, ref: t }) }) : null;
  }
);
pI.displayName = is;
var hq = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Ht(is, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ _(oI, { as: It, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ _(
        Li.div,
        {
          "data-state": nm(a.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Tr = "DialogContent", gI = b.forwardRef(
  (e, t) => {
    const n = dI(Tr, e.__scopeDialog), { forceMount: r = n.forceMount, ...a } = e, i = Ht(Tr, e.__scopeDialog);
    return /* @__PURE__ */ _(Ds, { present: r || i.open, children: i.modal ? /* @__PURE__ */ _(mq, { ...a, ref: t }) : /* @__PURE__ */ _(bq, { ...a, ref: t }) });
  }
);
gI.displayName = Tr;
var mq = b.forwardRef(
  (e, t) => {
    const n = Ht(Tr, e.__scopeDialog), r = b.useRef(null), a = Os(t, n.contentRef, r);
    return b.useEffect(() => {
      const i = r.current;
      if (i) return vs(i);
    }, []), /* @__PURE__ */ _(
      hI,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ja(e.onCloseAutoFocus, (i) => {
          var o;
          i.preventDefault(), (o = n.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: Ja(e.onPointerDownOutside, (i) => {
          const o = i.detail.originalEvent, s = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: Ja(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), bq = b.forwardRef(
  (e, t) => {
    const n = Ht(Tr, e.__scopeDialog), r = b.useRef(!1), a = b.useRef(!1);
    return /* @__PURE__ */ _(
      hI,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var o, s;
          (o = e.onCloseAutoFocus) == null || o.call(e, i), i.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), i.preventDefault()), r.current = !1, a.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const o = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(o)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
        }
      }
    );
  }
), hI = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: i, ...o } = e, s = Ht(Tr, n), l = b.useRef(null), c = Os(t, l);
    return Ih(), /* @__PURE__ */ Z(Ke, { children: [
      /* @__PURE__ */ _(
        kh,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: a,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ _(
            Nh,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": nm(s.open),
              ...o,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ Z(Ke, { children: [
        /* @__PURE__ */ _(vq, { titleId: s.titleId }),
        /* @__PURE__ */ _(Eq, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), tm = "DialogTitle", mI = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Ht(tm, n);
    return /* @__PURE__ */ _(Li.h2, { id: a.titleId, ...r, ref: t });
  }
);
mI.displayName = tm;
var bI = "DialogDescription", vI = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Ht(bI, n);
    return /* @__PURE__ */ _(Li.p, { id: a.descriptionId, ...r, ref: t });
  }
);
vI.displayName = bI;
var yI = "DialogClose", EI = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, a = Ht(yI, n);
    return /* @__PURE__ */ _(
      Li.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Ja(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
EI.displayName = yI;
function nm(e) {
  return e ? "open" : "closed";
}
var SI = "DialogTitleWarning", [LX, wI] = OU(SI, {
  contentName: Tr,
  titleName: tm,
  docsSlug: "dialog"
}), vq = ({ titleId: e }) => {
  const t = wI(SI), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return b.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, yq = "DialogDescriptionWarning", Eq = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${wI(yq).contentName}}.`;
  return b.useEffect(() => {
    var i;
    const a = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Sq = lI, wq = uI, _q = fI, Tq = pI, Rq = gI, Aq = mI, xq = vI, Cq = EI;
function Nq(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const _I = G.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), ya = () => {
  const e = G.useContext(_I);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
Nq(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Iq() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function kq() {
  return rm(/^Mac/);
}
function Oq() {
  return rm(/^iPhone/);
}
function Ey() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Dq() {
  return rm(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  kq() && navigator.maxTouchPoints > 1;
}
function TI() {
  return Oq() || Dq();
}
function rm(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Lq = 24, Mq = typeof window < "u" ? Rr : ye;
function Sy(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const Il = typeof document < "u" && window.visualViewport;
function wy(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function RI(e) {
  for (wy(e) && (e = e.parentElement); e && !wy(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const Pq = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let bo = 0, kl;
function Fq(e = {}) {
  let { isDisabled: t } = e;
  Mq(() => {
    if (!t)
      return bo++, bo === 1 && TI() && (kl = $q()), () => {
        bo--, bo === 0 && (kl == null || kl());
      };
  }, [
    t
  ]);
}
function $q() {
  let e, t = 0, n = (d) => {
    e = RI(d.target), !(e === document.documentElement && e === document.body) && (t = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!e || e === document.documentElement || e === document.body) {
      d.preventDefault();
      return;
    }
    let f = d.changedTouches[0].pageY, g = e.scrollTop, h = e.scrollHeight - e.clientHeight;
    h !== 0 && ((g <= 0 && f > t || g >= h && f < t) && d.preventDefault(), t = f);
  }, a = (d) => {
    let f = d.target;
    Lg(f) && f !== document.activeElement && (d.preventDefault(), f.style.transform = "translateY(-2000px)", f.focus(), requestAnimationFrame(() => {
      f.style.transform = "";
    }));
  }, i = (d) => {
    let f = d.target;
    Lg(f) && (f.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      f.style.transform = "", Il && (Il.height < window.innerHeight ? requestAnimationFrame(() => {
        _y(f);
      }) : Il.addEventListener("resize", () => _y(f), {
        once: !0
      }));
    }));
  }, o = () => {
    window.scrollTo(0, 0);
  }, s = window.pageXOffset, l = window.pageYOffset, c = Sy(Bq(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = Sy(Oa(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), Oa(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), Oa(document, "touchend", a, {
    passive: !1,
    capture: !0
  }), Oa(document, "focus", i, !0), Oa(window, "scroll", o));
  return () => {
    c(), u(), window.scrollTo(s, l);
  };
}
function Bq(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Oa(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function _y(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = RI(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, a = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const o = n.getBoundingClientRect().bottom + Lq;
      i > o && (n.scrollTop += a - r);
    }
    e = n.parentElement;
  }
}
function Lg(e) {
  return e instanceof HTMLInputElement && !Pq.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function Uq(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Gq(...e) {
  return (t) => e.forEach((n) => Uq(n, t));
}
function AI(...e) {
  return b.useCallback(Gq(...e), e);
}
const xI = /* @__PURE__ */ new WeakMap();
function qe(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([a, i]) => {
    if (a.startsWith("--")) {
      e.style.setProperty(a, i);
      return;
    }
    r[a] = e.style[a], e.style[a] = i;
  }), !n && xI.set(e, r);
}
function Hq(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = xI.get(e);
  n && (e.style[t] = n[t]);
}
const Ve = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function vo(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let a = r.match(/^matrix3d\((.+)\)$/);
  return a ? parseFloat(a[1].split(", ")[Ve(t) ? 13 : 12]) : (a = r.match(/^matrix\((.+)\)$/), a ? parseFloat(a[1].split(", ")[Ve(t) ? 5 : 4]) : null);
}
function zq(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function Ol(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function Wq(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const Me = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, CI = 0.4, qq = 0.25, Vq = 100, NI = 8, ir = 16, Mg = 26, Dl = "vaul-dragging";
function II(e) {
  const t = G.useRef(e);
  return G.useEffect(() => {
    t.current = e;
  }), G.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function jq({ defaultProp: e, onChange: t }) {
  const n = G.useState(e), [r] = n, a = G.useRef(r), i = II(t);
  return G.useEffect(() => {
    a.current !== r && (i(r), a.current = r);
  }, [
    r,
    a,
    i
  ]), n;
}
function kI({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = jq({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, o = i ? e : r, s = II(n), l = G.useCallback((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && s(d);
    } else
      a(c);
  }, [
    i,
    e,
    a,
    s
  ]);
  return [
    o,
    l
  ];
}
function Yq({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: a, fadeFromIndex: i, onSnapPointChange: o, direction: s = "bottom", container: l, snapToSequentialPoint: c }) {
  const [u, d] = kI({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [f, g] = G.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  G.useEffect(() => {
    function T() {
      g({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", T), () => window.removeEventListener("resize", T);
  }, []);
  const h = G.useMemo(() => u === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    u
  ]), p = G.useMemo(() => {
    var T;
    return (T = n == null ? void 0 : n.findIndex((A) => A === u)) != null ? T : null;
  }, [
    n,
    u
  ]), m = n && n.length > 0 && (i || i === 0) && !Number.isNaN(i) && n[i] === u || !n, v = G.useMemo(() => {
    const T = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var A;
    return (A = n == null ? void 0 : n.map((C) => {
      const N = typeof C == "string";
      let L = 0;
      if (N && (L = parseInt(C, 10)), Ve(s)) {
        const k = N ? L : f ? C * T.height : 0;
        return f ? s === "bottom" ? T.height - k : -T.height + k : k;
      }
      const I = N ? L : f ? C * T.width : 0;
      return f ? s === "right" ? T.width - I : -T.width + I : I;
    })) != null ? A : [];
  }, [
    n,
    f,
    l
  ]), y = G.useMemo(() => p !== null ? v == null ? void 0 : v[p] : null, [
    v,
    p
  ]), E = G.useCallback((T) => {
    var A;
    const C = (A = v == null ? void 0 : v.findIndex((N) => N === T)) != null ? A : null;
    o(C), qe(r.current, {
      transition: `transform ${Me.DURATION}s cubic-bezier(${Me.EASE.join(",")})`,
      transform: Ve(s) ? `translate3d(0, ${T}px, 0)` : `translate3d(${T}px, 0, 0)`
    }), v && C !== v.length - 1 && i !== void 0 && C !== i && C < i ? qe(a.current, {
      transition: `opacity ${Me.DURATION}s cubic-bezier(${Me.EASE.join(",")})`,
      opacity: "0"
    }) : qe(a.current, {
      transition: `opacity ${Me.DURATION}s cubic-bezier(${Me.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(C, 0)]);
  }, [
    r.current,
    n,
    v,
    i,
    a,
    d
  ]);
  G.useEffect(() => {
    if (u || e) {
      var T;
      const A = (T = n == null ? void 0 : n.findIndex((C) => C === e || C === u)) != null ? T : -1;
      v && A !== -1 && typeof v[A] == "number" && E(v[A]);
    }
  }, [
    u,
    e,
    n,
    v,
    E
  ]);
  function S({ draggedDistance: T, closeDrawer: A, velocity: C, dismissible: N }) {
    if (i === void 0) return;
    const L = s === "bottom" || s === "right" ? (y ?? 0) - T : (y ?? 0) + T, I = p === i - 1, k = p === 0, B = T > 0;
    if (I && qe(a.current, {
      transition: `opacity ${Me.DURATION}s cubic-bezier(${Me.EASE.join(",")})`
    }), !c && C > 2 && !B) {
      N ? A() : E(v[0]);
      return;
    }
    if (!c && C > 2 && B && v && n) {
      E(v[n.length - 1]);
      return;
    }
    const F = v == null ? void 0 : v.reduce((D, O) => typeof D != "number" || typeof O != "number" ? D : Math.abs(O - L) < Math.abs(D - L) ? O : D), P = Ve(s) ? window.innerHeight : window.innerWidth;
    if (C > CI && Math.abs(T) < P * 0.4) {
      const D = B ? 1 : -1;
      if (D > 0 && h && n) {
        E(v[n.length - 1]);
        return;
      }
      if (k && D < 0 && N && A(), p === null) return;
      E(v[p + D]);
      return;
    }
    E(F);
  }
  function w({ draggedDistance: T }) {
    if (y === null) return;
    const A = s === "bottom" || s === "right" ? y - T : y + T;
    (s === "bottom" || s === "right") && A < v[v.length - 1] || (s === "top" || s === "left") && A > v[v.length - 1] || qe(r.current, {
      transform: Ve(s) ? `translate3d(0, ${A}px, 0)` : `translate3d(${A}px, 0, 0)`
    });
  }
  function R(T, A) {
    if (!n || typeof p != "number" || !v || i === void 0) return null;
    const C = p === i - 1;
    if (p >= i && A)
      return 0;
    if (C && !A) return 1;
    if (!m && !C) return null;
    const L = C ? p + 1 : p - 1, I = C ? v[L] - v[L - 1] : v[L + 1] - v[L], k = T / Math.abs(I);
    return C ? 1 - k : k;
  }
  return {
    isLastSnapPoint: h,
    activeSnapPoint: u,
    shouldFade: m,
    getPercentageDragged: R,
    setActiveSnapPoint: d,
    activeSnapPointIndex: p,
    onRelease: S,
    onDrag: w,
    snapPointsOffset: v
  };
}
const Kq = () => () => {
};
function Xq() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: a } = ya(), i = G.useRef(null), o = yn(() => document.body.style.backgroundColor, []);
  function s() {
    return (window.innerWidth - Mg) / window.innerWidth;
  }
  G.useEffect(() => {
    if (t && n) {
      i.current && clearTimeout(i.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      Wq(r && !a ? Ol(document.body, {
        background: "black"
      }) : Kq, Ol(l, {
        transformOrigin: Ve(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Me.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Me.EASE.join(",")})`
      }));
      const c = Ol(l, {
        borderRadius: `${NI}px`,
        overflow: "hidden",
        ...Ve(e) ? {
          transform: `scale(${s()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${s()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), i.current = window.setTimeout(() => {
          o ? document.body.style.background = o : document.body.style.removeProperty("background");
        }, Me.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    o
  ]);
}
let Da = null;
function Zq({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: a, noBodyStyles: i }) {
  const [o, s] = G.useState(() => typeof window < "u" ? window.location.href : ""), l = G.useRef(0), c = G.useCallback(() => {
    if (Ey() && Da === null && e && !i) {
      Da = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: f } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const g = f - window.innerHeight;
        g && l.current >= f && (document.body.style.top = `${-(l.current + g)}px`);
      }), 300);
    }
  }, [
    e
  ]), u = G.useCallback(() => {
    if (Ey() && Da !== null && !i) {
      const d = -parseInt(document.body.style.top, 10), f = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Da), window.requestAnimationFrame(() => {
        if (a && o !== window.location.href) {
          s(window.location.href);
          return;
        }
        window.scrollTo(f, d);
      }), Da = null;
    }
  }, [
    o
  ]);
  return G.useEffect(() => {
    function d() {
      l.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), G.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    t,
    u
  ]), G.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && c(), t || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    r,
    o,
    t,
    n,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function OI({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: a, snapPoints: i, shouldScaleBackground: o = !1, setBackgroundColorOnScale: s = !0, closeThreshold: l = qq, scrollLockTimeout: c = Vq, dismissible: u = !0, handleOnly: d = !1, fadeFromIndex: f = i && i.length - 1, activeSnapPoint: g, setActiveSnapPoint: h, fixed: p, modal: m = !0, onClose: v, nested: y, noBodyStyles: E = !1, direction: S = "bottom", defaultOpen: w = !1, disablePreventScroll: R = !0, snapToSequentialPoint: T = !1, preventScrollRestoration: A = !1, repositionInputs: C = !0, onAnimationEnd: N, container: L, autoFocus: I = !1 }) {
  var k, B;
  const [F = !1, P] = kI({
    defaultProp: w,
    prop: e,
    onChange: (te) => {
      t == null || t(te), !te && !y && an(), setTimeout(() => {
        N == null || N(te);
      }, Me.DURATION * 1e3), te && !m && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), te || (document.body.style.pointerEvents = "auto");
    }
  }), [D, O] = G.useState(!1), [M, W] = G.useState(!1), [U, q] = G.useState(!1), re = G.useRef(null), j = G.useRef(null), ie = G.useRef(null), Q = G.useRef(null), H = G.useRef(null), K = G.useRef(!1), J = G.useRef(null), ne = G.useRef(0), ee = G.useRef(!1), ae = G.useRef(!w), he = G.useRef(0), $ = G.useRef(null), Y = G.useRef(((k = $.current) == null ? void 0 : k.getBoundingClientRect().height) || 0), Ee = G.useRef(((B = $.current) == null ? void 0 : B.getBoundingClientRect().width) || 0), Te = G.useRef(0), Ue = G.useCallback((te) => {
    i && te === ot.length - 1 && (j.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: oe, activeSnapPointIndex: Re, setActiveSnapPoint: zt, onRelease: Ge, snapPointsOffset: ot, onDrag: Et, shouldFade: Dt, getPercentageDragged: Wt } = Yq({
    snapPoints: i,
    activeSnapPointProp: g,
    setActiveSnapPointProp: h,
    drawerRef: $,
    fadeFromIndex: f,
    overlayRef: re,
    onSnapPointChange: Ue,
    direction: S,
    container: L,
    snapToSequentialPoint: T
  });
  Fq({
    isDisabled: !F || M || !m || U || !D || !C || !R
  });
  const { restorePositionSetting: an } = Zq({
    isOpen: F,
    modal: m,
    nested: y ?? !1,
    hasBeenOpened: D,
    preventScrollRestoration: A,
    noBodyStyles: E
  });
  function Zn() {
    return (window.innerWidth - Mg) / window.innerWidth;
  }
  function Fi(te) {
    var Se, Ce;
    !u && !i || $.current && !$.current.contains(te.target) || (Y.current = ((Se = $.current) == null ? void 0 : Se.getBoundingClientRect().height) || 0, Ee.current = ((Ce = $.current) == null ? void 0 : Ce.getBoundingClientRect().width) || 0, W(!0), ie.current = /* @__PURE__ */ new Date(), TI() && window.addEventListener("touchend", () => K.current = !1, {
      once: !0
    }), te.target.setPointerCapture(te.pointerId), ne.current = Ve(S) ? te.pageY : te.pageX);
  }
  function $i(te, Se) {
    var Ce;
    let pe = te;
    const $e = (Ce = window.getSelection()) == null ? void 0 : Ce.toString(), dt = $.current ? vo($.current, S) : null, st = /* @__PURE__ */ new Date();
    if (pe.tagName === "SELECT" || pe.hasAttribute("data-vaul-no-drag") || pe.closest("[data-vaul-no-drag]"))
      return !1;
    if (S === "right" || S === "left")
      return !0;
    if (j.current && st.getTime() - j.current.getTime() < 500)
      return !1;
    if (dt !== null && (S === "bottom" ? dt > 0 : dt < 0))
      return !0;
    if ($e && $e.length > 0)
      return !1;
    if (H.current && st.getTime() - H.current.getTime() < c && dt === 0 || Se)
      return H.current = st, !1;
    for (; pe; ) {
      if (pe.scrollHeight > pe.clientHeight) {
        if (pe.scrollTop !== 0)
          return H.current = /* @__PURE__ */ new Date(), !1;
        if (pe.getAttribute("role") === "dialog")
          return !0;
      }
      pe = pe.parentNode;
    }
    return !0;
  }
  function Gs(te) {
    if ($.current && M) {
      const Se = S === "bottom" || S === "right" ? 1 : -1, Ce = (ne.current - (Ve(S) ? te.pageY : te.pageX)) * Se, pe = Ce > 0, $e = i && !u && !pe;
      if ($e && Re === 0) return;
      const dt = Math.abs(Ce), st = document.querySelector("[data-vaul-drawer-wrapper]"), Rn = S === "bottom" || S === "top" ? Y.current : Ee.current;
      let Lt = dt / Rn;
      const Jn = Wt(dt, pe);
      if (Jn !== null && (Lt = Jn), $e && Lt >= 1 || !K.current && !$i(te.target, pe)) return;
      if ($.current.classList.add(Dl), K.current = !0, qe($.current, {
        transition: "none"
      }), qe(re.current, {
        transition: "none"
      }), i && Et({
        draggedDistance: Ce
      }), pe && !i) {
        const Vt = zq(Ce), Bi = Math.min(Vt * -1, 0) * Se;
        qe($.current, {
          transform: Ve(S) ? `translate3d(0, ${Bi}px, 0)` : `translate3d(${Bi}px, 0, 0)`
        });
        return;
      }
      const An = 1 - Lt;
      if ((Dt || f && Re === f - 1) && (r == null || r(te, Lt), qe(re.current, {
        opacity: `${An}`,
        transition: "none"
      }, !0)), st && re.current && o) {
        const Vt = Math.min(Zn() + Lt * (1 - Zn()), 1), Bi = 8 - Lt * 8, Im = Math.max(0, 14 - Lt * 14);
        qe(st, {
          borderRadius: `${Bi}px`,
          transform: Ve(S) ? `scale(${Vt}) translate3d(0, ${Im}px, 0)` : `scale(${Vt}) translate3d(${Im}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const Vt = dt * Se;
        qe($.current, {
          transform: Ve(S) ? `translate3d(0, ${Vt}px, 0)` : `translate3d(${Vt}px, 0, 0)`
        });
      }
    }
  }
  G.useEffect(() => {
    window.requestAnimationFrame(() => {
      ae.current = !0;
    });
  }, []), G.useEffect(() => {
    var te;
    function Se() {
      if (!$.current || !C) return;
      const Ce = document.activeElement;
      if (Lg(Ce) || ee.current) {
        var pe;
        const $e = ((pe = window.visualViewport) == null ? void 0 : pe.height) || 0, dt = window.innerHeight;
        let st = dt - $e;
        const Rn = $.current.getBoundingClientRect().height || 0, Lt = Rn > dt * 0.8;
        Te.current || (Te.current = Rn);
        const Jn = $.current.getBoundingClientRect().top;
        if (Math.abs(he.current - st) > 60 && (ee.current = !ee.current), i && i.length > 0 && ot && Re) {
          const An = ot[Re] || 0;
          st += An;
        }
        if (he.current = st, Rn > $e || ee.current) {
          const An = $.current.getBoundingClientRect().height;
          let Vt = An;
          An > $e && (Vt = $e - (Lt ? Jn : Mg)), p ? $.current.style.height = `${An - Math.max(st, 0)}px` : $.current.style.height = `${Math.max(Vt, $e - Jn)}px`;
        } else Iq() || ($.current.style.height = `${Te.current}px`);
        i && i.length > 0 && !ee.current ? $.current.style.bottom = "0px" : $.current.style.bottom = `${Math.max(st, 0)}px`;
      }
    }
    return (te = window.visualViewport) == null || te.addEventListener("resize", Se), () => {
      var Ce;
      return (Ce = window.visualViewport) == null ? void 0 : Ce.removeEventListener("resize", Se);
    };
  }, [
    Re,
    i,
    ot
  ]);
  function Qn(te) {
    wa(), v == null || v(), te || P(!1), setTimeout(() => {
      i && zt(i[0]);
    }, Me.DURATION * 1e3);
  }
  function qt() {
    if (!$.current) return;
    const te = document.querySelector("[data-vaul-drawer-wrapper]"), Se = vo($.current, S);
    qe($.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Me.DURATION}s cubic-bezier(${Me.EASE.join(",")})`
    }), qe(re.current, {
      transition: `opacity ${Me.DURATION}s cubic-bezier(${Me.EASE.join(",")})`,
      opacity: "1"
    }), o && Se && Se > 0 && F && qe(te, {
      borderRadius: `${NI}px`,
      overflow: "hidden",
      ...Ve(S) ? {
        transform: `scale(${Zn()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Zn()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Me.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Me.EASE.join(",")})`
    }, !0);
  }
  function wa() {
    !M || !$.current || ($.current.classList.remove(Dl), K.current = !1, W(!1), Q.current = /* @__PURE__ */ new Date());
  }
  function Hs(te) {
    if (!M || !$.current) return;
    $.current.classList.remove(Dl), K.current = !1, W(!1), Q.current = /* @__PURE__ */ new Date();
    const Se = vo($.current, S);
    if (!te || !$i(te.target, !1) || !Se || Number.isNaN(Se) || ie.current === null) return;
    const Ce = Q.current.getTime() - ie.current.getTime(), pe = ne.current - (Ve(S) ? te.pageY : te.pageX), $e = Math.abs(pe) / Ce;
    if ($e > 0.05 && (q(!0), setTimeout(() => {
      q(!1);
    }, 200)), i) {
      Ge({
        draggedDistance: pe * (S === "bottom" || S === "right" ? 1 : -1),
        closeDrawer: Qn,
        velocity: $e,
        dismissible: u
      }), a == null || a(te, !0);
      return;
    }
    if (S === "bottom" || S === "right" ? pe > 0 : pe < 0) {
      qt(), a == null || a(te, !0);
      return;
    }
    if ($e > CI) {
      Qn(), a == null || a(te, !1);
      return;
    }
    var dt;
    const st = Math.min((dt = $.current.getBoundingClientRect().height) != null ? dt : 0, window.innerHeight);
    var Rn;
    const Lt = Math.min((Rn = $.current.getBoundingClientRect().width) != null ? Rn : 0, window.innerWidth), Jn = S === "left" || S === "right";
    if (Math.abs(Se) >= (Jn ? Lt : st) * l) {
      Qn(), a == null || a(te, !1);
      return;
    }
    a == null || a(te, !0), qt();
  }
  G.useEffect(() => (F && (qe(document.documentElement, {
    scrollBehavior: "auto"
  }), j.current = /* @__PURE__ */ new Date()), () => {
    Hq(document.documentElement, "scrollBehavior");
  }), [
    F
  ]);
  function Vk(te) {
    const Se = te ? (window.innerWidth - ir) / window.innerWidth : 1, Ce = te ? -ir : 0;
    J.current && window.clearTimeout(J.current), qe($.current, {
      transition: `transform ${Me.DURATION}s cubic-bezier(${Me.EASE.join(",")})`,
      transform: `scale(${Se}) translate3d(0, ${Ce}px, 0)`
    }), !te && $.current && (J.current = setTimeout(() => {
      const pe = vo($.current, S);
      qe($.current, {
        transition: "none",
        transform: Ve(S) ? `translate3d(0, ${pe}px, 0)` : `translate3d(${pe}px, 0, 0)`
      });
    }, 500));
  }
  function jk(te, Se) {
    if (Se < 0) return;
    const Ce = (window.innerWidth - ir) / window.innerWidth, pe = Ce + Se * (1 - Ce), $e = -ir + Se * ir;
    qe($.current, {
      transform: Ve(S) ? `scale(${pe}) translate3d(0, ${$e}px, 0)` : `scale(${pe}) translate3d(${$e}px, 0, 0)`,
      transition: "none"
    });
  }
  function Yk(te, Se) {
    const Ce = Ve(S) ? window.innerHeight : window.innerWidth, pe = Se ? (Ce - ir) / Ce : 1, $e = Se ? -ir : 0;
    Se && qe($.current, {
      transition: `transform ${Me.DURATION}s cubic-bezier(${Me.EASE.join(",")})`,
      transform: Ve(S) ? `scale(${pe}) translate3d(0, ${$e}px, 0)` : `scale(${pe}) translate3d(${$e}px, 0, 0)`
    });
  }
  return G.useEffect(() => {
    m || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    m
  ]), /* @__PURE__ */ G.createElement(Sq, {
    defaultOpen: w,
    onOpenChange: (te) => {
      !u && !te || (te ? O(!0) : Qn(!0), P(te));
    },
    open: F
  }, /* @__PURE__ */ G.createElement(_I.Provider, {
    value: {
      activeSnapPoint: oe,
      snapPoints: i,
      setActiveSnapPoint: zt,
      drawerRef: $,
      overlayRef: re,
      onOpenChange: t,
      onPress: Fi,
      onRelease: Hs,
      onDrag: Gs,
      dismissible: u,
      shouldAnimate: ae,
      handleOnly: d,
      isOpen: F,
      isDragging: M,
      shouldFade: Dt,
      closeDrawer: Qn,
      onNestedDrag: jk,
      onNestedOpenChange: Vk,
      onNestedRelease: Yk,
      keyboardIsOpen: ee,
      modal: m,
      snapPointsOffset: ot,
      activeSnapPointIndex: Re,
      direction: S,
      shouldScaleBackground: o,
      setBackgroundColorOnScale: s,
      noBodyStyles: E,
      container: L,
      autoFocus: I
    }
  }, n));
}
const DI = /* @__PURE__ */ G.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: a, shouldFade: i, isOpen: o, modal: s, shouldAnimate: l } = ya(), c = AI(t, n), u = r && r.length > 0;
  if (!s)
    return null;
  const d = G.useCallback((f) => a(f), [
    a
  ]);
  return /* @__PURE__ */ G.createElement(Tq, {
    onMouseUp: d,
    ref: c,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": o && u ? "true" : "false",
    "data-vaul-snap-points-overlay": o && i ? "true" : "false",
    "data-vaul-animate": l != null && l.current ? "true" : "false",
    ...e
  });
});
DI.displayName = "Drawer.Overlay";
const LI = /* @__PURE__ */ G.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, a) {
  const { drawerRef: i, onPress: o, onRelease: s, onDrag: l, keyboardIsOpen: c, snapPointsOffset: u, activeSnapPointIndex: d, modal: f, isOpen: g, direction: h, snapPoints: p, container: m, handleOnly: v, shouldAnimate: y, autoFocus: E } = ya(), [S, w] = G.useState(!1), R = AI(a, i), T = G.useRef(null), A = G.useRef(null), C = G.useRef(!1), N = p && p.length > 0;
  Xq();
  const L = (k, B, F = 0) => {
    if (C.current) return !0;
    const P = Math.abs(k.y), D = Math.abs(k.x), O = D > P, M = [
      "bottom",
      "right"
    ].includes(B) ? 1 : -1;
    if (B === "left" || B === "right") {
      if (!(k.x * M < 0) && D >= 0 && D <= F)
        return O;
    } else if (!(k.y * M < 0) && P >= 0 && P <= F)
      return !O;
    return C.current = !0, !0;
  };
  G.useEffect(() => {
    N && window.requestAnimationFrame(() => {
      w(!0);
    });
  }, []);
  function I(k) {
    T.current = null, C.current = !1, s(k);
  }
  return /* @__PURE__ */ G.createElement(Rq, {
    "data-vaul-drawer-direction": h,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": S ? "true" : "false",
    "data-vaul-snap-points": g && N ? "true" : "false",
    "data-vaul-custom-container": m ? "true" : "false",
    "data-vaul-animate": y != null && y.current ? "true" : "false",
    ...r,
    ref: R,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[d ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (k) => {
      v || (r.onPointerDown == null || r.onPointerDown.call(r, k), T.current = {
        x: k.pageX,
        y: k.pageY
      }, o(k));
    },
    onOpenAutoFocus: (k) => {
      n == null || n(k), E || k.preventDefault();
    },
    onPointerDownOutside: (k) => {
      if (e == null || e(k), !f || k.defaultPrevented) {
        k.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (k) => {
      if (!f) {
        k.preventDefault();
        return;
      }
    },
    onPointerMove: (k) => {
      if (A.current = k, v || (r.onPointerMove == null || r.onPointerMove.call(r, k), !T.current)) return;
      const B = k.pageY - T.current.y, F = k.pageX - T.current.x, P = k.pointerType === "touch" ? 10 : 2;
      L({
        x: F,
        y: B
      }, h, P) ? l(k) : (Math.abs(F) > P || Math.abs(B) > P) && (T.current = null);
    },
    onPointerUp: (k) => {
      r.onPointerUp == null || r.onPointerUp.call(r, k), T.current = null, C.current = !1, s(k);
    },
    onPointerOut: (k) => {
      r.onPointerOut == null || r.onPointerOut.call(r, k), I(A.current);
    },
    onContextMenu: (k) => {
      r.onContextMenu == null || r.onContextMenu.call(r, k), A.current && I(A.current);
    }
  });
});
LI.displayName = "Drawer.Content";
const Qq = 250, Jq = 120, MI = /* @__PURE__ */ G.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: a, isDragging: i, snapPoints: o, activeSnapPoint: s, setActiveSnapPoint: l, dismissible: c, handleOnly: u, isOpen: d, onPress: f, onDrag: g } = ya(), h = G.useRef(null), p = G.useRef(!1);
  function m() {
    if (p.current) {
      E();
      return;
    }
    window.setTimeout(() => {
      v();
    }, Jq);
  }
  function v() {
    if (i || e || p.current) {
      E();
      return;
    }
    if (E(), !o || o.length === 0) {
      c || a();
      return;
    }
    if (s === o[o.length - 1] && c) {
      a();
      return;
    }
    const w = o.findIndex((T) => T === s);
    if (w === -1) return;
    const R = o[w + 1];
    l(R);
  }
  function y() {
    h.current = window.setTimeout(() => {
      p.current = !0;
    }, Qq);
  }
  function E() {
    h.current && window.clearTimeout(h.current), p.current = !1;
  }
  return /* @__PURE__ */ G.createElement("div", {
    onClick: m,
    onPointerCancel: E,
    onPointerDown: (S) => {
      u && f(S), y();
    },
    onPointerMove: (S) => {
      u && g(S);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ G.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
MI.displayName = "Drawer.Handle";
function eV({ onDrag: e, onOpenChange: t, ...n }) {
  const { onNestedDrag: r, onNestedOpenChange: a, onNestedRelease: i } = ya();
  if (!r)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ G.createElement(OI, {
    nested: !0,
    onClose: () => {
      a(!1);
    },
    onDrag: (o, s) => {
      r(o, s), e == null || e(o, s);
    },
    onOpenChange: (o) => {
      o && a(o);
    },
    onRelease: i,
    ...n
  });
}
function tV(e) {
  const t = ya(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ G.createElement(_q, {
    container: n,
    ...r
  });
}
const or = {
  Root: OI,
  NestedRoot: eV,
  Content: LI,
  Overlay: DI,
  Trigger: wq,
  Portal: tV,
  Handle: MI,
  Close: Cq,
  Title: Aq,
  Description: xq
}, MX = (e) => /* @__PURE__ */ Z(or.Root, { direction: "right", children: [
  /* @__PURE__ */ _(or.Trigger, { children: typeof e.trigger == "string" ? /* @__PURE__ */ _(iP, { children: e.trigger }) : e.trigger }),
  /* @__PURE__ */ Z(or.Portal, { children: [
    /* @__PURE__ */ _(or.Overlay, { className: "fixed inset-0 bg-black/40" }),
    /* @__PURE__ */ _(
      or.Content,
      {
        className: "right-2 top-2 bottom-2 fixed z-10 outline-none w-[30%] flex",
        style: { "--initial-transform": "calc(100% + 8px)" },
        children: /* @__PURE__ */ Z("div", { className: "bg-zinc-50 h-full w-full grow p-5 flex flex-col rounded-[16px]", children: [
          /* @__PURE__ */ Z("div", { className: "max-w-md", children: [
            /* @__PURE__ */ _(or.Title, { className: "font-medium mb-2 text-primary flex justify-between", children: e.title }),
            e.description && /* @__PURE__ */ _(or.Description, { className: "text-zinc-600 mb-2", children: e.description })
          ] }),
          /* @__PURE__ */ _("div", { className: "h-[100%] w-[100%]", children: e.content })
        ] })
      }
    )
  ] })
] });
function vn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
var os = b.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = b.Children.toArray(n), i = a.find(rV);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? b.Children.count(o) > 1 ? b.Children.only(null) : b.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ _(Pg, { ...r, ref: t, children: b.isValidElement(o) ? b.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ _(Pg, { ...r, ref: t, children: n });
});
os.displayName = "Slot";
var Pg = b.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (b.isValidElement(n)) {
    const a = iV(n), i = aV(r, n.props);
    return n.type !== b.Fragment && (i.ref = t ? ba(t, a) : a), b.cloneElement(n, i);
  }
  return b.Children.count(n) > 1 ? b.Children.only(null) : null;
});
Pg.displayName = "SlotClone";
var nV = ({ children: e }) => /* @__PURE__ */ _(Ke, { children: e });
function rV(e) {
  return b.isValidElement(e) && e.type === nV;
}
function aV(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...s) => {
      i(...s), a(...s);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...i } : r === "className" && (n[r] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function iV(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function oV(e) {
  const t = e + "CollectionProvider", [n, r] = nn(t), [a, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (g) => {
    const { scope: h, children: p } = g, m = G.useRef(null), v = G.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ _(a, { scope: h, itemMap: v, collectionRef: m, children: p });
  };
  o.displayName = t;
  const s = e + "CollectionSlot", l = G.forwardRef(
    (g, h) => {
      const { scope: p, children: m } = g, v = i(s, p), y = tt(h, v.collectionRef);
      return /* @__PURE__ */ _(os, { ref: y, children: m });
    }
  );
  l.displayName = s;
  const c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = G.forwardRef(
    (g, h) => {
      const { scope: p, children: m, ...v } = g, y = G.useRef(null), E = tt(h, y), S = i(c, p);
      return G.useEffect(() => (S.itemMap.set(y, { ref: y, ...v }), () => void S.itemMap.delete(y))), /* @__PURE__ */ _(os, { [u]: "", ref: E, children: m });
    }
  );
  d.displayName = c;
  function f(g) {
    const h = i(e + "CollectionConsumer", g);
    return G.useCallback(() => {
      const m = h.collectionRef.current;
      if (!m) return [];
      const v = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(h.itemMap.values()).sort(
        (S, w) => v.indexOf(S.ref.current) - v.indexOf(w.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: o, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
var sV = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ea = sV.reduce((e, t) => {
  const n = b.forwardRef((r, a) => {
    const { asChild: i, ...o } = r, s = i ? os : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(s, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Ll = "rovingFocusGroup.onEntryFocus", lV = { bubbles: !1, cancelable: !0 }, Ms = "RovingFocusGroup", [Fg, PI, cV] = oV(Ms), [uV, FI] = nn(
  Ms,
  [cV]
), [dV, fV] = uV(Ms), $I = b.forwardRef(
  (e, t) => /* @__PURE__ */ _(Fg.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ _(Fg.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ _(pV, { ...e, ref: t }) }) })
);
$I.displayName = Ms;
var pV = b.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: a = !1,
    dir: i,
    currentTabStopId: o,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, f = b.useRef(null), g = tt(t, f), h = Ni(i), [p = null, m] = wr({
    prop: o,
    defaultProp: s,
    onChange: l
  }), [v, y] = b.useState(!1), E = Qe(c), S = PI(n), w = b.useRef(!1), [R, T] = b.useState(0);
  return b.useEffect(() => {
    const A = f.current;
    if (A)
      return A.addEventListener(Ll, E), () => A.removeEventListener(Ll, E);
  }, [E]), /* @__PURE__ */ _(
    dV,
    {
      scope: n,
      orientation: r,
      dir: h,
      loop: a,
      currentTabStopId: p,
      onItemFocus: b.useCallback(
        (A) => m(A),
        [m]
      ),
      onItemShiftTab: b.useCallback(() => y(!0), []),
      onFocusableItemAdd: b.useCallback(
        () => T((A) => A + 1),
        []
      ),
      onFocusableItemRemove: b.useCallback(
        () => T((A) => A - 1),
        []
      ),
      children: /* @__PURE__ */ _(
        Ea.div,
        {
          tabIndex: v || R === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: g,
          style: { outline: "none", ...e.style },
          onMouseDown: vn(e.onMouseDown, () => {
            w.current = !0;
          }),
          onFocus: vn(e.onFocus, (A) => {
            const C = !w.current;
            if (A.target === A.currentTarget && C && !v) {
              const N = new CustomEvent(Ll, lV);
              if (A.currentTarget.dispatchEvent(N), !N.defaultPrevented) {
                const L = S().filter((P) => P.focusable), I = L.find((P) => P.active), k = L.find((P) => P.id === p), F = [I, k, ...L].filter(
                  Boolean
                ).map((P) => P.ref.current);
                GI(F, u);
              }
            }
            w.current = !1;
          }),
          onBlur: vn(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), BI = "RovingFocusGroupItem", UI = b.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: a = !1,
      tabStopId: i,
      ...o
    } = e, s = Bt(), l = i || s, c = fV(BI, n), u = c.currentTabStopId === l, d = PI(n), { onFocusableItemAdd: f, onFocusableItemRemove: g } = c;
    return b.useEffect(() => {
      if (r)
        return f(), () => g();
    }, [r, f, g]), /* @__PURE__ */ _(
      Fg.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: a,
        children: /* @__PURE__ */ _(
          Ea.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...o,
            ref: t,
            onMouseDown: vn(e.onMouseDown, (h) => {
              r ? c.onItemFocus(l) : h.preventDefault();
            }),
            onFocus: vn(e.onFocus, () => c.onItemFocus(l)),
            onKeyDown: vn(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget) return;
              const p = mV(h, c.orientation, c.dir);
              if (p !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey) return;
                h.preventDefault();
                let v = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (p === "last") v.reverse();
                else if (p === "prev" || p === "next") {
                  p === "prev" && v.reverse();
                  const y = v.indexOf(h.currentTarget);
                  v = c.loop ? bV(v, y + 1) : v.slice(y + 1);
                }
                setTimeout(() => GI(v));
              }
            })
          }
        )
      }
    );
  }
);
UI.displayName = BI;
var gV = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function hV(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function mV(e, t, n) {
  const r = hV(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return gV[r];
}
function GI(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function bV(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var vV = $I, yV = UI, am = "Tabs", [EV, PX] = nn(am, [
  FI
]), HI = FI(), [SV, im] = EV(am), zI = b.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: a,
      defaultValue: i,
      orientation: o = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = Ni(s), [d, f] = wr({
      prop: r,
      onChange: a,
      defaultProp: i
    });
    return /* @__PURE__ */ _(
      SV,
      {
        scope: n,
        baseId: Bt(),
        value: d,
        onValueChange: f,
        orientation: o,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ _(
          Ea.div,
          {
            dir: u,
            "data-orientation": o,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
zI.displayName = am;
var WI = "TabsList", qI = b.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...a } = e, i = im(WI, n), o = HI(n);
    return /* @__PURE__ */ _(
      vV,
      {
        asChild: !0,
        ...o,
        orientation: i.orientation,
        dir: i.dir,
        loop: r,
        children: /* @__PURE__ */ _(
          Ea.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...a,
            ref: t
          }
        )
      }
    );
  }
);
qI.displayName = WI;
var VI = "TabsTrigger", om = b.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: a = !1, ...i } = e, o = im(VI, n), s = HI(n), l = KI(o.baseId, r), c = XI(o.baseId, r), u = r === o.value;
    return /* @__PURE__ */ _(
      yV,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ _(
          Ea.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": a ? "" : void 0,
            disabled: a,
            id: l,
            ...i,
            ref: t,
            onMouseDown: vn(e.onMouseDown, (d) => {
              !a && d.button === 0 && d.ctrlKey === !1 ? o.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: vn(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && o.onValueChange(r);
            }),
            onFocus: vn(e.onFocus, () => {
              const d = o.activationMode !== "manual";
              !u && !a && d && o.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
om.displayName = VI;
var jI = "TabsContent", YI = b.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: a, children: i, ...o } = e, s = im(jI, n), l = KI(s.baseId, r), c = XI(s.baseId, r), u = r === s.value, d = b.useRef(u);
    return b.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ _(va, { present: a || u, children: ({ present: f }) => /* @__PURE__ */ _(
      Ea.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !f,
        id: c,
        tabIndex: 0,
        ...o,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && i
      }
    ) });
  }
);
YI.displayName = jI;
function KI(e, t) {
  return `${e}-trigger-${t}`;
}
function XI(e, t) {
  return `${e}-content-${t}`;
}
var wV = zI, ZI = qI, QI = om, JI = YI;
const _V = wV, ek = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  ZI,
  {
    ref: n,
    className: de(
      "inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
      e
    ),
    ...t
  }
));
ek.displayName = ZI.displayName;
const TV = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  QI,
  {
    ref: n,
    className: de(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      e
    ),
    ...t
  }
));
TV.displayName = QI.displayName;
const tk = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  JI,
  {
    ref: n,
    className: de(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
tk.displayName = JI.displayName;
const FX = ({ tabs: e }) => /* @__PURE__ */ Z(_V, { defaultValue: e[0].id, className: "w-[400px]", children: [
  /* @__PURE__ */ _(ek, { className: "grid w-full grid-cols-2", children: e.map((t) => /* @__PURE__ */ _(om, { value: t.id, children: t.label })) }),
  e.map((t) => /* @__PURE__ */ _(tk, { value: t.id, children: t.component }))
] }), RV = sh(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground border-primary/90"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function $X({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ _("div", { className: de(RV({ variant: t }), e), ...n });
}
function AV(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function xV(e, t) {
  if (e == null) return {};
  var n = AV(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $g(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function CV(e) {
  if (Array.isArray(e)) return $g(e);
}
function NV(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function IV(e, t) {
  if (e) {
    if (typeof e == "string") return $g(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $g(e, t);
  }
}
function kV() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bg(e) {
  return CV(e) || NV(e) || IV(e) || kV();
}
function mi(e) {
  "@babel/helpers - typeof";
  return mi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mi(e);
}
function OV(e, t) {
  if (mi(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (mi(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function DV(e) {
  var t = OV(e, "string");
  return mi(t) == "symbol" ? t : t + "";
}
function nk(e, t, n) {
  return t = DV(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ty(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ty(Object(n), !0).forEach(function(r) {
      nk(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ty(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function LV(e) {
  var t = e.length;
  if (t === 0 || t === 1) return e;
  if (t === 2)
    return [e[0], e[1], "".concat(e[0], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0])];
  if (t === 3)
    return [e[0], e[1], e[2], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0])];
  if (t >= 4)
    return [e[0], e[1], e[2], e[3], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3]), "".concat(e[3], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1], ".").concat(e[0])];
}
var Ml = {};
function MV(e) {
  if (e.length === 0 || e.length === 1) return e;
  var t = e.join(".");
  return Ml[t] || (Ml[t] = LV(e)), Ml[t];
}
function PV(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0, r = e.filter(function(i) {
    return i !== "token";
  }), a = MV(r);
  return a.reduce(function(i, o) {
    return jr(jr({}, i), n[o]);
  }, t);
}
function Ry(e) {
  return e.join(" ");
}
function FV(e, t) {
  var n = 0;
  return function(r) {
    return n += 1, r.map(function(a, i) {
      return rk({
        node: a,
        stylesheet: e,
        useInlineStyles: t,
        key: "code-segment-".concat(n, "-").concat(i)
      });
    });
  };
}
function rk(e) {
  var t = e.node, n = e.stylesheet, r = e.style, a = r === void 0 ? {} : r, i = e.useInlineStyles, o = e.key, s = t.properties, l = t.type, c = t.tagName, u = t.value;
  if (l === "text")
    return u;
  if (c) {
    var d = FV(n, i), f;
    if (!i)
      f = jr(jr({}, s), {}, {
        className: Ry(s.className)
      });
    else {
      var g = Object.keys(n).reduce(function(v, y) {
        return y.split(".").forEach(function(E) {
          v.includes(E) || v.push(E);
        }), v;
      }, []), h = s.className && s.className.includes("token") ? ["token"] : [], p = s.className && h.concat(s.className.filter(function(v) {
        return !g.includes(v);
      }));
      f = jr(jr({}, s), {}, {
        className: Ry(p) || void 0,
        style: PV(s.className, Object.assign({}, s.style, a), n)
      });
    }
    var m = d(t.children);
    return /* @__PURE__ */ G.createElement(c, Pe({
      key: o
    }, f), m);
  }
}
const $V = function(e, t) {
  var n = e.listLanguages();
  return n.indexOf(t) !== -1;
};
var BV = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function Ay(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Pn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ay(Object(n), !0).forEach(function(r) {
      nk(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ay(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var UV = /\n/g;
function GV(e) {
  return e.match(UV);
}
function HV(e) {
  var t = e.lines, n = e.startingLineNumber, r = e.style;
  return t.map(function(a, i) {
    var o = i + n;
    return /* @__PURE__ */ G.createElement("span", {
      key: "line-".concat(i),
      className: "react-syntax-highlighter-line-number",
      style: typeof r == "function" ? r(o) : r
    }, "".concat(o, `
`));
  });
}
function zV(e) {
  var t = e.codeString, n = e.codeStyle, r = e.containerStyle, a = r === void 0 ? {
    float: "left",
    paddingRight: "10px"
  } : r, i = e.numberStyle, o = i === void 0 ? {} : i, s = e.startingLineNumber;
  return /* @__PURE__ */ G.createElement("code", {
    style: Object.assign({}, n, a)
  }, HV({
    lines: t.replace(/\n$/, "").split(`
`),
    style: o,
    startingLineNumber: s
  }));
}
function WV(e) {
  return "".concat(e.toString().length, ".25em");
}
function ak(e, t) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(e),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: t
    },
    children: [{
      type: "text",
      value: e
    }]
  };
}
function ik(e, t, n) {
  var r = {
    display: "inline-block",
    minWidth: WV(n),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, a = typeof e == "function" ? e(t) : e, i = Pn(Pn({}, r), a);
  return i;
}
function Mo(e) {
  var t = e.children, n = e.lineNumber, r = e.lineNumberStyle, a = e.largestLineNumber, i = e.showInlineLineNumbers, o = e.lineProps, s = o === void 0 ? {} : o, l = e.className, c = l === void 0 ? [] : l, u = e.showLineNumbers, d = e.wrapLongLines, f = e.wrapLines, g = f === void 0 ? !1 : f, h = g ? Pn({}, typeof s == "function" ? s(n) : s) : {};
  if (h.className = h.className ? [].concat(Bg(h.className.trim().split(/\s+/)), Bg(c)) : c, n && i) {
    var p = ik(r, n, a);
    t.unshift(ak(n, p));
  }
  return d & u && (h.style = Pn({
    display: "flex"
  }, h.style)), {
    type: "element",
    tagName: "span",
    properties: h,
    children: t
  };
}
function ok(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = 0; r < e.length; r++) {
    var a = e[r];
    if (a.type === "text")
      n.push(Mo({
        children: [a],
        className: Bg(new Set(t))
      }));
    else if (a.children) {
      var i = t.concat(a.properties.className);
      ok(a.children, i).forEach(function(o) {
        return n.push(o);
      });
    }
  }
  return n;
}
function qV(e, t, n, r, a, i, o, s, l) {
  var c, u = ok(e.value), d = [], f = -1, g = 0;
  function h(w, R) {
    var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return Mo({
      children: w,
      lineNumber: R,
      lineNumberStyle: s,
      largestLineNumber: o,
      showInlineLineNumbers: a,
      lineProps: n,
      className: T,
      showLineNumbers: r,
      wrapLongLines: l,
      wrapLines: t
    });
  }
  function p(w, R) {
    if (r && R && a) {
      var T = ik(s, R, o);
      w.unshift(ak(R, T));
    }
    return w;
  }
  function m(w, R) {
    var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return t || T.length > 0 ? h(w, R, T) : p(w, R);
  }
  for (var v = function() {
    var R = u[g], T = R.children[0].value, A = GV(T);
    if (A) {
      var C = T.split(`
`);
      C.forEach(function(N, L) {
        var I = r && d.length + i, k = {
          type: "text",
          value: "".concat(N, `
`)
        };
        if (L === 0) {
          var B = u.slice(f + 1, g).concat(Mo({
            children: [k],
            className: R.properties.className
          })), F = m(B, I);
          d.push(F);
        } else if (L === C.length - 1) {
          var P = u[g + 1] && u[g + 1].children && u[g + 1].children[0], D = {
            type: "text",
            value: "".concat(N)
          };
          if (P) {
            var O = Mo({
              children: [D],
              className: R.properties.className
            });
            u.splice(g + 1, 0, O);
          } else {
            var M = [D], W = m(M, I, R.properties.className);
            d.push(W);
          }
        } else {
          var U = [k], q = m(U, I, R.properties.className);
          d.push(q);
        }
      }), f = g;
    }
    g++;
  }; g < u.length; )
    v();
  if (f !== u.length - 1) {
    var y = u.slice(f + 1, u.length);
    if (y && y.length) {
      var E = r && d.length + i, S = m(y, E);
      d.push(S);
    }
  }
  return t ? d : (c = []).concat.apply(c, d);
}
function VV(e) {
  var t = e.rows, n = e.stylesheet, r = e.useInlineStyles;
  return t.map(function(a, i) {
    return rk({
      node: a,
      stylesheet: n,
      useInlineStyles: r,
      key: "code-segement".concat(i)
    });
  });
}
function sk(e) {
  return e && typeof e.highlightAuto < "u";
}
function jV(e) {
  var t = e.astGenerator, n = e.language, r = e.code, a = e.defaultCodeValue;
  if (sk(t)) {
    var i = $V(t, n);
    return n === "text" ? {
      value: a,
      language: "text"
    } : i ? t.highlight(n, r) : t.highlightAuto(r);
  }
  try {
    return n && n !== "text" ? {
      value: t.highlight(r, n)
    } : {
      value: a
    };
  } catch {
    return {
      value: a
    };
  }
}
function YV(e, t) {
  return function(r) {
    var a = r.language, i = r.children, o = r.style, s = o === void 0 ? t : o, l = r.customStyle, c = l === void 0 ? {} : l, u = r.codeTagProps, d = u === void 0 ? {
      className: a ? "language-".concat(a) : void 0,
      style: Pn(Pn({}, s['code[class*="language-"]']), s['code[class*="language-'.concat(a, '"]')])
    } : u, f = r.useInlineStyles, g = f === void 0 ? !0 : f, h = r.showLineNumbers, p = h === void 0 ? !1 : h, m = r.showInlineLineNumbers, v = m === void 0 ? !0 : m, y = r.startingLineNumber, E = y === void 0 ? 1 : y, S = r.lineNumberContainerStyle, w = r.lineNumberStyle, R = w === void 0 ? {} : w, T = r.wrapLines, A = r.wrapLongLines, C = A === void 0 ? !1 : A, N = r.lineProps, L = N === void 0 ? {} : N, I = r.renderer, k = r.PreTag, B = k === void 0 ? "pre" : k, F = r.CodeTag, P = F === void 0 ? "code" : F, D = r.code, O = D === void 0 ? (Array.isArray(i) ? i[0] : i) || "" : D, M = r.astGenerator, W = xV(r, BV);
    M = M || e;
    var U = p ? /* @__PURE__ */ G.createElement(zV, {
      containerStyle: S,
      codeStyle: d.style || {},
      numberStyle: R,
      startingLineNumber: E,
      codeString: O
    }) : null, q = s.hljs || s['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    }, re = sk(M) ? "hljs" : "prismjs", j = g ? Object.assign({}, W, {
      style: Object.assign({}, q, c)
    }) : Object.assign({}, W, {
      className: W.className ? "".concat(re, " ").concat(W.className) : re,
      style: Object.assign({}, c)
    });
    if (C ? d.style = Pn({
      whiteSpace: "pre-wrap"
    }, d.style) : d.style = Pn({
      whiteSpace: "pre"
    }, d.style), !M)
      return /* @__PURE__ */ G.createElement(B, j, U, /* @__PURE__ */ G.createElement(P, d, O));
    (T === void 0 && I || C) && (T = !0), I = I || VV;
    var ie = [{
      type: "text",
      value: O
    }], Q = jV({
      astGenerator: M,
      language: a,
      code: O,
      defaultCodeValue: ie
    });
    Q.language === null && (Q.value = ie);
    var H = Q.value.length;
    H === 1 && Q.value[0].type === "text" && (H = Q.value[0].value.split(`
`).length);
    var K = H + E, J = qV(Q, T, L, p, v, E, K, R, C);
    return /* @__PURE__ */ G.createElement(B, j, /* @__PURE__ */ G.createElement(P, d, !v && U, I({
      rows: J,
      stylesheet: s,
      useInlineStyles: g
    })));
  };
}
var ss = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function KV(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
const XV = ["abap", "abnf", "actionscript", "ada", "agda", "al", "antlr4", "apacheconf", "apex", "apl", "applescript", "aql", "arduino", "arff", "asciidoc", "asm6502", "asmatmel", "aspnet", "autohotkey", "autoit", "avisynth", "avro-idl", "bash", "basic", "batch", "bbcode", "bicep", "birb", "bison", "bnf", "brainfuck", "brightscript", "bro", "bsl", "c", "cfscript", "chaiscript", "cil", "clike", "clojure", "cmake", "cobol", "coffeescript", "concurnas", "coq", "cpp", "crystal", "csharp", "cshtml", "csp", "css-extras", "css", "csv", "cypher", "d", "dart", "dataweave", "dax", "dhall", "diff", "django", "dns-zone-file", "docker", "dot", "ebnf", "editorconfig", "eiffel", "ejs", "elixir", "elm", "erb", "erlang", "etlua", "excel-formula", "factor", "false", "firestore-security-rules", "flow", "fortran", "fsharp", "ftl", "gap", "gcode", "gdscript", "gedcom", "gherkin", "git", "glsl", "gml", "gn", "go-module", "go", "graphql", "groovy", "haml", "handlebars", "haskell", "haxe", "hcl", "hlsl", "hoon", "hpkp", "hsts", "http", "ichigojam", "icon", "icu-message-format", "idris", "iecst", "ignore", "inform7", "ini", "io", "j", "java", "javadoc", "javadoclike", "javascript", "javastacktrace", "jexl", "jolie", "jq", "js-extras", "js-templates", "jsdoc", "json", "json5", "jsonp", "jsstacktrace", "jsx", "julia", "keepalived", "keyman", "kotlin", "kumir", "kusto", "latex", "latte", "less", "lilypond", "liquid", "lisp", "livescript", "llvm", "log", "lolcode", "lua", "magma", "makefile", "markdown", "markup-templating", "markup", "matlab", "maxscript", "mel", "mermaid", "mizar", "mongodb", "monkey", "moonscript", "n1ql", "n4js", "nand2tetris-hdl", "naniscript", "nasm", "neon", "nevod", "nginx", "nim", "nix", "nsis", "objectivec", "ocaml", "opencl", "openqasm", "oz", "parigp", "parser", "pascal", "pascaligo", "pcaxis", "peoplecode", "perl", "php-extras", "php", "phpdoc", "plsql", "powerquery", "powershell", "processing", "prolog", "promql", "properties", "protobuf", "psl", "pug", "puppet", "pure", "purebasic", "purescript", "python", "q", "qml", "qore", "qsharp", "r", "racket", "reason", "regex", "rego", "renpy", "rest", "rip", "roboconf", "robotframework", "ruby", "rust", "sas", "sass", "scala", "scheme", "scss", "shell-session", "smali", "smalltalk", "smarty", "sml", "solidity", "solution-file", "soy", "sparql", "splunk-spl", "sqf", "sql", "squirrel", "stan", "stylus", "swift", "systemd", "t4-cs", "t4-templating", "t4-vb", "tap", "tcl", "textile", "toml", "tremor", "tsx", "tt2", "turtle", "twig", "typescript", "typoscript", "unrealscript", "uorazor", "uri", "v", "vala", "vbnet", "velocity", "verilog", "vhdl", "vim", "visual-basic", "warpscript", "wasm", "web-idl", "wiki", "wolfram", "wren", "xeora", "xml-doc", "xojo", "xquery", "yaml", "yang", "zig"];
var ZV = JV, QV = Object.prototype.hasOwnProperty;
function JV() {
  for (var e = {}, t = 0; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      QV.call(n, r) && (e[r] = n[r]);
  }
  return e;
}
var lk = ck, sm = ck.prototype;
sm.space = null;
sm.normal = {};
sm.property = {};
function ck(e, t, n) {
  this.property = e, this.normal = t, n && (this.space = n);
}
var xy = ZV, e4 = lk, t4 = n4;
function n4(e) {
  for (var t = e.length, n = [], r = [], a = -1, i, o; ++a < t; )
    i = e[a], n.push(i.property), r.push(i.normal), o = i.space;
  return new e4(
    xy.apply(null, n),
    xy.apply(null, r),
    o
  );
}
var lm = r4;
function r4(e) {
  return e.toLowerCase();
}
var uk = dk, Ot = dk.prototype;
Ot.space = null;
Ot.attribute = null;
Ot.property = null;
Ot.boolean = !1;
Ot.booleanish = !1;
Ot.overloadedBoolean = !1;
Ot.number = !1;
Ot.commaSeparated = !1;
Ot.spaceSeparated = !1;
Ot.commaOrSpaceSeparated = !1;
Ot.mustUseProperty = !1;
Ot.defined = !1;
function dk(e, t) {
  this.property = e, this.attribute = t;
}
var rn = {}, a4 = 0;
rn.boolean = kr();
rn.booleanish = kr();
rn.overloadedBoolean = kr();
rn.number = kr();
rn.spaceSeparated = kr();
rn.commaSeparated = kr();
rn.commaOrSpaceSeparated = kr();
function kr() {
  return Math.pow(2, ++a4);
}
var fk = uk, Cy = rn, pk = cm;
cm.prototype = new fk();
cm.prototype.defined = !0;
var gk = [
  "boolean",
  "booleanish",
  "overloadedBoolean",
  "number",
  "commaSeparated",
  "spaceSeparated",
  "commaOrSpaceSeparated"
], i4 = gk.length;
function cm(e, t, n, r) {
  var a = -1, i;
  for (Ny(this, "space", r), fk.call(this, e, t); ++a < i4; )
    i = gk[a], Ny(this, i, (n & Cy[i]) === Cy[i]);
}
function Ny(e, t, n) {
  n && (e[t] = n);
}
var Iy = lm, o4 = lk, s4 = pk, Mi = l4;
function l4(e) {
  var t = e.space, n = e.mustUseProperty || [], r = e.attributes || {}, a = e.properties, i = e.transform, o = {}, s = {}, l, c;
  for (l in a)
    c = new s4(
      l,
      i(r, l),
      a[l],
      t
    ), n.indexOf(l) !== -1 && (c.mustUseProperty = !0), o[l] = c, s[Iy(l)] = l, s[Iy(c.attribute)] = l;
  return new o4(o, s, t);
}
var c4 = Mi, u4 = c4({
  space: "xlink",
  transform: d4,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
function d4(e, t) {
  return "xlink:" + t.slice(5).toLowerCase();
}
var f4 = Mi, p4 = f4({
  space: "xml",
  transform: g4,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});
function g4(e, t) {
  return "xml:" + t.slice(3).toLowerCase();
}
var h4 = m4;
function m4(e, t) {
  return t in e ? e[t] : t;
}
var b4 = h4, hk = v4;
function v4(e, t) {
  return b4(e, t.toLowerCase());
}
var y4 = Mi, E4 = hk, S4 = y4({
  space: "xmlns",
  attributes: {
    xmlnsxlink: "xmlns:xlink"
  },
  transform: E4,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
}), um = rn, w4 = Mi, pt = um.booleanish, At = um.number, sr = um.spaceSeparated, _4 = w4({
  transform: T4,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: pt,
    ariaAutoComplete: null,
    ariaBusy: pt,
    ariaChecked: pt,
    ariaColCount: At,
    ariaColIndex: At,
    ariaColSpan: At,
    ariaControls: sr,
    ariaCurrent: null,
    ariaDescribedBy: sr,
    ariaDetails: null,
    ariaDisabled: pt,
    ariaDropEffect: sr,
    ariaErrorMessage: null,
    ariaExpanded: pt,
    ariaFlowTo: sr,
    ariaGrabbed: pt,
    ariaHasPopup: null,
    ariaHidden: pt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: sr,
    ariaLevel: At,
    ariaLive: null,
    ariaModal: pt,
    ariaMultiLine: pt,
    ariaMultiSelectable: pt,
    ariaOrientation: null,
    ariaOwns: sr,
    ariaPlaceholder: null,
    ariaPosInSet: At,
    ariaPressed: pt,
    ariaReadOnly: pt,
    ariaRelevant: null,
    ariaRequired: pt,
    ariaRoleDescription: sr,
    ariaRowCount: At,
    ariaRowIndex: At,
    ariaRowSpan: At,
    ariaSelected: pt,
    ariaSetSize: At,
    ariaSort: null,
    ariaValueMax: At,
    ariaValueMin: At,
    ariaValueNow: At,
    ariaValueText: null,
    role: null
  }
});
function T4(e, t) {
  return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
}
var Sa = rn, R4 = Mi, A4 = hk, ce = Sa.boolean, x4 = Sa.overloadedBoolean, La = Sa.booleanish, Ie = Sa.number, lt = Sa.spaceSeparated, yo = Sa.commaSeparated, C4 = R4({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: A4,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: yo,
    acceptCharset: lt,
    accessKey: lt,
    action: null,
    allow: null,
    allowFullScreen: ce,
    allowPaymentRequest: ce,
    allowUserMedia: ce,
    alt: null,
    as: null,
    async: ce,
    autoCapitalize: null,
    autoComplete: lt,
    autoFocus: ce,
    autoPlay: ce,
    capture: ce,
    charSet: null,
    checked: ce,
    cite: null,
    className: lt,
    cols: Ie,
    colSpan: null,
    content: null,
    contentEditable: La,
    controls: ce,
    controlsList: lt,
    coords: Ie | yo,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: ce,
    defer: ce,
    dir: null,
    dirName: null,
    disabled: ce,
    download: x4,
    draggable: La,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: ce,
    formTarget: null,
    headers: lt,
    height: Ie,
    hidden: ce,
    high: Ie,
    href: null,
    hrefLang: null,
    htmlFor: lt,
    httpEquiv: lt,
    id: null,
    imageSizes: null,
    imageSrcSet: yo,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: ce,
    itemId: null,
    itemProp: lt,
    itemRef: lt,
    itemScope: ce,
    itemType: lt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: ce,
    low: Ie,
    manifest: null,
    max: null,
    maxLength: Ie,
    media: null,
    method: null,
    min: null,
    minLength: Ie,
    multiple: ce,
    muted: ce,
    name: null,
    nonce: null,
    noModule: ce,
    noValidate: ce,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: ce,
    optimum: Ie,
    pattern: null,
    ping: lt,
    placeholder: null,
    playsInline: ce,
    poster: null,
    preload: null,
    readOnly: ce,
    referrerPolicy: null,
    rel: lt,
    required: ce,
    reversed: ce,
    rows: Ie,
    rowSpan: Ie,
    sandbox: lt,
    scope: null,
    scoped: ce,
    seamless: ce,
    selected: ce,
    shape: null,
    size: Ie,
    sizes: null,
    slot: null,
    span: Ie,
    spellCheck: La,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: yo,
    start: Ie,
    step: null,
    style: null,
    tabIndex: Ie,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: ce,
    useMap: null,
    value: La,
    width: Ie,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: lt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ie,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ie,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: ce,
    // Lists. Use CSS to reduce space between items instead
    declare: ce,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ie,
    // `<img>` and `<object>`
    leftMargin: Ie,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ie,
    // `<body>`
    marginWidth: Ie,
    // `<body>`
    noResize: ce,
    // `<frame>`
    noHref: ce,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: ce,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: ce,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ie,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: La,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ie,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ie,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: ce,
    disableRemotePlayback: ce,
    prefix: null,
    property: null,
    results: Ie,
    security: null,
    unselectable: null
  }
}), N4 = t4, I4 = u4, k4 = p4, O4 = S4, D4 = _4, L4 = C4, M4 = N4([k4, I4, O4, D4, L4]), P4 = lm, F4 = pk, $4 = uk, dm = "data", B4 = H4, U4 = /^data[-\w.:]+$/i, mk = /-[a-z]/g, G4 = /[A-Z]/g;
function H4(e, t) {
  var n = P4(t), r = t, a = $4;
  return n in e.normal ? e.property[e.normal[n]] : (n.length > 4 && n.slice(0, 4) === dm && U4.test(t) && (t.charAt(4) === "-" ? r = z4(t) : t = W4(t), a = F4), new a(r, t));
}
function z4(e) {
  var t = e.slice(5).replace(mk, V4);
  return dm + t.charAt(0).toUpperCase() + t.slice(1);
}
function W4(e) {
  var t = e.slice(4);
  return mk.test(t) ? e : (t = t.replace(G4, q4), t.charAt(0) !== "-" && (t = "-" + t), dm + t);
}
function q4(e) {
  return "-" + e.toLowerCase();
}
function V4(e) {
  return e.charAt(1).toUpperCase();
}
var j4 = Y4, ky = /[#.]/g;
function Y4(e, t) {
  for (var n = e || "", r = t || "div", a = {}, i = 0, o, s, l; i < n.length; )
    ky.lastIndex = i, l = ky.exec(n), o = n.slice(i, l ? l.index : n.length), o && (s ? s === "#" ? a.id = o : a.className ? a.className.push(o) : a.className = [o] : r = o, i += o.length), l && (s = l[0], i++);
  return { type: "element", tagName: r, properties: a, children: [] };
}
var fm = {};
fm.parse = Z4;
fm.stringify = Q4;
var Oy = "", K4 = " ", X4 = /[ \t\n\r\f]+/g;
function Z4(e) {
  var t = String(e || Oy).trim();
  return t === Oy ? [] : t.split(X4);
}
function Q4(e) {
  return e.join(K4).trim();
}
var pm = {};
pm.parse = J4;
pm.stringify = e5;
var Ug = ",", Dy = " ", qa = "";
function J4(e) {
  for (var t = [], n = String(e || qa), r = n.indexOf(Ug), a = 0, i = !1, o; !i; )
    r === -1 && (r = n.length, i = !0), o = n.slice(a, r).trim(), (o || !i) && t.push(o), a = r + 1, r = n.indexOf(Ug, a);
  return t;
}
function e5(e, t) {
  var n = t || {}, r = n.padLeft === !1 ? qa : Dy, a = n.padRight ? Dy : qa;
  return e[e.length - 1] === qa && (e = e.concat(qa)), e.join(a + Ug + r).trim();
}
var t5 = B4, Ly = lm, n5 = j4, My = fm.parse, Py = pm.parse, r5 = i5, a5 = {}.hasOwnProperty;
function i5(e, t, n) {
  var r = n ? u5(n) : null;
  return a;
  function a(o, s) {
    var l = n5(o, t), c = Array.prototype.slice.call(arguments, 2), u = l.tagName.toLowerCase(), d;
    if (l.tagName = r && a5.call(r, u) ? r[u] : u, s && o5(s, l) && (c.unshift(s), s = null), s)
      for (d in s)
        i(l.properties, d, s[d]);
    return bk(l.children, c), l.tagName === "template" && (l.content = { type: "root", children: l.children }, l.children = []), l;
  }
  function i(o, s, l) {
    var c, u, d;
    l == null || l !== l || (c = t5(e, s), u = c.property, d = l, typeof d == "string" && (c.spaceSeparated ? d = My(d) : c.commaSeparated ? d = Py(d) : c.commaOrSpaceSeparated && (d = My(Py(d).join(" ")))), u === "style" && typeof l != "string" && (d = c5(d)), u === "className" && o.className && (d = o.className.concat(d)), o[u] = l5(c, u, d));
  }
}
function o5(e, t) {
  return typeof e == "string" || "length" in e || s5(t.tagName, e);
}
function s5(e, t) {
  var n = t.type;
  return e === "input" || !n || typeof n != "string" ? !1 : typeof t.children == "object" && "length" in t.children ? !0 : (n = n.toLowerCase(), e === "button" ? n !== "menu" && n !== "submit" && n !== "reset" && n !== "button" : "value" in t);
}
function bk(e, t) {
  var n, r;
  if (typeof t == "string" || typeof t == "number") {
    e.push({ type: "text", value: String(t) });
    return;
  }
  if (typeof t == "object" && "length" in t) {
    for (n = -1, r = t.length; ++n < r; )
      bk(e, t[n]);
    return;
  }
  if (typeof t != "object" || !("type" in t))
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
  e.push(t);
}
function l5(e, t, n) {
  var r, a, i;
  if (typeof n != "object" || !("length" in n))
    return Fy(e, t, n);
  for (a = n.length, r = -1, i = []; ++r < a; )
    i[r] = Fy(e, t, n[r]);
  return i;
}
function Fy(e, t, n) {
  var r = n;
  return e.number || e.positiveNumber ? !isNaN(r) && r !== "" && (r = Number(r)) : (e.boolean || e.overloadedBoolean) && typeof r == "string" && (r === "" || Ly(n) === Ly(t)) && (r = !0), r;
}
function c5(e) {
  var t = [], n;
  for (n in e)
    t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function u5(e) {
  for (var t = e.length, n = -1, r = {}, a; ++n < t; )
    a = e[n], r[a.toLowerCase()] = a;
  return r;
}
var d5 = M4, f5 = r5, vk = f5(d5, "div");
vk.displayName = "html";
var p5 = vk, g5 = p5;
const h5 = "Æ", m5 = "&", b5 = "Á", v5 = "Â", y5 = "À", E5 = "Å", S5 = "Ã", w5 = "Ä", _5 = "©", T5 = "Ç", R5 = "Ð", A5 = "É", x5 = "Ê", C5 = "È", N5 = "Ë", I5 = ">", k5 = "Í", O5 = "Î", D5 = "Ì", L5 = "Ï", M5 = "<", P5 = "Ñ", F5 = "Ó", $5 = "Ô", B5 = "Ò", U5 = "Ø", G5 = "Õ", H5 = "Ö", z5 = '"', W5 = "®", q5 = "Þ", V5 = "Ú", j5 = "Û", Y5 = "Ù", K5 = "Ü", X5 = "Ý", Z5 = "á", Q5 = "â", J5 = "´", ej = "æ", tj = "à", nj = "&", rj = "å", aj = "ã", ij = "ä", oj = "¦", sj = "ç", lj = "¸", cj = "¢", uj = "©", dj = "¤", fj = "°", pj = "÷", gj = "é", hj = "ê", mj = "è", bj = "ð", vj = "ë", yj = "½", Ej = "¼", Sj = "¾", wj = ">", _j = "í", Tj = "î", Rj = "¡", Aj = "ì", xj = "¿", Cj = "ï", Nj = "«", Ij = "<", kj = "¯", Oj = "µ", Dj = "·", Lj = " ", Mj = "¬", Pj = "ñ", Fj = "ó", $j = "ô", Bj = "ò", Uj = "ª", Gj = "º", Hj = "ø", zj = "õ", Wj = "ö", qj = "¶", Vj = "±", jj = "£", Yj = '"', Kj = "»", Xj = "®", Zj = "§", Qj = "­", Jj = "¹", e6 = "²", t6 = "³", n6 = "ß", r6 = "þ", a6 = "×", i6 = "ú", o6 = "û", s6 = "ù", l6 = "¨", c6 = "ü", u6 = "ý", d6 = "¥", f6 = "ÿ", p6 = {
  AElig: h5,
  AMP: m5,
  Aacute: b5,
  Acirc: v5,
  Agrave: y5,
  Aring: E5,
  Atilde: S5,
  Auml: w5,
  COPY: _5,
  Ccedil: T5,
  ETH: R5,
  Eacute: A5,
  Ecirc: x5,
  Egrave: C5,
  Euml: N5,
  GT: I5,
  Iacute: k5,
  Icirc: O5,
  Igrave: D5,
  Iuml: L5,
  LT: M5,
  Ntilde: P5,
  Oacute: F5,
  Ocirc: $5,
  Ograve: B5,
  Oslash: U5,
  Otilde: G5,
  Ouml: H5,
  QUOT: z5,
  REG: W5,
  THORN: q5,
  Uacute: V5,
  Ucirc: j5,
  Ugrave: Y5,
  Uuml: K5,
  Yacute: X5,
  aacute: Z5,
  acirc: Q5,
  acute: J5,
  aelig: ej,
  agrave: tj,
  amp: nj,
  aring: rj,
  atilde: aj,
  auml: ij,
  brvbar: oj,
  ccedil: sj,
  cedil: lj,
  cent: cj,
  copy: uj,
  curren: dj,
  deg: fj,
  divide: pj,
  eacute: gj,
  ecirc: hj,
  egrave: mj,
  eth: bj,
  euml: vj,
  frac12: yj,
  frac14: Ej,
  frac34: Sj,
  gt: wj,
  iacute: _j,
  icirc: Tj,
  iexcl: Rj,
  igrave: Aj,
  iquest: xj,
  iuml: Cj,
  laquo: Nj,
  lt: Ij,
  macr: kj,
  micro: Oj,
  middot: Dj,
  nbsp: Lj,
  not: Mj,
  ntilde: Pj,
  oacute: Fj,
  ocirc: $j,
  ograve: Bj,
  ordf: Uj,
  ordm: Gj,
  oslash: Hj,
  otilde: zj,
  ouml: Wj,
  para: qj,
  plusmn: Vj,
  pound: jj,
  quot: Yj,
  raquo: Kj,
  reg: Xj,
  sect: Zj,
  shy: Qj,
  sup1: Jj,
  sup2: e6,
  sup3: t6,
  szlig: n6,
  thorn: r6,
  times: a6,
  uacute: i6,
  ucirc: o6,
  ugrave: s6,
  uml: l6,
  uuml: c6,
  yacute: u6,
  yen: d6,
  yuml: f6
}, g6 = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
var yk = h6;
function h6(e) {
  var t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 48 && t <= 57;
}
var m6 = b6;
function b6(e) {
  var t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
}
var v6 = y6;
function y6(e) {
  var t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
var E6 = v6, S6 = yk, w6 = _6;
function _6(e) {
  return E6(e) || S6(e);
}
var Eo, T6 = 59, R6 = A6;
function A6(e) {
  var t = "&" + e + ";", n;
  return Eo = Eo || document.createElement("i"), Eo.innerHTML = t, n = Eo.textContent, n.charCodeAt(n.length - 1) === T6 && e !== "semi" || n === t ? !1 : n;
}
var $y = p6, By = g6, x6 = yk, C6 = m6, Ek = w6, N6 = R6, I6 = z6, k6 = {}.hasOwnProperty, qr = String.fromCharCode, O6 = Function.prototype, Uy = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: !1,
  nonTerminated: !0
}, D6 = 9, Gy = 10, L6 = 12, M6 = 32, Hy = 38, P6 = 59, F6 = 60, $6 = 61, B6 = 35, U6 = 88, G6 = 120, H6 = 65533, Vr = "named", gm = "hexadecimal", hm = "decimal", mm = {};
mm[gm] = 16;
mm[hm] = 10;
var Ps = {};
Ps[Vr] = Ek;
Ps[hm] = x6;
Ps[gm] = C6;
var Sk = 1, wk = 2, _k = 3, Tk = 4, Rk = 5, Gg = 6, Ak = 7, Xn = {};
Xn[Sk] = "Named character references must be terminated by a semicolon";
Xn[wk] = "Numeric character references must be terminated by a semicolon";
Xn[_k] = "Named character references cannot be empty";
Xn[Tk] = "Numeric character references cannot be empty";
Xn[Rk] = "Named character references must be known";
Xn[Gg] = "Numeric character references cannot be disallowed";
Xn[Ak] = "Numeric character references cannot be outside the permissible Unicode range";
function z6(e, t) {
  var n = {}, r, a;
  t || (t = {});
  for (a in Uy)
    r = t[a], n[a] = r ?? Uy[a];
  return (n.position.indent || n.position.start) && (n.indent = n.position.indent || [], n.position = n.position.start), W6(e, n);
}
function W6(e, t) {
  var n = t.additional, r = t.nonTerminated, a = t.text, i = t.reference, o = t.warning, s = t.textContext, l = t.referenceContext, c = t.warningContext, u = t.position, d = t.indent || [], f = e.length, g = 0, h = -1, p = u.column || 1, m = u.line || 1, v = "", y = [], E, S, w, R, T, A, C, N, L, I, k, B, F, P, D, O, M, W, U;
  for (typeof n == "string" && (n = n.charCodeAt(0)), O = q(), N = o ? re : O6, g--, f++; ++g < f; )
    if (T === Gy && (p = d[h] || 1), T = e.charCodeAt(g), T === Hy) {
      if (C = e.charCodeAt(g + 1), C === D6 || C === Gy || C === L6 || C === M6 || C === Hy || C === F6 || C !== C || n && C === n) {
        v += qr(T), p++;
        continue;
      }
      for (F = g + 1, B = F, U = F, C === B6 ? (U = ++B, C = e.charCodeAt(U), C === U6 || C === G6 ? (P = gm, U = ++B) : P = hm) : P = Vr, E = "", k = "", R = "", D = Ps[P], U--; ++U < f && (C = e.charCodeAt(U), !!D(C)); )
        R += qr(C), P === Vr && k6.call($y, R) && (E = R, k = $y[R]);
      w = e.charCodeAt(U) === P6, w && (U++, S = P === Vr ? N6(R) : !1, S && (E = R, k = S)), W = 1 + U - F, !w && !r || (R ? P === Vr ? (w && !k ? N(Rk, 1) : (E !== R && (U = B + E.length, W = 1 + U - B, w = !1), w || (L = E ? Sk : _k, t.attribute ? (C = e.charCodeAt(U), C === $6 ? (N(L, W), k = null) : Ek(C) ? k = null : N(L, W)) : N(L, W))), A = k) : (w || N(wk, W), A = parseInt(R, mm[P]), q6(A) ? (N(Ak, W), A = qr(H6)) : A in By ? (N(Gg, W), A = By[A]) : (I = "", V6(A) && N(Gg, W), A > 65535 && (A -= 65536, I += qr(A >>> 10 | 55296), A = 56320 | A & 1023), A = I + qr(A))) : P !== Vr && N(Tk, W)), A ? (j(), O = q(), g = U - 1, p += U - F + 1, y.push(A), M = q(), M.offset++, i && i.call(
        l,
        A,
        { start: O, end: M },
        e.slice(F - 1, U)
      ), O = M) : (R = e.slice(F - 1, U), v += R, p += R.length, g = U - 1);
    } else
      T === 10 && (m++, h++, p = 0), T === T ? (v += qr(T), p++) : j();
  return y.join("");
  function q() {
    return {
      line: m,
      column: p,
      offset: g + (u.offset || 0)
    };
  }
  function re(ie, Q) {
    var H = q();
    H.column += Q, H.offset += Q, o.call(c, Xn[ie], H, ie);
  }
  function j() {
    v && (y.push(v), a && a.call(s, v, { start: O, end: q() }), v = "");
  }
}
function q6(e) {
  return e >= 55296 && e <= 57343 || e > 1114111;
}
function V6(e) {
  return e >= 1 && e <= 8 || e === 11 || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534;
}
var xk = { exports: {} };
(function(e) {
  var t = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  var n = function(r) {
    var a = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, i = 0, o = {}, s = {
      /**
       * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
       * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
       * additional languages or plugins yourself.
       *
       * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
       *
       * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.manual = true;
       * // add a new <script> to load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      manual: r.Prism && r.Prism.manual,
      /**
       * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
       * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
       * own worker, you don't want it to do this.
       *
       * By setting this value to `true`, Prism will not add its own listeners to the worker.
       *
       * You obviously have to change this value before Prism executes. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.disableWorkerMessageHandler = true;
       * // Load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      disableWorkerMessageHandler: r.Prism && r.Prism.disableWorkerMessageHandler,
      /**
       * A namespace for utility methods.
       *
       * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
       * change or disappear at any time.
       *
       * @namespace
       * @memberof Prism
       */
      util: {
        encode: function y(E) {
          return E instanceof l ? new l(E.type, y(E.content), E.alias) : Array.isArray(E) ? E.map(y) : E.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
        },
        /**
         * Returns the name of the type of the given value.
         *
         * @param {any} o
         * @returns {string}
         * @example
         * type(null)      === 'Null'
         * type(undefined) === 'Undefined'
         * type(123)       === 'Number'
         * type('foo')     === 'String'
         * type(true)      === 'Boolean'
         * type([1, 2])    === 'Array'
         * type({})        === 'Object'
         * type(String)    === 'Function'
         * type(/abc+/)    === 'RegExp'
         */
        type: function(y) {
          return Object.prototype.toString.call(y).slice(8, -1);
        },
        /**
         * Returns a unique number for the given object. Later calls will still return the same number.
         *
         * @param {Object} obj
         * @returns {number}
         */
        objId: function(y) {
          return y.__id || Object.defineProperty(y, "__id", { value: ++i }), y.__id;
        },
        /**
         * Creates a deep clone of the given object.
         *
         * The main intended use of this function is to clone language definitions.
         *
         * @param {T} o
         * @param {Record<number, any>} [visited]
         * @returns {T}
         * @template T
         */
        clone: function y(E, S) {
          S = S || {};
          var w, R;
          switch (s.util.type(E)) {
            case "Object":
              if (R = s.util.objId(E), S[R])
                return S[R];
              w = /** @type {Record<string, any>} */
              {}, S[R] = w;
              for (var T in E)
                E.hasOwnProperty(T) && (w[T] = y(E[T], S));
              return (
                /** @type {any} */
                w
              );
            case "Array":
              return R = s.util.objId(E), S[R] ? S[R] : (w = [], S[R] = w, /** @type {Array} */
              /** @type {any} */
              E.forEach(function(A, C) {
                w[C] = y(A, S);
              }), /** @type {any} */
              w);
            default:
              return E;
          }
        },
        /**
         * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
         *
         * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
         *
         * @param {Element} element
         * @returns {string}
         */
        getLanguage: function(y) {
          for (; y; ) {
            var E = a.exec(y.className);
            if (E)
              return E[1].toLowerCase();
            y = y.parentElement;
          }
          return "none";
        },
        /**
         * Sets the Prism `language-xxxx` class of the given element.
         *
         * @param {Element} element
         * @param {string} language
         * @returns {void}
         */
        setLanguage: function(y, E) {
          y.className = y.className.replace(RegExp(a, "gi"), ""), y.classList.add("language-" + E);
        },
        /**
         * Returns the script element that is currently executing.
         *
         * This does __not__ work for line script element.
         *
         * @returns {HTMLScriptElement | null}
         */
        currentScript: function() {
          if (typeof document > "u")
            return null;
          if ("currentScript" in document)
            return (
              /** @type {any} */
              document.currentScript
            );
          try {
            throw new Error();
          } catch (w) {
            var y = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(w.stack) || [])[1];
            if (y) {
              var E = document.getElementsByTagName("script");
              for (var S in E)
                if (E[S].src == y)
                  return E[S];
            }
            return null;
          }
        },
        /**
         * Returns whether a given class is active for `element`.
         *
         * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
         * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
         * given class is just the given class with a `no-` prefix.
         *
         * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
         * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
         * ancestors have the given class or the negated version of it, then the default activation will be returned.
         *
         * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
         * version of it, the class is considered active.
         *
         * @param {Element} element
         * @param {string} className
         * @param {boolean} [defaultActivation=false]
         * @returns {boolean}
         */
        isActive: function(y, E, S) {
          for (var w = "no-" + E; y; ) {
            var R = y.classList;
            if (R.contains(E))
              return !0;
            if (R.contains(w))
              return !1;
            y = y.parentElement;
          }
          return !!S;
        }
      },
      /**
       * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
       *
       * @namespace
       * @memberof Prism
       * @public
       */
      languages: {
        /**
         * The grammar for plain, unformatted text.
         */
        plain: o,
        plaintext: o,
        text: o,
        txt: o,
        /**
         * Creates a deep copy of the language with the given id and appends the given tokens.
         *
         * If a token in `redef` also appears in the copied language, then the existing token in the copied language
         * will be overwritten at its original position.
         *
         * ## Best practices
         *
         * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
         * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
         * understand the language definition because, normally, the order of tokens matters in Prism grammars.
         *
         * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
         * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
         *
         * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
         * @param {Grammar} redef The new tokens to append.
         * @returns {Grammar} The new language created.
         * @public
         * @example
         * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
         *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
         *     // at its original position
         *     'comment': { ... },
         *     // CSS doesn't have a 'color' token, so this token will be appended
         *     'color': /\b(?:red|green|blue)\b/
         * });
         */
        extend: function(y, E) {
          var S = s.util.clone(s.languages[y]);
          for (var w in E)
            S[w] = E[w];
          return S;
        },
        /**
         * Inserts tokens _before_ another token in a language definition or any other grammar.
         *
         * ## Usage
         *
         * This helper method makes it easy to modify existing languages. For example, the CSS language definition
         * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
         * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
         * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
         * this:
         *
         * ```js
         * Prism.languages.markup.style = {
         *     // token
         * };
         * ```
         *
         * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
         * before existing tokens. For the CSS example above, you would use it like this:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'cdata', {
         *     'style': {
         *         // token
         *     }
         * });
         * ```
         *
         * ## Special cases
         *
         * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
         * will be ignored.
         *
         * This behavior can be used to insert tokens after `before`:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'comment', {
         *     'comment': Prism.languages.markup.comment,
         *     // tokens after 'comment'
         * });
         * ```
         *
         * ## Limitations
         *
         * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
         * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
         * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
         * deleting properties which is necessary to insert at arbitrary positions.
         *
         * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
         * Instead, it will create a new object and replace all references to the target object with the new one. This
         * can be done without temporarily deleting properties, so the iteration order is well-defined.
         *
         * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
         * you hold the target object in a variable, then the value of the variable will not change.
         *
         * ```js
         * var oldMarkup = Prism.languages.markup;
         * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
         *
         * assert(oldMarkup !== Prism.languages.markup);
         * assert(newMarkup === Prism.languages.markup);
         * ```
         *
         * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
         * object to be modified.
         * @param {string} before The key to insert before.
         * @param {Grammar} insert An object containing the key-value pairs to be inserted.
         * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
         * object to be modified.
         *
         * Defaults to `Prism.languages`.
         * @returns {Grammar} The new grammar object.
         * @public
         */
        insertBefore: function(y, E, S, w) {
          w = w || /** @type {any} */
          s.languages;
          var R = w[y], T = {};
          for (var A in R)
            if (R.hasOwnProperty(A)) {
              if (A == E)
                for (var C in S)
                  S.hasOwnProperty(C) && (T[C] = S[C]);
              S.hasOwnProperty(A) || (T[A] = R[A]);
            }
          var N = w[y];
          return w[y] = T, s.languages.DFS(s.languages, function(L, I) {
            I === N && L != y && (this[L] = T);
          }), T;
        },
        // Traverse a language definition with Depth First Search
        DFS: function y(E, S, w, R) {
          R = R || {};
          var T = s.util.objId;
          for (var A in E)
            if (E.hasOwnProperty(A)) {
              S.call(E, A, E[A], w || A);
              var C = E[A], N = s.util.type(C);
              N === "Object" && !R[T(C)] ? (R[T(C)] = !0, y(C, S, null, R)) : N === "Array" && !R[T(C)] && (R[T(C)] = !0, y(C, S, A, R));
            }
        }
      },
      plugins: {},
      /**
       * This is the most high-level function in Prism’s API.
       * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
       * each one of them.
       *
       * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
       *
       * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
       * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
       * @memberof Prism
       * @public
       */
      highlightAll: function(y, E) {
        s.highlightAllUnder(document, y, E);
      },
      /**
       * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
       * {@link Prism.highlightElement} on each one of them.
       *
       * The following hooks will be run:
       * 1. `before-highlightall`
       * 2. `before-all-elements-highlight`
       * 3. All hooks of {@link Prism.highlightElement} for each element.
       *
       * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
       * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
       * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
       * @memberof Prism
       * @public
       */
      highlightAllUnder: function(y, E, S) {
        var w = {
          callback: S,
          container: y,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        s.hooks.run("before-highlightall", w), w.elements = Array.prototype.slice.apply(w.container.querySelectorAll(w.selector)), s.hooks.run("before-all-elements-highlight", w);
        for (var R = 0, T; T = w.elements[R++]; )
          s.highlightElement(T, E === !0, w.callback);
      },
      /**
       * Highlights the code inside a single element.
       *
       * The following hooks will be run:
       * 1. `before-sanity-check`
       * 2. `before-highlight`
       * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
       * 4. `before-insert`
       * 5. `after-highlight`
       * 6. `complete`
       *
       * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
       * the element's language.
       *
       * @param {Element} element The element containing the code.
       * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
       * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
       * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
       * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
       *
       * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
       * asynchronous highlighting to work. You can build your own bundle on the
       * [Download page](https://prismjs.com/download.html).
       * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
       * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
       * @memberof Prism
       * @public
       */
      highlightElement: function(y, E, S) {
        var w = s.util.getLanguage(y), R = s.languages[w];
        s.util.setLanguage(y, w);
        var T = y.parentElement;
        T && T.nodeName.toLowerCase() === "pre" && s.util.setLanguage(T, w);
        var A = y.textContent, C = {
          element: y,
          language: w,
          grammar: R,
          code: A
        };
        function N(I) {
          C.highlightedCode = I, s.hooks.run("before-insert", C), C.element.innerHTML = C.highlightedCode, s.hooks.run("after-highlight", C), s.hooks.run("complete", C), S && S.call(C.element);
        }
        if (s.hooks.run("before-sanity-check", C), T = C.element.parentElement, T && T.nodeName.toLowerCase() === "pre" && !T.hasAttribute("tabindex") && T.setAttribute("tabindex", "0"), !C.code) {
          s.hooks.run("complete", C), S && S.call(C.element);
          return;
        }
        if (s.hooks.run("before-highlight", C), !C.grammar) {
          N(s.util.encode(C.code));
          return;
        }
        if (E && r.Worker) {
          var L = new Worker(s.filename);
          L.onmessage = function(I) {
            N(I.data);
          }, L.postMessage(JSON.stringify({
            language: C.language,
            code: C.code,
            immediateClose: !0
          }));
        } else
          N(s.highlight(C.code, C.grammar, C.language));
      },
      /**
       * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
       * and the language definitions to use, and returns a string with the HTML produced.
       *
       * The following hooks will be run:
       * 1. `before-tokenize`
       * 2. `after-tokenize`
       * 3. `wrap`: On each {@link Token}.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @param {string} language The name of the language definition passed to `grammar`.
       * @returns {string} The highlighted HTML.
       * @memberof Prism
       * @public
       * @example
       * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
       */
      highlight: function(y, E, S) {
        var w = {
          code: y,
          grammar: E,
          language: S
        };
        if (s.hooks.run("before-tokenize", w), !w.grammar)
          throw new Error('The language "' + w.language + '" has no grammar.');
        return w.tokens = s.tokenize(w.code, w.grammar), s.hooks.run("after-tokenize", w), l.stringify(s.util.encode(w.tokens), w.language);
      },
      /**
       * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
       * and the language definitions to use, and returns an array with the tokenized code.
       *
       * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
       *
       * This method could be useful in other contexts as well, as a very crude parser.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @returns {TokenStream} An array of strings and tokens, a token stream.
       * @memberof Prism
       * @public
       * @example
       * let code = `var foo = 0;`;
       * let tokens = Prism.tokenize(code, Prism.languages.javascript);
       * tokens.forEach(token => {
       *     if (token instanceof Prism.Token && token.type === 'number') {
       *         console.log(`Found numeric literal: ${token.content}`);
       *     }
       * });
       */
      tokenize: function(y, E) {
        var S = E.rest;
        if (S) {
          for (var w in S)
            E[w] = S[w];
          delete E.rest;
        }
        var R = new d();
        return f(R, R.head, y), u(y, R, E, R.head, 0), h(R);
      },
      /**
       * @namespace
       * @memberof Prism
       * @public
       */
      hooks: {
        all: {},
        /**
         * Adds the given callback to the list of callbacks for the given hook.
         *
         * The callback will be invoked when the hook it is registered for is run.
         * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
         *
         * One callback function can be registered to multiple hooks and the same hook multiple times.
         *
         * @param {string} name The name of the hook.
         * @param {HookCallback} callback The callback function which is given environment variables.
         * @public
         */
        add: function(y, E) {
          var S = s.hooks.all;
          S[y] = S[y] || [], S[y].push(E);
        },
        /**
         * Runs a hook invoking all registered callbacks with the given environment variables.
         *
         * Callbacks will be invoked synchronously and in the order in which they were registered.
         *
         * @param {string} name The name of the hook.
         * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
         * @public
         */
        run: function(y, E) {
          var S = s.hooks.all[y];
          if (!(!S || !S.length))
            for (var w = 0, R; R = S[w++]; )
              R(E);
        }
      },
      Token: l
    };
    r.Prism = s;
    function l(y, E, S, w) {
      this.type = y, this.content = E, this.alias = S, this.length = (w || "").length | 0;
    }
    l.stringify = function y(E, S) {
      if (typeof E == "string")
        return E;
      if (Array.isArray(E)) {
        var w = "";
        return E.forEach(function(N) {
          w += y(N, S);
        }), w;
      }
      var R = {
        type: E.type,
        content: y(E.content, S),
        tag: "span",
        classes: ["token", E.type],
        attributes: {},
        language: S
      }, T = E.alias;
      T && (Array.isArray(T) ? Array.prototype.push.apply(R.classes, T) : R.classes.push(T)), s.hooks.run("wrap", R);
      var A = "";
      for (var C in R.attributes)
        A += " " + C + '="' + (R.attributes[C] || "").replace(/"/g, "&quot;") + '"';
      return "<" + R.tag + ' class="' + R.classes.join(" ") + '"' + A + ">" + R.content + "</" + R.tag + ">";
    };
    function c(y, E, S, w) {
      y.lastIndex = E;
      var R = y.exec(S);
      if (R && w && R[1]) {
        var T = R[1].length;
        R.index += T, R[0] = R[0].slice(T);
      }
      return R;
    }
    function u(y, E, S, w, R, T) {
      for (var A in S)
        if (!(!S.hasOwnProperty(A) || !S[A])) {
          var C = S[A];
          C = Array.isArray(C) ? C : [C];
          for (var N = 0; N < C.length; ++N) {
            if (T && T.cause == A + "," + N)
              return;
            var L = C[N], I = L.inside, k = !!L.lookbehind, B = !!L.greedy, F = L.alias;
            if (B && !L.pattern.global) {
              var P = L.pattern.toString().match(/[imsuy]*$/)[0];
              L.pattern = RegExp(L.pattern.source, P + "g");
            }
            for (var D = L.pattern || L, O = w.next, M = R; O !== E.tail && !(T && M >= T.reach); M += O.value.length, O = O.next) {
              var W = O.value;
              if (E.length > y.length)
                return;
              if (!(W instanceof l)) {
                var U = 1, q;
                if (B) {
                  if (q = c(D, M, y, k), !q || q.index >= y.length)
                    break;
                  var Q = q.index, re = q.index + q[0].length, j = M;
                  for (j += O.value.length; Q >= j; )
                    O = O.next, j += O.value.length;
                  if (j -= O.value.length, M = j, O.value instanceof l)
                    continue;
                  for (var ie = O; ie !== E.tail && (j < re || typeof ie.value == "string"); ie = ie.next)
                    U++, j += ie.value.length;
                  U--, W = y.slice(M, j), q.index -= M;
                } else if (q = c(D, 0, W, k), !q)
                  continue;
                var Q = q.index, H = q[0], K = W.slice(0, Q), J = W.slice(Q + H.length), ne = M + W.length;
                T && ne > T.reach && (T.reach = ne);
                var ee = O.prev;
                K && (ee = f(E, ee, K), M += K.length), g(E, ee, U);
                var ae = new l(A, I ? s.tokenize(H, I) : H, F, H);
                if (O = f(E, ee, ae), J && f(E, O, J), U > 1) {
                  var he = {
                    cause: A + "," + N,
                    reach: ne
                  };
                  u(y, E, S, O.prev, M, he), T && he.reach > T.reach && (T.reach = he.reach);
                }
              }
            }
          }
        }
    }
    function d() {
      var y = { value: null, prev: null, next: null }, E = { value: null, prev: y, next: null };
      y.next = E, this.head = y, this.tail = E, this.length = 0;
    }
    function f(y, E, S) {
      var w = E.next, R = { value: S, prev: E, next: w };
      return E.next = R, w.prev = R, y.length++, R;
    }
    function g(y, E, S) {
      for (var w = E.next, R = 0; R < S && w !== y.tail; R++)
        w = w.next;
      E.next = w, w.prev = E, y.length -= R;
    }
    function h(y) {
      for (var E = [], S = y.head.next; S !== y.tail; )
        E.push(S.value), S = S.next;
      return E;
    }
    if (!r.document)
      return r.addEventListener && (s.disableWorkerMessageHandler || r.addEventListener("message", function(y) {
        var E = JSON.parse(y.data), S = E.language, w = E.code, R = E.immediateClose;
        r.postMessage(s.highlight(w, s.languages[S], S)), R && r.close();
      }, !1)), s;
    var p = s.util.currentScript();
    p && (s.filename = p.src, p.hasAttribute("data-manual") && (s.manual = !0));
    function m() {
      s.manual || s.highlightAll();
    }
    if (!s.manual) {
      var v = document.readyState;
      v === "loading" || v === "interactive" && p && p.defer ? document.addEventListener("DOMContentLoaded", m) : window.requestAnimationFrame ? window.requestAnimationFrame(m) : window.setTimeout(m, 16);
    }
    return s;
  }(t);
  e.exports && (e.exports = n), typeof ss < "u" && (ss.Prism = n);
})(xk);
var j6 = xk.exports, Y6 = bm;
bm.displayName = "markup";
bm.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
function bm(e) {
  e.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              /"|'/
            ]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  }, e.languages.markup.tag.inside["attr-value"].inside.entity = e.languages.markup.entity, e.languages.markup.doctype.inside["internal-subset"].inside = e.languages.markup, e.hooks.add("wrap", function(t) {
    t.type === "entity" && (t.attributes.title = t.content.value.replace(/&amp;/, "&"));
  }), Object.defineProperty(e.languages.markup.tag, "addInlined", {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function(n, r) {
      var a = {};
      a["language-" + r] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: e.languages[r]
      }, a.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var i = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: a
        }
      };
      i["language-" + r] = {
        pattern: /[\s\S]+/,
        inside: e.languages[r]
      };
      var o = {};
      o[n] = {
        pattern: RegExp(
          /(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(
            /__/g,
            function() {
              return n;
            }
          ),
          "i"
        ),
        lookbehind: !0,
        greedy: !0,
        inside: i
      }, e.languages.insertBefore("markup", "cdata", o);
    }
  }), Object.defineProperty(e.languages.markup.tag, "addAttribute", {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function(t, n) {
      e.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + t + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [n, "language-" + n],
                inside: e.languages[n]
              },
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  }), e.languages.html = e.languages.markup, e.languages.mathml = e.languages.markup, e.languages.svg = e.languages.markup, e.languages.xml = e.languages.extend("markup", {}), e.languages.ssml = e.languages.xml, e.languages.atom = e.languages.xml, e.languages.rss = e.languages.xml;
}
var K6 = vm;
vm.displayName = "css";
vm.aliases = [];
function vm(e) {
  (function(t) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    t.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
          // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp(
          "\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)",
          "i"
        ),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + n.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp(
          `(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"
        ),
        lookbehind: !0
      },
      string: {
        pattern: n,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, t.languages.css.atrule.inside.rest = t.languages.css;
    var r = t.languages.markup;
    r && (r.tag.addInlined("style", "css"), r.tag.addAttribute("style", "css"));
  })(e);
}
var X6 = ym;
ym.displayName = "clike";
ym.aliases = [];
function ym(e) {
  e.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  };
}
var Z6 = Em;
Em.displayName = "javascript";
Em.aliases = ["js"];
function Em(e) {
  e.languages.javascript = e.languages.extend("clike", {
    "class-name": [
      e.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: !0
      }
    ],
    keyword: [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: !0
      }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), e.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, e.languages.insertBefore("javascript", "keyword", {
    regex: {
      // eslint-disable-next-line regexp/no-dupe-characters-character-class
      pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: e.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: !0,
        inside: e.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: !0,
        inside: e.languages.javascript
      }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), e.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: e.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), e.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), e.languages.markup && (e.languages.markup.tag.addInlined("script", "javascript"), e.languages.markup.tag.addAttribute(
    /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
    "javascript"
  )), e.languages.js = e.languages.javascript;
}
var Va = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof ss == "object" ? ss : {}, Q6 = g8();
Va.Prism = { manual: !0, disableWorkerMessageHandler: !0 };
var J6 = g5, e8 = I6, Ck = j6, t8 = Y6, n8 = K6, r8 = X6, a8 = Z6;
Q6();
var Sm = {}.hasOwnProperty;
function Nk() {
}
Nk.prototype = Ck;
var ze = new Nk(), i8 = ze;
ze.highlight = s8;
ze.register = Pi;
ze.alias = o8;
ze.registered = l8;
ze.listLanguages = c8;
Pi(t8);
Pi(n8);
Pi(r8);
Pi(a8);
ze.util.encode = f8;
ze.Token.stringify = u8;
function Pi(e) {
  if (typeof e != "function" || !e.displayName)
    throw new Error("Expected `function` for `grammar`, got `" + e + "`");
  ze.languages[e.displayName] === void 0 && e(ze);
}
function o8(e, t) {
  var n = ze.languages, r = e, a, i, o, s;
  t && (r = {}, r[e] = t);
  for (a in r)
    for (i = r[a], i = typeof i == "string" ? [i] : i, o = i.length, s = -1; ++s < o; )
      n[i[s]] = n[a];
}
function s8(e, t) {
  var n = Ck.highlight, r;
  if (typeof e != "string")
    throw new Error("Expected `string` for `value`, got `" + e + "`");
  if (ze.util.type(t) === "Object")
    r = t, t = null;
  else {
    if (typeof t != "string")
      throw new Error("Expected `string` for `name`, got `" + t + "`");
    if (Sm.call(ze.languages, t))
      r = ze.languages[t];
    else
      throw new Error("Unknown language: `" + t + "` is not registered");
  }
  return n.call(this, e, r, t);
}
function l8(e) {
  if (typeof e != "string")
    throw new Error("Expected `string` for `language`, got `" + e + "`");
  return Sm.call(ze.languages, e);
}
function c8() {
  var e = ze.languages, t = [], n;
  for (n in e)
    Sm.call(e, n) && typeof e[n] == "object" && t.push(n);
  return t;
}
function u8(e, t, n) {
  var r;
  return typeof e == "string" ? { type: "text", value: e } : ze.util.type(e) === "Array" ? d8(e, t) : (r = {
    type: e.type,
    content: ze.Token.stringify(e.content, t, n),
    tag: "span",
    classes: ["token", e.type],
    attributes: {},
    language: t,
    parent: n
  }, e.alias && (r.classes = r.classes.concat(e.alias)), ze.hooks.run("wrap", r), J6(
    r.tag + "." + r.classes.join("."),
    p8(r.attributes),
    r.content
  ));
}
function d8(e, t) {
  for (var n = [], r = e.length, a = -1, i; ++a < r; )
    i = e[a], i !== "" && i !== null && i !== void 0 && n.push(i);
  for (a = -1, r = n.length; ++a < r; )
    i = n[a], n[a] = ze.Token.stringify(i, t, n);
  return n;
}
function f8(e) {
  return e;
}
function p8(e) {
  var t;
  for (t in e)
    e[t] = e8(e[t]);
  return e;
}
function g8() {
  var e = "Prism" in Va, t = e ? Va.Prism : void 0;
  return n;
  function n() {
    e ? Va.Prism = t : delete Va.Prism, e = void 0, t = void 0;
  }
}
const h8 = {
  'code[class*="language-"]': {
    color: "black",
    background: "none",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    color: "black",
    background: "#f5f2f0",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    padding: "1em",
    margin: ".5em 0",
    overflow: "auto"
  },
  'pre[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  ':not(pre) > code[class*="language-"]': {
    background: "#f5f2f0",
    padding: ".1em",
    borderRadius: ".3em",
    whiteSpace: "normal"
  },
  comment: {
    color: "slategray"
  },
  prolog: {
    color: "slategray"
  },
  doctype: {
    color: "slategray"
  },
  cdata: {
    color: "slategray"
  },
  punctuation: {
    color: "#999"
  },
  namespace: {
    Opacity: ".7"
  },
  property: {
    color: "#905"
  },
  tag: {
    color: "#905"
  },
  boolean: {
    color: "#905"
  },
  number: {
    color: "#905"
  },
  constant: {
    color: "#905"
  },
  symbol: {
    color: "#905"
  },
  deleted: {
    color: "#905"
  },
  selector: {
    color: "#690"
  },
  "attr-name": {
    color: "#690"
  },
  string: {
    color: "#690"
  },
  char: {
    color: "#690"
  },
  builtin: {
    color: "#690"
  },
  inserted: {
    color: "#690"
  },
  operator: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  entity: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)",
    cursor: "help"
  },
  url: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".language-css .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".style .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  atrule: {
    color: "#07a"
  },
  "attr-value": {
    color: "#07a"
  },
  keyword: {
    color: "#07a"
  },
  function: {
    color: "#DD4A68"
  },
  "class-name": {
    color: "#DD4A68"
  },
  regex: {
    color: "#e90"
  },
  important: {
    color: "#e90",
    fontWeight: "bold"
  },
  variable: {
    color: "#e90"
  },
  bold: {
    fontWeight: "bold"
  },
  italic: {
    fontStyle: "italic"
  }
};
var Pl, zy;
function m8() {
  if (zy) return Pl;
  zy = 1, Pl = e, e.displayName = "abap", e.aliases = [];
  function e(t) {
    t.languages.abap = {
      comment: /^\*.*/m,
      string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      "string-template": {
        pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
        lookbehind: !0,
        alias: "string"
      },
      /* End Of Line comments should not interfere with strings when the
      quote character occurs within them. We assume a string being highlighted
      inside an EOL comment is more acceptable than the opposite.
      */
      "eol-comment": {
        pattern: /(^|\s)".*/m,
        lookbehind: !0,
        alias: "comment"
      },
      keyword: {
        pattern: /(\s|\.|^)(?:SCIENTIFIC_WITH_LEADING_ZERO|SCALE_PRESERVING_SCIENTIFIC|RMC_COMMUNICATION_FAILURE|END-ENHANCEMENT-SECTION|MULTIPLY-CORRESPONDING|SUBTRACT-CORRESPONDING|VERIFICATION-MESSAGE|DIVIDE-CORRESPONDING|ENHANCEMENT-SECTION|CURRENCY_CONVERSION|RMC_SYSTEM_FAILURE|START-OF-SELECTION|MOVE-CORRESPONDING|RMC_INVALID_STATUS|CUSTOMER-FUNCTION|END-OF-DEFINITION|ENHANCEMENT-POINT|SYSTEM-EXCEPTIONS|ADD-CORRESPONDING|SCALE_PRESERVING|SELECTION-SCREEN|CURSOR-SELECTION|END-OF-SELECTION|LOAD-OF-PROGRAM|SCROLL-BOUNDARY|SELECTION-TABLE|EXCEPTION-TABLE|IMPLEMENTATIONS|PARAMETER-TABLE|RIGHT-JUSTIFIED|UNIT_CONVERSION|AUTHORITY-CHECK|LIST-PROCESSING|SIGN_AS_POSTFIX|COL_BACKGROUND|IMPLEMENTATION|INTERFACE-POOL|TRANSFORMATION|IDENTIFICATION|ENDENHANCEMENT|LINE-SELECTION|INITIALIZATION|LEFT-JUSTIFIED|SELECT-OPTIONS|SELECTION-SETS|COMMUNICATION|CORRESPONDING|DECIMAL_SHIFT|PRINT-CONTROL|VALUE-REQUEST|CHAIN-REQUEST|FUNCTION-POOL|FIELD-SYMBOLS|FUNCTIONALITY|INVERTED-DATE|SELECTION-SET|CLASS-METHODS|OUTPUT-LENGTH|CLASS-CODING|COL_NEGATIVE|ERRORMESSAGE|FIELD-GROUPS|HELP-REQUEST|NO-EXTENSION|NO-TOPOFPAGE|REDEFINITION|DISPLAY-MODE|ENDINTERFACE|EXIT-COMMAND|FIELD-SYMBOL|NO-SCROLLING|SHORTDUMP-ID|ACCESSPOLICY|CLASS-EVENTS|COL_POSITIVE|DECLARATIONS|ENHANCEMENTS|FILTER-TABLE|SWITCHSTATES|SYNTAX-CHECK|TRANSPORTING|ASYNCHRONOUS|SYNTAX-TRACE|TOKENIZATION|USER-COMMAND|WITH-HEADING|ABAP-SOURCE|BREAK-POINT|CHAIN-INPUT|COMPRESSION|FIXED-POINT|NEW-SECTION|NON-UNICODE|OCCURRENCES|RESPONSIBLE|SYSTEM-CALL|TRACE-TABLE|ABBREVIATED|CHAR-TO-HEX|END-OF-FILE|ENDFUNCTION|ENVIRONMENT|ASSOCIATION|COL_HEADING|EDITOR-CALL|END-OF-PAGE|ENGINEERING|IMPLEMENTED|INTENSIFIED|RADIOBUTTON|SYSTEM-EXIT|TOP-OF-PAGE|TRANSACTION|APPLICATION|CONCATENATE|DESTINATION|ENHANCEMENT|IMMEDIATELY|NO-GROUPING|PRECOMPILED|REPLACEMENT|TITLE-LINES|ACTIVATION|BYTE-ORDER|CLASS-POOL|CONNECTION|CONVERSION|DEFINITION|DEPARTMENT|EXPIRATION|INHERITING|MESSAGE-ID|NO-HEADING|PERFORMING|QUEUE-ONLY|RIGHTSPACE|SCIENTIFIC|STATUSINFO|STRUCTURES|SYNCPOINTS|WITH-TITLE|ATTRIBUTES|BOUNDARIES|CLASS-DATA|COL_NORMAL|DD\/MM\/YYYY|DESCENDING|INTERFACES|LINE-COUNT|MM\/DD\/YYYY|NON-UNIQUE|PRESERVING|SELECTIONS|STATEMENTS|SUBROUTINE|TRUNCATION|TYPE-POOLS|ARITHMETIC|BACKGROUND|ENDPROVIDE|EXCEPTIONS|IDENTIFIER|INDEX-LINE|OBLIGATORY|PARAMETERS|PERCENTAGE|PUSHBUTTON|RESOLUTION|COMPONENTS|DEALLOCATE|DISCONNECT|DUPLICATES|FIRST-LINE|HEAD-LINES|NO-DISPLAY|OCCURRENCE|RESPECTING|RETURNCODE|SUBMATCHES|TRACE-FILE|ASCENDING|BYPASSING|ENDMODULE|EXCEPTION|EXCLUDING|EXPORTING|INCREMENT|MATCHCODE|PARAMETER|PARTIALLY|PREFERRED|REFERENCE|REPLACING|RETURNING|SELECTION|SEPARATED|SPECIFIED|STATEMENT|TIMESTAMP|TYPE-POOL|ACCEPTING|APPENDAGE|ASSIGNING|COL_GROUP|COMPARING|CONSTANTS|DANGEROUS|IMPORTING|INSTANCES|LEFTSPACE|LOG-POINT|QUICKINFO|READ-ONLY|SCROLLING|SQLSCRIPT|STEP-LOOP|TOP-LINES|TRANSLATE|APPENDING|AUTHORITY|CHARACTER|COMPONENT|CONDITION|DIRECTORY|DUPLICATE|MESSAGING|RECEIVING|SUBSCREEN|ACCORDING|COL_TOTAL|END-LINES|ENDMETHOD|ENDSELECT|EXPANDING|EXTENSION|INCLUDING|INFOTYPES|INTERFACE|INTERVALS|LINE-SIZE|PF-STATUS|PROCEDURE|PROTECTED|REQUESTED|RESUMABLE|RIGHTPLUS|SAP-SPOOL|SECONDARY|STRUCTURE|SUBSTRING|TABLEVIEW|NUMOFCHAR|ADJACENT|ANALYSIS|ASSIGNED|BACKWARD|CHANNELS|CHECKBOX|CONTINUE|CRITICAL|DATAINFO|DD\/MM\/YY|DURATION|ENCODING|ENDCLASS|FUNCTION|LEFTPLUS|LINEFEED|MM\/DD\/YY|OVERFLOW|RECEIVED|SKIPPING|SORTABLE|STANDARD|SUBTRACT|SUPPRESS|TABSTRIP|TITLEBAR|TRUNCATE|UNASSIGN|WHENEVER|ANALYZER|COALESCE|COMMENTS|CONDENSE|DECIMALS|DEFERRED|ENDWHILE|EXPLICIT|KEYWORDS|MESSAGES|POSITION|PRIORITY|RECEIVER|RENAMING|TIMEZONE|TRAILING|ALLOCATE|CENTERED|CIRCULAR|CONTROLS|CURRENCY|DELETING|DESCRIBE|DISTANCE|ENDCATCH|EXPONENT|EXTENDED|GENERATE|IGNORING|INCLUDES|INTERNAL|MAJOR-ID|MODIFIER|NEW-LINE|OPTIONAL|PROPERTY|ROLLBACK|STARTING|SUPPLIED|ABSTRACT|CHANGING|CONTEXTS|CREATING|CUSTOMER|DATABASE|DAYLIGHT|DEFINING|DISTINCT|DIVISION|ENABLING|ENDCHAIN|ESCAPING|HARMLESS|IMPLICIT|INACTIVE|LANGUAGE|MINOR-ID|MULTIPLY|NEW-PAGE|NO-TITLE|POS_HIGH|SEPARATE|TEXTPOOL|TRANSFER|SELECTOR|DBMAXLEN|ITERATOR|ARCHIVE|BIT-XOR|BYTE-CO|COLLECT|COMMENT|CURRENT|DEFAULT|DISPLAY|ENDFORM|EXTRACT|LEADING|LISTBOX|LOCATOR|MEMBERS|METHODS|NESTING|POS_LOW|PROCESS|PROVIDE|RAISING|RESERVE|SECONDS|SUMMARY|VISIBLE|BETWEEN|BIT-AND|BYTE-CS|CLEANUP|COMPUTE|CONTROL|CONVERT|DATASET|ENDCASE|FORWARD|HEADERS|HOTSPOT|INCLUDE|INVERSE|KEEPING|NO-ZERO|OBJECTS|OVERLAY|PADDING|PATTERN|PROGRAM|REFRESH|SECTION|SUMMING|TESTING|VERSION|WINDOWS|WITHOUT|BIT-NOT|BYTE-CA|BYTE-NA|CASTING|CONTEXT|COUNTRY|DYNAMIC|ENABLED|ENDLOOP|EXECUTE|FRIENDS|HANDLER|HEADING|INITIAL|\*-INPUT|LOGFILE|MAXIMUM|MINIMUM|NO-GAPS|NO-SIGN|PRAGMAS|PRIMARY|PRIVATE|REDUCED|REPLACE|REQUEST|RESULTS|UNICODE|WARNING|ALIASES|BYTE-CN|BYTE-NS|CALLING|COL_KEY|COLUMNS|CONNECT|ENDEXEC|ENTRIES|EXCLUDE|FILTERS|FURTHER|HELP-ID|LOGICAL|MAPPING|MESSAGE|NAMETAB|OPTIONS|PACKAGE|PERFORM|RECEIVE|STATICS|VARYING|BINDING|CHARLEN|GREATER|XSTRLEN|ACCEPT|APPEND|DETAIL|ELSEIF|ENDING|ENDTRY|FORMAT|FRAMES|GIVING|HASHED|HEADER|IMPORT|INSERT|MARGIN|MODULE|NATIVE|OBJECT|OFFSET|REMOTE|RESUME|SAVING|SIMPLE|SUBMIT|TABBED|TOKENS|UNIQUE|UNPACK|UPDATE|WINDOW|YELLOW|ACTUAL|ASPECT|CENTER|CURSOR|DELETE|DIALOG|DIVIDE|DURING|ERRORS|EVENTS|EXTEND|FILTER|HANDLE|HAVING|IGNORE|LITTLE|MEMORY|NO-GAP|OCCURS|OPTION|PERSON|PLACES|PUBLIC|REDUCE|REPORT|RESULT|SINGLE|SORTED|SWITCH|SYNTAX|TARGET|VALUES|WRITER|ASSERT|BLOCKS|BOUNDS|BUFFER|CHANGE|COLUMN|COMMIT|CONCAT|COPIES|CREATE|DDMMYY|DEFINE|ENDIAN|ESCAPE|EXPAND|KERNEL|LAYOUT|LEGACY|LEVELS|MMDDYY|NUMBER|OUTPUT|RANGES|READER|RETURN|SCREEN|SEARCH|SELECT|SHARED|SOURCE|STABLE|STATIC|SUBKEY|SUFFIX|TABLES|UNWIND|YYMMDD|ASSIGN|BACKUP|BEFORE|BINARY|BIT-OR|BLANKS|CLIENT|CODING|COMMON|DEMAND|DYNPRO|EXCEPT|EXISTS|EXPORT|FIELDS|GLOBAL|GROUPS|LENGTH|LOCALE|MEDIUM|METHOD|MODIFY|NESTED|OTHERS|REJECT|SCROLL|SUPPLY|SYMBOL|ENDFOR|STRLEN|ALIGN|BEGIN|BOUND|ENDAT|ENTRY|EVENT|FINAL|FLUSH|GRANT|INNER|SHORT|USING|WRITE|AFTER|BLACK|BLOCK|CLOCK|COLOR|COUNT|DUMMY|EMPTY|ENDDO|ENDON|GREEN|INDEX|INOUT|LEAVE|LEVEL|LINES|MODIF|ORDER|OUTER|RANGE|RESET|RETRY|RIGHT|SMART|SPLIT|STYLE|TABLE|THROW|UNDER|UNTIL|UPPER|UTF-8|WHERE|ALIAS|BLANK|CLEAR|CLOSE|EXACT|FETCH|FIRST|FOUND|GROUP|LLANG|LOCAL|OTHER|REGEX|SPOOL|TITLE|TYPES|VALID|WHILE|ALPHA|BOXED|CATCH|CHAIN|CHECK|CLASS|COVER|ENDIF|EQUIV|FIELD|FLOOR|FRAME|INPUT|LOWER|MATCH|NODES|PAGES|PRINT|RAISE|ROUND|SHIFT|SPACE|SPOTS|STAMP|STATE|TASKS|TIMES|TRMAC|ULINE|UNION|VALUE|WIDTH|EQUAL|LOG10|TRUNC|BLOB|CASE|CEIL|CLOB|COND|EXIT|FILE|GAPS|HOLD|INCL|INTO|KEEP|KEYS|LAST|LINE|LONG|LPAD|MAIL|MODE|OPEN|PINK|READ|ROWS|TEST|THEN|ZERO|AREA|BACK|BADI|BYTE|CAST|EDIT|EXEC|FAIL|FIND|FKEQ|FONT|FREE|GKEQ|HIDE|INIT|ITNO|LATE|LOOP|MAIN|MARK|MOVE|NEXT|NULL|RISK|ROLE|UNIT|WAIT|ZONE|BASE|CALL|CODE|DATA|DATE|FKGE|GKGE|HIGH|KIND|LEFT|LIST|MASK|MESH|NAME|NODE|PACK|PAGE|POOL|SEND|SIGN|SIZE|SOME|STOP|TASK|TEXT|TIME|USER|VARY|WITH|WORD|BLUE|CONV|COPY|DEEP|ELSE|FORM|FROM|HINT|ICON|JOIN|LIKE|LOAD|ONLY|PART|SCAN|SKIP|SORT|TYPE|UNIX|VIEW|WHEN|WORK|ACOS|ASIN|ATAN|COSH|EACH|FRAC|LESS|RTTI|SINH|SQRT|TANH|AVG|BIT|DIV|ISO|LET|OUT|PAD|SQL|ALL|CI_|CPI|END|LOB|LPI|MAX|MIN|NEW|OLE|RUN|SET|\?TO|YES|ABS|ADD|AND|BIG|FOR|HDB|JOB|LOW|NOT|SAP|TRY|VIA|XML|ANY|GET|IDS|KEY|MOD|OFF|PUT|RAW|RED|REF|SUM|TAB|XSD|CNT|COS|EXP|LOG|SIN|TAN|XOR|AT|CO|CP|DO|GT|ID|IF|NS|OR|BT|CA|CS|GE|NA|NB|EQ|IN|LT|NE|NO|OF|ON|PF|TO|AS|BY|CN|IS|LE|NP|UP|E|I|M|O|Z|C|X)\b/i,
        lookbehind: !0
      },
      /* Numbers can be only integers. Decimal or Hex appear only as strings */
      number: /\b\d+\b/,
      /* Operators must always be surrounded by whitespace, they cannot be put
      adjacent to operands.
      */
      operator: {
        pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
        lookbehind: !0
      },
      "string-operator": {
        pattern: /(\s)&&?(?=\s)/,
        lookbehind: !0,
        /* The official editor highlights */
        alias: "keyword"
      },
      "token-operator": [
        {
          /* Special operators used to access structure components, class methods/attributes, etc. */
          pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
          lookbehind: !0,
          alias: "punctuation"
        },
        {
          /* Special tokens used do delimit string templates */
          pattern: /[|{}]/,
          alias: "punctuation"
        }
      ],
      punctuation: /[,.:()]/
    };
  }
  return Pl;
}
var Fl, Wy;
function b8() {
  if (Wy) return Fl;
  Wy = 1, Fl = e, e.displayName = "abnf", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = "(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)";
      n.languages.abnf = {
        comment: /;.*/,
        string: {
          pattern: /(?:%[is])?"[^"\n\r]*"/,
          greedy: !0,
          inside: {
            punctuation: /^%[is]/
          }
        },
        range: {
          pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
          alias: "number"
        },
        terminal: {
          pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
          alias: "number"
        },
        repetition: {
          pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
          lookbehind: !0,
          alias: "operator"
        },
        definition: {
          pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
          lookbehind: !0,
          alias: "keyword",
          inside: {
            punctuation: /<|>/
          }
        },
        "core-rule": {
          pattern: RegExp(
            "(?:(^|[^<\\w-])" + r + "|<" + r + ">)(?![\\w-])",
            "i"
          ),
          lookbehind: !0,
          alias: ["rule", "constant"],
          inside: {
            punctuation: /<|>/
          }
        },
        rule: {
          pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
          lookbehind: !0,
          inside: {
            punctuation: /<|>/
          }
        },
        operator: /=\/?|\//,
        punctuation: /[()\[\]]/
      };
    })(t);
  }
  return Fl;
}
var $l, qy;
function v8() {
  if (qy) return $l;
  qy = 1, $l = e, e.displayName = "actionscript", e.aliases = [];
  function e(t) {
    t.languages.actionscript = t.languages.extend("javascript", {
      keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
      operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
    }), t.languages.actionscript["class-name"].alias = "function", delete t.languages.actionscript.parameter, delete t.languages.actionscript["literal-property"], t.languages.markup && t.languages.insertBefore("actionscript", "string", {
      xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: !0,
        inside: t.languages.markup
      }
    });
  }
  return $l;
}
var Bl, Vy;
function y8() {
  if (Vy) return Bl;
  Vy = 1, Bl = e, e.displayName = "ada", e.aliases = [];
  function e(t) {
    t.languages.ada = {
      comment: /--.*/,
      string: /"(?:""|[^"\r\f\n])*"/,
      number: [
        {
          pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
        },
        {
          pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
        }
      ],
      "attr-name": /\b'\w+/,
      keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
      boolean: /\b(?:false|true)\b/i,
      operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
      punctuation: /\.\.?|[,;():]/,
      char: /'.'/,
      variable: /\b[a-z](?:\w)*\b/i
    };
  }
  return Bl;
}
var Ul, jy;
function E8() {
  if (jy) return Ul;
  jy = 1, Ul = e, e.displayName = "agda", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.agda = {
        comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
        string: {
          pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
          greedy: !0
        },
        punctuation: /[(){}⦃⦄.;@]/,
        "class-name": {
          pattern: /((?:data|record) +)\S+/,
          lookbehind: !0
        },
        function: {
          pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
          lookbehind: !0
        },
        operator: {
          pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
          lookbehind: !0
        },
        keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
      };
    })(t);
  }
  return Ul;
}
var Gl, Yy;
function S8() {
  if (Yy) return Gl;
  Yy = 1, Gl = e, e.displayName = "al", e.aliases = [];
  function e(t) {
    t.languages.al = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
        greedy: !0
      },
      function: {
        pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
        lookbehind: !0
      },
      keyword: [
        // keywords
        /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
        // objects and metadata that are used like keywords
        /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
      ],
      number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
      boolean: /\b(?:false|true)\b/i,
      variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
      "class-name": /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
      operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
      punctuation: /[()\[\]{}:.;,]/
    };
  }
  return Gl;
}
var Hl, Ky;
function w8() {
  if (Ky) return Hl;
  Ky = 1, Hl = e, e.displayName = "antlr4", e.aliases = ["g4"];
  function e(t) {
    t.languages.antlr4 = {
      comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      string: {
        pattern: /'(?:\\.|[^\\'\r\n])*'/,
        greedy: !0
      },
      "character-class": {
        pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
        greedy: !0,
        alias: "regex",
        inside: {
          range: {
            pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
            lookbehind: !0,
            alias: "punctuation"
          },
          escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
          punctuation: /[\[\]]/
        }
      },
      action: {
        pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
        greedy: !0,
        inside: {
          content: {
            // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
            pattern: /(\{)[\s\S]+(?=\})/,
            lookbehind: !0
          },
          punctuation: /[{}]/
        }
      },
      command: {
        pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
        lookbehind: !0,
        inside: {
          function: /\b\w+(?=\s*(?:[,(]|$))/,
          punctuation: /[,()]/
        }
      },
      annotation: {
        pattern: /@\w+(?:::\w+)*/,
        alias: "keyword"
      },
      label: {
        pattern: /#[ \t]*\w+/,
        alias: "punctuation"
      },
      keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
      definition: [
        {
          pattern: /\b[a-z]\w*(?=\s*:)/,
          alias: ["rule", "class-name"]
        },
        {
          pattern: /\b[A-Z]\w*(?=\s*:)/,
          alias: ["token", "constant"]
        }
      ],
      constant: /\b[A-Z][A-Z_]*\b/,
      operator: /\.\.|->|[|~]|[*+?]\??/,
      punctuation: /[;:()=]/
    }, t.languages.g4 = t.languages.antlr4;
  }
  return Hl;
}
var zl, Xy;
function _8() {
  if (Xy) return zl;
  Xy = 1, zl = e, e.displayName = "apacheconf", e.aliases = [];
  function e(t) {
    t.languages.apacheconf = {
      comment: /#.*/,
      "directive-inline": {
        pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
        lookbehind: !0,
        alias: "property"
      },
      "directive-block": {
        pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
        inside: {
          "directive-block": {
            pattern: /^<\/?\w+/,
            inside: {
              punctuation: /^<\/?/
            },
            alias: "tag"
          },
          "directive-block-parameter": {
            pattern: /.*[^>]/,
            inside: {
              punctuation: /:/,
              string: {
                pattern: /("|').*\1/,
                inside: {
                  variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
                }
              }
            },
            alias: "attr-value"
          },
          punctuation: />/
        },
        alias: "tag"
      },
      "directive-flags": {
        pattern: /\[(?:[\w=],?)+\]/,
        alias: "keyword"
      },
      string: {
        pattern: /("|').*\1/,
        inside: {
          variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
        }
      },
      variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
      regex: /\^?.*\$|\^.*\$?/
    };
  }
  return zl;
}
var Wl, Zy;
function wm() {
  if (Zy) return Wl;
  Zy = 1, Wl = e, e.displayName = "sql", e.aliases = [];
  function e(t) {
    t.languages.sql = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: !0
      },
      variable: [
        {
          pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
          greedy: !0
        },
        /@[\w.$]+/
      ],
      string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: !0,
        lookbehind: !0
      },
      identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: !0,
        lookbehind: !0,
        inside: {
          punctuation: /^`|`$/
        }
      },
      function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
      // Should we highlight user defined functions too?
      keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
      boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
      number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
      operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
      punctuation: /[;[\]()`,.]/
    };
  }
  return Wl;
}
var ql, Qy;
function T8() {
  if (Qy) return ql;
  Qy = 1;
  var e = wm();
  ql = t, t.displayName = "apex", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i, i = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(
        /<keyword>/g,
        function() {
          return a.source;
        }
      );
      function o(l) {
        return RegExp(
          l.replace(/<CLASS-NAME>/g, function() {
            return i;
          }),
          "i"
        );
      }
      var s = {
        keyword: a,
        punctuation: /[()\[\]{};,:.<>]/
      };
      r.languages.apex = {
        comment: r.languages.clike.comment,
        string: r.languages.clike.string,
        sql: {
          pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
          lookbehind: !0,
          greedy: !0,
          alias: "language-sql",
          inside: r.languages.sql
        },
        annotation: {
          pattern: /@\w+\b/,
          alias: "punctuation"
        },
        "class-name": [
          {
            pattern: o(
              /(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source
            ),
            lookbehind: !0,
            inside: s
          },
          {
            // cast
            pattern: o(
              /(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source
            ),
            lookbehind: !0,
            inside: s
          },
          {
            // variable/parameter declaration and return types
            pattern: o(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
            inside: s
          }
        ],
        trigger: {
          pattern: /(\btrigger\s+)\w+\b/i,
          lookbehind: !0,
          alias: "class-name"
        },
        keyword: a,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/i,
        number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
        operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
        punctuation: /[()\[\]{};,.]/
      };
    }(n);
  }
  return ql;
}
var Vl, Jy;
function R8() {
  if (Jy) return Vl;
  Jy = 1, Vl = e, e.displayName = "apl", e.aliases = [];
  function e(t) {
    t.languages.apl = {
      comment: /(?:⍝|#[! ]).*$/m,
      string: {
        pattern: /'(?:[^'\r\n]|'')*'/,
        greedy: !0
      },
      number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
      statement: /:[A-Z][a-z][A-Za-z]*\b/,
      "system-function": {
        pattern: /⎕[A-Z]+/i,
        alias: "function"
      },
      constant: /[⍬⌾#⎕⍞]/,
      function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
      "monadic-operator": {
        pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
        alias: "operator"
      },
      "dyadic-operator": {
        pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
        alias: "operator"
      },
      assignment: {
        pattern: /←/,
        alias: "keyword"
      },
      punctuation: /[\[;\]()◇⋄]/,
      dfn: {
        pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
        alias: "builtin"
      }
    };
  }
  return Vl;
}
var jl, eE;
function A8() {
  if (eE) return jl;
  eE = 1, jl = e, e.displayName = "applescript", e.aliases = [];
  function e(t) {
    t.languages.applescript = {
      comment: [
        // Allow one level of nesting
        /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
        /--.+/,
        /#.+/
      ],
      string: /"(?:\\.|[^"\\\r\n])*"/,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
      operator: [
        /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
        /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
      ],
      keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
      "class-name": /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
      punctuation: /[{}():,¬«»《》]/
    };
  }
  return jl;
}
var Yl, tE;
function x8() {
  if (tE) return Yl;
  tE = 1, Yl = e, e.displayName = "aql", e.aliases = [];
  function e(t) {
    t.languages.aql = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      property: {
        pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
        greedy: !0
      },
      identifier: {
        pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
        greedy: !0
      },
      variable: /@@?\w+/,
      keyword: [
        {
          pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
          lookbehind: !0
        },
        /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
        // pseudo keywords get a lookbehind to avoid false positives
        {
          pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
          lookbehind: !0
        },
        {
          pattern: /\bOPTIONS(?=\s*\{)/i
        }
      ],
      function: /\b(?!\d)\w+(?=\s*\()/,
      boolean: /\b(?:false|true)\b/i,
      range: {
        pattern: /\.\./,
        alias: "operator"
      },
      number: [
        /\b0b[01]+/i,
        /\b0x[0-9a-f]+/i,
        /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
      ],
      operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
      punctuation: /::|[?.:,;()[\]{}]/
    };
  }
  return Yl;
}
var Kl, nE;
function Or() {
  if (nE) return Kl;
  nE = 1, Kl = e, e.displayName = "c", e.aliases = [];
  function e(t) {
    t.languages.c = t.languages.extend("clike", {
      comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      string: {
        // https://en.cppreference.com/w/c/language/string_literal
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: !0
      },
      keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
      operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    }), t.languages.insertBefore("c", "string", {
      char: {
        // https://en.cppreference.com/w/c/language/character_constant
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: !0
      }
    }), t.languages.insertBefore("c", "string", {
      macro: {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: !0,
        greedy: !0,
        alias: "property",
        inside: {
          string: [
            {
              // highlight the path of the include statement as a string
              pattern: /^(#\s*include\s*)<[^>]+>/,
              lookbehind: !0
            },
            t.languages.c.string
          ],
          char: t.languages.c.char,
          comment: t.languages.c.comment,
          "macro-name": [
            {
              pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
              lookbehind: !0
            },
            {
              pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
              lookbehind: !0,
              alias: "function"
            }
          ],
          // highlight macro directives as keywords
          directive: {
            pattern: /^(#\s*)[a-z]+/,
            lookbehind: !0,
            alias: "keyword"
          },
          "directive-hash": /^#/,
          punctuation: /##|\\(?=[\r\n])/,
          expression: {
            pattern: /\S[\s\S]*/,
            inside: t.languages.c
          }
        }
      }
    }), t.languages.insertBefore("c", "function", {
      // highlight predefined macros as constants
      constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    }), delete t.languages.c.boolean;
  }
  return Kl;
}
var Xl, rE;
function _m() {
  if (rE) return Xl;
  rE = 1;
  var e = Or();
  Xl = t, t.displayName = "cpp", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, i = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(
        /<keyword>/g,
        function() {
          return a.source;
        }
      );
      r.languages.cpp = r.languages.extend("c", {
        "class-name": [
          {
            pattern: RegExp(
              /(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(
                /<keyword>/g,
                function() {
                  return a.source;
                }
              )
            ),
            lookbehind: !0
          },
          // This is intended to capture the class name of method implementations like:
          //   void foo::bar() const {}
          // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
          // it starts with an uppercase letter. This approximation should give decent results.
          /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
          // This will capture the class name before destructors like:
          //   Foo::~Foo() {}
          /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
          // This also intends to capture the class name of method implementations but here the class has template
          // parameters, so it can't be a namespace (until C++ adds generic namespaces).
          /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: a,
        number: {
          pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
          greedy: !0
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
      }), r.languages.insertBefore("cpp", "string", {
        module: {
          // https://en.cppreference.com/w/cpp/language/modules
          pattern: RegExp(
            /(\b(?:import|module)\s+)/.source + "(?:" + // header-name
            /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
            /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(
              /<mod-name>/g,
              function() {
                return i;
              }
            ) + ")"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            string: /^[<"][\s\S]+/,
            operator: /:/,
            punctuation: /\./
          }
        },
        "raw-string": {
          pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
          alias: "string",
          greedy: !0
        }
      }), r.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
          pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
          inside: {
            function: /^\w+/,
            generic: {
              pattern: /<[\s\S]+/,
              alias: "class-name",
              inside: r.languages.cpp
            }
          }
        }
      }), r.languages.insertBefore("cpp", "operator", {
        "double-colon": {
          pattern: /::/,
          alias: "punctuation"
        }
      }), r.languages.insertBefore("cpp", "class-name", {
        // the base clause is an optional list of parent classes
        // https://en.cppreference.com/w/cpp/language/class
        "base-clause": {
          pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
          lookbehind: !0,
          greedy: !0,
          inside: r.languages.extend("cpp", {})
        }
      }), r.languages.insertBefore(
        "inside",
        "double-colon",
        {
          // All untokenized words that are not namespaces should be class names
          "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
        },
        r.languages.cpp["base-clause"]
      );
    }(n);
  }
  return Xl;
}
var Zl, aE;
function C8() {
  if (aE) return Zl;
  aE = 1;
  var e = _m();
  Zl = t, t.displayName = "arduino", t.aliases = ["ino"];
  function t(n) {
    n.register(e), n.languages.arduino = n.languages.extend("cpp", {
      keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
      constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
      builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
    }), n.languages.ino = n.languages.arduino;
  }
  return Zl;
}
var Ql, iE;
function N8() {
  if (iE) return Ql;
  iE = 1, Ql = e, e.displayName = "arff", e.aliases = [];
  function e(t) {
    t.languages.arff = {
      comment: /%.*/,
      string: {
        pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: /@(?:attribute|data|end|relation)\b/i,
      number: /\b\d+(?:\.\d+)?\b/,
      punctuation: /[{},]/
    };
  }
  return Ql;
}
var Jl, oE;
function I8() {
  if (oE) return Jl;
  oE = 1, Jl = e, e.displayName = "asciidoc", e.aliases = ["adoc"];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
        lookbehind: !0,
        inside: {
          quoted: {
            pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
            inside: {
              punctuation: /^[$`]|[$`]$/
            }
          },
          interpreted: {
            pattern: /'(?:[^'\\]|\\.)*'/,
            inside: {
              punctuation: /^'|'$/
              // See rest below
            }
          },
          string: /"(?:[^"\\]|\\.)*"/,
          variable: /\w+(?==)/,
          punctuation: /^\[|\]$|,/,
          operator: /=/,
          // The negative look-ahead prevents blank matches
          "attr-value": /(?!^\s+$).+/
        }
      }, a = n.languages.asciidoc = {
        "comment-block": {
          pattern: /^(\/{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1/m,
          alias: "comment"
        },
        table: {
          pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
          inside: {
            specifiers: {
              pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
              alias: "attr-value"
            },
            punctuation: {
              pattern: /(^|[^\\])[|!]=*/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        "passthrough-block": {
          pattern: /^(\+{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^\++|\++$/
            // See rest below
          }
        },
        // Literal blocks and listing blocks
        "literal-block": {
          pattern: /^(-{4,}|\.{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
            // See rest below
          }
        },
        // Sidebar blocks, quote blocks, example blocks and open blocks
        "other-block": {
          pattern: /^(--|\*{4,}|_{4,}|={4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
            // See rest below
          }
        },
        // list-punctuation and list-label must appear before indented-block
        "list-punctuation": {
          pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
          lookbehind: !0,
          alias: "punctuation"
        },
        "list-label": {
          pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
          lookbehind: !0,
          alias: "symbol"
        },
        "indented-block": {
          pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
          lookbehind: !0
        },
        comment: /^\/\/.*/m,
        title: {
          pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
          alias: "important",
          inside: {
            punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
            // See rest below
          }
        },
        "attribute-entry": {
          pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
          alias: "tag"
        },
        attributes: r,
        hr: {
          pattern: /^'{3,}$/m,
          alias: "punctuation"
        },
        "page-break": {
          pattern: /^<{3,}$/m,
          alias: "punctuation"
        },
        admonition: {
          pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
          alias: "keyword"
        },
        callout: [
          {
            pattern: /(^[ \t]*)<?\d*>/m,
            lookbehind: !0,
            alias: "symbol"
          },
          {
            pattern: /<\d+>/,
            alias: "symbol"
          }
        ],
        macro: {
          pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
          inside: {
            function: /^[a-z\d-]+(?=:)/,
            punctuation: /^::?/,
            attributes: {
              pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
              inside: r.inside
            }
          }
        },
        inline: {
          /*
          The initial look-behind prevents the highlighting of escaped quoted text.
          Quoted text can be multi-line but cannot span an empty line.
          All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
          First, we handle the constrained quotes.
          Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
          They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
          Then we handle the unconstrained quotes.
          Those do not have the restrictions of the constrained quotes.
          They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
          */
          pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
          lookbehind: !0,
          inside: {
            attributes: r,
            url: {
              pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
              inside: {
                punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
              }
            },
            "attribute-ref": {
              pattern: /^\{.+\}$/,
              inside: {
                variable: {
                  pattern: /(^\{)[a-z\d,+_-]+/,
                  lookbehind: !0
                },
                operator: /^[=?!#%@$]|!(?=[:}])/,
                punctuation: /^\{|\}$|::?/
              }
            },
            italic: {
              pattern: /^(['_])[\s\S]+\1$/,
              inside: {
                punctuation: /^(?:''?|__?)|(?:''?|__?)$/
              }
            },
            bold: {
              pattern: /^\*[\s\S]+\*$/,
              inside: {
                punctuation: /^\*\*?|\*\*?$/
              }
            },
            punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
          }
        },
        replacement: {
          pattern: /\((?:C|R|TM)\)/,
          alias: "builtin"
        },
        entity: /&#?[\da-z]{1,8};/i,
        "line-continuation": {
          pattern: /(^| )\+$/m,
          lookbehind: !0,
          alias: "punctuation"
        }
      };
      function i(o) {
        o = o.split(" ");
        for (var s = {}, l = 0, c = o.length; l < c; l++)
          s[o[l]] = a[o[l]];
        return s;
      }
      r.inside.interpreted.inside.rest = i(
        "macro inline replacement entity"
      ), a["passthrough-block"].inside.rest = i("macro"), a["literal-block"].inside.rest = i("callout"), a.table.inside.rest = i(
        "comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation"
      ), a["other-block"].inside.rest = i(
        "table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation"
      ), a.title.inside.rest = i(
        "macro inline replacement entity"
      ), n.hooks.add("wrap", function(o) {
        o.type === "entity" && (o.attributes.title = o.content.value.replace(/&amp;/, "&"));
      }), n.languages.adoc = n.languages.asciidoc;
    })(t);
  }
  return Jl;
}
var ec, sE;
function k8() {
  if (sE) return ec;
  sE = 1, ec = e, e.displayName = "asm6502", e.aliases = [];
  function e(t) {
    t.languages.asm6502 = {
      comment: /;.*/,
      directive: {
        pattern: /\.\w+(?= )/,
        alias: "property"
      },
      string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      "op-code": {
        pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
        alias: "keyword"
      },
      "hex-number": {
        pattern: /#?\$[\da-f]{1,4}\b/i,
        alias: "number"
      },
      "binary-number": {
        pattern: /#?%[01]+\b/,
        alias: "number"
      },
      "decimal-number": {
        pattern: /#?\b\d+\b/,
        alias: "number"
      },
      register: {
        pattern: /\b[xya]\b/i,
        alias: "variable"
      },
      punctuation: /[(),:]/
    };
  }
  return ec;
}
var tc, lE;
function O8() {
  if (lE) return tc;
  lE = 1, tc = e, e.displayName = "asmatmel", e.aliases = [];
  function e(t) {
    t.languages.asmatmel = {
      comment: {
        pattern: /;.*/,
        greedy: !0
      },
      string: {
        pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
      directive: {
        pattern: /\.\w+(?= )/,
        alias: "property"
      },
      "r-register": {
        pattern: /\br(?:\d|[12]\d|3[01])\b/,
        alias: "variable"
      },
      "op-code": {
        pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
        alias: "keyword"
      },
      "hex-number": {
        pattern: /#?\$[\da-f]{2,4}\b/i,
        alias: "number"
      },
      "binary-number": {
        pattern: /#?%[01]+\b/,
        alias: "number"
      },
      "decimal-number": {
        pattern: /#?\b\d+\b/,
        alias: "number"
      },
      register: {
        pattern: /\b[acznvshtixy]\b/i,
        alias: "variable"
      },
      operator: />>=?|<<=?|&&?|\|\|?|[-+*/%&|^!=<>?]=?/,
      punctuation: /[(),:]/
    };
  }
  return tc;
}
var nc, cE;
function Fs() {
  if (cE) return nc;
  cE = 1, nc = e, e.displayName = "csharp", e.aliases = ["dotnet", "cs"];
  function e(t) {
    (function(n) {
      function r(U, q) {
        return U.replace(/<<(\d+)>>/g, function(re, j) {
          return "(?:" + q[+j] + ")";
        });
      }
      function a(U, q, re) {
        return RegExp(r(U, q), "");
      }
      function i(U, q) {
        for (var re = 0; re < q; re++)
          U = U.replace(/<<self>>/g, function() {
            return "(?:" + U + ")";
          });
        return U.replace(/<<self>>/g, "[^\\s\\S]");
      }
      var o = {
        // keywords which represent a return or variable type
        type: "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",
        // keywords which are used to declare a type
        typeDeclaration: "class enum interface record struct",
        // contextual keywords
        // ("var" and "dynamic" are missing because they are used like types)
        contextual: "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",
        // all other keywords
        other: "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield"
      };
      function s(U) {
        return "\\b(?:" + U.trim().replace(/ /g, "|") + ")\\b";
      }
      var l = s(
        o.typeDeclaration
      ), c = RegExp(
        s(
          o.type + " " + o.typeDeclaration + " " + o.contextual + " " + o.other
        )
      ), u = s(
        o.typeDeclaration + " " + o.contextual + " " + o.other
      ), d = s(
        o.type + " " + o.typeDeclaration + " " + o.other
      ), f = i(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2), g = i(/\((?:[^()]|<<self>>)*\)/.source, 2), h = /@?\b[A-Za-z_]\w*\b/.source, p = r(/<<0>>(?:\s*<<1>>)?/.source, [h, f]), m = r(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
        u,
        p
      ]), v = /\[\s*(?:,\s*)*\]/.source, y = r(
        /<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source,
        [m, v]
      ), E = r(
        /[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source,
        [f, g, v]
      ), S = r(/\(<<0>>+(?:,<<0>>+)+\)/.source, [E]), w = r(
        /(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source,
        [S, m, v]
      ), R = {
        keyword: c,
        punctuation: /[<>()?,.:[\]]/
      }, T = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source, A = /"(?:\\.|[^\\"\r\n])*"/.source, C = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
      n.languages.csharp = n.languages.extend("clike", {
        string: [
          {
            pattern: a(/(^|[^$\\])<<0>>/.source, [C]),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: a(/(^|[^@$\\])<<0>>/.source, [A]),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "class-name": [
          {
            // Using static
            // using static System.Math;
            pattern: a(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
              m
            ]),
            lookbehind: !0,
            inside: R
          },
          {
            // Using alias (type)
            // using Project = PC.MyCompany.Project;
            pattern: a(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
              h,
              w
            ]),
            lookbehind: !0,
            inside: R
          },
          {
            // Using alias (alias)
            // using Project = PC.MyCompany.Project;
            pattern: a(/(\busing\s+)<<0>>(?=\s*=)/.source, [h]),
            lookbehind: !0
          },
          {
            // Type declarations
            // class Foo<A, B>
            // interface Foo<out A, B>
            pattern: a(/(\b<<0>>\s+)<<1>>/.source, [
              l,
              p
            ]),
            lookbehind: !0,
            inside: R
          },
          {
            // Single catch exception declaration
            // catch(Foo)
            // (things like catch(Foo e) is covered by variable declaration)
            pattern: a(/(\bcatch\s*\(\s*)<<0>>/.source, [m]),
            lookbehind: !0,
            inside: R
          },
          {
            // Name of the type parameter of generic constraints
            // where Foo : class
            pattern: a(/(\bwhere\s+)<<0>>/.source, [h]),
            lookbehind: !0
          },
          {
            // Casts and checks via as and is.
            // as Foo<A>, is Bar<B>
            // (things like if(a is Foo b) is covered by variable declaration)
            pattern: a(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
              y
            ]),
            lookbehind: !0,
            inside: R
          },
          {
            // Variable, field and parameter declaration
            // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
            pattern: a(
              /\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source,
              [w, d, h]
            ),
            inside: R
          }
        ],
        keyword: c,
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
        number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
        operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
        punctuation: /\?\.?|::|[{}[\];(),.:]/
      }), n.languages.insertBefore("csharp", "number", {
        range: {
          pattern: /\.\./,
          alias: "operator"
        }
      }), n.languages.insertBefore("csharp", "punctuation", {
        "named-parameter": {
          pattern: a(/([(,]\s*)<<0>>(?=\s*:)/.source, [h]),
          lookbehind: !0,
          alias: "punctuation"
        }
      }), n.languages.insertBefore("csharp", "class-name", {
        namespace: {
          // namespace Foo.Bar {}
          // using Foo.Bar;
          pattern: a(
            /(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source,
            [h]
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        "type-expression": {
          // default(Foo), typeof(Foo<Bar>), sizeof(int)
          pattern: a(
            /(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source,
            [g]
          ),
          lookbehind: !0,
          alias: "class-name",
          inside: R
        },
        "return-type": {
          // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
          // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
          // int Foo => 0; int Foo { get; set } = 0;
          pattern: a(
            /<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source,
            [w, m]
          ),
          inside: R,
          alias: "class-name"
        },
        "constructor-invocation": {
          // new List<Foo<Bar[]>> { }
          pattern: a(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [w]),
          lookbehind: !0,
          inside: R,
          alias: "class-name"
        },
        /*'explicit-implementation': {
        // int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
        pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
        inside: classNameInside,
        alias: 'class-name'
        },*/
        "generic-method": {
          // foo<Bar>()
          pattern: a(/<<0>>\s*<<1>>(?=\s*\()/.source, [h, f]),
          inside: {
            function: a(/^<<0>>/.source, [h]),
            generic: {
              pattern: RegExp(f),
              alias: "class-name",
              inside: R
            }
          }
        },
        "type-list": {
          // The list of types inherited or of generic constraints
          // class Foo<F> : Bar, IList<FooBar>
          // where F : Bar, IList<int>
          pattern: a(
            /\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source,
            [
              l,
              p,
              h,
              w,
              c.source,
              g,
              /\bnew\s*\(\s*\)/.source
            ]
          ),
          lookbehind: !0,
          inside: {
            "record-arguments": {
              pattern: a(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                p,
                g
              ]),
              lookbehind: !0,
              greedy: !0,
              inside: n.languages.csharp
            },
            keyword: c,
            "class-name": {
              pattern: RegExp(w),
              greedy: !0,
              inside: R
            },
            punctuation: /[,()]/
          }
        },
        preprocessor: {
          pattern: /(^[\t ]*)#.*/m,
          lookbehind: !0,
          alias: "property",
          inside: {
            // highlight preprocessor directives as keywords
            directive: {
              pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
              lookbehind: !0,
              alias: "keyword"
            }
          }
        }
      });
      var N = A + "|" + T, L = r(
        /\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source,
        [N]
      ), I = i(
        r(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
          L
        ]),
        2
      ), k = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source, B = r(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
        m,
        I
      ]);
      n.languages.insertBefore("csharp", "class-name", {
        attribute: {
          // Attributes
          // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
          pattern: a(
            /((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source,
            [k, B]
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            target: {
              pattern: a(/^<<0>>(?=\s*:)/.source, [k]),
              alias: "keyword"
            },
            "attribute-arguments": {
              pattern: a(/\(<<0>>*\)/.source, [I]),
              inside: n.languages.csharp
            },
            "class-name": {
              pattern: RegExp(m),
              inside: {
                punctuation: /\./
              }
            },
            punctuation: /[:,]/
          }
        }
      });
      var F = /:[^}\r\n]+/.source, P = i(
        r(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
          L
        ]),
        2
      ), D = r(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
        P,
        F
      ]), O = i(
        r(
          /[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source,
          [N]
        ),
        2
      ), M = r(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
        O,
        F
      ]);
      function W(U, q) {
        return {
          interpolation: {
            pattern: a(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [U]),
            lookbehind: !0,
            inside: {
              "format-string": {
                pattern: a(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                  q,
                  F
                ]),
                lookbehind: !0,
                inside: {
                  punctuation: /^:/
                }
              },
              punctuation: /^\{|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                alias: "language-csharp",
                inside: n.languages.csharp
              }
            }
          },
          string: /[\s\S]+/
        };
      }
      n.languages.insertBefore("csharp", "string", {
        "interpolation-string": [
          {
            pattern: a(
              /(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source,
              [D]
            ),
            lookbehind: !0,
            greedy: !0,
            inside: W(D, P)
          },
          {
            pattern: a(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
              M
            ]),
            lookbehind: !0,
            greedy: !0,
            inside: W(M, O)
          }
        ],
        char: {
          pattern: RegExp(T),
          greedy: !0
        }
      }), n.languages.dotnet = n.languages.cs = n.languages.csharp;
    })(t);
  }
  return nc;
}
var rc, uE;
function D8() {
  if (uE) return rc;
  uE = 1;
  var e = Fs();
  rc = t, t.displayName = "aspnet", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.aspnet = n.languages.extend("markup", {
      "page-directive": {
        pattern: /<%\s*@.*%>/,
        alias: "tag",
        inside: {
          "page-directive": {
            pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
            alias: "tag"
          },
          rest: n.languages.markup.tag.inside
        }
      },
      directive: {
        pattern: /<%.*%>/,
        alias: "tag",
        inside: {
          directive: {
            pattern: /<%\s*?[$=%#:]{0,2}|%>/,
            alias: "tag"
          },
          rest: n.languages.csharp
        }
      }
    }), n.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, n.languages.insertBefore(
      "inside",
      "punctuation",
      {
        directive: n.languages.aspnet.directive
      },
      n.languages.aspnet.tag.inside["attr-value"]
    ), n.languages.insertBefore("aspnet", "comment", {
      "asp-comment": {
        pattern: /<%--[\s\S]*?--%>/,
        alias: ["asp", "comment"]
      }
    }), n.languages.insertBefore(
      "aspnet",
      n.languages.javascript ? "script" : "tag",
      {
        "asp-script": {
          pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
          lookbehind: !0,
          alias: ["asp", "script"],
          inside: n.languages.csharp || {}
        }
      }
    );
  }
  return rc;
}
var ac, dE;
function L8() {
  if (dE) return ac;
  dE = 1, ac = e, e.displayName = "autohotkey", e.aliases = [];
  function e(t) {
    t.languages.autohotkey = {
      comment: [
        {
          pattern: /(^|\s);.*/,
          lookbehind: !0
        },
        {
          pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
          lookbehind: !0,
          greedy: !0
        }
      ],
      tag: {
        // labels
        pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
        lookbehind: !0
      },
      string: /"(?:[^"\n\r]|"")*"/,
      variable: /%\w+%/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
      operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
      boolean: /\b(?:false|true)\b/,
      selector: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
      constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
      builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
      symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
      important: /#\b(?:AllowSameLineComments|ClipboardTimeout|CommentFlag|DerefChar|ErrorStdOut|EscapeChar|HotkeyInterval|HotkeyModifierTimeout|Hotstring|If|IfTimeout|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Include|IncludeAgain|InputLevel|InstallKeybdHook|InstallMouseHook|KeyHistory|MaxHotkeysPerInterval|MaxMem|MaxThreads|MaxThreadsBuffer|MaxThreadsPerHotkey|MenuMaskKey|NoEnv|NoTrayIcon|Persistent|SingleInstance|UseHook|Warn|WinActivateForce)\b/i,
      keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
      function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
      punctuation: /[{}[\]():,]/
    };
  }
  return ac;
}
var ic, fE;
function M8() {
  if (fE) return ic;
  fE = 1, ic = e, e.displayName = "autoit", e.aliases = [];
  function e(t) {
    t.languages.autoit = {
      comment: [
        /;.*/,
        {
          // The multi-line comments delimiters can actually be commented out with ";"
          pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
          lookbehind: !0
        }
      ],
      url: {
        pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
        lookbehind: !0
      },
      string: {
        pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
        greedy: !0,
        inside: {
          variable: /([%$@])\w+\1/
        }
      },
      directive: {
        pattern: /(^[\t ]*)#[\w-]+/m,
        lookbehind: !0,
        alias: "keyword"
      },
      function: /\b\w+(?=\()/,
      // Variables and macros
      variable: /[$@]\w+/,
      keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
      boolean: /\b(?:False|True)\b/i,
      operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
      punctuation: /[\[\]().,:]/
    };
  }
  return ic;
}
var oc, pE;
function P8() {
  if (pE) return oc;
  pE = 1, oc = e, e.displayName = "avisynth", e.aliases = ["avs"];
  function e(t) {
    (function(n) {
      function r(u, d) {
        return u.replace(/<<(\d+)>>/g, function(f, g) {
          return d[+g];
        });
      }
      function a(u, d, f) {
        return RegExp(r(u, d), f);
      }
      var i = /bool|clip|float|int|string|val/.source, o = [
        // bools
        /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
        // control
        /apply|assert|default|eval|import|nop|select|undefined/.source,
        // global
        /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
        // conv
        /hex(?:value)?|value/.source,
        // numeric
        /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
        // trig
        /a?sinh?|a?cosh?|a?tan[2h]?/.source,
        // bit
        /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
        // runtime
        /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
        // script
        /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
        // string
        /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
        // version
        /isversionorgreater|version(?:number|string)/.source,
        // helper
        /buildpixeltype|colorspacenametopixeltype/.source,
        // avsplus
        /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
      ].join("|"), s = [
        // content
        /has(?:audio|video)/.source,
        // resolution
        /height|width/.source,
        // framerate
        /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
        // interlacing
        /getparity|is(?:field|frame)based/.source,
        // color format
        /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
        // audio
        /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
      ].join("|"), l = [
        // source
        /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
        // color
        /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
        // overlay
        /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
        // geometry
        /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
        // pixel
        /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
        // timeline
        /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
        // interlace
        /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
        // audio
        /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
        // conditional
        /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
        // export
        /imagewriter/.source,
        // debug
        /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
      ].join("|"), c = [o, s, l].join("|");
      n.languages.avisynth = {
        comment: [
          {
            // Matches [* *] nestable block comments, but only supports 1 level of nested comments
            // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
            pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // Matches /* */ block comments
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // Matches # comments
            pattern: /(^|[^\\$])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        // Handle before strings because optional arguments are surrounded by double quotes
        argument: {
          pattern: a(/\b(?:<<0>>)\s+("?)\w+\1/.source, [i], "i"),
          inside: {
            keyword: /^\w+/
          }
        },
        // Optional argument assignment
        "argument-label": {
          pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
          lookbehind: !0,
          inside: {
            "argument-name": {
              pattern: /^\w+/,
              alias: "punctuation"
            },
            punctuation: /=$/
          }
        },
        string: [
          {
            // triple double-quoted
            pattern: /"""[\s\S]*?"""/,
            greedy: !0
          },
          {
            // single double-quoted
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: !0,
            inside: {
              constant: {
                // These *are* case-sensitive!
                pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
              }
            }
          }
        ],
        // The special "last" variable that takes the value of the last implicitly returned clip
        variable: /\b(?:last)\b/i,
        boolean: /\b(?:false|no|true|yes)\b/i,
        keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
        constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
        // AviSynth's internal functions, filters, and properties
        "builtin-function": {
          pattern: a(/\b(?:<<0>>)\b/.source, [c], "i"),
          alias: "function"
        },
        "type-cast": {
          pattern: a(/\b(?:<<0>>)(?=\s*\()/.source, [i], "i"),
          alias: "keyword"
        },
        // External/user-defined filters
        function: {
          pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
          lookbehind: !0
        },
        // Matches a \ as the first or last character on a line
        "line-continuation": {
          pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
        operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
        punctuation: /[{}\[\]();,.]/
      }, n.languages.avs = n.languages.avisynth;
    })(t);
  }
  return oc;
}
var sc, gE;
function F8() {
  if (gE) return sc;
  gE = 1, sc = e, e.displayName = "avroIdl", e.aliases = [];
  function e(t) {
    t.languages["avro-idl"] = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
        lookbehind: !0,
        greedy: !0
      },
      annotation: {
        pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
        greedy: !0,
        alias: "function"
      },
      "function-identifier": {
        pattern: /`[^\r\n`]+`(?=\s*\()/,
        greedy: !0,
        alias: "function"
      },
      identifier: {
        pattern: /`[^\r\n`]+`/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: [
        {
          pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
          lookbehind: !0
        },
        /-?\b(?:Infinity|NaN)\b/
      ],
      operator: /=/,
      punctuation: /[()\[\]{}<>.:,;-]/
    }, t.languages.avdl = t.languages["avro-idl"];
  }
  return sc;
}
var lc, hE;
function Ik() {
  if (hE) return lc;
  hE = 1, lc = e, e.displayName = "bash", e.aliases = ["shell"];
  function e(t) {
    (function(n) {
      var r = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", a = {
        pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
        lookbehind: !0,
        alias: "punctuation",
        // this looks reasonably well in all themes
        inside: null
        // see below
      }, i = {
        bash: a,
        environment: {
          pattern: RegExp("\\$" + r),
          alias: "constant"
        },
        variable: [
          // [0]: Arithmetic Environment
          {
            pattern: /\$?\(\([\s\S]+?\)\)/,
            greedy: !0,
            inside: {
              // If there is a $ sign at the beginning highlight $(( and )) as variable
              variable: [
                {
                  pattern: /(^\$\(\([\s\S]+)\)\)/,
                  lookbehind: !0
                },
                /^\$\(\(/
              ],
              number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
              // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
              operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
              // If there is no $ sign at the beginning highlight (( and )) as punctuation
              punctuation: /\(\(?|\)\)?|,|;/
            }
          },
          // [1]: Command Substitution
          {
            pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
            greedy: !0,
            inside: {
              variable: /^\$\(|^`|\)$|`$/
            }
          },
          // [2]: Brace expansion
          {
            pattern: /\$\{[^}]+\}/,
            greedy: !0,
            inside: {
              operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
              punctuation: /[\[\]]/,
              environment: {
                pattern: RegExp("(\\{)" + r),
                lookbehind: !0,
                alias: "constant"
              }
            }
          },
          /\$(?:\w+|[#?*!@$])/
        ],
        // Escape sequences from echo and printf's manuals, and escaped quotes.
        entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
      };
      n.languages.bash = {
        shebang: {
          pattern: /^#!\s*\/.*/,
          alias: "important"
        },
        comment: {
          pattern: /(^|[^"{\\$])#.*/,
          lookbehind: !0
        },
        "function-name": [
          // a) function foo {
          // b) foo() {
          // c) function foo() {
          // but not “foo {”
          {
            // a) and c)
            pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
            lookbehind: !0,
            alias: "function"
          },
          {
            // b)
            pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
            alias: "function"
          }
        ],
        // Highlight variable names as variables in for and select beginnings.
        "for-or-select": {
          pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
          alias: "variable",
          lookbehind: !0
        },
        // Highlight variable names as variables in the left-hand part
        // of assignments (“=” and “+=”).
        "assign-left": {
          pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
          inside: {
            environment: {
              pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + r),
              lookbehind: !0,
              alias: "constant"
            }
          },
          alias: "variable",
          lookbehind: !0
        },
        string: [
          // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
          {
            pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
            lookbehind: !0,
            greedy: !0,
            inside: i
          },
          // Here-document with quotes around the tag
          // → No expansion (so no “inside”).
          {
            pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              bash: a
            }
          },
          // “Normal” string
          {
            // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
            pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
            lookbehind: !0,
            greedy: !0,
            inside: i
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
            pattern: /(^|[^$\\])'[^']*'/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
            pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
            greedy: !0,
            inside: {
              entity: i.entity
            }
          }
        ],
        environment: {
          pattern: RegExp("\\$?" + r),
          alias: "constant"
        },
        variable: i.variable,
        function: {
          pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        keyword: {
          pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        builtin: {
          pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
          lookbehind: !0,
          // Alias added to make those easier to distinguish from strings.
          alias: "class-name"
        },
        boolean: {
          pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        "file-descriptor": {
          pattern: /\B&\d\b/,
          alias: "important"
        },
        operator: {
          // Lots of redirections here, but not just that.
          pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
          inside: {
            "file-descriptor": {
              pattern: /^\d/,
              alias: "important"
            }
          }
        },
        punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
        number: {
          pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
          lookbehind: !0
        }
      }, a.inside = n.languages.bash;
      for (var o = [
        "comment",
        "function-name",
        "for-or-select",
        "assign-left",
        "string",
        "environment",
        "function",
        "keyword",
        "builtin",
        "boolean",
        "file-descriptor",
        "operator",
        "punctuation",
        "number"
      ], s = i.variable[1].inside, l = 0; l < o.length; l++)
        s[o[l]] = n.languages.bash[o[l]];
      n.languages.shell = n.languages.bash;
    })(t);
  }
  return lc;
}
var cc, mE;
function kk() {
  if (mE) return cc;
  mE = 1, cc = e, e.displayName = "basic", e.aliases = [];
  function e(t) {
    t.languages.basic = {
      comment: {
        pattern: /(?:!|REM\b).+/i,
        inside: {
          keyword: /^REM/i
        }
      },
      string: {
        pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
        greedy: !0
      },
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
      function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
      operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
      punctuation: /[,;:()]/
    };
  }
  return cc;
}
var uc, bE;
function $8() {
  if (bE) return uc;
  bE = 1, uc = e, e.displayName = "batch", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /%%?[~:\w]+%?|!\S+!/, a = {
        pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
        alias: "attr-name",
        inside: {
          punctuation: /:/
        }
      }, i = /"(?:[\\"]"|[^"])*"(?!")/, o = /(?:\b|-)\d+\b/;
      n.languages.batch = {
        comment: [
          /^::.*/m,
          {
            pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
            lookbehind: !0
          }
        ],
        label: {
          pattern: /^:.*/m,
          alias: "property"
        },
        command: [
          {
            // FOR command
            pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
            lookbehind: !0,
            inside: {
              keyword: /\b(?:do|in)\b|^for\b/i,
              string: i,
              parameter: a,
              variable: r,
              number: o,
              punctuation: /[()',]/
            }
          },
          {
            // IF command
            pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
            lookbehind: !0,
            inside: {
              keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
              string: i,
              parameter: a,
              variable: r,
              number: o,
              operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
            }
          },
          {
            // ELSE command
            pattern: /((?:^|[&()])[ \t]*)else\b/im,
            lookbehind: !0,
            inside: {
              keyword: /^else\b/i
            }
          },
          {
            // SET command
            pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
            lookbehind: !0,
            inside: {
              keyword: /^set\b/i,
              string: i,
              parameter: a,
              variable: [r, /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/],
              number: o,
              operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
              punctuation: /[()',]/
            }
          },
          {
            // Other commands
            pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
            lookbehind: !0,
            inside: {
              keyword: /^\w+\b/,
              string: i,
              parameter: a,
              label: {
                pattern: /(^\s*):\S+/m,
                lookbehind: !0,
                alias: "property"
              },
              variable: r,
              number: o,
              operator: /\^/
            }
          }
        ],
        operator: /[&@]/,
        punctuation: /[()']/
      };
    })(t);
  }
  return uc;
}
var dc, vE;
function B8() {
  if (vE) return dc;
  vE = 1, dc = e, e.displayName = "bbcode", e.aliases = ["shortcode"];
  function e(t) {
    t.languages.bbcode = {
      tag: {
        pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
        inside: {
          tag: {
            pattern: /^\[\/?[^\s=\]]+/,
            inside: {
              punctuation: /^\[\/?/
            }
          },
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
            inside: {
              punctuation: [
                /^=/,
                {
                  pattern: /^(\s*)["']|["']$/,
                  lookbehind: !0
                }
              ]
            }
          },
          punctuation: /\]/,
          "attr-name": /[^\s=\]]+/
        }
      }
    }, t.languages.shortcode = t.languages.bbcode;
  }
  return dc;
}
var fc, yE;
function U8() {
  if (yE) return fc;
  yE = 1, fc = e, e.displayName = "bicep", e.aliases = [];
  function e(t) {
    t.languages.bicep = {
      comment: [
        {
          // multiline comments eg /* ASDF */
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          // singleline comments eg // ASDF
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      property: [
        {
          pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
          lookbehind: !0
        },
        {
          pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: [
        {
          pattern: /'''[^'][\s\S]*?'''/,
          greedy: !0
        },
        {
          pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      "interpolated-string": {
        pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{[^{}\r\n]*\}/,
            inside: {
              expression: {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0
              },
              punctuation: /^\$\{|\}$/
            }
          },
          string: /[\s\S]+/
        }
      },
      datatype: {
        pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
        lookbehind: !0,
        alias: "class-name"
      },
      boolean: /\b(?:false|true)\b/,
      // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
      keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
      decorator: /@\w+\b/,
      function: /\b[a-z_]\w*(?=[ \t]*\()/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.bicep["interpolated-string"].inside.interpolation.inside.expression.inside = t.languages.bicep;
  }
  return fc;
}
var pc, EE;
function G8() {
  if (EE) return pc;
  EE = 1, pc = e, e.displayName = "birb", e.aliases = [];
  function e(t) {
    t.languages.birb = t.languages.extend("clike", {
      string: {
        pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      "class-name": [
        /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
        // matches variable and function return types (parameters as well).
        /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
      ],
      keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
      operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
      variable: /\b[a-z_]\w*\b/
    }), t.languages.insertBefore("birb", "function", {
      metadata: {
        pattern: /<\w+>/,
        greedy: !0,
        alias: "symbol"
      }
    });
  }
  return pc;
}
var gc, SE;
function H8() {
  if (SE) return gc;
  SE = 1;
  var e = Or();
  gc = t, t.displayName = "bison", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.bison = n.languages.extend("c", {}), n.languages.insertBefore("bison", "comment", {
      bison: {
        // This should match all the beginning of the file
        // including the prologue(s), the bison declarations and
        // the grammar rules.
        pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
        inside: {
          c: {
            // Allow for one level of nested braces
            pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
            inside: {
              delimiter: {
                pattern: /^%?\{|%?\}$/,
                alias: "punctuation"
              },
              "bison-variable": {
                pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
                alias: "variable",
                inside: {
                  punctuation: /<|>/
                }
              },
              rest: n.languages.c
            }
          },
          comment: n.languages.c.comment,
          string: n.languages.c.string,
          property: /\S+(?=:)/,
          keyword: /%\w+/,
          number: {
            pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
            lookbehind: !0
          },
          punctuation: /%[%?]|[|:;\[\]<>]/
        }
      }
    });
  }
  return gc;
}
var hc, wE;
function z8() {
  if (wE) return hc;
  wE = 1, hc = e, e.displayName = "bnf", e.aliases = ["rbnf"];
  function e(t) {
    t.languages.bnf = {
      string: {
        pattern: /"[^\r\n"]*"|'[^\r\n']*'/
      },
      definition: {
        pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
        alias: ["rule", "keyword"],
        inside: {
          punctuation: /^<|>$/
        }
      },
      rule: {
        pattern: /<[^<>\r\n\t]+>/,
        inside: {
          punctuation: /^<|>$/
        }
      },
      operator: /::=|[|()[\]{}*+?]|\.{3}/
    }, t.languages.rbnf = t.languages.bnf;
  }
  return hc;
}
var mc, _E;
function W8() {
  if (_E) return mc;
  _E = 1, mc = e, e.displayName = "brainfuck", e.aliases = [];
  function e(t) {
    t.languages.brainfuck = {
      pointer: {
        pattern: /<|>/,
        alias: "keyword"
      },
      increment: {
        pattern: /\+/,
        alias: "inserted"
      },
      decrement: {
        pattern: /-/,
        alias: "deleted"
      },
      branching: {
        pattern: /\[|\]/,
        alias: "important"
      },
      operator: /[.,]/,
      comment: /\S+/
    };
  }
  return mc;
}
var bc, TE;
function q8() {
  if (TE) return bc;
  TE = 1, bc = e, e.displayName = "brightscript", e.aliases = [];
  function e(t) {
    t.languages.brightscript = {
      comment: /(?:\brem|').*/i,
      "directive-statement": {
        pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
        lookbehind: !0,
        alias: "property",
        inside: {
          "error-message": {
            pattern: /(^#error).+/,
            lookbehind: !0
          },
          directive: {
            pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
            alias: "keyword"
          },
          expression: {
            pattern: /[\s\S]+/,
            inside: null
            // see below
          }
        }
      },
      property: {
        pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\bAs[\t ]+)\w+/i,
        lookbehind: !0
      },
      keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\b(?!\d)\w+(?=[\t ]*\()/,
      number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
      operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
      punctuation: /[.,;()[\]{}]/,
      constant: /\b(?:LINE_NUM)\b/i
    }, t.languages.brightscript["directive-statement"].inside.expression.inside = t.languages.brightscript;
  }
  return bc;
}
var vc, RE;
function V8() {
  if (RE) return vc;
  RE = 1, vc = e, e.displayName = "bro", e.aliases = [];
  function e(t) {
    t.languages.bro = {
      comment: {
        pattern: /(^|[^\\$])#.*/,
        lookbehind: !0,
        inside: {
          italic: /\b(?:FIXME|TODO|XXX)\b/
        }
      },
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      boolean: /\b[TF]\b/,
      function: {
        pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
        lookbehind: !0
      },
      builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
      constant: {
        pattern: /(\bconst[ \t]+)\w+/i,
        lookbehind: !0
      },
      keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
      operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return vc;
}
var yc, AE;
function j8() {
  if (AE) return yc;
  AE = 1, yc = e, e.displayName = "bsl", e.aliases = [];
  function e(t) {
    t.languages.bsl = {
      comment: /\/\/.*/,
      string: [
        // Строки
        // Strings
        {
          pattern: /"(?:[^"]|"")*"(?!")/,
          greedy: !0
        },
        // Дата и время
        // Date & time
        {
          pattern: /'(?:[^'\r\n\\]|\\.)*'/
        }
      ],
      keyword: [
        {
          // RU
          pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
          lookbehind: !0
        },
        {
          // EN
          pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
        }
      ],
      number: {
        pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
        lookbehind: !0
      },
      operator: [
        /[<>+\-*/]=?|[%=]/,
        // RU
        {
          pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
          lookbehind: !0
        },
        // EN
        {
          pattern: /\b(?:and|not|or)\b/i
        }
      ],
      punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
      directive: [
        // Теги препроцессора вида &Клиент, &Сервер, ...
        // Preprocessor tags of the type &Client, &Server, ...
        {
          pattern: /^([ \t]*)&.*/m,
          lookbehind: !0,
          greedy: !0,
          alias: "important"
        },
        // Инструкции препроцессора вида:
        // #Если Сервер Тогда
        // ...
        // #КонецЕсли
        // Preprocessor instructions of the form:
        // #If Server Then
        // ...
        // #EndIf
        {
          pattern: /^([ \t]*)#.*/gm,
          lookbehind: !0,
          greedy: !0,
          alias: "important"
        }
      ]
    }, t.languages.oscript = t.languages.bsl;
  }
  return yc;
}
var Ec, xE;
function Y8() {
  if (xE) return Ec;
  xE = 1, Ec = e, e.displayName = "cfscript", e.aliases = [];
  function e(t) {
    t.languages.cfscript = t.languages.extend("clike", {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          inside: {
            annotation: {
              pattern: /(?:^|[^.])@[\w\.]+/,
              alias: "punctuation"
            }
          }
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
      operator: [
        /\+\+|--|&&|\|\||::|=>|[!=]==|<=?|>=?|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|[?:]/,
        /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
      ],
      scope: {
        pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
        alias: "global"
      },
      type: {
        pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
        alias: "builtin"
      }
    }), t.languages.insertBefore("cfscript", "keyword", {
      // This must be declared before keyword because we use "function" inside the lookahead
      "function-variable": {
        pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      }
    }), delete t.languages.cfscript["class-name"], t.languages.cfc = t.languages.cfscript;
  }
  return Ec;
}
var Sc, CE;
function K8() {
  if (CE) return Sc;
  CE = 1;
  var e = _m();
  Sc = t, t.displayName = "chaiscript", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.chaiscript = n.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": [
        {
          // e.g. class Rectangle { ... }
          pattern: /(\bclass\s+)\w+/,
          lookbehind: !0
        },
        {
          // e.g. attr Rectangle::height, def Rectangle::area() { ... }
          pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
          lookbehind: !0
        }
      ],
      keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
      number: [n.languages.cpp.number, /\b(?:Infinity|NaN)\b/],
      operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
    }), n.languages.insertBefore("chaiscript", "operator", {
      "parameter-type": {
        // e.g. def foo(int x, Vector y) {...}
        pattern: /([,(]\s*)\w+(?=\s+\w)/,
        lookbehind: !0,
        alias: "class-name"
      }
    }), n.languages.insertBefore("chaiscript", "string", {
      "string-interpolation": {
        pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
            lookbehind: !0,
            inside: {
              "interpolation-expression": {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0,
                inside: n.languages.chaiscript
              },
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    });
  }
  return Sc;
}
var wc, NE;
function X8() {
  if (NE) return wc;
  NE = 1, wc = e, e.displayName = "cil", e.aliases = [];
  function e(t) {
    t.languages.cil = {
      comment: /\/\/.*/,
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      directive: {
        pattern: /(^|\W)\.[a-z]+(?=\s)/,
        lookbehind: !0,
        alias: "class-name"
      },
      // Actually an assembly reference
      variable: /\[[\w\.]+\]/,
      keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
      function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
      punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
    };
  }
  return wc;
}
var _c, IE;
function Z8() {
  if (IE) return _c;
  IE = 1, _c = e, e.displayName = "clojure", e.aliases = [];
  function e(t) {
    t.languages.clojure = {
      comment: {
        pattern: /;.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      char: /\\\w+/,
      symbol: {
        pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
        lookbehind: !0
      },
      keyword: {
        pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
        lookbehind: !0
      },
      boolean: /\b(?:false|nil|true)\b/,
      number: {
        pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
        lookbehind: !0
      },
      function: {
        pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
        lookbehind: !0
      },
      operator: /[#@^`~]/,
      punctuation: /[{}\[\](),]/
    };
  }
  return _c;
}
var Tc, kE;
function Q8() {
  if (kE) return Tc;
  kE = 1, Tc = e, e.displayName = "cmake", e.aliases = [];
  function e(t) {
    t.languages.cmake = {
      comment: /#.*/,
      string: {
        pattern: /"(?:[^\\"]|\\.)*"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
            inside: {
              punctuation: /\$\{|\}/,
              variable: /\w+/
            }
          }
        }
      },
      variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_(?:BINARY_DIR|DESCRIPTION|HOMEPAGE_URL|NAME|SOURCE_DIR|VERSION|VERSION_(?:MAJOR|MINOR|PATCH|TWEAK))|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE|XCODE_VERSION))\b/,
      property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|GLOBAL_KEYWORD|GLOBAL_PROJECT_TYPES|GLOBAL_ROOTNAMESPACE|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
      keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
      boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
      namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
      operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
      inserted: {
        pattern: /\b\w+::\w+\b/,
        alias: "class-name"
      },
      number: /\b\d+(?:\.\d+)*\b/,
      function: /\b[a-z_]\w*(?=\s*\()\b/i,
      punctuation: /[()>}]|\$[<{]/
    };
  }
  return Tc;
}
var Rc, OE;
function J8() {
  if (OE) return Rc;
  OE = 1, Rc = e, e.displayName = "cobol", e.aliases = [];
  function e(t) {
    t.languages.cobol = {
      comment: {
        pattern: /\*>.*|(^[ \t]*)\*.*/m,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
        greedy: !0
      },
      level: {
        pattern: /(^[ \t]*)\d+\b/m,
        lookbehind: !0,
        greedy: !0,
        alias: "number"
      },
      "class-name": {
        // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
        pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
        lookbehind: !0,
        inside: {
          number: {
            pattern: /(\()\d+/,
            lookbehind: !0
          },
          punctuation: /[()]/
        }
      },
      keyword: {
        pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
        lookbehind: !0
      },
      number: {
        pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
        lookbehind: !0
      },
      operator: [
        /<>|[<>]=?|[=+*/&]/,
        {
          pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
          lookbehind: !0
        }
      ],
      punctuation: /[.:,()]/
    };
  }
  return Rc;
}
var Ac, DE;
function eY() {
  if (DE) return Ac;
  DE = 1, Ac = e, e.displayName = "coffeescript", e.aliases = ["coffee"];
  function e(t) {
    (function(n) {
      var r = /#(?!\{).+/, a = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
      };
      n.languages.coffeescript = n.languages.extend("javascript", {
        comment: r,
        string: [
          // Strings are multiline
          {
            pattern: /'(?:\\[\s\S]|[^\\'])*'/,
            greedy: !0
          },
          {
            // Strings are multiline
            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
            greedy: !0,
            inside: {
              interpolation: a
            }
          }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
          pattern: /@(?!\d)\w+/,
          alias: "variable"
        }
      }), n.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
          pattern: /###[\s\S]+?###/,
          alias: "comment"
        },
        // Block regexp can contain comments and interpolation
        "block-regex": {
          pattern: /\/{3}[\s\S]*?\/{3}/,
          alias: "regex",
          inside: {
            comment: r,
            interpolation: a
          }
        }
      }), n.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
          pattern: /`(?:\\[\s\S]|[^\\`])*`/,
          inside: {
            delimiter: {
              pattern: /^`|`$/,
              alias: "punctuation"
            },
            script: {
              pattern: /[\s\S]+/,
              alias: "language-javascript",
              inside: n.languages.javascript
            }
          }
        },
        // Block strings
        "multiline-string": [
          {
            pattern: /'''[\s\S]*?'''/,
            greedy: !0,
            alias: "string"
          },
          {
            pattern: /"""[\s\S]*?"""/,
            greedy: !0,
            alias: "string",
            inside: {
              interpolation: a
            }
          }
        ]
      }), n.languages.insertBefore("coffeescript", "keyword", {
        // Object property
        property: /(?!\d)\w+(?=\s*:(?!:))/
      }), delete n.languages.coffeescript["template-string"], n.languages.coffee = n.languages.coffeescript;
    })(t);
  }
  return Ac;
}
var xc, LE;
function tY() {
  if (LE) return xc;
  LE = 1, xc = e, e.displayName = "concurnas", e.aliases = ["conc"];
  function e(t) {
    t.languages.concurnas = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
        lookbehind: !0,
        greedy: !0
      },
      langext: {
        pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
        greedy: !0,
        inside: {
          "class-name": /^\w+/,
          string: {
            pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
            lookbehind: !0
          },
          punctuation: /\|\|/
        }
      },
      function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
        lookbehind: !0
      },
      keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
      punctuation: /[{}[\];(),.:]/,
      operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
      annotation: {
        pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
        alias: "builtin"
      }
    }, t.languages.insertBefore("concurnas", "langext", {
      "regex-literal": {
        pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: t.languages.concurnas
          },
          regex: /[\s\S]+/
        }
      },
      "string-literal": {
        pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: t.languages.concurnas
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.conc = t.languages.concurnas;
  }
  return xc;
}
var Cc, ME;
function nY() {
  if (ME) return Cc;
  ME = 1, Cc = e, e.displayName = "coq", e.aliases = [];
  function e(t) {
    (function(n) {
      for (var r = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source, a = 0; a < 2; a++)
        r = r.replace(/<self>/g, function() {
          return r;
        });
      r = r.replace(/<self>/g, "[]"), n.languages.coq = {
        comment: RegExp(r),
        string: {
          pattern: /"(?:[^"]|"")*"(?!")/,
          greedy: !0
        },
        attribute: [
          {
            pattern: RegExp(
              /#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(
                /<comment>/g,
                function() {
                  return r;
                }
              )
            ),
            greedy: !0,
            alias: "attr-name",
            inside: {
              comment: RegExp(r),
              string: {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: !0
              },
              operator: /=/,
              punctuation: /^#\[|\]$|[,()]/
            }
          },
          {
            pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
            alias: "attr-name"
          }
        ],
        keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
        number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
        punct: {
          pattern: /@\{|\{\||\[=|:>/,
          alias: "punctuation"
        },
        operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
        punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
      };
    })(t);
  }
  return Cc;
}
var Nc, PE;
function $s() {
  if (PE) return Nc;
  PE = 1, Nc = e, e.displayName = "ruby", e.aliases = ["rb"];
  function e(t) {
    (function(n) {
      n.languages.ruby = n.languages.extend("clike", {
        comment: {
          pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
          greedy: !0
        },
        "class-name": {
          pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
          lookbehind: !0,
          inside: {
            punctuation: /[.\\]/
          }
        },
        keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
        operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
        punctuation: /[(){}[\].,;]/
      }), n.languages.insertBefore("ruby", "operator", {
        "double-colon": {
          pattern: /::/,
          alias: "punctuation"
        }
      });
      var r = {
        pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
        lookbehind: !0,
        inside: {
          content: {
            pattern: /^(#\{)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            inside: n.languages.ruby
          },
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: "punctuation"
          }
        }
      };
      delete n.languages.ruby.function;
      var a = "(?:" + [
        /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
        /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
        /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
        /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
        /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
      ].join("|") + ")", i = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
      n.languages.insertBefore("ruby", "keyword", {
        "regex-literal": [
          {
            pattern: RegExp(
              /%r/.source + a + /[egimnosux]{0,6}/.source
            ),
            greedy: !0,
            inside: {
              interpolation: r,
              regex: /[\s\S]+/
            }
          },
          {
            pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              interpolation: r,
              regex: /[\s\S]+/
            }
          }
        ],
        variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
        symbol: [
          {
            pattern: RegExp(/(^|[^:]):/.source + i),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: RegExp(
              /([\r\n{(,][ \t]*)/.source + i + /(?=:(?!:))/.source
            ),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "method-definition": {
          pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
          lookbehind: !0,
          inside: {
            function: /\b\w+$/,
            keyword: /^self\b/,
            "class-name": /^\w+/,
            punctuation: /\./
          }
        }
      }), n.languages.insertBefore("ruby", "string", {
        "string-literal": [
          {
            pattern: RegExp(/%[qQiIwWs]?/.source + a),
            greedy: !0,
            inside: {
              interpolation: r,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
            greedy: !0,
            inside: {
              interpolation: r,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
            alias: "heredoc-string",
            greedy: !0,
            inside: {
              delimiter: {
                pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                inside: {
                  symbol: /\b\w+/,
                  punctuation: /^<<[-~]?/
                }
              },
              interpolation: r,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
            alias: "heredoc-string",
            greedy: !0,
            inside: {
              delimiter: {
                pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                inside: {
                  symbol: /\b\w+/,
                  punctuation: /^<<[-~]?'|'$/
                }
              },
              string: /[\s\S]+/
            }
          }
        ],
        "command-literal": [
          {
            pattern: RegExp(/%x/.source + a),
            greedy: !0,
            inside: {
              interpolation: r,
              command: {
                pattern: /[\s\S]+/,
                alias: "string"
              }
            }
          },
          {
            pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
            greedy: !0,
            inside: {
              interpolation: r,
              command: {
                pattern: /[\s\S]+/,
                alias: "string"
              }
            }
          }
        ]
      }), delete n.languages.ruby.string, n.languages.insertBefore("ruby", "number", {
        builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
        constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
      }), n.languages.rb = n.languages.ruby;
    })(t);
  }
  return Nc;
}
var Ic, FE;
function rY() {
  if (FE) return Ic;
  FE = 1;
  var e = $s();
  Ic = t, t.displayName = "crystal", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.crystal = r.languages.extend("ruby", {
        keyword: [
          /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
          {
            pattern: /(\.\s*)(?:is_a|responds_to)\?/,
            lookbehind: !0
          }
        ],
        number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
        operator: [/->/, r.languages.ruby.operator],
        punctuation: /[(){}[\].,;\\]/
      }), r.languages.insertBefore("crystal", "string-literal", {
        attribute: {
          pattern: /@\[.*?\]/,
          inside: {
            delimiter: {
              pattern: /^@\[|\]$/,
              alias: "punctuation"
            },
            attribute: {
              pattern: /^(\s*)\w+/,
              lookbehind: !0,
              alias: "class-name"
            },
            args: {
              pattern: /\S(?:[\s\S]*\S)?/,
              inside: r.languages.crystal
            }
          }
        },
        expansion: {
          pattern: /\{(?:\{.*?\}|%.*?%)\}/,
          inside: {
            content: {
              pattern: /^(\{.)[\s\S]+(?=.\}$)/,
              lookbehind: !0,
              inside: r.languages.crystal
            },
            delimiter: {
              pattern: /^\{[\{%]|[\}%]\}$/,
              alias: "operator"
            }
          }
        },
        char: {
          pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
          greedy: !0
        }
      });
    }(n);
  }
  return Ic;
}
var kc, $E;
function aY() {
  if ($E) return kc;
  $E = 1;
  var e = Fs();
  kc = t, t.displayName = "cshtml", t.aliases = ["razor"];
  function t(n) {
    n.register(e), function(r) {
      var a = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source, i = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + "|" + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
      function o(m, v) {
        for (var y = 0; y < v; y++)
          m = m.replace(/<self>/g, function() {
            return "(?:" + m + ")";
          });
        return m.replace(/<self>/g, "[^\\s\\S]").replace(/<str>/g, "(?:" + i + ")").replace(/<comment>/g, "(?:" + a + ")");
      }
      var s = o(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2), l = o(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 2), c = o(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2), u = o(/<(?:[^<>'"@/]|<str>|<comment>|<self>)*>/.source, 2), d = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?/.source, f = /(?!\d)[^\s>\/=$<%]+/.source + d + /\s*\/?>/.source, g = /\B@?/.source + "(?:" + /<([a-zA-Z][\w:]*)/.source + d + /\s*>/.source + "(?:" + (/[^<]/.source + "|" + // all tags that are not the start tag
      // eslint-disable-next-line regexp/strict
      /<\/?(?!\1\b)/.source + f + "|" + // nested start tag
      o(
        // eslint-disable-next-line regexp/strict
        /<\1/.source + d + /\s*>/.source + "(?:" + (/[^<]/.source + "|" + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + f + "|<self>") + ")*" + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source,
        2
      )) + ")*" + // eslint-disable-next-line regexp/strict
      /<\/\1\s*>/.source + "|" + /</.source + f + ")";
      r.languages.cshtml = r.languages.extend("markup", {});
      var h = r.languages.insertBefore(
        "csharp",
        "string",
        {
          html: {
            pattern: RegExp(g),
            greedy: !0,
            inside: r.languages.cshtml
          }
        },
        {
          csharp: r.languages.extend("csharp", {})
        }
      ), p = {
        pattern: /\S[\s\S]*/,
        alias: "language-csharp",
        inside: h
      };
      r.languages.insertBefore("cshtml", "prolog", {
        "razor-comment": {
          pattern: /@\*[\s\S]*?\*@/,
          greedy: !0,
          alias: "comment"
        },
        block: {
          pattern: RegExp(
            /(^|[^@])@/.source + "(?:" + [
              // @{ ... }
              c,
              // @code{ ... }
              /(?:code|functions)\s*/.source + c,
              // @for (...) { ... }
              /(?:for|foreach|lock|switch|using|while)\s*/.source + s + /\s*/.source + c,
              // @do { ... } while (...);
              /do\s*/.source + c + /\s*while\s*/.source + s + /(?:\s*;)?/.source,
              // @try { ... } catch (...) { ... } finally { ... }
              /try\s*/.source + c + /\s*catch\s*/.source + s + /\s*/.source + c + /\s*finally\s*/.source + c,
              // @if (...) {...} else if (...) {...} else {...}
              /if\s*/.source + s + /\s*/.source + c + "(?:" + /\s*else/.source + "(?:" + /\s+if\s*/.source + s + ")?" + /\s*/.source + c + ")*"
            ].join("|") + ")"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^@\w*/,
            csharp: p
          }
        },
        directive: {
          pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^@\w+/,
            csharp: p
          }
        },
        value: {
          pattern: RegExp(
            /(^|[^@])@/.source + /(?:await\b\s*)?/.source + "(?:" + /\w+\b/.source + "|" + s + ")(?:" + /[?!]?\.\w+\b/.source + "|" + s + "|" + l + "|" + u + s + ")*"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "variable",
          inside: {
            keyword: /^@/,
            csharp: p
          }
        },
        "delegate-operator": {
          pattern: /(^|[^@])@(?=<)/,
          lookbehind: !0,
          alias: "operator"
        }
      }), r.languages.razor = r.languages.cshtml;
    }(n);
  }
  return kc;
}
var Oc, BE;
function iY() {
  if (BE) return Oc;
  BE = 1, Oc = e, e.displayName = "csp", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(a) {
        return RegExp(
          /([ \t])/.source + "(?:" + a + ")" + /(?=[\s;]|$)/.source,
          "i"
        );
      }
      n.languages.csp = {
        directive: {
          pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
          lookbehind: !0,
          alias: "property"
        },
        scheme: {
          pattern: r(/[a-z][a-z0-9.+-]*:/.source),
          lookbehind: !0
        },
        none: {
          pattern: r(/'none'/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        nonce: {
          pattern: r(/'nonce-[-+/\w=]+'/.source),
          lookbehind: !0,
          alias: "number"
        },
        hash: {
          pattern: r(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
          lookbehind: !0,
          alias: "number"
        },
        host: {
          pattern: r(
            /[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + "|" + /\*[^\s;,']*/.source + "|" + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source
          ),
          lookbehind: !0,
          alias: "url",
          inside: {
            important: /\*/
          }
        },
        keyword: [
          {
            pattern: r(/'unsafe-[a-z-]+'/.source),
            lookbehind: !0,
            alias: "unsafe"
          },
          {
            pattern: r(/'[a-z-]+'/.source),
            lookbehind: !0,
            alias: "safe"
          }
        ],
        punctuation: /;/
      };
    })(t);
  }
  return Oc;
}
var Dc, UE;
function oY() {
  if (UE) return Dc;
  UE = 1, Dc = e, e.displayName = "cssExtras", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, a;
      n.languages.css.selector = {
        pattern: n.languages.css.selector.pattern,
        lookbehind: !0,
        inside: a = {
          "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
          "pseudo-class": /:[-\w]+/,
          class: /\.[-\w]+/,
          id: /#[-\w]+/,
          attribute: {
            pattern: RegExp(`\\[(?:[^[\\]"']|` + r.source + ")*\\]"),
            greedy: !0,
            inside: {
              punctuation: /^\[|\]$/,
              "case-sensitivity": {
                pattern: /(\s)[si]$/i,
                lookbehind: !0,
                alias: "keyword"
              },
              namespace: {
                pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                lookbehind: !0,
                inside: {
                  punctuation: /\|$/
                }
              },
              "attr-name": {
                pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                lookbehind: !0
              },
              "attr-value": [
                r,
                {
                  pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                  lookbehind: !0
                }
              ],
              operator: /[|~*^$]?=/
            }
          },
          "n-th": [
            {
              pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
              lookbehind: !0,
              inside: {
                number: /[\dn]+/,
                operator: /[+-]/
              }
            },
            {
              pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
              lookbehind: !0
            }
          ],
          combinator: />|\+|~|\|\|/,
          // the `tag` token has been existed and removed.
          // because we can't find a perfect tokenize to match it.
          // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
          punctuation: /[(),]/
        }
      }, n.languages.css.atrule.inside["selector-function-argument"].inside = a, n.languages.insertBefore("css", "property", {
        variable: {
          pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
          lookbehind: !0
        }
      });
      var i = {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: !0
      }, o = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: !0
      };
      n.languages.insertBefore("css", "function", {
        operator: {
          pattern: /(\s)[+\-*\/](?=\s)/,
          lookbehind: !0
        },
        // CAREFUL!
        // Previewers and Inline color use hexcode and color.
        hexcode: {
          pattern: /\B#[\da-f]{3,8}\b/i,
          alias: "color"
        },
        color: [
          {
            pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
            lookbehind: !0
          },
          {
            pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
            inside: {
              unit: i,
              number: o,
              function: /[\w-]+(?=\()/,
              punctuation: /[(),]/
            }
          }
        ],
        // it's important that there is no boundary assertion after the hex digits
        entity: /\\[\da-f]{1,8}/i,
        unit: i,
        number: o
      });
    })(t);
  }
  return Dc;
}
var Lc, GE;
function sY() {
  if (GE) return Lc;
  GE = 1, Lc = e, e.displayName = "csv", e.aliases = [];
  function e(t) {
    t.languages.csv = {
      value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
      punctuation: /,/
    };
  }
  return Lc;
}
var Mc, HE;
function lY() {
  if (HE) return Mc;
  HE = 1, Mc = e, e.displayName = "cypher", e.aliases = [];
  function e(t) {
    t.languages.cypher = {
      // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
      comment: /\/\/.*/,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
        greedy: !0
      },
      "class-name": {
        pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
        lookbehind: !0,
        greedy: !0
      },
      relationship: {
        pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      identifier: {
        pattern: /`(?:[^`\\\r\n])*`/,
        greedy: !0
      },
      variable: /\$\w+/,
      // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
      keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
      function: /\b\w+\b(?=\s*\()/,
      boolean: /\b(?:false|null|true)\b/i,
      number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
      // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
      operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
      punctuation: /[()[\]{},;.]/
    };
  }
  return Mc;
}
var Pc, zE;
function cY() {
  if (zE) return Pc;
  zE = 1, Pc = e, e.displayName = "d", e.aliases = [];
  function e(t) {
    t.languages.d = t.languages.extend("clike", {
      comment: [
        {
          // Shebang
          pattern: /^\s*#!.+/,
          greedy: !0
        },
        {
          pattern: RegExp(
            /(^|[^\\])/.source + "(?:" + [
              // /+ comment +/
              // Allow one level of nesting
              /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
              // // comment
              /\/\/.*/.source,
              // /* comment */
              /\/\*[\s\S]*?\*\//.source
            ].join("|") + ")"
          ),
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: [
        {
          pattern: RegExp(
            [
              // r"", x""
              /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
              // q"[]", q"()", q"<>", q"{}"
              /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
              // q"IDENT
              // ...
              // IDENT"
              /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
              // q"//", q"||", etc.
              // eslint-disable-next-line regexp/strict
              /\bq"(.)[\s\S]*?\2"/.source,
              // eslint-disable-next-line regexp/strict
              /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
            ].join("|"),
            "m"
          ),
          greedy: !0
        },
        {
          pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
          greedy: !0,
          alias: "token-string"
        }
      ],
      // In order: $, keywords and special tokens, globally defined symbols
      keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
      number: [
        // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
        // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
        /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
        {
          pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
          lookbehind: !0
        }
      ],
      operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
    }), t.languages.insertBefore("d", "string", {
      // Characters
      // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
      char: /'(?:\\(?:\W|\w+)|[^\\])'/
    }), t.languages.insertBefore("d", "keyword", {
      property: /\B@\w*/
    }), t.languages.insertBefore("d", "function", {
      register: {
        // Iasm registers
        pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
        alias: "variable"
      }
    });
  }
  return Pc;
}
var Fc, WE;
function uY() {
  if (WE) return Fc;
  WE = 1, Fc = e, e.displayName = "dart", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = [
        /\b(?:async|sync|yield)\*/,
        /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
      ], a = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, i = {
        pattern: RegExp(a + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: !0,
        inside: {
          namespace: {
            pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
            inside: {
              punctuation: /\./
            }
          }
        }
      };
      n.languages.dart = n.languages.extend("clike", {
        "class-name": [
          i,
          {
            // variables and parameters
            // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
            pattern: RegExp(
              a + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source
            ),
            lookbehind: !0,
            inside: i.inside
          }
        ],
        keyword: r,
        operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
      }), n.languages.insertBefore("dart", "string", {
        "string-literal": {
          pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
              lookbehind: !0,
              inside: {
                punctuation: /^\$\{?|\}$/,
                expression: {
                  pattern: /[\s\S]+/,
                  inside: n.languages.dart
                }
              }
            },
            string: /[\s\S]+/
          }
        },
        string: void 0
      }), n.languages.insertBefore("dart", "class-name", {
        metadata: {
          pattern: /@\w+/,
          alias: "function"
        }
      }), n.languages.insertBefore("dart", "class-name", {
        generics: {
          pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
          inside: {
            "class-name": i,
            keyword: r,
            punctuation: /[<>(),.:]/,
            operator: /[?&|]/
          }
        }
      });
    })(t);
  }
  return Fc;
}
var $c, qE;
function dY() {
  if (qE) return $c;
  qE = 1, $c = e, e.displayName = "dataweave", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.dataweave = {
        url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
        property: {
          pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
          greedy: !0
        },
        string: {
          pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
          greedy: !0
        },
        "mime-type": /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
        date: {
          pattern: /\|[\w:+-]+\|/,
          greedy: !0
        },
        comment: [
          {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        regex: {
          pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
          greedy: !0
        },
        keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
        function: /\b[A-Z_]\w*(?=\s*\()/i,
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\];(),.:@]/,
        operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
        boolean: /\b(?:false|true)\b/
      };
    })(t);
  }
  return $c;
}
var Bc, VE;
function fY() {
  if (VE) return Bc;
  VE = 1, Bc = e, e.displayName = "dax", e.aliases = [];
  function e(t) {
    t.languages.dax = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
        lookbehind: !0
      },
      "data-field": {
        pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
        alias: "symbol"
      },
      measure: {
        pattern: /\[[ \w\xA0-\uFFFF]+\]/,
        alias: "constant"
      },
      string: {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
      keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
      boolean: {
        pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
        alias: "constant"
      },
      number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
      operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
      punctuation: /[;\[\](){}`,.]/
    };
  }
  return Bc;
}
var Uc, jE;
function pY() {
  if (jE) return Uc;
  jE = 1, Uc = e, e.displayName = "dhall", e.aliases = [];
  function e(t) {
    t.languages.dhall = {
      // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
      // The multi-line pattern is essentially this:
      //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
      comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
      string: {
        pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{[^{}]*\}/,
            inside: {
              expression: {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0,
                alias: "language-dhall",
                inside: null
                // see blow
              },
              punctuation: /\$\{|\}/
            }
          }
        }
      },
      label: {
        pattern: /`[^`]*`/,
        greedy: !0
      },
      url: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
        pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
        greedy: !0
      },
      env: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
        pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
        greedy: !0,
        inside: {
          function: /^env/,
          operator: /^:/,
          variable: /[\s\S]+/
        }
      },
      hash: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
        pattern: /\bsha256:[\da-fA-F]{64}\b/,
        inside: {
          function: /sha256/,
          operator: /:/,
          number: /[\da-fA-F]{64}/
        }
      },
      // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
      keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
      builtin: /\b(?:None|Some)\b/,
      boolean: /\b(?:False|True)\b/,
      number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
      operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
      punctuation: /\.\.|[{}\[\](),./]/,
      // we'll just assume that every capital word left is a type name
      "class-name": /\b[A-Z]\w*\b/
    }, t.languages.dhall.string.inside.interpolation.inside.expression.inside = t.languages.dhall;
  }
  return Uc;
}
var Gc, YE;
function gY() {
  if (YE) return Gc;
  YE = 1, Gc = e, e.displayName = "diff", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.diff = {
        coord: [
          // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
          /^(?:\*{3}|-{3}|\+{3}).*$/m,
          // Match "@@ ... @@" coord lines in unified diff.
          /^@@.*@@$/m,
          // Match coord lines in normal diff (starts with a number).
          /^\d.*$/m
        ]
        // deleted, inserted, unchanged, diff
      };
      var r = {
        "deleted-sign": "-",
        "deleted-arrow": "<",
        "inserted-sign": "+",
        "inserted-arrow": ">",
        unchanged: " ",
        diff: "!"
      };
      Object.keys(r).forEach(function(a) {
        var i = r[a], o = [];
        /^\w+$/.test(a) || o.push(/\w+/.exec(a)[0]), a === "diff" && o.push("bold"), n.languages.diff[a] = {
          pattern: RegExp(
            "^(?:[" + i + `].*(?:\r
?|
|(?![\\s\\S])))+`,
            "m"
          ),
          alias: o,
          inside: {
            line: {
              pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
              lookbehind: !0
            },
            prefix: {
              pattern: /[\s\S]/,
              alias: /\w+/.exec(a)[0]
            }
          }
        };
      }), Object.defineProperty(n.languages.diff, "PREFIXES", {
        value: r
      });
    })(t);
  }
  return Gc;
}
var Hc, KE;
function yt() {
  if (KE) return Hc;
  KE = 1, Hc = e, e.displayName = "markupTemplating", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(a, i) {
        return "___" + a.toUpperCase() + i + "___";
      }
      Object.defineProperties(n.languages["markup-templating"] = {}, {
        buildPlaceholders: {
          /**
           * Tokenize all inline templating expressions matching `placeholderPattern`.
           *
           * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
           * `true` will be replaced.
           *
           * @param {object} env The environment of the `before-tokenize` hook.
           * @param {string} language The language id.
           * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
           * @param {(match: string) => boolean} [replaceFilter]
           */
          value: function(a, i, o, s) {
            if (a.language === i) {
              var l = a.tokenStack = [];
              a.code = a.code.replace(o, function(c) {
                if (typeof s == "function" && !s(c))
                  return c;
                for (var u = l.length, d; a.code.indexOf(d = r(i, u)) !== -1; )
                  ++u;
                return l[u] = c, d;
              }), a.grammar = n.languages.markup;
            }
          }
        },
        tokenizePlaceholders: {
          /**
           * Replace placeholders with proper tokens after tokenizing.
           *
           * @param {object} env The environment of the `after-tokenize` hook.
           * @param {string} language The language id.
           */
          value: function(a, i) {
            if (a.language !== i || !a.tokenStack)
              return;
            a.grammar = n.languages[i];
            var o = 0, s = Object.keys(a.tokenStack);
            function l(c) {
              for (var u = 0; u < c.length && !(o >= s.length); u++) {
                var d = c[u];
                if (typeof d == "string" || d.content && typeof d.content == "string") {
                  var f = s[o], g = a.tokenStack[f], h = typeof d == "string" ? d : d.content, p = r(i, f), m = h.indexOf(p);
                  if (m > -1) {
                    ++o;
                    var v = h.substring(0, m), y = new n.Token(
                      i,
                      n.tokenize(g, a.grammar),
                      "language-" + i,
                      g
                    ), E = h.substring(m + p.length), S = [];
                    v && S.push.apply(S, l([v])), S.push(y), E && S.push.apply(S, l([E])), typeof d == "string" ? c.splice.apply(c, [u, 1].concat(S)) : d.content = S;
                  }
                } else d.content && l(d.content);
              }
              return c;
            }
            l(a.tokens);
          }
        }
      });
    })(t);
  }
  return Hc;
}
var zc, XE;
function hY() {
  if (XE) return zc;
  XE = 1;
  var e = yt();
  zc = t, t.displayName = "django", t.aliases = ["jinja2"];
  function t(n) {
    n.register(e), function(r) {
      r.languages.django = {
        comment: /^\{#[\s\S]*?#\}$/,
        tag: {
          pattern: /(^\{%[+-]?\s*)\w+/,
          lookbehind: !0,
          alias: "keyword"
        },
        delimiter: {
          pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
          alias: "punctuation"
        },
        string: {
          pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        },
        filter: {
          pattern: /(\|)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        test: {
          pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        function: /\b[a-z_]\w+(?=\s*\()/i,
        keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
        operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        number: /\b\d+(?:\.\d+)?\b/,
        boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
        variable: /\b\w+\b/,
        punctuation: /[{}[\](),.:;]/
      };
      var a = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g, i = r.languages["markup-templating"];
      r.hooks.add("before-tokenize", function(o) {
        i.buildPlaceholders(o, "django", a);
      }), r.hooks.add("after-tokenize", function(o) {
        i.tokenizePlaceholders(o, "django");
      }), r.languages.jinja2 = r.languages.django, r.hooks.add("before-tokenize", function(o) {
        i.buildPlaceholders(o, "jinja2", a);
      }), r.hooks.add("after-tokenize", function(o) {
        i.tokenizePlaceholders(o, "jinja2");
      });
    }(n);
  }
  return zc;
}
var Wc, ZE;
function mY() {
  if (ZE) return Wc;
  ZE = 1, Wc = e, e.displayName = "dnsZoneFile", e.aliases = [];
  function e(t) {
    t.languages["dns-zone-file"] = {
      comment: /;.*/,
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0
      },
      variable: [
        {
          pattern: /(^\$ORIGIN[ \t]+)\S+/m,
          lookbehind: !0
        },
        {
          pattern: /(^|\s)@(?=\s|$)/,
          lookbehind: !0
        }
      ],
      keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
      class: {
        // https://tools.ietf.org/html/rfc1035#page-13
        pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      type: {
        // https://en.wikipedia.org/wiki/List_of_DNS_record_types
        pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      punctuation: /[()]/
    }, t.languages["dns-zone"] = t.languages["dns-zone-file"];
  }
  return Wc;
}
var qc, QE;
function bY() {
  if (QE) return qc;
  QE = 1, qc = e, e.displayName = "docker", e.aliases = ["dockerfile"];
  function e(t) {
    (function(n) {
      var r = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source, a = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(
        /<SP_BS>/g,
        function() {
          return r;
        }
      ), i = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source, o = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(
        /<STR>/g,
        function() {
          return i;
        }
      ), s = {
        pattern: RegExp(i),
        greedy: !0
      }, l = {
        pattern: /(^[ \t]*)#.*/m,
        lookbehind: !0,
        greedy: !0
      };
      function c(u, d) {
        return u = u.replace(/<OPT>/g, function() {
          return o;
        }).replace(/<SP>/g, function() {
          return a;
        }), RegExp(u, d);
      }
      n.languages.docker = {
        instruction: {
          pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
          lookbehind: !0,
          greedy: !0,
          inside: {
            options: {
              pattern: c(
                /(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source,
                "i"
              ),
              lookbehind: !0,
              greedy: !0,
              inside: {
                property: {
                  pattern: /(^|\s)--[\w-]+/,
                  lookbehind: !0
                },
                string: [
                  s,
                  {
                    pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                    lookbehind: !0
                  }
                ],
                operator: /\\$/m,
                punctuation: /=/
              }
            },
            keyword: [
              {
                // https://docs.docker.com/engine/reference/builder/#healthcheck
                pattern: c(
                  /(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source,
                  "i"
                ),
                lookbehind: !0,
                greedy: !0
              },
              {
                // https://docs.docker.com/engine/reference/builder/#from
                pattern: c(
                  /(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source,
                  "i"
                ),
                lookbehind: !0,
                greedy: !0
              },
              {
                // https://docs.docker.com/engine/reference/builder/#onbuild
                pattern: c(/(^ONBUILD<SP>)\w+/.source, "i"),
                lookbehind: !0,
                greedy: !0
              },
              {
                pattern: /^\w+/,
                greedy: !0
              }
            ],
            comment: l,
            string: s,
            variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
            operator: /\\$/m
          }
        },
        comment: l
      }, n.languages.dockerfile = n.languages.docker;
    })(t);
  }
  return qc;
}
var Vc, JE;
function vY() {
  if (JE) return Vc;
  JE = 1, Vc = e, e.displayName = "dot", e.aliases = ["gv"];
  function e(t) {
    (function(n) {
      var r = "(?:" + [
        // an identifier
        /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
        // a number
        /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
        // a double-quoted string
        /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
        // HTML-like string
        /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
      ].join("|") + ")", a = {
        markup: {
          pattern: /(^<)[\s\S]+(?=>$)/,
          lookbehind: !0,
          alias: ["language-markup", "language-html", "language-xml"],
          inside: n.languages.markup
        }
      };
      function i(o, s) {
        return RegExp(
          o.replace(/<ID>/g, function() {
            return r;
          }),
          s
        );
      }
      n.languages.dot = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
          greedy: !0
        },
        "graph-name": {
          pattern: i(
            /(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source,
            "i"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "class-name",
          inside: a
        },
        "attr-value": {
          pattern: i(/(=[ \t\r\n]*)<ID>/.source),
          lookbehind: !0,
          greedy: !0,
          inside: a
        },
        "attr-name": {
          pattern: i(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
          lookbehind: !0,
          greedy: !0,
          inside: a
        },
        keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
        "compass-point": {
          pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
          lookbehind: !0,
          alias: "builtin"
        },
        node: {
          pattern: i(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
          lookbehind: !0,
          greedy: !0,
          inside: a
        },
        operator: /[=:]|-[->]/,
        punctuation: /[\[\]{};,]/
      }, n.languages.gv = n.languages.dot;
    })(t);
  }
  return Vc;
}
var jc, eS;
function yY() {
  if (eS) return jc;
  eS = 1, jc = e, e.displayName = "ebnf", e.aliases = [];
  function e(t) {
    t.languages.ebnf = {
      comment: /\(\*[\s\S]*?\*\)/,
      string: {
        pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
        greedy: !0
      },
      special: {
        pattern: /\?[^?\r\n]*\?/,
        greedy: !0,
        alias: "class-name"
      },
      definition: {
        pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
        lookbehind: !0,
        alias: ["rule", "keyword"]
      },
      rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
      punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
      operator: /[-=|*/!]/
    };
  }
  return jc;
}
var Yc, tS;
function EY() {
  if (tS) return Yc;
  tS = 1, Yc = e, e.displayName = "editorconfig", e.aliases = [];
  function e(t) {
    t.languages.editorconfig = {
      // https://editorconfig-specification.readthedocs.io
      comment: /[;#].*/,
      section: {
        pattern: /(^[ \t]*)\[.+\]/m,
        lookbehind: !0,
        alias: "selector",
        inside: {
          regex: /\\\\[\[\]{},!?.*]/,
          // Escape special characters with '\\'
          operator: /[!?]|\.\.|\*{1,2}/,
          punctuation: /[\[\]{},]/
        }
      },
      key: {
        pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      value: {
        pattern: /=.*/,
        alias: "attr-value",
        inside: {
          punctuation: /^=/
        }
      }
    };
  }
  return Yc;
}
var Kc, nS;
function SY() {
  if (nS) return Kc;
  nS = 1, Kc = e, e.displayName = "eiffel", e.aliases = [];
  function e(t) {
    t.languages.eiffel = {
      comment: /--.*/,
      string: [
        // Aligned-verbatim-strings
        {
          pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
          greedy: !0
        },
        // Non-aligned-verbatim-strings
        {
          pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
          greedy: !0
        },
        // Single-line string
        {
          pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
          greedy: !0
        }
      ],
      // normal char | special char | char code
      char: /'(?:%.|[^%'\r\n])+'/,
      keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
      boolean: /\b(?:False|True)\b/i,
      // Convention: class-names are always all upper-case characters
      "class-name": /\b[A-Z][\dA-Z_]*\b/,
      number: [
        // hexa | octal | bin
        /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
        // Decimal
        /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
      ],
      punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
      operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
    };
  }
  return Kc;
}
var Xc, rS;
function wY() {
  if (rS) return Xc;
  rS = 1;
  var e = yt();
  Xc = t, t.displayName = "ejs", t.aliases = ["eta"];
  function t(n) {
    n.register(e), function(r) {
      r.languages.ejs = {
        delimiter: {
          pattern: /^<%[-_=]?|[-_]?%>$/,
          alias: "punctuation"
        },
        comment: /^#[\s\S]*/,
        "language-javascript": {
          pattern: /[\s\S]+/,
          inside: r.languages.javascript
        }
      }, r.hooks.add("before-tokenize", function(a) {
        var i = /<%(?!%)[\s\S]+?%>/g;
        r.languages["markup-templating"].buildPlaceholders(
          a,
          "ejs",
          i
        );
      }), r.hooks.add("after-tokenize", function(a) {
        r.languages["markup-templating"].tokenizePlaceholders(a, "ejs");
      }), r.languages.eta = r.languages.ejs;
    }(n);
  }
  return Xc;
}
var Zc, aS;
function _Y() {
  if (aS) return Zc;
  aS = 1, Zc = e, e.displayName = "elixir", e.aliases = [];
  function e(t) {
    t.languages.elixir = {
      doc: {
        pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
        inside: {
          attribute: /^@\w+/,
          string: /['"][\s\S]+/
        }
      },
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
      regex: {
        pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
        greedy: !0
      },
      string: [
        {
          // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
          pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        },
        {
          pattern: /("""|''')[\s\S]*?\1/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        },
        {
          // Multi-line strings are allowed
          pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        }
      ],
      atom: {
        // Look-behind prevents bad highlighting of the :: operator
        pattern: /(^|[^:]):\w+/,
        lookbehind: !0,
        alias: "symbol"
      },
      module: {
        pattern: /\b[A-Z]\w*\b/,
        alias: "class-name"
      },
      // Look-ahead prevents bad highlighting of the :: operator
      "attr-name": /\b\w+\??:(?!:)/,
      argument: {
        // Look-behind prevents bad highlighting of the && operator
        pattern: /(^|[^&])&\d+/,
        lookbehind: !0,
        alias: "variable"
      },
      attribute: {
        pattern: /@\w+/,
        alias: "variable"
      },
      function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
      number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
      keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
      boolean: /\b(?:false|nil|true)\b/,
      operator: [
        /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
        {
          // We don't want to match <<
          pattern: /([^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /([^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      punctuation: /<<|>>|[.,%\[\]{}()]/
    }, t.languages.elixir.string.forEach(function(n) {
      n.inside = {
        interpolation: {
          pattern: /#\{[^}]+\}/,
          inside: {
            delimiter: {
              pattern: /^#\{|\}$/,
              alias: "punctuation"
            },
            rest: t.languages.elixir
          }
        }
      };
    });
  }
  return Zc;
}
var Qc, iS;
function TY() {
  if (iS) return Qc;
  iS = 1, Qc = e, e.displayName = "elm", e.aliases = [];
  function e(t) {
    t.languages.elm = {
      comment: /--.*|\{-[\s\S]*?-\}/,
      char: {
        pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
        greedy: !0
      },
      string: [
        {
          // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
          pattern: /"""[\s\S]*?"""/,
          greedy: !0
        },
        {
          pattern: /"(?:[^\\"\r\n]|\\.)*"/,
          greedy: !0
        }
      ],
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|exposing|import)\b/
        }
      },
      keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
      // These are builtin variables only. Constructors are highlighted later as a constant.
      builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
      // decimal integers and floating point numbers | hexadecimal integers
      number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
      // Most of this is needed because of the meaning of a single '.'.
      // If it stands alone freely, it is the function composition.
      // It may also be a separator between a module name and an identifier => no
      // operator. If it comes together with other special characters it is an
      // operator too.
      // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
      // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
      operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
      // In Elm, nearly everything is a variable, do not highlight these.
      hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
      constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
      punctuation: /[{}[\]|(),.:]/
    };
  }
  return Qc;
}
var Jc, oS;
function RY() {
  if (oS) return Jc;
  oS = 1;
  var e = $s(), t = yt();
  Jc = n, n.displayName = "erb", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      a.languages.erb = {
        delimiter: {
          pattern: /^(\s*)<%=?|%>(?=\s*$)/,
          lookbehind: !0,
          alias: "punctuation"
        },
        ruby: {
          pattern: /\s*\S[\s\S]*/,
          alias: "language-ruby",
          inside: a.languages.ruby
        }
      }, a.hooks.add("before-tokenize", function(i) {
        var o = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
        a.languages["markup-templating"].buildPlaceholders(
          i,
          "erb",
          o
        );
      }), a.hooks.add("after-tokenize", function(i) {
        a.languages["markup-templating"].tokenizePlaceholders(i, "erb");
      });
    }(r);
  }
  return Jc;
}
var eu, sS;
function AY() {
  if (sS) return eu;
  sS = 1, eu = e, e.displayName = "erlang", e.aliases = [];
  function e(t) {
    t.languages.erlang = {
      comment: /%.+/,
      string: {
        pattern: /"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      "quoted-function": {
        pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
        alias: "function"
      },
      "quoted-atom": {
        pattern: /'(?:\\.|[^\\'\r\n])+'/,
        alias: "atom"
      },
      boolean: /\b(?:false|true)\b/,
      keyword: /\b(?:after|case|catch|end|fun|if|of|receive|try|when)\b/,
      number: [
        /\$\\?./,
        /\b\d+#[a-z0-9]+/i,
        /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
      ],
      function: /\b[a-z][\w@]*(?=\()/,
      variable: {
        // Look-behind is used to prevent wrong highlighting of atoms containing "@"
        pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
        lookbehind: !0
      },
      operator: [
        /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
        {
          // We don't want to match <<
          pattern: /(^|[^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /(^|[^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      atom: /\b[a-z][\w@]*/,
      punctuation: /[()[\]{}:;,.#|]|<<|>>/
    };
  }
  return eu;
}
var tu, lS;
function Ok() {
  if (lS) return tu;
  lS = 1, tu = e, e.displayName = "lua", e.aliases = [];
  function e(t) {
    t.languages.lua = {
      comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
      // \z may be used to skip the following space
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
        greedy: !0
      },
      number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
      keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
      function: /(?!\d)\w+(?=\s*(?:[({]))/,
      operator: [
        /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
        {
          // Match ".." but don't break "..."
          pattern: /(^|[^.])\.\.(?!\.)/,
          lookbehind: !0
        }
      ],
      punctuation: /[\[\](){},;]|\.+|:+/
    };
  }
  return tu;
}
var nu, cS;
function xY() {
  if (cS) return nu;
  cS = 1;
  var e = Ok(), t = yt();
  nu = n, n.displayName = "etlua", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      a.languages.etlua = {
        delimiter: {
          pattern: /^<%[-=]?|-?%>$/,
          alias: "punctuation"
        },
        "language-lua": {
          pattern: /[\s\S]+/,
          inside: a.languages.lua
        }
      }, a.hooks.add("before-tokenize", function(i) {
        var o = /<%[\s\S]+?%>/g;
        a.languages["markup-templating"].buildPlaceholders(
          i,
          "etlua",
          o
        );
      }), a.hooks.add("after-tokenize", function(i) {
        a.languages["markup-templating"].tokenizePlaceholders(i, "etlua");
      });
    }(r);
  }
  return nu;
}
var ru, uS;
function CY() {
  if (uS) return ru;
  uS = 1, ru = e, e.displayName = "excelFormula", e.aliases = [];
  function e(t) {
    t.languages["excel-formula"] = {
      comment: {
        pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      reference: {
        // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
        // Sales!B2
        // 'Winter sales'!B2
        // [Sales.xlsx]Jan!B2:B5
        // D:\Reports\[Sales.xlsx]Jan!B2:B5
        // '[Sales.xlsx]Jan sales'!B2:B5
        // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
        pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
        greedy: !0,
        alias: "string",
        inside: {
          operator: /!$/,
          punctuation: /'/,
          sheet: {
            pattern: /[^[\]]+$/,
            alias: "function"
          },
          file: {
            pattern: /\[[^[\]]+\]$/,
            inside: {
              punctuation: /[[\]]/
            }
          },
          path: /[\s\S]+/
        }
      },
      "function-name": {
        pattern: /\b[A-Z]\w*(?=\()/i,
        alias: "keyword"
      },
      range: {
        pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
        alias: "property",
        inside: {
          operator: /:/,
          cell: /\$?[A-Z]+\$?\d+/i,
          column: /\$?[A-Z]+/i,
          row: /\$?\d+/
        }
      },
      cell: {
        // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
        // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
        pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
        alias: "property"
      },
      number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
      boolean: /\b(?:FALSE|TRUE)\b/i,
      operator: /[-+*/^%=&,]|<[=>]?|>=?/,
      punctuation: /[[\]();{}|]/
    }, t.languages.xlsx = t.languages.xls = t.languages["excel-formula"];
  }
  return ru;
}
var au, dS;
function NY() {
  if (dS) return au;
  dS = 1, au = e, e.displayName = "factor", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
      }, a = {
        number: /\\[^\s']|%\w/
      }, i = {
        comment: [
          {
            // ! single-line exclamation point comments with whitespace after/around the !
            pattern: /(^|\s)(?:! .*|!$)/,
            lookbehind: !0,
            inside: r
          },
          /* from basis/multiline: */
          {
            // /* comment */, /* comment*/
            pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            inside: r
          },
          {
            // ![[ comment ]] , ![===[ comment]===]
            pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            inside: r
          }
        ],
        number: [
          {
            // basic base 10 integers 9, -9
            pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
            pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
            lookbehind: !0
          },
          {
            // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
            pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
            lookbehind: !0
          },
          {
            // positive mixed numbers 23+1/5 +23+1/5
            pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // negative mixed numbers -23-1/5
            pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
            // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
            pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
            lookbehind: !0
          },
          {
            // NAN literal syntax NAN: 80000deadbeef, NAN: a
            pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
            lookbehind: !0
          },
          {
            /*
            base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
            "The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
            The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
            <https://docs.factorcode.org/content/article-syntax-floats.html>
            */
            pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
            lookbehind: !0
          }
        ],
        // R/ regexp?\/\\/
        regexp: {
          pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
          lookbehind: !0,
          alias: "number",
          inside: {
            variable: /\\\S/,
            keyword: /[+?*\[\]^$(){}.|]/,
            operator: {
              pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
              lookbehind: !0
            }
          }
        },
        boolean: {
          pattern: /(^|\s)[tf](?=\s|$)/,
          lookbehind: !0
        },
        // SBUF" asd", URL" ://...", P" /etc/"
        "custom-string": {
          pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
          lookbehind: !0,
          greedy: !0,
          alias: "string",
          inside: {
            number: /\\\S|%\w|\//
          }
        },
        "multiline-string": [
          {
            // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
            pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: {
              number: a.number,
              // trailing semicolon on its own line
              "semicolon-or-setlocal": {
                pattern: /([\r\n][ \t]*);(?=\s|$)/,
                lookbehind: !0,
                alias: "function"
              }
            }
          },
          {
            // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
            pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: a
          },
          {
            // [[ string ]], [==[ string]==]
            pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: a
          }
        ],
        "special-using": {
          pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
          lookbehind: !0,
          alias: "function",
          inside: {
            // this is essentially a regex for vocab names, which i don't want to specify
            // but the USING: gets picked up as a vocab name
            string: {
              pattern: /(\s)[^:\s]+/,
              lookbehind: !0
            }
          }
        },
        /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
        trying to do better is more work and regex-computation-time than it's worth though.
        - we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
        - we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
        - we'd like if the following variable name conventions were recognised specifically:
        special row variables = ..a b..
        type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
        word throws unconditional error = *
        any other word-like variable name = a ? q' etc
        https://docs.factorcode.org/content/article-effects.html
        these are pretty complicated to highlight properly without a real parser, and therefore out of scope
        the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
        */
        // current solution is not great
        "stack-effect-delimiter": [
          {
            // opening parenthesis
            pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // middle --
            pattern: /(\s)--(?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing parenthesis
            pattern: /(\s)\)(?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        combinators: {
          pattern: null,
          lookbehind: !0,
          alias: "keyword"
        },
        "kernel-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "sequences-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "math-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "constructor-word": {
          // <array> but not <=>
          pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
          lookbehind: !0,
          alias: "keyword"
        },
        "other-builtin-syntax": {
          pattern: null,
          lookbehind: !0,
          alias: "operator"
        },
        /*
        full list of supported word naming conventions: (the convention appears outside of the [brackets])
        set-[x]
        change-[x]
        with-[x]
        new-[x]
        >[string]
        [base]>
        [string]>[number]
        +[symbol]+
        [boolean-word]?
        ?[of]
        [slot-reader]>>
        >>[slot-setter]
        [slot-writer]<<
        ([implementation-detail])
        [mutater]!
        [variant]*
        [prettyprint].
        $[help-markup]
        <constructors>, SYNTAX:, etc are supported by their own patterns.
        `with` and `new` from `kernel` are their own builtins.
        see <https://docs.factorcode.org/content/article-conventions.html>
        */
        "conventionally-named-word": {
          pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
          lookbehind: !0,
          alias: "keyword"
        },
        "colon-syntax": {
          pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
          lookbehind: !0,
          greedy: !0,
          alias: "function"
        },
        "semicolon-or-setlocal": {
          pattern: /(\s)(?:;|:>)(?=\s|$)/,
          lookbehind: !0,
          alias: "function"
        },
        // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
        "curly-brace-literal-delimiter": [
          {
            // opening
            pattern: /(^|\s)[a-z]*\{(?=\s)/i,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing
            pattern: /(\s)\}(?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
        "quotation-delimiter": [
          {
            // opening
            pattern: /(^|\s)\[(?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing
            pattern: /(\s)\](?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        "normal-word": {
          pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
          lookbehind: !0
        },
        /*
        basic first-class string "a"
        with escaped double-quote "a\""
        escaped backslash "\\"
        and general escapes since Factor has so many "\N"
        syntax that works in the reference implementation that isn't fully
        supported because it's an implementation detail:
        "string 1""string 2" -> 2 strings (works anyway)
        "string"5 -> string, 5
        "string"[ ] -> string, quotation
        { "a"} -> array<string>
        the rest of those examples all properly recognise the string, but not
        the other object (number, quotation, etc)
        this is fine for a regex-only implementation.
        */
        string: {
          pattern: /"(?:\\\S|[^"\\])*"/,
          greedy: !0,
          inside: a
        }
      }, o = function(u) {
        return (u + "").replace(/([.?*+\^$\[\]\\(){}|\-])/g, "\\$1");
      }, s = function(u) {
        return new RegExp("(^|\\s)(?:" + u.map(o).join("|") + ")(?=\\s|$)");
      }, l = {
        "kernel-builtin": [
          "or",
          "2nipd",
          "4drop",
          "tuck",
          "wrapper",
          "nip",
          "wrapper?",
          "callstack>array",
          "die",
          "dupd",
          "callstack",
          "callstack?",
          "3dup",
          "hashcode",
          "pick",
          "4nip",
          "build",
          ">boolean",
          "nipd",
          "clone",
          "5nip",
          "eq?",
          "?",
          "=",
          "swapd",
          "2over",
          "clear",
          "2dup",
          "get-retainstack",
          "not",
          "tuple?",
          "dup",
          "3nipd",
          "call",
          "-rotd",
          "object",
          "drop",
          "assert=",
          "assert?",
          "-rot",
          "execute",
          "boa",
          "get-callstack",
          "curried?",
          "3drop",
          "pickd",
          "overd",
          "over",
          "roll",
          "3nip",
          "swap",
          "and",
          "2nip",
          "rotd",
          "throw",
          "(clone)",
          "hashcode*",
          "spin",
          "reach",
          "4dup",
          "equal?",
          "get-datastack",
          "assert",
          "2drop",
          "<wrapper>",
          "boolean?",
          "identity-hashcode",
          "identity-tuple?",
          "null",
          "composed?",
          "new",
          "5drop",
          "rot",
          "-roll",
          "xor",
          "identity-tuple",
          "boolean"
        ],
        "other-builtin-syntax": [
          // syntax
          "=======",
          "recursive",
          "flushable",
          ">>",
          "<<<<<<",
          "M\\",
          "B",
          "PRIVATE>",
          "\\",
          "======",
          "final",
          "inline",
          "delimiter",
          "deprecated",
          "<PRIVATE",
          ">>>>>>",
          "<<<<<<<",
          "parse-complex",
          "malformed-complex",
          "read-only",
          ">>>>>>>",
          "call-next-method",
          "<<",
          "foldable",
          // literals
          "$",
          "$[",
          "${"
        ],
        "sequences-builtin": [
          "member-eq?",
          "mismatch",
          "append",
          "assert-sequence=",
          "longer",
          "repetition",
          "clone-like",
          "3sequence",
          "assert-sequence?",
          "last-index-from",
          "reversed",
          "index-from",
          "cut*",
          "pad-tail",
          "join-as",
          "remove-eq!",
          "concat-as",
          "but-last",
          "snip",
          "nths",
          "nth",
          "sequence",
          "longest",
          "slice?",
          "<slice>",
          "remove-nth",
          "tail-slice",
          "empty?",
          "tail*",
          "member?",
          "virtual-sequence?",
          "set-length",
          "drop-prefix",
          "iota",
          "unclip",
          "bounds-error?",
          "unclip-last-slice",
          "non-negative-integer-expected",
          "non-negative-integer-expected?",
          "midpoint@",
          "longer?",
          "?set-nth",
          "?first",
          "rest-slice",
          "prepend-as",
          "prepend",
          "fourth",
          "sift",
          "subseq-start",
          "new-sequence",
          "?last",
          "like",
          "first4",
          "1sequence",
          "reverse",
          "slice",
          "virtual@",
          "repetition?",
          "set-last",
          "index",
          "4sequence",
          "max-length",
          "set-second",
          "immutable-sequence",
          "first2",
          "first3",
          "supremum",
          "unclip-slice",
          "suffix!",
          "insert-nth",
          "tail",
          "3append",
          "short",
          "suffix",
          "concat",
          "flip",
          "immutable?",
          "reverse!",
          "2sequence",
          "sum",
          "delete-all",
          "indices",
          "snip-slice",
          "<iota>",
          "check-slice",
          "sequence?",
          "head",
          "append-as",
          "halves",
          "sequence=",
          "collapse-slice",
          "?second",
          "slice-error?",
          "product",
          "bounds-check?",
          "bounds-check",
          "immutable",
          "virtual-exemplar",
          "harvest",
          "remove",
          "pad-head",
          "last",
          "set-fourth",
          "cartesian-product",
          "remove-eq",
          "shorten",
          "shorter",
          "reversed?",
          "shorter?",
          "shortest",
          "head-slice",
          "pop*",
          "tail-slice*",
          "but-last-slice",
          "iota?",
          "append!",
          "cut-slice",
          "new-resizable",
          "head-slice*",
          "sequence-hashcode",
          "pop",
          "set-nth",
          "?nth",
          "second",
          "join",
          "immutable-sequence?",
          "<reversed>",
          "3append-as",
          "virtual-sequence",
          "subseq?",
          "remove-nth!",
          "length",
          "last-index",
          "lengthen",
          "assert-sequence",
          "copy",
          "move",
          "third",
          "first",
          "tail?",
          "set-first",
          "prefix",
          "bounds-error",
          "<repetition>",
          "exchange",
          "surround",
          "cut",
          "min-length",
          "set-third",
          "push-all",
          "head?",
          "subseq-start-from",
          "delete-slice",
          "rest",
          "sum-lengths",
          "head*",
          "infimum",
          "remove!",
          "glue",
          "slice-error",
          "subseq",
          "push",
          "replace-slice",
          "subseq-as",
          "unclip-last"
        ],
        "math-builtin": [
          "number=",
          "next-power-of-2",
          "?1+",
          "fp-special?",
          "imaginary-part",
          "float>bits",
          "number?",
          "fp-infinity?",
          "bignum?",
          "fp-snan?",
          "denominator",
          "gcd",
          "*",
          "+",
          "fp-bitwise=",
          "-",
          "u>=",
          "/",
          ">=",
          "bitand",
          "power-of-2?",
          "log2-expects-positive",
          "neg?",
          "<",
          "log2",
          ">",
          "integer?",
          "number",
          "bits>double",
          "2/",
          "zero?",
          "bits>float",
          "float?",
          "shift",
          "ratio?",
          "rect>",
          "even?",
          "ratio",
          "fp-sign",
          "bitnot",
          ">fixnum",
          "complex?",
          "/i",
          "integer>fixnum",
          "/f",
          "sgn",
          ">bignum",
          "next-float",
          "u<",
          "u>",
          "mod",
          "recip",
          "rational",
          ">float",
          "2^",
          "integer",
          "fixnum?",
          "neg",
          "fixnum",
          "sq",
          "bignum",
          ">rect",
          "bit?",
          "fp-qnan?",
          "simple-gcd",
          "complex",
          "<fp-nan>",
          "real",
          ">fraction",
          "double>bits",
          "bitor",
          "rem",
          "fp-nan-payload",
          "real-part",
          "log2-expects-positive?",
          "prev-float",
          "align",
          "unordered?",
          "float",
          "fp-nan?",
          "abs",
          "bitxor",
          "integer>fixnum-strict",
          "u<=",
          "odd?",
          "<=",
          "/mod",
          ">integer",
          "real?",
          "rational?",
          "numerator"
        ]
        // that's all for now
      };
      Object.keys(l).forEach(function(u) {
        i[u].pattern = s(l[u]);
      });
      var c = [
        // kernel
        "2bi",
        "while",
        "2tri",
        "bi*",
        "4dip",
        "both?",
        "same?",
        "tri@",
        "curry",
        "prepose",
        "3bi",
        "?if",
        "tri*",
        "2keep",
        "3keep",
        "curried",
        "2keepd",
        "when",
        "2bi*",
        "2tri*",
        "4keep",
        "bi@",
        "keepdd",
        "do",
        "unless*",
        "tri-curry",
        "if*",
        "loop",
        "bi-curry*",
        "when*",
        "2bi@",
        "2tri@",
        "with",
        "2with",
        "either?",
        "bi",
        "until",
        "3dip",
        "3curry",
        "tri-curry*",
        "tri-curry@",
        "bi-curry",
        "keepd",
        "compose",
        "2dip",
        "if",
        "3tri",
        "unless",
        "tuple",
        "keep",
        "2curry",
        "tri",
        "most",
        "while*",
        "dip",
        "composed",
        "bi-curry@",
        // sequences
        "find-last-from",
        "trim-head-slice",
        "map-as",
        "each-from",
        "none?",
        "trim-tail",
        "partition",
        "if-empty",
        "accumulate*",
        "reject!",
        "find-from",
        "accumulate-as",
        "collector-for-as",
        "reject",
        "map",
        "map-sum",
        "accumulate!",
        "2each-from",
        "follow",
        "supremum-by",
        "map!",
        "unless-empty",
        "collector",
        "padding",
        "reduce-index",
        "replicate-as",
        "infimum-by",
        "trim-tail-slice",
        "count",
        "find-index",
        "filter",
        "accumulate*!",
        "reject-as",
        "map-integers",
        "map-find",
        "reduce",
        "selector",
        "interleave",
        "2map",
        "filter-as",
        "binary-reduce",
        "map-index-as",
        "find",
        "produce",
        "filter!",
        "replicate",
        "cartesian-map",
        "cartesian-each",
        "find-index-from",
        "map-find-last",
        "3map-as",
        "3map",
        "find-last",
        "selector-as",
        "2map-as",
        "2map-reduce",
        "accumulate",
        "each",
        "each-index",
        "accumulate*-as",
        "when-empty",
        "all?",
        "collector-as",
        "push-either",
        "new-like",
        "collector-for",
        "2selector",
        "push-if",
        "2all?",
        "map-reduce",
        "3each",
        "any?",
        "trim-slice",
        "2reduce",
        "change-nth",
        "produce-as",
        "2each",
        "trim",
        "trim-head",
        "cartesian-find",
        "map-index",
        // math
        "if-zero",
        "each-integer",
        "unless-zero",
        "(find-integer)",
        "when-zero",
        "find-last-integer",
        "(all-integers?)",
        "times",
        "(each-integer)",
        "find-integer",
        "all-integers?",
        // math.combinators
        "unless-negative",
        "if-positive",
        "when-positive",
        "when-negative",
        "unless-positive",
        "if-negative",
        // combinators
        "case",
        "2cleave",
        "cond>quot",
        "case>quot",
        "3cleave",
        "wrong-values",
        "to-fixed-point",
        "alist>quot",
        "cond",
        "cleave",
        "call-effect",
        "recursive-hashcode",
        "spread",
        "deep-spread>quot",
        // combinators.short-circuit
        "2||",
        "0||",
        "n||",
        "0&&",
        "2&&",
        "3||",
        "1||",
        "1&&",
        "n&&",
        "3&&",
        // combinators.smart
        "smart-unless*",
        "keep-inputs",
        "reduce-outputs",
        "smart-when*",
        "cleave>array",
        "smart-with",
        "smart-apply",
        "smart-if",
        "inputs/outputs",
        "output>sequence-n",
        "map-outputs",
        "map-reduce-outputs",
        "dropping",
        "output>array",
        "smart-map-reduce",
        "smart-2map-reduce",
        "output>array-n",
        "nullary",
        "input<sequence",
        "append-outputs",
        "drop-inputs",
        "inputs",
        "smart-2reduce",
        "drop-outputs",
        "smart-reduce",
        "preserving",
        "smart-when",
        "outputs",
        "append-outputs-as",
        "smart-unless",
        "smart-if*",
        "sum-outputs",
        "input<sequence-unsafe",
        "output>sequence"
        // tafn
      ];
      i.combinators.pattern = s(c), n.languages.factor = i;
    })(t);
  }
  return au;
}
var iu, fS;
function IY() {
  if (fS) return iu;
  fS = 1, iu = e, e.displayName = "$false", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.false = {
        comment: {
          pattern: /\{[^}]*\}/
        },
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        "character-code": {
          pattern: /'(?:[^\r]|\r\n?)/,
          alias: "number"
        },
        "assembler-code": {
          pattern: /\d+`/,
          alias: "important"
        },
        number: /\d+/,
        operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
        punctuation: /\[|\]/,
        variable: /[a-z]/,
        "non-standard": {
          pattern: /[()<BDO®]/,
          alias: "bold"
        }
      };
    })(t);
  }
  return iu;
}
var ou, pS;
function kY() {
  if (pS) return ou;
  pS = 1, ou = e, e.displayName = "firestoreSecurityRules", e.aliases = [];
  function e(t) {
    t.languages["firestore-security-rules"] = t.languages.extend(
      "clike",
      {
        comment: /\/\/.*/,
        keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
        operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
      }
    ), delete t.languages["firestore-security-rules"]["class-name"], t.languages.insertBefore("firestore-security-rules", "keyword", {
      path: {
        pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          variable: {
            pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
            inside: {
              operator: /=/,
              keyword: /\*\*/,
              punctuation: /[.$(){}]/
            }
          },
          punctuation: /\//
        }
      },
      method: {
        // to make the pattern shorter, the actual method names are omitted
        pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
        lookbehind: !0,
        alias: "builtin",
        inside: {
          punctuation: /,/
        }
      }
    });
  }
  return ou;
}
var su, gS;
function OY() {
  if (gS) return su;
  gS = 1, su = e, e.displayName = "flow", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.flow = n.languages.extend("javascript", {}), n.languages.insertBefore("flow", "keyword", {
        type: [
          {
            pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|any|mixed|null|void)\b/,
            alias: "tag"
          }
        ]
      }), n.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete n.languages.flow.parameter, n.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
          pattern: /\{\||\|\}/,
          alias: "punctuation"
        }
      }), Array.isArray(n.languages.flow.keyword) || (n.languages.flow.keyword = [n.languages.flow.keyword]), n.languages.flow.keyword.unshift(
        {
          pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
          lookbehind: !0
        }
      );
    })(t);
  }
  return su;
}
var lu, hS;
function DY() {
  if (hS) return lu;
  hS = 1, lu = e, e.displayName = "fortran", e.aliases = [];
  function e(t) {
    t.languages.fortran = {
      "quoted-number": {
        pattern: /[BOZ](['"])[A-F0-9]+\1/i,
        alias: "number"
      },
      string: {
        pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
        inside: {
          comment: {
            pattern: /(&(?:\r\n?|\n)\s*)!.*/,
            lookbehind: !0
          }
        }
      },
      comment: {
        pattern: /!.*/,
        greedy: !0
      },
      boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
      keyword: [
        // Types
        /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
        // END statements
        /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
        // Statements
        /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
        // Others
        /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
      ],
      operator: [
        /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
        {
          // Use lookbehind to prevent confusion with (/ /)
          pattern: /(^|(?!\().)\/(?!\))/,
          lookbehind: !0
        }
      ],
      punctuation: /\(\/|\/\)|[(),;:&]/
    };
  }
  return lu;
}
var cu, mS;
function LY() {
  if (mS) return cu;
  mS = 1, cu = e, e.displayName = "fsharp", e.aliases = [];
  function e(t) {
    t.languages.fsharp = t.languages.extend("clike", {
      comment: [
        {
          pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
        lookbehind: !0,
        inside: {
          operator: /->|\*/,
          punctuation: /\./
        }
      },
      keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
      number: [
        /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
        /\b0b[01]+(?:uy|y)?\b/,
        /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
        /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
      ],
      operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
    }), t.languages.insertBefore("fsharp", "keyword", {
      preprocessor: {
        pattern: /(^[\t ]*)#.*/m,
        lookbehind: !0,
        alias: "property",
        inside: {
          directive: {
            pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
            lookbehind: !0,
            alias: "keyword"
          }
        }
      }
    }), t.languages.insertBefore("fsharp", "punctuation", {
      "computation-expression": {
        pattern: /\b[_a-z]\w*(?=\s*\{)/i,
        alias: "keyword"
      }
    }), t.languages.insertBefore("fsharp", "string", {
      annotation: {
        pattern: /\[<.+?>\]/,
        greedy: !0,
        inside: {
          punctuation: /^\[<|>\]$/,
          "class-name": {
            pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
            lookbehind: !0
          },
          "annotation-content": {
            pattern: /[\s\S]+/,
            inside: t.languages.fsharp
          }
        }
      },
      char: {
        pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
        greedy: !0
      }
    });
  }
  return cu;
}
var uu, bS;
function MY() {
  if (bS) return uu;
  bS = 1;
  var e = yt();
  uu = t, t.displayName = "ftl", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      for (var a = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source, i = 0; i < 2; i++)
        a = a.replace(/<expr>/g, function() {
          return a;
        });
      a = a.replace(/<expr>/g, /[^\s\S]/.source);
      var o = {
        comment: /<#--[\s\S]*?-->/,
        string: [
          {
            // raw string
            pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
            greedy: !0
          },
          {
            pattern: RegExp(
              /("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(
                /<expr>/g,
                function() {
                  return a;
                }
              )
            ),
            greedy: !0,
            inside: {
              interpolation: {
                pattern: RegExp(
                  /((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(
                    /<expr>/g,
                    function() {
                      return a;
                    }
                  )
                ),
                lookbehind: !0,
                inside: {
                  "interpolation-punctuation": {
                    pattern: /^\$\{|\}$/,
                    alias: "punctuation"
                  },
                  rest: null
                }
              }
            }
          }
        ],
        keyword: /\b(?:as)\b/,
        boolean: /\b(?:false|true)\b/,
        "builtin-function": {
          pattern: /((?:^|[^?])\?\s*)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        function: /\b\w+(?=\s*\()/,
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
        punctuation: /[,;.:()[\]{}]/
      };
      o.string[1].inside.interpolation.inside.rest = o, r.languages.ftl = {
        "ftl-comment": {
          // the pattern is shortened to be more efficient
          pattern: /^<#--[\s\S]*/,
          alias: "comment"
        },
        "ftl-directive": {
          pattern: /^<[\s\S]+>$/,
          inside: {
            directive: {
              pattern: /(^<\/?)[#@][a-z]\w*/i,
              lookbehind: !0,
              alias: "keyword"
            },
            punctuation: /^<\/?|\/?>$/,
            content: {
              pattern: /\s*\S[\s\S]*/,
              alias: "ftl",
              inside: o
            }
          }
        },
        "ftl-interpolation": {
          pattern: /^\$\{[\s\S]*\}$/,
          inside: {
            punctuation: /^\$\{|\}$/,
            content: {
              pattern: /\s*\S[\s\S]*/,
              alias: "ftl",
              inside: o
            }
          }
        }
      }, r.hooks.add("before-tokenize", function(s) {
        var l = RegExp(
          /<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(
            /<expr>/g,
            function() {
              return a;
            }
          ),
          "gi"
        );
        r.languages["markup-templating"].buildPlaceholders(
          s,
          "ftl",
          l
        );
      }), r.hooks.add("after-tokenize", function(s) {
        r.languages["markup-templating"].tokenizePlaceholders(s, "ftl");
      });
    }(n);
  }
  return uu;
}
var du, vS;
function PY() {
  if (vS) return du;
  vS = 1, du = e, e.displayName = "gap", e.aliases = [];
  function e(t) {
    t.languages.gap = {
      shell: {
        pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
        greedy: !0,
        inside: {
          gap: {
            pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
            lookbehind: !0,
            inside: null
            // see below
          },
          punctuation: /^gap>/
        }
      },
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          continuation: {
            pattern: /([\r\n])>/,
            lookbehind: !0,
            alias: "punctuation"
          }
        }
      },
      keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: {
        pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
        lookbehind: !0
      },
      continuation: {
        pattern: /([\r\n])>/,
        lookbehind: !0,
        alias: "punctuation"
      },
      operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
      punctuation: /[()[\]{},;.:]/
    }, t.languages.gap.shell.inside.gap.inside = t.languages.gap;
  }
  return du;
}
var fu, yS;
function FY() {
  if (yS) return fu;
  yS = 1, fu = e, e.displayName = "gcode", e.aliases = [];
  function e(t) {
    t.languages.gcode = {
      comment: /;.*|\B\(.*?\)\B/,
      string: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      keyword: /\b[GM]\d+(?:\.\d+)?\b/,
      property: /\b[A-Z]/,
      checksum: {
        pattern: /(\*)\d+/,
        lookbehind: !0,
        alias: "number"
      },
      // T0:0:0
      punctuation: /[:*]/
    };
  }
  return fu;
}
var pu, ES;
function $Y() {
  if (ES) return pu;
  ES = 1, pu = e, e.displayName = "gdscript", e.aliases = [];
  function e(t) {
    t.languages.gdscript = {
      comment: /#.*/,
      string: {
        pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
        greedy: !0
      },
      "class-name": {
        // class_name Foo, extends Bar, class InnerClass
        // export(int) var baz, export(int, 0) var i
        // as Node
        // const FOO: int = 9, var bar: bool = true
        // func add(reference: Item, amount: int) -> Item:
        pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
        lookbehind: !0
      },
      keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
      function: /\b[a-z_]\w*(?=[ \t]*\()/i,
      variable: /\$\w+/,
      number: [
        /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
        /\b(?:INF|NAN|PI|TAU)\b/
      ],
      constant: /\b[A-Z][A-Z_\d]*\b/,
      boolean: /\b(?:false|true)\b/,
      operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
      punctuation: /[.:,;()[\]{}]/
    };
  }
  return pu;
}
var gu, SS;
function BY() {
  if (SS) return gu;
  SS = 1, gu = e, e.displayName = "gedcom", e.aliases = [];
  function e(t) {
    t.languages.gedcom = {
      "line-value": {
        // Preceded by level, optional pointer, and tag
        pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
        lookbehind: !0,
        inside: {
          pointer: {
            pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
            alias: "variable"
          }
        }
      },
      tag: {
        // Preceded by level and optional pointer
        pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
        lookbehind: !0,
        alias: "string"
      },
      level: {
        pattern: /(^[\t ]*)\d+/m,
        lookbehind: !0,
        alias: "number"
      },
      pointer: {
        pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
        alias: "variable"
      }
    };
  }
  return gu;
}
var hu, wS;
function UY() {
  if (wS) return hu;
  wS = 1, hu = e, e.displayName = "gherkin", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
      n.languages.gherkin = {
        pystring: {
          pattern: /("""|''')[\s\S]+?\1/,
          alias: "string"
        },
        comment: {
          pattern: /(^[ \t]*)#.*/m,
          lookbehind: !0
        },
        tag: {
          pattern: /(^[ \t]*)@\S*/m,
          lookbehind: !0
        },
        feature: {
          pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
          lookbehind: !0,
          inside: {
            important: {
              pattern: /(:)[^\r\n]+/,
              lookbehind: !0
            },
            keyword: /[^:\r\n]+:/
          }
        },
        scenario: {
          pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
          lookbehind: !0,
          inside: {
            important: {
              pattern: /(:)[^\r\n]*/,
              lookbehind: !0
            },
            keyword: /[^:\r\n]+:/
          }
        },
        "table-body": {
          // Look-behind is used to skip the table head, which has the same format as any table row
          pattern: RegExp("(" + r + ")(?:" + r + ")+"),
          lookbehind: !0,
          inside: {
            outline: {
              pattern: /<[^>]+>/,
              alias: "variable"
            },
            td: {
              pattern: /\s*[^\s|][^|]*/,
              alias: "string"
            },
            punctuation: /\|/
          }
        },
        "table-head": {
          pattern: RegExp(r),
          inside: {
            th: {
              pattern: /\s*[^\s|][^|]*/,
              alias: "variable"
            },
            punctuation: /\|/
          }
        },
        atrule: {
          pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
          lookbehind: !0
        },
        string: {
          pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
          inside: {
            outline: {
              pattern: /<[^>]+>/,
              alias: "variable"
            }
          }
        },
        outline: {
          pattern: /<[^>]+>/,
          alias: "variable"
        }
      };
    })(t);
  }
  return hu;
}
var mu, _S;
function GY() {
  if (_S) return mu;
  _S = 1, mu = e, e.displayName = "git", e.aliases = [];
  function e(t) {
    t.languages.git = {
      /*
       * A simple one line comment like in a git status command
       * For instance:
       * $ git status
       * # On branch infinite-scroll
       * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
       * # and have 1 and 2 different commits each, respectively.
       * nothing to commit (working directory clean)
       */
      comment: /^#.*/m,
      /*
       * Regexp to match the changed lines in a git diff output. Check the example below.
       */
      deleted: /^[-–].*/m,
      inserted: /^\+.*/m,
      /*
       * a string (double and simple quote)
       */
      string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      /*
       * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
       * For instance:
       * $ git add file.txt
       */
      command: {
        pattern: /^.*\$ git .*$/m,
        inside: {
          /*
           * A git command can contain a parameter starting by a single or a double dash followed by a string
           * For instance:
           * $ git diff --cached
           * $ git log -p
           */
          parameter: /\s--?\w+/
        }
      },
      /*
       * Coordinates displayed in a git diff command
       * For instance:
       * $ git diff
       * diff --git file.txt file.txt
       * index 6214953..1d54a52 100644
       * --- file.txt
       * +++ file.txt
       * @@ -1 +1,2 @@
       * -Here's my tetx file
       * +Here's my text file
       * +And this is the second line
       */
      coord: /^@@.*@@$/m,
      /*
       * Match a "commit [SHA1]" line in a git log output.
       * For instance:
       * $ git log
       * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
       * Author: lgiraudel
       * Date:   Mon Feb 17 11:18:34 2014 +0100
       *
       *     Add of a new line
       */
      "commit-sha1": /^commit \w{40}$/m
    };
  }
  return mu;
}
var bu, TS;
function HY() {
  if (TS) return bu;
  TS = 1;
  var e = Or();
  bu = t, t.displayName = "glsl", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.glsl = n.languages.extend("c", {
      keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
    });
  }
  return bu;
}
var vu, RS;
function zY() {
  if (RS) return vu;
  RS = 1, vu = e, e.displayName = "gml", e.aliases = [];
  function e(t) {
    t.languages.gamemakerlanguage = t.languages.gml = t.languages.extend("clike", {
      keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
      number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
      operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
      constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
      variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
    });
  }
  return vu;
}
var yu, AS;
function WY() {
  if (AS) return yu;
  AS = 1, yu = e, e.displayName = "gn", e.aliases = ["gni"];
  function e(t) {
    t.languages.gn = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      "string-literal": {
        pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
            lookbehind: !0,
            inside: {
              number: /^\$0x[\s\S]{2}$/,
              variable: /^\$\w+$/,
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              expression: {
                pattern: /[\s\S]+/,
                inside: null
                // see below
              }
            }
          },
          string: /[\s\S]+/
        }
      },
      keyword: /\b(?:else|if)\b/,
      boolean: /\b(?:false|true)\b/,
      "builtin-function": {
        // a few functions get special highlighting to improve readability
        pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
        alias: "keyword"
      },
      function: /\b[a-z_]\w*(?=\s*\()/i,
      constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
      number: /-?\b\d+\b/,
      operator: /[-+!=<>]=?|&&|\|\|/,
      punctuation: /[(){}[\],.]/
    }, t.languages.gn["string-literal"].inside.interpolation.inside.expression.inside = t.languages.gn, t.languages.gni = t.languages.gn;
  }
  return yu;
}
var Eu, xS;
function qY() {
  if (xS) return Eu;
  xS = 1, Eu = e, e.displayName = "goModule", e.aliases = [];
  function e(t) {
    t.languages["go-mod"] = t.languages["go-module"] = {
      comment: {
        pattern: /\/\/.*/,
        greedy: !0
      },
      version: {
        pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
        lookbehind: !0,
        alias: "number"
      },
      "go-version": {
        pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
        lookbehind: !0,
        alias: "number"
      },
      keyword: {
        pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
        lookbehind: !0
      },
      operator: /=>/,
      punctuation: /[()[\],]/
    };
  }
  return Eu;
}
var Su, CS;
function VY() {
  if (CS) return Su;
  CS = 1, Su = e, e.displayName = "go", e.aliases = [];
  function e(t) {
    t.languages.go = t.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
      boolean: /\b(?:_|false|iota|nil|true)\b/,
      number: [
        // binary and octal integers
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        // hexadecimal integers and floats
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        // decimal integers and floats
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
      ],
      operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
      builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
    }), t.languages.insertBefore("go", "string", {
      char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: !0
      }
    }), delete t.languages.go["class-name"];
  }
  return Su;
}
var wu, NS;
function jY() {
  if (NS) return wu;
  NS = 1, wu = e, e.displayName = "graphql", e.aliases = [];
  function e(t) {
    t.languages.graphql = {
      comment: /#.*/,
      description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: !0,
        alias: "string",
        inside: {
          "language-markdown": {
            pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
            lookbehind: !0,
            inside: t.languages.markdown
          }
        }
      },
      string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      boolean: /\b(?:false|true)\b/,
      variable: /\$[a-z_]\w*/i,
      directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
      },
      "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: !0
      },
      "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
      },
      scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
      constant: /\b[A-Z][A-Z_\d]*\b/,
      "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: !0
      },
      fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
      operator: /[!=|&]|\.{3}/,
      "property-query": /\w+(?=\s*\()/,
      object: /\w+(?=\s*\{)/,
      punctuation: /[!(){}\[\]:=,]/,
      property: /\w+/
    }, t.hooks.add("after-tokenize", function(r) {
      if (r.language !== "graphql")
        return;
      var a = r.tokens.filter(function(v) {
        return typeof v != "string" && v.type !== "comment" && v.type !== "scalar";
      }), i = 0;
      function o(v) {
        return a[i + v];
      }
      function s(v, y) {
        y = y || 0;
        for (var E = 0; E < v.length; E++) {
          var S = o(E + y);
          if (!S || S.type !== v[E])
            return !1;
        }
        return !0;
      }
      function l(v, y) {
        for (var E = 1, S = i; S < a.length; S++) {
          var w = a[S], R = w.content;
          if (w.type === "punctuation" && typeof R == "string") {
            if (v.test(R))
              E++;
            else if (y.test(R) && (E--, E === 0))
              return S;
          }
        }
        return -1;
      }
      function c(v, y) {
        var E = v.alias;
        E ? Array.isArray(E) || (v.alias = E = [E]) : v.alias = E = [], E.push(y);
      }
      for (; i < a.length; ) {
        var u = a[i++];
        if (u.type === "keyword" && u.content === "mutation") {
          var d = [];
          if (s(["definition-mutation", "punctuation"]) && o(1).content === "(") {
            i += 2;
            var f = l(/^\($/, /^\)$/);
            if (f === -1)
              continue;
            for (; i < f; i++) {
              var g = o(0);
              g.type === "variable" && (c(g, "variable-input"), d.push(g.content));
            }
            i = f + 1;
          }
          if (s(["punctuation", "property-query"]) && o(0).content === "{" && (i++, c(o(0), "property-mutation"), d.length > 0)) {
            var h = l(/^\{$/, /^\}$/);
            if (h === -1)
              continue;
            for (var p = i; p < h; p++) {
              var m = a[p];
              m.type === "variable" && d.indexOf(m.content) >= 0 && c(m, "variable-input");
            }
          }
        }
      }
    });
  }
  return wu;
}
var _u, IS;
function YY() {
  if (IS) return _u;
  IS = 1, _u = e, e.displayName = "groovy", e.aliases = [];
  function e(t) {
    t.languages.groovy = t.languages.extend("clike", {
      string: [
        {
          // https://groovy-lang.org/syntax.html#_dollar_slashy_string
          pattern: /("""|''')(?:[^\\]|\\[\s\S])*?\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
          greedy: !0
        },
        {
          // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
          // simple division (see JS regex), so find a fix maybe?
          pattern: /(["'/])(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        }
      ],
      keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
      number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
      operator: {
        pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
        lookbehind: !0
      },
      punctuation: /\.+|[{}[\];(),:$]/
    }), t.languages.insertBefore("groovy", "string", {
      shebang: {
        pattern: /#!.+/,
        alias: "comment"
      }
    }), t.languages.insertBefore("groovy", "punctuation", {
      "spock-block": /\b(?:and|cleanup|expect|given|setup|then|when|where):/
    }), t.languages.insertBefore("groovy", "function", {
      annotation: {
        pattern: /(^|[^.])@\w+/,
        lookbehind: !0,
        alias: "punctuation"
      }
    }), t.hooks.add("wrap", function(n) {
      if (n.language === "groovy" && n.type === "string") {
        var r = n.content.value[0];
        if (r != "'") {
          var a = /([^\\])(?:\$(?:\{.*?\}|[\w.]+))/;
          r === "$" && (a = /([^\$])(?:\$(?:\{.*?\}|[\w.]+))/), n.content.value = n.content.value.replace(/&lt;/g, "<").replace(/&amp;/g, "&"), n.content = t.highlight(n.content.value, {
            expression: {
              pattern: a,
              lookbehind: !0,
              inside: t.languages.groovy
            }
          }), n.classes.push(r === "/" ? "regex" : "gstring");
        }
      }
    });
  }
  return _u;
}
var Tu, kS;
function KY() {
  if (kS) return Tu;
  kS = 1;
  var e = $s();
  Tu = t, t.displayName = "haml", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.haml = {
        // Multiline stuff should appear before the rest
        "multiline-comment": {
          pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
          lookbehind: !0,
          alias: "comment"
        },
        "multiline-code": [
          {
            pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
            lookbehind: !0,
            inside: r.languages.ruby
          },
          {
            pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
            lookbehind: !0,
            inside: r.languages.ruby
          }
        ],
        // See at the end of the file for known filters
        filter: {
          pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "symbol"
            }
          }
        },
        markup: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
          lookbehind: !0,
          inside: r.languages.markup
        },
        doctype: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
          lookbehind: !0
        },
        tag: {
          // Allows for one nested group of braces
          pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
          lookbehind: !0,
          inside: {
            attributes: [
              {
                // Lookbehind tries to prevent interpolations from breaking it all
                // Allows for one nested group of braces
                pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
                lookbehind: !0,
                inside: r.languages.ruby
              },
              {
                pattern: /\([^)]+\)/,
                inside: {
                  "attr-value": {
                    pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                    lookbehind: !0
                  },
                  "attr-name": /[\w:-]+(?=\s*!?=|\s*[,)])/,
                  punctuation: /[=(),]/
                }
              },
              {
                pattern: /\[[^\]]+\]/,
                inside: r.languages.ruby
              }
            ],
            punctuation: /[<>]/
          }
        },
        code: {
          pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
          lookbehind: !0,
          inside: r.languages.ruby
        },
        // Interpolations in plain text
        interpolation: {
          pattern: /#\{[^}]+\}/,
          inside: {
            delimiter: {
              pattern: /^#\{|\}$/,
              alias: "punctuation"
            },
            ruby: {
              pattern: /[\s\S]+/,
              inside: r.languages.ruby
            }
          }
        },
        punctuation: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
          lookbehind: !0
        }
      };
      for (var a = "((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+", i = [
        "css",
        {
          filter: "coffee",
          language: "coffeescript"
        },
        "erb",
        "javascript",
        "less",
        "markdown",
        "ruby",
        "scss",
        "textile"
      ], o = {}, s = 0, l = i.length; s < l; s++) {
        var c = i[s];
        c = typeof c == "string" ? {
          filter: c,
          language: c
        } : c, r.languages[c.language] && (o["filter-" + c.filter] = {
          pattern: RegExp(
            a.replace("{{filter_name}}", function() {
              return c.filter;
            })
          ),
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "symbol"
            },
            text: {
              pattern: /[\s\S]+/,
              alias: [c.language, "language-" + c.language],
              inside: r.languages[c.language]
            }
          }
        });
      }
      r.languages.insertBefore("haml", "filter", o);
    }(n);
  }
  return Tu;
}
var Ru, OS;
function XY() {
  if (OS) return Ru;
  OS = 1;
  var e = yt();
  Ru = t, t.displayName = "handlebars", t.aliases = ["hbs"];
  function t(n) {
    n.register(e), function(r) {
      r.languages.handlebars = {
        comment: /\{\{![\s\S]*?\}\}/,
        delimiter: {
          pattern: /^\{\{\{?|\}\}\}?$/,
          alias: "punctuation"
        },
        string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
        boolean: /\b(?:false|true)\b/,
        block: {
          pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
          lookbehind: !0,
          alias: "keyword"
        },
        brackets: {
          pattern: /\[[^\]]+\]/,
          inside: {
            punctuation: /\[|\]/,
            variable: /[\s\S]+/
          }
        },
        punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
        variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
      }, r.hooks.add("before-tokenize", function(a) {
        var i = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
        r.languages["markup-templating"].buildPlaceholders(
          a,
          "handlebars",
          i
        );
      }), r.hooks.add("after-tokenize", function(a) {
        r.languages["markup-templating"].tokenizePlaceholders(
          a,
          "handlebars"
        );
      }), r.languages.hbs = r.languages.handlebars;
    }(n);
  }
  return Ru;
}
var Au, DS;
function Tm() {
  if (DS) return Au;
  DS = 1, Au = e, e.displayName = "haskell", e.aliases = ["hs"];
  function e(t) {
    t.languages.haskell = {
      comment: {
        pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
        lookbehind: !0
      },
      char: {
        pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
        alias: "string"
      },
      string: {
        pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
        greedy: !0
      },
      keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|hiding|import|qualified)\b/,
          punctuation: /\./
        }
      },
      // These are builtin variables only. Constructors are highlighted later as a constant.
      builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
      // decimal integers and floating point numbers | octal integers | hexadecimal integers
      number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
      operator: [
        {
          // infix operator
          pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
          greedy: !0
        },
        {
          // function composition
          pattern: /(\s)\.(?=\s)/,
          lookbehind: !0
        },
        // Most of this is needed because of the meaning of a single '.'.
        // If it stands alone freely, it is the function composition.
        // It may also be a separator between a module name and an identifier => no
        // operator. If it comes together with other special characters it is an
        // operator too.
        //
        // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
        /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
      ],
      // In Haskell, nearly everything is a variable, do not highlight these.
      hvariable: {
        pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
        inside: {
          punctuation: /\./
        }
      },
      constant: {
        pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
        inside: {
          punctuation: /\./
        }
      },
      punctuation: /[{}[\];(),.:]/
    }, t.languages.hs = t.languages.haskell;
  }
  return Au;
}
var xu, LS;
function ZY() {
  if (LS) return xu;
  LS = 1, xu = e, e.displayName = "haxe", e.aliases = [];
  function e(t) {
    t.languages.haxe = t.languages.extend("clike", {
      string: {
        // Strings can be multi-line
        pattern: /"(?:[^"\\]|\\[\s\S])*"/,
        greedy: !0
      },
      "class-name": [
        {
          pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
          lookbehind: !0
        },
        // based on naming convention
        /\b[A-Z]\w*/
      ],
      // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
      keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
      function: {
        pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
        greedy: !0
      },
      operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
    }), t.languages.insertBefore("haxe", "string", {
      "string-interpolation": {
        pattern: /'(?:[^'\\]|\\[\s\S])*'/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{?|\}$/,
                alias: "punctuation"
              },
              expression: {
                pattern: /[\s\S]+/,
                inside: t.languages.haxe
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.insertBefore("haxe", "class-name", {
      regex: {
        pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
        greedy: !0,
        inside: {
          "regex-flags": /\b[a-z]+$/,
          "regex-source": {
            pattern: /^(~\/)[\s\S]+(?=\/$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^~\/|\/$/
        }
      }
    }), t.languages.insertBefore("haxe", "keyword", {
      preprocessor: {
        pattern: /#(?:else|elseif|end|if)\b.*/,
        alias: "property"
      },
      metadata: {
        pattern: /@:?[\w.]+/,
        alias: "symbol"
      },
      reification: {
        pattern: /\$(?:\w+|(?=\{))/,
        alias: "important"
      }
    });
  }
  return xu;
}
var Cu, MS;
function QY() {
  if (MS) return Cu;
  MS = 1, Cu = e, e.displayName = "hcl", e.aliases = [];
  function e(t) {
    t.languages.hcl = {
      comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
      heredoc: {
        pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
        greedy: !0,
        alias: "string"
      },
      keyword: [
        {
          pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
          inside: {
            type: {
              pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
              lookbehind: !0,
              alias: "variable"
            }
          }
        },
        {
          pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
          inside: {
            type: {
              pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
              lookbehind: !0,
              alias: "variable"
            }
          }
        },
        /[\w-]+(?=\s+\{)/
      ],
      property: [/[-\w\.]+(?=\s*=(?!=))/, /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/],
      string: {
        pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
            lookbehind: !0,
            inside: {
              type: {
                pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
                lookbehind: !0,
                alias: "variable"
              },
              keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
              function: /\w+(?=\()/,
              string: {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: !0
              },
              number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
              punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
            }
          }
        }
      },
      number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
      boolean: /\b(?:false|true)\b/i,
      punctuation: /[=\[\]{}]/
    };
  }
  return Cu;
}
var Nu, PS;
function JY() {
  if (PS) return Nu;
  PS = 1;
  var e = Or();
  Nu = t, t.displayName = "hlsl", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.hlsl = n.languages.extend("c", {
      // Regarding keywords and class names:
      // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
      "class-name": [
        n.languages.c["class-name"],
        /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
      ],
      keyword: [
        // HLSL keyword
        /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
        // scalar, vector, and matrix types
        /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
      ],
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
      number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
      boolean: /\b(?:false|true)\b/
    });
  }
  return Nu;
}
var Iu, FS;
function e9() {
  if (FS) return Iu;
  FS = 1, Iu = e, e.displayName = "hoon", e.aliases = [];
  function e(t) {
    t.languages.hoon = {
      comment: {
        pattern: /::.*/,
        greedy: !0
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      constant: /%(?:\.[ny]|[\w-]+)/,
      "class-name": /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
      function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
      keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
    };
  }
  return Iu;
}
var ku, $S;
function t9() {
  if ($S) return ku;
  $S = 1, ku = e, e.displayName = "hpkp", e.aliases = [];
  function e(t) {
    t.languages.hpkp = {
      directive: {
        pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
        alias: "property"
      },
      operator: /=/,
      punctuation: /;/
    };
  }
  return ku;
}
var Ou, BS;
function n9() {
  if (BS) return Ou;
  BS = 1, Ou = e, e.displayName = "hsts", e.aliases = [];
  function e(t) {
    t.languages.hsts = {
      directive: {
        pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
        alias: "property"
      },
      operator: /=/,
      punctuation: /;/
    };
  }
  return Ou;
}
var Du, US;
function r9() {
  if (US) return Du;
  US = 1, Du = e, e.displayName = "http", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(d) {
        return RegExp("(^(?:" + d + "):[ 	]*(?![ 	]))[^]+", "i");
      }
      n.languages.http = {
        "request-line": {
          pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
          inside: {
            // HTTP Method
            method: {
              pattern: /^[A-Z]+\b/,
              alias: "property"
            },
            // Request Target e.g. http://example.com, /path/to/file
            "request-target": {
              pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
              lookbehind: !0,
              alias: "url",
              inside: n.languages.uri
            },
            // HTTP Version
            "http-version": {
              pattern: /^(\s)HTTP\/[\d.]+/,
              lookbehind: !0,
              alias: "property"
            }
          }
        },
        "response-status": {
          pattern: /^HTTP\/[\d.]+ \d+ .+/m,
          inside: {
            // HTTP Version
            "http-version": {
              pattern: /^HTTP\/[\d.]+/,
              alias: "property"
            },
            // Status Code
            "status-code": {
              pattern: /^(\s)\d+(?=\s)/,
              lookbehind: !0,
              alias: "number"
            },
            // Reason Phrase
            "reason-phrase": {
              pattern: /^(\s).+/,
              lookbehind: !0,
              alias: "string"
            }
          }
        },
        header: {
          pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
          inside: {
            "header-value": [
              {
                pattern: r(/Content-Security-Policy/.source),
                lookbehind: !0,
                alias: ["csp", "languages-csp"],
                inside: n.languages.csp
              },
              {
                pattern: r(/Public-Key-Pins(?:-Report-Only)?/.source),
                lookbehind: !0,
                alias: ["hpkp", "languages-hpkp"],
                inside: n.languages.hpkp
              },
              {
                pattern: r(/Strict-Transport-Security/.source),
                lookbehind: !0,
                alias: ["hsts", "languages-hsts"],
                inside: n.languages.hsts
              },
              {
                pattern: r(/[^:]+/.source),
                lookbehind: !0
              }
            ],
            "header-name": {
              pattern: /^[^:]+/,
              alias: "keyword"
            },
            punctuation: /^:/
          }
        }
      };
      var a = n.languages, i = {
        "application/javascript": a.javascript,
        "application/json": a.json || a.javascript,
        "application/xml": a.xml,
        "text/xml": a.xml,
        "text/html": a.html,
        "text/css": a.css,
        "text/plain": a.plain
      }, o = {
        "application/json": !0,
        "application/xml": !0
      };
      function s(d) {
        var f = d.replace(/^[a-z]+\//, ""), g = "\\w+/(?:[\\w.-]+\\+)+" + f + "(?![+\\w.-])";
        return "(?:" + d + "|" + g + ")";
      }
      var l;
      for (var c in i)
        if (i[c]) {
          l = l || {};
          var u = o[c] ? s(c) : c;
          l[c.replace(/\//g, "-")] = {
            pattern: RegExp(
              "(" + /content-type:\s*/.source + u + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ")" + // This is a little interesting:
              // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
              // However, when writing code by hand (e.g. to display on a website) people can forget about this,
              // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
              // the body does not start with a [\w-] character (as headers do).
              /[^ \t\w-][\s\S]*/.source,
              "i"
            ),
            lookbehind: !0,
            inside: i[c]
          };
        }
      l && n.languages.insertBefore("http", "header", l);
    })(t);
  }
  return Du;
}
var Lu, GS;
function a9() {
  if (GS) return Lu;
  GS = 1, Lu = e, e.displayName = "ichigojam", e.aliases = [];
  function e(t) {
    t.languages.ichigojam = {
      comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
      string: {
        pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
        greedy: !0
      },
      number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
      function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
      label: /(?:\B@\S+)/,
      operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
      punctuation: /[\[,;:()\]]/
    };
  }
  return Lu;
}
var Mu, HS;
function i9() {
  if (HS) return Mu;
  HS = 1, Mu = e, e.displayName = "icon", e.aliases = [];
  function e(t) {
    t.languages.icon = {
      comment: /#.*/,
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
        greedy: !0
      },
      number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
      "builtin-keyword": {
        pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
        alias: "variable"
      },
      directive: {
        pattern: /\$\w+/,
        alias: "builtin"
      },
      keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
      function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
      operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
      punctuation: /[\[\](){},;]/
    };
  }
  return Mu;
}
var Pu, zS;
function o9() {
  if (zS) return Pu;
  zS = 1, Pu = e, e.displayName = "icuMessageFormat", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(c, u) {
        return u <= 0 ? /[]/.source : c.replace(/<SELF>/g, function() {
          return r(c, u - 1);
        });
      }
      var a = /'[{}:=,](?:[^']|'')*'(?!')/, i = {
        pattern: /''/,
        greedy: !0,
        alias: "operator"
      }, o = {
        pattern: a,
        greedy: !0,
        inside: {
          escape: i
        }
      }, s = r(
        /\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(
          /<STR>/g,
          function() {
            return a.source;
          }
        ),
        8
      ), l = {
        pattern: RegExp(s),
        inside: {
          message: {
            pattern: /^(\{)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "message-delimiter": {
            pattern: /./,
            alias: "punctuation"
          }
        }
      };
      n.languages["icu-message-format"] = {
        argument: {
          pattern: RegExp(s),
          greedy: !0,
          inside: {
            content: {
              pattern: /^(\{)[\s\S]+(?=\}$)/,
              lookbehind: !0,
              inside: {
                "argument-name": {
                  pattern: /^(\s*)[^{}:=,\s]+/,
                  lookbehind: !0
                },
                "choice-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                  pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    punctuation: /\|/,
                    range: {
                      pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                      lookbehind: !0,
                      inside: {
                        operator: /[<#\u2264]/,
                        number: /\S+/
                      }
                    },
                    rest: null
                    // see below
                  }
                },
                "plural-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                  pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    offset: /^offset:\s*\d+/,
                    "nested-message": l,
                    selector: {
                      pattern: /=\d+|[^{}:=,\s]+/,
                      inside: {
                        keyword: /^(?:few|many|one|other|two|zero)$/
                      }
                    }
                  }
                },
                "select-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                  pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    "nested-message": l,
                    selector: {
                      pattern: /[^{}:=,\s]+/,
                      inside: {
                        keyword: /^other$/
                      }
                    }
                  }
                },
                keyword: /\b(?:choice|plural|select|selectordinal)\b/,
                "arg-type": {
                  pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                  alias: "keyword"
                },
                "arg-skeleton": {
                  pattern: /(,\s*)::[^{}:=,\s]+/,
                  lookbehind: !0
                },
                "arg-style": {
                  pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                  lookbehind: !0
                },
                "arg-style-text": {
                  pattern: RegExp(
                    /(^\s*,\s*(?=\S))/.source + r(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + "$"
                  ),
                  lookbehind: !0,
                  alias: "string"
                },
                punctuation: /,/
              }
            },
            "argument-delimiter": {
              pattern: /./,
              alias: "operator"
            }
          }
        },
        escape: i,
        string: o
      }, l.inside.message.inside = n.languages["icu-message-format"], n.languages["icu-message-format"].argument.inside.content.inside["choice-style"].inside.rest = n.languages["icu-message-format"];
    })(t);
  }
  return Pu;
}
var Fu, WS;
function s9() {
  if (WS) return Fu;
  WS = 1;
  var e = Tm();
  Fu = t, t.displayName = "idris", t.aliases = ["idr"];
  function t(n) {
    n.register(e), n.languages.idris = n.languages.extend("haskell", {
      comment: {
        pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
      },
      keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
      builtin: void 0
    }), n.languages.insertBefore("idris", "keyword", {
      "import-statement": {
        pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    }), n.languages.idr = n.languages.idris;
  }
  return Fu;
}
var $u, qS;
function l9() {
  if (qS) return $u;
  qS = 1, $u = e, e.displayName = "iecst", e.aliases = [];
  function e(t) {
    t.languages.iecst = {
      comment: [
        {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: [
        /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
        /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
      ],
      "class-name": /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
      address: {
        pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
        alias: "symbol"
      },
      number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      boolean: /\b(?:FALSE|NULL|TRUE)\b/,
      operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      punctuation: /[()[\].,;]/
    };
  }
  return $u;
}
var Bu, VS;
function c9() {
  if (VS) return Bu;
  VS = 1, Bu = e, e.displayName = "ignore", e.aliases = ["gitignore", "hgignore", "npmignore"];
  function e(t) {
    (function(n) {
      n.languages.ignore = {
        // https://git-scm.com/docs/gitignore
        comment: /^#.*/m,
        entry: {
          pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
          alias: "string",
          inside: {
            operator: /^!|\*\*?|\?/,
            regex: {
              pattern: /(^|[^\\])\[[^\[\]]*\]/,
              lookbehind: !0
            },
            punctuation: /\//
          }
        }
      }, n.languages.gitignore = n.languages.ignore, n.languages.hgignore = n.languages.ignore, n.languages.npmignore = n.languages.ignore;
    })(t);
  }
  return Bu;
}
var Uu, jS;
function u9() {
  if (jS) return Uu;
  jS = 1, Uu = e, e.displayName = "inform7", e.aliases = [];
  function e(t) {
    t.languages.inform7 = {
      string: {
        pattern: /"[^"]*"/,
        inside: {
          substitution: {
            pattern: /\[[^\[\]]+\]/,
            inside: {
              delimiter: {
                pattern: /\[|\]/,
                alias: "punctuation"
              }
              // See rest below
            }
          }
        }
      },
      comment: {
        pattern: /\[[^\[\]]+\]/,
        greedy: !0
      },
      title: {
        pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
        alias: "important"
      },
      number: {
        pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
        lookbehind: !0
      },
      verb: {
        pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
        lookbehind: !0,
        alias: "operator"
      },
      keyword: {
        pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
        lookbehind: !0
      },
      property: {
        pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
        lookbehind: !0,
        alias: "symbol"
      },
      position: {
        pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
        lookbehind: !0,
        alias: "keyword"
      },
      type: {
        pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
        lookbehind: !0,
        alias: "variable"
      },
      punctuation: /[.,:;(){}]/
    }, t.languages.inform7.string.inside.substitution.inside.rest = t.languages.inform7, t.languages.inform7.string.inside.substitution.inside.rest.text = {
      pattern: /\S(?:\s*\S)*/,
      alias: "comment"
    };
  }
  return Uu;
}
var Gu, YS;
function d9() {
  if (YS) return Gu;
  YS = 1, Gu = e, e.displayName = "ini", e.aliases = [];
  function e(t) {
    t.languages.ini = {
      /**
       * The component mimics the behavior of the Win32 API parser.
       *
       * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
       */
      comment: {
        pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
        lookbehind: !0
      },
      section: {
        pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
        lookbehind: !0,
        inside: {
          "section-name": {
            pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
            lookbehind: !0,
            alias: "selector"
          },
          punctuation: /\[|\]/
        }
      },
      key: {
        pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      value: {
        pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
        lookbehind: !0,
        alias: "attr-value",
        inside: {
          "inner-value": {
            pattern: /^("|').+(?=\1$)/,
            lookbehind: !0
          }
        }
      },
      punctuation: /=/
    };
  }
  return Gu;
}
var Hu, KS;
function f9() {
  if (KS) return Hu;
  KS = 1, Hu = e, e.displayName = "io", e.aliases = [];
  function e(t) {
    t.languages.io = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
        lookbehind: !0,
        greedy: !0
      },
      "triple-quoted-string": {
        pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /"(?:\\.|[^\\\r\n"])*"/,
        greedy: !0
      },
      keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
      builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
      boolean: /\b(?:false|nil|true)\b/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
      operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return Hu;
}
var zu, XS;
function p9() {
  if (XS) return zu;
  XS = 1, zu = e, e.displayName = "j", e.aliases = [];
  function e(t) {
    t.languages.j = {
      comment: {
        pattern: /\bNB\..*/,
        greedy: !0
      },
      string: {
        pattern: /'(?:''|[^'\r\n])*'/,
        greedy: !0
      },
      keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
      verb: {
        // Negative look-ahead prevents bad highlighting
        // of ^: ;. =. =: !. !:
        pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
        alias: "keyword"
      },
      number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
      adverb: {
        pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
        alias: "builtin"
      },
      operator: /[=a][.:]|_\./,
      conjunction: {
        pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
        alias: "variable"
      },
      punctuation: /[()]/
    };
  }
  return zu;
}
var Wu, ZS;
function Rm() {
  if (ZS) return Wu;
  ZS = 1, Wu = e, e.displayName = "java", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, a = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, i = {
        pattern: RegExp(a + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: !0,
        inside: {
          namespace: {
            pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /\./
        }
      };
      n.languages.java = n.languages.extend("clike", {
        string: {
          pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
          lookbehind: !0,
          greedy: !0
        },
        "class-name": [
          i,
          {
            // variables and parameters
            // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
            pattern: RegExp(
              a + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source
            ),
            lookbehind: !0,
            inside: i.inside
          }
        ],
        keyword: r,
        function: [
          n.languages.clike.function,
          {
            pattern: /(::\s*)[a-z_]\w*/,
            lookbehind: !0
          }
        ],
        number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
        operator: {
          pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
          lookbehind: !0
        }
      }), n.languages.insertBefore("java", "string", {
        "triple-quoted-string": {
          // http://openjdk.java.net/jeps/355#Description
          pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
          greedy: !0,
          alias: "string"
        },
        char: {
          pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
          greedy: !0
        }
      }), n.languages.insertBefore("java", "class-name", {
        annotation: {
          pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
          lookbehind: !0,
          alias: "punctuation"
        },
        generics: {
          pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
          inside: {
            "class-name": i,
            keyword: r,
            punctuation: /[<>(),.:]/,
            operator: /[?&|]/
          }
        },
        namespace: {
          pattern: RegExp(
            /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(
              /<keyword>/g,
              function() {
                return r.source;
              }
            )
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      });
    })(t);
  }
  return Wu;
}
var qu, QS;
function Bs() {
  if (QS) return qu;
  QS = 1, qu = e, e.displayName = "javadoclike", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.languages.javadoclike = {
        parameter: {
          pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
          lookbehind: !0
        },
        keyword: {
          // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
          // @word, {@word}
          pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
          lookbehind: !0
        },
        punctuation: /[{}]/
      };
      function a(o, s) {
        var l = "doc-comment", c = n.languages[o];
        if (c) {
          var u = c[l];
          if (!u) {
            var d = {};
            d[l] = {
              pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
              lookbehind: !0,
              alias: "comment"
            }, c = n.languages.insertBefore(o, "comment", d), u = c[l];
          }
          if (u instanceof RegExp && (u = c[l] = {
            pattern: u
          }), Array.isArray(u))
            for (var f = 0, g = u.length; f < g; f++)
              u[f] instanceof RegExp && (u[f] = {
                pattern: u[f]
              }), s(u[f]);
          else
            s(u);
        }
      }
      function i(o, s) {
        typeof o == "string" && (o = [o]), o.forEach(function(l) {
          a(l, function(c) {
            c.inside || (c.inside = {}), c.inside.rest = s;
          });
        });
      }
      Object.defineProperty(r, "addSupport", {
        value: i
      }), r.addSupport(["java", "javascript", "php"], r);
    })(t);
  }
  return qu;
}
var Vu, JS;
function g9() {
  if (JS) return Vu;
  JS = 1;
  var e = Rm(), t = Bs();
  Vu = n, n.displayName = "javadoc", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      var i = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m, o = /#\s*\w+(?:\s*\([^()]*\))?/.source, s = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(
        /<mem>/g,
        function() {
          return o;
        }
      );
      a.languages.javadoc = a.languages.extend("javadoclike", {}), a.languages.insertBefore("javadoc", "keyword", {
        reference: {
          pattern: RegExp(
            /(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + "(?:" + s + ")"
          ),
          lookbehind: !0,
          inside: {
            function: {
              pattern: /(#\s*)\w+(?=\s*\()/,
              lookbehind: !0
            },
            field: {
              pattern: /(#\s*)\w+/,
              lookbehind: !0
            },
            namespace: {
              pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
              inside: {
                punctuation: /\./
              }
            },
            "class-name": /\b[A-Z]\w*/,
            keyword: a.languages.java.keyword,
            punctuation: /[#()[\],.]/
          }
        },
        "class-name": {
          // @param <T> the first generic type parameter
          pattern: /(@param\s+)<[A-Z]\w*>/,
          lookbehind: !0,
          inside: {
            punctuation: /[.<>]/
          }
        },
        "code-section": [
          {
            pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
            lookbehind: !0,
            inside: {
              code: {
                // there can't be any HTML inside of {@code} tags
                pattern: i,
                lookbehind: !0,
                inside: a.languages.java,
                alias: "language-java"
              }
            }
          },
          {
            pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
            lookbehind: !0,
            inside: {
              line: {
                pattern: i,
                lookbehind: !0,
                inside: {
                  // highlight HTML tags and entities
                  tag: a.languages.markup.tag,
                  entity: a.languages.markup.entity,
                  code: {
                    // everything else is Java code
                    pattern: /.+/,
                    inside: a.languages.java,
                    alias: "language-java"
                  }
                }
              }
            }
          }
        ],
        tag: a.languages.markup.tag,
        entity: a.languages.markup.entity
      }), a.languages.javadoclike.addSupport("java", a.languages.javadoc);
    }(r);
  }
  return Vu;
}
var ju, ew;
function h9() {
  if (ew) return ju;
  ew = 1, ju = e, e.displayName = "javastacktrace", e.aliases = [];
  function e(t) {
    t.languages.javastacktrace = {
      // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
      // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
      // Caused by: com.example.myproject.MyProjectServletException
      // Caused by: MidLevelException: LowLevelException
      // Suppressed: Resource$CloseFailException: Resource ID = 0
      summary: {
        pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
            lookbehind: !0
          },
          // the current thread if the summary starts with 'Exception in thread'
          string: {
            pattern: /^(\s*)"[^"]*"/,
            lookbehind: !0
          },
          exceptions: {
            pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
            lookbehind: !0,
            inside: {
              "class-name": /[\w$]+$/,
              namespace: /\b[a-z]\w*\b/,
              punctuation: /\./
            }
          },
          message: {
            pattern: /(:\s*)\S.*/,
            lookbehind: !0,
            alias: "string"
          },
          punctuation: /:/
        }
      },
      // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
      // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
      // at java.base/java.lang.Class.forName0(Native Method)
      // at Util.<init>(Unknown Source)
      // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
      // at com.foo.loader//com.foo.bar.App.run(App.java:12)
      // at acme@2.1/org.acme.Lib.test(Lib.java:80)
      // at MyClass.mash(MyClass.java:9)
      //
      // More information:
      // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
      //
      // A valid Java module name is defined as:
      //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
      // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
      //
      // A Java module version is defined by this class:
      // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
      // This is the implementation of the `parse` method in JDK13:
      // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
      // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
      "stack-frame": {
        pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /^(\s*)at(?= )/,
            lookbehind: !0
          },
          source: [
            // (Main.java:15)
            // (Main.scala:15)
            {
              pattern: /(\()\w+\.\w+:\d+(?=\))/,
              lookbehind: !0,
              inside: {
                file: /^\w+\.\w+/,
                punctuation: /:/,
                "line-number": {
                  pattern: /\b\d+\b/,
                  alias: "number"
                }
              }
            },
            // (Unknown Source)
            // (Native Method)
            // (...something...)
            {
              pattern: /(\()[^()]*(?=\))/,
              lookbehind: !0,
              inside: {
                keyword: /^(?:Native Method|Unknown Source)$/
              }
            }
          ],
          "class-name": /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
          function: /(?:<init>|[\w$]+)(?=\()/,
          "class-loader": {
            pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
            lookbehind: !0,
            alias: "namespace",
            inside: {
              punctuation: /\./
            }
          },
          module: {
            pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
            lookbehind: !0,
            inside: {
              version: {
                pattern: /(@)[\s\S]+/,
                lookbehind: !0,
                alias: "number"
              },
              punctuation: /[@.]/
            }
          },
          namespace: {
            pattern: /(?:\b[a-z]\w*\.)+/,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[()/.]/
        }
      },
      // ... 32 more
      // ... 32 common frames omitted
      more: {
        pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /\.{3}/,
          number: /\d+/,
          keyword: /\b[a-z]+(?: [a-z]+)*\b/
        }
      }
    };
  }
  return ju;
}
var Yu, tw;
function m9() {
  if (tw) return Yu;
  tw = 1, Yu = e, e.displayName = "jexl", e.aliases = [];
  function e(t) {
    t.languages.jexl = {
      string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
      transform: {
        pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
        alias: "function",
        lookbehind: !0
      },
      function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
      number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
      operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
      boolean: /\b(?:false|true)\b/,
      keyword: /\bin\b/,
      punctuation: /[{}[\](),.]/
    };
  }
  return Yu;
}
var Ku, nw;
function b9() {
  if (nw) return Ku;
  nw = 1, Ku = e, e.displayName = "jolie", e.aliases = [];
  function e(t) {
    t.languages.jolie = t.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": {
        pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
        lookbehind: !0
      },
      keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
      function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
      operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
      punctuation: /[()[\]{},;.:]/,
      builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
    }), t.languages.insertBefore("jolie", "keyword", {
      aggregates: {
        pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
        lookbehind: !0,
        inside: {
          keyword: /\bwith\b/,
          "class-name": /\w+/,
          punctuation: /,/
        }
      },
      redirects: {
        pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
        lookbehind: !0,
        inside: {
          punctuation: /,/,
          "class-name": /\w+/,
          operator: /=>/
        }
      },
      property: {
        pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
      }
    });
  }
  return Ku;
}
var Xu, rw;
function v9() {
  if (rw) return Xu;
  rw = 1, Xu = e, e.displayName = "jq", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\\\((?:[^()]|\([^()]*\))*\)/.source, a = RegExp(
        /(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(
          /__/g,
          function() {
            return r;
          }
        )
      ), i = {
        interpolation: {
          pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + r),
          lookbehind: !0,
          inside: {
            content: {
              pattern: /^(\\\()[\s\S]+(?=\)$)/,
              lookbehind: !0,
              inside: null
              // see below
            },
            punctuation: /^\\\(|\)$/
          }
        }
      }, o = n.languages.jq = {
        comment: /#.*/,
        property: {
          pattern: RegExp(a.source + /(?=\s*:(?!:))/.source),
          lookbehind: !0,
          greedy: !0,
          inside: i
        },
        string: {
          pattern: a,
          lookbehind: !0,
          greedy: !0,
          inside: i
        },
        function: {
          pattern: /(\bdef\s+)[a-z_]\w+/i,
          lookbehind: !0
        },
        variable: /\B\$\w+/,
        "property-literal": {
          pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
          alias: "property"
        },
        keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
        operator: [
          {
            pattern: /\|=?/,
            alias: "pipe"
          },
          /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
        ],
        "c-style-function": {
          pattern: /\b[a-z_]\w*(?=\s*\()/i,
          alias: "function"
        },
        punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
        dot: {
          pattern: /\./,
          alias: "important"
        }
      };
      i.interpolation.inside.content.inside = o;
    })(t);
  }
  return Xu;
}
var Zu, aw;
function y9() {
  if (aw) return Zu;
  aw = 1, Zu = e, e.displayName = "jsExtras", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
          pattern: RegExp(
            "(\\.\\s*)" + n.languages.javascript["function-variable"].pattern.source
          ),
          lookbehind: !0,
          alias: ["function-variable", "method", "function", "property-access"]
        }
      }), n.languages.insertBefore("javascript", "function", {
        method: {
          pattern: RegExp(
            "(\\.\\s*)" + n.languages.javascript.function.source
          ),
          lookbehind: !0,
          alias: ["function", "property-access"]
        }
      }), n.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
          {
            // standard built-ins
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
            pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
            alias: "class-name"
          },
          {
            // errors
            pattern: /\b(?:[A-Z]\w*)Error\b/,
            alias: "class-name"
          }
        ]
      });
      function r(c, u) {
        return RegExp(
          c.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
          }),
          u
        );
      }
      n.languages.insertBefore("javascript", "keyword", {
        imports: {
          // https://tc39.es/ecma262/#sec-imports
          pattern: r(
            /(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source
          ),
          lookbehind: !0,
          inside: n.languages.javascript
        },
        exports: {
          // https://tc39.es/ecma262/#sec-exports
          pattern: r(
            /(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source
          ),
          lookbehind: !0,
          inside: n.languages.javascript
        }
      }), n.languages.javascript.keyword.unshift(
        {
          pattern: /\b(?:as|default|export|from|import)\b/,
          alias: "module"
        },
        {
          pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
          alias: "control-flow"
        },
        {
          pattern: /\bnull\b/,
          alias: ["null", "nil"]
        },
        {
          pattern: /\bundefined\b/,
          alias: "nil"
        }
      ), n.languages.insertBefore("javascript", "operator", {
        spread: {
          pattern: /\.{3}/,
          alias: "operator"
        },
        arrow: {
          pattern: /=>/,
          alias: "operator"
        }
      }), n.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
          pattern: r(/(\.\s*)#?<ID>/.source),
          lookbehind: !0
        },
        "maybe-class-name": {
          pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
          lookbehind: !0
        },
        dom: {
          // this contains only a few commonly used DOM variables
          pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
          alias: "variable"
        },
        console: {
          pattern: /\bconsole(?=\s*\.)/,
          alias: "class-name"
        }
      });
      for (var a = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
      ], i = 0; i < a.length; i++) {
        var o = a[i], s = n.languages.javascript[o];
        n.util.type(s) === "RegExp" && (s = n.languages.javascript[o] = {
          pattern: s
        });
        var l = s.inside || {};
        s.inside = l, l["maybe-class-name"] = /^[A-Z][\s\S]*/;
      }
    })(t);
  }
  return Zu;
}
var Qu, iw;
function E9() {
  if (iw) return Qu;
  iw = 1, Qu = e, e.displayName = "jsTemplates", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.languages.javascript["template-string"], a = r.pattern.source, i = r.inside.interpolation, o = i.inside["interpolation-punctuation"], s = i.pattern.source;
      function l(p, m) {
        if (n.languages[p])
          return {
            pattern: RegExp("((?:" + m + ")\\s*)" + a),
            lookbehind: !0,
            greedy: !0,
            inside: {
              "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
              },
              "embedded-code": {
                pattern: /[\s\S]+/,
                alias: p
              }
            }
          };
      }
      n.languages.javascript["template-string"] = [
        // styled-jsx:
        //   css`a { color: #25F; }`
        // styled-components:
        //   styled.h1`color: red;`
        l(
          "css",
          /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source
        ),
        // html`<p></p>`
        // div.innerHTML = `<p></p>`
        l("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        // svg`<path fill="#fff" d="M55.37 ..."/>`
        l("svg", /\bsvg/.source),
        // md`# h1`, markdown`## h2`
        l("markdown", /\b(?:markdown|md)/.source),
        // gql`...`, graphql`...`, graphql.experimental`...`
        l(
          "graphql",
          /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source
        ),
        // sql`...`
        l("sql", /\bsql/.source),
        // vanilla template string
        r
      ].filter(Boolean);
      function c(p, m) {
        return "___" + m.toUpperCase() + "_" + p + "___";
      }
      function u(p, m, v) {
        var y = {
          code: p,
          grammar: m,
          language: v
        };
        return n.hooks.run("before-tokenize", y), y.tokens = n.tokenize(y.code, y.grammar), n.hooks.run("after-tokenize", y), y.tokens;
      }
      function d(p) {
        var m = {};
        m["interpolation-punctuation"] = o;
        var v = n.tokenize(p, m);
        if (v.length === 3) {
          var y = [1, 1];
          y.push.apply(
            y,
            u(v[1], n.languages.javascript, "javascript")
          ), v.splice.apply(v, y);
        }
        return new n.Token(
          "interpolation",
          v,
          i.alias,
          p
        );
      }
      function f(p, m, v) {
        var y = n.tokenize(p, {
          interpolation: {
            pattern: RegExp(s),
            lookbehind: !0
          }
        }), E = 0, S = {}, w = y.map(function(C) {
          if (typeof C == "string")
            return C;
          for (var N = C.content, L; p.indexOf(
            L = c(E++, v)
          ) !== -1; )
            ;
          return S[L] = N, L;
        }).join(""), R = u(w, m, v), T = Object.keys(S);
        E = 0;
        function A(C) {
          for (var N = 0; N < C.length; N++) {
            if (E >= T.length)
              return;
            var L = C[N];
            if (typeof L == "string" || typeof L.content == "string") {
              var I = T[E], k = typeof L == "string" ? L : (
                /** @type {string} */
                L.content
              ), B = k.indexOf(I);
              if (B !== -1) {
                ++E;
                var F = k.substring(0, B), P = d(
                  S[I]
                ), D = k.substring(B + I.length), O = [];
                if (F && O.push(F), O.push(P), D) {
                  var M = [D];
                  A(M), O.push.apply(O, M);
                }
                typeof L == "string" ? (C.splice.apply(C, [N, 1].concat(O)), N += O.length - 1) : L.content = O;
              }
            } else {
              var W = L.content;
              Array.isArray(W) ? A(W) : A([W]);
            }
          }
        }
        return A(R), new n.Token(
          v,
          R,
          "language-" + v,
          p
        );
      }
      var g = {
        javascript: !0,
        js: !0,
        typescript: !0,
        ts: !0,
        jsx: !0,
        tsx: !0
      };
      n.hooks.add("after-tokenize", function(p) {
        if (!(p.language in g))
          return;
        function m(v) {
          for (var y = 0, E = v.length; y < E; y++) {
            var S = v[y];
            if (typeof S != "string") {
              var w = S.content;
              if (!Array.isArray(w)) {
                typeof w != "string" && m([w]);
                continue;
              }
              if (S.type === "template-string") {
                var R = w[1];
                if (w.length === 3 && typeof R != "string" && R.type === "embedded-code") {
                  var T = h(R), A = R.alias, C = Array.isArray(A) ? A[0] : A, N = n.languages[C];
                  if (!N)
                    continue;
                  w[1] = f(T, N, C);
                }
              } else
                m(w);
            }
          }
        }
        m(p.tokens);
      });
      function h(p) {
        return typeof p == "string" ? p : Array.isArray(p) ? p.map(h).join("") : h(p.content);
      }
    })(t);
  }
  return Qu;
}
var Ju, ow;
function Am() {
  if (ow) return Ju;
  ow = 1, Ju = e, e.displayName = "typescript", e.aliases = ["ts"];
  function e(t) {
    (function(n) {
      n.languages.typescript = n.languages.extend("javascript", {
        "class-name": {
          pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
      }), n.languages.typescript.keyword.push(
        /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
        // keywords that have to be followed by an identifier
        /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
        // This is for `import type *, {}`
        /\btype\b(?=\s*(?:[\{*]|$))/
      ), delete n.languages.typescript.parameter, delete n.languages.typescript["literal-property"];
      var r = n.languages.extend("typescript", {});
      delete r["class-name"], n.languages.typescript["class-name"].inside = r, n.languages.insertBefore("typescript", "function", {
        decorator: {
          pattern: /@[$\w\xA0-\uFFFF]+/,
          inside: {
            at: {
              pattern: /^@/,
              alias: "operator"
            },
            function: /^[\s\S]+/
          }
        },
        "generic-function": {
          // e.g. foo<T extends "bar" | "baz">( ...
          pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
          greedy: !0,
          inside: {
            function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
            generic: {
              pattern: /<[\s\S]+/,
              // everything after the first <
              alias: "class-name",
              inside: r
            }
          }
        }
      }), n.languages.ts = n.languages.typescript;
    })(t);
  }
  return Ju;
}
var ed, sw;
function S9() {
  if (sw) return ed;
  sw = 1;
  var e = Bs(), t = Am();
  ed = n, n.displayName = "jsdoc", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      var i = a.languages.javascript, o = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, s = "(@(?:arg|argument|param|property)\\s+(?:" + o + "\\s+)?)";
      a.languages.jsdoc = a.languages.extend("javadoclike", {
        parameter: {
          // @param {string} foo - foo bar
          pattern: RegExp(
            s + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      }), a.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
          // @param {string} [baz.foo="bar"] foo bar
          pattern: RegExp(
            s + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source
          ),
          lookbehind: !0,
          inside: {
            parameter: {
              pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
              lookbehind: !0,
              inside: {
                punctuation: /\./
              }
            },
            code: {
              pattern: /(=)[\s\S]*(?=\]$)/,
              lookbehind: !0,
              inside: i,
              alias: "language-javascript"
            },
            punctuation: /[=[\]]/
          }
        },
        "class-name": [
          {
            pattern: RegExp(
              /(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(
                /<TYPE>/g,
                function() {
                  return o;
                }
              )
            ),
            lookbehind: !0,
            inside: {
              punctuation: /\./
            }
          },
          {
            pattern: RegExp("(@[a-z]+\\s+)" + o),
            lookbehind: !0,
            inside: {
              string: i.string,
              number: i.number,
              boolean: i.boolean,
              keyword: a.languages.typescript.keyword,
              operator: /=>|\.\.\.|[&|?:*]/,
              punctuation: /[.,;=<>{}()[\]]/
            }
          }
        ],
        example: {
          pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
          lookbehind: !0,
          inside: {
            code: {
              pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
              lookbehind: !0,
              inside: i,
              alias: "language-javascript"
            }
          }
        }
      }), a.languages.javadoclike.addSupport("javascript", a.languages.jsdoc);
    }(r);
  }
  return ed;
}
var td, lw;
function xm() {
  if (lw) return td;
  lw = 1, td = e, e.displayName = "json", e.aliases = ["webmanifest"];
  function e(t) {
    t.languages.json = {
      property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      punctuation: /[{}[\],]/,
      operator: /:/,
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      }
    }, t.languages.webmanifest = t.languages.json;
  }
  return td;
}
var nd, cw;
function w9() {
  if (cw) return nd;
  cw = 1;
  var e = xm();
  nd = t, t.displayName = "json5", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
      r.languages.json5 = r.languages.extend("json", {
        property: [
          {
            pattern: RegExp(a.source + "(?=\\s*:)"),
            greedy: !0
          },
          {
            pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
            alias: "unquoted"
          }
        ],
        string: {
          pattern: a,
          greedy: !0
        },
        number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
      });
    }(n);
  }
  return nd;
}
var rd, uw;
function _9() {
  if (uw) return rd;
  uw = 1;
  var e = xm();
  rd = t, t.displayName = "jsonp", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.jsonp = n.languages.extend("json", {
      punctuation: /[{}[\]();,.]/
    }), n.languages.insertBefore("jsonp", "punctuation", {
      function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
    });
  }
  return rd;
}
var ad, dw;
function T9() {
  if (dw) return ad;
  dw = 1, ad = e, e.displayName = "jsstacktrace", e.aliases = [];
  function e(t) {
    t.languages.jsstacktrace = {
      "error-message": {
        pattern: /^\S.*/m,
        alias: "string"
      },
      "stack-frame": {
        pattern: /(^[ \t]+)at[ \t].*/m,
        lookbehind: !0,
        inside: {
          "not-my-code": {
            pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
            alias: "comment"
          },
          filename: {
            pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
            lookbehind: !0,
            alias: "url"
          },
          function: {
            pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
            lookbehind: !0,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[()]/,
          keyword: /\b(?:at|new)\b/,
          alias: {
            pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
            alias: "variable"
          },
          "line-number": {
            pattern: /:\d+(?::\d+)?\b/,
            alias: "number",
            inside: {
              punctuation: /:/
            }
          }
        }
      }
    };
  }
  return ad;
}
var id, fw;
function Dk() {
  if (fw) return id;
  fw = 1, id = e, e.displayName = "jsx", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.util.clone(n.languages.javascript), a = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, i = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, o = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
      function s(u, d) {
        return u = u.replace(/<S>/g, function() {
          return a;
        }).replace(/<BRACES>/g, function() {
          return i;
        }).replace(/<SPREAD>/g, function() {
          return o;
        }), RegExp(u, d);
      }
      o = s(o).source, n.languages.jsx = n.languages.extend("markup", r), n.languages.jsx.tag.pattern = s(
        /<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
      ), n.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, n.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, n.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, n.languages.jsx.tag.inside.comment = r.comment, n.languages.insertBefore(
        "inside",
        "attr-name",
        {
          spread: {
            pattern: s(/<SPREAD>/.source),
            inside: n.languages.jsx
          }
        },
        n.languages.jsx.tag
      ), n.languages.insertBefore(
        "inside",
        "special-attr",
        {
          script: {
            // Allow for two levels of nesting
            pattern: s(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
              "script-punctuation": {
                pattern: /^=(?=\{)/,
                alias: "punctuation"
              },
              rest: n.languages.jsx
            }
          }
        },
        n.languages.jsx.tag
      );
      var l = function(u) {
        return u ? typeof u == "string" ? u : typeof u.content == "string" ? u.content : u.content.map(l).join("") : "";
      }, c = function(u) {
        for (var d = [], f = 0; f < u.length; f++) {
          var g = u[f], h = !1;
          if (typeof g != "string" && (g.type === "tag" && g.content[0] && g.content[0].type === "tag" ? g.content[0].content[0].content === "</" ? d.length > 0 && d[d.length - 1].tagName === l(g.content[0].content[1]) && d.pop() : g.content[g.content.length - 1].content === "/>" || d.push({
            tagName: l(g.content[0].content[1]),
            openedBraces: 0
          }) : d.length > 0 && g.type === "punctuation" && g.content === "{" ? d[d.length - 1].openedBraces++ : d.length > 0 && d[d.length - 1].openedBraces > 0 && g.type === "punctuation" && g.content === "}" ? d[d.length - 1].openedBraces-- : h = !0), (h || typeof g == "string") && d.length > 0 && d[d.length - 1].openedBraces === 0) {
            var p = l(g);
            f < u.length - 1 && (typeof u[f + 1] == "string" || u[f + 1].type === "plain-text") && (p += l(u[f + 1]), u.splice(f + 1, 1)), f > 0 && (typeof u[f - 1] == "string" || u[f - 1].type === "plain-text") && (p = l(u[f - 1]) + p, u.splice(f - 1, 1), f--), u[f] = new n.Token(
              "plain-text",
              p,
              null,
              p
            );
          }
          g.content && typeof g.content != "string" && c(g.content);
        }
      };
      n.hooks.add("after-tokenize", function(u) {
        u.language !== "jsx" && u.language !== "tsx" || c(u.tokens);
      });
    })(t);
  }
  return id;
}
var od, pw;
function R9() {
  if (pw) return od;
  pw = 1, od = e, e.displayName = "julia", e.aliases = [];
  function e(t) {
    t.languages.julia = {
      comment: {
        // support one level of nested comments
        // https://github.com/JuliaLang/julia/pull/6128
        pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
        lookbehind: !0
      },
      regex: {
        // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
        pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
        greedy: !0
      },
      string: {
        // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
        // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
        // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
        pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
        greedy: !0
      },
      char: {
        // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
        pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
      // https://docs.julialang.org/en/v1/manual/mathematical-operations/
      // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
      operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
      punctuation: /::?|[{}[\]();,.?]/,
      // https://docs.julialang.org/en/v1/base/numbers/#Base.im
      constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
    };
  }
  return od;
}
var sd, gw;
function A9() {
  if (gw) return sd;
  gw = 1, sd = e, e.displayName = "keepalived", e.aliases = [];
  function e(t) {
    t.languages.keepalived = {
      comment: {
        pattern: /[#!].*/,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
        lookbehind: !0,
        greedy: !0
      },
      // support IPv4, IPv6, subnet mask
      ip: {
        pattern: RegExp(
          /\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(
            /<ipv4>/g,
            function() {
              return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
            }
          ),
          "i"
        ),
        alias: "number"
      },
      // support *nix / Windows, directory / file
      path: {
        pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
        lookbehind: !0,
        alias: "string"
      },
      variable: /\$\{?\w+\}?/,
      email: {
        pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
        alias: "string"
      },
      "conditional-configuration": {
        pattern: /@\^?[\w-]+/,
        alias: "variable"
      },
      operator: /=/,
      property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
      constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
      number: {
        pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
        lookbehind: !0
      },
      boolean: /\b(?:false|no|off|on|true|yes)\b/,
      punctuation: /[\{\}]/
    };
  }
  return sd;
}
var ld, hw;
function x9() {
  if (hw) return ld;
  hw = 1, ld = e, e.displayName = "keyman", e.aliases = [];
  function e(t) {
    t.languages.keyman = {
      comment: {
        pattern: /\bc .*/i,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
        greedy: !0
      },
      "virtual-key": {
        pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
        greedy: !0,
        alias: "function"
        // alias for styles
      },
      // https://help.keyman.com/developer/language/guide/headers
      "header-keyword": {
        pattern: /&\w+/,
        alias: "bold"
        // alias for styles
      },
      "header-statement": {
        pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
        alias: "bold"
        // alias for styles
      },
      "rule-keyword": {
        pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
        alias: "keyword"
      },
      "structural-keyword": {
        pattern: /\b(?:ansi|begin|group|match|nomatch|unicode|using keys)\b/i,
        alias: "keyword"
      },
      "compile-target": {
        pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
        alias: "property"
      },
      // U+####, x###, d### characters and numbers
      number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
      operator: /[+>\\$]|\.\./,
      punctuation: /[()=,]/
    };
  }
  return ld;
}
var cd, mw;
function C9() {
  if (mw) return cd;
  mw = 1, cd = e, e.displayName = "kotlin", e.aliases = ["kt", "kts"];
  function e(t) {
    (function(n) {
      n.languages.kotlin = n.languages.extend("clike", {
        keyword: {
          // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
          pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
          lookbehind: !0
        },
        function: [
          {
            pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
            greedy: !0
          },
          {
            pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
      }), delete n.languages.kotlin["class-name"];
      var r = {
        "interpolation-punctuation": {
          pattern: /^\$\{?|\}$/,
          alias: "punctuation"
        },
        expression: {
          pattern: /[\s\S]+/,
          inside: n.languages.kotlin
        }
      };
      n.languages.insertBefore("kotlin", "string", {
        // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
        "string-literal": [
          {
            pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
            alias: "multiline",
            inside: {
              interpolation: {
                pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                inside: r
              },
              string: /[\s\S]+/
            }
          },
          {
            pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
            alias: "singleline",
            inside: {
              interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                lookbehind: !0,
                inside: r
              },
              string: /[\s\S]+/
            }
          }
        ],
        char: {
          // https://kotlinlang.org/spec/expressions.html#character-literals
          pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
          greedy: !0
        }
      }), delete n.languages.kotlin.string, n.languages.insertBefore("kotlin", "keyword", {
        annotation: {
          pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
          alias: "builtin"
        }
      }), n.languages.insertBefore("kotlin", "function", {
        label: {
          pattern: /\b\w+@|@\w+\b/,
          alias: "symbol"
        }
      }), n.languages.kt = n.languages.kotlin, n.languages.kts = n.languages.kotlin;
    })(t);
  }
  return cd;
}
var ud, bw;
function N9() {
  if (bw) return ud;
  bw = 1, ud = e, e.displayName = "kumir", e.aliases = ["kum"];
  function e(t) {
    (function(n) {
      var r = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
      function a(i, o) {
        return RegExp(i.replace(/<nonId>/g, r), o);
      }
      n.languages.kumir = {
        comment: {
          pattern: /\|.*/
        },
        prolog: {
          pattern: /#.*/,
          greedy: !0
        },
        string: {
          pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
          greedy: !0
        },
        boolean: {
          pattern: a(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
          lookbehind: !0
        },
        "operator-word": {
          pattern: a(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        "system-variable": {
          pattern: a(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        type: [
          {
            pattern: a(
              /(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source
            ),
            lookbehind: !0,
            alias: "builtin"
          },
          {
            pattern: a(
              /(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source
            ),
            lookbehind: !0,
            alias: "important"
          }
        ],
        /**
         * Should be performed after searching for type names because of "таб".
         * "таб" is a reserved word, but never used without a preceding type name.
         * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
         */
        keyword: {
          pattern: a(
            /(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for reserved words. */
        name: {
          // eslint-disable-next-line regexp/no-super-linear-backtracking
          pattern: a(
            /(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for names. */
        number: {
          pattern: a(
            /(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source,
            "i"
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for words. */
        punctuation: /:=|[(),:;\[\]]/,
        /**
         * Should be performed after searching for
         * - numeric constants (because of "+" and "-");
         * - punctuation marks (because of ":=" and "=").
         */
        "operator-char": {
          pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
          alias: "operator"
        }
      }, n.languages.kum = n.languages.kumir;
    })(t);
  }
  return ud;
}
var dd, vw;
function I9() {
  if (vw) return dd;
  vw = 1, dd = e, e.displayName = "kusto", e.aliases = [];
  function e(t) {
    t.languages.kusto = {
      comment: {
        pattern: /\/\/.*/,
        greedy: !0
      },
      string: {
        pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
        greedy: !0
      },
      verb: {
        pattern: /(\|\s*)[a-z][\w-]*/i,
        lookbehind: !0,
        alias: "keyword"
      },
      command: {
        pattern: /\.[a-z][a-z\d-]*\b/,
        alias: "keyword"
      },
      "class-name": /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
      keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
      boolean: /\b(?:false|null|true)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/,
      datetime: [
        {
          // RFC 822 + RFC 850
          pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
          alias: "number"
        },
        {
          // ISO 8601
          pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
          alias: "number"
        }
      ],
      number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
      operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
      punctuation: /[()\[\]{},;.:]/
    };
  }
  return dd;
}
var fd, yw;
function k9() {
  if (yw) return fd;
  yw = 1, fd = e, e.displayName = "latex", e.aliases = ["tex", "context"];
  function e(t) {
    (function(n) {
      var r = /\\(?:[^a-z()[\]]|[a-z*]+)/i, a = {
        "equation-command": {
          pattern: r,
          alias: "regex"
        }
      };
      n.languages.latex = {
        comment: /%.*/,
        // the verbatim environment prints whitespace to the document
        cdata: {
          pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
          lookbehind: !0
        },
        /*
         * equations can be between $$ $$ or $ $ or \( \) or \[ \]
         * (all are multiline)
         */
        equation: [
          {
            pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
            inside: a,
            alias: "string"
          },
          {
            pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
            lookbehind: !0,
            inside: a,
            alias: "string"
          }
        ],
        /*
         * arguments which are keywords or references are highlighted
         * as keywords
         */
        keyword: {
          pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
          lookbehind: !0
        },
        url: {
          pattern: /(\\url\{)[^}]+(?=\})/,
          lookbehind: !0
        },
        /*
         * section or chapter headlines are highlighted as bold so that
         * they stand out more
         */
        headline: {
          pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
          lookbehind: !0,
          alias: "class-name"
        },
        function: {
          pattern: r,
          alias: "selector"
        },
        punctuation: /[[\]{}&]/
      }, n.languages.tex = n.languages.latex, n.languages.context = n.languages.latex;
    })(t);
  }
  return fd;
}
var pd, Ew;
function Us() {
  if (Ew) return pd;
  Ew = 1;
  var e = yt();
  pd = t, t.displayName = "php", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/, i = [
        {
          pattern: /\b(?:false|true)\b/i,
          alias: "boolean"
        },
        {
          pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
          greedy: !0,
          lookbehind: !0
        },
        /\b(?:null)\b/i,
        /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
      ], o = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i, s = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/, l = /[{}\[\](),:;]/;
      r.languages.php = {
        delimiter: {
          pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
          alias: "important"
        },
        comment: a,
        variable: /\$+(?:\w+\b|(?=\{))/,
        package: {
          pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        "class-name-definition": {
          pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
          lookbehind: !0,
          alias: "class-name"
        },
        "function-definition": {
          pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
          lookbehind: !0,
          alias: "function"
        },
        keyword: [
          {
            pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
            alias: "type-casting",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
            alias: "type-hint",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string|void)\b/i,
            alias: "return-type",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
            alias: "type-declaration",
            greedy: !0
          },
          {
            pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
            alias: "type-declaration",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b(?:parent|self|static)(?=\s*::)/i,
            alias: "static-context",
            greedy: !0
          },
          {
            // yield from
            pattern: /(\byield\s+)from\b/i,
            lookbehind: !0
          },
          // `class` is always a keyword unlike other keywords
          /\bclass\b/i,
          {
            // https://www.php.net/manual/en/reserved.keywords.php
            //
            // keywords cannot be preceded by "->"
            // the complex lookbehind means `(?<!(?:->|::)\s*)`
            pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
            lookbehind: !0
          }
        ],
        "argument-name": {
          pattern: /([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i,
          lookbehind: !0
        },
        "class-name": [
          {
            pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
            greedy: !0
          },
          {
            pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /\b[a-z_]\w*(?=\s*\$)/i,
            alias: "type-declaration",
            greedy: !0
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
            alias: ["class-name-fully-qualified", "type-declaration"],
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /\b[a-z_]\w*(?=\s*::)/i,
            alias: "static-context",
            greedy: !0
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
            alias: ["class-name-fully-qualified", "static-context"],
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
            alias: "type-hint",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
            alias: ["class-name-fully-qualified", "type-hint"],
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
            alias: "return-type",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
            alias: ["class-name-fully-qualified", "return-type"],
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          }
        ],
        constant: i,
        function: {
          pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        property: {
          pattern: /(->\s*)\w+/,
          lookbehind: !0
        },
        number: o,
        operator: s,
        punctuation: l
      };
      var c = {
        pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
        lookbehind: !0,
        inside: r.languages.php
      }, u = [
        {
          pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
          alias: "nowdoc-string",
          greedy: !0,
          inside: {
            delimiter: {
              pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
              alias: "symbol",
              inside: {
                punctuation: /^<<<'?|[';]$/
              }
            }
          }
        },
        {
          pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
          alias: "heredoc-string",
          greedy: !0,
          inside: {
            delimiter: {
              pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
              alias: "symbol",
              inside: {
                punctuation: /^<<<"?|[";]$/
              }
            },
            interpolation: c
          }
        },
        {
          pattern: /`(?:\\[\s\S]|[^\\`])*`/,
          alias: "backtick-quoted-string",
          greedy: !0
        },
        {
          pattern: /'(?:\\[\s\S]|[^\\'])*'/,
          alias: "single-quoted-string",
          greedy: !0
        },
        {
          pattern: /"(?:\\[\s\S]|[^\\"])*"/,
          alias: "double-quoted-string",
          greedy: !0,
          inside: {
            interpolation: c
          }
        }
      ];
      r.languages.insertBefore("php", "variable", {
        string: u,
        attribute: {
          pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
          greedy: !0,
          inside: {
            "attribute-content": {
              pattern: /^(#\[)[\s\S]+(?=\]$)/,
              lookbehind: !0,
              // inside can appear subset of php
              inside: {
                comment: a,
                string: u,
                "attribute-class-name": [
                  {
                    pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                    alias: "class-name",
                    greedy: !0,
                    lookbehind: !0
                  },
                  {
                    pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                    alias: ["class-name", "class-name-fully-qualified"],
                    greedy: !0,
                    lookbehind: !0,
                    inside: {
                      punctuation: /\\/
                    }
                  }
                ],
                constant: i,
                number: o,
                operator: s,
                punctuation: l
              }
            },
            delimiter: {
              pattern: /^#\[|\]$/,
              alias: "punctuation"
            }
          }
        }
      }), r.hooks.add("before-tokenize", function(d) {
        if (/<\?/.test(d.code)) {
          var f = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
          r.languages["markup-templating"].buildPlaceholders(
            d,
            "php",
            f
          );
        }
      }), r.hooks.add("after-tokenize", function(d) {
        r.languages["markup-templating"].tokenizePlaceholders(d, "php");
      });
    }(n);
  }
  return pd;
}
var gd, Sw;
function O9() {
  if (Sw) return gd;
  Sw = 1;
  var e = yt(), t = Us();
  gd = n, n.displayName = "latte", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      a.languages.latte = {
        comment: /^\{\*[\s\S]*/,
        "latte-tag": {
          // https://latte.nette.org/en/tags
          pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
          lookbehind: !0,
          alias: "important"
        },
        delimiter: {
          pattern: /^\{\/?|\}$/,
          alias: "punctuation"
        },
        php: {
          pattern: /\S(?:[\s\S]*\S)?/,
          alias: "language-php",
          inside: a.languages.php
        }
      };
      var i = a.languages.extend("markup", {});
      a.languages.insertBefore(
        "inside",
        "attr-value",
        {
          "n-attr": {
            pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
            inside: {
              "attr-name": {
                pattern: /^[^\s=]+/,
                alias: "important"
              },
              "attr-value": {
                pattern: /=[\s\S]+/,
                inside: {
                  punctuation: [
                    /^=/,
                    {
                      pattern: /^(\s*)["']|["']$/,
                      lookbehind: !0
                    }
                  ],
                  php: {
                    pattern: /\S(?:[\s\S]*\S)?/,
                    inside: a.languages.php
                  }
                }
              }
            }
          }
        },
        i.tag
      ), a.hooks.add("before-tokenize", function(o) {
        if (o.language === "latte") {
          var s = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
          a.languages["markup-templating"].buildPlaceholders(
            o,
            "latte",
            s
          ), o.grammar = i;
        }
      }), a.hooks.add("after-tokenize", function(o) {
        a.languages["markup-templating"].tokenizePlaceholders(o, "latte");
      });
    }(r);
  }
  return gd;
}
var hd, ww;
function D9() {
  if (ww) return hd;
  ww = 1, hd = e, e.displayName = "less", e.aliases = [];
  function e(t) {
    t.languages.less = t.languages.extend("css", {
      comment: [
        /\/\*[\s\S]*?\*\//,
        {
          pattern: /(^|[^\\])\/\/.*/,
          lookbehind: !0
        }
      ],
      atrule: {
        pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
        inside: {
          punctuation: /[:()]/
        }
      },
      // selectors and mixins are considered the same
      selector: {
        pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
        inside: {
          // mixin parameters
          variable: /@+[\w-]+/
        }
      },
      property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
      operator: /[+\-*\/]/
    }), t.languages.insertBefore("less", "property", {
      variable: [
        // Variable declaration (the colon must be consumed!)
        {
          pattern: /@[\w-]+\s*:/,
          inside: {
            punctuation: /:/
          }
        },
        // Variable usage
        /@@?[\w-]+/
      ],
      "mixin-usage": {
        pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
        lookbehind: !0,
        alias: "function"
      }
    });
  }
  return hd;
}
var md, _w;
function Cm() {
  if (_w) return md;
  _w = 1, md = e, e.displayName = "scheme", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.scheme = {
        // this supports "normal" single-line comments:
        //   ; comment
        // and (potentially nested) multiline comments:
        //   #| comment #| nested |# still comment |#
        // (only 1 level of nesting is supported)
        comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        symbol: {
          pattern: /'[^()\[\]#'\s]+/,
          greedy: !0
        },
        char: {
          pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
          greedy: !0
        },
        "lambda-parameter": [
          // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
          {
            pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
            lookbehind: !0
          },
          {
            pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
            lookbehind: !0
          }
        ],
        keyword: {
          pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        builtin: {
          // all functions of the base library of R7RS plus some of built-ins of R5Rs
          pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        operator: {
          pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        number: {
          // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
          //
          // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
          // <num R>       := <prefix R><complex R>
          // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
          // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
          // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
          // <ureal R>     := <uint R>(?:\/<uint R>)?
          //                | <decimal R>
          //
          // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
          // <uint R>      := <digit R>+
          // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
          // <radix 2>     := #b
          // <radix 8>     := #o
          // <radix 10>    := (?:#d)?
          // <radix 16>    := #x
          // <digit 2>     := [01]
          // <digit 8>     := [0-7]
          // <digit 10>    := \d
          // <digit 16>    := [0-9a-f]
          //
          // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
          // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
          // pattern:
          pattern: RegExp(
            r({
              "<ureal dec>": /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
              "<real dec>": /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
              "<imaginary dec>": /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
              "<complex dec>": /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
              "<num dec>": /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
              "<ureal box>": /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
              "<real box>": /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
              "<imaginary box>": /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
              "<complex box>": /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
              "<num box>": /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
              "<number>": /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
            }),
            "i"
          ),
          lookbehind: !0
        },
        boolean: {
          pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        function: {
          pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        identifier: {
          pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
          lookbehind: !0,
          greedy: !0
        },
        punctuation: /[()\[\]']/
      };
      function r(a) {
        for (var i in a)
          a[i] = a[i].replace(/<[\w\s]+>/g, function(o) {
            return "(?:" + a[o].trim() + ")";
          });
        return a[i];
      }
    })(t);
  }
  return md;
}
var bd, Tw;
function L9() {
  if (Tw) return bd;
  Tw = 1;
  var e = Cm();
  bd = t, t.displayName = "lilypond", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      for (var a = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source, i = 5, o = 0; o < i; o++)
        a = a.replace(/<expr>/g, function() {
          return a;
        });
      a = a.replace(/<expr>/g, /[^\s\S]/.source);
      var s = r.languages.lilypond = {
        comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
        "embedded-scheme": {
          pattern: RegExp(
            /(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(
              /<expr>/g,
              function() {
                return a;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            scheme: {
              pattern: /^(#)[\s\S]+$/,
              lookbehind: !0,
              alias: "language-scheme",
              inside: {
                "embedded-lilypond": {
                  pattern: /#\{[\s\S]*?#\}/,
                  greedy: !0,
                  inside: {
                    punctuation: /^#\{|#\}$/,
                    lilypond: {
                      pattern: /[\s\S]+/,
                      alias: "language-lilypond",
                      inside: null
                      // see below
                    }
                  }
                },
                rest: r.languages.scheme
              }
            },
            punctuation: /#/
          }
        },
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        "class-name": {
          pattern: /(\\new\s+)[\w-]+/,
          lookbehind: !0
        },
        keyword: {
          pattern: /\\[a-z][-\w]*/i,
          inside: {
            punctuation: /^\\/
          }
        },
        operator: /[=|]|<<|>>/,
        punctuation: {
          pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
          lookbehind: !0
        },
        number: /\b\d+(?:\/\d+)?\b/
      };
      s["embedded-scheme"].inside.scheme.inside["embedded-lilypond"].inside.lilypond.inside = s, r.languages.ly = s;
    }(n);
  }
  return bd;
}
var vd, Rw;
function M9() {
  if (Rw) return vd;
  Rw = 1;
  var e = yt();
  vd = t, t.displayName = "liquid", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.liquid = {
      comment: {
        pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
        lookbehind: !0
      },
      delimiter: {
        pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
        alias: "punctuation"
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
      object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
      function: [
        {
          pattern: /(\|\s*)\w+/,
          lookbehind: !0,
          alias: "filter"
        },
        {
          // array functions
          pattern: /(\.\s*)(?:first|last|size)/,
          lookbehind: !0
        }
      ],
      boolean: /\b(?:false|nil|true)\b/,
      range: {
        pattern: /\.\./,
        alias: "operator"
      },
      // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
      number: /\b\d+(?:\.\d+)?\b/,
      operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
      punctuation: /[.,\[\]()]/,
      empty: {
        pattern: /\bempty\b/,
        alias: "keyword"
      }
    }, n.hooks.add("before-tokenize", function(r) {
      var a = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g, i = !1;
      n.languages["markup-templating"].buildPlaceholders(
        r,
        "liquid",
        a,
        function(o) {
          var s = /^\{%-?\s*(\w+)/.exec(o);
          if (s) {
            var l = s[1];
            if (l === "raw" && !i)
              return i = !0, !0;
            if (l === "endraw")
              return i = !1, !0;
          }
          return !i;
        }
      );
    }), n.hooks.add("after-tokenize", function(r) {
      n.languages["markup-templating"].tokenizePlaceholders(r, "liquid");
    });
  }
  return vd;
}
var yd, Aw;
function P9() {
  if (Aw) return yd;
  Aw = 1, yd = e, e.displayName = "lisp", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(p) {
        return RegExp(/(\()/.source + "(?:" + p + ")" + /(?=[\s\)])/.source);
      }
      function a(p) {
        return RegExp(
          /([\s([])/.source + "(?:" + p + ")" + /(?=[\s)])/.source
        );
      }
      var i = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source, o = "&" + i, s = "(\\()", l = "(?=\\))", c = "(?=\\s)", u = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source, d = {
        // Three or four semicolons are considered a heading.
        // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
        heading: {
          pattern: /;;;.*/,
          alias: ["comment", "title"]
        },
        comment: /;.*/,
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0,
          inside: {
            argument: /[-A-Z]+(?=[.,\s])/,
            symbol: RegExp("`" + i + "'")
          }
        },
        "quoted-symbol": {
          pattern: RegExp("#?'" + i),
          alias: ["variable", "symbol"]
        },
        "lisp-property": {
          pattern: RegExp(":" + i),
          alias: "property"
        },
        splice: {
          pattern: RegExp(",@?" + i),
          alias: ["symbol", "variable"]
        },
        keyword: [
          {
            pattern: RegExp(
              s + "(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)" + c
            ),
            lookbehind: !0
          },
          {
            pattern: RegExp(
              s + "(?:append|by|collect|concat|do|finally|for|in|return)" + c
            ),
            lookbehind: !0
          }
        ],
        declare: {
          pattern: r(/declare/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        interactive: {
          pattern: r(/interactive/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        boolean: {
          pattern: a(/nil|t/.source),
          lookbehind: !0
        },
        number: {
          pattern: a(/[-+]?\d+(?:\.\d*)?/.source),
          lookbehind: !0
        },
        defvar: {
          pattern: RegExp(s + "def(?:const|custom|group|var)\\s+" + i),
          lookbehind: !0,
          inside: {
            keyword: /^def[a-z]+/,
            variable: RegExp(i)
          }
        },
        defun: {
          pattern: RegExp(
            s + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + i + /\s+\(/.source + u + /\)/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^(?:cl-)?def\S+/,
            // See below, this property needs to be defined later so that it can
            // reference the language object.
            arguments: null,
            function: {
              pattern: RegExp("(^\\s)" + i),
              lookbehind: !0
            },
            punctuation: /[()]/
          }
        },
        lambda: {
          pattern: RegExp(
            s + "lambda\\s+\\(\\s*(?:&?" + i + "(?:\\s+&?" + i + ")*\\s*)?\\)"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^lambda/,
            // See below, this property needs to be defined later so that it can
            // reference the language object.
            arguments: null,
            punctuation: /[()]/
          }
        },
        car: {
          pattern: RegExp(s + i),
          lookbehind: !0
        },
        punctuation: [
          // open paren, brackets, and close paren
          /(?:['`,]?\(|[)\[\]])/,
          // cons
          {
            pattern: /(\s)\.(?=\s)/,
            lookbehind: !0
          }
        ]
      }, f = {
        "lisp-marker": RegExp(o),
        varform: {
          pattern: RegExp(
            /\(/.source + i + /\s+(?=\S)/.source + u + /\)/.source
          ),
          inside: d
        },
        argument: {
          pattern: RegExp(/(^|[\s(])/.source + i),
          lookbehind: !0,
          alias: "variable"
        },
        rest: d
      }, g = "\\S+(?:\\s+\\S+)*", h = {
        pattern: RegExp(s + u + l),
        lookbehind: !0,
        inside: {
          "rest-vars": {
            pattern: RegExp("&(?:body|rest)\\s+" + g),
            inside: f
          },
          "other-marker-vars": {
            pattern: RegExp("&(?:aux|optional)\\s+" + g),
            inside: f
          },
          keys: {
            pattern: RegExp("&key\\s+" + g + "(?:\\s+&allow-other-keys)?"),
            inside: f
          },
          argument: {
            pattern: RegExp(i),
            alias: "variable"
          },
          punctuation: /[()]/
        }
      };
      d.lambda.inside.arguments = h, d.defun.inside.arguments = n.util.clone(h), d.defun.inside.arguments.inside.sublist = h, n.languages.lisp = d, n.languages.elisp = d, n.languages.emacs = d, n.languages["emacs-lisp"] = d;
    })(t);
  }
  return yd;
}
var Ed, xw;
function F9() {
  if (xw) return Ed;
  xw = 1, Ed = e, e.displayName = "livescript", e.aliases = [];
  function e(t) {
    t.languages.livescript = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\\])#.*/,
          lookbehind: !0
        }
      ],
      "interpolated-string": {
        /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
         * forcing it to match """-quoted string when it would otherwise match "-quoted first. */
        pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          variable: {
            pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
            lookbehind: !0
          },
          interpolation: {
            pattern: /(^|[^\\])#\{[^}]+\}/m,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^#\{|\}$/,
                alias: "variable"
              }
              // See rest below
            }
          },
          string: /[\s\S]+/
        }
      },
      string: [
        {
          pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
          greedy: !0
        },
        {
          pattern: /<\[[\s\S]*?\]>/,
          greedy: !0
        },
        /\\[^\s,;\])}]+/
      ],
      regex: [
        {
          pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
          greedy: !0,
          inside: {
            comment: {
              pattern: /(^|[^\\])#.*/,
              lookbehind: !0
            }
          }
        },
        {
          pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
          greedy: !0
        }
      ],
      keyword: {
        pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
        lookbehind: !0
      },
      "keyword-operator": {
        pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
        lookbehind: !0,
        alias: "operator"
      },
      boolean: {
        pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
        lookbehind: !0
      },
      argument: {
        // Don't match .&. nor &&
        pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
        lookbehind: !0,
        alias: "variable"
      },
      number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
      identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
      operator: [
        // Spaced .
        {
          pattern: /( )\.(?= )/,
          lookbehind: !0
        },
        // Full list, in order:
        // .= .~ .. ...
        // .&. .^. .<<. .>>. .>>>.
        // := :: ::=
        // &&
        // || |>
        // < << <<< <<<<
        // <- <-- <-! <--!
        // <~ <~~ <~! <~~!
        // <| <= <?
        // > >> >= >?
        // - -- -> -->
        // + ++
        // @ @@
        // % %%
        // * **
        // ! != !~=
        // !~> !~~>
        // !-> !-->
        // ~ ~> ~~> ~=
        // = ==
        // ^ ^^
        // / ?
        /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
      ],
      punctuation: /[(){}\[\]|.,:;`]/
    }, t.languages.livescript["interpolated-string"].inside.interpolation.inside.rest = t.languages.livescript;
  }
  return Ed;
}
var Sd, Cw;
function $9() {
  if (Cw) return Sd;
  Cw = 1, Sd = e, e.displayName = "llvm", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.llvm = {
        comment: /;.*/,
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        boolean: /\b(?:false|true)\b/,
        variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
        label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
        type: {
          pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
          alias: "class-name"
        },
        keyword: /\b[a-z_][a-z_0-9]*\b/,
        number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
        punctuation: /[{}[\];(),.!*=<>]/
      };
    })(t);
  }
  return Sd;
}
var wd, Nw;
function B9() {
  if (Nw) return wd;
  Nw = 1, wd = e, e.displayName = "log", e.aliases = [];
  function e(t) {
    t.languages.log = {
      string: {
        // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
        greedy: !0
      },
      exception: {
        pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
        lookbehind: !0,
        greedy: !0,
        alias: ["javastacktrace", "language-javastacktrace"],
        inside: t.languages.javastacktrace || {
          keyword: /\bat\b/,
          function: /[a-z_][\w$]*(?=\()/,
          punctuation: /[.:()]/
        }
      },
      level: [
        {
          pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
          alias: ["error", "important"]
        },
        {
          pattern: /\b(?:WARN|WARNING|WRN)\b/,
          alias: ["warning", "important"]
        },
        {
          pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
          alias: ["info", "keyword"]
        },
        {
          pattern: /\b(?:DBG|DEBUG|FINE)\b/,
          alias: ["debug", "keyword"]
        },
        {
          pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
          alias: ["trace", "comment"]
        }
      ],
      property: {
        pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
        lookbehind: !0
      },
      separator: {
        pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
        lookbehind: !0,
        alias: "comment"
      },
      url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
      email: {
        pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
        lookbehind: !0,
        alias: "url"
      },
      "ip-address": {
        pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
        alias: "constant"
      },
      "mac-address": {
        pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
        alias: "constant"
      },
      domain: {
        pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
        lookbehind: !0,
        alias: "constant"
      },
      uuid: {
        pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
        alias: "constant"
      },
      hash: {
        pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
        alias: "constant"
      },
      "file-path": {
        pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
        lookbehind: !0,
        greedy: !0,
        alias: "string"
      },
      date: {
        pattern: RegExp(
          /\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + "|" + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + "|" + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source,
          "i"
        ),
        alias: "number"
      },
      time: {
        pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
        alias: "number"
      },
      boolean: /\b(?:false|null|true)\b/i,
      number: {
        pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
        lookbehind: !0
      },
      operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
      punctuation: /[\[\].,]/
    };
  }
  return wd;
}
var _d, Iw;
function U9() {
  if (Iw) return _d;
  Iw = 1, _d = e, e.displayName = "lolcode", e.aliases = [];
  function e(t) {
    t.languages.lolcode = {
      comment: [/\bOBTW\s[\s\S]*?\sTLDR\b/, /\bBTW.+/],
      string: {
        pattern: /"(?::.|[^":])*"/,
        inside: {
          variable: /:\{[^}]+\}/,
          symbol: [/:\([a-f\d]+\)/i, /:\[[^\]]+\]/, /:[)>o":]/]
        },
        greedy: !0
      },
      number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
      symbol: {
        pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
        lookbehind: !0,
        inside: {
          keyword: /A(?=\s)/
        }
      },
      label: {
        pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
        lookbehind: !0,
        alias: "string"
      },
      function: {
        pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
        lookbehind: !0
      },
      keyword: [
        {
          pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
          lookbehind: !0
        },
        /'Z(?=\s|,|$)/
      ],
      boolean: {
        pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
        lookbehind: !0
      },
      variable: {
        pattern: /(^|\s)IT(?=\s|,|$)/,
        lookbehind: !0
      },
      operator: {
        pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
        lookbehind: !0
      },
      punctuation: /\.{3}|…|,|!/
    };
  }
  return _d;
}
var Td, kw;
function G9() {
  if (kw) return Td;
  kw = 1, Td = e, e.displayName = "magma", e.aliases = [];
  function e(t) {
    t.languages.magma = {
      output: {
        pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
        lookbehind: !0,
        greedy: !0
      },
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
        lookbehind: !0,
        greedy: !0
      },
      // http://magma.maths.usyd.edu.au/magma/handbook/text/82
      keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
      boolean: /\b(?:false|true)\b/,
      generator: {
        pattern: /\b[a-z_]\w*(?=\s*<)/i,
        alias: "class-name"
      },
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: {
        pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
        lookbehind: !0
      },
      operator: /->|[-+*/^~!|#=]|:=|\.\./,
      punctuation: /[()[\]{}<>,;.:]/
    };
  }
  return Td;
}
var Rd, Ow;
function H9() {
  if (Ow) return Rd;
  Ow = 1, Rd = e, e.displayName = "makefile", e.aliases = [];
  function e(t) {
    t.languages.makefile = {
      comment: {
        pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
        lookbehind: !0
      },
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "builtin-target": {
        pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
        alias: "builtin"
      },
      target: {
        pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
        alias: "symbol",
        inside: {
          variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
        }
      },
      variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
      // Directives
      keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
      function: {
        pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
        lookbehind: !0
      },
      operator: /(?:::|[?:+!])?=|[|@]/,
      punctuation: /[:;(){}]/
    };
  }
  return Rd;
}
var Ad, Dw;
function z9() {
  if (Dw) return Ad;
  Dw = 1, Ad = e, e.displayName = "markdown", e.aliases = ["md"];
  function e(t) {
    (function(n) {
      var r = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
      function a(f) {
        return f = f.replace(/<inner>/g, function() {
          return r;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + f + ")");
      }
      var i = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, o = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(
        /__/g,
        function() {
          return i;
        }
      ), s = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
      n.languages.markdown = n.languages.extend("markup", {}), n.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
          pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            punctuation: /^---|---$/,
            "front-matter": {
              pattern: /\S+(?:\s+\S+)*/,
              alias: ["yaml", "language-yaml"],
              inside: n.languages.yaml
            }
          }
        },
        blockquote: {
          // > ...
          pattern: /^>(?:[\t ]*>)*/m,
          alias: "punctuation"
        },
        table: {
          pattern: RegExp(
            "^" + o + s + "(?:" + o + ")*",
            "m"
          ),
          inside: {
            "table-data-rows": {
              pattern: RegExp(
                "^(" + o + s + ")(?:" + o + ")*$"
              ),
              lookbehind: !0,
              inside: {
                "table-data": {
                  pattern: RegExp(i),
                  inside: n.languages.markdown
                },
                punctuation: /\|/
              }
            },
            "table-line": {
              pattern: RegExp("^(" + o + ")" + s + "$"),
              lookbehind: !0,
              inside: {
                punctuation: /\||:?-{3,}:?/
              }
            },
            "table-header-row": {
              pattern: RegExp("^" + o + "$"),
              inside: {
                "table-header": {
                  pattern: RegExp(i),
                  alias: "important",
                  inside: n.languages.markdown
                },
                punctuation: /\|/
              }
            }
          }
        },
        code: [
          {
            // Prefixed by 4 spaces or 1 tab and preceded by an empty line
            pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
            lookbehind: !0,
            alias: "keyword"
          },
          {
            // ```optional language
            // code block
            // ```
            pattern: /^```[\s\S]*?^```$/m,
            greedy: !0,
            inside: {
              "code-block": {
                pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                lookbehind: !0
              },
              "code-language": {
                pattern: /^(```).+/,
                lookbehind: !0
              },
              punctuation: /```/
            }
          }
        ],
        title: [
          {
            // title 1
            // =======
            // title 2
            // -------
            pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
            alias: "important",
            inside: {
              punctuation: /==+$|--+$/
            }
          },
          {
            // # title 1
            // ###### title 6
            pattern: /(^\s*)#.+/m,
            lookbehind: !0,
            alias: "important",
            inside: {
              punctuation: /^#+|#+$/
            }
          }
        ],
        hr: {
          // ***
          // ---
          // * * *
          // -----------
          pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        list: {
          // * item
          // + item
          // - item
          // 1. item
          pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        "url-reference": {
          // [id]: http://example.com "Optional title"
          // [id]: http://example.com 'Optional title'
          // [id]: http://example.com (Optional title)
          // [id]: <http://example.com> "Optional title"
          pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
          inside: {
            variable: {
              pattern: /^(!?\[)[^\]]+/,
              lookbehind: !0
            },
            string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
            punctuation: /^[\[\]!:]|[<>]/
          },
          alias: "url"
        },
        bold: {
          // **strong**
          // __strong__
          // allow one nested instance of italic text using the same delimiter
          pattern: a(
            /\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^..)[\s\S]+(?=..$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /\*\*|__/
          }
        },
        italic: {
          // *em*
          // _em_
          // allow one nested instance of bold text using the same delimiter
          pattern: a(
            /\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^.)[\s\S]+(?=.$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /[*_]/
          }
        },
        strike: {
          // ~~strike through~~
          // ~strike~
          // eslint-disable-next-line regexp/strict
          pattern: a(/(~~?)(?:(?!~)<inner>)+\2/.source),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^~~?)[\s\S]+(?=\1$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /~~?/
          }
        },
        "code-snippet": {
          // `code`
          // ``code``
          pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
          lookbehind: !0,
          greedy: !0,
          alias: ["code", "keyword"]
        },
        url: {
          // [example](http://example.com "Optional title")
          // [example][id]
          // [example] [id]
          pattern: a(
            /!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            operator: /^!/,
            content: {
              pattern: /(^\[)[^\]]+(?=\])/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            variable: {
              pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
              lookbehind: !0
            },
            url: {
              pattern: /(^\]\()[^\s)]+/,
              lookbehind: !0
            },
            string: {
              pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
              lookbehind: !0
            }
          }
        }
      }), ["url", "bold", "italic", "strike"].forEach(function(f) {
        ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(g) {
          f !== g && (n.languages.markdown[f].inside.content.inside[g] = n.languages.markdown[g]);
        });
      }), n.hooks.add("after-tokenize", function(f) {
        if (f.language !== "markdown" && f.language !== "md")
          return;
        function g(h) {
          if (!(!h || typeof h == "string"))
            for (var p = 0, m = h.length; p < m; p++) {
              var v = h[p];
              if (v.type !== "code") {
                g(v.content);
                continue;
              }
              var y = v.content[1], E = v.content[3];
              if (y && E && y.type === "code-language" && E.type === "code-block" && typeof y.content == "string") {
                var S = y.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
                S = (/[a-z][\w-]*/i.exec(S) || [""])[0].toLowerCase();
                var w = "language-" + S;
                E.alias ? typeof E.alias == "string" ? E.alias = [E.alias, w] : E.alias.push(w) : E.alias = [w];
              }
            }
        }
        g(f.tokens);
      }), n.hooks.add("wrap", function(f) {
        if (f.type === "code-block") {
          for (var g = "", h = 0, p = f.classes.length; h < p; h++) {
            var m = f.classes[h], v = /language-(.+)/.exec(m);
            if (v) {
              g = v[1];
              break;
            }
          }
          var y = n.languages[g];
          if (y)
            f.content = n.highlight(
              d(f.content.value),
              y,
              g
            );
          else if (g && g !== "none" && n.plugins.autoloader) {
            var E = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
            f.attributes.id = E, n.plugins.autoloader.loadLanguages(g, function() {
              var S = document.getElementById(E);
              S && (S.innerHTML = n.highlight(
                S.textContent,
                n.languages[g],
                g
              ));
            });
          }
        }
      });
      var l = RegExp(n.languages.markup.tag.pattern.source, "gi"), c = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
      }, u = String.fromCodePoint || String.fromCharCode;
      function d(f) {
        var g = f.replace(l, "");
        return g = g.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(h, p) {
          if (p = p.toLowerCase(), p[0] === "#") {
            var m;
            return p[1] === "x" ? m = parseInt(p.slice(2), 16) : m = Number(p.slice(1)), u(m);
          } else {
            var v = c[p];
            return v || h;
          }
        }), g;
      }
      n.languages.md = n.languages.markdown;
    })(t);
  }
  return Ad;
}
var xd, Lw;
function W9() {
  if (Lw) return xd;
  Lw = 1, xd = e, e.displayName = "matlab", e.aliases = [];
  function e(t) {
    t.languages.matlab = {
      comment: [/%\{[\s\S]*?\}%/, /%.+/],
      string: {
        pattern: /\B'(?:''|[^'\r\n])*'/,
        greedy: !0
      },
      // FIXME We could handle imaginary numbers as a whole
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
      keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
      function: /\b(?!\d)\w+(?=\s*\()/,
      operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
      punctuation: /\.{3}|[.,;\[\](){}!]/
    };
  }
  return xd;
}
var Cd, Mw;
function q9() {
  if (Mw) return Cd;
  Mw = 1, Cd = e, e.displayName = "maxscript", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
      n.languages.maxscript = {
        comment: {
          pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
          greedy: !0
        },
        string: {
          pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
          lookbehind: !0,
          greedy: !0
        },
        path: {
          pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
          greedy: !0,
          alias: "string"
        },
        "function-call": {
          pattern: RegExp(
            "((?:" + // start of line
            (/^/.source + "|" + // operators and other language constructs
            /[;=<>+\-*/^({\[]/.source + "|" + // keywords as part of statements
            /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ")[ 	]*)(?!" + r.source + ")" + /[a-z_]\w*\b/.source + "(?=[ 	]*(?:" + // variable
            ("(?!" + r.source + ")" + /[a-z_]/.source + "|" + // number
            /\d|-\.?\d/.source + "|" + // other expressions or literals
            /[({'"$@#?]/.source) + "))",
            "im"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "function"
        },
        "function-definition": {
          pattern: /(\b(?:fn|function)\s+)\w+\b/i,
          lookbehind: !0,
          alias: "function"
        },
        argument: {
          pattern: /\b[a-z_]\w*(?=:)/i,
          alias: "attr-name"
        },
        keyword: r,
        boolean: /\b(?:false|true)\b/,
        time: {
          pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
          lookbehind: !0,
          alias: "number"
        },
        number: [
          {
            pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
            lookbehind: !0
          },
          /\b(?:e|pi)\b/
        ],
        constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
        color: {
          pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
          alias: "constant"
        },
        operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
        punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
      };
    })(t);
  }
  return Cd;
}
var Nd, Pw;
function V9() {
  if (Pw) return Nd;
  Pw = 1, Nd = e, e.displayName = "mel", e.aliases = [];
  function e(t) {
    t.languages.mel = {
      comment: /\/\/.*/,
      code: {
        pattern: /`(?:\\.|[^\\`\r\n])*`/,
        greedy: !0,
        alias: "italic",
        inside: {
          delimiter: {
            pattern: /^`|`$/,
            alias: "punctuation"
          }
          // See rest below
        }
      },
      string: {
        pattern: /"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      variable: /\$\w+/,
      number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
      flag: {
        pattern: /-[^\d\W]\w*/,
        alias: "operator"
      },
      keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
      function: /\b\w+(?=\()|\b(?:CBG|HfAddAttractorToAS|HfAssignAS|HfBuildEqualMap|HfBuildFurFiles|HfBuildFurImages|HfCancelAFR|HfConnectASToHF|HfCreateAttractor|HfDeleteAS|HfEditAS|HfPerformCreateAS|HfRemoveAttractorFromAS|HfSelectAttached|HfSelectAttractors|HfUnAssignAS|Mayatomr|about|abs|addAttr|addAttributeEditorNodeHelp|addDynamic|addNewShelfTab|addPP|addPanelCategory|addPrefixToName|advanceToNextDrivenKey|affectedNet|affects|aimConstraint|air|alias|aliasAttr|align|alignCtx|alignCurve|alignSurface|allViewFit|ambientLight|angle|angleBetween|animCone|animCurveEditor|animDisplay|animView|annotate|appendStringArray|applicationName|applyAttrPreset|applyTake|arcLenDimContext|arcLengthDimension|arclen|arrayMapper|art3dPaintCtx|artAttrCtx|artAttrPaintVertexCtx|artAttrSkinPaintCtx|artAttrTool|artBuildPaintMenu|artFluidAttrCtx|artPuttyCtx|artSelectCtx|artSetPaintCtx|artUserPaintCtx|assignCommand|assignInputDevice|assignViewportFactories|attachCurve|attachDeviceAttr|attachSurface|attrColorSliderGrp|attrCompatibility|attrControlGrp|attrEnumOptionMenu|attrEnumOptionMenuGrp|attrFieldGrp|attrFieldSliderGrp|attrNavigationControlGrp|attrPresetEditWin|attributeExists|attributeInfo|attributeMenu|attributeQuery|autoKeyframe|autoPlace|bakeClip|bakeFluidShading|bakePartialHistory|bakeResults|bakeSimulation|basename|basenameEx|batchRender|bessel|bevel|bevelPlus|binMembership|bindSkin|blend2|blendShape|blendShapeEditor|blendShapePanel|blendTwoAttr|blindDataType|boneLattice|boundary|boxDollyCtx|boxZoomCtx|bufferCurve|buildBookmarkMenu|buildKeyframeMenu|button|buttonManip|cacheFile|cacheFileCombine|cacheFileMerge|cacheFileTrack|camera|cameraView|canCreateManip|canvas|capitalizeString|catch|catchQuiet|ceil|changeSubdivComponentDisplayLevel|changeSubdivRegion|channelBox|character|characterMap|characterOutlineEditor|characterize|chdir|checkBox|checkBoxGrp|checkDefaultRenderGlobals|choice|circle|circularFillet|clamp|clear|clearCache|clip|clipEditor|clipEditorCurrentTimeCtx|clipSchedule|clipSchedulerOutliner|clipTrimBefore|closeCurve|closeSurface|cluster|cmdFileOutput|cmdScrollFieldExecuter|cmdScrollFieldReporter|cmdShell|coarsenSubdivSelectionList|collision|color|colorAtPoint|colorEditor|colorIndex|colorIndexSliderGrp|colorSliderButtonGrp|colorSliderGrp|columnLayout|commandEcho|commandLine|commandPort|compactHairSystem|componentEditor|compositingInterop|computePolysetVolume|condition|cone|confirmDialog|connectAttr|connectControl|connectDynamic|connectJoint|connectionInfo|constrain|constrainValue|constructionHistory|container|containsMultibyte|contextInfo|control|convertFromOldLayers|convertIffToPsd|convertLightmap|convertSolidTx|convertTessellation|convertUnit|copyArray|copyFlexor|copyKey|copySkinWeights|cos|cpButton|cpCache|cpClothSet|cpCollision|cpConstraint|cpConvClothToMesh|cpForces|cpGetSolverAttr|cpPanel|cpProperty|cpRigidCollisionFilter|cpSeam|cpSetEdit|cpSetSolverAttr|cpSolver|cpSolverTypes|cpTool|cpUpdateClothUVs|createDisplayLayer|createDrawCtx|createEditor|createLayeredPsdFile|createMotionField|createNewShelf|createNode|createRenderLayer|createSubdivRegion|cross|crossProduct|ctxAbort|ctxCompletion|ctxEditMode|ctxTraverse|currentCtx|currentTime|currentTimeCtx|currentUnit|curve|curveAddPtCtx|curveCVCtx|curveEPCtx|curveEditorCtx|curveIntersect|curveMoveEPCtx|curveOnSurface|curveSketchCtx|cutKey|cycleCheck|cylinder|dagPose|date|defaultLightListCheckBox|defaultNavigation|defineDataServer|defineVirtualDevice|deformer|deg_to_rad|delete|deleteAttr|deleteShadingGroupsAndMaterials|deleteShelfTab|deleteUI|deleteUnusedBrushes|delrandstr|detachCurve|detachDeviceAttr|detachSurface|deviceEditor|devicePanel|dgInfo|dgdirty|dgeval|dgtimer|dimWhen|directKeyCtx|directionalLight|dirmap|dirname|disable|disconnectAttr|disconnectJoint|diskCache|displacementToPoly|displayAffected|displayColor|displayCull|displayLevelOfDetail|displayPref|displayRGBColor|displaySmoothness|displayStats|displayString|displaySurface|distanceDimContext|distanceDimension|doBlur|dolly|dollyCtx|dopeSheetEditor|dot|dotProduct|doubleProfileBirailSurface|drag|dragAttrContext|draggerContext|dropoffLocator|duplicate|duplicateCurve|duplicateSurface|dynCache|dynControl|dynExport|dynExpression|dynGlobals|dynPaintEditor|dynParticleCtx|dynPref|dynRelEdPanel|dynRelEditor|dynamicLoad|editAttrLimits|editDisplayLayerGlobals|editDisplayLayerMembers|editRenderLayerAdjustment|editRenderLayerGlobals|editRenderLayerMembers|editor|editorTemplate|effector|emit|emitter|enableDevice|encodeString|endString|endsWith|env|equivalent|equivalentTol|erf|error|eval|evalDeferred|evalEcho|event|exactWorldBoundingBox|exclusiveLightCheckBox|exec|executeForEachObject|exists|exp|expression|expressionEditorListen|extendCurve|extendSurface|extrude|fcheck|fclose|feof|fflush|fgetline|fgetword|file|fileBrowserDialog|fileDialog|fileExtension|fileInfo|filetest|filletCurve|filter|filterCurve|filterExpand|filterStudioImport|findAllIntersections|findAnimCurves|findKeyframe|findMenuItem|findRelatedSkinCluster|finder|firstParentOf|fitBspline|flexor|floatEq|floatField|floatFieldGrp|floatScrollBar|floatSlider|floatSlider2|floatSliderButtonGrp|floatSliderGrp|floor|flow|fluidCacheInfo|fluidEmitter|fluidVoxelInfo|flushUndo|fmod|fontDialog|fopen|formLayout|format|fprint|frameLayout|fread|freeFormFillet|frewind|fromNativePath|fwrite|gamma|gauss|geometryConstraint|getApplicationVersionAsFloat|getAttr|getClassification|getDefaultBrush|getFileList|getFluidAttr|getInputDeviceRange|getMayaPanelTypes|getModifiers|getPanel|getParticleAttr|getPluginResource|getenv|getpid|glRender|glRenderEditor|globalStitch|gmatch|goal|gotoBindPose|grabColor|gradientControl|gradientControlNoAttr|graphDollyCtx|graphSelectContext|graphTrackCtx|gravity|grid|gridLayout|group|groupObjectsByName|hardenPointCurve|hardware|hardwareRenderPanel|headsUpDisplay|headsUpMessage|help|helpLine|hermite|hide|hilite|hitTest|hotBox|hotkey|hotkeyCheck|hsv_to_rgb|hudButton|hudSlider|hudSliderButton|hwReflectionMap|hwRender|hwRenderLoad|hyperGraph|hyperPanel|hyperShade|hypot|iconTextButton|iconTextCheckBox|iconTextRadioButton|iconTextRadioCollection|iconTextScrollList|iconTextStaticLabel|ikHandle|ikHandleCtx|ikHandleDisplayScale|ikSolver|ikSplineHandleCtx|ikSystem|ikSystemInfo|ikfkDisplayMethod|illustratorCurves|image|imfPlugins|inheritTransform|insertJoint|insertJointCtx|insertKeyCtx|insertKnotCurve|insertKnotSurface|instance|instanceable|instancer|intField|intFieldGrp|intScrollBar|intSlider|intSliderGrp|interToUI|internalVar|intersect|iprEngine|isAnimCurve|isConnected|isDirty|isParentOf|isSameObject|isTrue|isValidObjectName|isValidString|isValidUiName|isolateSelect|itemFilter|itemFilterAttr|itemFilterRender|itemFilterType|joint|jointCluster|jointCtx|jointDisplayScale|jointLattice|keyTangent|keyframe|keyframeOutliner|keyframeRegionCurrentTimeCtx|keyframeRegionDirectKeyCtx|keyframeRegionDollyCtx|keyframeRegionInsertKeyCtx|keyframeRegionMoveKeyCtx|keyframeRegionScaleKeyCtx|keyframeRegionSelectKeyCtx|keyframeRegionSetKeyCtx|keyframeRegionTrackCtx|keyframeStats|lassoContext|lattice|latticeDeformKeyCtx|launch|launchImageEditor|layerButton|layeredShaderPort|layeredTexturePort|layout|layoutDialog|lightList|lightListEditor|lightListPanel|lightlink|lineIntersection|linearPrecision|linstep|listAnimatable|listAttr|listCameras|listConnections|listDeviceAttachments|listHistory|listInputDeviceAxes|listInputDeviceButtons|listInputDevices|listMenuAnnotation|listNodeTypes|listPanelCategories|listRelatives|listSets|listTransforms|listUnselected|listerEditor|loadFluid|loadNewShelf|loadPlugin|loadPluginLanguageResources|loadPrefObjects|localizedPanelLabel|lockNode|loft|log|longNameOf|lookThru|ls|lsThroughFilter|lsType|lsUI|mag|makeIdentity|makeLive|makePaintable|makeRoll|makeSingleSurface|makeTubeOn|makebot|manipMoveContext|manipMoveLimitsCtx|manipOptions|manipRotateContext|manipRotateLimitsCtx|manipScaleContext|manipScaleLimitsCtx|marker|match|max|memory|menu|menuBarLayout|menuEditor|menuItem|menuItemToShelf|menuSet|menuSetPref|messageLine|min|minimizeApp|mirrorJoint|modelCurrentTimeCtx|modelEditor|modelPanel|mouse|movIn|movOut|move|moveIKtoFK|moveKeyCtx|moveVertexAlongDirection|multiProfileBirailSurface|mute|nParticle|nameCommand|nameField|namespace|namespaceInfo|newPanelItems|newton|nodeCast|nodeIconButton|nodeOutliner|nodePreset|nodeType|noise|nonLinear|normalConstraint|normalize|nurbsBoolean|nurbsCopyUVSet|nurbsCube|nurbsEditUV|nurbsPlane|nurbsSelect|nurbsSquare|nurbsToPoly|nurbsToPolygonsPref|nurbsToSubdiv|nurbsToSubdivPref|nurbsUVSet|nurbsViewDirectionVector|objExists|objectCenter|objectLayer|objectType|objectTypeUI|obsoleteProc|oceanNurbsPreviewPlane|offsetCurve|offsetCurveOnSurface|offsetSurface|openGLExtension|openMayaPref|optionMenu|optionMenuGrp|optionVar|orbit|orbitCtx|orientConstraint|outlinerEditor|outlinerPanel|overrideModifier|paintEffectsDisplay|pairBlend|palettePort|paneLayout|panel|panelConfiguration|panelHistory|paramDimContext|paramDimension|paramLocator|parent|parentConstraint|particle|particleExists|particleInstancer|particleRenderInfo|partition|pasteKey|pathAnimation|pause|pclose|percent|performanceOptions|pfxstrokes|pickWalk|picture|pixelMove|planarSrf|plane|play|playbackOptions|playblast|plugAttr|plugNode|pluginInfo|pluginResourceUtil|pointConstraint|pointCurveConstraint|pointLight|pointMatrixMult|pointOnCurve|pointOnSurface|pointPosition|poleVectorConstraint|polyAppend|polyAppendFacetCtx|polyAppendVertex|polyAutoProjection|polyAverageNormal|polyAverageVertex|polyBevel|polyBlendColor|polyBlindData|polyBoolOp|polyBridgeEdge|polyCacheMonitor|polyCheck|polyChipOff|polyClipboard|polyCloseBorder|polyCollapseEdge|polyCollapseFacet|polyColorBlindData|polyColorDel|polyColorPerVertex|polyColorSet|polyCompare|polyCone|polyCopyUV|polyCrease|polyCreaseCtx|polyCreateFacet|polyCreateFacetCtx|polyCube|polyCut|polyCutCtx|polyCylinder|polyCylindricalProjection|polyDelEdge|polyDelFacet|polyDelVertex|polyDuplicateAndConnect|polyDuplicateEdge|polyEditUV|polyEditUVShell|polyEvaluate|polyExtrudeEdge|polyExtrudeFacet|polyExtrudeVertex|polyFlipEdge|polyFlipUV|polyForceUV|polyGeoSampler|polyHelix|polyInfo|polyInstallAction|polyLayoutUV|polyListComponentConversion|polyMapCut|polyMapDel|polyMapSew|polyMapSewMove|polyMergeEdge|polyMergeEdgeCtx|polyMergeFacet|polyMergeFacetCtx|polyMergeUV|polyMergeVertex|polyMirrorFace|polyMoveEdge|polyMoveFacet|polyMoveFacetUV|polyMoveUV|polyMoveVertex|polyNormal|polyNormalPerVertex|polyNormalizeUV|polyOptUvs|polyOptions|polyOutput|polyPipe|polyPlanarProjection|polyPlane|polyPlatonicSolid|polyPoke|polyPrimitive|polyPrism|polyProjection|polyPyramid|polyQuad|polyQueryBlindData|polyReduce|polySelect|polySelectConstraint|polySelectConstraintMonitor|polySelectCtx|polySelectEditCtx|polySeparate|polySetToFaceNormal|polySewEdge|polyShortestPathCtx|polySmooth|polySoftEdge|polySphere|polySphericalProjection|polySplit|polySplitCtx|polySplitEdge|polySplitRing|polySplitVertex|polyStraightenUVBorder|polySubdivideEdge|polySubdivideFacet|polyToSubdiv|polyTorus|polyTransfer|polyTriangulate|polyUVSet|polyUnite|polyWedgeFace|popen|popupMenu|pose|pow|preloadRefEd|print|progressBar|progressWindow|projFileViewer|projectCurve|projectTangent|projectionContext|projectionManip|promptDialog|propModCtx|propMove|psdChannelOutliner|psdEditTextureFile|psdExport|psdTextureFile|putenv|pwd|python|querySubdiv|quit|rad_to_deg|radial|radioButton|radioButtonGrp|radioCollection|radioMenuItemCollection|rampColorPort|rand|randomizeFollicles|randstate|rangeControl|readTake|rebuildCurve|rebuildSurface|recordAttr|recordDevice|redo|reference|referenceEdit|referenceQuery|refineSubdivSelectionList|refresh|refreshAE|registerPluginResource|rehash|reloadImage|removeJoint|removeMultiInstance|removePanelCategory|rename|renameAttr|renameSelectionList|renameUI|render|renderGlobalsNode|renderInfo|renderLayerButton|renderLayerParent|renderLayerPostProcess|renderLayerUnparent|renderManip|renderPartition|renderQualityNode|renderSettings|renderThumbnailUpdate|renderWindowEditor|renderWindowSelectContext|renderer|reorder|reorderDeformers|requires|reroot|resampleFluid|resetAE|resetPfxToPolyCamera|resetTool|resolutionNode|retarget|reverseCurve|reverseSurface|revolve|rgb_to_hsv|rigidBody|rigidSolver|roll|rollCtx|rootOf|rot|rotate|rotationInterpolation|roundConstantRadius|rowColumnLayout|rowLayout|runTimeCommand|runup|sampleImage|saveAllShelves|saveAttrPreset|saveFluid|saveImage|saveInitialState|saveMenu|savePrefObjects|savePrefs|saveShelf|saveToolSettings|scale|scaleBrushBrightness|scaleComponents|scaleConstraint|scaleKey|scaleKeyCtx|sceneEditor|sceneUIReplacement|scmh|scriptCtx|scriptEditorInfo|scriptJob|scriptNode|scriptTable|scriptToShelf|scriptedPanel|scriptedPanelType|scrollField|scrollLayout|sculpt|searchPathArray|seed|selLoadSettings|select|selectContext|selectCurveCV|selectKey|selectKeyCtx|selectKeyframeRegionCtx|selectMode|selectPref|selectPriority|selectType|selectedNodes|selectionConnection|separator|setAttr|setAttrEnumResource|setAttrMapping|setAttrNiceNameResource|setConstraintRestPosition|setDefaultShadingGroup|setDrivenKeyframe|setDynamic|setEditCtx|setEditor|setFluidAttr|setFocus|setInfinity|setInputDeviceMapping|setKeyCtx|setKeyPath|setKeyframe|setKeyframeBlendshapeTargetWts|setMenuMode|setNodeNiceNameResource|setNodeTypeFlag|setParent|setParticleAttr|setPfxToPolyCamera|setPluginResource|setProject|setStampDensity|setStartupMessage|setState|setToolTo|setUITemplate|setXformManip|sets|shadingConnection|shadingGeometryRelCtx|shadingLightRelCtx|shadingNetworkCompare|shadingNode|shapeCompare|shelfButton|shelfLayout|shelfTabLayout|shellField|shortNameOf|showHelp|showHidden|showManipCtx|showSelectionInTitle|showShadingGroupAttrEditor|showWindow|sign|simplify|sin|singleProfileBirailSurface|size|sizeBytes|skinCluster|skinPercent|smoothCurve|smoothTangentSurface|smoothstep|snap2to2|snapKey|snapMode|snapTogetherCtx|snapshot|soft|softMod|softModCtx|sort|sound|soundControl|source|spaceLocator|sphere|sphrand|spotLight|spotLightPreviewPort|spreadSheetEditor|spring|sqrt|squareSurface|srtContext|stackTrace|startString|startsWith|stitchAndExplodeShell|stitchSurface|stitchSurfacePoints|strcmp|stringArrayCatenate|stringArrayContains|stringArrayCount|stringArrayInsertAtIndex|stringArrayIntersector|stringArrayRemove|stringArrayRemoveAtIndex|stringArrayRemoveDuplicates|stringArrayRemoveExact|stringArrayToString|stringToStringArray|strip|stripPrefixFromName|stroke|subdAutoProjection|subdCleanTopology|subdCollapse|subdDuplicateAndConnect|subdEditUV|subdListComponentConversion|subdMapCut|subdMapSewMove|subdMatchTopology|subdMirror|subdToBlind|subdToPoly|subdTransferUVsToCache|subdiv|subdivCrease|subdivDisplaySmoothness|substitute|substituteAllString|substituteGeometry|substring|surface|surfaceSampler|surfaceShaderList|swatchDisplayPort|switchTable|symbolButton|symbolCheckBox|sysFile|system|tabLayout|tan|tangentConstraint|texLatticeDeformContext|texManipContext|texMoveContext|texMoveUVShellContext|texRotateContext|texScaleContext|texSelectContext|texSelectShortestPathCtx|texSmudgeUVContext|texWinToolCtx|text|textCurves|textField|textFieldButtonGrp|textFieldGrp|textManip|textScrollList|textToShelf|textureDisplacePlane|textureHairColor|texturePlacementContext|textureWindow|threadCount|threePointArcCtx|timeControl|timePort|timerX|toNativePath|toggle|toggleAxis|toggleWindowVisibility|tokenize|tokenizeList|tolerance|tolower|toolButton|toolCollection|toolDropped|toolHasOptions|toolPropertyWindow|torus|toupper|trace|track|trackCtx|transferAttributes|transformCompare|transformLimits|translator|trim|trunc|truncateFluidCache|truncateHairCache|tumble|tumbleCtx|turbulence|twoPointArcCtx|uiRes|uiTemplate|unassignInputDevice|undo|undoInfo|ungroup|uniform|unit|unloadPlugin|untangleUV|untitledFileName|untrim|upAxis|updateAE|userCtx|uvLink|uvSnapshot|validateShelfName|vectorize|view2dToolCtx|viewCamera|viewClipPlane|viewFit|viewHeadOn|viewLookAt|viewManip|viewPlace|viewSet|visor|volumeAxis|vortex|waitCursor|warning|webBrowser|webBrowserPrefs|whatIs|window|windowPref|wire|wireContext|workspace|wrinkle|wrinkleContext|writeTake|xbmLangPathList|xform)\b/,
      operator: [
        /\+[+=]?|-[-=]?|&&|\|\||[<>]=|[*\/!=]=?|[%^]/,
        {
          // We don't want to match <<
          pattern: /(^|[^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /(^|[^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      punctuation: /<<|>>|[.,:;?\[\](){}]/
    }, t.languages.mel.code.inside.rest = t.languages.mel;
  }
  return Nd;
}
var Id, Fw;
function j9() {
  if (Fw) return Id;
  Fw = 1, Id = e, e.displayName = "mermaid", e.aliases = [];
  function e(t) {
    t.languages.mermaid = {
      comment: {
        pattern: /%%.*/,
        greedy: !0
      },
      style: {
        pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
        lookbehind: !0,
        inside: {
          property: /\b\w[\w-]*(?=[ \t]*:)/,
          operator: /:/,
          punctuation: /,/
        }
      },
      "inter-arrow-label": {
        pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          arrow: {
            pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
            alias: "operator"
          },
          label: {
            pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
            lookbehind: !0,
            alias: "property"
          },
          "arrow-head": {
            pattern: /^\S+/,
            alias: ["arrow", "operator"]
          }
        }
      },
      arrow: [
        // This might look complex but it really isn't.
        // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
        // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
        // characters in the one lookbehind because that would create too many false negatives. So we have to split the
        // arrows into different patterns.
        {
          // ER diagram
          pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // flow chart
          // (?:==+|--+|-\.*-)
          pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // sequence diagram
          pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // class diagram
          pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
          lookbehind: !0,
          alias: "operator"
        }
      ],
      label: {
        pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      text: {
        pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
        alias: "string"
      },
      string: {
        pattern: /"[^"\r\n]*"/,
        greedy: !0
      },
      annotation: {
        pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
        alias: "important"
      },
      keyword: [
        // This language has both case-sensitive and case-insensitive keywords
        {
          pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
          lookbehind: !0,
          greedy: !0
        }
      ],
      entity: /#[a-z0-9]+;/,
      operator: {
        pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
        lookbehind: !0
      },
      punctuation: /[(){};]/
    };
  }
  return Id;
}
var kd, $w;
function Y9() {
  if ($w) return kd;
  $w = 1, kd = e, e.displayName = "mizar", e.aliases = [];
  function e(t) {
    t.languages.mizar = {
      comment: /::.+/,
      keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
      parameter: {
        pattern: /\$(?:10|\d)/,
        alias: "variable"
      },
      variable: /\b\w+(?=:)/,
      number: /(?:\b|-)\d+\b/,
      operator: /\.\.\.|->|&|\.?=/,
      punctuation: /\(#|#\)|[,:;\[\](){}]/
    };
  }
  return kd;
}
var Od, Bw;
function K9() {
  if (Bw) return Od;
  Bw = 1, Od = e, e.displayName = "mongodb", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = [
        // query and projection
        "$eq",
        "$gt",
        "$gte",
        "$in",
        "$lt",
        "$lte",
        "$ne",
        "$nin",
        "$and",
        "$not",
        "$nor",
        "$or",
        "$exists",
        "$type",
        "$expr",
        "$jsonSchema",
        "$mod",
        "$regex",
        "$text",
        "$where",
        "$geoIntersects",
        "$geoWithin",
        "$near",
        "$nearSphere",
        "$all",
        "$elemMatch",
        "$size",
        "$bitsAllClear",
        "$bitsAllSet",
        "$bitsAnyClear",
        "$bitsAnySet",
        "$comment",
        "$elemMatch",
        "$meta",
        "$slice",
        // update
        "$currentDate",
        "$inc",
        "$min",
        "$max",
        "$mul",
        "$rename",
        "$set",
        "$setOnInsert",
        "$unset",
        "$addToSet",
        "$pop",
        "$pull",
        "$push",
        "$pullAll",
        "$each",
        "$position",
        "$slice",
        "$sort",
        "$bit",
        // aggregation pipeline stages
        "$addFields",
        "$bucket",
        "$bucketAuto",
        "$collStats",
        "$count",
        "$currentOp",
        "$facet",
        "$geoNear",
        "$graphLookup",
        "$group",
        "$indexStats",
        "$limit",
        "$listLocalSessions",
        "$listSessions",
        "$lookup",
        "$match",
        "$merge",
        "$out",
        "$planCacheStats",
        "$project",
        "$redact",
        "$replaceRoot",
        "$replaceWith",
        "$sample",
        "$set",
        "$skip",
        "$sort",
        "$sortByCount",
        "$unionWith",
        "$unset",
        "$unwind",
        "$setWindowFields",
        // aggregation pipeline operators
        "$abs",
        "$accumulator",
        "$acos",
        "$acosh",
        "$add",
        "$addToSet",
        "$allElementsTrue",
        "$and",
        "$anyElementTrue",
        "$arrayElemAt",
        "$arrayToObject",
        "$asin",
        "$asinh",
        "$atan",
        "$atan2",
        "$atanh",
        "$avg",
        "$binarySize",
        "$bsonSize",
        "$ceil",
        "$cmp",
        "$concat",
        "$concatArrays",
        "$cond",
        "$convert",
        "$cos",
        "$dateFromParts",
        "$dateToParts",
        "$dateFromString",
        "$dateToString",
        "$dayOfMonth",
        "$dayOfWeek",
        "$dayOfYear",
        "$degreesToRadians",
        "$divide",
        "$eq",
        "$exp",
        "$filter",
        "$first",
        "$floor",
        "$function",
        "$gt",
        "$gte",
        "$hour",
        "$ifNull",
        "$in",
        "$indexOfArray",
        "$indexOfBytes",
        "$indexOfCP",
        "$isArray",
        "$isNumber",
        "$isoDayOfWeek",
        "$isoWeek",
        "$isoWeekYear",
        "$last",
        "$last",
        "$let",
        "$literal",
        "$ln",
        "$log",
        "$log10",
        "$lt",
        "$lte",
        "$ltrim",
        "$map",
        "$max",
        "$mergeObjects",
        "$meta",
        "$min",
        "$millisecond",
        "$minute",
        "$mod",
        "$month",
        "$multiply",
        "$ne",
        "$not",
        "$objectToArray",
        "$or",
        "$pow",
        "$push",
        "$radiansToDegrees",
        "$range",
        "$reduce",
        "$regexFind",
        "$regexFindAll",
        "$regexMatch",
        "$replaceOne",
        "$replaceAll",
        "$reverseArray",
        "$round",
        "$rtrim",
        "$second",
        "$setDifference",
        "$setEquals",
        "$setIntersection",
        "$setIsSubset",
        "$setUnion",
        "$size",
        "$sin",
        "$slice",
        "$split",
        "$sqrt",
        "$stdDevPop",
        "$stdDevSamp",
        "$strcasecmp",
        "$strLenBytes",
        "$strLenCP",
        "$substr",
        "$substrBytes",
        "$substrCP",
        "$subtract",
        "$sum",
        "$switch",
        "$tan",
        "$toBool",
        "$toDate",
        "$toDecimal",
        "$toDouble",
        "$toInt",
        "$toLong",
        "$toObjectId",
        "$toString",
        "$toLower",
        "$toUpper",
        "$trim",
        "$trunc",
        "$type",
        "$week",
        "$year",
        "$zip",
        "$count",
        "$dateAdd",
        "$dateDiff",
        "$dateSubtract",
        "$dateTrunc",
        "$getField",
        "$rand",
        "$sampleRate",
        "$setField",
        "$unsetField",
        // aggregation pipeline query modifiers
        "$comment",
        "$explain",
        "$hint",
        "$max",
        "$maxTimeMS",
        "$min",
        "$orderby",
        "$query",
        "$returnKey",
        "$showDiskLoc",
        "$natural"
      ], a = [
        "ObjectId",
        "Code",
        "BinData",
        "DBRef",
        "Timestamp",
        "NumberLong",
        "NumberDecimal",
        "MaxKey",
        "MinKey",
        "RegExp",
        "ISODate",
        "UUID"
      ];
      r = r.map(function(o) {
        return o.replace("$", "\\$");
      });
      var i = "(?:" + r.join("|") + ")\\b";
      n.languages.mongodb = n.languages.extend("javascript", {}), n.languages.insertBefore("mongodb", "string", {
        property: {
          pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
          greedy: !0,
          inside: {
            keyword: RegExp(`^(['"])?` + i + "(?:\\1)?$")
          }
        }
      }), n.languages.mongodb.string.inside = {
        url: {
          // url pattern
          pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
          greedy: !0
        },
        entity: {
          // ipv4
          pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
          greedy: !0
        }
      }, n.languages.insertBefore("mongodb", "constant", {
        builtin: {
          pattern: RegExp("\\b(?:" + a.join("|") + ")\\b"),
          alias: "keyword"
        }
      });
    })(t);
  }
  return Od;
}
var Dd, Uw;
function X9() {
  if (Uw) return Dd;
  Uw = 1, Dd = e, e.displayName = "monkey", e.aliases = [];
  function e(t) {
    t.languages.monkey = {
      comment: {
        pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"/,
        greedy: !0
      },
      preprocessor: {
        pattern: /(^[ \t]*)#.+/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      function: /\b\w+(?=\()/,
      "type-char": {
        pattern: /\b[?%#$]/,
        alias: "class-name"
      },
      number: {
        pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
        lookbehind: !0
      },
      keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
      operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
      punctuation: /[.,:;()\[\]]/
    };
  }
  return Dd;
}
var Ld, Gw;
function Z9() {
  if (Gw) return Ld;
  Gw = 1, Ld = e, e.displayName = "moonscript", e.aliases = ["moon"];
  function e(t) {
    t.languages.moonscript = {
      comment: /--.*/,
      string: [
        {
          pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
          greedy: !0
        },
        {
          pattern: /"[^"]*"/,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /#\{[^{}]*\}/,
              inside: {
                moonscript: {
                  pattern: /(^#\{)[\s\S]+(?=\})/,
                  lookbehind: !0,
                  inside: null
                  // see beow
                },
                "interpolation-punctuation": {
                  pattern: /#\{|\}/,
                  alias: "punctuation"
                }
              }
            }
          }
        }
      ],
      "class-name": [
        {
          pattern: /(\b(?:class|extends)[ \t]+)\w+/,
          lookbehind: !0
        },
        // class-like names start with a capital letter
        /\b[A-Z]\w*/
      ],
      keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
      variable: /@@?\w*/,
      property: {
        pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
        lookbehind: !0
      },
      function: {
        pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
        inside: {
          punctuation: /\./
        }
      },
      boolean: /\b(?:false|true)\b/,
      number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
      operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
      punctuation: /[.,()[\]{}\\]/
    }, t.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = t.languages.moonscript, t.languages.moon = t.languages.moonscript;
  }
  return Ld;
}
var Md, Hw;
function Q9() {
  if (Hw) return Md;
  Hw = 1, Md = e, e.displayName = "n1ql", e.aliases = [];
  function e(t) {
    t.languages.n1ql = {
      comment: {
        pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
        greedy: !0
      },
      string: {
        pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
        greedy: !0
      },
      identifier: {
        pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
        greedy: !0
      },
      parameter: /\$[\w.]+/,
      // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
      keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      boolean: /\b(?:FALSE|TRUE)\b/i,
      number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
      operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
      punctuation: /[;[\](),.{}:]/
    };
  }
  return Md;
}
var Pd, zw;
function J9() {
  if (zw) return Pd;
  zw = 1, Pd = e, e.displayName = "n4js", e.aliases = ["n4jsd"];
  function e(t) {
    t.languages.n4js = t.languages.extend("javascript", {
      // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
      keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
    }), t.languages.insertBefore("n4js", "constant", {
      // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
      annotation: {
        pattern: /@+\w+/,
        alias: "operator"
      }
    }), t.languages.n4jsd = t.languages.n4js;
  }
  return Pd;
}
var Fd, Ww;
function e7() {
  if (Ww) return Fd;
  Ww = 1, Fd = e, e.displayName = "nand2tetrisHdl", e.aliases = [];
  function e(t) {
    t.languages["nand2tetris-hdl"] = {
      comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
      number: /\b\d+\b/,
      operator: /=|\.\./,
      punctuation: /[{}[\];(),:]/
    };
  }
  return Fd;
}
var $d, qw;
function t7() {
  if (qw) return $d;
  qw = 1, $d = e, e.displayName = "naniscript", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\{[^\r\n\[\]{}]*\}/, a = {
        "quoted-string": {
          pattern: /"(?:[^"\\]|\\.)*"/,
          alias: "operator"
        },
        "command-param-id": {
          pattern: /(\s)\w+:/,
          lookbehind: !0,
          alias: "property"
        },
        "command-param-value": [
          {
            pattern: r,
            alias: "selector"
          },
          {
            pattern: /([\t ])\S+/,
            lookbehind: !0,
            greedy: !0,
            alias: "operator"
          },
          {
            pattern: /\S(?:.*\S)?/,
            alias: "operator"
          }
        ]
      };
      n.languages.naniscript = {
        // ; ...
        comment: {
          pattern: /^([\t ]*);.*/m,
          lookbehind: !0
        },
        // > ...
        // Define is a control line starting with '>' followed by a word, a space and a text.
        define: {
          pattern: /^>.+/m,
          alias: "tag",
          inside: {
            value: {
              pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
              lookbehind: !0,
              alias: "operator"
            },
            key: {
              pattern: /(^>)\w+/,
              lookbehind: !0
            }
          }
        },
        // # ...
        label: {
          pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
          lookbehind: !0,
          alias: "regex"
        },
        command: {
          pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
          lookbehind: !0,
          alias: "function",
          inside: {
            "command-name": /^@\w+/,
            expression: {
              pattern: r,
              greedy: !0,
              alias: "selector"
            },
            "command-params": {
              pattern: /\s*\S[\s\S]*/,
              inside: a
            }
          }
        },
        // Generic is any line that doesn't start with operators: ;>#@
        "generic-text": {
          pattern: /(^[ \t]*)[^#@>;\s].*/m,
          lookbehind: !0,
          alias: "punctuation",
          inside: {
            // \{ ... \} ... \[ ... \] ... \"
            "escaped-char": /\\[{}\[\]"]/,
            expression: {
              pattern: r,
              greedy: !0,
              alias: "selector"
            },
            "inline-command": {
              pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
              greedy: !0,
              alias: "function",
              inside: {
                "command-params": {
                  pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                  lookbehind: !0,
                  inside: a
                },
                "command-param-name": {
                  pattern: /^(\[[\t ]*)\w+/,
                  lookbehind: !0,
                  alias: "name"
                },
                "start-stop-char": /[\[\]]/
              }
            }
          }
        }
      }, n.languages.nani = n.languages.naniscript, n.hooks.add("after-tokenize", function(s) {
        var l = s.tokens;
        l.forEach(function(c) {
          if (typeof c != "string" && c.type === "generic-text") {
            var u = o(c);
            i(u) || (c.type = "bad-line", c.content = u);
          }
        });
      });
      function i(s) {
        for (var l = "[]{}", c = [], u = 0; u < s.length; u++) {
          var d = s[u], f = l.indexOf(d);
          if (f !== -1) {
            if (f % 2 === 0)
              c.push(f + 1);
            else if (c.pop() !== f)
              return !1;
          }
        }
        return c.length === 0;
      }
      function o(s) {
        return typeof s == "string" ? s : Array.isArray(s) ? s.map(o).join("") : o(s.content);
      }
    })(t);
  }
  return $d;
}
var Bd, Vw;
function n7() {
  if (Vw) return Bd;
  Vw = 1, Bd = e, e.displayName = "nasm", e.aliases = [];
  function e(t) {
    t.languages.nasm = {
      comment: /;.*$/m,
      string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      label: {
        pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
        lookbehind: !0,
        alias: "function"
      },
      keyword: [
        /\[?BITS (?:16|32|64)\]?/,
        {
          pattern: /(^\s*)section\s*[a-z.]+:?/im,
          lookbehind: !0
        },
        /(?:extern|global)[^;\r\n]*/i,
        /(?:CPU|DEFAULT|FLOAT).*$/m
      ],
      register: {
        pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
        alias: "variable"
      },
      number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
      operator: /[\[\]*+\-\/%<>=&|$!]/
    };
  }
  return Bd;
}
var Ud, jw;
function r7() {
  if (jw) return Ud;
  jw = 1, Ud = e, e.displayName = "neon", e.aliases = [];
  function e(t) {
    t.languages.neon = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      datetime: {
        pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
        lookbehind: !0,
        alias: "number"
      },
      key: {
        pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
        lookbehind: !0,
        alias: "atrule"
      },
      number: {
        pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
        lookbehind: !0
      },
      null: {
        pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
        lookbehind: !0,
        alias: "keyword"
      },
      string: {
        pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
        lookbehind: !0,
        greedy: !0
      },
      literal: {
        pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
        lookbehind: !0,
        alias: "string"
      },
      punctuation: /[,:=[\]{}()-]/
    };
  }
  return Ud;
}
var Gd, Yw;
function a7() {
  if (Yw) return Gd;
  Yw = 1, Gd = e, e.displayName = "nevod", e.aliases = [];
  function e(t) {
    t.languages.nevod = {
      comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
      string: {
        pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
        greedy: !0,
        inside: {
          "string-attrs": /!$|!\*$|\*$/
        }
      },
      namespace: {
        pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
        lookbehind: !0
      },
      pattern: {
        pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
        lookbehind: !0,
        inside: {
          "pattern-name": {
            pattern: /^#?[a-zA-Z0-9\-.]+/,
            alias: "class-name"
          },
          fields: {
            pattern: /\(.*\)/,
            inside: {
              "field-name": {
                pattern: /[a-zA-Z0-9\-.]+/,
                alias: "variable"
              },
              punctuation: /[,()]/,
              operator: {
                pattern: /~/,
                alias: "field-hidden-mark"
              }
            }
          }
        }
      },
      search: {
        pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
        alias: "function",
        lookbehind: !0
      },
      keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
      "standard-pattern": {
        pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
        inside: {
          "standard-pattern-name": {
            pattern: /^[a-zA-Z0-9\-.]+/,
            alias: "builtin"
          },
          quantifier: {
            pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
            alias: "number"
          },
          "standard-pattern-attr": {
            pattern: /[a-zA-Z0-9\-.]+/,
            alias: "builtin"
          },
          punctuation: /[,()]/
        }
      },
      quantifier: {
        pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
        alias: "number"
      },
      operator: [
        {
          pattern: /=/,
          alias: "pattern-def"
        },
        {
          pattern: /&/,
          alias: "conjunction"
        },
        {
          pattern: /~/,
          alias: "exception"
        },
        {
          pattern: /\?/,
          alias: "optionality"
        },
        {
          pattern: /[[\]]/,
          alias: "repetition"
        },
        {
          pattern: /[{}]/,
          alias: "variation"
        },
        {
          pattern: /[+_]/,
          alias: "sequence"
        },
        {
          pattern: /\.{2,3}/,
          alias: "span"
        }
      ],
      "field-capture": [
        {
          pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
          lookbehind: !0,
          inside: {
            "field-name": {
              pattern: /[a-zA-Z0-9\-.]+/,
              alias: "variable"
            },
            colon: /:/
          }
        },
        {
          pattern: /[a-zA-Z0-9\-.]+\s*:/,
          inside: {
            "field-name": {
              pattern: /[a-zA-Z0-9\-.]+/,
              alias: "variable"
            },
            colon: /:/
          }
        }
      ],
      punctuation: /[:;,()]/,
      name: /[a-zA-Z0-9\-.]+/
    };
  }
  return Gd;
}
var Hd, Kw;
function i7() {
  if (Kw) return Hd;
  Kw = 1, Hd = e, e.displayName = "nginx", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
      n.languages.nginx = {
        comment: {
          pattern: /(^|[\s{};])#.*/,
          lookbehind: !0,
          greedy: !0
        },
        directive: {
          pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            string: {
              pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
              lookbehind: !0,
              greedy: !0,
              inside: {
                escape: {
                  pattern: /\\["'\\nrt]/,
                  alias: "entity"
                },
                variable: r
              }
            },
            comment: {
              pattern: /(\s)#.*/,
              lookbehind: !0,
              greedy: !0
            },
            keyword: {
              pattern: /^\S+/,
              greedy: !0
            },
            // other patterns
            boolean: {
              pattern: /(\s)(?:off|on)(?!\S)/,
              lookbehind: !0
            },
            number: {
              pattern: /(\s)\d+[a-z]*(?!\S)/i,
              lookbehind: !0
            },
            variable: r
          }
        },
        punctuation: /[{};]/
      };
    })(t);
  }
  return Hd;
}
var zd, Xw;
function o7() {
  if (Xw) return zd;
  Xw = 1, zd = e, e.displayName = "nim", e.aliases = [];
  function e(t) {
    t.languages.nim = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
        pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
        greedy: !0
      },
      char: {
        // Character literals are handled specifically to prevent issues with numeric type suffixes
        pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
        greedy: !0
      },
      function: {
        pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
        greedy: !0,
        inside: {
          operator: /\*$/
        }
      },
      // We don't want to highlight operators (and anything really) inside backticks
      identifier: {
        pattern: /`[^`\r\n]+`/,
        greedy: !0,
        inside: {
          punctuation: /`/
        }
      },
      // The negative look ahead prevents wrong highlighting of the .. operator
      number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
      keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
      operator: {
        // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
        // but allow the slice operator .. to take precedence over them
        // One can define his own operators in Nim so all combination of operators might be an operator.
        pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
        lookbehind: !0
      },
      punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
    };
  }
  return zd;
}
var Wd, Zw;
function s7() {
  if (Zw) return Wd;
  Zw = 1, Wd = e, e.displayName = "nix", e.aliases = [];
  function e(t) {
    t.languages.nix = {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|#.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
        greedy: !0,
        inside: {
          interpolation: {
            // The lookbehind ensures the ${} is not preceded by \ or ''
            pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
            lookbehind: !0,
            inside: null
            // see below
          }
        }
      },
      url: [
        /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
        {
          pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
          lookbehind: !0
        }
      ],
      antiquotation: {
        pattern: /\$(?=\{)/,
        alias: "important"
      },
      number: /\b\d+\b/,
      keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
      function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
      boolean: /\b(?:false|true)\b/,
      operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
      punctuation: /[{}()[\].,:;]/
    }, t.languages.nix.string.inside.interpolation.inside = t.languages.nix;
  }
  return Wd;
}
var qd, Qw;
function l7() {
  if (Qw) return qd;
  Qw = 1, qd = e, e.displayName = "nsis", e.aliases = [];
  function e(t) {
    t.languages.nsis = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: {
        pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|LabelAddress|TempFileName)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
        lookbehind: !0
      },
      property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
      constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
      variable: /\$\w[\w\.]*/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
      operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
      punctuation: /[{}[\];(),.:]/,
      important: {
        pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
        lookbehind: !0
      }
    };
  }
  return qd;
}
var Vd, Jw;
function c7() {
  if (Jw) return Vd;
  Jw = 1;
  var e = Or();
  Vd = t, t.displayName = "objectivec", t.aliases = ["objc"];
  function t(n) {
    n.register(e), n.languages.objectivec = n.languages.extend("c", {
      string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
      operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
    }), delete n.languages.objectivec["class-name"], n.languages.objc = n.languages.objectivec;
  }
  return Vd;
}
var jd, e_;
function u7() {
  if (e_) return jd;
  e_ = 1, jd = e, e.displayName = "ocaml", e.aliases = [];
  function e(t) {
    t.languages.ocaml = {
      comment: {
        pattern: /\(\*[\s\S]*?\*\)/,
        greedy: !0
      },
      char: {
        pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
        greedy: !0
      },
      string: [
        {
          pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
          greedy: !0
        },
        {
          pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
          greedy: !0
        }
      ],
      number: [
        // binary and octal
        /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
        // hexadecimal
        /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
        // decimal
        /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
      ],
      directive: {
        pattern: /\B#\w+/,
        alias: "property"
      },
      label: {
        pattern: /\B~\w+/,
        alias: "property"
      },
      "type-variable": {
        pattern: /\B'\w+/,
        alias: "function"
      },
      variant: {
        pattern: /`\w+/,
        alias: "symbol"
      },
      // For the list of keywords and operators,
      // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
      keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
      boolean: /\b(?:false|true)\b/,
      "operator-like-punctuation": {
        pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
        alias: "punctuation"
      },
      // Custom operators are allowed
      operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
      punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
    };
  }
  return jd;
}
var Yd, t_;
function d7() {
  if (t_) return Yd;
  t_ = 1;
  var e = Or();
  Yd = t, t.displayName = "opencl", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.opencl = r.languages.extend("c", {
        // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
        keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
        // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
        // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
        // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
        boolean: /\b(?:false|true)\b/,
        "constant-opencl-kernel": {
          pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
          alias: "constant"
        }
      }), r.languages.insertBefore("opencl", "class-name", {
        // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
        // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
        "builtin-type": {
          pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
          alias: "keyword"
        }
      });
      var a = {
        // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
        "type-opencl-host": {
          pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
          alias: "keyword"
        },
        "boolean-opencl-host": {
          pattern: /\bCL_(?:FALSE|TRUE)\b/,
          alias: "boolean"
        },
        // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
        "constant-opencl-host": {
          pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
          alias: "constant"
        },
        // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
        "function-opencl-host": {
          pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
          alias: "function"
        }
      };
      r.languages.insertBefore("c", "keyword", a), r.languages.cpp && (a["type-opencl-host-cpp"] = {
        pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
        alias: "keyword"
      }, r.languages.insertBefore("cpp", "keyword", a));
    }(n);
  }
  return Yd;
}
var Kd, n_;
function f7() {
  if (n_) return Kd;
  n_ = 1, Kd = e, e.displayName = "openqasm", e.aliases = ["qasm"];
  function e(t) {
    t.languages.openqasm = {
      comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
      string: {
        pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
        greedy: !0
      },
      keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
      "class-name": /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
      function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
      constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
      number: {
        pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
        lookbehind: !0
      },
      operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
      punctuation: /[(){}\[\];,:.]/
    }, t.languages.qasm = t.languages.openqasm;
  }
  return Kd;
}
var Xd, r_;
function p7() {
  if (r_) return Xd;
  r_ = 1, Xd = e, e.displayName = "oz", e.aliases = [];
  function e(t) {
    t.languages.oz = {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|%.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\[\s\S])*"/,
        greedy: !0
      },
      atom: {
        pattern: /'(?:[^'\\]|\\[\s\S])*'/,
        greedy: !0,
        alias: "builtin"
      },
      keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
      function: [
        /\b[a-z][A-Za-z\d]*(?=\()/,
        {
          pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
          lookbehind: !0
        }
      ],
      number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
      variable: /`(?:[^`\\]|\\.)+`/,
      "attr-name": /\b\w+(?=[ \t]*:(?![:=]))/,
      operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
      punctuation: /[\[\](){}.:;?]/
    };
  }
  return Xd;
}
var Zd, a_;
function g7() {
  if (a_) return Zd;
  a_ = 1, Zd = e, e.displayName = "parigp", e.aliases = [];
  function e(t) {
    t.languages.parigp = {
      comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"/,
        greedy: !0
      },
      // PARI/GP does not care about white spaces at all
      // so let's process the keywords to build an appropriate regexp
      // (e.g. "b *r *e *a *k", etc.)
      keyword: function() {
        var n = [
          "breakpoint",
          "break",
          "dbg_down",
          "dbg_err",
          "dbg_up",
          "dbg_x",
          "forcomposite",
          "fordiv",
          "forell",
          "forpart",
          "forprime",
          "forstep",
          "forsubgroup",
          "forvec",
          "for",
          "iferr",
          "if",
          "local",
          "my",
          "next",
          "return",
          "until",
          "while"
        ];
        return n = n.map(function(r) {
          return r.split("").join(" *");
        }).join("|"), RegExp("\\b(?:" + n + ")\\b");
      }(),
      function: /\b\w(?:[\w ]*\w)?(?= *\()/,
      number: {
        // The lookbehind and the negative lookahead prevent from breaking the .. operator
        pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
        lookbehind: !0
      },
      operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
      punctuation: /[\[\]{}().,:;|]/
    };
  }
  return Zd;
}
var Qd, i_;
function h7() {
  if (i_) return Qd;
  i_ = 1, Qd = e, e.displayName = "parser", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.languages.parser = n.languages.extend("markup", {
        keyword: {
          pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
          lookbehind: !0
        },
        variable: {
          pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
          lookbehind: !0,
          inside: {
            punctuation: /\.|:+/
          }
        },
        function: {
          pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
          lookbehind: !0,
          inside: {
            keyword: {
              pattern: /(^@)(?:GET_|SET_)/,
              lookbehind: !0
            },
            punctuation: /\.|:+/
          }
        },
        escape: {
          pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
          alias: "builtin"
        },
        punctuation: /[\[\](){};]/
      });
      r = n.languages.insertBefore("parser", "keyword", {
        "parser-comment": {
          pattern: /(\s)#.*/,
          lookbehind: !0,
          alias: "comment"
        },
        expression: {
          // Allow for 3 levels of depth
          pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
          greedy: !0,
          lookbehind: !0,
          inside: {
            string: {
              pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
              lookbehind: !0
            },
            keyword: r.keyword,
            variable: r.variable,
            function: r.function,
            boolean: /\b(?:false|true)\b/,
            number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
            escape: r.escape,
            operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
            punctuation: r.punctuation
          }
        }
      }), n.languages.insertBefore(
        "inside",
        "punctuation",
        {
          expression: r.expression,
          keyword: r.keyword,
          variable: r.variable,
          function: r.function,
          escape: r.escape,
          "parser-punctuation": {
            pattern: r.punctuation,
            alias: "punctuation"
          }
        },
        r.tag.inside["attr-value"]
      );
    })(t);
  }
  return Qd;
}
var Jd, o_;
function m7() {
  if (o_) return Jd;
  o_ = 1, Jd = e, e.displayName = "pascal", e.aliases = ["objectpascal"];
  function e(t) {
    t.languages.pascal = {
      directive: {
        pattern: /\{\$[\s\S]*?\}/,
        greedy: !0,
        alias: ["marco", "property"]
      },
      comment: {
        pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
        greedy: !0
      },
      string: {
        pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
        greedy: !0
      },
      asm: {
        pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      keyword: [
        {
          // Turbo Pascal
          pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
          lookbehind: !0
        },
        {
          // Free Pascal
          pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
          lookbehind: !0
        },
        {
          // Object Pascal
          pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
          lookbehind: !0
        },
        {
          // Modifiers
          pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
          lookbehind: !0
        }
      ],
      number: [
        // Hexadecimal, octal and binary
        /(?:[&%]\d+|\$[a-f\d]+)/i,
        // Decimal
        /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
      ],
      operator: [
        /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
        {
          pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
          lookbehind: !0
        }
      ],
      punctuation: /\(\.|\.\)|[()\[\]:;,.]/
    }, t.languages.pascal.asm.inside = t.languages.extend("pascal", {
      asm: void 0,
      keyword: void 0,
      operator: void 0
    }), t.languages.objectpascal = t.languages.pascal;
  }
  return Jd;
}
var ef, s_;
function b7() {
  if (s_) return ef;
  s_ = 1, ef = e, e.displayName = "pascaligo", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source, a = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(
        /<braces>/g,
        function() {
          return r;
        }
      ), i = n.languages.pascaligo = {
        comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
        string: {
          pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
          greedy: !0
        },
        "class-name": [
          {
            pattern: RegExp(
              /(\btype\s+\w+\s+is\s+)<type>/.source.replace(
                /<type>/g,
                function() {
                  return a;
                }
              ),
              "i"
            ),
            lookbehind: !0,
            inside: null
            // see below
          },
          {
            pattern: RegExp(
              /<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
                return a;
              }),
              "i"
            ),
            inside: null
            // see below
          },
          {
            pattern: RegExp(
              /(:\s*)<type>/.source.replace(/<type>/g, function() {
                return a;
              })
            ),
            lookbehind: !0,
            inside: null
            // see below
          }
        ],
        keyword: {
          pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
          lookbehind: !0
        },
        boolean: {
          pattern: /(^|[^&])\b(?:False|True)\b/i,
          lookbehind: !0
        },
        builtin: {
          pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
          lookbehind: !0
        },
        function: /\b\w+(?=\s*\()/,
        number: [
          // Hexadecimal, octal and binary
          /%[01]+|&[0-7]+|\$[a-f\d]+/i,
          // Decimal
          /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
        ],
        operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
        punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
      }, o = [
        "comment",
        "keyword",
        "builtin",
        "operator",
        "punctuation"
      ].reduce(function(s, l) {
        return s[l] = i[l], s;
      }, {});
      i["class-name"].forEach(function(s) {
        s.inside = o;
      });
    })(t);
  }
  return ef;
}
var tf, l_;
function v7() {
  if (l_) return tf;
  l_ = 1, tf = e, e.displayName = "pcaxis", e.aliases = ["px"];
  function e(t) {
    t.languages.pcaxis = {
      string: /"[^"]*"/,
      keyword: {
        pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^[-A-Z\d]+/,
          language: {
            pattern: /^(\s*)\[[-\w]+\]/,
            lookbehind: !0,
            inside: {
              punctuation: /^\[|\]$/,
              property: /[-\w]+/
            }
          },
          "sub-key": {
            pattern: /^(\s*)\S[\s\S]*/,
            lookbehind: !0,
            inside: {
              parameter: {
                pattern: /"[^"]*"/,
                alias: "property"
              },
              punctuation: /^\(|\)$|,/
            }
          }
        }
      },
      operator: /=/,
      tlist: {
        pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
        greedy: !0,
        inside: {
          function: /^TLIST/,
          property: {
            pattern: /^(\s*\(\s*)\w+/,
            lookbehind: !0
          },
          string: /"[^"]*"/,
          punctuation: /[(),]/,
          operator: /-/
        }
      },
      punctuation: /[;,]/,
      number: {
        pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
        lookbehind: !0
      },
      boolean: /NO|YES/
    }, t.languages.px = t.languages.pcaxis;
  }
  return tf;
}
var nf, c_;
function y7() {
  if (c_) return nf;
  c_ = 1, nf = e, e.displayName = "peoplecode", e.aliases = ["pcode"];
  function e(t) {
    t.languages.peoplecode = {
      comment: RegExp(
        [
          // C-style multiline comments
          /\/\*[\s\S]*?\*\//.source,
          // REM comments
          /\bREM[^;]*;/.source,
          // Nested <* *> comments
          /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
          // /+ +/ comments
          /\/\+[\s\S]*?\+\//.source
        ].join("|")
      ),
      string: {
        pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
        greedy: !0
      },
      variable: /%\w+/,
      "function-definition": {
        pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
        lookbehind: !0,
        alias: "function"
      },
      "class-name": {
        pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
        lookbehind: !0,
        inside: {
          punctuation: /:/
        }
      },
      keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
      "operator-keyword": {
        pattern: /\b(?:and|not|or)\b/i,
        alias: "operator"
      },
      function: /[_a-z]\w*(?=\s*\()/i,
      boolean: /\b(?:false|true)\b/i,
      number: /\b\d+(?:\.\d+)?\b/,
      operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
      punctuation: /[:.;,()[\]]/
    }, t.languages.pcode = t.languages.peoplecode;
  }
  return nf;
}
var rf, u_;
function E7() {
  if (u_) return rf;
  u_ = 1, rf = e, e.displayName = "perl", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
      n.languages.perl = {
        comment: [
          {
            // POD
            pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        // TODO Could be nice to handle Heredoc too.
        string: [
          {
            pattern: RegExp(
              /\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // q/.../
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                // q a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // q(...)
                // q{...}
                // q[...]
                // q<...>
                r
              ].join("|") + ")"
            ),
            greedy: !0
          },
          // "...", `...`
          {
            pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
            greedy: !0
          },
          // '...'
          // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
          {
            pattern: /'(?:[^'\\\r\n]|\\.)*'/,
            greedy: !0
          }
        ],
        regex: [
          {
            pattern: RegExp(
              /\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // m/.../
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                // m a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // m(...)
                // m{...}
                // m[...]
                // m<...>
                r
              ].join("|") + ")" + /[msixpodualngc]*/.source
            ),
            greedy: !0
          },
          // The lookbehinds prevent -s from breaking
          {
            pattern: RegExp(
              /(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // s/.../.../
                // eslint-disable-next-line regexp/strict
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // s a...a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                // s(...)(...)
                // s{...}{...}
                // s[...][...]
                // s<...><...>
                // s(...)[...]
                r + /\s*/.source + r
              ].join("|") + ")" + /[msixpodualngcer]*/.source
            ),
            lookbehind: !0,
            greedy: !0
          },
          // /.../
          // The look-ahead tries to prevent two divisions on
          // the same line from being highlighted as regex.
          // This does not support multi-line regex.
          {
            pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
            greedy: !0
          }
        ],
        // FIXME Not sure about the handling of ::, ', and #
        variable: [
          // ${^POSTMATCH}
          /[&*$@%]\{\^[A-Z]+\}/,
          // $^V
          /[&*$@%]\^[A-Z_]/,
          // ${...}
          /[&*$@%]#?(?=\{)/,
          // $foo
          /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
          // $1
          /[&*$@%]\d+/,
          // $_, @_, %!
          // The negative lookahead prevents from breaking the %= operator
          /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
        ],
        filehandle: {
          // <>, <FOO>, _
          pattern: /<(?![<=])\S*?>|\b_\b/,
          alias: "symbol"
        },
        "v-string": {
          // v1.2, 1.2.3
          pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
          alias: "string"
        },
        function: {
          pattern: /(\bsub[ \t]+)\w+/,
          lookbehind: !0
        },
        keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
        operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
        punctuation: /[{}[\];(),:]/
      };
    })(t);
  }
  return rf;
}
var af, d_;
function S7() {
  if (d_) return af;
  d_ = 1;
  var e = Us();
  af = t, t.displayName = "phpExtras", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.insertBefore("php", "variable", {
      this: {
        pattern: /\$this\b/,
        alias: "keyword"
      },
      global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
      scope: {
        pattern: /\b[\w\\]+::/,
        inside: {
          keyword: /\b(?:parent|self|static)\b/,
          punctuation: /::|\\/
        }
      }
    });
  }
  return af;
}
var of, f_;
function w7() {
  if (f_) return of;
  f_ = 1;
  var e = Us(), t = Bs();
  of = n, n.displayName = "phpdoc", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      var i = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
      a.languages.phpdoc = a.languages.extend("javadoclike", {
        parameter: {
          pattern: RegExp(
            "(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:" + i + "\\s+)?)\\$\\w+"
          ),
          lookbehind: !0
        }
      }), a.languages.insertBefore("phpdoc", "keyword", {
        "class-name": [
          {
            pattern: RegExp(
              "(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)" + i
            ),
            lookbehind: !0,
            inside: {
              keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
              punctuation: /[|\\[\]()]/
            }
          }
        ]
      }), a.languages.javadoclike.addSupport("php", a.languages.phpdoc);
    }(r);
  }
  return of;
}
var sf, p_;
function _7() {
  if (p_) return sf;
  p_ = 1;
  var e = wm();
  sf = t, t.displayName = "plsql", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.plsql = n.languages.extend("sql", {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|--.*/,
        greedy: !0
      },
      // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
      keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
      // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
      operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
    }), n.languages.insertBefore("plsql", "operator", {
      label: {
        pattern: /<<\s*\w+\s*>>/,
        alias: "symbol"
      }
    });
  }
  return sf;
}
var lf, g_;
function T7() {
  if (g_) return lf;
  g_ = 1, lf = e, e.displayName = "powerquery", e.aliases = [];
  function e(t) {
    t.languages.powerquery = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0,
        greedy: !0
      },
      "quoted-identifier": {
        pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      string: {
        pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      constant: [
        /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
        /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
        /\bOccurrence\.(?:All|First|Last)\b/,
        /\bOrder\.(?:Ascending|Descending)\b/,
        /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
        /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
        /\bQuoteStyle\.(?:Csv|None)\b/,
        /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
        /\bGroupKind\.(?:Global|Local)\b/,
        /\bExtraValues\.(?:Error|Ignore|List)\b/,
        /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
        /\bJoinSide\.(?:Left|Right)\b/,
        /\bPrecision\.(?:Decimal|Double)\b/,
        /\bRelativePosition\.From(?:End|Start)\b/,
        /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
        /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
        /\bnull\b/
      ],
      boolean: /\b(?:false|true)\b/,
      keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
      function: {
        pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
        lookbehind: !0
      },
      "data-type": {
        pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
        alias: "class-name"
      },
      number: {
        pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
        lookbehind: !0
      },
      operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
      punctuation: /[,;\[\](){}]/
    }, t.languages.pq = t.languages.powerquery, t.languages.mscript = t.languages.powerquery;
  }
  return lf;
}
var cf, h_;
function R7() {
  if (h_) return cf;
  h_ = 1, cf = e, e.displayName = "powershell", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.languages.powershell = {
        comment: [
          {
            pattern: /(^|[^`])<#[\s\S]*?#>/,
            lookbehind: !0
          },
          {
            pattern: /(^|[^`])#.*/,
            lookbehind: !0
          }
        ],
        string: [
          {
            pattern: /"(?:`[\s\S]|[^`"])*"/,
            greedy: !0,
            inside: null
            // see below
          },
          {
            pattern: /'(?:[^']|'')*'/,
            greedy: !0
          }
        ],
        // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
        // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
        namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
        boolean: /\$(?:false|true)\b/i,
        variable: /\$\w+\b/,
        // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
        // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
        // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
        function: [
          /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
          /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
        ],
        // per http://technet.microsoft.com/en-us/library/hh847744.aspx
        keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
        operator: {
          pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
          lookbehind: !0
        },
        punctuation: /[|{}[\];(),.]/
      };
      r.string[0].inside = {
        function: {
          // Allow for one level of nesting
          pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
          lookbehind: !0,
          inside: r
        },
        boolean: r.boolean,
        variable: r.variable
      };
    })(t);
  }
  return cf;
}
var uf, m_;
function A7() {
  if (m_) return uf;
  m_ = 1, uf = e, e.displayName = "processing", e.aliases = [];
  function e(t) {
    t.languages.processing = t.languages.extend("clike", {
      keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
      // Spaces are allowed between function name and parenthesis
      function: /\b\w+(?=\s*\()/,
      operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
    }), t.languages.insertBefore("processing", "number", {
      // Special case: XML is a type
      constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
      type: {
        pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
        alias: "class-name"
      }
    });
  }
  return uf;
}
var df, b_;
function x7() {
  if (b_) return df;
  b_ = 1, df = e, e.displayName = "prolog", e.aliases = [];
  function e(t) {
    t.languages.prolog = {
      // Syntax depends on the implementation
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|%.*/,
        greedy: !0
      },
      // Depending on the implementation, strings may allow escaped newlines and quote-escape
      string: {
        pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
        greedy: !0
      },
      builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
      // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
      function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
      number: /\b\d+(?:\.\d*)?/,
      // Custom operators are allowed
      operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
      punctuation: /[(){}\[\],]/
    };
  }
  return df;
}
var ff, v_;
function C7() {
  if (v_) return ff;
  v_ = 1, ff = e, e.displayName = "promql", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = [
        "sum",
        "min",
        "max",
        "avg",
        "group",
        "stddev",
        "stdvar",
        "count",
        "count_values",
        "bottomk",
        "topk",
        "quantile"
      ], a = [
        "on",
        "ignoring",
        "group_right",
        "group_left",
        "by",
        "without"
      ], i = ["offset"], o = r.concat(a, i);
      n.languages.promql = {
        comment: {
          pattern: /(^[ \t]*)#.*/m,
          lookbehind: !0
        },
        "vector-match": {
          // Match the comma-separated label lists inside vector matching:
          pattern: new RegExp(
            "((?:" + a.join("|") + ")\\s*)\\([^)]*\\)"
          ),
          lookbehind: !0,
          inside: {
            "label-key": {
              pattern: /\b[^,]+\b/,
              alias: "attr-name"
            },
            punctuation: /[(),]/
          }
        },
        "context-labels": {
          pattern: /\{[^{}]*\}/,
          inside: {
            "label-key": {
              pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
              alias: "attr-name"
            },
            "label-value": {
              pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
              greedy: !0,
              alias: "attr-value"
            },
            punctuation: /\{|\}|=~?|![=~]|,/
          }
        },
        "context-range": [
          {
            pattern: /\[[\w\s:]+\]/,
            // [1m]
            inside: {
              punctuation: /\[|\]|:/,
              "range-duration": {
                pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                alias: "number"
              }
            }
          },
          {
            pattern: /(\boffset\s+)\w+/,
            // offset 1m
            lookbehind: !0,
            inside: {
              "range-duration": {
                pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                alias: "number"
              }
            }
          }
        ],
        keyword: new RegExp("\\b(?:" + o.join("|") + ")\\b", "i"),
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
        operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
        punctuation: /[{};()`,.[\]]/
      };
    })(t);
  }
  return ff;
}
var pf, y_;
function N7() {
  if (y_) return pf;
  y_ = 1, pf = e, e.displayName = "properties", e.aliases = [];
  function e(t) {
    t.languages.properties = {
      comment: /^[ \t]*[#!].*$/m,
      "attr-value": {
        pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
        lookbehind: !0
      },
      "attr-name": /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
      punctuation: /[=:]/
    };
  }
  return pf;
}
var gf, E_;
function I7() {
  if (E_) return gf;
  E_ = 1, gf = e, e.displayName = "protobuf", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
      n.languages.protobuf = n.languages.extend("clike", {
        "class-name": [
          {
            pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
            lookbehind: !0
          },
          {
            pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
            lookbehind: !0
          }
        ],
        keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
        function: /\b[a-z_]\w*(?=\s*\()/i
      }), n.languages.insertBefore("protobuf", "operator", {
        map: {
          pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
          alias: "class-name",
          inside: {
            punctuation: /[<>.,]/,
            builtin: r
          }
        },
        builtin: r,
        "positional-class-name": {
          pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
          alias: "class-name",
          inside: {
            punctuation: /\./
          }
        },
        annotation: {
          pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
          lookbehind: !0
        }
      });
    })(t);
  }
  return gf;
}
var hf, S_;
function k7() {
  if (S_) return hf;
  S_ = 1, hf = e, e.displayName = "psl", e.aliases = [];
  function e(t) {
    t.languages.psl = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:\\.|[^\\"])*"/,
        greedy: !0,
        inside: {
          symbol: /\\[ntrbA-Z"\\]/
        }
      },
      "heredoc-string": {
        pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
        alias: "string",
        greedy: !0
      },
      keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
      constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
      boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
      variable: /\b(?:PslDebug|errno|exit_status)\b/,
      builtin: {
        pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
        alias: "builtin-function"
      },
      "foreach-variable": {
        pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
        lookbehind: !0,
        greedy: !0
      },
      function: /\b[_a-z]\w*\b(?=\s*\()/i,
      number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
      operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
      punctuation: /[(){}\[\];,]/
    };
  }
  return hf;
}
var mf, w_;
function O7() {
  if (w_) return mf;
  w_ = 1, mf = e, e.displayName = "pug", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.pug = {
        // Multiline stuff should appear before the rest
        // This handles both single-line and multi-line comments
        comment: {
          pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
          lookbehind: !0
        },
        // All the tag-related part is in lookbehind
        // so that it can be highlighted by the "tag" pattern
        "multiline-script": {
          pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        // See at the end of the file for known filters
        filter: {
          pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "variable"
            },
            text: /\S[\s\S]*/
          }
        },
        "multiline-plain-text": {
          pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0
        },
        markup: {
          pattern: /(^[\t ]*)<.+/m,
          lookbehind: !0,
          inside: n.languages.markup
        },
        doctype: {
          pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
          lookbehind: !0
        },
        // This handle all conditional and loop keywords
        "flow-control": {
          pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
          lookbehind: !0,
          inside: {
            each: {
              pattern: /^each .+? in\b/,
              inside: {
                keyword: /\b(?:each|in)\b/,
                punctuation: /,/
              }
            },
            branch: {
              pattern: /^(?:case|default|else|if|unless|when|while)\b/,
              alias: "keyword"
            },
            rest: n.languages.javascript
          }
        },
        keyword: {
          pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
          lookbehind: !0
        },
        mixin: [
          // Declaration
          {
            pattern: /(^[\t ]*)mixin .+/m,
            lookbehind: !0,
            inside: {
              keyword: /^mixin/,
              function: /\w+(?=\s*\(|\s*$)/,
              punctuation: /[(),.]/
            }
          },
          // Usage
          {
            pattern: /(^[\t ]*)\+.+/m,
            lookbehind: !0,
            inside: {
              name: {
                pattern: /^\+\w+/,
                alias: "function"
              },
              rest: n.languages.javascript
            }
          }
        ],
        script: {
          pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        "plain-text": {
          pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
          lookbehind: !0
        },
        tag: {
          pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
          lookbehind: !0,
          inside: {
            attributes: [
              {
                pattern: /&[^(]+\([^)]+\)/,
                inside: n.languages.javascript
              },
              {
                pattern: /\([^)]+\)/,
                inside: {
                  "attr-value": {
                    pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                    lookbehind: !0,
                    inside: n.languages.javascript
                  },
                  "attr-name": /[\w-]+(?=\s*!?=|\s*[,)])/,
                  punctuation: /[!=(),]+/
                }
              }
            ],
            punctuation: /:/,
            "attr-id": /#[\w\-]+/,
            "attr-class": /\.[\w\-]+/
          }
        },
        code: [
          {
            pattern: /(^[\t ]*(?:-|!?=)).+/m,
            lookbehind: !0,
            inside: n.languages.javascript
          }
        ],
        punctuation: /[.\-!=|]+/
      };
      for (var r = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source, a = [
        {
          filter: "atpl",
          language: "twig"
        },
        {
          filter: "coffee",
          language: "coffeescript"
        },
        "ejs",
        "handlebars",
        "less",
        "livescript",
        "markdown",
        {
          filter: "sass",
          language: "scss"
        },
        "stylus"
      ], i = {}, o = 0, s = a.length; o < s; o++) {
        var l = a[o];
        l = typeof l == "string" ? {
          filter: l,
          language: l
        } : l, n.languages[l.language] && (i["filter-" + l.filter] = {
          pattern: RegExp(
            r.replace("<filter_name>", function() {
              return l.filter;
            }),
            "m"
          ),
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "variable"
            },
            text: {
              pattern: /\S[\s\S]*/,
              alias: [l.language, "language-" + l.language],
              inside: n.languages[l.language]
            }
          }
        });
      }
      n.languages.insertBefore("pug", "filter", i);
    })(t);
  }
  return mf;
}
var bf, __;
function D7() {
  if (__) return bf;
  __ = 1, bf = e, e.displayName = "puppet", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.puppet = {
        heredoc: [
          // Matches the content of a quoted heredoc string (subject to interpolation)
          {
            pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
            lookbehind: !0,
            alias: "string",
            inside: {
              // Matches the end tag
              punctuation: /(?=\S).*\S(?= *$)/
              // See interpolation below
            }
          },
          // Matches the content of an unquoted heredoc string (no interpolation)
          {
            pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: {
              // Matches the end tag
              punctuation: /(?=\S).*\S(?= *$)/
            }
          },
          // Matches the start tag of heredoc strings
          {
            pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
            alias: "string",
            inside: {
              punctuation: {
                pattern: /(\().+?(?=\))/,
                lookbehind: !0
              }
            }
          }
        ],
        "multiline-comment": {
          pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
          lookbehind: !0,
          greedy: !0,
          alias: "comment"
        },
        regex: {
          // Must be prefixed with the keyword "node" or a non-word char
          pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            // Extended regexes must have the x flag. They can contain single-line comments.
            "extended-regex": {
              pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
              inside: {
                comment: /#.*/
              }
            }
          }
        },
        comment: {
          pattern: /(^|[^\\])#.*/,
          lookbehind: !0,
          greedy: !0
        },
        string: {
          // Allow for one nested level of double quotes inside interpolation
          pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
          greedy: !0,
          inside: {
            "double-quoted": {
              pattern: /^"[\s\S]*"$/,
              inside: {
                // See interpolation below
              }
            }
          }
        },
        variable: {
          pattern: /\$(?:::)?\w+(?:::\w+)*/,
          inside: {
            punctuation: /::/
          }
        },
        "attr-name": /(?:\b\w+|\*)(?=\s*=>)/,
        function: [
          {
            pattern: /(\.)(?!\d)\w+/,
            lookbehind: !0
          },
          /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
        ],
        number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
        boolean: /\b(?:false|true)\b/,
        // Includes words reserved for future use
        keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
        datatype: {
          pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
          alias: "symbol"
        },
        operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
        punctuation: /[\[\]{}().,;]|:+/
      };
      var r = [
        {
          // Allow for one nested level of braces inside interpolation
          pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
          lookbehind: !0,
          inside: {
            "short-variable": {
              // Negative look-ahead prevent wrong highlighting of functions
              pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
              lookbehind: !0,
              alias: "variable",
              inside: {
                punctuation: /::/
              }
            },
            delimiter: {
              pattern: /^\$/,
              alias: "variable"
            },
            rest: n.languages.puppet
          }
        },
        {
          pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
          lookbehind: !0,
          alias: "variable",
          inside: {
            punctuation: /::/
          }
        }
      ];
      n.languages.puppet.heredoc[0].inside.interpolation = r, n.languages.puppet.string.inside["double-quoted"].inside.interpolation = r;
    })(t);
  }
  return bf;
}
var vf, T_;
function L7() {
  if (T_) return vf;
  T_ = 1, vf = e, e.displayName = "pure", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.pure = {
        comment: [
          {
            pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
            lookbehind: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0
          },
          /#!.+/
        ],
        "inline-lang": {
          pattern: /%<[\s\S]+?%>/,
          greedy: !0,
          inside: {
            lang: {
              pattern: /(^%< *)-\*-.+?-\*-/,
              lookbehind: !0,
              alias: "comment"
            },
            delimiter: {
              pattern: /^%<.*|%>$/,
              alias: "punctuation"
            }
          }
        },
        string: {
          pattern: /"(?:\\.|[^"\\\r\n])*"/,
          greedy: !0
        },
        number: {
          // The look-behind prevents wrong highlighting of the .. operator
          pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
          lookbehind: !0
        },
        keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
        function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
        special: {
          pattern: /\b__[a-z]+__\b/i,
          alias: "builtin"
        },
        // Any combination of operator chars can be an operator
        // eslint-disable-next-line no-misleading-character-class
        operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
        // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
        punctuation: /[(){}\[\];,|]/
      };
      var r = [
        "c",
        {
          lang: "c++",
          alias: "cpp"
        },
        "fortran"
      ], a = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
      r.forEach(function(i) {
        var o = i;
        if (typeof i != "string" && (o = i.alias, i = i.lang), n.languages[o]) {
          var s = {};
          s["inline-lang-" + o] = {
            pattern: RegExp(
              a.replace(
                "<lang>",
                i.replace(/([.+*?\/\\(){}\[\]])/g, "\\$1")
              ),
              "i"
            ),
            inside: n.util.clone(n.languages.pure["inline-lang"].inside)
          }, s["inline-lang-" + o].inside.rest = n.util.clone(
            n.languages[o]
          ), n.languages.insertBefore("pure", "inline-lang", s);
        }
      }), n.languages.c && (n.languages.pure["inline-lang"].inside.rest = n.util.clone(
        n.languages.c
      ));
    })(t);
  }
  return vf;
}
var yf, R_;
function M7() {
  if (R_) return yf;
  R_ = 1, yf = e, e.displayName = "purebasic", e.aliases = [];
  function e(t) {
    t.languages.purebasic = t.languages.extend("clike", {
      comment: /;.*/,
      keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
      function: /\b\w+(?:\.\w+)?\s*(?=\()/,
      number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
      operator: /(?:@\*?|\?|\*)\w+|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
    }), t.languages.insertBefore("purebasic", "keyword", {
      tag: /#\w+\$?/,
      asm: {
        pattern: /(^[\t ]*)!.*/m,
        lookbehind: !0,
        alias: "tag",
        inside: {
          comment: /;.*/,
          string: {
            pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: !0
          },
          // Anonymous label references, i.e.: jmp @b
          "label-reference-anonymous": {
            pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
            lookbehind: !0,
            alias: "fasm-label"
          },
          // Named label reference, i.e.: jne label1
          "label-reference-addressed": {
            pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
            lookbehind: !0,
            alias: "fasm-label"
          },
          keyword: [
            /\b(?:extern|global)\b[^;\r\n]*/i,
            /\b(?:CPU|DEFAULT|FLOAT)\b.*/
          ],
          function: {
            pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
            lookbehind: !0
          },
          "function-inline": {
            pattern: /(:\s*)[\da-z]+(?=\s)/i,
            lookbehind: !0,
            alias: "function"
          },
          label: {
            pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
            lookbehind: !0,
            alias: "fasm-label"
          },
          register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
          number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
          operator: /[\[\]*+\-/%<>=&|$!,.:]/
        }
      }
    }), delete t.languages.purebasic["class-name"], delete t.languages.purebasic.boolean, t.languages.pbfasm = t.languages.purebasic;
  }
  return yf;
}
var Ef, A_;
function P7() {
  if (A_) return Ef;
  A_ = 1;
  var e = Tm();
  Ef = t, t.displayName = "purescript", t.aliases = ["purs"];
  function t(n) {
    n.register(e), n.languages.purescript = n.languages.extend("haskell", {
      keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|hiding|import)\b/,
          punctuation: /\./
        }
      },
      // These are builtin functions only. Constructors are highlighted later as a constant.
      builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
      operator: [
        // Infix operators
        n.languages.haskell.operator[0],
        // ASCII operators
        n.languages.haskell.operator[2],
        // All UTF16 Unicode operator symbols
        // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
        // See https://github.com/PrismJS/prism/issues/3006 for more details.
        /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
      ]
    }), n.languages.purs = n.languages.purescript;
  }
  return Ef;
}
var Sf, x_;
function F7() {
  if (x_) return Sf;
  x_ = 1, Sf = e, e.displayName = "python", e.aliases = ["py"];
  function e(t) {
    t.languages.python = {
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0,
        greedy: !0
      },
      "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: !0,
        inside: {
          interpolation: {
            // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
            pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
            lookbehind: !0,
            inside: {
              "format-spec": {
                pattern: /(:)[^:(){}]+(?=\}$)/,
                lookbehind: !0
              },
              "conversion-option": {
                pattern: /![sra](?=[:}]$)/,
                alias: "punctuation"
              },
              rest: null
            }
          },
          string: /[\s\S]+/
        }
      },
      "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: !0
      },
      function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: !0
      },
      "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: !0
      },
      decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: !0,
        alias: ["annotation", "punctuation"],
        inside: {
          punctuation: /\./
        }
      },
      keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
      builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
      boolean: /\b(?:False|None|True)\b/,
      number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
      operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.python["string-interpolation"].inside.interpolation.inside.rest = t.languages.python, t.languages.py = t.languages.python;
  }
  return Sf;
}
var wf, C_;
function $7() {
  if (C_) return wf;
  C_ = 1, wf = e, e.displayName = "q", e.aliases = [];
  function e(t) {
    t.languages.q = {
      string: /"(?:\\.|[^"\\\r\n])*"/,
      comment: [
        // From http://code.kx.com/wiki/Reference/Slash:
        // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
        {
          pattern: /([\t )\]}])\/.*/,
          lookbehind: !0,
          greedy: !0
        },
        // From http://code.kx.com/wiki/Reference/Slash:
        // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
        // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
        // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
        // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
        {
          pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
          lookbehind: !0,
          greedy: !0
        },
        // From http://code.kx.com/wiki/Reference/Slash:
        // A \ on a line by itself with no preceding matching / will comment to end of file.
        {
          pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
          greedy: !0
        },
        {
          pattern: /^#!.+/m,
          greedy: !0
        }
      ],
      symbol: /`(?::\S+|[\w.]*)/,
      datetime: {
        pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
        alias: "number"
      },
      // The negative look-ahead prevents bad highlighting
      // of verbs 0: and 1:
      number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
      keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
      adverb: {
        pattern: /['\/\\]:?|\beach\b/,
        alias: "function"
      },
      verb: {
        pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
        alias: "operator"
      },
      punctuation: /[(){}\[\];.]/
    };
  }
  return wf;
}
var _f, N_;
function B7() {
  if (N_) return _f;
  N_ = 1, _f = e, e.displayName = "qml", e.aliases = [];
  function e(t) {
    (function(n) {
      for (var r = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source, a = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source, i = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
        return r;
      }).replace(/<comment>/g, function() {
        return a;
      }), o = 0; o < 2; o++)
        i = i.replace(/<expr>/g, function() {
          return i;
        });
      i = i.replace(/<expr>/g, "[^\\s\\S]"), n.languages.qml = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
          greedy: !0
        },
        "javascript-function": {
          pattern: RegExp(
            /((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(
              /<js>/g,
              function() {
                return i;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "language-javascript",
          inside: n.languages.javascript
        },
        "class-name": {
          pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
          lookbehind: !0
        },
        property: [
          {
            pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
            lookbehind: !0
          },
          {
            pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
            lookbehind: !0,
            inside: {
              keyword: /^property/,
              property: /\w+(?:\.\w+)*/
            }
          }
        ],
        "javascript-expression": {
          pattern: RegExp(
            /(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(
              /<js>/g,
              function() {
                return i;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "language-javascript",
          inside: n.languages.javascript
        },
        string: {
          pattern: /"(?:\\.|[^\\"\r\n])*"/,
          greedy: !0
        },
        keyword: /\b(?:as|import|on)\b/,
        punctuation: /[{}[\]:;,]/
      };
    })(t);
  }
  return _f;
}
var Tf, I_;
function U7() {
  if (I_) return Tf;
  I_ = 1, Tf = e, e.displayName = "qore", e.aliases = [];
  function e(t) {
    t.languages.qore = t.languages.extend("clike", {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
        lookbehind: !0
      },
      // Overridden to allow unescaped multi-line strings
      string: {
        pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
      boolean: /\b(?:false|true)\b/i,
      function: /\$?\b(?!\d)\w+(?=\()/,
      number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
      operator: {
        pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
        lookbehind: !0
      },
      variable: /\$(?!\d)\w+\b/
    });
  }
  return Tf;
}
var Rf, k_;
function G7() {
  if (k_) return Rf;
  k_ = 1, Rf = e, e.displayName = "qsharp", e.aliases = ["qs"];
  function e(t) {
    (function(n) {
      function r(h, p) {
        return h.replace(/<<(\d+)>>/g, function(m, v) {
          return "(?:" + p[+v] + ")";
        });
      }
      function a(h, p, m) {
        return RegExp(r(h, p), "");
      }
      function i(h, p) {
        for (var m = 0; m < p; m++)
          h = h.replace(/<<self>>/g, function() {
            return "(?:" + h + ")";
          });
        return h.replace(/<<self>>/g, "[^\\s\\S]");
      }
      var o = {
        // keywords which represent a return or variable type
        type: "Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero",
        // all other keywords
        other: "Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within"
      };
      function s(h) {
        return "\\b(?:" + h.trim().replace(/ /g, "|") + ")\\b";
      }
      var l = RegExp(
        s(o.type + " " + o.other)
      ), c = /\b[A-Za-z_]\w*\b/.source, u = r(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [c]), d = {
        keyword: l,
        punctuation: /[<>()?,.:[\]]/
      }, f = /"(?:\\.|[^\\"])*"/.source;
      n.languages.qsharp = n.languages.extend("clike", {
        comment: /\/\/.*/,
        string: [
          {
            pattern: a(/(^|[^$\\])<<0>>/.source, [f]),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "class-name": [
          {
            // open Microsoft.Quantum.Canon;
            // open Microsoft.Quantum.Canon as CN;
            pattern: a(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
              u
            ]),
            lookbehind: !0,
            inside: d
          },
          {
            // namespace Quantum.App1;
            pattern: a(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [u]),
            lookbehind: !0,
            inside: d
          }
        ],
        keyword: l,
        number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
        operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
        punctuation: /::|[{}[\];(),.:]/
      }), n.languages.insertBefore("qsharp", "number", {
        range: {
          pattern: /\.\./,
          alias: "operator"
        }
      });
      var g = i(
        r(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [f]),
        2
      );
      n.languages.insertBefore("qsharp", "string", {
        "interpolation-string": {
          pattern: a(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [g]),
          greedy: !0,
          inside: {
            interpolation: {
              pattern: a(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
                g
              ]),
              lookbehind: !0,
              inside: {
                punctuation: /^\{|\}$/,
                expression: {
                  pattern: /[\s\S]+/,
                  alias: "language-qsharp",
                  inside: n.languages.qsharp
                }
              }
            },
            string: /[\s\S]+/
          }
        }
      });
    })(t), t.languages.qs = t.languages.qsharp;
  }
  return Rf;
}
var Af, O_;
function H7() {
  if (O_) return Af;
  O_ = 1, Af = e, e.displayName = "r", e.aliases = [];
  function e(t) {
    t.languages.r = {
      comment: /#.*/,
      string: {
        pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "percent-operator": {
        // Includes user-defined operators
        // and %%, %*%, %/%, %in%, %o%, %x%
        pattern: /%[^%\s]*%/,
        alias: "operator"
      },
      boolean: /\b(?:FALSE|TRUE)\b/,
      ellipsis: /\.\.(?:\.|\d+)/,
      number: [
        /\b(?:Inf|NaN)\b/,
        /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
      ],
      keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
      operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
      punctuation: /[(){}\[\],;]/
    };
  }
  return Af;
}
var xf, D_;
function z7() {
  if (D_) return xf;
  D_ = 1;
  var e = Cm();
  xf = t, t.displayName = "racket", t.aliases = ["rkt"];
  function t(n) {
    n.register(e), n.languages.racket = n.languages.extend("scheme", {
      "lambda-parameter": {
        // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
        // this will just prevent false positives of the `function` pattern
        pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
        lookbehind: !0
      }
    }), n.languages.insertBefore("racket", "string", {
      lang: {
        pattern: /^#lang.+/m,
        greedy: !0,
        alias: "keyword"
      }
    }), n.languages.rkt = n.languages.racket;
  }
  return xf;
}
var Cf, L_;
function W7() {
  if (L_) return Cf;
  L_ = 1, Cf = e, e.displayName = "reason", e.aliases = [];
  function e(t) {
    t.languages.reason = t.languages.extend("clike", {
      string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: !0
      },
      // 'class-name' must be matched *after* 'constructor' defined below
      "class-name": /\b[A-Z]\w*/,
      keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
      operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
    }), t.languages.insertBefore("reason", "class-name", {
      char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: !0
      },
      // Negative look-ahead prevents from matching things like String.capitalize
      constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
      label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
      }
    }), delete t.languages.reason.function;
  }
  return Cf;
}
var Nf, M_;
function q7() {
  if (M_) return Nf;
  M_ = 1, Nf = e, e.displayName = "regex", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
      }, a = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, i = {
        pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
        alias: "class-name"
      }, o = {
        pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
        alias: "class-name"
      }, s = "(?:[^\\\\-]|" + a.source + ")", l = RegExp(s + "-" + s), c = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: !0,
        alias: "variable"
      };
      n.languages.regex = {
        "char-class": {
          pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
          lookbehind: !0,
          inside: {
            "char-class-negation": {
              pattern: /(^\[)\^/,
              lookbehind: !0,
              alias: "operator"
            },
            "char-class-punctuation": {
              pattern: /^\[|\]$/,
              alias: "punctuation"
            },
            range: {
              pattern: l,
              inside: {
                escape: a,
                "range-punctuation": {
                  pattern: /-/,
                  alias: "operator"
                }
              }
            },
            "special-escape": r,
            "char-set": o,
            escape: a
          }
        },
        "special-escape": r,
        "char-set": i,
        backreference: [
          {
            // a backreference which is not an octal escape
            pattern: /\\(?![123][0-7]{2})[1-9]/,
            alias: "keyword"
          },
          {
            pattern: /\\k<[^<>']+>/,
            alias: "keyword",
            inside: {
              "group-name": c
            }
          }
        ],
        anchor: {
          pattern: /[$^]|\\[ABbGZz]/,
          alias: "function"
        },
        escape: a,
        group: [
          {
            // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
            // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
            // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
            pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
            alias: "punctuation",
            inside: {
              "group-name": c
            }
          },
          {
            pattern: /\)/,
            alias: "punctuation"
          }
        ],
        quantifier: {
          pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
          alias: "number"
        },
        alternation: {
          pattern: /\|/,
          alias: "keyword"
        }
      };
    })(t);
  }
  return Nf;
}
var If, P_;
function V7() {
  if (P_) return If;
  P_ = 1, If = e, e.displayName = "rego", e.aliases = [];
  function e(t) {
    t.languages.rego = {
      comment: /#.*/,
      property: {
        pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
      boolean: /\b(?:false|true)\b/,
      function: {
        pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
        inside: {
          namespace: /\b\w+\b(?=\s*\.)/,
          punctuation: /\./
        }
      },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
      punctuation: /[,;.\[\]{}()]/
    };
  }
  return If;
}
var kf, F_;
function j7() {
  if (F_) return kf;
  F_ = 1, kf = e, e.displayName = "renpy", e.aliases = ["rpy"];
  function e(t) {
    t.languages.renpy = {
      comment: {
        pattern: /(^|[^\\])#.+/,
        lookbehind: !0
      },
      string: {
        pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
        greedy: !0
      },
      function: /\b[a-z_]\w*(?=\()/i,
      property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
      tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
      keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
      boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
      number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
      operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.rpy = t.languages.renpy;
  }
  return kf;
}
var Of, $_;
function Y7() {
  if ($_) return Of;
  $_ = 1, Of = e, e.displayName = "rest", e.aliases = [];
  function e(t) {
    t.languages.rest = {
      table: [
        {
          pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
          lookbehind: !0,
          inside: {
            punctuation: /\||(?:\+[=-]+)+\+/
          }
        },
        {
          pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
          lookbehind: !0,
          inside: {
            punctuation: /[=-]+/
          }
        }
      ],
      // Directive-like patterns
      "substitution-def": {
        pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
        lookbehind: !0,
        inside: {
          substitution: {
            pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
            alias: "attr-value",
            inside: {
              punctuation: /^\||\|$/
            }
          },
          directive: {
            pattern: /( )(?! )[^:]+::/,
            lookbehind: !0,
            alias: "function",
            inside: {
              punctuation: /::$/
            }
          }
        }
      },
      "link-target": [
        {
          pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /^\[|\]$/
          }
        },
        {
          pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /^_|:$/
          }
        }
      ],
      directive: {
        pattern: /(^[\t ]*\.\. )[^:]+::/m,
        lookbehind: !0,
        alias: "function",
        inside: {
          punctuation: /::$/
        }
      },
      comment: {
        // The two alternatives try to prevent highlighting of blank comments
        pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
        lookbehind: !0
      },
      title: [
        // Overlined and underlined
        {
          pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
          inside: {
            punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
            important: /.+/
          }
        },
        // Underlined only
        {
          pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
          lookbehind: !0,
          inside: {
            punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
            important: /.+/
          }
        }
      ],
      hr: {
        pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
        lookbehind: !0,
        alias: "punctuation"
      },
      field: {
        pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      "command-line-option": {
        pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
        lookbehind: !0,
        alias: "symbol"
      },
      "literal-block": {
        pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
        inside: {
          "literal-block-punctuation": {
            pattern: /^::/,
            alias: "punctuation"
          }
        }
      },
      "quoted-literal-block": {
        pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
        inside: {
          "literal-block-punctuation": {
            pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
            alias: "punctuation"
          }
        }
      },
      "list-bullet": {
        pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
        lookbehind: !0,
        alias: "punctuation"
      },
      "doctest-block": {
        pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /^>>>/
        }
      },
      inline: [
        {
          pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
          lookbehind: !0,
          inside: {
            bold: {
              pattern: /(^\*\*).+(?=\*\*$)/,
              lookbehind: !0
            },
            italic: {
              pattern: /(^\*).+(?=\*$)/,
              lookbehind: !0
            },
            "inline-literal": {
              pattern: /(^``).+(?=``$)/,
              lookbehind: !0,
              alias: "symbol"
            },
            role: {
              pattern: /^:[^:]+:|:[^:]+:$/,
              alias: "function",
              inside: {
                punctuation: /^:|:$/
              }
            },
            "interpreted-text": {
              pattern: /(^`).+(?=`$)/,
              lookbehind: !0,
              alias: "attr-value"
            },
            substitution: {
              pattern: /(^\|).+(?=\|$)/,
              lookbehind: !0,
              alias: "attr-value"
            },
            punctuation: /\*\*?|``?|\|/
          }
        }
      ],
      link: [
        {
          pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
          alias: "string",
          inside: {
            punctuation: /^\[|\]_$/
          }
        },
        {
          pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
          alias: "string",
          inside: {
            punctuation: /^_?`|`$|`?_?_$/
          }
        }
      ],
      // Line block start,
      // quote attribution,
      // explicit markup start,
      // and anonymous hyperlink target shortcut (__)
      punctuation: {
        pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
        lookbehind: !0
      }
    };
  }
  return Of;
}
var Df, B_;
function K7() {
  if (B_) return Df;
  B_ = 1, Df = e, e.displayName = "rip", e.aliases = [];
  function e(t) {
    t.languages.rip = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      char: {
        pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      regex: {
        pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
      builtin: /@|\bSystem\b/,
      boolean: /\b(?:false|true)\b/,
      date: /\b\d{4}-\d{2}-\d{2}\b/,
      time: /\b\d{2}:\d{2}:\d{2}\b/,
      datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
      symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
      number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
      punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
      reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
    };
  }
  return Df;
}
var Lf, U_;
function X7() {
  if (U_) return Lf;
  U_ = 1, Lf = e, e.displayName = "roboconf", e.aliases = [];
  function e(t) {
    t.languages.roboconf = {
      comment: /#.*/,
      keyword: {
        pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
        lookbehind: !0
      },
      component: {
        pattern: /[\w-]+(?=[ \t]*\{)/,
        alias: "variable"
      },
      property: /[\w.-]+(?=[ \t]*:)/,
      value: {
        pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
        lookbehind: !0,
        alias: "attr-value"
      },
      optional: {
        pattern: /\(optional\)/,
        alias: "builtin"
      },
      wildcard: {
        pattern: /(\.)\*/,
        lookbehind: !0,
        alias: "operator"
      },
      punctuation: /[{},.;:=]/
    };
  }
  return Lf;
}
var Mf, G_;
function Z7() {
  if (G_) return Mf;
  G_ = 1, Mf = e, e.displayName = "robotframework", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /(^[ \t]*| {2}|\t)#.*/m,
        lookbehind: !0,
        greedy: !0
      }, a = {
        pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
        lookbehind: !0,
        inside: {
          punctuation: /^[$@&%]\{|\}$/
        }
      };
      function i(c, u) {
        var d = {};
        d["section-header"] = {
          pattern: /^ ?\*{3}.+?\*{3}/,
          alias: "keyword"
        };
        for (var f in u)
          d[f] = u[f];
        return d.tag = {
          pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
          lookbehind: !0,
          inside: {
            punctuation: /\[|\]/
          }
        }, d.variable = a, d.comment = r, {
          pattern: RegExp(
            /^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(
              /<name>/g,
              function() {
                return c;
              }
            ),
            "im"
          ),
          alias: "section",
          inside: d
        };
      }
      var o = {
        pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
        lookbehind: !0,
        alias: "string"
      }, s = {
        pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
        lookbehind: !0,
        alias: "function",
        inside: {
          variable: a
        }
      }, l = {
        pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
        lookbehind: !0,
        inside: {
          variable: a
        }
      };
      n.languages.robotframework = {
        settings: i("Settings", {
          documentation: {
            pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
            lookbehind: !0,
            alias: "string"
          },
          property: {
            pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: !0
          }
        }),
        variables: i("Variables"),
        "test-cases": i("Test Cases", {
          "test-name": s,
          documentation: o,
          property: l
        }),
        keywords: i("Keywords", {
          "keyword-name": s,
          documentation: o,
          property: l
        }),
        tasks: i("Tasks", {
          "task-name": s,
          documentation: o,
          property: l
        }),
        comment: r
      }, n.languages.robot = n.languages.robotframework;
    })(t);
  }
  return Mf;
}
var Pf, H_;
function Q7() {
  if (H_) return Pf;
  H_ = 1, Pf = e, e.displayName = "rust", e.aliases = [];
  function e(t) {
    (function(n) {
      for (var r = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, a = 0; a < 2; a++)
        r = r.replace(/<self>/g, function() {
          return r;
        });
      r = r.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
      }), n.languages.rust = {
        comment: [
          {
            pattern: RegExp(/(^|[^\\])/.source + r),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        string: {
          pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
          greedy: !0
        },
        char: {
          pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
          greedy: !0
        },
        attribute: {
          pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
          greedy: !0,
          alias: "attr-name",
          inside: {
            string: null
            // see below
          }
        },
        // Closure params should not be confused with bitwise OR |
        "closure-params": {
          pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            "closure-punctuation": {
              pattern: /^\||\|$/,
              alias: "punctuation"
            },
            rest: null
            // see below
          }
        },
        "lifetime-annotation": {
          pattern: /'\w+/,
          alias: "symbol"
        },
        "fragment-specifier": {
          pattern: /(\$\w+:)[a-z]+/,
          lookbehind: !0,
          alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
          pattern: /(\bfn\s+)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        "type-definition": {
          pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
          lookbehind: !0,
          alias: "class-name"
        },
        "module-declaration": [
          {
            pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
            lookbehind: !0,
            alias: "namespace"
          },
          {
            pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
            lookbehind: !0,
            alias: "namespace",
            inside: {
              punctuation: /::/
            }
          }
        ],
        keyword: [
          // https://github.com/rust-lang/reference/blob/master/src/keywords.md
          /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
          // primitives and str
          // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
          /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
        // and Rust's naming conventions recommend snake_case anyway.
        // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
          pattern: /\b\w+!/,
          alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
          pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
          inside: {
            punctuation: /::/
          }
        },
        // Hex, oct, bin, dec numbers with visual separators and type suffix
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
      }, n.languages.rust["closure-params"].inside.rest = n.languages.rust, n.languages.rust.attribute.inside.string = n.languages.rust.string;
    })(t);
  }
  return Pf;
}
var Ff, z_;
function J7() {
  if (z_) return Ff;
  z_ = 1, Ff = e, e.displayName = "sas", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source, a = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i, i = {
        pattern: RegExp(r + "[bx]"),
        alias: "number"
      }, o = {
        pattern: /&[a-z_]\w*/i
      }, s = {
        pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, l = {
        pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
        alias: "keyword",
        lookbehind: !0
      }, c = [
        /\/\*[\s\S]*?\*\//,
        {
          pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
          lookbehind: !0
        }
      ], u = {
        pattern: RegExp(r),
        greedy: !0
      }, d = /[$%@.(){}\[\];,\\]/, f = {
        pattern: /%?\b\w+(?=\()/,
        alias: "keyword"
      }, g = {
        function: f,
        "arg-value": {
          pattern: /(=\s*)[A-Z\.]+/i,
          lookbehind: !0
        },
        operator: /=/,
        "macro-variable": o,
        arg: {
          pattern: /[A-Z]+/i,
          alias: "keyword"
        },
        number: a,
        "numeric-constant": i,
        punctuation: d,
        string: u
      }, h = {
        pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
        inside: {
          keyword: /^(?:format|put)(?==)/i,
          equals: /=/,
          format: {
            pattern: /(?:\w|\$\d)+\.\d?/,
            alias: "number"
          }
        }
      }, p = {
        pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
        inside: {
          keyword: /^(?:format|put)/i,
          format: {
            pattern: /[\w$]+\.\d?/,
            alias: "number"
          }
        }
      }, m = {
        pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, v = {
        pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, y = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source, E = {
        pattern: RegExp(
          /(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(
            /<act>/g,
            function() {
              return y;
            }
          ),
          "i"
        ),
        lookbehind: !0,
        inside: {
          keyword: RegExp(
            /(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
              return y;
            }),
            "i"
          ),
          action: {
            pattern: /(?:action)/i,
            alias: "keyword"
          },
          comment: c,
          function: f,
          "arg-value": g["arg-value"],
          operator: g.operator,
          argument: g.arg,
          number: a,
          "numeric-constant": i,
          punctuation: d,
          string: u
        }
      }, S = {
        pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
        lookbehind: !0
      };
      n.languages.sas = {
        datalines: {
          pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
          lookbehind: !0,
          alias: "string",
          inside: {
            keyword: {
              pattern: /^(?:cards|(?:data)?lines)/i
            },
            punctuation: /;/
          }
        },
        "proc-sql": {
          pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            sql: {
              pattern: RegExp(
                /^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(
                  /<str>/g,
                  function() {
                    return r;
                  }
                ),
                "im"
              ),
              alias: "language-sql",
              inside: n.languages.sql
            },
            "global-statements": m,
            "sql-statements": {
              pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
              lookbehind: !0,
              alias: "keyword"
            },
            number: a,
            "numeric-constant": i,
            punctuation: d,
            string: u
          }
        },
        "proc-groovy": {
          pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: c,
            groovy: {
              pattern: RegExp(
                /(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(
                  /<str>/g,
                  function() {
                    return r;
                  }
                ),
                "im"
              ),
              lookbehind: !0,
              alias: "language-groovy",
              inside: n.languages.groovy
            },
            keyword: S,
            "submit-statement": v,
            "global-statements": m,
            number: a,
            "numeric-constant": i,
            punctuation: d,
            string: u
          }
        },
        "proc-lua": {
          pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: c,
            lua: {
              pattern: RegExp(
                /(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(
                  /<str>/g,
                  function() {
                    return r;
                  }
                ),
                "im"
              ),
              lookbehind: !0,
              alias: "language-lua",
              inside: n.languages.lua
            },
            keyword: S,
            "submit-statement": v,
            "global-statements": m,
            number: a,
            "numeric-constant": i,
            punctuation: d,
            string: u
          }
        },
        "proc-cas": {
          pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: c,
            "statement-var": {
              pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
              lookbehind: !0,
              inside: {
                statement: {
                  pattern: /^saveresult\s+\S+/i,
                  inside: {
                    keyword: /^(?:saveresult)/i
                  }
                },
                rest: g
              }
            },
            "cas-actions": E,
            statement: {
              pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
              lookbehind: !0,
              inside: g
            },
            step: l,
            keyword: S,
            function: f,
            format: h,
            altformat: p,
            "global-statements": m,
            number: a,
            "numeric-constant": i,
            punctuation: d,
            string: u
          }
        },
        "proc-args": {
          pattern: RegExp(
            /(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(
              /<str>/g,
              function() {
                return r;
              }
            ),
            "im"
          ),
          lookbehind: !0,
          inside: g
        },
        /*Special keywords within macros*/
        "macro-keyword": s,
        "macro-variable": o,
        "macro-string-functions": {
          pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
          lookbehind: !0,
          inside: {
            function: {
              pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
              alias: "keyword"
            },
            "macro-keyword": s,
            "macro-variable": o,
            "escaped-char": {
              pattern: /%['"()<>=¬^~;,#]/
            },
            punctuation: d
          }
        },
        "macro-declaration": {
          pattern: /^%macro[^;]+(?=;)/im,
          inside: {
            keyword: /%macro/i
          }
        },
        "macro-end": {
          pattern: /^%mend[^;]+(?=;)/im,
          inside: {
            keyword: /%mend/i
          }
        },
        /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */
        macro: {
          pattern: /%_\w+(?=\()/,
          alias: "keyword"
        },
        input: {
          pattern: /\binput\s[-\w\s/*.$&]+;/i,
          inside: {
            input: {
              alias: "keyword",
              pattern: /^input/i
            },
            comment: c,
            number: a,
            "numeric-constant": i
          }
        },
        "options-args": {
          pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
          lookbehind: !0,
          inside: g
        },
        "cas-actions": E,
        comment: c,
        function: f,
        format: h,
        altformat: p,
        "numeric-constant": i,
        datetime: {
          // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
          pattern: RegExp(r + "(?:dt?|t)"),
          alias: "number"
        },
        string: u,
        step: l,
        keyword: S,
        // In SAS Studio syntax highlighting, these operators are styled like keywords
        "operator-keyword": {
          pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
          alias: "operator"
        },
        // Decimal (1.2e23), hexadecimal (0c1x)
        number: a,
        operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
        punctuation: d
      };
    })(t);
  }
  return Ff;
}
var $f, W_;
function eK() {
  if (W_) return $f;
  W_ = 1, $f = e, e.displayName = "sass", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.sass = n.languages.extend("css", {
        // Sass comments don't need to be closed, only indented
        comment: {
          pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
          lookbehind: !0,
          greedy: !0
        }
      }), n.languages.insertBefore("sass", "atrule", {
        // We want to consume the whole line
        "atrule-line": {
          // Includes support for = and + shortcuts
          pattern: /^(?:[ \t]*)[@+=].+/m,
          greedy: !0,
          inside: {
            atrule: /(?:@[\w-]+|[+=])/
          }
        }
      }), delete n.languages.sass.atrule;
      var r = /\$[-\w]+|#\{\$[-\w]+\}/, a = [
        /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
        {
          pattern: /(\s)-(?=\s)/,
          lookbehind: !0
        }
      ];
      n.languages.insertBefore("sass", "property", {
        // We want to consume the whole line
        "variable-line": {
          pattern: /^[ \t]*\$.+/m,
          greedy: !0,
          inside: {
            punctuation: /:/,
            variable: r,
            operator: a
          }
        },
        // We want to consume the whole line
        "property-line": {
          pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
          greedy: !0,
          inside: {
            property: [
              /[^:\s]+(?=\s*:)/,
              {
                pattern: /(:)[^:\s]+/,
                lookbehind: !0
              }
            ],
            punctuation: /:/,
            variable: r,
            operator: a,
            important: n.languages.sass.important
          }
        }
      }), delete n.languages.sass.property, delete n.languages.sass.important, n.languages.insertBefore("sass", "punctuation", {
        selector: {
          pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
          lookbehind: !0,
          greedy: !0
        }
      });
    })(t);
  }
  return $f;
}
var Bf, q_;
function tK() {
  if (q_) return Bf;
  q_ = 1;
  var e = Rm();
  Bf = t, t.displayName = "scala", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.scala = n.languages.extend("java", {
      "triple-quoted-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: /<-|=>|\b(?:abstract|case|catch|class|def|do|else|extends|final|finally|for|forSome|if|implicit|import|lazy|match|new|null|object|override|package|private|protected|return|sealed|self|super|this|throw|trait|try|type|val|var|while|with|yield)\b/,
      number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
      builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
      symbol: /'[^\d\s\\]\w*/
    }), n.languages.insertBefore("scala", "triple-quoted-string", {
      "string-interpolation": {
        pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
        greedy: !0,
        inside: {
          id: {
            pattern: /^\w+/,
            greedy: !0,
            alias: "function"
          },
          escape: {
            pattern: /\\\$"|\$[$"]/,
            greedy: !0,
            alias: "symbol"
          },
          interpolation: {
            pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
            greedy: !0,
            inside: {
              punctuation: /^\$\{?|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: n.languages.scala
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    }), delete n.languages.scala["class-name"], delete n.languages.scala.function;
  }
  return Bf;
}
var Uf, V_;
function nK() {
  if (V_) return Uf;
  V_ = 1, Uf = e, e.displayName = "scss", e.aliases = [];
  function e(t) {
    t.languages.scss = t.languages.extend("css", {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0
      },
      atrule: {
        pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
        inside: {
          rule: /@[\w-]+/
          // See rest below
        }
      },
      // url, compassified
      url: /(?:[-a-z]+-)?url(?=\()/i,
      // CSS selector regex is not appropriate for Sass
      // since there can be lot more things (var, @ directive, nesting..)
      // a selector must start at the end of a property or after a brace (end of other rules or nesting)
      // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
      // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
      // can "pass" as a selector- e.g: proper#{$erty})
      // this one was hard to do, so please be careful if you edit this one :)
      selector: {
        // Initial look-ahead is used to prevent matching of blank selectors
        pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
        inside: {
          parent: {
            pattern: /&/,
            alias: "important"
          },
          placeholder: /%[-\w]+/,
          variable: /\$[-\w]+|#\{\$[-\w]+\}/
        }
      },
      property: {
        pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
        inside: {
          variable: /\$[-\w]+|#\{\$[-\w]+\}/
        }
      }
    }), t.languages.insertBefore("scss", "atrule", {
      keyword: [
        /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
        {
          pattern: /( )(?:from|through)(?= )/,
          lookbehind: !0
        }
      ]
    }), t.languages.insertBefore("scss", "important", {
      // var and interpolated vars
      variable: /\$[-\w]+|#\{\$[-\w]+\}/
    }), t.languages.insertBefore("scss", "function", {
      "module-modifier": {
        pattern: /\b(?:as|hide|show|with)\b/i,
        alias: "keyword"
      },
      placeholder: {
        pattern: /%[-\w]+/,
        alias: "selector"
      },
      statement: {
        pattern: /\B!(?:default|optional)\b/i,
        alias: "keyword"
      },
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      },
      operator: {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
        lookbehind: !0
      }
    }), t.languages.scss.atrule.inside.rest = t.languages.scss;
  }
  return Uf;
}
var Gf, j_;
function rK() {
  if (j_) return Gf;
  j_ = 1;
  var e = Ik();
  Gf = t, t.displayName = "shellSession", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = [
        // normal string
        /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
        /'[^']*'/.source,
        /\$'(?:[^'\\]|\\[\s\S])*'/.source,
        // here doc
        // 2 capturing groups
        /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
      ].join("|");
      r.languages["shell-session"] = {
        command: {
          pattern: RegExp(
            // user info
            /^/.source + "(?:" + // <user> ":" ( <path> )?
            (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + "|" + // <path>
            // Since the path pattern is quite general, we will require it to start with a special character to
            // prevent false positives.
            /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ")?" + // shell symbol
            /[$#%](?=\s)/.source + // bash command
            /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(
              /<<str>>/g,
              function() {
                return a;
              }
            ),
            "m"
          ),
          greedy: !0,
          inside: {
            info: {
              // foo@bar:~/files$ exit
              // foo@bar$ exit
              // ~/files$ exit
              pattern: /^[^#$%]+/,
              alias: "punctuation",
              inside: {
                user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
                punctuation: /:/,
                path: /[\s\S]+/
              }
            },
            bash: {
              pattern: /(^[$#%]\s*)\S[\s\S]*/,
              lookbehind: !0,
              alias: "language-bash",
              inside: r.languages.bash
            },
            "shell-symbol": {
              pattern: /^[$#%]/,
              alias: "important"
            }
          }
        },
        output: /.(?:.*(?:[\r\n]|.$))*/
      }, r.languages["sh-session"] = r.languages.shellsession = r.languages["shell-session"];
    }(n);
  }
  return Gf;
}
var Hf, Y_;
function aK() {
  if (Y_) return Hf;
  Y_ = 1, Hf = e, e.displayName = "smali", e.aliases = [];
  function e(t) {
    t.languages.smali = {
      comment: /#.*/,
      string: {
        pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
        greedy: !0
      },
      "class-name": {
        pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
        lookbehind: !0,
        inside: {
          "class-name": {
            pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
            lookbehind: !0
          },
          namespace: {
            pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
            lookbehind: !0,
            inside: {
              punctuation: /\//
            }
          },
          builtin: /^L/
        }
      },
      builtin: [
        {
          // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
          pattern: /([();\[])[BCDFIJSVZ]+/,
          lookbehind: !0
        },
        {
          // e.g. .field mWifiOnUid:I
          pattern: /([\w$>]:)[BCDFIJSVZ]/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /(\.end\s+)[\w-]+/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
          lookbehind: !0
        }
      ],
      function: {
        pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
        lookbehind: !0
      },
      field: {
        pattern: /[\w$]+(?=:)/,
        alias: "variable"
      },
      register: {
        pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
        lookbehind: !0,
        alias: "variable"
      },
      boolean: {
        pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
        lookbehind: !0
      },
      number: {
        pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
        lookbehind: !0
      },
      label: {
        pattern: /(:)\w+/,
        lookbehind: !0,
        alias: "property"
      },
      operator: /->|\.\.|[\[=]/,
      punctuation: /[{}(),;:]/
    };
  }
  return Hf;
}
var zf, K_;
function iK() {
  if (K_) return zf;
  K_ = 1, zf = e, e.displayName = "smalltalk", e.aliases = [];
  function e(t) {
    t.languages.smalltalk = {
      comment: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      char: {
        pattern: /\$./,
        greedy: !0
      },
      string: {
        pattern: /'(?:''|[^'])*'/,
        greedy: !0
      },
      symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
      "block-arguments": {
        pattern: /(\[\s*):[^\[|]*\|/,
        lookbehind: !0,
        inside: {
          variable: /:[\da-z]+/i,
          punctuation: /\|/
        }
      },
      "temporary-variables": {
        pattern: /\|[^|]+\|/,
        inside: {
          variable: /[\da-z]+/i,
          punctuation: /\|/
        }
      },
      keyword: /\b(?:new|nil|self|super)\b/,
      boolean: /\b(?:false|true)\b/,
      number: [
        /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
        /\b\d+(?:\.\d+)?(?:e-?\d+)?/
      ],
      operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
      punctuation: /[.;:?\[\](){}]/
    };
  }
  return zf;
}
var Wf, X_;
function oK() {
  if (X_) return Wf;
  X_ = 1;
  var e = yt();
  Wf = t, t.displayName = "smarty", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.smarty = {
        comment: {
          pattern: /^\{\*[\s\S]*?\*\}/,
          greedy: !0
        },
        "embedded-php": {
          pattern: /^\{php\}[\s\S]*?\{\/php\}/,
          greedy: !0,
          inside: {
            smarty: {
              pattern: /^\{php\}|\{\/php\}$/,
              inside: null
              // see below
            },
            php: {
              pattern: /[\s\S]+/,
              alias: "language-php",
              inside: r.languages.php
            }
          }
        },
        string: [
          {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: !0,
            inside: {
              interpolation: {
                pattern: /\{[^{}]*\}|`[^`]*`/,
                inside: {
                  "interpolation-punctuation": {
                    pattern: /^[{`]|[`}]$/,
                    alias: "punctuation"
                  },
                  expression: {
                    pattern: /[\s\S]+/,
                    inside: null
                    // see below
                  }
                }
              },
              variable: /\$\w+/
            }
          },
          {
            pattern: /'(?:\\.|[^'\\\r\n])*'/,
            greedy: !0
          }
        ],
        keyword: {
          pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
          lookbehind: !0,
          greedy: !0
        },
        delimiter: {
          pattern: /^\{\/?|\}$/,
          greedy: !0,
          alias: "punctuation"
        },
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        variable: [
          /\$(?!\d)\w+/,
          /#(?!\d)\w+#/,
          {
            pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
            lookbehind: !0
          },
          {
            pattern: /(\[)(?!\d)\w+(?=\])/,
            lookbehind: !0
          }
        ],
        function: {
          pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
          lookbehind: !0
        },
        "attr-name": /\b[a-z_]\w*(?=\s*=)/i,
        boolean: /\b(?:false|no|off|on|true|yes)\b/,
        punctuation: /[\[\](){}.,:`]|->/,
        operator: [
          /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
          /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
          /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
        ]
      }, r.languages.smarty["embedded-php"].inside.smarty.inside = r.languages.smarty, r.languages.smarty.string[0].inside.interpolation.inside.expression.inside = r.languages.smarty;
      var a = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/, i = RegExp(
        // comments
        /\{\*[\s\S]*?\*\}/.source + "|" + // php tags
        /\{php\}[\s\S]*?\{\/php\}/.source + "|" + // smarty blocks
        /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(
          /<str>/g,
          function() {
            return a.source;
          }
        ),
        "g"
      );
      r.hooks.add("before-tokenize", function(o) {
        var s = "{literal}", l = "{/literal}", c = !1;
        r.languages["markup-templating"].buildPlaceholders(
          o,
          "smarty",
          i,
          function(u) {
            return u === l && (c = !1), c ? !1 : (u === s && (c = !0), !0);
          }
        );
      }), r.hooks.add("after-tokenize", function(o) {
        r.languages["markup-templating"].tokenizePlaceholders(o, "smarty");
      });
    }(n);
  }
  return Wf;
}
var qf, Z_;
function sK() {
  if (Z_) return qf;
  Z_ = 1, qf = e, e.displayName = "sml", e.aliases = ["smlnj"];
  function e(t) {
    (function(n) {
      var r = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
      n.languages.sml = {
        // allow one level of nesting
        comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
        string: {
          pattern: /#?"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        "class-name": [
          {
            // This is only an approximation since the real grammar is context-free
            //
            // Why the main loop so complex?
            // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
            // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
            // followed by a long identifier.
            pattern: RegExp(
              /((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
                return /\s*(?:[*,]|->)/.source;
              }).replace(/<TERMINAL>/g, function() {
                return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
              }).replace(/<LONG-ID>/g, function() {
                return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
              }).replace(/<KEYWORD>/g, function() {
                return r.source;
              }),
              "i"
            ),
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          {
            pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
            lookbehind: !0
          }
        ],
        function: {
          pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
          lookbehind: !0
        },
        keyword: r,
        variable: {
          pattern: /(^|[^\w'])'[\w']*/,
          lookbehind: !0
        },
        number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
        word: {
          pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
          alias: "constant"
        },
        boolean: /\b(?:false|true)\b/i,
        operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
        punctuation: /[(){}\[\].:,;]/
      }, n.languages.sml["class-name"][0].inside = n.languages.sml, n.languages.smlnj = n.languages.sml;
    })(t);
  }
  return qf;
}
var Vf, Q_;
function lK() {
  if (Q_) return Vf;
  Q_ = 1, Vf = e, e.displayName = "solidity", e.aliases = ["sol"];
  function e(t) {
    t.languages.solidity = t.languages.extend("clike", {
      "class-name": {
        pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
        lookbehind: !0
      },
      keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
      operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
    }), t.languages.insertBefore("solidity", "keyword", {
      builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
    }), t.languages.insertBefore("solidity", "number", {
      version: {
        pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
        lookbehind: !0,
        alias: "number"
      }
    }), t.languages.sol = t.languages.solidity;
  }
  return Vf;
}
var jf, J_;
function cK() {
  if (J_) return jf;
  J_ = 1, jf = e, e.displayName = "solutionFile", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
        pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
        alias: "constant",
        inside: {
          punctuation: /[{}]/
        }
      };
      n.languages["solution-file"] = {
        comment: {
          pattern: /#.*/,
          greedy: !0
        },
        string: {
          pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
          greedy: !0,
          inside: {
            guid: r
          }
        },
        object: {
          // Foo
          //   Bar("abs") = 9
          //   EndBar
          //   Prop = TRUE
          // EndFoo
          pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
          lookbehind: !0,
          greedy: !0,
          alias: "keyword"
        },
        property: {
          pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
          lookbehind: !0,
          inside: {
            guid: r
          }
        },
        guid: r,
        number: /\b\d+(?:\.\d+)*\b/,
        boolean: /\b(?:FALSE|TRUE)\b/,
        operator: /=/,
        punctuation: /[(),]/
      }, n.languages.sln = n.languages["solution-file"];
    })(t);
  }
  return jf;
}
var Yf, eT;
function uK() {
  if (eT) return Yf;
  eT = 1;
  var e = yt();
  Yf = t, t.displayName = "soy", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, i = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
      r.languages.soy = {
        comment: [
          /\/\*[\s\S]*?\*\//,
          {
            pattern: /(\s)\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        "command-arg": {
          pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /\./
          }
        },
        parameter: {
          pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
          lookbehind: !0,
          alias: "variable"
        },
        keyword: [
          {
            pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
            lookbehind: !0
          },
          /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
        ],
        delimiter: {
          pattern: /^\{+\/?|\/?\}+$/,
          alias: "punctuation"
        },
        property: /\w+(?==)/,
        variable: {
          pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
          inside: {
            string: {
              pattern: a,
              greedy: !0
            },
            number: i,
            punctuation: /[\[\].?]/
          }
        },
        string: {
          pattern: a,
          greedy: !0
        },
        function: [
          /\w+(?=\()/,
          {
            pattern: /(\|[^\S\r\n]*)\w+/,
            lookbehind: !0
          }
        ],
        boolean: /\b(?:false|true)\b/,
        number: i,
        operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
        punctuation: /[{}()\[\]|.,:]/
      }, r.hooks.add("before-tokenize", function(o) {
        var s = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g, l = "{literal}", c = "{/literal}", u = !1;
        r.languages["markup-templating"].buildPlaceholders(
          o,
          "soy",
          s,
          function(d) {
            return d === c && (u = !1), u ? !1 : (d === l && (u = !0), !0);
          }
        );
      }), r.hooks.add("after-tokenize", function(o) {
        r.languages["markup-templating"].tokenizePlaceholders(o, "soy");
      });
    }(n);
  }
  return Yf;
}
var Kf, tT;
function Lk() {
  if (tT) return Kf;
  tT = 1, Kf = e, e.displayName = "turtle", e.aliases = [];
  function e(t) {
    t.languages.turtle = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      "multiline-string": {
        pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
        greedy: !0,
        alias: "string",
        inside: {
          comment: /#.*/
        }
      },
      string: {
        pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
        greedy: !0
      },
      url: {
        pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
        greedy: !0,
        inside: {
          punctuation: /[<>]/
        }
      },
      function: {
        pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
        inside: {
          "local-name": {
            pattern: /([^:]*:)[\s\S]+/,
            lookbehind: !0
          },
          prefix: {
            pattern: /[\s\S]+/,
            inside: {
              punctuation: /:/
            }
          }
        }
      },
      number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
      punctuation: /[{}.,;()[\]]|\^\^/,
      boolean: /\b(?:false|true)\b/,
      keyword: [/(?:\ba|@prefix|@base)\b|=/, /\b(?:base|graph|prefix)\b/i],
      tag: {
        pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
        inside: {
          punctuation: /@/
        }
      }
    }, t.languages.trig = t.languages.turtle;
  }
  return Kf;
}
var Xf, nT;
function dK() {
  if (nT) return Xf;
  nT = 1;
  var e = Lk();
  Xf = t, t.displayName = "sparql", t.aliases = ["rq"];
  function t(n) {
    n.register(e), n.languages.sparql = n.languages.extend("turtle", {
      boolean: /\b(?:false|true)\b/i,
      variable: {
        pattern: /[?$]\w+/,
        greedy: !0
      }
    }), n.languages.insertBefore("sparql", "punctuation", {
      keyword: [
        /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
        /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
        /\b(?:BASE|GRAPH|PREFIX)\b/i
      ]
    }), n.languages.rq = n.languages.sparql;
  }
  return Xf;
}
var Zf, rT;
function fK() {
  if (rT) return Zf;
  rT = 1, Zf = e, e.displayName = "splunkSpl", e.aliases = [];
  function e(t) {
    t.languages["splunk-spl"] = {
      comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
      string: {
        pattern: /"(?:\\.|[^\\"])*"/,
        greedy: !0
      },
      // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
      keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
      "operator-word": {
        pattern: /\b(?:and|as|by|not|or|xor)\b/i,
        alias: "operator"
      },
      function: /\b\w+(?=\s*\()/,
      property: /\b\w+(?=\s*=(?!=))/,
      date: {
        // MM/DD/YYYY(:HH:MM:SS)?
        pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
        alias: "number"
      },
      number: /\b\d+(?:\.\d+)?\b/,
      boolean: /\b(?:f|false|t|true)\b/i,
      operator: /[<>=]=?|[-+*/%|]/,
      punctuation: /[()[\],]/
    };
  }
  return Zf;
}
var Qf, aT;
function pK() {
  if (aT) return Qf;
  aT = 1, Qf = e, e.displayName = "sqf", e.aliases = [];
  function e(t) {
    t.languages.sqf = t.languages.extend("clike", {
      string: {
        pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
        greedy: !0
      },
      keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
      number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
      operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
      "magic-variable": {
        pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
        alias: "keyword"
      },
      constant: /\bDIK(?:_[a-z\d]+)+\b/i
    }), t.languages.insertBefore("sqf", "string", {
      macro: {
        pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: !0,
        greedy: !0,
        alias: "property",
        inside: {
          directive: {
            pattern: /#[a-z]+\b/i,
            alias: "keyword"
          },
          comment: t.languages.sqf.comment
        }
      }
    }), delete t.languages.sqf["class-name"];
  }
  return Qf;
}
var Jf, iT;
function gK() {
  if (iT) return Jf;
  iT = 1, Jf = e, e.displayName = "squirrel", e.aliases = [];
  function e(t) {
    t.languages.squirrel = t.languages.extend("clike", {
      comment: [
        t.languages.clike.comment[0],
        {
          pattern: /(^|[^\\:])(?:\/\/|#).*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      },
      keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
      number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
      operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
      punctuation: /[(){}\[\],;.]/
    }), t.languages.insertBefore("squirrel", "string", {
      char: {
        pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
        lookbehind: !0,
        greedy: !0
      }
    }), t.languages.insertBefore("squirrel", "operator", {
      "attribute-punctuation": {
        pattern: /<\/|\/>/,
        alias: "important"
      },
      lambda: {
        pattern: /@(?=\()/,
        alias: "operator"
      }
    });
  }
  return Jf;
}
var ep, oT;
function hK() {
  if (oT) return ep;
  oT = 1, ep = e, e.displayName = "stan", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
      n.languages.stan = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
        string: {
          // String literals can contain spaces and any printable ASCII characters except for " and \
          // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
          pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
          greedy: !0
        },
        directive: {
          pattern: /^([ \t]*)#include\b.*/m,
          lookbehind: !0,
          alias: "property"
        },
        "function-arg": {
          pattern: RegExp(
            "(" + r.source + /\s*\(\s*/.source + ")" + /[a-zA-Z]\w*/.source
          ),
          lookbehind: !0,
          alias: "function"
        },
        constraint: {
          pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
          lookbehind: !0,
          inside: {
            expression: {
              pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            property: /\b[a-z]\w*(?=\s*=)/i,
            operator: /=/,
            punctuation: /^<|>$|,/
          }
        },
        keyword: [
          {
            pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
            alias: "program-block"
          },
          /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
          // these are functions that are known to take another function as their first argument.
          r
        ],
        function: /\b[a-z]\w*(?=\s*\()/i,
        number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        boolean: /\b(?:false|true)\b/,
        operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
        punctuation: /[()\[\]{},;]/
      }, n.languages.stan.constraint.inside.expression.inside = n.languages.stan;
    })(t);
  }
  return ep;
}
var tp, sT;
function mK() {
  if (sT) return tp;
  sT = 1, tp = e, e.displayName = "stylus", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /(\b\d+)(?:%|[a-z]+)/,
        lookbehind: !0
      }, a = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: !0
      }, i = {
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
          lookbehind: !0
        },
        url: {
          pattern: /\burl\((["']?).*?\1\)/i,
          greedy: !0
        },
        string: {
          pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
          greedy: !0
        },
        interpolation: null,
        // See below
        func: null,
        // See below
        important: /\B!(?:important|optional)\b/i,
        keyword: {
          pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
          lookbehind: !0
        },
        hexcode: /#[\da-f]{3,6}/i,
        color: [
          /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
          {
            pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
            inside: {
              unit: r,
              number: a,
              function: /[\w-]+(?=\()/,
              punctuation: /[(),]/
            }
          }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: r,
        boolean: /\b(?:false|true)\b/,
        operator: [
          // We want non-word chars around "-" because it is
          // accepted in property names.
          /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
        ],
        number: a,
        punctuation: /[{}()\[\];:,]/
      };
      i.interpolation = {
        pattern: /\{[^\r\n}:]+\}/,
        alias: "variable",
        inside: {
          delimiter: {
            pattern: /^\{|\}$/,
            alias: "punctuation"
          },
          rest: i
        }
      }, i.func = {
        pattern: /[\w-]+\([^)]*\).*/,
        inside: {
          function: /^[^(]+/,
          rest: i
        }
      }, n.languages.stylus = {
        "atrule-declaration": {
          pattern: /(^[ \t]*)@.+/m,
          lookbehind: !0,
          inside: {
            atrule: /^@[\w-]+/,
            rest: i
          }
        },
        "variable-declaration": {
          pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
          lookbehind: !0,
          inside: {
            variable: /^\S+/,
            rest: i
          }
        },
        statement: {
          pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
          lookbehind: !0,
          inside: {
            keyword: /^\S+/,
            rest: i
          }
        },
        // A property/value pair cannot end with a comma or a brace
        // It cannot have indented content unless it ended with a semicolon
        "property-declaration": {
          pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
          lookbehind: !0,
          inside: {
            property: {
              pattern: /^[^\s:]+/,
              inside: {
                interpolation: i.interpolation
              }
            },
            rest: i
          }
        },
        // A selector can contain parentheses only as part of a pseudo-element
        // It can span multiple lines.
        // It must end with a comma or an accolade or have indented content.
        selector: {
          pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
          lookbehind: !0,
          inside: {
            interpolation: i.interpolation,
            comment: i.comment,
            punctuation: /[{},]/
          }
        },
        func: i.func,
        string: i.string,
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
          lookbehind: !0,
          greedy: !0
        },
        interpolation: i.interpolation,
        punctuation: /[{}()\[\];:.]/
      };
    })(t);
  }
  return tp;
}
var np, lT;
function bK() {
  if (lT) return np;
  lT = 1, np = e, e.displayName = "swift", e.aliases = [];
  function e(t) {
    t.languages.swift = {
      comment: {
        // Nested comments are supported up to 2 levels
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: !0,
        greedy: !0
      },
      "string-literal": [
        // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
        {
          pattern: RegExp(
            /(^|[^"#])/.source + "(?:" + // single-line string
            /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + // multi-line string
            /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            "interpolation-punctuation": {
              pattern: /^\)|\\\($/,
              alias: "punctuation"
            },
            punctuation: /\\(?=[\r\n])/,
            string: /[\s\S]+/
          }
        },
        {
          pattern: RegExp(
            /(^|[^"#])(#+)/.source + "(?:" + // single-line string
            /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + // multi-line string
            /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            "interpolation-punctuation": {
              pattern: /^\)|\\#+\($/,
              alias: "punctuation"
            },
            string: /[\s\S]+/
          }
        }
      ],
      directive: {
        // directives with conditions
        pattern: RegExp(
          /#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + // This regex is a little complex. It's equivalent to this:
          //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
          // where <round> is a general parentheses expression.
          /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"
        ),
        alias: "property",
        inside: {
          "directive-name": /^#\w+/,
          boolean: /\b(?:false|true)\b/,
          number: /\b\d+(?:\.\d+)*\b/,
          operator: /!|&&|\|\||[<>]=?/,
          punctuation: /[(),]/
        }
      },
      literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
      },
      "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
      },
      attribute: {
        pattern: /@\w+/,
        alias: "atrule"
      },
      "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      label: {
        // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: !0,
        alias: "important"
      },
      keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
      boolean: /\b(?:false|true)\b/,
      nil: {
        pattern: /\bnil\b/,
        alias: "constant"
      },
      "short-argument": /\$\d+\b/,
      omit: {
        pattern: /\b_\b/,
        alias: "keyword"
      },
      number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
      // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
      "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
      // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
      // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
      // This regex only supports ASCII operators.
      operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
      punctuation: /[{}[\]();,.:\\]/
    }, t.languages.swift["string-literal"].forEach(function(n) {
      n.inside.interpolation.inside = t.languages.swift;
    });
  }
  return np;
}
var rp, cT;
function vK() {
  if (cT) return rp;
  cT = 1, rp = e, e.displayName = "systemd", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /^[;#].*/m,
        greedy: !0
      }, a = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
      n.languages.systemd = {
        comment: r,
        section: {
          pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
          greedy: !0,
          inside: {
            punctuation: /^\[|\]$/,
            "section-name": {
              pattern: /[\s\S]+/,
              alias: "selector"
            }
          }
        },
        key: {
          pattern: /^[^\s=]+(?=[ \t]*=)/m,
          greedy: !0,
          alias: "attr-name"
        },
        value: {
          // This pattern is quite complex because of two properties:
          //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
          //     the lookbehind. You will see this in the main loop where spaces are handled separately.
          //  2) Line continuations.
          //     After line continuations, empty lines and comments are ignored so we have to consume them.
          pattern: RegExp(
            /(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
            "(?:" + a + `|(?=[^"\r
]))(?:` + (/[^\s\\]/.source + // handle spaces separately because of quotes
            '|[ 	]+(?:(?![ 	"])|' + a + ")|" + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ")*"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "attr-value",
          inside: {
            comment: r,
            quoted: {
              pattern: RegExp(/(^|\s)/.source + a),
              lookbehind: !0,
              greedy: !0
            },
            punctuation: /\\$/m,
            boolean: {
              pattern: /^(?:false|no|off|on|true|yes)$/,
              greedy: !0
            }
          }
        },
        punctuation: /=/
      };
    })(t);
  }
  return rp;
}
var ap, uT;
function Nm() {
  if (uT) return ap;
  uT = 1, ap = e, e.displayName = "t4Templating", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(i, o, s) {
        return {
          pattern: RegExp("<#" + i + "[\\s\\S]*?#>"),
          alias: "block",
          inside: {
            delimiter: {
              pattern: RegExp("^<#" + i + "|#>$"),
              alias: "important"
            },
            content: {
              pattern: /[\s\S]+/,
              inside: o,
              alias: s
            }
          }
        };
      }
      function a(i) {
        var o = n.languages[i], s = "language-" + i;
        return {
          block: {
            pattern: /<#[\s\S]+?#>/,
            inside: {
              directive: r("@", {
                "attr-value": {
                  pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                  inside: {
                    punctuation: /^=|^["']|["']$/
                  }
                },
                keyword: /\b\w+(?=\s)/,
                "attr-name": /\b\w+/
              }),
              expression: r("=", o, s),
              "class-feature": r("\\+", o, s),
              standard: r("", o, s)
            }
          }
        };
      }
      n.languages["t4-templating"] = Object.defineProperty({}, "createT4", {
        value: a
      });
    })(t);
  }
  return ap;
}
var ip, dT;
function yK() {
  if (dT) return ip;
  dT = 1;
  var e = Nm(), t = Fs();
  ip = n, n.displayName = "t4Cs", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), r.languages.t4 = r.languages["t4-cs"] = r.languages["t4-templating"].createT4("csharp");
  }
  return ip;
}
var op, fT;
function Mk() {
  if (fT) return op;
  fT = 1;
  var e = kk();
  op = t, t.displayName = "vbnet", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.vbnet = n.languages.extend("basic", {
      comment: [
        {
          pattern: /(?:!|REM\b).+/i,
          inside: {
            keyword: /^REM/i
          }
        },
        {
          pattern: /(^|[^\\:])'.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
      punctuation: /[,;:(){}]/
    });
  }
  return op;
}
var sp, pT;
function EK() {
  if (pT) return sp;
  pT = 1;
  var e = Nm(), t = Mk();
  sp = n, n.displayName = "t4Vb", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), r.languages["t4-vb"] = r.languages["t4-templating"].createT4("vbnet");
  }
  return sp;
}
var lp, gT;
function Pk() {
  if (gT) return lp;
  gT = 1, lp = e, e.displayName = "yaml", e.aliases = ["yml"];
  function e(t) {
    (function(n) {
      var r = /[*&][^\s[\]{},]+/, a = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, i = "(?:" + a.source + "(?:[ 	]+" + r.source + ")?|" + r.source + "(?:[ 	]+" + a.source + ")?)", o = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(
        /<PLAIN>/g,
        function() {
          return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        }
      ), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
      function l(c, u) {
        u = (u || "").replace(/m/g, "") + "m";
        var d = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
          return i;
        }).replace(/<<value>>/g, function() {
          return c;
        });
        return RegExp(d, u);
      }
      n.languages.yaml = {
        scalar: {
          pattern: RegExp(
            /([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(
              /<<prop>>/g,
              function() {
                return i;
              }
            )
          ),
          lookbehind: !0,
          alias: "string"
        },
        comment: /#.*/,
        key: {
          pattern: RegExp(
            /((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
              return i;
            }).replace(/<<key>>/g, function() {
              return "(?:" + o + "|" + s + ")";
            })
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "atrule"
        },
        directive: {
          pattern: /(^[ \t]*)%.+/m,
          lookbehind: !0,
          alias: "important"
        },
        datetime: {
          pattern: l(
            /\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source
          ),
          lookbehind: !0,
          alias: "number"
        },
        boolean: {
          pattern: l(/false|true/.source, "i"),
          lookbehind: !0,
          alias: "important"
        },
        null: {
          pattern: l(/null|~/.source, "i"),
          lookbehind: !0,
          alias: "important"
        },
        string: {
          pattern: l(s),
          lookbehind: !0,
          greedy: !0
        },
        number: {
          pattern: l(
            /[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source,
            "i"
          ),
          lookbehind: !0
        },
        tag: a,
        important: r,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
      }, n.languages.yml = n.languages.yaml;
    })(t);
  }
  return lp;
}
var cp, hT;
function SK() {
  if (hT) return cp;
  hT = 1;
  var e = Pk();
  cp = t, t.displayName = "tap", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.tap = {
      fail: /not ok[^#{\n\r]*/,
      pass: /ok[^#{\n\r]*/,
      pragma: /pragma [+-][a-z]+/,
      bailout: /bail out!.*/i,
      version: /TAP version \d+/i,
      plan: /\b\d+\.\.\d+(?: +#.*)?/,
      subtest: {
        pattern: /# Subtest(?:: .*)?/,
        greedy: !0
      },
      punctuation: /[{}]/,
      directive: /#.*/,
      yamlish: {
        pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
        lookbehind: !0,
        inside: n.languages.yaml,
        alias: "language-yaml"
      }
    };
  }
  return cp;
}
var up, mT;
function wK() {
  if (mT) return up;
  mT = 1, up = e, e.displayName = "tcl", e.aliases = [];
  function e(t) {
    t.languages.tcl = {
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0
      },
      string: {
        pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
        greedy: !0
      },
      variable: [
        {
          pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
          lookbehind: !0
        },
        {
          pattern: /(\$)\{[^}]+\}/,
          lookbehind: !0
        },
        {
          pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
          lookbehind: !0
        }
      ],
      function: {
        pattern: /(^[\t ]*proc[ \t]+)\S+/m,
        lookbehind: !0
      },
      builtin: [
        {
          pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
          lookbehind: !0
        },
        /\b(?:else|elseif)\b/
      ],
      scope: {
        pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
        lookbehind: !0,
        alias: "constant"
      },
      keyword: {
        pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
        lookbehind: !0
      },
      operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
      punctuation: /[{}()\[\]]/
    };
  }
  return up;
}
var dp, bT;
function _K() {
  if (bT) return dp;
  bT = 1, dp = e, e.displayName = "textile", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source, a = /\)|\((?![^|()\n]+\))/.source;
      function i(f, g) {
        return RegExp(
          f.replace(/<MOD>/g, function() {
            return "(?:" + r + ")";
          }).replace(/<PAR>/g, function() {
            return "(?:" + a + ")";
          }),
          g || ""
        );
      }
      var o = {
        css: {
          pattern: /\{[^{}]+\}/,
          inside: {
            rest: n.languages.css
          }
        },
        "class-id": {
          pattern: /(\()[^()]+(?=\))/,
          lookbehind: !0,
          alias: "attr-value"
        },
        lang: {
          pattern: /(\[)[^\[\]]+(?=\])/,
          lookbehind: !0,
          alias: "attr-value"
        },
        // Anything else is punctuation (the first pattern is for row/col spans inside tables)
        punctuation: /[\\\/]\d+|\S/
      }, s = n.languages.textile = n.languages.extend("markup", {
        phrase: {
          pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
          lookbehind: !0,
          inside: {
            // h1. Header 1
            "block-tag": {
              pattern: i(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
              inside: {
                modifier: {
                  pattern: i(
                    /(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source
                  ),
                  lookbehind: !0,
                  inside: o
                },
                tag: /^[a-z]\w*/,
                punctuation: /\.$/
              }
            },
            // # List item
            // * List item
            list: {
              pattern: i(/^[*#]+<MOD>*\s+\S.*/.source, "m"),
              inside: {
                modifier: {
                  pattern: i(/(^[*#]+)<MOD>+/.source),
                  lookbehind: !0,
                  inside: o
                },
                punctuation: /^[*#]+/
              }
            },
            // | cell | cell | cell |
            table: {
              // Modifiers can be applied to the row: {color:red}.|1|2|3|
              // or the cell: |{color:red}.1|2|3|
              pattern: i(
                /^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source,
                "m"
              ),
              inside: {
                modifier: {
                  // Modifiers for rows after the first one are
                  // preceded by a pipe and a line feed
                  pattern: i(
                    /(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source
                  ),
                  lookbehind: !0,
                  inside: o
                },
                punctuation: /\||^\./
              }
            },
            inline: {
              // eslint-disable-next-line regexp/no-super-linear-backtracking
              pattern: i(
                /(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source
              ),
              lookbehind: !0,
              inside: {
                // Note: superscripts and subscripts are not handled specifically
                // *bold*, **bold**
                bold: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                  lookbehind: !0
                },
                // _italic_, __italic__
                italic: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^(__?)<MOD>*).+?(?=\2)/.source),
                  lookbehind: !0
                },
                // ??cite??
                cite: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                  lookbehind: !0,
                  alias: "string"
                },
                // @code@
                code: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^@<MOD>*).+?(?=@)/.source),
                  lookbehind: !0,
                  alias: "keyword"
                },
                // +inserted+
                inserted: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^\+<MOD>*).+?(?=\+)/.source),
                  lookbehind: !0
                },
                // -deleted-
                deleted: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^-<MOD>*).+?(?=-)/.source),
                  lookbehind: !0
                },
                // %span%
                span: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^%<MOD>*).+?(?=%)/.source),
                  lookbehind: !0
                },
                modifier: {
                  pattern: i(
                    /(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source
                  ),
                  lookbehind: !0,
                  inside: o
                },
                punctuation: /[*_%?@+\-^~]+/
              }
            },
            // [alias]http://example.com
            "link-ref": {
              pattern: /^\[[^\]]+\]\S+$/m,
              inside: {
                string: {
                  pattern: /(^\[)[^\]]+(?=\])/,
                  lookbehind: !0
                },
                url: {
                  pattern: /(^\])\S+$/,
                  lookbehind: !0
                },
                punctuation: /[\[\]]/
              }
            },
            // "text":http://example.com
            // "text":link-ref
            link: {
              // eslint-disable-next-line regexp/no-super-linear-backtracking
              pattern: i(
                /"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source
              ),
              inside: {
                text: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^"<MOD>*)[^"]+(?=")/.source),
                  lookbehind: !0
                },
                modifier: {
                  pattern: i(/(^")<MOD>+/.source),
                  lookbehind: !0,
                  inside: o
                },
                url: {
                  pattern: /(:).+/,
                  lookbehind: !0
                },
                punctuation: /[":]/
              }
            },
            // !image.jpg!
            // !image.jpg(Title)!:http://example.com
            image: {
              pattern: i(
                /!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source
              ),
              inside: {
                source: {
                  pattern: i(
                    /(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source
                  ),
                  lookbehind: !0,
                  alias: "url"
                },
                modifier: {
                  pattern: i(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                  lookbehind: !0,
                  inside: o
                },
                url: {
                  pattern: /(:).+/,
                  lookbehind: !0
                },
                punctuation: /[!:]/
              }
            },
            // Footnote[1]
            footnote: {
              pattern: /\b\[\d+\]/,
              alias: "comment",
              inside: {
                punctuation: /\[|\]/
              }
            },
            // CSS(Cascading Style Sheet)
            acronym: {
              pattern: /\b[A-Z\d]+\([^)]+\)/,
              inside: {
                comment: {
                  pattern: /(\()[^()]+(?=\))/,
                  lookbehind: !0
                },
                punctuation: /[()]/
              }
            },
            // Prism(C)
            mark: {
              pattern: /\b\((?:C|R|TM)\)/,
              alias: "comment",
              inside: {
                punctuation: /[()]/
              }
            }
          }
        }
      }), l = s.phrase.inside, c = {
        inline: l.inline,
        link: l.link,
        image: l.image,
        footnote: l.footnote,
        acronym: l.acronym,
        mark: l.mark
      };
      s.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i;
      var u = l.inline.inside;
      u.bold.inside = c, u.italic.inside = c, u.inserted.inside = c, u.deleted.inside = c, u.span.inside = c;
      var d = l.table.inside;
      d.inline = c.inline, d.link = c.link, d.image = c.image, d.footnote = c.footnote, d.acronym = c.acronym, d.mark = c.mark;
    })(t);
  }
  return dp;
}
var fp, vT;
function TK() {
  if (vT) return fp;
  vT = 1, fp = e, e.displayName = "toml", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
      function a(i) {
        return i.replace(/__/g, function() {
          return r;
        });
      }
      n.languages.toml = {
        comment: {
          pattern: /#.*/,
          greedy: !0
        },
        table: {
          pattern: RegExp(
            a(
              /(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "class-name"
        },
        key: {
          pattern: RegExp(
            a(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "property"
        },
        string: {
          pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
          greedy: !0
        },
        date: [
          {
            // Offset Date-Time, Local Date-Time, Local Date
            pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
            alias: "number"
          },
          {
            // Local Time
            pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
            alias: "number"
          }
        ],
        number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /[.,=[\]{}]/
      };
    })(t);
  }
  return fp;
}
var pp, yT;
function RK() {
  if (yT) return pp;
  yT = 1, pp = e, e.displayName = "tremor", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.tremor = {
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
          lookbehind: !0
        },
        "interpolated-string": null,
        // see below
        extractor: {
          pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
          greedy: !0,
          inside: {
            regex: {
              pattern: /(^re)\|[\s\S]+/,
              lookbehind: !0
            },
            function: /^\w+/,
            value: /\|[\s\S]+/
          }
        },
        identifier: {
          pattern: /`[^`]*`/,
          greedy: !0
        },
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
        keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
        boolean: /\b(?:false|null|true)\b/i,
        number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
        "pattern-punctuation": {
          pattern: /%(?=[({[])/,
          alias: "punctuation"
        },
        operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
        punctuation: /::|[;\[\]()\{\},.:]/
      };
      var r = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
      n.languages.tremor["interpolated-string"] = {
        pattern: RegExp(
          /(^|[^\\])/.source + '(?:"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + "|" + r + ')*"""|"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + "|" + r + ')*")'
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: RegExp(r),
            inside: {
              punctuation: /^#\{|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: n.languages.tremor
              }
            }
          },
          string: /[\s\S]+/
        }
      }, n.languages.troy = n.languages.tremor, n.languages.trickle = n.languages.tremor;
    })(t);
  }
  return pp;
}
var gp, ET;
function AK() {
  if (ET) return gp;
  ET = 1;
  var e = Dk(), t = Am();
  gp = n, n.displayName = "tsx", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      var i = a.util.clone(a.languages.typescript);
      a.languages.tsx = a.languages.extend("jsx", i), delete a.languages.tsx.parameter, delete a.languages.tsx["literal-property"];
      var o = a.languages.tsx.tag;
      o.pattern = RegExp(
        /(^|[^\w$]|(?=<\/))/.source + "(?:" + o.pattern.source + ")",
        o.pattern.flags
      ), o.lookbehind = !0;
    }(r);
  }
  return gp;
}
var hp, ST;
function xK() {
  if (ST) return hp;
  ST = 1;
  var e = yt();
  hp = t, t.displayName = "tt2", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.tt2 = r.languages.extend("clike", {
        comment: /#.*|\[%#[\s\S]*?%\]/,
        keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
        punctuation: /[[\]{},()]/
      }), r.languages.insertBefore("tt2", "number", {
        operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
        variable: {
          pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
        }
      }), r.languages.insertBefore("tt2", "keyword", {
        delimiter: {
          pattern: /^(?:\[%|%%)-?|-?%\]$/,
          alias: "punctuation"
        }
      }), r.languages.insertBefore("tt2", "string", {
        "single-quoted-string": {
          pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
          greedy: !0,
          alias: "string"
        },
        "double-quoted-string": {
          pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
          greedy: !0,
          alias: "string",
          inside: {
            variable: {
              pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
            }
          }
        }
      }), delete r.languages.tt2.string, r.hooks.add("before-tokenize", function(a) {
        var i = /\[%[\s\S]+?%\]/g;
        r.languages["markup-templating"].buildPlaceholders(
          a,
          "tt2",
          i
        );
      }), r.hooks.add("after-tokenize", function(a) {
        r.languages["markup-templating"].tokenizePlaceholders(a, "tt2");
      });
    }(n);
  }
  return hp;
}
var mp, wT;
function CK() {
  if (wT) return mp;
  wT = 1;
  var e = yt();
  mp = t, t.displayName = "twig", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.twig = {
      comment: /^\{#[\s\S]*?#\}$/,
      "tag-name": {
        pattern: /(^\{%-?\s*)\w+/,
        lookbehind: !0,
        alias: "keyword"
      },
      delimiter: {
        pattern: /^\{[{%]-?|-?[%}]\}$/,
        alias: "punctuation"
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        inside: {
          punctuation: /^['"]|['"]$/
        }
      },
      keyword: /\b(?:even|if|odd)\b/,
      boolean: /\b(?:false|null|true)\b/,
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      operator: [
        {
          pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
          lookbehind: !0
        },
        /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
      ],
      punctuation: /[()\[\]{}:.,]/
    }, n.hooks.add("before-tokenize", function(r) {
      if (r.language === "twig") {
        var a = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
        n.languages["markup-templating"].buildPlaceholders(r, "twig", a);
      }
    }), n.hooks.add("after-tokenize", function(r) {
      n.languages["markup-templating"].tokenizePlaceholders(r, "twig");
    });
  }
  return mp;
}
var bp, _T;
function NK() {
  if (_T) return bp;
  _T = 1, bp = e, e.displayName = "typoscript", e.aliases = ["tsconfig"];
  function e(t) {
    (function(n) {
      var r = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
      n.languages.typoscript = {
        comment: [
          {
            // multiline comments /* */
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0
          },
          {
            // double-slash comments - ignored when backslashes or colon is found in front
            // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
            pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // hash comments - ignored when leading quote is found for hex colors in strings
            pattern: /(^|[^"'])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        function: [
          {
            // old include style
            pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
            inside: {
              string: {
                pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                inside: {
                  keyword: r
                }
              },
              keyword: {
                pattern: /INCLUDE_TYPOSCRIPT/
              }
            }
          },
          {
            // new include style
            pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
            inside: {
              string: /"[^"\r\n]*"|'[^'\r\n]*'/
            }
          }
        ],
        string: {
          pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
          lookbehind: !0,
          inside: {
            function: /\{\$.*\}/,
            // constants include
            keyword: r,
            number: /^\d+$/,
            punctuation: /[,|:]/
          }
        },
        keyword: r,
        number: {
          // special highlighting for indexes of arrays in tags
          pattern: /\b\d+\s*[.{=]/,
          inside: {
            operator: /[.{=]/
          }
        },
        tag: {
          pattern: /\.?[-\w\\]+\.?/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /[{}[\];(),.:|]/,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
      }, n.languages.tsconfig = n.languages.typoscript;
    })(t);
  }
  return bp;
}
var vp, TT;
function IK() {
  if (TT) return vp;
  TT = 1, vp = e, e.displayName = "unrealscript", e.aliases = ["uc", "uscript"];
  function e(t) {
    t.languages.unrealscript = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      category: {
        pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      metadata: {
        pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          property: /\b\w+(?=\s*=)/,
          operator: /=/,
          punctuation: /[<>|]/
        }
      },
      macro: {
        pattern: /`\w+/,
        alias: "property"
      },
      "class-name": {
        pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
        lookbehind: !0
      },
      keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      boolean: /\b(?:false|true)\b/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
      operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
      punctuation: /[()[\]{};,.]/
    }, t.languages.uc = t.languages.uscript = t.languages.unrealscript;
  }
  return vp;
}
var yp, RT;
function kK() {
  if (RT) return yp;
  RT = 1, yp = e, e.displayName = "uorazor", e.aliases = [];
  function e(t) {
    t.languages.uorazor = {
      "comment-hash": {
        pattern: /#.*/,
        alias: "comment",
        greedy: !0
      },
      "comment-slash": {
        pattern: /\/\/.*/,
        alias: "comment",
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        inside: {
          punctuation: /^['"]|['"]$/
        },
        greedy: !0
      },
      "source-layers": {
        pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
        alias: "function"
      },
      "source-commands": {
        pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
        alias: "function"
      },
      "tag-name": {
        pattern: /(^\{%-?\s*)\w+/,
        lookbehind: !0,
        alias: "keyword"
      },
      delimiter: {
        pattern: /^\{[{%]-?|-?[%}]\}$/,
        alias: "punctuation"
      },
      function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
      keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
      boolean: /\b(?:false|null|true)\b/,
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      operator: [
        {
          pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
          lookbehind: !0
        },
        /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
      ],
      punctuation: /[()\[\]{}:.,]/
    };
  }
  return yp;
}
var Ep, AT;
function OK() {
  if (AT) return Ep;
  AT = 1, Ep = e, e.displayName = "uri", e.aliases = ["url"];
  function e(t) {
    t.languages.uri = {
      scheme: {
        pattern: /^[a-z][a-z0-9+.-]*:/im,
        greedy: !0,
        inside: {
          "scheme-delimiter": /:$/
        }
      },
      fragment: {
        pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
        inside: {
          "fragment-delimiter": /^#/
        }
      },
      query: {
        pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
        inside: {
          "query-delimiter": {
            pattern: /^\?/,
            greedy: !0
          },
          "pair-delimiter": /[&;]/,
          pair: {
            pattern: /^[^=][\s\S]*/,
            inside: {
              key: /^[^=]+/,
              value: {
                pattern: /(^=)[\s\S]+/,
                lookbehind: !0
              }
            }
          }
        }
      },
      authority: {
        pattern: RegExp(
          /^\/\//.source + // [ userinfo "@" ]
          /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
          ("(?:" + // IP-literal
          /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + "|" + // IPv4address or registered name
          /[\w\-.~!$&'()*+,;=%]*/.source + ")") + // [ ":" port ]
          /(?::\d*)?/.source,
          "m"
        ),
        inside: {
          "authority-delimiter": /^\/\//,
          "user-info-segment": {
            pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
            inside: {
              "user-info-delimiter": /@$/,
              "user-info": /^[\w\-.~!$&'()*+,;=%:]+/
            }
          },
          "port-segment": {
            pattern: /:\d*$/,
            inside: {
              "port-delimiter": /^:/,
              port: /^\d+/
            }
          },
          host: {
            pattern: /[\s\S]+/,
            inside: {
              "ip-literal": {
                pattern: /^\[[\s\S]+\]$/,
                inside: {
                  "ip-literal-delimiter": /^\[|\]$/,
                  "ipv-future": /^v[\s\S]+/,
                  "ipv6-address": /^[\s\S]+/
                }
              },
              "ipv4-address": /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
            }
          }
        }
      },
      path: {
        pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
        inside: {
          "path-separator": /\//
        }
      }
    }, t.languages.url = t.languages.uri;
  }
  return Ep;
}
var Sp, xT;
function DK() {
  if (xT) return Sp;
  xT = 1, Sp = e, e.displayName = "v", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /[\s\S]+/,
        inside: null
      };
      n.languages.v = n.languages.extend("clike", {
        string: {
          pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          alias: "quoted-string",
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
              lookbehind: !0,
              inside: {
                "interpolation-variable": {
                  pattern: /^\$\w[\s\S]*$/,
                  alias: "variable"
                },
                "interpolation-punctuation": {
                  pattern: /^\$\{|\}$/,
                  alias: "punctuation"
                },
                "interpolation-expression": r
              }
            }
          }
        },
        "class-name": {
          pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
          lookbehind: !0
        },
        keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
        number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
        operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
        builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
      }), r.inside = n.languages.v, n.languages.insertBefore("v", "string", {
        char: {
          pattern: /`(?:\\`|\\?[^`]{1,2})`/,
          // using {1,2} instead of `u` flag for compatibility
          alias: "rune"
        }
      }), n.languages.insertBefore("v", "operator", {
        attribute: {
          pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
          lookbehind: !0,
          alias: "annotation",
          inside: {
            punctuation: /[\[\]]/,
            keyword: /\w+/
          }
        },
        generic: {
          pattern: /<\w+>(?=\s*[\)\{])/,
          inside: {
            punctuation: /[<>]/,
            "class-name": /\w+/
          }
        }
      }), n.languages.insertBefore("v", "function", {
        "generic-function": {
          // e.g. foo<T>( ...
          pattern: /\b\w+\s*<\w+>(?=\()/,
          inside: {
            function: /^\w+/,
            generic: {
              pattern: /<\w+>/,
              inside: n.languages.v.generic.inside
            }
          }
        }
      });
    })(t);
  }
  return Sp;
}
var wp, CT;
function LK() {
  if (CT) return wp;
  CT = 1, wp = e, e.displayName = "vala", e.aliases = [];
  function e(t) {
    t.languages.vala = t.languages.extend("clike", {
      // Classes copied from prism-csharp
      "class-name": [
        {
          // (Foo bar, Bar baz)
          pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
          inside: {
            punctuation: /\./
          }
        },
        {
          // [Foo]
          pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        {
          // class Foo : Bar
          pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        {
          // class Foo
          pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      ],
      keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
      function: /\b\w+(?=\s*\()/,
      number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
      operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
      punctuation: /[{}[\];(),.:]/,
      constant: /\b[A-Z0-9_]+\b/
    }), t.languages.insertBefore("vala", "string", {
      "raw-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      "template-string": {
        pattern: /@"[\s\S]*?"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
            inside: {
              delimiter: {
                pattern: /^\$\(?|\)$/,
                alias: "punctuation"
              },
              rest: t.languages.vala
            }
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.insertBefore("vala", "keyword", {
      regex: {
        pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^\//,
          "regex-flags": /^[a-z]+$/
        }
      }
    });
  }
  return wp;
}
var _p, NT;
function MK() {
  if (NT) return _p;
  NT = 1, _p = e, e.displayName = "velocity", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.velocity = n.languages.extend("markup", {});
      var r = {
        variable: {
          pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
          lookbehind: !0,
          inside: {}
          // See below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        number: /\b\d+\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
        punctuation: /[(){}[\]:,.]/
      };
      r.variable.inside = {
        string: r.string,
        function: {
          pattern: /([^\w-])[a-z][\w-]*(?=\()/,
          lookbehind: !0
        },
        number: r.number,
        boolean: r.boolean,
        punctuation: r.punctuation
      }, n.languages.insertBefore("velocity", "comment", {
        unparsed: {
          pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            punctuation: /^#\[\[|\]\]#$/
          }
        },
        "velocity-comment": [
          {
            pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
            lookbehind: !0,
            greedy: !0,
            alias: "comment"
          },
          {
            pattern: /(^|[^\\])##.*/,
            lookbehind: !0,
            greedy: !0,
            alias: "comment"
          }
        ],
        directive: {
          pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
          lookbehind: !0,
          inside: {
            keyword: {
              pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
              inside: {
                punctuation: /[{}]/
              }
            },
            rest: r
          }
        },
        variable: r.variable
      }), n.languages.velocity.tag.inside["attr-value"].inside.rest = n.languages.velocity;
    })(t);
  }
  return _p;
}
var Tp, IT;
function PK() {
  if (IT) return Tp;
  IT = 1, Tp = e, e.displayName = "verilog", e.aliases = [];
  function e(t) {
    t.languages.verilog = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      "kernel-function": {
        // support for any kernel function (ex: $display())
        pattern: /\B\$\w+\b/,
        alias: "property"
      },
      // support for user defined constants (ex: `define)
      constant: /\B`\w+\b/,
      function: /\b\w+(?=\()/,
      // support for verilog and system verilog keywords
      keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
      // bold highlighting for all verilog and system verilog logic blocks
      important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
      // support for time ticks, vectors, and real numbers
      number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
      operator: /[-+{}^~%*\/?=!<>&|]+/,
      punctuation: /[[\];(),.:]/
    };
  }
  return Tp;
}
var Rp, kT;
function FK() {
  if (kT) return Rp;
  kT = 1, Rp = e, e.displayName = "vhdl", e.aliases = [];
  function e(t) {
    t.languages.vhdl = {
      comment: /--.+/,
      // support for all logic vectors
      "vhdl-vectors": {
        pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
        alias: "number"
      },
      // support for operator overloading included
      "quoted-function": {
        pattern: /"\S+?"(?=\()/,
        alias: "function"
      },
      string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
      constant: /\b(?:library|use)\b/i,
      // support for predefined attributes included
      keyword: /\b(?:'active|'ascending|'base|'delayed|'driving|'driving_value|'event|'high|'image|'instance_name|'last_active|'last_event|'last_value|'left|'leftof|'length|'low|'path_name|'pos|'pred|'quiet|'range|'reverse_range|'right|'rightof|'simple_name|'stable|'succ|'transaction|'val|'value|access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|wait|when|while|with)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\w+(?=\()/,
      // decimal, based, physical, and exponential numbers supported
      number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
      operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return Rp;
}
var Ap, OT;
function $K() {
  if (OT) return Ap;
  OT = 1, Ap = e, e.displayName = "vim", e.aliases = [];
  function e(t) {
    t.languages.vim = {
      string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
      comment: /".*/,
      function: /\b\w+(?=\()/,
      keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
      builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
      operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
      punctuation: /[{}[\](),;:]/
    };
  }
  return Ap;
}
var xp, DT;
function BK() {
  if (DT) return xp;
  DT = 1, xp = e, e.displayName = "visualBasic", e.aliases = [];
  function e(t) {
    t.languages["visual-basic"] = {
      comment: {
        pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
        inside: {
          keyword: /^REM/i
        }
      },
      directive: {
        pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
        alias: "property",
        greedy: !0
      },
      string: {
        pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
        greedy: !0
      },
      date: {
        pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
        alias: "number"
      },
      number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
      boolean: /\b(?:False|Nothing|True)\b/i,
      keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
      operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
      punctuation: /[{}().,:?]/
    }, t.languages.vb = t.languages["visual-basic"], t.languages.vba = t.languages["visual-basic"];
  }
  return xp;
}
var Cp, LT;
function UK() {
  if (LT) return Cp;
  LT = 1, Cp = e, e.displayName = "warpscript", e.aliases = [];
  function e(t) {
    t.languages.warpscript = {
      comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
        greedy: !0
      },
      variable: /\$\S+/,
      macro: {
        pattern: /@\S+/,
        alias: "property"
      },
      // WarpScript doesn't have any keywords, these are all functions under the control category
      // https://www.warp10.io/tags/control
      keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
      number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
      boolean: /\b(?:F|T|false|true)\b/,
      punctuation: /<%|%>|[{}[\]()]/,
      // Some operators from the "operators" category
      // https://www.warp10.io/tags/operators
      operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
    };
  }
  return Cp;
}
var Np, MT;
function GK() {
  if (MT) return Np;
  MT = 1, Np = e, e.displayName = "wasm", e.aliases = [];
  function e(t) {
    t.languages.wasm = {
      comment: [
        /\(;[\s\S]*?;\)/,
        {
          pattern: /;;.*/,
          greedy: !0
        }
      ],
      string: {
        pattern: /"(?:\\[\s\S]|[^"\\])*"/,
        greedy: !0
      },
      keyword: [
        {
          pattern: /\b(?:align|offset)=/,
          inside: {
            operator: /=/
          }
        },
        {
          pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
          inside: {
            punctuation: /\./
          }
        },
        /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
      ],
      variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
      number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
      punctuation: /[()]/
    };
  }
  return Np;
}
var Ip, PT;
function HK() {
  if (PT) return Ip;
  PT = 1, Ip = e, e.displayName = "webIdl", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source, a = "(?:" + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + "|" + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + "|" + /(?!(?:unrestricted|unsigned)\b)/.source + r + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ")" + /(?:\s*\?)?/.source, i = {};
      n.languages["web-idl"] = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
          greedy: !0
        },
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        namespace: {
          pattern: RegExp(/(\bnamespace\s+)/.source + r),
          lookbehind: !0
        },
        "class-name": [
          {
            pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
            lookbehind: !0,
            inside: i
          },
          {
            pattern: RegExp(
              /(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + a
            ),
            lookbehind: !0,
            inside: i
          },
          {
            // callback return type
            pattern: RegExp(
              "(" + /\bcallback\s+/.source + r + /\s*=\s*/.source + ")" + a
            ),
            lookbehind: !0,
            inside: i
          },
          {
            // typedef
            pattern: RegExp(/(\btypedef\b\s*)/.source + a),
            lookbehind: !0,
            inside: i
          },
          {
            pattern: RegExp(
              /(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + r
            ),
            lookbehind: !0
          },
          {
            // inheritance
            pattern: RegExp(/(:\s*)/.source + r),
            lookbehind: !0
          },
          // includes and implements
          RegExp(r + /(?=\s+(?:implements|includes)\b)/.source),
          {
            pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + r),
            lookbehind: !0
          },
          {
            // function return type, parameter types, and dictionary members
            pattern: RegExp(
              a + "(?=" + /\s*(?:\.{3}\s*)?/.source + r + /\s*[(),;=]/.source + ")"
            ),
            inside: i
          }
        ],
        builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
        keyword: [
          /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
          // type keywords
          /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
        ],
        boolean: /\b(?:false|true)\b/,
        number: {
          pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
          lookbehind: !0
        },
        operator: /\.{3}|[=:?<>-]/,
        punctuation: /[(){}[\].,;]/
      };
      for (var o in n.languages["web-idl"])
        o !== "class-name" && (i[o] = n.languages["web-idl"][o]);
      n.languages.webidl = n.languages["web-idl"];
    })(t);
  }
  return Ip;
}
var kp, FT;
function zK() {
  if (FT) return kp;
  FT = 1, kp = e, e.displayName = "wiki", e.aliases = [];
  function e(t) {
    t.languages.wiki = t.languages.extend("markup", {
      "block-comment": {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: !0,
        alias: "comment"
      },
      heading: {
        pattern: /^(=+)[^=\r\n].*?\1/m,
        inside: {
          punctuation: /^=+|=+$/,
          important: /.+/
        }
      },
      emphasis: {
        // TODO Multi-line
        pattern: /('{2,5}).+?\1/,
        inside: {
          "bold-italic": {
            pattern: /(''''').+?(?=\1)/,
            lookbehind: !0,
            alias: ["bold", "italic"]
          },
          bold: {
            pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
            lookbehind: !0
          },
          italic: {
            pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
            lookbehind: !0
          },
          punctuation: /^''+|''+$/
        }
      },
      hr: {
        pattern: /^-{4,}/m,
        alias: "punctuation"
      },
      url: [
        /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
        /\[\[.+?\]\]|\[.+?\]/
      ],
      variable: [
        /__[A-Z]+__/,
        // FIXME Nested structures should be handled
        // {{formatnum:{{#expr:{{{3}}}}}}}
        /\{{3}.+?\}{3}/,
        /\{\{.+?\}\}/
      ],
      symbol: [/^#redirect/im, /~{3,5}/],
      // Handle table attrs:
      // {|
      // ! style="text-align:left;"| Item
      // |}
      "table-tag": {
        pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
        lookbehind: !0,
        inside: {
          "table-bar": {
            pattern: /\|$/,
            alias: "punctuation"
          },
          rest: t.languages.markup.tag.inside
        }
      },
      punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
    }), t.languages.insertBefore("wiki", "tag", {
      // Prevent highlighting inside <nowiki>, <source> and <pre> tags
      nowiki: {
        pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
        inside: {
          tag: {
            pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
            inside: t.languages.markup.tag.inside
          }
        }
      }
    });
  }
  return kp;
}
var Op, $T;
function WK() {
  if ($T) return Op;
  $T = 1, Op = e, e.displayName = "wolfram", e.aliases = ["mathematica", "wl", "nb"];
  function e(t) {
    t.languages.wolfram = {
      // Allow one level of nesting - note: regex taken from applescipt
      comment: /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0
      },
      keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
      context: {
        pattern: /\b\w+`+\w*/,
        alias: "class-name"
      },
      blank: {
        pattern: /\b\w+_\b/,
        alias: "regex"
      },
      "global-variable": {
        pattern: /\$\w+/,
        alias: "variable"
      },
      boolean: /\b(?:False|True)\b/,
      number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
      operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\^|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.mathematica = t.languages.wolfram, t.languages.wl = t.languages.wolfram, t.languages.nb = t.languages.wolfram;
  }
  return Op;
}
var Dp, BT;
function qK() {
  if (BT) return Dp;
  BT = 1, Dp = e, e.displayName = "wren", e.aliases = [];
  function e(t) {
    t.languages.wren = {
      // Multiline comments in Wren can have nested multiline comments
      // Comments: // and /* */
      comment: [
        {
          // support 3 levels of nesting
          // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
          pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      // Triple quoted strings are multiline but cannot have interpolation (raw strings)
      // Based on prism-python.js
      "triple-quoted-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      // see below
      "string-literal": null,
      // #!/usr/bin/env wren on the first line
      hashbang: {
        pattern: /^#!\/.+/,
        greedy: !0,
        alias: "comment"
      },
      // Attributes are special keywords to add meta data to classes
      attribute: {
        // #! attributes are stored in class properties
        // #!myvar = true
        // #attributes are not stored and dismissed at compilation
        pattern: /#!?[ \t\u3000]*\w+/,
        alias: "keyword"
      },
      "class-name": [
        {
          // class definition
          // class Meta {}
          pattern: /(\bclass\s+)\w+/,
          lookbehind: !0
        },
        // A class must always start with an uppercase.
        // File.read
        /\b[A-Z][a-z\d_]*\b/
      ],
      // A constant can be a variable, class, property or method. Just named in all uppercase letters
      constant: /\b[A-Z][A-Z\d_]*\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      },
      keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
      // Functions can be Class.method()
      function: /\b[a-z_]\w*(?=\s*[({])/i,
      operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
      punctuation: /[\[\](){}.,;]/
    }, t.languages.wren["string-literal"] = {
      // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
      pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          // "%(interpolation)"
          pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
          lookbehind: !0,
          inside: {
            expression: {
              pattern: /^(%\()[\s\S]+(?=\)$)/,
              lookbehind: !0,
              inside: t.languages.wren
            },
            "interpolation-punctuation": {
              pattern: /^%\(|\)$/,
              alias: "punctuation"
            }
          }
        },
        string: /[\s\S]+/
      }
    };
  }
  return Dp;
}
var Lp, UT;
function VK() {
  if (UT) return Lp;
  UT = 1, Lp = e, e.displayName = "xeora", e.aliases = ["xeoracube"];
  function e(t) {
    (function(n) {
      n.languages.xeora = n.languages.extend("markup", {
        constant: {
          pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
          inside: {
            punctuation: {
              pattern: /\$/
            }
          }
        },
        variable: {
          pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /[$.]/
            },
            operator: {
              pattern: /#+|[-+*~=^@]/
            }
          }
        },
        "function-inline": {
          pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
          inside: {
            variable: {
              pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
              inside: {
                punctuation: {
                  pattern: /[,.|]/
                },
                operator: {
                  pattern: /#+|[-+*~=^@]/
                }
              }
            },
            punctuation: {
              pattern: /\$\w:|[$:?.,|]/
            }
          },
          alias: "function"
        },
        "function-block": {
          pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
          inside: {
            punctuation: {
              pattern: /[$:{}?.,|]/
            }
          },
          alias: "function"
        },
        "directive-inline": {
          pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
              inside: {
                tag: {
                  pattern: /#\d/
                }
              }
            }
          },
          alias: "function"
        },
        "directive-block-open": {
          pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
          inside: {
            punctuation: {
              pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
              inside: {
                tag: {
                  pattern: /#\d/
                }
              }
            },
            attribute: {
              pattern: /![A-Z]+$/,
              inside: {
                punctuation: {
                  pattern: /!/
                }
              },
              alias: "keyword"
            }
          },
          alias: "function"
        },
        "directive-block-separator": {
          pattern: /\}:[-\w.]+:\{/,
          inside: {
            punctuation: {
              pattern: /[:{}]/
            }
          },
          alias: "function"
        },
        "directive-block-close": {
          pattern: /\}:[-\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /[:{}$]/
            }
          },
          alias: "function"
        }
      }), n.languages.insertBefore(
        "inside",
        "punctuation",
        {
          variable: n.languages.xeora["function-inline"].inside.variable
        },
        n.languages.xeora["function-block"]
      ), n.languages.xeoracube = n.languages.xeora;
    })(t);
  }
  return Lp;
}
var Mp, GT;
function jK() {
  if (GT) return Mp;
  GT = 1, Mp = e, e.displayName = "xmlDoc", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(s, l) {
        n.languages[s] && n.languages.insertBefore(s, "comment", {
          "doc-comment": l
        });
      }
      var a = n.languages.markup.tag, i = {
        pattern: /\/\/\/.*/,
        greedy: !0,
        alias: "comment",
        inside: {
          tag: a
        }
      }, o = {
        pattern: /'''.*/,
        greedy: !0,
        alias: "comment",
        inside: {
          tag: a
        }
      };
      r("csharp", i), r("fsharp", i), r("vbnet", o);
    })(t);
  }
  return Mp;
}
var Pp, HT;
function YK() {
  if (HT) return Pp;
  HT = 1, Pp = e, e.displayName = "xojo", e.aliases = [];
  function e(t) {
    t.languages.xojo = {
      comment: {
        pattern: /(?:'|\/\/|Rem\b).+/i,
        greedy: !0
      },
      string: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      number: [/(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i, /&[bchou][a-z\d]+/i],
      directive: {
        pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
        alias: "property"
      },
      keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
      operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
      punctuation: /[.,;:()]/
    };
  }
  return Pp;
}
var Fp, zT;
function KK() {
  if (zT) return Fp;
  zT = 1, Fp = e, e.displayName = "xquery", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.xquery = n.languages.extend("markup", {
        "xquery-comment": {
          pattern: /\(:[\s\S]*?:\)/,
          greedy: !0,
          alias: "comment"
        },
        string: {
          pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
          greedy: !0
        },
        extension: {
          pattern: /\(#.+?#\)/,
          alias: "symbol"
        },
        variable: /\$[-\w:]+/,
        axis: {
          pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
          lookbehind: !0,
          alias: "operator"
        },
        "keyword-operator": {
          pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
          lookbehind: !0,
          alias: "operator"
        },
        keyword: {
          pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
          lookbehind: !0
        },
        function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
        "xquery-element": {
          pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
          lookbehind: !0,
          alias: "tag"
        },
        "xquery-attribute": {
          pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
          lookbehind: !0,
          alias: "attr-name"
        },
        builtin: {
          pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
          lookbehind: !0
        },
        number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
        operator: [
          /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
          {
            pattern: /(\s)-(?=\s)/,
            lookbehind: !0
          }
        ],
        punctuation: /[[\](){},;:/]/
      }), n.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, n.languages.xquery.tag.inside["attr-value"].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/, n.languages.xquery.tag.inside["attr-value"].inside.punctuation = /^="|"$/, n.languages.xquery.tag.inside["attr-value"].inside.expression = {
        // Allow for two levels of nesting
        pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
        inside: n.languages.xquery,
        alias: "language-xquery"
      };
      var r = function(i) {
        return typeof i == "string" ? i : typeof i.content == "string" ? i.content : i.content.map(r).join("");
      }, a = function(i) {
        for (var o = [], s = 0; s < i.length; s++) {
          var l = i[s], c = !1;
          if (typeof l != "string" && (l.type === "tag" && l.content[0] && l.content[0].type === "tag" ? l.content[0].content[0].content === "</" ? o.length > 0 && o[o.length - 1].tagName === r(l.content[0].content[1]) && o.pop() : l.content[l.content.length - 1].content === "/>" || o.push({
            tagName: r(l.content[0].content[1]),
            openedBraces: 0
          }) : o.length > 0 && l.type === "punctuation" && l.content === "{" && // Ignore `{{`
          (!i[s + 1] || i[s + 1].type !== "punctuation" || i[s + 1].content !== "{") && (!i[s - 1] || i[s - 1].type !== "plain-text" || i[s - 1].content !== "{") ? o[o.length - 1].openedBraces++ : o.length > 0 && o[o.length - 1].openedBraces > 0 && l.type === "punctuation" && l.content === "}" ? o[o.length - 1].openedBraces-- : l.type !== "comment" && (c = !0)), (c || typeof l == "string") && o.length > 0 && o[o.length - 1].openedBraces === 0) {
            var u = r(l);
            s < i.length - 1 && (typeof i[s + 1] == "string" || i[s + 1].type === "plain-text") && (u += r(i[s + 1]), i.splice(s + 1, 1)), s > 0 && (typeof i[s - 1] == "string" || i[s - 1].type === "plain-text") && (u = r(i[s - 1]) + u, i.splice(s - 1, 1), s--), /^\s+$/.test(u) ? i[s] = u : i[s] = new n.Token(
              "plain-text",
              u,
              null,
              u
            );
          }
          l.content && typeof l.content != "string" && a(l.content);
        }
      };
      n.hooks.add("after-tokenize", function(i) {
        i.language === "xquery" && a(i.tokens);
      });
    })(t);
  }
  return Fp;
}
var $p, WT;
function XK() {
  if (WT) return $p;
  WT = 1, $p = e, e.displayName = "yang", e.aliases = [];
  function e(t) {
    t.languages.yang = {
      // https://tools.ietf.org/html/rfc6020#page-34
      // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
      comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
      string: {
        pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
        greedy: !0
      },
      keyword: {
        pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
        lookbehind: !0
      },
      namespace: {
        pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
        lookbehind: !0
      },
      boolean: /\b(?:false|true)\b/,
      operator: /\+/,
      punctuation: /[{};:]/
    };
  }
  return $p;
}
var Bp, qT;
function ZK() {
  if (qT) return Bp;
  qT = 1, Bp = e, e.displayName = "zig", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(u) {
        return function() {
          return u;
        };
      }
      var a = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/, i = "\\b(?!" + a.source + ")(?!\\d)\\w+\\b", o = /align\s*\((?:[^()]|\([^()]*\))*\)/.source, s = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(
        /<ALIGN>/g,
        r(o)
      ), l = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(
        /<ID>/g,
        r(i)
      ), c = "(?!\\s)(?:!?\\s*(?:" + s + "\\s*)*" + l + ")+";
      n.languages.zig = {
        comment: [
          {
            pattern: /\/\/[/!].*/,
            alias: "doc-comment"
          },
          /\/{2}.*/
        ],
        string: [
          {
            // "string" and c"string"
            pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // multiline strings and c-strings
            pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        char: {
          // characters 'a', '\n', '\xFF', '\u{10FFFF}'
          pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
          lookbehind: !0,
          greedy: !0
        },
        builtin: /\B@(?!\d)\w+(?=\s*\()/,
        label: {
          pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
          lookbehind: !0
        },
        "class-name": [
          // const Foo = struct {};
          /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
          {
            // const x: i32 = 9;
            // var x: Bar;
            // fn foo(x: bool, y: f32) void {}
            pattern: RegExp(
              /(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, r(c)).replace(/<ALIGN>/g, r(o))
            ),
            lookbehind: !0,
            inside: null
            // see below
          },
          {
            // extern fn foo(x: f64) f64; (optional alignment)
            pattern: RegExp(
              /(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, r(c)).replace(/<ALIGN>/g, r(o))
            ),
            lookbehind: !0,
            inside: null
            // see below
          }
        ],
        "builtin-type": {
          pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
          alias: "keyword"
        },
        keyword: a,
        function: /\b(?!\d)\w+(?=\s*\()/,
        number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
        punctuation: /[.:,;(){}[\]]/
      }, n.languages.zig["class-name"].forEach(function(u) {
        u.inside === null && (u.inside = n.languages.zig);
      });
    })(t);
  }
  return Bp;
}
var x = i8, QK = x;
x.register(m8());
x.register(b8());
x.register(v8());
x.register(y8());
x.register(E8());
x.register(S8());
x.register(w8());
x.register(_8());
x.register(T8());
x.register(R8());
x.register(A8());
x.register(x8());
x.register(C8());
x.register(N8());
x.register(I8());
x.register(k8());
x.register(O8());
x.register(D8());
x.register(L8());
x.register(M8());
x.register(P8());
x.register(F8());
x.register(Ik());
x.register(kk());
x.register($8());
x.register(B8());
x.register(U8());
x.register(G8());
x.register(H8());
x.register(z8());
x.register(W8());
x.register(q8());
x.register(V8());
x.register(j8());
x.register(Or());
x.register(Y8());
x.register(K8());
x.register(X8());
x.register(Z8());
x.register(Q8());
x.register(J8());
x.register(eY());
x.register(tY());
x.register(nY());
x.register(_m());
x.register(rY());
x.register(Fs());
x.register(aY());
x.register(iY());
x.register(oY());
x.register(sY());
x.register(lY());
x.register(cY());
x.register(uY());
x.register(dY());
x.register(fY());
x.register(pY());
x.register(gY());
x.register(hY());
x.register(mY());
x.register(bY());
x.register(vY());
x.register(yY());
x.register(EY());
x.register(SY());
x.register(wY());
x.register(_Y());
x.register(TY());
x.register(RY());
x.register(AY());
x.register(xY());
x.register(CY());
x.register(NY());
x.register(IY());
x.register(kY());
x.register(OY());
x.register(DY());
x.register(LY());
x.register(MY());
x.register(PY());
x.register(FY());
x.register($Y());
x.register(BY());
x.register(UY());
x.register(GY());
x.register(HY());
x.register(zY());
x.register(WY());
x.register(qY());
x.register(VY());
x.register(jY());
x.register(YY());
x.register(KY());
x.register(XY());
x.register(Tm());
x.register(ZY());
x.register(QY());
x.register(JY());
x.register(e9());
x.register(t9());
x.register(n9());
x.register(r9());
x.register(a9());
x.register(i9());
x.register(o9());
x.register(s9());
x.register(l9());
x.register(c9());
x.register(u9());
x.register(d9());
x.register(f9());
x.register(p9());
x.register(Rm());
x.register(g9());
x.register(Bs());
x.register(h9());
x.register(m9());
x.register(b9());
x.register(v9());
x.register(y9());
x.register(E9());
x.register(S9());
x.register(xm());
x.register(w9());
x.register(_9());
x.register(T9());
x.register(Dk());
x.register(R9());
x.register(A9());
x.register(x9());
x.register(C9());
x.register(N9());
x.register(I9());
x.register(k9());
x.register(O9());
x.register(D9());
x.register(L9());
x.register(M9());
x.register(P9());
x.register(F9());
x.register($9());
x.register(B9());
x.register(U9());
x.register(Ok());
x.register(G9());
x.register(H9());
x.register(z9());
x.register(yt());
x.register(W9());
x.register(q9());
x.register(V9());
x.register(j9());
x.register(Y9());
x.register(K9());
x.register(X9());
x.register(Z9());
x.register(Q9());
x.register(J9());
x.register(e7());
x.register(t7());
x.register(n7());
x.register(r7());
x.register(a7());
x.register(i7());
x.register(o7());
x.register(s7());
x.register(l7());
x.register(c7());
x.register(u7());
x.register(d7());
x.register(f7());
x.register(p7());
x.register(g7());
x.register(h7());
x.register(m7());
x.register(b7());
x.register(v7());
x.register(y7());
x.register(E7());
x.register(S7());
x.register(Us());
x.register(w7());
x.register(_7());
x.register(T7());
x.register(R7());
x.register(A7());
x.register(x7());
x.register(C7());
x.register(N7());
x.register(I7());
x.register(k7());
x.register(O7());
x.register(D7());
x.register(L7());
x.register(M7());
x.register(P7());
x.register(F7());
x.register($7());
x.register(B7());
x.register(U7());
x.register(G7());
x.register(H7());
x.register(z7());
x.register(W7());
x.register(q7());
x.register(V7());
x.register(j7());
x.register(Y7());
x.register(K7());
x.register(X7());
x.register(Z7());
x.register($s());
x.register(Q7());
x.register(J7());
x.register(eK());
x.register(tK());
x.register(Cm());
x.register(nK());
x.register(rK());
x.register(aK());
x.register(iK());
x.register(oK());
x.register(sK());
x.register(lK());
x.register(cK());
x.register(uK());
x.register(dK());
x.register(fK());
x.register(pK());
x.register(wm());
x.register(gK());
x.register(hK());
x.register(mK());
x.register(bK());
x.register(vK());
x.register(yK());
x.register(Nm());
x.register(EK());
x.register(SK());
x.register(wK());
x.register(_K());
x.register(TK());
x.register(RK());
x.register(AK());
x.register(xK());
x.register(Lk());
x.register(CK());
x.register(Am());
x.register(NK());
x.register(IK());
x.register(kK());
x.register(OK());
x.register(DK());
x.register(LK());
x.register(Mk());
x.register(MK());
x.register(PK());
x.register(FK());
x.register($K());
x.register(BK());
x.register(UK());
x.register(GK());
x.register(HK());
x.register(zK());
x.register(WK());
x.register(qK());
x.register(VK());
x.register(jK());
x.register(YK());
x.register(KK());
x.register(Pk());
x.register(XK());
x.register(ZK());
const JK = /* @__PURE__ */ KV(QK);
var Fk = YV(JK, h8);
Fk.supportedLanguages = XV;
const eX = {
  'code[class*="language-"]': {
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    color: "#eee",
    background: "#2f2f2f",
    fontFamily: "Roboto Mono, monospace",
    fontSize: "1em",
    lineHeight: "1.5em",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    color: "#eee",
    background: "#2f2f2f",
    fontFamily: "Roboto Mono, monospace",
    fontSize: "1em",
    lineHeight: "1.5em",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    overflow: "auto",
    position: "relative",
    margin: "0.5em 0",
    padding: "1.25em 1em"
  },
  'code[class*="language-"]::-moz-selection': {
    background: "#363636"
  },
  'pre[class*="language-"]::-moz-selection': {
    background: "#363636"
  },
  'code[class*="language-"] ::-moz-selection': {
    background: "#363636"
  },
  'pre[class*="language-"] ::-moz-selection': {
    background: "#363636"
  },
  'code[class*="language-"]::selection': {
    background: "#363636"
  },
  'pre[class*="language-"]::selection': {
    background: "#363636"
  },
  'code[class*="language-"] ::selection': {
    background: "#363636"
  },
  'pre[class*="language-"] ::selection': {
    background: "#363636"
  },
  ':not(pre) > code[class*="language-"]': {
    whiteSpace: "normal",
    borderRadius: "0.2em",
    padding: "0.1em"
  },
  ".language-css > code": {
    color: "#fd9170"
  },
  ".language-sass > code": {
    color: "#fd9170"
  },
  ".language-scss > code": {
    color: "#fd9170"
  },
  '[class*="language-"] .namespace': {
    Opacity: "0.7"
  },
  atrule: {
    color: "#c792ea"
  },
  "attr-name": {
    color: "#ffcb6b"
  },
  "attr-value": {
    color: "#a5e844"
  },
  attribute: {
    color: "#a5e844"
  },
  boolean: {
    color: "#c792ea"
  },
  builtin: {
    color: "#ffcb6b"
  },
  cdata: {
    color: "#80cbc4"
  },
  char: {
    color: "#80cbc4"
  },
  class: {
    color: "#ffcb6b"
  },
  "class-name": {
    color: "#f2ff00"
  },
  comment: {
    color: "#616161"
  },
  constant: {
    color: "#c792ea"
  },
  deleted: {
    color: "#ff6666"
  },
  doctype: {
    color: "#616161"
  },
  entity: {
    color: "#ff6666"
  },
  function: {
    color: "#c792ea"
  },
  hexcode: {
    color: "#f2ff00"
  },
  id: {
    color: "#c792ea",
    fontWeight: "bold"
  },
  important: {
    color: "#c792ea",
    fontWeight: "bold"
  },
  inserted: {
    color: "#80cbc4"
  },
  keyword: {
    color: "#c792ea"
  },
  number: {
    color: "#fd9170"
  },
  operator: {
    color: "#89ddff"
  },
  prolog: {
    color: "#616161"
  },
  property: {
    color: "#80cbc4"
  },
  "pseudo-class": {
    color: "#a5e844"
  },
  "pseudo-element": {
    color: "#a5e844"
  },
  punctuation: {
    color: "#89ddff"
  },
  regex: {
    color: "#f2ff00"
  },
  selector: {
    color: "#ff6666"
  },
  string: {
    color: "#a5e844"
  },
  symbol: {
    color: "#c792ea"
  },
  tag: {
    color: "#ff6666"
  },
  unit: {
    color: "#fd9170"
  },
  url: {
    color: "#ff6666"
  },
  variable: {
    color: "#ff6666"
  }
}, BX = (e) => /* @__PURE__ */ _(Ke, { children: /* @__PURE__ */ _(
  Fk,
  {
    PreTag: (n) => /* @__PURE__ */ _("pre", { ...n }),
    language: e.language,
    style: eX,
    showLineNumbers: !0,
    customStyle: {
      borderRadius: "8px"
    },
    children: e.code
  }
) });
var tX = Object.defineProperty, nX = Object.defineProperties, rX = Object.getOwnPropertyDescriptors, ls = Object.getOwnPropertySymbols, $k = Object.prototype.hasOwnProperty, Bk = Object.prototype.propertyIsEnumerable, VT = (e, t, n) => t in e ? tX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, aX = (e, t) => {
  for (var n in t || (t = {})) $k.call(t, n) && VT(e, n, t[n]);
  if (ls) for (var n of ls(t)) Bk.call(t, n) && VT(e, n, t[n]);
  return e;
}, iX = (e, t) => nX(e, rX(t)), oX = (e, t) => {
  var n = {};
  for (var r in e) $k.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && ls) for (var r of ls(e)) t.indexOf(r) < 0 && Bk.call(e, r) && (n[r] = e[r]);
  return n;
};
function sX(e) {
  let t = setTimeout(e, 0), n = setTimeout(e, 10), r = setTimeout(e, 50);
  return [t, n, r];
}
function lX(e) {
  let t = b.useRef();
  return b.useEffect(() => {
    t.current = e;
  }), t.current;
}
var cX = 18, Uk = 40, uX = `${Uk}px`, dX = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function fX({ containerRef: e, inputRef: t, pushPasswordManagerStrategy: n, isFocused: r }) {
  let [a, i] = b.useState(!1), [o, s] = b.useState(!1), [l, c] = b.useState(!1), u = b.useMemo(() => n === "none" ? !1 : (n === "increase-width" || n === "experimental-no-flickering") && a && o, [a, o, n]), d = b.useCallback(() => {
    let f = e.current, g = t.current;
    if (!f || !g || l || n === "none") return;
    let h = f, p = h.getBoundingClientRect().left + h.offsetWidth, m = h.getBoundingClientRect().top + h.offsetHeight / 2, v = p - cX, y = m;
    document.querySelectorAll(dX).length === 0 && document.elementFromPoint(v, y) === f || (i(!0), c(!0));
  }, [e, t, l, n]);
  return b.useEffect(() => {
    let f = e.current;
    if (!f || n === "none") return;
    function g() {
      let p = window.innerWidth - f.getBoundingClientRect().right;
      s(p >= Uk);
    }
    g();
    let h = setInterval(g, 1e3);
    return () => {
      clearInterval(h);
    };
  }, [e, n]), b.useEffect(() => {
    let f = r || document.activeElement === t.current;
    if (n === "none" || !f) return;
    let g = setTimeout(d, 0), h = setTimeout(d, 2e3), p = setTimeout(d, 5e3), m = setTimeout(() => {
      c(!0);
    }, 6e3);
    return () => {
      clearTimeout(g), clearTimeout(h), clearTimeout(p), clearTimeout(m);
    };
  }, [t, r, n, d]), { hasPWMBadge: a, willPushPWMBadge: u, PWM_BADGE_SPACE_WIDTH: uX };
}
var Gk = b.createContext({}), Hk = b.forwardRef((e, t) => {
  var n = e, { value: r, onChange: a, maxLength: i, textAlign: o = "left", pattern: s, placeholder: l, inputMode: c = "numeric", onComplete: u, pushPasswordManagerStrategy: d = "increase-width", pasteTransformer: f, containerClassName: g, noScriptCSSFallback: h = pX, render: p, children: m } = n, v = oX(n, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), y, E, S, w, R;
  let [T, A] = b.useState(typeof v.defaultValue == "string" ? v.defaultValue : ""), C = r ?? T, N = lX(C), L = b.useCallback(($) => {
    a == null || a($), A($);
  }, [a]), I = b.useMemo(() => s ? typeof s == "string" ? new RegExp(s) : s : null, [s]), k = b.useRef(null), B = b.useRef(null), F = b.useRef({ value: C, onChange: L, isIOS: typeof window < "u" && ((E = (y = window == null ? void 0 : window.CSS) == null ? void 0 : y.supports) == null ? void 0 : E.call(y, "-webkit-touch-callout", "none")) }), P = b.useRef({ prev: [(S = k.current) == null ? void 0 : S.selectionStart, (w = k.current) == null ? void 0 : w.selectionEnd, (R = k.current) == null ? void 0 : R.selectionDirection] });
  b.useImperativeHandle(t, () => k.current, []), b.useEffect(() => {
    let $ = k.current, Y = B.current;
    if (!$ || !Y) return;
    F.current.value !== $.value && F.current.onChange($.value), P.current.prev = [$.selectionStart, $.selectionEnd, $.selectionDirection];
    function Ee() {
      if (document.activeElement !== $) {
        q(null), j(null);
        return;
      }
      let oe = $.selectionStart, Re = $.selectionEnd, zt = $.selectionDirection, Ge = $.maxLength, ot = $.value, Et = P.current.prev, Dt = -1, Wt = -1, an;
      if (ot.length !== 0 && oe !== null && Re !== null) {
        let Gs = oe === Re, Qn = oe === ot.length && ot.length < Ge;
        if (Gs && !Qn) {
          let qt = oe;
          if (qt === 0) Dt = 0, Wt = 1, an = "forward";
          else if (qt === Ge) Dt = qt - 1, Wt = qt, an = "backward";
          else if (Ge > 1 && ot.length > 1) {
            let wa = 0;
            if (Et[0] !== null && Et[1] !== null) {
              an = qt < Et[1] ? "backward" : "forward";
              let Hs = Et[0] === Et[1] && Et[0] < Ge;
              an === "backward" && !Hs && (wa = -1);
            }
            Dt = wa + qt, Wt = wa + qt + 1;
          }
        }
        Dt !== -1 && Wt !== -1 && Dt !== Wt && k.current.setSelectionRange(Dt, Wt, an);
      }
      let Zn = Dt !== -1 ? Dt : oe, Fi = Wt !== -1 ? Wt : Re, $i = an ?? zt;
      q(Zn), j(Fi), P.current.prev = [Zn, Fi, $i];
    }
    if (document.addEventListener("selectionchange", Ee, { capture: !0 }), Ee(), document.activeElement === $ && W(!0), !document.getElementById("input-otp-style")) {
      let oe = document.createElement("style");
      if (oe.id = "input-otp-style", document.head.appendChild(oe), oe.sheet) {
        let Re = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        Ma(oe.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), Ma(oe.sheet, `[data-input-otp]:autofill { ${Re} }`), Ma(oe.sheet, `[data-input-otp]:-webkit-autofill { ${Re} }`), Ma(oe.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), Ma(oe.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let Te = () => {
      Y && Y.style.setProperty("--root-height", `${$.clientHeight}px`);
    };
    Te();
    let Ue = new ResizeObserver(Te);
    return Ue.observe($), () => {
      document.removeEventListener("selectionchange", Ee, { capture: !0 }), Ue.disconnect();
    };
  }, []);
  let [D, O] = b.useState(!1), [M, W] = b.useState(!1), [U, q] = b.useState(null), [re, j] = b.useState(null);
  b.useEffect(() => {
    sX(() => {
      var $, Y, Ee, Te;
      ($ = k.current) == null || $.dispatchEvent(new Event("input"));
      let Ue = (Y = k.current) == null ? void 0 : Y.selectionStart, oe = (Ee = k.current) == null ? void 0 : Ee.selectionEnd, Re = (Te = k.current) == null ? void 0 : Te.selectionDirection;
      Ue !== null && oe !== null && (q(Ue), j(oe), P.current.prev = [Ue, oe, Re]);
    });
  }, [C, M]), b.useEffect(() => {
    N !== void 0 && C !== N && N.length < i && C.length === i && (u == null || u(C));
  }, [i, u, N, C]);
  let ie = fX({ containerRef: B, inputRef: k, pushPasswordManagerStrategy: d, isFocused: M }), Q = b.useCallback(($) => {
    let Y = $.currentTarget.value.slice(0, i);
    if (Y.length > 0 && I && !I.test(Y)) {
      $.preventDefault();
      return;
    }
    typeof N == "string" && Y.length < N.length && document.dispatchEvent(new Event("selectionchange")), L(Y);
  }, [i, L, N, I]), H = b.useCallback(() => {
    var $;
    if (k.current) {
      let Y = Math.min(k.current.value.length, i - 1), Ee = k.current.value.length;
      ($ = k.current) == null || $.setSelectionRange(Y, Ee), q(Y), j(Ee);
    }
    W(!0);
  }, [i]), K = b.useCallback(($) => {
    var Y, Ee;
    let Te = k.current;
    if (!f && (!F.current.isIOS || !$.clipboardData || !Te)) return;
    let Ue = $.clipboardData.getData("text/plain"), oe = f ? f(Ue) : Ue;
    $.preventDefault();
    let Re = (Y = k.current) == null ? void 0 : Y.selectionStart, zt = (Ee = k.current) == null ? void 0 : Ee.selectionEnd, Ge = (Re !== zt ? C.slice(0, Re) + oe + C.slice(zt) : C.slice(0, Re) + oe + C.slice(Re)).slice(0, i);
    if (Ge.length > 0 && I && !I.test(Ge)) return;
    Te.value = Ge, L(Ge);
    let ot = Math.min(Ge.length, i - 1), Et = Ge.length;
    Te.setSelectionRange(ot, Et), q(ot), j(Et);
  }, [i, L, I, C]), J = b.useMemo(() => ({ position: "relative", cursor: v.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [v.disabled]), ne = b.useMemo(() => ({ position: "absolute", inset: 0, width: ie.willPushPWMBadge ? `calc(100% + ${ie.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: ie.willPushPWMBadge ? `inset(0 ${ie.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: o, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [ie.PWM_BADGE_SPACE_WIDTH, ie.willPushPWMBadge, o]), ee = b.useMemo(() => b.createElement("input", iX(aX({ autoComplete: v.autoComplete || "one-time-code" }, v), { "data-input-otp": !0, "data-input-otp-placeholder-shown": C.length === 0 || void 0, "data-input-otp-mss": U, "data-input-otp-mse": re, inputMode: c, pattern: I == null ? void 0 : I.source, "aria-placeholder": l, style: ne, maxLength: i, value: C, ref: k, onPaste: ($) => {
    var Y;
    K($), (Y = v.onPaste) == null || Y.call(v, $);
  }, onChange: Q, onMouseOver: ($) => {
    var Y;
    O(!0), (Y = v.onMouseOver) == null || Y.call(v, $);
  }, onMouseLeave: ($) => {
    var Y;
    O(!1), (Y = v.onMouseLeave) == null || Y.call(v, $);
  }, onFocus: ($) => {
    var Y;
    H(), (Y = v.onFocus) == null || Y.call(v, $);
  }, onBlur: ($) => {
    var Y;
    W(!1), (Y = v.onBlur) == null || Y.call(v, $);
  } })), [Q, H, K, c, ne, i, re, U, v, I == null ? void 0 : I.source, C]), ae = b.useMemo(() => ({ slots: Array.from({ length: i }).map(($, Y) => {
    var Ee;
    let Te = M && U !== null && re !== null && (U === re && Y === U || Y >= U && Y < re), Ue = C[Y] !== void 0 ? C[Y] : null, oe = C[0] !== void 0 ? null : (Ee = l == null ? void 0 : l[Y]) != null ? Ee : null;
    return { char: Ue, placeholderChar: oe, isActive: Te, hasFakeCaret: Te && Ue === null };
  }), isFocused: M, isHovering: !v.disabled && D }), [M, D, i, re, U, v.disabled, C]), he = b.useMemo(() => p ? p(ae) : b.createElement(Gk.Provider, { value: ae }, m), [m, ae, p]);
  return b.createElement(b.Fragment, null, h !== null && b.createElement("noscript", null, b.createElement("style", null, h)), b.createElement("div", { ref: B, "data-input-otp-container": !0, style: J, className: g }, he, b.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, ee)));
});
Hk.displayName = "Input";
function Ma(e, t) {
  try {
    e.insertRule(t);
  } catch {
    console.error("input-otp could not insert CSS rule:", t);
  }
}
var pX = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`;
const zk = b.forwardRef(({ className: e, containerClassName: t, ...n }, r) => /* @__PURE__ */ _(
  Hk,
  {
    ref: r,
    containerClassName: de(
      "flex items-center gap-2 has-[:disabled]:opacity-50",
      t
    ),
    className: de("disabled:cursor-not-allowed", e),
    ...n
  }
));
zk.displayName = "InputOTP";
const Wk = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _("div", { ref: n, className: de("flex items-center", e), ...t }));
Wk.displayName = "InputOTPGroup";
const qk = b.forwardRef(({ index: e, className: t, ...n }, r) => {
  const a = b.useContext(Gk), { char: i, hasFakeCaret: o, isActive: s } = a.slots[e];
  return /* @__PURE__ */ Z(
    "div",
    {
      ref: r,
      className: de(
        "relative flex h-9 w-9 items-center justify-center border-y border-r border-input text-sm shadow-sm transition-all first:rounded-l-md first:border-l last:rounded-r-md",
        s && "z-10 ring-1 ring-ring",
        t
      ),
      ...n,
      children: [
        i,
        o && /* @__PURE__ */ _("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ _("div", { className: "h-4 w-px animate-caret-blink bg-foreground duration-1000" }) })
      ]
    }
  );
});
qk.displayName = "InputOTPSlot";
const gX = b.forwardRef(({ ...e }, t) => /* @__PURE__ */ _("div", { ref: t, role: "separator", ...e, children: /* @__PURE__ */ _(vM, {}) }));
gX.displayName = "InputOTPSeparator";
const UX = (e) => {
  const { length: t, disabled: n, value: r } = e;
  return /* @__PURE__ */ _(zk, { maxLength: t, disabled: n, value: r, ...e, children: /* @__PURE__ */ _(Wk, { children: new Array(t).fill(0).map((a, i) => /* @__PURE__ */ _(qk, { index: i })) }) });
};
export {
  NX as Alert,
  MX as AppDrawer,
  $X as Badge,
  iP as Button,
  e0 as Card,
  BX as CodeSnippet,
  CX as DatePickerWithPresets,
  OX as DropdownMenu,
  UX as InputOTP,
  wX as LineGraph,
  _X as NoData,
  ny as Select,
  FX as Tabs
};
